
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d9c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d9c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iTneE", function(module, exports) {

$parcel$export(module.exports, "create", () => hd);
var md = Object.defineProperty;
var G = (t, e)=>()=>(t && (e = t(t = 0)), e);
var Bt = (t, e)=>{
    for(var r in e)md(t, r, {
        get: e[r],
        enumerable: !0
    });
};
var gd, yd, D, z, Pr = G(()=>{
    gd = globalThis, yd = globalThis, D = globalThis, z = D.document;
});
var Ce, ts, Ot, Nr = G(()=>{
    Pr();
    Ce = (t)=>(typeof Node == "object" ? t instanceof D.Node : t && typeof t == "object" && typeof t.nodeType == "number" && typeof t.nodeName == "string") || !1, ts = (t)=>(typeof HTMLElement == "object" ? t instanceof D.HTMLElement : t && typeof t == "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string") || !1, Ot = (t)=>typeof D < "u" && (D.Node && t instanceof D.Node || D.Window && t instanceof D.Window || t === D || t === document);
});
var g, b, ct, y, Pn, Tc, _, Rc, N, bt, K, es, At, Dr, St = G(()=>{
    Nr();
    g = (t)=>t === null ? !1 : typeof t == "object" && t.constructor === Object, b = (t)=>typeof t == "string", ct = (t)=>typeof t == "number", y = (t)=>typeof t == "function", Pn = (t)=>t === !0 || t === !1, Tc = (t)=>t === null, _ = (t)=>Array.isArray(t), Rc = (t)=>t instanceof Date, N = (t)=>t === null ? !1 : typeof t == "object", bt = (t)=>t !== void 0, K = (t)=>t === void 0, es = {
        boolean: Pn,
        array: _,
        object: g,
        string: b,
        date: Rc,
        number: ct,
        null: Tc,
        function: y,
        objectLike: N,
        node: Ce,
        htmlElement: ts,
        defined: bt
    }, At = (t)=>(...e)=>e.some((r)=>es[r](t)), Dr = (t)=>(...e)=>!e.some((r)=>es[r](t));
});
var bd, Sd, rs, xd, Nn, ns, _d, wd, os, vd, Cd, Ed, kd, Od, Ad, Td, Dn, Fr, qe = G(()=>{
    Xt();
    St();
    bd = (t, e)=>e.every((r)=>t.includes(r)), Sd = (t, e)=>{
        let r = 0;
        for(let n = 0; n < t.length; n++)t[n] === e && r++;
        return r;
    }, rs = (t, e)=>{
        if (b(e) && (e = parseInt(e)), ct(e)) {
            if (e < 0 || e >= t.length || isNaN(e)) throw new Error("Invalid index");
            t.splice(e, 1);
        } else throw new Error("Invalid index");
        return t;
    }, xd = (t, e, r)=>{
        [t[e], t[r]] = [
            t[r],
            t[e]
        ];
    }, Nn = (...t)=>[].concat(...t), ns = (t, e = [])=>t.reduce((r, n)=>H(r, j(n, {
                exclude: e
            }), e), {}), _d = (t, e)=>{
        let r = t.indexOf(e);
        return r !== -1 ? t.slice(0, r) : t;
    }, wd = (t, e)=>{
        if (!_(t)) return;
        let r = t.indexOf(e);
        return r !== -1 ? t.slice(r + 1) : t;
    }, os = (t, e)=>{
        let r = t.indexOf(e);
        if (r > -1) {
            let n = [
                ...t
            ];
            return n.splice(r, 1), n;
        }
        return t;
    }, vd = (t, e)=>t.filter((r)=>r !== e), Cd = (t, e)=>{
        let r = [];
        for(let n = 0; n < t.length; n++)r.push(t[n]), n < t.length - 1 && r.push(e);
        return r;
    }, Ed = (t, e, r)=>{
        let n = [
            ...t
        ], o = n.indexOf(e), s = n.indexOf(r);
        if (o !== -1 && s !== -1) {
            let i = n.splice(o, 1)[0], a = s < o ? s : s + 1;
            n.splice(a, 0, i);
        }
        return n;
    }, kd = (t, e)=>{
        if (t.length !== e.length) return !1;
        for(let r = 0; r < t.length; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, Od = (t, e)=>t.filter((r)=>!e.includes(r)), Ad = (t, e)=>{
        let r = new Set(e);
        return t.filter((n)=>!r.has(n));
    }, Td = (t, e)=>{
        if (!t) return 0;
        let r = 0;
        for(let n = 0; n < e.length; n++)t.includes(e[n]) && r++;
        return r;
    }, Dn = (t)=>_(t) ? [
            ...new Set(t)
        ] : t, Fr = (t, e)=>{
        for(let r in e)Object.defineProperty(t, r, {
            value: e[r],
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    };
});
function Pd(t, e, r = {}) {
    let { bracketsLength: n = 2 } = r, o = n === 3 ? "{{{" : "{{";
    if (!t.includes(o)) return t;
    let s = Id[n], i = e || this.state || {}, a = this;
    return t.replace(s, (c, f, l, u)=>{
        let p = l.trim();
        if (u) {
            let h = a?.context?.functions?.[u];
            if (h) try {
                let d = ss(i, p);
                return String(h.call(a, d ?? p) ?? "");
            } catch  {
                return "";
            }
            return "";
        }
        if (f) {
            let h = (f.match(/\.\.\//g) || []).length, d = i;
            for(let S = 0; S < h; S++){
                if (!d || !d.parent) return "";
                d = d.parent;
            }
            if (p === "parent") return String(d.value ?? "");
            let m = ss(d, p);
            return String(m ?? "");
        } else {
            let h = ss(i, p);
            return String(h ?? "");
        }
    });
}
var is, Rd, Id, ss, ce, Nd, Dd, Fd, $d, Ld, Md, Bd, Ud, $r = G(()=>{
    is = (t, e)=>{
        for (let r of e)if (t.includes(r)) return !0;
        return !1;
    }, Rd = (t, e)=>{
        let r = new RegExp(`[${e.join("\\")}]`, "g");
        return t.replace(r, "");
    }, Id = {
        2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}/g,
        3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}}/g
    }, ss = (t, e)=>e.split(".").reduce((r, n)=>r?.[n], t);
    ce = (t)=>`${t.charAt(0).toLowerCase()}${t.slice(1)}`, Nd = (t, e)=>{
        let r = t.split(`
`), n = -1, o = -1, s = -1, i = -1, a = new RegExp(`\\b${e}\\b\\s*:\\s*`), c = 0, f = !1;
        for(let l = 0; l < r.length; l++)if (a.test(r[l]) && !f) {
            if (f = !0, n = l + 1, s = r[l].indexOf(e) + 1, r[l].includes("{}")) {
                o = n, i = r[l].indexOf("{}") + 3;
                break;
            }
            let u = r[l].slice(s + e.length);
            if (u.includes("{") || u.includes("[")) c = 1;
            else {
                o = l + 1, i = r[l].length + 1;
                break;
            }
        } else if (f && (c += (r[l].match(/{/g) || []).length, c += (r[l].match(/\[/g) || []).length, c -= (r[l].match(/}/g) || []).length, c -= (r[l].match(/]/g) || []).length, c === 0)) {
            o = l + 1, i = r[l].lastIndexOf("}") !== -1 ? r[l].lastIndexOf("}") + 2 : r[l].length + 1;
            break;
        }
        return {
            startColumn: s,
            endColumn: i,
            startLineNumber: n,
            endLineNumber: o
        };
    }, Dd = /\\([0-7]{1,3})/g, Fd = (t)=>t.replace(Dd, (e, r)=>String.fromCharCode(parseInt(r, 8))), $d = (t)=>t.replace(/\n/g, "/////n").replace(/`/g, "/////tilde").replace(/\$/g, "/////dlrsgn"), Ld = (t)=>t.replace(/\/\/\/\/\/n/g, `
`).replace(/\/\/\/\/\/tilde/g, "`").replace(/\/\/\/\/\/dlrsgn/g, "$"), Md = /[^a-zA-Z0-9\s]/g, Bd = (t)=>t.replace(Md, (e)=>"%" + e.charCodeAt(0).toString(16).toUpperCase()), Ud = (t)=>t.replace(/%[0-9A-Fa-f]{2}/g, (e)=>String.fromCharCode(parseInt(e.slice(1), 16)));
});
var ze, as, jd, Tt, He, Fn, cs, ls, We = G(()=>{
    ze = new Set([
        "attr",
        "style",
        "text",
        "html",
        "content",
        "data",
        "classlist",
        "state",
        "scope",
        "root",
        "deps",
        "extend",
        "extends",
        "$router",
        "routes",
        "children",
        "childExtend",
        "childExtends",
        "childExtendRecursive",
        "childExtendsRecursive",
        "props",
        "if",
        "define",
        "__name",
        "__ref",
        "__hash",
        "__text",
        "key",
        "tag",
        "query",
        "parent",
        "node",
        "variables",
        "on",
        "fetch",
        "component",
        "context"
    ]), as = new Set([
        "attr",
        "style",
        "text",
        "html",
        "content",
        "data",
        "class",
        "state",
        "scope",
        "children",
        "props",
        "if",
        "key",
        "tag",
        "query",
        "on",
        "context"
    ]), jd = [
        "ref",
        "parent",
        "__element",
        "__depends",
        "__ref",
        "__children",
        "root"
    ], Tt = new Set([
        "update",
        "parse",
        "clean",
        "create",
        "destroy",
        "add",
        "toggle",
        "remove",
        "apply",
        "set",
        "reset",
        "replace",
        "quietReplace",
        "quietUpdate",
        "applyReplace",
        "applyFunction",
        "keys",
        "values",
        "ref",
        "rootUpdate",
        "parentUpdate",
        "parent",
        "__element",
        "__depends",
        "__ref",
        "__children",
        "root",
        "setByPath",
        "setPathCollection",
        "removeByPath",
        "removePathCollection",
        "getByPath"
    ]), He = new Set([
        "update",
        "__element"
    ]), Fn = new Set([
        "set",
        "reset",
        "update",
        "remove",
        "updateContent",
        "removeContent",
        "lookup",
        "lookdown",
        "lookdownAll",
        "getRef",
        "getPath",
        "setNodeStyles",
        "spotByPath",
        "keys",
        "parse",
        "setProps",
        "parseDeep",
        "variables",
        "if",
        "log",
        "verbose",
        "warn",
        "error",
        "call",
        "nextElement",
        "previousElement",
        "getRootState",
        "getRoot",
        "getRootData",
        "getRootContext",
        "getContext",
        "getQuery",
        "getDB",
        "getChildren"
    ]), cs = new Set([
        "node",
        "context",
        "extends",
        "__element",
        "__ref",
        ...Fn,
        ...Tt,
        ...He
    ]), ls = new Set([
        "init",
        "beforeClassAssign",
        "render",
        "renderRouter",
        "attachNode",
        "stateInit",
        "stateCreated",
        "beforeStateUpdate",
        "stateUpdate",
        "beforeUpdate",
        "done",
        "create",
        "complete",
        "frame",
        "update",
        "fetchError",
        "fetchComplete"
    ]);
});
var Ic, Ee, O, Vd, Y, H, qd, j, fs, zd, us, Hd, Wd, $n, le, ps, Gd, Kd, Pc, Yd, Qd, fe, Lr, it, Nc, Xd, ds, hs, Dc, ms, gs, ys, bs, Ss, Jd, Zd, Xt = G(()=>{
    Pr();
    St();
    qe();
    $r();
    Nr();
    We();
    Ic = "production", Ee = (t)=>t.charCodeAt(0) === 95 && t.charCodeAt(1) === 95, O = (t, e, r, n)=>{
        if (y(t)) {
            if (!e) return;
            if (typeof t.call != "function") return t;
            let o = t.call(e, e, r || e.state, n || e.context);
            if (o && typeof o.then == "function") {
                let s;
                return o.then((i)=>{
                    s = i;
                }), s;
            }
            return o;
        }
        if (t != null && e?.context?.plugins && (_(t) || g(t) && !Ot(t))) {
            let o = e.context.plugins;
            for (let s of o)if (s.resolveHandler) {
                let i = s.resolveHandler(t, e);
                if (typeof i == "function") return O(i, e, r, n);
            }
        }
        return t;
    }, Vd = (t, e, r)=>{
        for(let n in e)t[n] = O(e[n], r);
    }, Y = (t, e, r = [])=>{
        let n = r instanceof Set;
        for(let o in e)Object.prototype.hasOwnProperty.call(e, o) && (Ee(o) || (n ? r.has(o) : r.includes(o)) || t[o] === void 0 && (t[o] = e[o]));
        return t;
    }, H = (t, e, r = cs)=>{
        let n = r instanceof Set;
        for(let o in e){
            if (!Object.prototype.hasOwnProperty.call(e, o) || Ee(o) || (n ? r.has(o) : r.includes(o))) continue;
            let s = t[o], i = e[o];
            N(s) && N(i) ? H(s, i, r) : s === void 0 && (t[o] = i);
        }
        return t;
    }, qd = (t, e = [])=>{
        let r = e instanceof Set, n = {};
        for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && (Ee(o) || (r ? e.has(o) : e.includes(o)) || (n[o] = t[o]));
        return n;
    }, j = (t, e = {})=>{
        let { exclude: r = [], cleanUndefined: n = !1, cleanNull: o = !1, window: s, visited: i = new WeakMap, handleExtends: a = !1 } = e, c = s || D || globalThis;
        if (!N(t) || Ot(t)) return t;
        if (i.has(t)) return i.get(t);
        let l = _(t) ? [] : {};
        i.set(t, l);
        let u = r instanceof Set ? r : r.length > 3 ? new Set(r) : null;
        for(let p in t){
            if (!Object.prototype.hasOwnProperty.call(t, p) || Ee(p) || p === "__proto__" || (u ? u.has(p) : r.includes(p))) continue;
            let h = t[p];
            if (!(n && h === void 0) && !(o && h === null)) {
                if (Ot(h)) {
                    l[p] = h;
                    continue;
                }
                if (a && p === "extends" && _(h)) {
                    l[p] = ns(h, r);
                    continue;
                }
                if (y(h) && e.window) {
                    l[p] = c.eval("(" + h.toString() + ")");
                    continue;
                }
                N(h) ? l[p] = j(h, {
                    ...e,
                    visited: i
                }) : l[p] = h;
            }
        }
        return l;
    }, fs = (t, e = {})=>{
        (t.node || t.__ref || t.parent || t.__element || t.parse) && ((t.__element || t.parent?.__element).warn("Trying to clone element or state at", t), t = t.parse?.());
        for(let r in t){
            let n = t[r];
            if (y(n)) e[r] = n.toString();
            else if (g(n)) e[r] = {}, fs(n, e[r]);
            else if (_(n)) {
                let o = e[r] = [];
                for(let s = 0; s < n.length; s++){
                    let i = n[s];
                    g(i) ? (o[s] = {}, fs(i, o[s])) : y(i) ? o[s] = i.toString() : o[s] = i;
                }
            } else e[r] = n;
        }
        return e;
    }, zd = new Set([
        "&",
        "*",
        "-",
        ":",
        "%",
        "{",
        "}",
        ">",
        "<",
        "@",
        ".",
        "/",
        "!",
        " "
    ]), us = (t = {}, e = 0)=>{
        if (t === null || typeof t != "object") return String(t);
        let r = !1;
        for(let s in t){
            r = !0;
            break;
        }
        if (!r) return "{}";
        let n = "  ".repeat(e), o = `{
`;
        for(let s in t){
            if (!Object.prototype.hasOwnProperty.call(t, s)) continue;
            let i = t[s], a = !1;
            for(let f = 0; f < s.length; f++)if (zd.has(s[f])) {
                a = !0;
                break;
            }
            let c = a ? `'${s}'` : s;
            if (o += `${n}  ${c}: `, _(i)) {
                o += `[
`;
                for (let f of i)N(f) && f !== null ? o += `${n}    ${us(f, e + 2)},
` : b(f) ? o += `${n}    '${f}',
` : o += `${n}    ${f},
`;
                o += `${n}  ]`;
            } else N(i) ? o += us(i, e + 1) : b(i) ? o += is(i, [
                `
`,
                "'"
            ]) ? `\`${i}\`` : `'${i}'` : o += i;
            o += `,
`;
        }
        return o += `${n}}`, o;
    }, Hd = [
        /^\(\s*\{[^}]*\}\s*\)\s*=>/,
        /^(\([^)]*\)|[^=]*)\s*=>/,
        /^function[\s(]/,
        /^async\s+/,
        /^\(\s*function/,
        /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
    ], Wd = /^["[{]/, $n = (t)=>{
        if (!t) return !1;
        let e = t.trim().replace(/\n\s*/g, " ").trim();
        if (e === "" || e === "{}" || e === "[]" || !Hd.some((s)=>s.test(e))) return !1;
        let n = e.charCodeAt(0), o = e.includes("=>");
        return !(n === 123 && !o || n === 91 || Wd.test(e) && !o);
    }, le = (t, e = {})=>{
        for(let r in t){
            if (!Object.prototype.hasOwnProperty.call(t, r)) continue;
            let n = t[r];
            if (b(n)) {
                if ($n(n)) try {
                    e[r] = D.eval(`(${n})`);
                } catch (o) {
                    o && (e[r] = n);
                }
                else e[r] = n;
            } else if (_(n)) {
                let o = e[r] = [];
                for(let s = 0; s < n.length; s++){
                    let i = n[s];
                    if (b(i)) {
                        if ($n(i)) try {
                            o.push(D.eval(`(${i})`));
                        } catch (a) {
                            a && o.push(i);
                        }
                        else o.push(i);
                    } else g(i) ? o.push(le(i)) : o.push(i);
                }
            } else g(n) ? e[r] = le(n, e[r]) : e[r] = n;
        }
        return e;
    }, ps = (t)=>{
        if (!t || typeof t != "object") return t;
        let e = {}, r = [];
        for (let n of Object.keys(t)){
            let o = t[n];
            b(o) && $n(o) ? r.push([
                n,
                o
            ]) : e[n] = o;
        }
        for (let [n, o] of r)try {
            let s = Object.keys(e).map((i)=>`var ${i} = __gs__[${JSON.stringify(i)}];`).join(`
`);
            e[n] = D.eval(`(function(__gs__) { ${s}
 return (${o}); })`)(e);
        } catch  {
            try {
                e[n] = D.eval(`(${o})`);
            } catch  {
                e[n] = o;
            }
        }
        return e;
    }, Gd = (t, e = {
        verbose: !0
    })=>{
        try {
            return t ? D.eval("(" + t + ")") : {};
        } catch (r) {
            e.verbose && console.warn(r);
        }
    }, Kd = (t, ...e)=>Object.prototype.hasOwnProperty.call(t, ...e), Pc = (t)=>{
        for(let e in t)return !1;
        return !0;
    }, Yd = (t)=>g(t) && Pc(t), Qd = ()=>Object.create(null), fe = (t, e, r = {})=>{
        let n = r.exclude || [], o = r.preventUnderscore;
        for(let s in e)n.includes(s) || !o && Ee(s) || e[s] !== void 0 && (t[s] = e[s]);
        return t;
    }, Lr = (t, e, r = [])=>{
        let n = r instanceof Set;
        for(let o in e)Ee(o) || (n ? r.has(o) : r.includes(o)) || (t[o] = e[o]);
        return t;
    }, it = (t, e, r = {}, n = new WeakMap)=>{
        if (!N(t) || !N(e) || Ot(t) || Ot(e)) return e;
        if (n.has(t)) return n.get(t);
        n.set(t, t);
        let o = r.exclude, s = o ? o instanceof Set ? o : new Set(o) : null, i = !r.preventForce;
        for(let a in e){
            if (!Object.prototype.hasOwnProperty.call(e, a) || s && s.has(a) || i && Ee(a)) continue;
            let c = t[a], f = e[a];
            Ot(f) ? t[a] = f : N(c) && N(f) ? t[a] = it(c, f, r, n) : f !== void 0 && (t[a] = f);
        }
        return t;
    }, Nc = (t, e, r = new Set)=>{
        if (typeof t != "object" || typeof e != "object" || t === null || e === null) return t === e;
        if (r.has(t) || r.has(e)) return !0;
        r.add(t), r.add(e);
        let n = Object.keys(t), o = Object.keys(e);
        if (n.length !== o.length) return !1;
        for(let s = 0; s < n.length; s++){
            let i = n[s];
            if (!Object.prototype.hasOwnProperty.call(e, i) || !Nc(t[i], e[i], r)) return !1;
        }
        return !0;
    }, Xd = new Set([
        "node",
        "__ref"
    ]), ds = (t, e, r = Xd)=>{
        if (t === e) return !0;
        if (!N(t) || !N(e) || Ot(t) || Ot(e)) return t === e;
        let n = r instanceof Set ? r : new Set(r), o = new WeakSet;
        function s(i, a) {
            if (o.has(a)) return !0;
            o.add(a);
            for(let c in a){
                if (!Object.prototype.hasOwnProperty.call(a, c) || n.has(c)) continue;
                if (!Object.prototype.hasOwnProperty.call(i, c)) return !1;
                let f = a[c], l = i[c];
                if (Ot(f) || Ot(l)) {
                    if (f !== l) return !1;
                } else if (N(f) && N(l)) {
                    if (!s(l, f)) return !1;
                } else if (f !== l) return !1;
            }
            return !0;
        }
        return s(t, e);
    }, hs = (t, e)=>{
        if (e == null) return t;
        if (At(e)("string", "number")) delete t[e];
        else if (_(e)) for(let r = 0; r < e.length; r++)delete t[e[r]];
        else throw new Error("Invalid input: props must be a string or an array of strings");
        return t;
    }, Dc = (t)=>{
        if (t === null || typeof t != "object") return t;
        let e = Object.create(null);
        for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = Dc(t[r]));
        return e;
    }, ms = (t, e)=>{
        if (t.length === 0) return e;
        let r = {}, n = r;
        for(let o = 0; o < t.length; o++)o === t.length - 1 && e ? n[t[o]] = e : (n[t[o]] = {}, n = n[t[o]]);
        return r;
    }, gs = (t, e)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let r = t;
        for(let o = 0; o < e.length - 1; o++){
            if (r[e[o]] === void 0) return;
            r = r[e[o]];
        }
        let n = e[e.length - 1];
        r && Object.prototype.hasOwnProperty.call(r, n) && delete r[n];
    }, ys = (t, e, r)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let n = t;
        for(let o = 0; o < e.length - 1; o++)(!n[e[o]] || typeof n[e[o]] != "object") && (n[e[o]] = {}), n = n[e[o]];
        return n[e[e.length - 1]] = r, t;
    }, bs = (t, e)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let r = t;
        for(let n = 0; n < e.length; n++){
            if (r == null) return;
            r = r[e[n]];
        }
        return r;
    }, Ss = (t)=>{
        let r = [], n = 0;
        for(let o = 0; o < t.length; o++)if (r.length < 2) r.push(t[o]);
        else if (t[o] === r[o % 2] ? n++ : (r = [
            t[o - 1],
            t[o]
        ], n = 1), n >= 20) return (Ic === "test" || Ic === "development") && console.warn("Warning: Potential infinite loop detected due to repeated sequence:", r), !0;
    }, Jd = (t)=>{
        let e = new WeakSet;
        function r(n) {
            if (n && typeof n == "object") {
                if (e.has(n)) return !0;
                e.add(n);
                for(let o in n)if (Object.prototype.hasOwnProperty.call(n, o) && r(n[o])) return console.log(n, "cycle at " + o), !0;
            }
            return !1;
        }
        return r(t);
    }, Zd = (t, e)=>{
        let r = e instanceof Set ? e : new Set(e), n = {};
        for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && !r.has(o) && (n[o] = t[o]);
        return n;
    };
});
var xs, _s, ws, Ln = G(()=>{
    Xt();
    xs = function() {
        let t = 0;
        function e() {
            return t++, t;
        }
        return e;
    }(), _s = xs, ws = (t, e, r)=>(O(r, t) || r || t.key || xs()).toString();
});
var Jt, th, Ge, Fc, eh, rh, nh, Zt, oh, Mr, vs = G(()=>{
    Jt = "production", th = Jt, Ge = (t = Jt)=>t === "production", Fc = (t = Jt)=>t === "testing" || t === "test", eh = Fc, rh = (t = Jt)=>t === "staging", nh = (t = Jt)=>t === "local", Zt = (t = Jt)=>t === "development" || t === "dev" || t === "local", oh = (t, e = Jt)=>e[t], Mr = (t = Jt)=>!Ge(t);
});
function sh(t, e, r) {
    let n;
    return function() {
        let o = this, s = arguments, i = function() {
            n = null, r || t.apply(o, s);
        }, a = r && !n;
        clearTimeout(n), n = setTimeout(i, e), a && t.apply(o, s);
    };
}
function fh(t, e = window) {
    let r = function() {
        return t.apply(e, arguments);
    };
    for(let n in t)Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    return r;
}
var ih, ah, ch, lh, Ke, Ye, Mn, Bn = G(()=>{
    ih = (t, e, r = 300)=>{
        let n;
        return (...o)=>{
            clearTimeout(n), n = setTimeout(()=>{
                e.apply(t, o);
            }, r);
        };
    }, ah = (t)=>{
        let e = {};
        return (...r)=>{
            let n = r[0];
            if (n in e) return e[n];
            {
                let o = t(n);
                return e[n] = o, o;
            }
        };
    }, ch = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/, lh = (t)=>ch.test(t), Ke = (t)=>{
        let e = t?.plugins;
        if (!e || !e.length) return !1;
        for (let r of e)if (r.resolveHandler) return !0;
        return !1;
    }, Ye = (t, e)=>{
        if (typeof t == "function") return t;
        let r = e?.context?.plugins;
        if (!r) return t;
        for (let n of r)if (n.resolveHandler) {
            let o = n.resolveHandler(t, e);
            if (typeof o == "function") return o;
        }
        return t;
    }, Mn = (t, e, ...r)=>{
        let n = e?.context?.plugins;
        if (n) for (let o of n)typeof o[t] == "function" && o[t](e, ...r);
    };
});
var Br, $c = G(()=>{
    St();
    Xt();
    Br = (t, e)=>{
        let { __ref: r } = t, n = t.if;
        if (y(n)) {
            let o;
            try {
                o = n(t, t.state, t.context);
            } catch (s) {
                typeof console < "u" && console.warn("[DOMQL] if condition error:", s), delete r.__if;
                return;
            }
            o ? r.__if = !0 : delete r.__if;
        } else n != null && typeof n == "object" ? O(n, t) ? r.__if = !0 : delete r.__if : r.__if = !0;
    };
});
var uh, ph, Lc = G(()=>{
    uh = (t, ...e)=>{
        t && e.map((r)=>console.log(r));
    }, ph = (t, e, ...r)=>{
        t && (console.group(e), r.map((n)=>console.log(n)), console.groupEnd(e));
    };
});
function yh(t) {
    if (!window.localStorage) return;
    let e = window.localStorage.getItem(t);
    if (e !== null) try {
        return JSON.parse(e);
    } catch  {
        return;
    }
}
function bh(t, e) {
    if (!window.localStorage || e === void 0 || e === null) return;
    let r = typeof e == "object" ? JSON.stringify(e) : e;
    window.localStorage.setItem(t, r);
}
var dh, hh, mh, gh, Mc = G(()=>{
    St();
    Pr();
    dh = typeof navigator > "u" ? !1 : /Mobi/.test(navigator.userAgent), hh = (t, e, r = 365)=>{
        if (K(z) || K(z.cookie)) return;
        let n = new Date;
        n.setTime(n.getTime() + r * 86400000);
        let o = `expires=${n.toUTCString()}`;
        z.cookie = `${t}=${e};${o};path=/`;
    }, mh = (t)=>{
        if (K(z) || K(z.cookie)) return;
        let e = `${t}=`, n = decodeURIComponent(z.cookie).split(";");
        for(let o = 0; o < n.length; o++){
            let s = n[o];
            for(; s.charAt(0) === " ";)s = s.substring(1);
            if (s.indexOf(e) === 0) return s.substring(e.length, s.length);
        }
        return "";
    }, gh = (t)=>{
        K(z) || K(z.cookie) || (z.cookie = t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
    };
});
var Un, Qe, ke, Cs = G(()=>{
    Un = {
        root: [
            "body",
            "html"
        ],
        head: [
            "title",
            "base",
            "meta",
            "style",
            "noscript",
            "script"
        ],
        body: new Set([
            "string",
            "style",
            "fragment",
            "a",
            "abbr",
            "acronym",
            "address",
            "applet",
            "area",
            "article",
            "aside",
            "audio",
            "b",
            "basefont",
            "bdi",
            "bdo",
            "big",
            "blockquote",
            "br",
            "button",
            "canvas",
            "caption",
            "center",
            "cite",
            "code",
            "search",
            "col",
            "colgroup",
            "data",
            "datalist",
            "dd",
            "del",
            "details",
            "dfn",
            "dialog",
            "dir",
            "div",
            "dl",
            "dt",
            "em",
            "embed",
            "fieldset",
            "figcaption",
            "figure",
            "font",
            "footer",
            "form",
            "frame",
            "frameset",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "head",
            "header",
            "hr",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "link",
            "main",
            "map",
            "mark",
            "meter",
            "nav",
            "noframes",
            "noscript",
            "object",
            "ol",
            "optgroup",
            "option",
            "output",
            "p",
            "param",
            "picture",
            "pre",
            "progress",
            "hgroup",
            "q",
            "rp",
            "rt",
            "ruby",
            "s",
            "samp",
            "script",
            "section",
            "select",
            "small",
            "source",
            "span",
            "strike",
            "strong",
            "sub",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "template",
            "hgroup",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "track",
            "tt",
            "u",
            "ul",
            "var",
            "video",
            "wbr",
            "svg",
            "path",
            "circle",
            "ellipse",
            "line",
            "polygon",
            "polyline",
            "rect",
            "g",
            "defs",
            "symbol",
            "use",
            "text",
            "tspan",
            "image",
            "clipPath",
            "mask",
            "pattern",
            "marker",
            "linearGradient",
            "radialGradient",
            "stop",
            "filter",
            "feGaussianBlur",
            "feOffset",
            "feMerge",
            "feMergeNode",
            "feBlend",
            "feColorMatrix",
            "feFlood",
            "feComposite",
            "foreignObject"
        ])
    }, Qe = new Set([
        "svg",
        "path",
        "circle",
        "ellipse",
        "line",
        "polygon",
        "polyline",
        "rect",
        "g",
        "defs",
        "symbol",
        "use",
        "text",
        "tspan",
        "image",
        "clipPath",
        "mask",
        "pattern",
        "marker",
        "linearGradient",
        "radialGradient",
        "stop",
        "filter",
        "feGaussianBlur",
        "feOffset",
        "feMerge",
        "feMergeNode",
        "feBlend",
        "feColorMatrix",
        "feFlood",
        "feComposite",
        "foreignObject"
    ]), ke = (t)=>Un.body.has(t);
});
var Es, Bc, jn, As, Rt, Ts, Uc, Rs, Sh, Is, jc, Vc, Ps, qc, Vn, xh, ue, zc, ks, Ns, _h, Os, wh, vh, Hc, Wc, Gc, Kc, Yc, Qc, Ds, qn = G(()=>{
    qe();
    Fs();
    Xt();
    St();
    Es = "production", Bc = (t)=>t.sourcemap !== !1 && Es !== "production", jn = (t)=>{
        if (t.includes("+")) return t.split("+").filter(It);
        if (t.includes("_")) {
            let [e] = t.split("_");
            return [
                e
            ];
        }
        if (t.includes(".") && !It(t.split(".")[1])) {
            let [e] = t.split(".");
            return [
                e
            ];
        }
        return [
            t
        ];
    }, As = (t, e, r)=>{
        let n = [], o = jn(r);
        o && (n = [
            ...o
        ]);
        let s = t.extends;
        return s && (n = _(s) ? [
            ...n,
            ...s
        ] : [
            ...n,
            s
        ]), n;
    }, Rt = (t, e)=>{
        let { __ref: r } = e, { __extends: n } = r;
        if (!t) return n;
        let o = e.props?.variant, s = e.context;
        if (o && s?.components && !Array.isArray(t) && typeof t == "string") {
            let i = `${t}.${o}`;
            s.components[i] && (t = i);
        }
        return n.includes(t) || (n = Array.isArray(t) ? [
            ...n,
            ...t
        ] : [
            ...n,
            t
        ], r.__extends = n), n;
    }, Ts = (t, e)=>{
        if (!t) return e;
        let { extends: r } = e, n = _(r) ? r : [
            r
        ], o = _(t) ? t : [
            t
        ];
        return {
            ...e,
            extends: Nn(o, n)
        };
    }, Uc = ()=>Math.random().toString(36).substring(2), Rs = {}, Sh = {}, Is = (t)=>Rs[t.__hash], jc = (t, e)=>{
        let r = Uc();
        return b(t) || (t.__hash = r), r !== "__proto__" && r !== "constructor" && r !== "prototype" && (Rs[r] = e), e;
    }, Vc = (t, e)=>t.__hash ? e.concat(Is(t)) : jc(t, e), Ps = (t, e, r, n = new Set, o, s)=>{
        for (let i of t)_(i) ? Ps(i, e, r, n, o, s) : Vn(i, e, r, n, o, void 0, s);
        return e;
    }, qc = (t, e, r, n = new Set, o, s, i)=>{
        let a = t.extends || t.extend, c = {
            ...t
        };
        delete c.extends, delete c.extend;
        let f = !1;
        for(let l in c){
            f = !0;
            break;
        }
        return f && (e.push(c), o && o.push(s)), a && Vn(a, e, r, n, o, s, i), e;
    }, Vn = (t, e, r, n = new Set, o, s, i)=>{
        if (!t || n.has(t)) return e;
        if (_(t)) return Ps(t, e, r, n, o, i);
        let a = s;
        return b(t) ? (a = t, t = Ns(t, r)) : i && g(t) && i.has(t) && (a = i.get(t)), n.add(t), t?.extends || t?.extend ? qc(t, e, r, n, o, a, i) : t && (e.push(t), o && o.push(a)), e;
    }, xh = new Set([
        "parent",
        "node",
        "__ref",
        "__proto__",
        "extend",
        "childExtend",
        "childExtendRecursive"
    ]), ue = (t, e, r, n, o)=>{
        e = j(e);
        for(let s in e){
            if (xh.has(s)) continue;
            let i = t[s], a = e[s];
            if (a !== void 0 && Object.prototype.hasOwnProperty.call(e, s) && s !== "__proto__" && s !== "constructor" && s !== "prototype") {
                if (i === void 0) t[s] = a, r && n ? g(a) && !_(a) ? (r[s] = r[s] || {}, zc(r[s], a, n)) : r[s] = n : r && o?.[s] && (r[s] = o[s]);
                else if (g(i) && g(a)) {
                    let c = r ? r[s] = r[s] || {} : void 0, f = o?.[s];
                    It(s) ? t[s] = ue(i, a, c, n, f) : ue(i, a, c, n, f);
                }
                if (s === "extends" || s === "childExtends" || s === "childExtendsRecursive") {
                    if (_(i) && _(a)) t[s] = i.concat(a);
                    else if (_(i) && g(a)) {
                        let c = ue({}, i);
                        t[s] = ue(c, a);
                    }
                }
            }
        }
        return t;
    }, zc = (t, e, r, n)=>{
        if (n || (n = new WeakSet), !n.has(e)) {
            n.add(e);
            for(let o in e){
                if (!Object.prototype.hasOwnProperty.call(e, o) || o === "__proto__" || o === "constructor" || o === "prototype") continue;
                let s = e[o];
                g(s) && !_(s) ? (t[o] = t[o] || {}, zc(t[o], s, r, n)) : t[o] = r;
            }
        }
    }, ks = (t, e, r)=>t.reduce((n, o, s)=>{
            let i = j(o), a = r ? r[s] : void 0;
            return ue(n, i, e, a);
        }, {}), Ns = (t, e, r = {}, n)=>{
        let o = e?.components || r.components, s = e?.pages || r.pages;
        if (b(t)) {
            let i = o && (o[t + "." + n] || o[t] || o["smbls." + t]), a = s && t.charCodeAt(0) === 47 && s[t];
            if (i) return i;
            if (a) return a;
            r.verbose && (Es === "test" || Es === "development") && console.warn("Extend is string but component was not found:", t);
            return;
        }
        return t;
    }, _h = (t, e)=>[].concat(t.slice(0, 1)).concat(e.slice(0, 1)).concat(t.slice(1)).concat(e.slice(1)), Os = (t, e, r, n)=>{
        if (!t) return [];
        if (t.__hash) return Is(t) || [];
        let s = Vn(t, [], e, new Set, r, void 0, n);
        return r ? s : Vc(t, s);
    }, wh = (t, e)=>{
        if (!t) return e;
        let r = _(t) ? t : [
            t
        ];
        return Nn(r, e);
    }, vh = (t)=>{
        let e = [];
        function r(n) {
            for(let o in n)Object.prototype.hasOwnProperty.call(n, o) && (It(o) && e.push(o), o === "extends" && (typeof n[o] == "string" ? e.push(n[o]) : Array.isArray(n[o]) && (e = e.concat(n[o]))), typeof n[o] == "object" && n[o] !== null && r(n[o]));
        }
        return r(t), e;
    }, Hc = (t, e, r = {})=>{
        let { __ref: n } = t, o = t.context || e.context, s = t.props?.variant;
        if (t.extend && !t.extends && (t.extends = t.extend), delete t.extend, !t.extends && t.props?.extends && (t.extends = t.props.extends), t.extends) {
            if (Array.isArray(t.extends) && t.extends.length > 0) {
                let [i, ...a] = t.extends;
                if (typeof i == "string" && s && o?.components) {
                    let c = `${i}.${s}`;
                    o.components[c] ? Rt([
                        c,
                        ...a
                    ], t) : Rt(t.extends, t);
                } else Rt(t.extends, t);
            } else if (typeof t.extends == "string" && s && o?.components) {
                let i = `${t.extends}.${s}`;
                o.components[i] ? Rt(i, t) : Rt(t.extends, t);
            } else Rt(t.extends, t);
        }
        return Wc(t, e, r), Gc(t, e, r), Kc(t, e, r), t.component && Rt(O(t.component, t), t), o.defaultExtends && Rt(o.defaultExtends, t), Dn(n.__extends);
    }, Wc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t;
        return r.ignoreChildExtends || n?.ignoreChildExtends || e.props?.childProps?.extends && Rt(e.props?.childProps.extends, t), o.__extends;
    }, Gc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = r.ignoreChildExtends || n?.ignoreChildExtends, i = e.childExtends || e.childExtend;
        return !s && i && Rt(i, t), o.__extends;
    }, Kc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = e.childExtendsRecursive || e.childExtendRecursive, i = r.ignoreChildExtendsRecursive || n?.ignoreChildExtendsRecursive, a = t.key === "__text";
        return s && !a && !i && Rt(s, t), o.__extends;
    }, Yc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = t.context || e.context, i = t.variant || n?.variant, a = Bc(r), c = a ? [
            ...o.__extends
        ] : null, f = Dn(o.__extends.map((l, u)=>Ns(l, s, r, u === 0 && i)));
        if (a) {
            let l = new WeakMap;
            for(let h = 0; h < f.length; h++){
                let d = f[h], m = c[h];
                d && g(d) && b(m) && l.set(d, m);
            }
            let u = [], p = Os(f, s, u, l);
            o.__extendsStack = p, o.__extendsNames = u;
        } else {
            let l = Os(f, s);
            o.__extendsStack = l;
        }
        return o.__extendsStack;
    }, Qc = (t, e, r = {})=>{
        let { __ref: n } = t, { __extendsStack: o } = n;
        if (Bc(r)) {
            let s = {}, i = n.__extendsNames || [], a = ks(o, s, i), c = {};
            ue(t, a, c, void 0, s), n.__sourcemap = c;
        } else {
            let s = ks(o);
            ue(t, s);
        }
        return t;
    }, Ds = (t, e, r = {})=>(Hc(t, e, r), Yc(t, e, r), Qc(t, e, r), t);
});
function Ch(t) {
    return Object.keys(t).filter((e)=>/^[A-Z]/.test(e));
}
function Eh(t) {
    return Object.keys(t).filter((e)=>/^\d+$/.test(e));
}
function $s(t, e, r) {
    let { context: n } = e || {}, [o] = jn(r), s = r || o;
    return n?.components?.[s] || n?.pages?.[s];
}
var It, Fs = G(()=>{
    qn();
    St();
    It = (t)=>{
        if (!b(t) || !t.length) return !1;
        let e = t.charCodeAt(0);
        return e >= 65 && e <= 90;
    };
});
function Xc(t, e) {
    let { props: r, on: n } = e, o = ce(t.split("on")[1]), s = n[o], i = r[t];
    y(s) ? n[o] = (...a)=>{
        if (s(...a) !== !1 && y(i)) return i(...a);
    } : n[o] = i;
}
var Jc = G(()=>{
    $r();
    St();
});
function el(t, e = {}) {
    let r = e.cachedKeys || [];
    for(let n in t){
        let o = t[n];
        if (n.length > 2 && n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && n[2] === n[2].toUpperCase() && (y(o) || o != null && Ke(this.context))) {
            let d = ce(n.slice(2));
            t.on && (t.on[d] = o), delete t[n];
            continue;
        }
        if (n === "childProps") {
            t.props[n] = o, delete t[n], r.push(n);
            continue;
        }
        let a = this.define?.[n], c = this.context?.define?.[n], f = g(a) || y(a), l = g(c) || y(c);
        if (f || l) continue;
        let u = n.charAt(0);
        if (tl.has(u)) {
            t.props[n] = o, delete t[n], r.push(n);
            continue;
        }
        let p = Bs.test(n) || Zc.test(n) || Oh(o), h = ze.has(n);
        !p && !h && (n in t.props || (t.props[n] = o), delete t[n], r.push(n));
    }
    return t;
}
function Ur(t = this, e) {
    let r = e.cachedKeys || [];
    for(let n in t.props){
        let o = t.props[n], s = n.length > 2 && n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110, i = y(o) || o != null && Ke(this.context);
        if (s && i) {
            Xc(n, t), delete t.props[n];
            continue;
        }
        if (r.includes(n) || n === "childProps") continue;
        let a = n.charAt(0);
        if (tl.has(a)) continue;
        let c = this.define?.[n], f = this.context?.define?.[n], l = g(c) || y(c), u = g(f) || y(f), p = Bs.test(n) || Zc.test(n), h = ze.has(n);
        (p || h || l || u) && (t[n] === void 0 || o === null) && (t[n] = o, t.props && delete t.props[n]);
    }
    return t;
}
function zn(t = this) {
    let e = [];
    return el.call(this, t, {
        cachedKeys: e
    }), Ur.call(this, t, {
        cachedKeys: e
    }), t;
}
function js(t = {}) {
    return t.on || (t.on = {}), t.props || (t.props = {}), zn.call(this, t);
}
function rl(t, e) {
    this.__element.update({
        props: t
    }, e);
}
function qs(t) {
    let e = {
        update: rl.bind(t.props),
        __element: t
    };
    Object.setPrototypeOf(t.props, e);
}
var Bs, Zc, tl, kh, Oh, Us, Ls, Ah, Vs, zs, Hs, nl, Ms, Hn, Ws, Gs = G(()=>{
    We();
    Jc();
    Xt();
    St();
    $r();
    Bn();
    Bs = /^[A-Z]/, Zc = /^\d+$/, tl = new Set([
        ":",
        "@",
        "[",
        "*",
        "+",
        "~",
        "&",
        ">",
        "$",
        "-",
        ".",
        "!"
    ]), kh = new Set([
        "extend",
        "props",
        "text",
        "tag",
        "on",
        "if",
        "childExtend",
        "children",
        "childrenAs",
        "state",
        "html",
        "attr",
        "define",
        "content"
    ]), Oh = (t)=>{
        if (!t || typeof t != "object" || Array.isArray(t)) return !1;
        for(let e in t)if (kh.has(e) || Bs.test(e)) return !0;
        return !1;
    }, Us = (t, e, r)=>{
        let { props: n, __ref: o } = t;
        if (o.__propsStack = [], n) o.__initialProps = n;
        else return {};
        return N(n) ? {
            ...n
        } : (o.__propsStack.push(n), {});
    };
    Ls = (t)=>At(t)("string", "number") ? {
            inheritedString: t
        } : t, Ah = (t, e)=>!t || !e.length ? !1 : e.includes(t), Vs = (t, e)=>{
        let { __ref: r } = t, n = r.__propsStack || [], o = e.props;
        if (!o) return n;
        let s = o[t.key], i = o.childProps || e.childProps, a = t.props?.ignoreChildProps;
        if (i && !a) {
            let c = Ls(i);
            n.unshift(c);
        }
        if (s) {
            let c = Ls(s);
            n.unshift(c);
        }
        return n;
    };
    zs = (t)=>{
        let e = new Set;
        return t.filter((r)=>!r || He.has(r) || e.has(r) ? !1 : (e.add(r), !0));
    }, Hs = (t, e, r)=>(e.props = t.reduce((n, o)=>{
            if (He.has(o)) return n;
            for(; y(o);)o = O(o, e);
            return H(n, j(o, {
                exclude: He
            }));
        }, {}), qs(e), e.props), nl = (t, e)=>{
        let { props: r, __ref: n } = t, o = n.__propsStack || [];
        if (e?.props && (o = [
            ...Vs(t, e)
        ]), g(r) ? o.push(r) : r === "inherit" && e?.props ? o.push(e.props) : r && o.push(r), _(n.__extendsStack)) for(let s = 0; s < n.__extendsStack.length; s++){
            let i = n.__extendsStack[s];
            i.props && i.props !== r && o.push(i.props);
        }
        return n.__propsStack = zs(o), n.__propsStack;
    }, Ms = (t, e)=>{
        let { __ref: r } = t, n = nl(t, e);
        n.length ? Hs(n, t) : (r.__propsStack = [], t.props = {});
    }, Hn = function(t, e, r) {
        let { __ref: n } = t;
        if (n.__if) Ms(t, e);
        else try {
            Ms(t, e);
        } catch (o) {
            t.context?.designSystem?.verbose && console.warn("initProps error at", n.path?.join("."), o), t.props = {}, n.__propsStack = [];
        }
        return qs(t), t;
    }, Ws = (t, e, r)=>{
        let { __ref: n } = e, s = [
            ...n.__propsStack || []
        ], i = Vs(e, r);
        return i.length && (s = [
            ...i,
            ...s
        ]), t && (s = [
            t,
            ...s
        ]), n.__propsStack = zs(s), n.__propsStack.length && Hs(n.__propsStack, e), e;
    };
});
var ol, sl, il, al, cl, Ks, ll, fl, ul, Ys, pl = G(()=>{
    qn();
    Ln();
    Nr();
    Gs();
    Cs();
    St();
    ol = "production", sl = (t, e, r)=>{
        let n = e.childExtends && e.childExtends.tag, o = e.props.childProps && e.props.childProps.tag, s = Un.body.has(r) && r;
        return {
            text: t,
            tag: n || o || s || "string"
        };
    }, il = (t, e, r)=>{
        if (t === void 0) return (ol === "test" || ol === "development") && console.warn(r, "element is undefined in", e?.__ref?.path), {};
        if (t !== null) return t === !0 ? {} : At(t)("string", "number") ? sl(t, e, r) : y(t) ? {
            props: t
        } : t;
    }, al = (t, e)=>{
        let r = {};
        return r.origin = t, r.parent = e, r;
    }, cl = (t, e, r, n, o)=>{
        if (!e) return o;
        if (Ce(e)) {
            let s = {
                key: ":root",
                node: e
            };
            return o[`${r}_parent`] = s, s;
        }
        return e;
    }, Ks = (t, e)=>{
        let { __ref: r } = t, { __ref: n } = e, o = e && e.key === ":root";
        r?.root || (r.root = o ? t : n?.root);
    }, ll = (t, e, r)=>{
        let { __ref: n } = e;
        return n || (n = e.ref = {}), n.path || (n.path = []), n.path.concat(r);
    }, fl = (t, e, r, n, o)=>(n.context && !o.context && !t.context && (o.context = n.context), n.context || e.context || o.context || t.context), ul = (t, e, r)=>{
        let n = al(t, e);
        return t.__ref = n, n.__defineCache || (n.__defineCache = {}), n.__exec || (n.__exec = {}), n.__execProps || (n.__execProps = {}), n.__class || (n.__class = {}), n.__classNames || (n.__classNames = {}), n.__attr || (n.__attr = {}), n.__changes || (n.__changes = []), n.__children || (n.__children = []), n.__extends = As(t, e, r), n.path = ll(t, e, r), n;
    }, Ys = (t, e, r, n, o)=>{
        let i = t?.__hash ? {
            extends: [
                t
            ]
        } : il(t, e, r);
        if (!i) return;
        let a = cl(i, e, r, n, o), c = ws(i, a, r);
        ul(i, a, c);
        let f = Us(i, a, c), l = fl(i, a, c, n, o), u = i.on || {};
        return {
            ...i,
            key: c,
            props: f,
            parent: a,
            context: l,
            on: u
        };
    };
});
var Qs, Xe, Je, Ze, tr, Xs, er, Wn, Js, Zs, ti, dl = G(()=>{
    qe();
    We();
    Xt();
    St();
    Qs = (t)=>{
        let { state: e, props: r, __ref: n } = t, o = r?.state || e;
        return At(o)("string", "number") ? (n.__state = o, {
            value: o
        }) : o === !0 ? (n.__state = t.key, {}) : o ? (n.__hasRootState = !0, o) : !1;
    }, Xe = (t, e)=>{
        if (!t.includes("~/")) return;
        if (t.split("~/").length > 1) return e.root;
    }, Je = (t, e)=>{
        if (!t.includes("../")) return;
        let n = t.split("../").length - 1;
        for(let o = 0; o < n; o++){
            if (!e.parent) return null;
            e = e.parent;
        }
        return e;
    }, Ze = (t, e, r = {})=>{
        let n = b(t) ? t.split("/") : [
            t
        ], o = n.length - 1;
        for(let s = 0; s < o; s++){
            let i = n[s], a = n[s + 1];
            if (i === "__proto__" || a === "__proto__") return;
            let c = e[i];
            c || (c = e[i] = {}), c[a] || (c[a] = {}), t = a, e = c;
        }
        return r.returnParent ? e : e[t];
    }, tr = (t, e, r = {})=>{
        let o = t.__ref.__state;
        if (!er(t)) return;
        let s = Xe(o, e.state), i = e.state;
        if (s) i = s, o = o.replaceAll("~/", "");
        else {
            let a = Je(o, e.state);
            a && (i = a, o = o.replaceAll("../", ""));
        }
        if (i) return Ze(o, i, r);
    }, Xs = (t, e)=>{
        let r = t.__ref, n = tr(t, e);
        if (n === void 0) return t.state;
        if (At(n)("object", "array")) return j(n);
        if (At(n)("string", "number", "boolean")) return r.__stateType = typeof n, {
            value: n
        };
        console.warn(r.__state, "is not present. Replacing with", {});
    }, er = (t)=>{
        let { __ref: e } = t, r = e?.__state;
        return !!(r && At(r)("number", "string", "boolean"));
    }, Wn = function(t) {
        return N(t) ? !!(t.update && t.parse && t.clean && t.create && t.parent && t.destroy && t.rootUpdate && t.parentUpdate && t.keys && t.values && t.toggle && t.replace && t.quietUpdate && t.quietReplace && t.add && t.apply && t.applyReplace && t.setByPath && t.setPathCollection && t.removeByPath && t.removePathCollection && t.getByPath && t.applyFunction && t.__element && t.__children) : !1;
    }, Js = (t, e)=>{
        if (!t) return e || {};
        let r = t.split("/"), n = {}, o = n, s = r.length - 1;
        for(let i = 0; i <= s; i++)o[r[i]] = i === s ? e || {} : {}, o = o[r[i]];
        return n;
    }, Zs = (t, e)=>{
        let { __element: r } = e, n = r?.state;
        if (!n) return;
        let o = j(n, Tt), s = {
            [t.key]: o
        }, i = g(n.__depends) ? {
            ...n.__depends,
            ...s
        } : s;
        return Array.isArray(n) ? Fr(n, {
            ...Object.getPrototypeOf(n),
            __depends: i
        }) : Object.setPrototypeOf(n, {
            ...Object.getPrototypeOf(n),
            __depends: i
        }), o;
    }, ti = (t, e, r = {})=>{
        let { overwrite: n } = r;
        if (!n) return;
        let o = n === "shallow";
        if (n === "merge") {
            H(t, e, Tt);
            return;
        }
        (o ? Lr : it)(t, e, Tt);
    };
});
var Gn, hl = G(()=>{
    Gn = (t, e)=>{
        let { __ref: r } = t, n = t.context || e.context || r.root?.context;
        n && !n.globalScope && (n.globalScope = {});
        let o = e.scope || r.root?.scope, s = n?.globalScope;
        if (!t.scope) o ? t.scope = o : s ? t.scope = Object.create(s) : t.scope = {};
        else if (typeof t.scope == "object" && t.scope !== null && Object.getPrototypeOf(t.scope) === Object.prototype) {
            let i = o || s;
            i && Object.setPrototypeOf(t.scope, i);
        }
    };
});
var ml, jr, W, ei, vt, ri = G(()=>{
    St();
    Bn();
    ml = (t, e)=>{
        let r = e.on?.[t];
        if (r) return r;
        let n = e.props;
        if (!n) return;
        let o = "on" + t.charAt(0).toUpperCase() + t.slice(1);
        return n[o];
    }, jr = (t, e, r, n, o)=>{
        if (t = Ye(t, e), !!y(t)) try {
            let s = t.call(e, e, r || e.state, n || e.context, o);
            return s && typeof s.then == "function" && s.catch((i)=>{
                e.error = i, i instanceof ReferenceError ? console.warn("[DOMQL] Async event warning:", i.message) : console.error("[DOMQL] Async event error:", i);
            }), s;
        } catch (s) {
            if (e.error = s, s instanceof ReferenceError ? console.warn("[DOMQL] Event handler warning:", s.message) : console.error("[DOMQL] Event handler error:", s), e.context?.strictMode) throw s;
        }
    }, W = (t, e, r)=>{
        if (!e) throw new Error("Element is required");
        Mn(t, e, r);
        let n = ml(t, e);
        if (n) {
            let { state: o, context: s } = e;
            return jr(n, e, o, s, r);
        }
    }, ei = (t, e, r, n, o, s)=>{
        if (t = Ye(t, r), !!y(t)) try {
            let i = t.call(r, e, r, n || r.state, o || r.context, s);
            return i && typeof i.then == "function" && i.catch((a)=>{
                r.error = a, console.error("[DOMQL] Async event update error:", a);
            }), i;
        } catch (i) {
            if (r.error = i, console.error("[DOMQL] Event update error:", i), r.context?.strictMode) throw i;
        }
    }, vt = (t, e, r, n)=>{
        Mn(t, r, e, n);
        let o = ml(t, r);
        if (o) {
            let { state: s, context: i } = r;
            return ei(o, e, r, s, i, n);
        }
    };
});
var Th, ut, ni = G(()=>{
    Th = {}, ut = {};
});
var yl = {};
Bt(yl, {
    setup: ()=>Rh,
    supabaseAdapter: ()=>gl
});
var Rh, oi, Ih, gl;

var bl = G(()=>{
    "use strict";
    Rh = async ({ url: t, key: e, projectId: r, createClient: n, ...o })=>{
        let s = t || r && `https://${r}.supabase.co`;
        if (!s || !e) throw new Error("@symbo.ls/fetch supabase: url (or projectId) and key are required");
        n || (n = (await Promise.resolve((parcelRequire("dNnfS")))).createClient);
        let i = n(s, e, o);
        return !i || !i.auth ? null : gl(i);
    }, oi = (t, e)=>{
        if (!e) return t;
        for(let r in e){
            let n = e[r];
            if (n === null) t = t.is(r, null);
            else if (Array.isArray(n)) t = t.in(r, n);
            else if (typeof n == "object") for(let o in n)o === "gt" ? t = t.gt(r, n[o]) : o === "gte" ? t = t.gte(r, n[o]) : o === "lt" ? t = t.lt(r, n[o]) : o === "lte" ? t = t.lte(r, n[o]) : o === "neq" ? t = t.neq(r, n[o]) : o === "like" ? t = t.like(r, n[o]) : o === "ilike" ? t = t.ilike(r, n[o]) : o === "in" ? t = t.in(r, n[o]) : o === "is" ? t = t.is(r, n[o]) : o === "contains" ? t = t.contains(r, n[o]) : o === "containedBy" ? t = t.containedBy(r, n[o]) : o === "textSearch" && (t = t.textSearch(r, n[o]));
            else t = t.eq(r, n);
        }
        return t;
    }, Ih = (t, { limit: e, offset: r, order: n, single: o } = {})=>{
        if (n) {
            if (Array.isArray(n)) for (let s of n){
                let i = typeof s == "string" ? s : s.by;
                t = t.order(i, {
                    ascending: s.asc !== !1
                });
            }
            else {
                let s = typeof n == "string" ? n : n.by;
                t = t.order(s, {
                    ascending: n.asc !== !1
                });
            }
        }
        return e && (t = t.limit(e)), r && (t = t.range(r, r + (e || 20) - 1)), o && (t = t.single()), t;
    }, gl = (t)=>({
            name: "supabase",
            client: t,
            getSession: async ()=>{
                let { data: e } = await t.auth.getSession();
                return e?.session || null;
            },
            getUser: async ()=>{
                let { data: e } = await t.auth.getUser();
                return e?.user || null;
            },
            signIn: (e)=>e.provider ? t.auth.signInWithOAuth({
                    provider: e.provider
                }) : e.token ? t.auth.signInWithIdToken(e) : t.auth.signInWithPassword(e),
            signUp: (e)=>t.auth.signUp(e),
            signOut: ()=>t.auth.signOut(),
            onAuthStateChange: (e)=>{
                let { data: { subscription: r } } = t.auth.onAuthStateChange((n, o)=>e(n, o));
                return ()=>r.unsubscribe();
            },
            select: async ({ from: e, select: r, params: n, ...o })=>{
                let s = t.from(e).select(r || "*");
                return s = oi(s, n), s = Ih(s, o), s;
            },
            rpc: ({ from: e, params: r })=>t.rpc(e, r),
            insert: ({ from: e, data: r, select: n })=>t.from(e).insert(r).select(n || "*"),
            update: ({ from: e, data: r, params: n, select: o })=>{
                let s = t.from(e).update(r);
                return s = oi(s, n), s.select(o || "*");
            },
            upsert: ({ from: e, data: r, select: n })=>t.from(e).upsert(r).select(n || "*"),
            delete: ({ from: e, params: r })=>{
                let n = t.from(e).delete();
                return n = oi(n, r), n;
            },
            subscribe: ({ from: e, params: r, on: n }, o)=>{
                let s = n || "*", i = t.channel(`db-${e}-${Date.now()}`).on("postgres_changes", {
                    event: s,
                    schema: "public",
                    table: e,
                    ...r?.id ? {
                        filter: `id=eq.${r.id}`
                    } : {}
                }, (a)=>o(a.new, a.old, a)).subscribe();
                return ()=>t.removeChannel(i);
            },
            upload: ({ bucket: e, path: r, file: n, options: o })=>t.storage.from(e).upload(r, n, o),
            download: ({ bucket: e, path: r })=>t.storage.from(e).download(r),
            getPublicUrl: ({ bucket: e, path: r })=>t.storage.from(e).getPublicUrl(r)
        });
});
var xl = {};
Bt(xl, {
    restAdapter: ()=>Sl,
    setup: ()=>Nh
});
var Ph, pe, Nh, Sl, _l = G(()=>{
    "use strict";
    Ph = (t, e, r)=>{
        let n = e && !e.startsWith("/") ? "/" : "", o = new URL(`${t}${n}${e}`);
        if (r) for(let s in r){
            let i = r[s];
            i != null && o.searchParams.set(s, typeof i == "object" ? JSON.stringify(i) : i);
        }
        return o.toString();
    }, pe = async (t, e)=>{
        let r = await globalThis.fetch(t, e), n = r.headers.get("content-type"), o = n && n.includes("json") ? await r.json() : await r.text();
        return {
            data: o,
            error: r.ok ? null : o?.message || o?.error || r.statusText,
            status: r.status
        };
    }, Nh = async ({ url: t, headers: e, auth: r, fetchOptions: n })=>{
        if (!t) throw new Error("@symbo.ls/fetch rest: url is required");
        return Sl(t, e, r, n);
    }, Sl = (t, e = {}, r, n = {})=>{
        let o = r?.token || null, s = (l)=>{
            let u = {
                ...e,
                ...l
            };
            return o && (u.Authorization = `Bearer ${o}`), u;
        }, i = (l)=>({
                ...s(l),
                "Content-Type": "application/json"
            }), a = (l)=>({
                ...n,
                ...l
            }), c = (l, u)=>{
            let p = u || t;
            if (l && (l.startsWith("http://") || l.startsWith("https://"))) return l;
            let h = l && !l.startsWith("/") ? "/" : "";
            return `${p}${h}${l || ""}`;
        };
        return {
            name: "rest",
            setToken: (l)=>{
                o = l;
            },
            getSession: async ()=>{
                if (!r?.sessionUrl) return o ? {
                    token: o
                } : null;
                let l = await pe(c(r.sessionUrl, r.baseUrl), a({
                    headers: s()
                }));
                return l.error ? null : l.data;
            },
            signIn: async (l)=>{
                if (!r?.signInUrl) throw new Error("rest: auth.signInUrl not configured");
                let u = await pe(c(r.signInUrl, r.baseUrl), a({
                    method: "POST",
                    headers: i(),
                    body: JSON.stringify(l)
                }));
                return u.data?.token && (o = u.data.token), u;
            },
            signOut: async ()=>(r?.signOutUrl && await pe(c(r.signOutUrl, r.baseUrl), a({
                    method: "POST",
                    headers: s()
                })), o = null, {
                    error: null
                }),
            select: ({ from: l, params: u, select: p, limit: h, offset: d, order: m, single: S, headers: x, baseUrl: w })=>{
                let C = {
                    ...u
                };
                return p && (C.select = p), h && (C.limit = h), d && (C.offset = d), S && (C.single = !0), m && (typeof m == "string" ? C.order = m : Array.isArray(m) ? C.order = m.map((R)=>`${R.by}:${R.asc === !1 ? "desc" : "asc"}`).join(",") : m.by && (C.order = `${m.by}:${m.asc === !1 ? "desc" : "asc"}`)), pe(Ph(w || t, l || "", C), a({
                    headers: s(x)
                }));
            },
            rpc: ({ from: l, params: u, headers: p, baseUrl: h })=>pe(c(`rpc/${l}`, h), a({
                    method: "POST",
                    headers: i(p),
                    body: JSON.stringify(u)
                })),
            insert: ({ from: l, data: u, headers: p, baseUrl: h })=>pe(c(l, h), a({
                    method: "POST",
                    headers: i(p),
                    body: JSON.stringify(u)
                })),
            update: ({ from: l, data: u, params: p, method: h, headers: d, baseUrl: m })=>{
                let S = p?.id || u?.id, x = S ? `${l}/${S}` : l;
                return pe(c(x, m), a({
                    method: h || "PATCH",
                    headers: i(d),
                    body: JSON.stringify(u)
                }));
            },
            delete: ({ from: l, params: u, headers: p, baseUrl: h })=>{
                let d = u?.id, m = d ? `${l}/${d}` : l;
                return pe(c(m, h), a({
                    method: "DELETE",
                    headers: s(p)
                }));
            }
        };
    };
});
var vl = {};
Bt(vl, {
    localAdapter: ()=>wl,
    setup: ()=>Fh
});
var si, Dh, Fh, wl, Cl = G(()=>{
    "use strict";
    si = (t, e)=>{
        if (!e) return !0;
        for(let r in e){
            let n = e[r];
            if (n === null) {
                if (t[r] !== null && t[r] !== void 0) return !1;
            } else if (Array.isArray(n)) {
                if (!n.includes(t[r])) return !1;
            } else if (typeof n == "object") {
                for(let o in n)if (o === "gt" && !(t[r] > n[o]) || o === "gte" && !(t[r] >= n[o]) || o === "lt" && !(t[r] < n[o]) || o === "lte" && !(t[r] <= n[o]) || o === "neq" && t[r] === n[o] || o === "like" && !String(t[r]).includes(n[o])) return !1;
            } else if (t[r] !== n) return !1;
        }
        return !0;
    }, Dh = (t, { order: e, limit: r, offset: n, single: o })=>{
        let s = [
            ...t
        ];
        if (e) {
            let i = typeof e == "string" ? e : e.by, a = e.asc !== !1;
            s.sort((c, f)=>c[i] < f[i] ? a ? -1 : 1 : c[i] > f[i] ? a ? 1 : -1 : 0);
        }
        return n && (s = s.slice(n)), r && (s = s.slice(0, r)), o ? {
            data: s[0] || null,
            error: null
        } : {
            data: s,
            error: null
        };
    }, Fh = async ({ data: t, ...e })=>wl(t, e), wl = (t = {}, e = {})=>{
        let r = {}, n = {}, o = e.persist !== !1 && typeof localStorage < "u", s = e.prefix || "smbls_db_", i = (l)=>{
            if (!r[l]) {
                if (o) try {
                    let u = localStorage.getItem(s + l);
                    r[l] = u ? JSON.parse(u) : t[l] || [];
                } catch  {
                    r[l] = t[l] || [];
                }
                else r[l] = t[l] || [];
            }
            return r[l];
        }, a = (l)=>{
            if (o) try {
                localStorage.setItem(s + l, JSON.stringify(r[l]));
            } catch  {}
        }, c = (l, u, p, h)=>{
            let d = n[l];
            if (d) for (let m of d)m(p, h, {
                event: u,
                table: l
            });
        }, f = Date.now();
        return {
            name: "local",
            store: r,
            select: async ({ from: l, params: u, ...p })=>{
                let d = i(l).filter((m)=>si(m, u));
                return Dh(d, p);
            },
            insert: async ({ from: l, data: u })=>{
                let p = i(l), d = (Array.isArray(u) ? u : [
                    u
                ]).map((m)=>{
                    let S = {
                        id: m.id || ++f,
                        ...m
                    };
                    return p.push(S), S;
                });
                a(l);
                for (let m of d)c(l, "INSERT", m, null);
                return {
                    data: Array.isArray(u) ? d : d[0],
                    error: null
                };
            },
            update: async ({ from: l, data: u, params: p })=>{
                let h = i(l), d = [];
                for(let m = 0; m < h.length; m++)if (si(h[m], p)) {
                    let S = {
                        ...h[m]
                    };
                    Object.assign(h[m], u), d.push(h[m]), c(l, "UPDATE", h[m], S);
                }
                return a(l), {
                    data: d,
                    error: null
                };
            },
            delete: async ({ from: l, params: u })=>{
                let p = i(l), h = [];
                for(let d = p.length - 1; d >= 0; d--)si(p[d], u) && (h.push(p[d]), p.splice(d, 1), c(l, "DELETE", null, h[h.length - 1]));
                return a(l), {
                    data: h,
                    error: null
                };
            },
            subscribe: ({ from: l, on: u }, p)=>{
                n[l] || (n[l] = []);
                let h = (d, m, S)=>{
                    u && u !== "*" && u !== S.event || p(d, m, S);
                };
                return n[l].push(h), ()=>{
                    let d = n[l].indexOf(h);
                    d > -1 && n[l].splice(d, 1);
                };
            }
        };
    };
});
var Kr = {};
Bt(Kr, {
    createAdapter: ()=>Mh,
    default: ()=>Kh,
    executeFetch: ()=>Gr,
    fetchPlugin: ()=>ui,
    initAdapterAuth: ()=>Qn,
    parseDuration: ()=>Vr,
    queryClient: ()=>Gh,
    registerAdapter: ()=>Lh,
    resolveDb: ()=>Tl
});
var $h, Al, Lh, Mh, Tl, Vr, xt, Rl, Kn, Bh, Wr, qr, zr, ii, li, Yn, Uh, El, ai, Il, Pl, rr, kl, jh, Ol, Vh, Nl, Dl, Qn, fi, Pt, Hr, Oe, zt, de, qh, zh, Hh, ci, Wh, Gr, Gh, ui, Kh;

var Ae = G(()=>{
    "use strict";
    v();
    $h = [
        "select",
        "rpc",
        "insert",
        "update",
        "delete",
        "subscribe"
    ], Al = {
        supabase: ()=>Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("dNnfS")));
            }).then((res)=>(bl(), yl)),
        rest: ()=>Promise.resolve().then(()=>(_l(), xl)),
        local: ()=>Promise.resolve().then(()=>(Cl(), vl))
    }, Lh = (t, e)=>{
        Al[t] = e;
    }, Mh = (t)=>{
        let e = {};
        for (let r of $h)t[r] && (e[r] = t[r]);
        return e.name = t.name || "custom", e;
    }, Tl = async (t)=>{
        if (!t) return null;
        if (typeof t.select == "function") return t;
        let { adapter: e, ...r } = t, n = typeof e == "string" ? e : typeof t == "string" ? t : null;
        if (!n) return null;
        let o = Al[n];
        if (!o) throw new Error(`Unknown db adapter: "${n}". Use registerAdapter() for adapters with optional deps.`);
        return (await o()).setup(r);
    }, Vr = (t)=>{
        if (!t) return 0;
        if (typeof t == "number") return t;
        let e = t.match(/^(\d+)(ms|s|m|h)$/);
        if (!e) return 0;
        let r = parseInt(e[1]), n = e[2];
        return n === "ms" ? r : n === "s" ? r * 1e3 : n === "m" ? r * 6e4 : n === "h" ? r * 36e5 : 0;
    }, xt = new Map, Rl = new Map, Kn = new Map, Bh = (t)=>{
        if (t.cache?.key) return t.cache.key;
        let e = Vh(t.params);
        return `${t.from}:${t.method}:${JSON.stringify(e || "")}`;
    }, Wr = (t)=>xt.get(t) || null, qr = (t, e, r)=>{
        let n = xt.get(t), o = {
            data: e,
            error: r,
            time: Date.now(),
            stale: !1
        };
        xt.set(t, o);
        let s = Rl.get(t);
        if (s) for (let i of s)y(i) && i(o);
        return o;
    }, zr = (t)=>{
        if (t) {
            let e = xt.get(t);
            e && (e.stale = !0);
            return;
        }
        for (let [, e] of xt)e.stale = !0;
    }, ii = (t)=>{
        if (t) {
            xt.delete(t);
            return;
        }
        xt.clear();
    }, li = (t)=>!t && t !== !1 ? {
            staleTime: 6e4,
            gcTime: 3e5
        } : t === !1 ? null : t === !0 ? {
            staleTime: 6e4,
            gcTime: 3e5
        } : typeof t == "number" ? {
            staleTime: t,
            gcTime: Math.max(t * 5, 3e5)
        } : b(t) ? {
            staleTime: Vr(t),
            gcTime: 3e5
        } : {
            staleTime: Vr(t.stale || t.staleTime) || 6e4,
            gcTime: Vr(t.gc || t.gcTime || t.expire) || 3e5,
            key: t.key
        }, Yn = null, Uh = ()=>{
        Yn || (Yn = setInterval(()=>{
            let t = Date.now();
            for (let [e, r] of xt){
                let n = Rl.get(e);
                !(n && n.size > 0) && t - r.time > (r.gcTime || 3e5) && xt.delete(e);
            }
        }, 3e4), Yn.unref && Yn.unref());
    };
    Uh();
    El = 3, ai = (t)=>Math.min(1e3 * 2 ** t, 3e4), Il = (t)=>{
        let e = t.retry;
        return e === !1 ? {
            count: 0
        } : e === !0 || e === void 0 ? {
            count: El,
            delay: ai
        } : typeof e == "number" ? {
            count: e,
            delay: ai
        } : {
            count: e.count ?? El,
            delay: y(e.delay) ? e.delay : typeof e.delay == "number" ? ()=>e.delay : ai
        };
    }, Pl = async (t, e)=>{
        let { count: r, delay: n } = e, o;
        for(let s = 0; s <= r; s++)try {
            let i = await t();
            if (i?.error) {
                if (o = i.error, s < r) {
                    let a = y(n) ? n(s, o) : n;
                    await new Promise((c)=>setTimeout(c, a));
                    continue;
                }
                return i;
            }
            return i;
        } catch (i) {
            if (o = i, s < r) {
                let a = y(n) ? n(s, i) : n;
                await new Promise((c)=>setTimeout(c, a));
                continue;
            }
            throw i;
        }
        return {
            data: null,
            error: o
        };
    }, rr = {
        focus: new Set,
        online: new Set
    }, kl = !1, jh = ()=>{
        if (kl || typeof window > "u") return;
        kl = !0;
        let t = ()=>{
            for (let r of rr.focus)r();
        }, e = ()=>{
            for (let r of rr.online)r();
        };
        window.addEventListener("visibilitychange", ()=>{
            document.visibilityState === "visible" && t();
        }), window.addEventListener("focus", t), window.addEventListener("online", e);
    }, Ol = (t, e)=>{
        let r = e.__ref;
        if (t === !0) return {
            from: r.__state || e.key,
            method: "select",
            query: !0,
            on: "create"
        };
        if (b(t)) return {
            from: t,
            method: "select",
            query: !0,
            on: "create"
        };
        if (g(t)) {
            let n = {
                ...t
            };
            return n.from = n.from || r.__state || e.key, n.method = n.method || "select", n.on = n.on || "create", n.query === void 0 && (n.query = !0), n;
        }
        return null;
    }, Vh = (t)=>(!t || y(t), t), Nl = (t, e)=>{
        let r = t?.state?.root || e?.state?.root;
        if (r?.lang) return r.lang;
    }, Dl = (t, e, r)=>{
        let n;
        if (!t) n = void 0;
        else if (y(t)) n = t(e, e.state);
        else {
            n = {};
            for(let o in t){
                let s = t[o];
                n[o] = y(s) ? s(e, e.state) : s;
            }
        }
        return n;
    }, Qn = async (t, e)=>{
        if (!t || t.__authInitialized || (t.__authInitialized = !0, !t.getSession)) return;
        let r = (n, o)=>{
            let s = e.state?.root;
            s?.update && s.update({
                auth: {
                    user: n,
                    session: o,
                    loading: !1
                }
            });
        };
        try {
            let n = await t.getSession();
            r(n?.user || null, n);
        } catch (n) {
            console.warn("[fetch] Failed to restore auth session:", n.message);
        }
        t.onAuthStateChange && t.onAuthStateChange((n, o)=>{
            r(o?.user || null, o);
        });
    }, fi = async (t, e)=>{
        if (y(t.select)) return t.auth !== !1 && await Qn(t, e), t;
        if (t.__resolved) return t.auth !== !1 && await Qn(t.__resolved, e), t.__resolved;
        if (t.__resolving) return t.__resolving;
        t.__resolving = Tl(t);
        let r = await t.__resolving;
        return delete t.__resolving, r ? (t.__resolved = r, e.fetch = r, t.auth !== !1 && await Qn(r, e), r) : null;
    }, Pt = (t, e, ...r)=>{
        let n = y(t[e]) ? t[e] : t.props && y(t.props[e]) ? t.props[e] : null;
        n && n.call(t, ...r, t, t.state, t.context);
    }, Hr = (t)=>{
        let e = {}, r = t.node;
        if (!r) return e;
        if (r.tagName === "FORM") {
            let o = new FormData(r);
            for (let [s, i] of o.entries())e[s] = i;
            return e;
        }
        let n = r.querySelectorAll("input, textarea, select");
        for(let o = 0; o < n.length; o++){
            let s = n[o], i = s.name || s.getAttribute("name");
            i && (s.type === "checkbox" ? e[i] = s.checked : s.type === "file" ? e[i] = s.files : e[i] = s.value);
        }
        return e;
    }, Oe = (t, e, r, n = {})=>{
        let o = r ? {
            [r]: e
        } : e;
        t.state?.update && t.state.update(o, {
            preventFetch: !0,
            ...n
        });
    }, zt = (t, e)=>{
        let r = t.__ref;
        r.__fetchStatus = e, r.__fetching = e.isFetching, r.__fetchError = e.error;
    }, de = async (t, e, r, n = {})=>{
        let o = r?.fetch;
        if (!o || t.enabled === !1 || y(t.enabled) && !t.enabled(e, e.state)) return;
        let s = await fi(o, r);
        if (!s) return;
        let i = e.__ref, { from: a, method: c, query: f, params: l, cache: u, transform: p, single: h, auth: d, fields: m, as: S, limit: x, offset: w, order: C, headers: R, baseUrl: T, page: A, cursor: k, getNextPageParam: L, getPreviousPageParam: P, infinite: F, placeholderData: U, initialData: Z, select: tt, keepPreviousData: pt } = t, _t;
        if (f && y(e.getQuery)) {
            let J = e.getQuery(s.name || "paths");
            J && (_t = J.select || J.length && J.join(",") || void 0);
        }
        let Mt = Dl(l, e, r), Ir = li(u), Qo = Il(t), st = Ir ? u?.key || `${a}:${c}:${JSON.stringify(Mt || "")}${F ? ":infinite" : ""}${A ? ":p" + JSON.stringify(A) : ""}` : null;
        if (!i.__fetchInitialized && st && (i.__fetchInitialized = !0, Z !== void 0)) {
            let J = y(Z) ? Z() : Z;
            qr(st, J, null);
        }
        if ((c === "select" || c === "rpc") && st && Ir) {
            let J = Wr(st);
            if (J && !J.error) {
                let q = Date.now() - J.time, ft = J.stale || q > (Ir.staleTime || 0), B = J.data;
                if (tt && (B = tt(B, e, e.state)), p && (B = p(B, e, e.state)), Oe(e, B, S), !ft) {
                    zt(e, {
                        isFetching: !1,
                        isLoading: !1,
                        isStale: !1,
                        isSuccess: !0,
                        error: null,
                        status: "success",
                        fetchStatus: "idle"
                    });
                    return;
                }
            } else if (U !== void 0) {
                let q = y(U) ? U(e, e.state) : U;
                q !== void 0 && Oe(e, q, S);
            }
        }
        if (st && Kn.has(st) && !n.force) {
            let J = Kn.get(st);
            try {
                let q = await J;
                if (q?.data !== void 0) {
                    let ft = q.data;
                    tt && (ft = tt(ft, e, e.state)), p && (ft = p(ft, e, e.state)), Oe(e, ft, S), Pt(e, "onFetchComplete", ft);
                }
            } catch  {}
            return;
        }
        let Xo = !Wr(st)?.data;
        zt(e, {
            isFetching: !0,
            isLoading: Xo,
            isStale: !1,
            isSuccess: !1,
            error: null,
            status: "pending",
            fetchStatus: "fetching"
        }), Pt(e, "onFetchStart");
        let Ac = Pl(async ()=>{
            if (d !== !1 && s.getSession) {
                let B = await s.getSession();
                if (d === !0 && !B) {
                    let wt = {
                        message: "Not authenticated"
                    };
                    return zt(e, {
                        isFetching: !1,
                        isLoading: !1,
                        isStale: !1,
                        isSuccess: !1,
                        error: wt,
                        status: "error",
                        fetchStatus: "idle"
                    }), Pt(e, "onFetchError", wt), {
                        data: null,
                        error: wt
                    };
                }
            }
            let J = s[c];
            if (!y(J)) return {
                data: null,
                error: {
                    message: `Method "${c}" not found on adapter`
                }
            };
            let q = {
                from: a,
                select: _t,
                params: Mt,
                single: h,
                limit: x,
                offset: w,
                order: C,
                headers: R,
                baseUrl: T
            }, ft = Nl(e, r);
            if (ft && (q.headers = {
                ...q.headers,
                "Accept-Language": ft
            }), A !== void 0) {
                if (g(A)) A.offset !== void 0 && (q.offset = A.offset), A.limit !== void 0 && (q.limit = A.limit), A.cursor !== void 0 && (q.params = {
                    ...q.params,
                    cursor: A.cursor
                });
                else if (typeof A == "number") {
                    let B = t.pageSize || x || 20;
                    q.offset = (A - 1) * B, q.limit = B;
                }
            }
            if (k !== void 0 && (q.params = {
                ...q.params,
                cursor: k
            }), c === "insert" || c === "update" || c === "upsert") {
                let B;
                if (m === !0 || t.on === "submit") B = Hr(e);
                else if (_(m)) {
                    let wt = Hr(e);
                    B = {};
                    for (let Zo of m)B[Zo] = wt[Zo];
                } else e.state?.parse ? B = e.state.parse() : g(e.state) && (B = {
                    ...e.state
                });
                p && (B = p(B, e, e.state)), q.data = B;
            }
            if (c === "rpc") {
                let B = Mt;
                if (t.on === "submit") {
                    let wt = Hr(e);
                    B = t.transformParams ? t.transformParams(wt, e, e.state) : wt;
                }
                q.params = B;
            }
            if (c === "subscribe") {
                let B = s.subscribe({
                    from: a,
                    params: Mt,
                    on: t.subscribeOn
                }, (wt, Zo, l_)=>{
                    Oe(e, wt, S), Pt(e, "onFetchComplete", wt);
                });
                return i.__unsubscribe = B, {
                    data: null,
                    error: null,
                    subscribed: !0
                };
            }
            return J(q);
        }, Qo);
        st && Kn.set(st, Ac);
        try {
            let J = await Ac;
            if (J?.subscribed) return;
            let { data: q, error: ft } = J || {};
            if (ft) {
                st && qr(st, null, ft), zt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !1,
                    error: ft,
                    status: "error",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchError", ft);
                return;
            }
            if (q !== void 0) {
                if ((c === "select" || c === "rpc") && st) {
                    let wt = qr(st, q, null);
                    wt.gcTime = Ir?.gcTime || 3e5;
                }
                let B = q;
                F && _(q) && (i.__pages || (i.__pages = []), n.direction === "previous" ? i.__pages.unshift(q) : i.__pages.push(q), B = i.__pages.flat(), L && (i.__nextPageParam = L(q, i.__pages), i.__hasNextPage = i.__nextPageParam != null), P && (i.__prevPageParam = P(q, i.__pages), i.__hasPreviousPage = i.__prevPageParam != null)), tt && (B = tt(B, e, e.state)), p && (B = p(B, e, e.state)), (!pt || B !== void 0) && Oe(e, B, S), zt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !0,
                    error: null,
                    status: "success",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchComplete", B);
            }
        } catch (J) {
            zt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !1,
                error: J,
                status: "error",
                fetchStatus: "idle"
            }), Pt(e, "onFetchError", J);
        } finally{
            st && Kn.delete(st);
        }
    }, qh = (t, e, r)=>{
        let n = t.on, o = e.__ref;
        o.__fetchListeners || (o.__fetchListeners = []);
        let s = t.__runner || de;
        if (n === "submit") {
            let i = (c)=>{
                c.preventDefault(), s(t, e, r);
            }, a = e.node;
            a && (a.addEventListener("submit", i), o.__fetchListeners.push(()=>a.removeEventListener("submit", i)));
        } else if (n === "click") {
            let i = ()=>s(t, e, r), a = e.node;
            a && (a.addEventListener("click", i), o.__fetchListeners.push(()=>a.removeEventListener("click", i)));
        } else n === "stateChange" && (o.__fetchOnStateChange = ()=>s(t, e, r));
    }, zh = (t, e, r)=>{
        let n = e.__ref;
        n.__fetchCleanups || (n.__fetchCleanups = []), jh();
        let o = t.refetchInterval;
        if (o) {
            let s = typeof o == "number" ? o : Vr(o);
            if (s > 0) {
                let i = setInterval(()=>{
                    (t.refetchIntervalInBackground || typeof document > "u" || document.visibilityState === "visible") && de(t, e, r, {
                        force: !0
                    });
                }, s);
                n.__fetchCleanups.push(()=>clearInterval(i));
            }
        }
        if (t.refetchOnWindowFocus !== !1) {
            let s = ()=>{
                let i = Bh(t), a = Wr(i), c = li(t.cache);
                (!a || a.stale || Date.now() - a.time > (c?.staleTime || 0)) && de(t, e, r, {
                    force: !0
                });
            };
            rr.focus.add(s), n.__fetchCleanups.push(()=>rr.focus.delete(s));
        }
        if (t.refetchOnReconnect !== !1) {
            let s = ()=>de(t, e, r, {
                    force: !0
                });
            rr.online.add(s), n.__fetchCleanups.push(()=>rr.online.delete(s));
        }
    }, Hh = (t, e, r)=>{
        if (!e.optimistic) return null;
        let n = t.__ref, o = e.as, s = t.state?.parse ? t.state.parse() : g(t.state) ? {
            ...t.state
        } : t.state;
        n.__optimisticSnapshot = s;
        let i = y(e.optimistic) ? e.optimistic(r, s, t) : e.optimistic;
        return i !== void 0 && Oe(t, i, o), s;
    }, ci = (t, e)=>{
        let r = t.__ref, n = r.__optimisticSnapshot;
        n !== void 0 && (Oe(t, n, e.as), delete r.__optimisticSnapshot);
    }, Wh = async (t, e, r)=>{
        let n = r?.fetch;
        if (!n) return;
        let o = await fi(n, r);
        if (!o) return;
        let s = e.__ref, { method: i, from: a, fields: c, transform: f, as: l, on: u, auth: p, headers: h, baseUrl: d, invalidates: m, optimistic: S, onMutate: x, onSuccess: w, onError: C, onSettled: R } = t, T;
        if (c === !0 || u === "submit") T = Hr(e);
        else if (_(c)) {
            let k = Hr(e);
            T = {};
            for (let L of c)T[L] = k[L];
        } else e.state?.parse ? T = e.state.parse() : g(e.state) && (T = {
            ...e.state
        });
        f && (T = f(T, e, e.state)), y(x) && x(T, e, e.state);
        let A = S ? Hh(e, t, T) : null;
        s.__fetching = !0, zt(e, {
            isFetching: !0,
            isLoading: !1,
            isStale: !1,
            isSuccess: !1,
            error: null,
            status: "pending",
            fetchStatus: "fetching"
        }), Pt(e, "onFetchStart");
        try {
            if (p !== !1 && o.getSession) {
                let pt = await o.getSession();
                if (p === !0 && !pt) {
                    A !== void 0 && ci(e, t), Pt(e, "onFetchError", {
                        message: "Not authenticated"
                    });
                    return;
                }
            }
            let k = o[i];
            if (!y(k)) return;
            let L = {
                from: a,
                data: T,
                headers: h,
                baseUrl: d
            };
            t.params && (L.params = Dl(t.params, e, r));
            let P = Nl(e, r);
            P && (L.headers = {
                ...L.headers,
                "Accept-Language": P
            });
            let F = Il(t), U = await Pl(()=>k(L), F), { data: Z, error: tt } = U || {};
            if (tt) {
                A !== void 0 && ci(e, t), zt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !1,
                    error: tt,
                    status: "error",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchError", tt), y(C) && C(tt, T, e), y(R) && R(null, tt, T, e);
                return;
            }
            if (delete s.__optimisticSnapshot, Z !== void 0) {
                let pt = l ? {
                    [l]: Z
                } : Z;
                e.state?.update && e.state.update(pt, {
                    preventFetch: !0
                });
            }
            if (zt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !0,
                error: null,
                status: "success",
                fetchStatus: "idle"
            }), Pt(e, "onFetchComplete", Z), y(w) && w(Z, T, e), y(R) && R(Z, null, T, e), m) {
                let pt = _(m) ? m : [
                    m
                ];
                for (let _t of pt)if (_t === !0 || _t === "*") for (let [Mt] of xt)Mt.startsWith(a + ":") && zr(Mt);
                else zr(_t);
            }
        } catch (k) {
            A !== void 0 && ci(e, t), zt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !1,
                error: k,
                status: "error",
                fetchStatus: "idle"
            }), Pt(e, "onFetchError", k), y(C) && C(k, T, e), y(R) && R(null, k, T, e);
        } finally{
            s.__fetching = !1;
        }
    }, Gr = (t, e, r, n)=>{
        if (!t || !n?.fetch) return;
        let s = O(t, e);
        if (!s) return;
        let i = _(s) ? s.map((c)=>Ol(O(c, e), e)).filter(Boolean) : [
            Ol(s, e)
        ].filter(Boolean);
        for (let c of i){
            let f = c.method === "insert" || c.method === "update" || c.method === "upsert" || c.method === "delete", l = f ? Wh : de;
            c.on === "create" ? l(c, e, n) : Promise.resolve().then(()=>{
                qh({
                    ...c,
                    __runner: l
                }, e, n);
            }), !f && c.on === "create" && (c.refetchInterval || c.refetchOnWindowFocus !== !1 || c.refetchOnReconnect !== !1) && zh(c, e, n);
        }
        let a = e.__ref;
        a.refetch = (c)=>{
            for (let f of i)de(f, e, n, {
                force: !0,
                ...c
            });
        }, a.fetchNextPage = ()=>{
            let c = i[0];
            if (!c || !c.infinite) return;
            let f = a.__nextPageParam;
            if (f == null) return;
            let l = {
                ...c,
                cursor: f
            };
            de(l, e, n, {
                direction: "next",
                force: !0
            });
        }, a.fetchPreviousPage = ()=>{
            let c = i[0];
            if (!c || !c.infinite) return;
            let f = a.__prevPageParam;
            if (f == null) return;
            let l = {
                ...c,
                cursor: f
            };
            de(l, e, n, {
                direction: "previous",
                force: !0
            });
        };
    }, Gh = {
        invalidateQueries: (t)=>{
            if (!t) {
                zr();
                return;
            }
            if (b(t)) for (let [e] of xt)(e.startsWith(t) || e.includes(t)) && zr(e);
            else if (_(t)) {
                let e = t.join(":");
                for (let [r] of xt)r.includes(e) && zr(r);
            }
        },
        removeQueries: (t)=>{
            if (!t) {
                ii();
                return;
            }
            if (b(t)) for (let [e] of xt)(e.startsWith(t) || e.includes(t)) && ii(e);
        },
        getQueryData: (t)=>Wr(t)?.data ?? void 0,
        setQueryData: (t, e)=>{
            let r = Wr(t), n = y(e) ? e(r?.data) : e;
            qr(t, n, null);
        },
        prefetchQuery: async (t, e)=>{
            let r = e?.fetch;
            if (!r) return;
            let n = await fi(r, e);
            if (!n) return;
            let o = t.cache?.key || `${t.from}:${t.method || "select"}:${JSON.stringify(t.params || "")}`, s = n[t.method || "select"];
            if (!y(s)) return;
            let i = await s({
                from: t.from,
                params: t.params,
                limit: t.limit,
                offset: t.offset,
                order: t.order,
                single: t.single
            });
            if (i?.data !== void 0 && !i?.error) {
                let a = qr(o, i.data, null);
                a.gcTime = li(t.cache)?.gcTime || 3e5;
            }
            return i;
        },
        getCache: ()=>xt,
        clear: ()=>ii()
    }, ui = {
        name: "fetch",
        create (t) {
            let e = t.fetch || t.props?.fetch;
            e && Gr(e, t, t.state, t.context);
        }
    }, Kh = Gr;
});
function di(t) {
    let e = this, { __ref: r } = e, n = [].concat(t), o = r.root[n[0]];
    if (!n || !n.length) return console.log(n, "on", e.key, "is undefined");
    for(; o.key === n[0] && (n.shift(), !!n.length);)if (o = o[n[0]], !o) return;
    return o;
}
function hi(t) {
    let e = this, { parent: r } = e;
    if (y(t)) return r.state && t(r, r.state, r.context) ? r : r.parent ? r.lookup(t) : void 0;
    if (e[t]) return e[t];
    for(; r.param !== t;){
        if (r[t]) return r[t];
        if (r = r.parent, !r) return;
    }
    return r;
}
function mi(t) {
    let e = this, { __ref: r } = e, n = r?.__children;
    if (n) for(let o = 0; o < n.length; o++){
        let s = n[o], i = e[s];
        if (s === t) return i;
        if (y(t)) {
            let c = t(i, i.state, i.context);
            if (i.state && c) return i;
        }
        let a = i?.lookdown?.(t);
        if (a) return a;
    }
}
function gi(t, e = []) {
    let r = this, { __ref: n } = r, o = n?.__children;
    if (o) {
        for(let s = 0; s < o.length; s++){
            let i = o[s], a = r[i];
            if (i === t) e.push(a);
            else if (y(t)) {
                let c = t(a, a.state, a.context);
                a.state && c && e.push(a);
            }
            a?.lookdownAll?.(t, e);
        }
        return e.length ? e : void 0;
    }
}
function Xn(t = {}) {
    let e = this;
    if (e.node?.style) {
        for(let r in t){
            let n = t[r], o = e[r];
            g(n) && o ? Xn.call(o, n) : e.node.style[r] = n;
        }
        return e;
    }
}
function yi(t) {
    let e = this;
    if (W("beforeRemove", e, t) === !1) return e;
    y(e.node.remove) ? e.node.remove() : Ge() || (console.warn("This item cant be removed"), e.log()), delete e.parent[e.key], e.parent.__ref && (e.parent.__ref.__children = os(e.parent.__ref.__children, e.key)), W("remove", e, t);
}
function Yh(t) {
    return this[t];
}
function bi(t, e) {
    let r = this;
    if (!(!t || !r.props)) return r.update({
        props: t
    }, e), r;
}
function Si(t) {
    return t ? this.__ref && this.__ref[t] : this.__ref;
}
function Qh() {
    return this.getRef("__children").map((e)=>this[e]);
}
function xi() {
    return this.getRef().path;
}
function _i(t) {
    let e = null, r = (n)=>n.__element && n.root?.isRootState;
    if (!this) e = window.platformState || window.smblsApp?.state;
    else if (r(this)) e = this.root;
    else if (this.__ref && this.__ref.path) {
        let n = this.state && r(this.state), o = y(this.state) && this.parent.state && r(this.parent.state);
        (n || o) && (e = this.state.root || this.parent.state.root);
    }
    return e || (e = window.platformState || window.smblsApp?.state), t ? e?.[t] : e;
}
function wi(t) {
    let e = this.getRootState()?.__element;
    return e && Object.keys(e).length > 0 && t ? e[t] : e;
}
function vi(t) {
    return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && t ? this.getRoot("data")[t] : this.getRoot("data");
}
function Ci(t) {
    let e = this.getRoot()?.context;
    return t ? e[t] : e;
}
function Ei(t) {
    let e = this.context;
    return t ? e[t] : e;
}
function Jn() {
    let t = this, e = [];
    for(let r in t)!Object.prototype.hasOwnProperty.call(t, r) || ze.has(r) && !as.has(r) || e.push(r);
    return e;
}
function Zn(t = []) {
    let e = this, r = {}, n = Jn.call(e), o = n.includes("children"), s = t.length ? new Set(t) : null;
    for(let i = 0; i < n.length; i++){
        let a = n[i];
        if (s && s.has(a) || !Object.prototype.hasOwnProperty.call(e, a) || o && a === "content") continue;
        let c = e[a];
        if (a === "state") {
            if (e.__ref && !e.__ref.__hasRootState) continue;
            let f = y(c && c.parse) ? c.parse() : c;
            r[a] = y(f) ? f : JSON.parse(JSON.stringify(f || {}));
        } else if (a === "scope") {
            if (e.__ref && !e.__ref.__hasRootScope) continue;
            r[a] = JSON.parse(JSON.stringify(c || {}));
        } else if (a === "props") {
            let { __element: f, update: l, ...u } = e[a];
            r[a] = u;
        } else bt(c) && Object.prototype.hasOwnProperty.call(e, a) && (r[a] = c);
    }
    return r;
}
function Yr(t = [], e = new WeakSet) {
    let r = this;
    if (e.has(r)) return;
    e.add(r);
    let n = Zn.call(r, t), o = t.length ? new Set(t) : null;
    for(let s in n){
        if (o && o.has(s) || !Object.prototype.hasOwnProperty.call(r, s)) continue;
        let i = n[s];
        Array.isArray(i) ? n[s] = i.map((a)=>N(a) ? Yr.call(a, t, e) : a) : N(i) && (n[s] = Yr.call(i, t, e));
    }
    return n;
}
function to(...t) {
    if (he !== "test" && he !== "development") return;
    let e = this, { __ref: r } = e;
    return console.groupCollapsed(e.key), t.length ? t.forEach((n)=>console.log(`%c${n}:
`, "font-weight: bold", e[n])) : (console.log(r.path), e.keys().forEach((o)=>console.log(`%c${o}:`, "font-weight: bold", e[o]))), console.log(e), console.groupEnd(e.key), e;
}
function ki(...t) {
    (he === "test" || he === "development") && console.log(...t);
}
function Oi(...t) {
    (he === "test" || he === "development") && console.warn(...t);
}
function Qr(...t) {
    if (he === "test" || he === "development") {
        if (t[t.length - 1]?.debugger) debugger;
        throw t[t.length - 1]?.verbose && to.call(this), new Error(...t);
    }
}
function Ai() {
    let t = this, { key: e, parent: r } = t, { __children: n } = r.__ref, o = n.indexOf(e), s = n[o + 1];
    return r[s];
}
function Ti(t) {
    let e = t || this, { key: r, parent: n } = e, { __children: o } = n.__ref;
    if (!o) return;
    let s = o.indexOf(r);
    return n[o[s - 1]];
}
function Ri(t = {}) {
    let e = this;
    e.data || (e.data = {}), e.data.varCaches || (e.data.varCaches = {});
    let r = e.data.varCaches, n = {}, o;
    for(let s in t)t[s] !== r[s] && (o = !0, n[s] = t[s]);
    return {
        changed: (s)=>{
            if (!o) return;
            let i = s(n, j(r));
            for(let a in n)r[a] = n[a];
            return i;
        },
        timeout: (s, i)=>{
            if (!o) return;
            let a = setTimeout(()=>{
                s(n), clearTimeout(a);
            }, i);
        }
    };
}
function Ii(t, ...e) {
    let r = this.context, n = r.utils?.[t] || r.functions?.[t] || r.methods?.[t] || r.snippets?.[t];
    if (n) try {
        let o = n.call(this, ...e);
        return o && typeof o.then == "function" && o.catch((s)=>{
            Qr.call(this, s);
        }), o;
    } catch (o) {
        if (Qr.call(this, o), r?.strictMode) throw o;
    }
}
async function Pi() {
    let t = this, e = t.context?.fetch;
    if (!e) return null;
    if (typeof e.select == "function") {
        if (!e.__authInitialized && e.getSession) {
            let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Kr));
            await o(e, t.context);
        }
        return e;
    }
    if (e.__resolved) {
        if (!e.__resolved.__authInitialized && e.__resolved.getSession) {
            let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Kr));
            await o(e.__resolved, t.context);
        }
        return e.__resolved;
    }
    if (e.__resolving) return e.__resolving;
    let r = Promise.resolve().then(()=>(Ae(), Kr)).then(({ resolveDb: o })=>o(e));
    e.__resolving = r;
    let n = await r;
    if (e.__resolved = n, t.context.fetch = n, delete e.__resolving, n.getSession) {
        let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Kr));
        await o(n, t.context);
    }
    return n;
}
function Ni(t) {
    let e = this, r = t || ut.useStateQuery || e.context?.useStateQuery;
    if (!r) return null;
    let n = {};
    if (pi(e, n), r === !0) return n;
    let o = sm[r];
    return o ? o(n) : n;
}
function Ht(t, e) {
    return !!(Fn.has(t) || e?.context?.methods?.[t]);
}
var he, Xh, pi, Jh, Fl, Zh, tm, em, rm, nm, om, sm, Di = G(()=>{
    ri();
    We();
    St();
    Xt();
    vs();
    qe();
    ni();
    he = "production";
    Xh = (t, e, r, n)=>Object.defineProperty(t, e, {
            get: r,
            set: n
        });
    pi = (t, e)=>{
        let r = t.__ref;
        if (!r) return;
        let n = r.__state;
        n && typeof n == "string" && Jh(e, n);
        let o = r.__children;
        if (o) for(let a = 0; a < o.length; a++){
            let c = t[o[a]];
            c && c.__ref && pi(c, e);
        }
        let s = r.contentElementKey || "content", i = t[s];
        i && i.__ref && pi(i, e);
    }, Jh = (t, e)=>{
        let n = e.replaceAll("../", "").replaceAll("~/", "").split("/"), o = t;
        for(let s = 0; s < n.length; s++){
            let i = n[s];
            s === n.length - 1 ? o[i] || (o[i] = !0) : (o[i] === !0 && (o[i] = {}), o[i] || (o[i] = {}), o = o[i]);
        }
    }, Fl = (t, e = 0)=>{
        let r = "  ".repeat(e), n = Object.entries(t);
        return n.length ? n.map(([s, i])=>i === !0 ? `${r}${s}` : `${r}${s} {
${Fl(i, e + 1)}
${r}}`).join(`
`) : "";
    }, Zh = (t)=>`{
${Fl(t, 1)}
}`, tm = (t)=>{
        let e = {
            fields: {},
            include: []
        }, r = (n, o)=>{
            let s = [];
            for(let i in n)if (n[i] === !0) s.push(i);
            else {
                let a = o ? `${o}.${i}` : i;
                e.include.push(a), r(n[i], a);
            }
            s.length && (e.fields[o || "_root"] = s);
        };
        return r(t, ""), e;
    }, em = (t)=>{
        let e = (s)=>{
            let i = [], a = [];
            for(let c in s)if (s[c] === !0) i.push(c);
            else {
                let f = e(s[c]), l = [];
                f.select && l.push(`$select=${f.select}`), f.expand && l.push(`$expand=${f.expand}`), a.push(l.length ? `${c}(${l.join(";")})` : c);
            }
            return {
                select: i.length ? i.join(",") : "",
                expand: a.length ? a.join(",") : ""
            };
        }, { select: r, expand: n } = e(t), o = [];
        return r && o.push(`$select=${r}`), n && o.push(`$expand=${n}`), o.join("&");
    }, rm = (t, e)=>{
        let r = [], n = [], o = new Set, s = (l, u, p)=>{
            o.add(u), p && n.push(`LEFT JOIN ${u} ON ${u}.${p}_id = ${p}.id`);
            for(let h in l)l[h] === !0 ? r.push(`${u}.${h}`) : s(l[h], h, u);
        }, i = Object.keys(t);
        i.length === 1 && t[i[0]] !== !0 ? s(t[i[0]], i[0], null) : s(t, "_root", null);
        let a = [
            ...o
        ][0] || "_root", c = r.length ? r.join(", ") : "*", f = n.length ? `
` + n.join(`
`) : "";
        return `SELECT ${c}
FROM ${a}${f}`;
    }, nm = (t)=>{
        let e = [], r = (n, o)=>{
            for(let s in n){
                let i = o ? `${o}/${s}` : s;
                n[s] === !0 ? e.push(i) : r(n[s], i);
            }
        };
        return r(t, ""), e;
    }, om = (t)=>{
        let e = (n)=>{
            let o = [];
            for(let s in n)n[s] === !0 ? o.push(s) : o.push(`${s}(${e(n[s])})`);
            return o.join(", ");
        }, r = Object.keys(t);
        return r.length === 1 && t[r[0]] !== !0 ? {
            from: r[0],
            select: e(t[r[0]])
        } : {
            from: null,
            select: e(t)
        };
    }, sm = {
        graphql: Zh,
        "json-api": tm,
        odata: em,
        sql: rm,
        supabase: om,
        paths: nm
    };
});
var im, Fi, $l = G(()=>{
    Ln();
    im = {
        snapshotId: _s
    }, Fi = (t, e)=>{
        let r = t.__ref, { currentSnapshot: n, calleeElement: o } = e;
        if (!o || o === t) {
            let a = im.snapshotId();
            return r.__currentSnapshot = a, [
                a,
                t
            ];
        }
        let i = o.__ref.__currentSnapshot;
        return n < i ? [
            i,
            o,
            !0
        ] : [
            i,
            o
        ];
    };
});
var v = G(()=>{
    Ln();
    vs();
    St();
    Xt();
    Bn();
    qe();
    Nr();
    $c();
    Lc();
    $r();
    Pr();
    Mc();
    Cs();
    Fs();
    Gs();
    qn();
    pl();
    dl();
    We();
    hl();
    Di();
    ni();
    $l();
    ri();
});
v();
v();
var ov = [
    "alert",
    "alertdialog",
    "application",
    "article",
    "banner",
    "button",
    "cell",
    "checkbox",
    "columnheader",
    "combobox",
    "complementary",
    "contentinfo",
    "definition",
    "dialog",
    "directory",
    "document",
    "feed",
    "figure",
    "form",
    "grid",
    "gridcell",
    "group",
    "heading",
    "img",
    "link",
    "list",
    "listbox",
    "listitem",
    "log",
    "main",
    "marquee",
    "math",
    "menu",
    "menubar",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "navigation",
    "none",
    "note",
    "option",
    "presentation",
    "progressbar",
    "radio",
    "radiogroup",
    "region",
    "row",
    "rowgroup",
    "rowheader",
    "scrollbar",
    "search",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "status",
    "switch",
    "tab",
    "table",
    "tablist",
    "tabpanel",
    "term",
    "textbox",
    "timer",
    "toolbar",
    "tooltip",
    "tree",
    "treegrid",
    "treeitem"
], $i = {
    default: [
        "accesskey",
        "autofocus",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "hidden",
        "id",
        "lang",
        "part",
        "placeholder",
        "slot",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate",
        "inert",
        "radiogroup",
        "role",
        "about",
        "datatype",
        "inlist",
        "prefix",
        "property",
        "resource",
        "typeof",
        "vocab",
        "autocapitalize",
        "autocorrect",
        "autosave",
        "color",
        "itemprop",
        "itemscope",
        "itemtype",
        "itemid",
        "itemref",
        "results",
        "security",
        "unselectable",
        "is"
    ],
    a: [
        "accesskey",
        "charset",
        "coords",
        "download",
        "href",
        "hreflang",
        "name",
        "rel",
        "rev",
        "shape",
        "target",
        "type"
    ],
    aria: [
        "aria-activedescendant",
        "aria-atomic",
        "aria-autocomplete",
        "aria-checked",
        "aria-colcount",
        "aria-colindex",
        "aria-colspan",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-errormessage",
        "aria-expanded",
        "aria-flowto",
        "aria-grabbed",
        "aria-haspopup",
        "aria-hidden",
        "aria-invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-level",
        "aria-live",
        "aria-modal",
        "aria-multiline",
        "aria-multiselectable",
        "aria-orientation",
        "aria-owns",
        "aria-placeholder",
        "aria-posinset",
        "aria-pressed",
        "aria-readonly",
        "aria-relevant",
        "aria-required",
        "aria-roledescription",
        "aria-rowcount",
        "aria-rowindex",
        "aria-rowspan",
        "aria-selected",
        "aria-setsize",
        "aria-sort",
        "aria-valuemax",
        "aria-valuemin",
        "aria-valuenow",
        "aria-valuetext"
    ],
    anchor: [
        "download",
        "href",
        "hreflang",
        "media",
        "ping",
        "rel",
        "target",
        "type",
        "referrerpolicy"
    ],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    area: [
        "alt",
        "coords",
        "download",
        "href",
        "hreflang",
        "media",
        "referrerpolicy",
        "rel",
        "shape",
        "target",
        "ping"
    ],
    base: [
        "href",
        "target"
    ],
    blockquote: [
        "cite"
    ],
    button: [
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "name",
        "type",
        "value"
    ],
    canvas: [
        "height",
        "width"
    ],
    col: [
        "span",
        "width"
    ],
    colgroup: [
        "span"
    ],
    data: [
        "value"
    ],
    details: [
        "open"
    ],
    del: [
        "cite",
        "datetime"
    ],
    dialog: [
        "open"
    ],
    embed: [
        "height",
        "src",
        "type",
        "width"
    ],
    fieldset: [
        "disabled",
        "form",
        "name"
    ],
    form: [
        "acceptcharset",
        "action",
        "autocomplete",
        "enctype",
        "method",
        "name",
        "novalidate",
        "target",
        "rel"
    ],
    html: [
        "manifest"
    ],
    iframe: [
        "allow",
        "allowfullscreen",
        "allowtransparency",
        "frameborder",
        "height",
        "loading",
        "marginheight",
        "marginwidth",
        "mozallowfullscreen",
        "name",
        "referrerpolicy",
        "sandbox",
        "scrolling",
        "seamless",
        "src",
        "srcdoc",
        "webkitallowfullscreen",
        "width"
    ],
    img: [
        "alt",
        "crossorigin",
        "decoding",
        "height",
        "ismap",
        "loading",
        "referrerpolicy",
        "sizes",
        "src",
        "srcset",
        "usemap",
        "width"
    ],
    ins: [
        "cite",
        "datetime"
    ],
    input: [
        "accept",
        "alt",
        "autocomplete",
        "capture",
        "checked",
        "crossorigin",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "height",
        "indeterminate",
        "list",
        "max",
        "maxlength",
        "min",
        "minlength",
        "multiple",
        "name",
        "pattern",
        "placeholder",
        "readonly",
        "required",
        "size",
        "src",
        "step",
        "type",
        "value",
        "width"
    ],
    keygen: [
        "challenge",
        "disabled",
        "form",
        "keytype",
        "keyparams",
        "name"
    ],
    label: [
        "form",
        "for"
    ],
    li: [
        "value"
    ],
    link: [
        "as",
        "crossorigin",
        "href",
        "hreflang",
        "integrity",
        "media",
        "imagesrcset",
        "imagesizes",
        "referrerpolicy",
        "rel",
        "sizes",
        "type",
        "charset"
    ],
    map: [
        "name"
    ],
    menu: [
        "type"
    ],
    media: [
        "autoplay",
        "controls",
        "currenttime",
        "defaultmuted",
        "defaultplaybackrate",
        "loop",
        "mediagroup",
        "muted",
        "playsinline",
        "preload",
        "src",
        "volume"
    ],
    meta: [
        "charset",
        "content",
        "http-equiv",
        "name",
        "media"
    ],
    meter: [
        "form",
        "high",
        "low",
        "max",
        "min",
        "optimum",
        "value"
    ],
    quote: [
        "cite"
    ],
    object: [
        "classid",
        "data",
        "form",
        "height",
        "name",
        "type",
        "usemap",
        "width",
        "wmode"
    ],
    ol: [
        "reversed",
        "start",
        "type"
    ],
    optgroup: [
        "disabled",
        "label"
    ],
    option: [
        "disabled",
        "label",
        "selected",
        "value"
    ],
    output: [
        "form",
        "for",
        "name"
    ],
    param: [
        "name",
        "value"
    ],
    progress: [
        "max",
        "value"
    ],
    slot: [
        "name"
    ],
    script: [
        "async",
        "charset",
        "crossorigin",
        "defer",
        "integrity",
        "nomodule",
        "nonce",
        "referrerpolicy",
        "src",
        "type"
    ],
    select: [
        "autocomplete",
        "disabled",
        "form",
        "multiple",
        "name",
        "required",
        "size",
        "value",
        "onchange"
    ],
    source: [
        "height",
        "media",
        "sizes",
        "src",
        "srcset",
        "type",
        "width"
    ],
    style: [
        "media",
        "nonce",
        "scoped",
        "type"
    ],
    table: [
        "align",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "rules",
        "summary",
        "width"
    ],
    textarea: [
        "autocomplete",
        "cols",
        "dirname",
        "disabled",
        "form",
        "maxlength",
        "minlength",
        "name",
        "placeholder",
        "readonly",
        "required",
        "rows",
        "value",
        "wrap"
    ],
    td: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr",
        "height",
        "width",
        "valign"
    ],
    th: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr"
    ],
    time: [
        "datetime"
    ],
    track: [
        "default",
        "kind",
        "label",
        "src",
        "srclang"
    ],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "disablepictureinpicture",
        "disableremoteplayback",
        "height",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "width"
    ],
    svg: [
        "className",
        "class",
        "color",
        "height",
        "id",
        "lang",
        "max",
        "media",
        "method",
        "min",
        "name",
        "style",
        "target",
        "type",
        "width",
        "role",
        "tabindex",
        "crossorigin",
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "allowReorder",
        "alphabetic",
        "amplitude",
        "arabic-form",
        "ascent",
        "attributeName",
        "attributeType",
        "autoReverse",
        "azimuth",
        "baseFrequency",
        "baseline-shift",
        "baseProfile",
        "bbox",
        "begin",
        "bias",
        "by",
        "calcMode",
        "cap-height",
        "clip",
        "clip-path",
        "clipPathUnits",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "contentScriptType",
        "contentStyleType",
        "cursor",
        "cx",
        "cy",
        "d",
        "decelerate",
        "descent",
        "diffuseConstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "dx",
        "dy",
        "edgeMode",
        "elevation",
        "enable-background",
        "end",
        "exponent",
        "externalResourcesRequired",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterRes",
        "filterUnits",
        "flood-color",
        "flood-opacity",
        "focusable",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "format",
        "from",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "glyphRef",
        "gradientTransform",
        "gradientUnits",
        "hanging",
        "href",
        "horiz-adv-x",
        "horiz-origin-x",
        "ideographic",
        "image-rendering",
        "in2",
        "in",
        "intercept",
        "k1",
        "k2",
        "k3",
        "k4",
        "k",
        "kernelMatrix",
        "kernelUnitLength",
        "kerning",
        "keyPoints",
        "keySplines",
        "keyTimes",
        "lengthAdjust",
        "letter-spacing",
        "lighting-color",
        "limitingConeAngle",
        "local",
        "marker-end",
        "markerHeight",
        "marker-mid",
        "marker-start",
        "markerUnits",
        "markerWidth",
        "mask",
        "maskContentUnits",
        "maskUnits",
        "mathematical",
        "mode",
        "numOctaves",
        "offset",
        "opacity",
        "operator",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "path",
        "pathLength",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "pointer-events",
        "points",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "preserveAlpha",
        "preserveAspectRatio",
        "primitiveUnits",
        "r",
        "radius",
        "refX",
        "refY",
        "rendering-intent",
        "repeatCount",
        "repeatDur",
        "requiredExtensions",
        "requiredFeatures",
        "restart",
        "result",
        "rotate",
        "rx",
        "ry",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "spacing",
        "specularConstant",
        "specularExponent",
        "speed",
        "spreadMethod",
        "startOffset",
        "stdDeviation",
        "stemh",
        "stemv",
        "stitchTiles",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "string",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "surfaceScale",
        "systemLanguage",
        "tableValues",
        "targetX",
        "targetY",
        "text-anchor",
        "text-decoration",
        "textLength",
        "text-rendering",
        "to",
        "transform",
        "u1",
        "u2",
        "underline-position",
        "underline-thickness",
        "unicode",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "values",
        "vector-effect",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "v-hanging",
        "v-ideographic",
        "viewBox",
        "viewTarget",
        "visibility",
        "v-mathematical",
        "widths",
        "word-spacing",
        "writing-mode",
        "x1",
        "x2",
        "x",
        "xChannelSelector",
        "x-height",
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:href",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type",
        "xml:base",
        "xml:lang",
        "xmlns",
        "xmlns:xlink",
        "xml:space",
        "y1",
        "y2",
        "y",
        "yChannelSelector",
        "z",
        "zoomAndPan"
    ]
}, am = [
    "oncopy",
    "oncut",
    "onpaste",
    "oncompositionend",
    "oncompositionstart",
    "oncompositionupdate",
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onblur",
    "onchange",
    "onbeforeinput",
    "oninput",
    "onreset",
    "onsubmit",
    "oninvalid",
    "onformdata",
    "onload",
    "onerror",
    "ontoggle",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onabort",
    "oncanplay",
    "oncanplaythrough",
    "oncuechange",
    "ondurationchange",
    "onemptied",
    "onencrypted",
    "onended",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onseeked",
    "onseeking",
    "onstalled",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting",
    "onauxclick",
    "onclick",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onselect",
    "onselectionchange",
    "onselectstart",
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    "ongotpointercapture",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerup",
    "onlostpointercapture",
    "onscroll",
    "onresize",
    "onwheel",
    "onanimationstart",
    "onanimationend",
    "onanimationiteration",
    "ontransitionstart",
    "ontransitionrun",
    "ontransitionend",
    "ontransitioncancel",
    "onoutrostart",
    "onoutroend",
    "onintrostart",
    "onintroend",
    "onmessage",
    "onmessageerror",
    "onvisibilitychange",
    "oncancel",
    "onclose",
    "onfullscreenchange",
    "onfullscreenerror"
], Li = (t)=>t.startsWith("aria") && t.length > 4 && t.charCodeAt(4) >= 65 && t.charCodeAt(4) <= 90 ? "aria-" + t.charAt(4).toLowerCase() + t.slice(5).replace(/([A-Z])/g, (e)=>"-" + e.toLowerCase()) : t.startsWith("data") && t.length > 4 && t.charCodeAt(4) >= 65 && t.charCodeAt(4) <= 90 ? "data-" + t.charAt(4).toLowerCase() + t.slice(5).replace(/([A-Z])/g, (e)=>"-" + e.toLowerCase()) : null, Mi = (t, e)=>{
    if (e.startsWith("aria-") || e.startsWith("data-") || Li(e)) return !0;
    if (Object.prototype.hasOwnProperty.call($i, t)) {
        let r = $i[t];
        return r.includes(e) || r.includes("default");
    } else return $i.default.includes(e);
}, Bl = (t)=>{
    if (!b(t)) return !1;
    let e = t.toLowerCase();
    return am.includes(e);
}, Ul = (t, e, r)=>{
    let n = {};
    for(let o in e)if (Object.prototype.hasOwnProperty.call(e, o)) {
        if (r && o in r) continue;
        if (o === "aria" && e[o] && typeof e[o] == "object") {
            for(let a in e[o])bt(e[o][a]) && (n["aria-" + a] = e[o][a]);
            continue;
        }
        if (o === "data" && e[o] && typeof e[o] == "object") {
            for(let a in e[o])if (bt(e[o][a])) {
                let c = a.replace(/([A-Z])/g, (f)=>"-" + f.toLowerCase());
                n["data-" + c] = e[o][a];
            }
            continue;
        }
        let s = Mi(t, o), i = Bl(o);
        if (bt(e[o]) && (s || i)) {
            let a = Li(o) || o;
            n[a] = e[o];
        }
    }
    return n;
}, sv = (t, e)=>{
    let r = {};
    if (t.attr) for(let n in t.attr)r[n] = t.attr[n](e, e.state, e.context);
    return r;
}, Te = (t, e)=>{
    let r = t.call("exec", e, t);
    if (r) return b(r) && r.includes("{{") && (r = t.call("replaceLiteralsWithObjectFields", r)), r;
}, Ll = (t, e)=>{
    let r = (t.props.preSrc || "") + (Te(t, e) || "");
    if (!r) return;
    try {
        return new URL(r), r;
    } catch  {}
    let { context: n } = t;
    if (!n.files) return r;
    let o = r.startsWith("/files/") ? r.slice(7) : r, s = n.files[r] || n.files[o];
    return s && s.content ? s.content.src : r;
}, Xr = {
    src: (t)=>Ll(t, t.props.src),
    href: (t)=>Te(t, t.props.href),
    action: (t)=>Te(t, t.props.action),
    poster: (t)=>Ll(t, t.props.poster),
    data: (t)=>Te(t, t.props.data)
}, iv = (t)=>{
    let e = t.tag || "div", { props: r } = t, n = {};
    for(let o in Xr)if (r[o] !== void 0 && Mi(e, o)) {
        let s = Xr[o](t);
        s !== void 0 && (n[o] = s);
    }
    return n;
}, Ml = (t, e)=>{
    let r = e.context?.cases?.[t];
    if (r !== void 0) return y(r) ? r.call(e, e) : !!r;
}, cm = (t, e, r)=>{
    if (t === "$") {
        let o = Ml(e, r);
        return o === void 0 && (o = !!r.props?.[e]), o;
    }
    let n = r.props[e] === !0 || r.state[e] || r[e];
    if (!n) {
        let o = Ml(e, r);
        o !== void 0 && (n = o);
    }
    return t === "." ? !!n : !n;
}, lm = new Set([
    "$",
    ".",
    "!"
]), jl = (t, e, r)=>{
    let n = {}, o = (s, i, a, c)=>{
        let f = i;
        n[s] = (l)=>{
            if (cm(a, c, l)) return y(f) ? f(l) : f;
        };
    };
    for(let s in t){
        let i = s.charAt(0);
        if (!lm.has(i)) continue;
        let a = t[s];
        if (!a || typeof a != "object") continue;
        let c = s.slice(1);
        for(let f in a){
            if (r && f in r) continue;
            if (f === "aria" && a[f] && typeof a[f] == "object") {
                for(let h in a[f])o("aria-" + h, a[f][h], i, c);
                continue;
            }
            if (f === "data" && a[f] && typeof a[f] == "object") {
                for(let h in a[f]){
                    let d = h.replace(/([A-Z])/g, (m)=>"-" + m.toLowerCase());
                    o("data-" + d, a[f][h], i, c);
                }
                continue;
            }
            let l = Mi(e, f), u = Bl(f);
            if (!l && !u) continue;
            let p = Li(f) || f;
            o(p, a[f], i, c);
        }
    }
    return n;
};
v();
v();
var fm = !1;
function um(t) {
    if (t.sheet) return t.sheet;
    for(var e = 0; e < document.styleSheets.length; e++)if (document.styleSheets[e].ownerNode === t) return document.styleSheets[e];
}
function pm(t) {
    var e = document.createElement("style");
    return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var Vl = function() {
    function t(r) {
        var n = this;
        this._insertTag = function(o) {
            var s;
            n.tags.length === 0 ? n.insertionPoint ? s = n.insertionPoint.nextSibling : n.prepend ? s = n.container.firstChild : s = n.before : s = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, s), n.tags.push(o);
        }, this.isSpeedy = r.speedy === void 0 ? !fm : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
    }
    var e = t.prototype;
    return e.hydrate = function(n) {
        n.forEach(this._insertTag);
    }, e.insert = function(n) {
        this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(pm(this));
        var o = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var s = um(o);
            try {
                s.insertRule(n, s.cssRules.length);
            } catch  {}
        } else o.appendChild(document.createTextNode(n));
        this.ctr++;
    }, e.flush = function() {
        this.tags.forEach(function(n) {
            var o;
            return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
        }), this.tags = [], this.ctr = 0;
    }, t;
}();
var lt = "-ms-", Jr = "-moz-", V = "-webkit-", eo = "comm", nr = "rule", or = "decl";
var ql = "@import";
var ro = "@keyframes";
var zl = "@layer";
var Hl = Math.abs, Re = String.fromCharCode, Wl = Object.assign;
function Gl(t, e) {
    return et(t, 0) ^ 45 ? (((e << 2 ^ et(t, 0)) << 2 ^ et(t, 1)) << 2 ^ et(t, 2)) << 2 ^ et(t, 3) : 0;
}
function no(t) {
    return t.trim();
}
function Bi(t, e) {
    return (t = e.exec(t)) ? t[0] : t;
}
function M(t, e, r) {
    return t.replace(e, r);
}
function Zr(t, e) {
    return t.indexOf(e);
}
function et(t, e) {
    return t.charCodeAt(e) | 0;
}
function me(t, e, r) {
    return t.slice(e, r);
}
function dt(t) {
    return t.length;
}
function sr(t) {
    return t.length;
}
function ir(t, e) {
    return e.push(t), t;
}
function Ui(t, e) {
    return t.map(e).join("");
}
var oo = 1, ar = 1, Kl = 0, ht = 0, rt = 0, lr = "";
function tn(t, e, r, n, o, s, i) {
    return {
        value: t,
        root: e,
        parent: r,
        type: n,
        props: o,
        children: s,
        line: oo,
        column: ar,
        length: i,
        return: ""
    };
}
function fr(t, e) {
    return Wl(tn("", null, null, "", null, null, 0), t, {
        length: -t.length
    }, e);
}
function Yl() {
    return rt;
}
function Ql() {
    return rt = ht > 0 ? et(lr, --ht) : 0, ar--, rt === 10 && (ar = 1, oo--), rt;
}
function mt() {
    return rt = ht < Kl ? et(lr, ht++) : 0, ar++, rt === 10 && (ar = 1, oo++), rt;
}
function Nt() {
    return et(lr, ht);
}
function en() {
    return ht;
}
function ur(t, e) {
    return me(lr, t, e);
}
function cr(t) {
    switch(t){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function so(t) {
    return oo = ar = 1, Kl = dt(lr = t), ht = 0, [];
}
function io(t) {
    return lr = "", t;
}
function pr(t) {
    return no(ur(ht - 1, ji(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function Xl(t) {
    for(; (rt = Nt()) && rt < 33;)mt();
    return cr(t) > 2 || cr(rt) > 3 ? "" : " ";
}
function Jl(t, e) {
    for(; --e && mt() && !(rt < 48 || rt > 102 || rt > 57 && rt < 65 || rt > 70 && rt < 97););
    return ur(t, en() + (e < 6 && Nt() == 32 && mt() == 32));
}
function ji(t) {
    for(; mt();)switch(rt){
        case t:
            return ht;
        case 34:
        case 39:
            t !== 34 && t !== 39 && ji(rt);
            break;
        case 40:
            t === 41 && ji(t);
            break;
        case 92:
            mt();
            break;
    }
    return ht;
}
function Zl(t, e) {
    for(; mt() && t + rt !== 57;)if (t + rt === 84 && Nt() === 47) break;
    return "/*" + ur(e, ht - 1) + "*" + Re(t === 47 ? t : mt());
}
function tf(t) {
    for(; !cr(Nt());)mt();
    return ur(t, ht);
}
function nf(t) {
    return io(ao("", null, null, null, [
        ""
    ], t = so(t), 0, [
        0
    ], t));
}
function ao(t, e, r, n, o, s, i, a, c) {
    for(var f = 0, l = 0, u = i, p = 0, h = 0, d = 0, m = 1, S = 1, x = 1, w = 0, C = "", R = o, T = s, A = n, k = C; S;)switch(d = w, w = mt()){
        case 40:
            if (d != 108 && et(k, u - 1) == 58) {
                Zr(k += M(pr(w), "&", "&\f"), "&\f") != -1 && (x = -1);
                break;
            }
        case 34:
        case 39:
        case 91:
            k += pr(w);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            k += Xl(d);
            break;
        case 92:
            k += Jl(en() - 1, 7);
            continue;
        case 47:
            switch(Nt()){
                case 42:
                case 47:
                    ir(dm(Zl(mt(), en()), e, r), c);
                    break;
                default:
                    k += "/";
            }
            break;
        case 123 * m:
            a[f++] = dt(k) * x;
        case 125 * m:
        case 59:
        case 0:
            switch(w){
                case 0:
                case 125:
                    S = 0;
                case 59 + l:
                    x == -1 && (k = M(k, /\f/g, "")), h > 0 && dt(k) - u && ir(h > 32 ? rf(k + ";", n, r, u - 1) : rf(M(k, " ", "") + ";", n, r, u - 2), c);
                    break;
                case 59:
                    k += ";";
                default:
                    if (ir(A = ef(k, e, r, f, l, o, a, C, R = [], T = [], u), s), w === 123) {
                        if (l === 0) ao(k, e, A, A, R, s, u, a, T);
                        else switch(p === 99 && et(k, 3) === 110 ? 100 : p){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ao(t, A, A, n && ir(ef(t, A, A, 0, 0, o, a, C, o, R = [], u), T), o, T, u, a, n ? R : T);
                                break;
                            default:
                                ao(k, A, A, A, [
                                    ""
                                ], T, 0, a, T);
                        }
                    }
            }
            f = l = h = 0, m = x = 1, C = k = "", u = i;
            break;
        case 58:
            u = 1 + dt(k), h = d;
        default:
            if (m < 1) {
                if (w == 123) --m;
                else if (w == 125 && m++ == 0 && Ql() == 125) continue;
            }
            switch(k += Re(w), w * m){
                case 38:
                    x = l > 0 ? 1 : (k += "\f", -1);
                    break;
                case 44:
                    a[f++] = (dt(k) - 1) * x, x = 1;
                    break;
                case 64:
                    Nt() === 45 && (k += pr(mt())), p = Nt(), l = u = dt(C = k += tf(en())), w++;
                    break;
                case 45:
                    d === 45 && dt(k) == 2 && (m = 0);
            }
    }
    return s;
}
function ef(t, e, r, n, o, s, i, a, c, f, l) {
    for(var u = o - 1, p = o === 0 ? s : [
        ""
    ], h = sr(p), d = 0, m = 0, S = 0; d < n; ++d)for(var x = 0, w = me(t, u + 1, u = Hl(m = i[d])), C = t; x < h; ++x)(C = no(m > 0 ? p[x] + " " + w : M(w, /&\f/g, p[x]))) && (c[S++] = C);
    return tn(t, e, r, o === 0 ? nr : a, c, f, l);
}
function dm(t, e, r) {
    return tn(t, e, r, eo, Re(Yl()), me(t, 2, -2), 0);
}
function rf(t, e, r, n) {
    return tn(t, e, r, or, me(t, 0, n), me(t, n + 1, -1), n);
}
function Ie(t, e) {
    for(var r = "", n = sr(t), o = 0; o < n; o++)r += e(t[o], o, t, e) || "";
    return r;
}
function of(t, e, r, n) {
    switch(t.type){
        case zl:
            if (t.children.length) break;
        case ql:
        case or:
            return t.return = t.return || t.value;
        case eo:
            return "";
        case ro:
            return t.return = t.value + "{" + Ie(t.children, n) + "}";
        case nr:
            t.value = t.props.join(",");
    }
    return dt(r = Ie(t.children, n)) ? t.return = t.value + "{" + r + "}" : "";
}
function sf(t) {
    var e = sr(t);
    return function(r, n, o, s) {
        for(var i = "", a = 0; a < e; a++)i += t[a](r, n, o, s) || "";
        return i;
    };
}
function af(t) {
    return function(e) {
        e.root || (e = e.return) && t(e);
    };
}
function cf(t) {
    var e = Object.create(null);
    return function(r) {
        return e[r] === void 0 && (e[r] = t(r)), e[r];
    };
}
var hm = function(e, r, n) {
    for(var o = 0, s = 0; o = s, s = Nt(), o === 38 && s === 12 && (r[n] = 1), !cr(s);)mt();
    return ur(e, ht);
}, mm = function(e, r) {
    var n = -1, o = 44;
    do switch(cr(o)){
        case 0:
            o === 38 && Nt() === 12 && (r[n] = 1), e[n] += hm(ht - 1, r, n);
            break;
        case 2:
            e[n] += pr(o);
            break;
        case 4:
            if (o === 44) {
                e[++n] = Nt() === 58 ? "&\f" : "", r[n] = e[n].length;
                break;
            }
        default:
            e[n] += Re(o);
    }
    while (o = mt());
    return e;
}, gm = function(e, r) {
    return io(mm(so(e), r));
}, lf = new WeakMap, ym = function(e) {
    if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
        for(var r = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; n.type !== "rule";)if (n = n.parent, !n) return;
        if (!(e.props.length === 1 && r.charCodeAt(0) !== 58 && !lf.get(n)) && !o) {
            lf.set(e, !0);
            for(var s = [], i = gm(r, s), a = n.props, c = 0, f = 0; c < i.length; c++)for(var l = 0; l < a.length; l++, f++)e.props[f] = s[c] ? i[c].replace(/&\f/g, a[l]) : a[l] + " " + i[c];
        }
    }
}, bm = function(e) {
    if (e.type === "decl") {
        var r = e.value;
        r.charCodeAt(0) === 108 && r.charCodeAt(2) === 98 && (e.return = "", e.value = "");
    }
};
function ff(t, e) {
    switch(Gl(t, e)){
        case 5103:
            return V + "print-" + t + t;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return V + t + t;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return V + t + Jr + t + lt + t + t;
        case 6828:
        case 4268:
            return V + t + lt + t + t;
        case 6165:
            return V + t + lt + "flex-" + t + t;
        case 5187:
            return V + t + M(t, /(\w+).+(:[^]+)/, V + "box-$1$2" + lt + "flex-$1$2") + t;
        case 5443:
            return V + t + lt + "flex-item-" + M(t, /flex-|-self/, "") + t;
        case 4675:
            return V + t + lt + "flex-line-pack" + M(t, /align-content|flex-|-self/, "") + t;
        case 5548:
            return V + t + lt + M(t, "shrink", "negative") + t;
        case 5292:
            return V + t + lt + M(t, "basis", "preferred-size") + t;
        case 6060:
            return V + "box-" + M(t, "-grow", "") + V + t + lt + M(t, "grow", "positive") + t;
        case 4554:
            return V + M(t, /([^-])(transform)/g, "$1" + V + "$2") + t;
        case 6187:
            return M(M(M(t, /(zoom-|grab)/, V + "$1"), /(image-set)/, V + "$1"), t, "") + t;
        case 5495:
        case 3959:
            return M(t, /(image-set\([^]*)/, V + "$1$`$1");
        case 4968:
            return M(M(t, /(.+:)(flex-)?(.*)/, V + "box-pack:$3" + lt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + V + t + t;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return M(t, /(.+)-inline(.+)/, V + "$1$2") + t;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (dt(t) - 1 - e > 6) switch(et(t, e + 1)){
                case 109:
                    if (et(t, e + 4) !== 45) break;
                case 102:
                    return M(t, /(.+:)(.+)-([^]+)/, "$1" + V + "$2-$3$1" + Jr + (et(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
                case 115:
                    return ~Zr(t, "stretch") ? ff(M(t, "stretch", "fill-available"), e) + t : t;
            }
            break;
        case 4949:
            if (et(t, e + 1) !== 115) break;
        case 6444:
            switch(et(t, dt(t) - 3 - (~Zr(t, "!important") && 10))){
                case 107:
                    return M(t, ":", ":" + V) + t;
                case 101:
                    return M(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + V + (et(t, 14) === 45 ? "inline-" : "") + "box$3$1" + V + "$2$3$1" + lt + "$2box$3") + t;
            }
            break;
        case 5936:
            switch(et(t, e + 11)){
                case 114:
                    return V + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
                case 108:
                    return V + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
                case 45:
                    return V + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
            }
            return V + t + lt + t + t;
    }
    return t;
}
var Sm = function(e, r, n, o) {
    if (e.length > -1 && !e.return) switch(e.type){
        case or:
            e.return = ff(e.value, e.length);
            break;
        case ro:
            return Ie([
                fr(e, {
                    value: M(e.value, "@", "@" + V)
                })
            ], o);
        case nr:
            if (e.length) return Ui(e.props, function(s) {
                switch(Bi(s, /(::plac\w+|:read-\w+)/)){
                    case ":read-only":
                    case ":read-write":
                        return Ie([
                            fr(e, {
                                props: [
                                    M(s, /:(read-\w+)/, ":" + Jr + "$1")
                                ]
                            })
                        ], o);
                    case "::placeholder":
                        return Ie([
                            fr(e, {
                                props: [
                                    M(s, /:(plac\w+)/, ":" + V + "input-$1")
                                ]
                            }),
                            fr(e, {
                                props: [
                                    M(s, /:(plac\w+)/, ":" + Jr + "$1")
                                ]
                            }),
                            fr(e, {
                                props: [
                                    M(s, /:(plac\w+)/, lt + "input-$1")
                                ]
                            })
                        ], o);
                }
                return "";
            });
    }
}, xm = [
    Sm
], uf = function(e) {
    var r = e.key;
    if (r === "css") {
        var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
        Array.prototype.forEach.call(n, function(m) {
            var S = m.getAttribute("data-emotion");
            S.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
        });
    }
    var o = e.stylisPlugins || xm, s = {}, i, a = [];
    i = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + r + ' "]'), function(m) {
        for(var S = m.getAttribute("data-emotion").split(" "), x = 1; x < S.length; x++)s[S[x]] = !0;
        a.push(m);
    });
    var c, f = [
        ym,
        bm
    ];
    var l, u = [
        of,
        af(function(m) {
            l.insert(m);
        })
    ], p = sf(f.concat(o, u)), h = function(S) {
        return Ie(nf(S), p);
    };
    c = function(S, x, w, C) {
        l = w, h(S ? S + "{" + x.styles + "}" : x.styles), C && (d.inserted[x.name] = !0);
    };
    var d = {
        key: r,
        sheet: new Vl({
            key: r,
            container: i,
            nonce: e.nonce,
            speedy: e.speedy,
            prepend: e.prepend,
            insertionPoint: e.insertionPoint
        }),
        nonce: e.nonce,
        inserted: s,
        registered: {},
        insert: c
    };
    return d.sheet.hydrate(a), d;
};
function pf(t) {
    for(var e = 0, r, n = 0, o = t.length; o >= 4; ++n, o -= 4)r = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, r = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= r >>> 24, e = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
    switch(o){
        case 3:
            e ^= (t.charCodeAt(n + 2) & 255) << 16;
        case 2:
            e ^= (t.charCodeAt(n + 1) & 255) << 8;
        case 1:
            e ^= t.charCodeAt(n) & 255, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
    }
    return e ^= e >>> 13, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var df = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var _m = !1, wm = /[A-Z]|^ms/g, vm = /_EMO_([^_]+?)_([^]*?)_EMO_/g, yf = function(e) {
    return e.charCodeAt(1) === 45;
}, hf = function(e) {
    return e != null && typeof e != "boolean";
}, Vi = cf(function(t) {
    return yf(t) ? t : t.replace(wm, "-$&").toLowerCase();
}), mf = function(e, r) {
    switch(e){
        case "animation":
        case "animationName":
            if (typeof r == "string") return r.replace(vm, function(n, o, s) {
                return Wt = {
                    name: o,
                    styles: s,
                    next: Wt
                }, o;
            });
    }
    return df[e] !== 1 && !yf(e) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, Cm = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function rn(t, e, r) {
    if (r == null) return "";
    var n = r;
    if (n.__emotion_styles !== void 0) return n;
    switch(typeof r){
        case "boolean":
            return "";
        case "object":
            var o = r;
            if (o.anim === 1) return Wt = {
                name: o.name,
                styles: o.styles,
                next: Wt
            }, o.name;
            var s = r;
            if (s.styles !== void 0) {
                var i = s.next;
                if (i !== void 0) for(; i !== void 0;)Wt = {
                    name: i.name,
                    styles: i.styles,
                    next: Wt
                }, i = i.next;
                var a = s.styles + ";";
                return a;
            }
            return Em(t, e, r);
        case "function":
            if (t !== void 0) {
                var c = Wt, f = r(t);
                return Wt = c, rn(t, e, f);
            }
            break;
    }
    var l = r;
    if (e == null) return l;
    var u = e[l];
    return u !== void 0 ? u : l;
}
function Em(t, e, r) {
    var n = "";
    if (Array.isArray(r)) for(var o = 0; o < r.length; o++)n += rn(t, e, r[o]) + ";";
    else for(var s in r){
        var i = r[s];
        if (typeof i != "object") {
            var a = i;
            e != null && e[a] !== void 0 ? n += s + "{" + e[a] + "}" : hf(a) && (n += Vi(s) + ":" + mf(s, a) + ";");
        } else {
            if (s === "NO_COMPONENT_SELECTOR" && _m) throw new Error(Cm);
            if (Array.isArray(i) && typeof i[0] == "string" && (e == null || e[i[0]] === void 0)) for(var c = 0; c < i.length; c++)hf(i[c]) && (n += Vi(s) + ":" + mf(s, i[c]) + ";");
            else {
                var f = rn(t, e, i);
                switch(s){
                    case "animation":
                    case "animationName":
                        n += Vi(s) + ":" + f + ";";
                        break;
                    default:
                        n += s + "{" + f + "}";
                }
            }
        }
    }
    return n;
}
var gf = /label:\s*([^\s;{]+)\s*(;|$)/g, Wt;
function co(t, e, r) {
    if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0) return t[0];
    var n = !0, o = "";
    Wt = void 0;
    var s = t[0];
    if (s == null || s.raw === void 0) n = !1, o += rn(r, e, s);
    else {
        var i = s;
        o += i[0];
    }
    for(var a = 1; a < t.length; a++)if (o += rn(r, e, t[a]), n) {
        var c = s;
        o += c[a];
    }
    gf.lastIndex = 0;
    for(var f = "", l; (l = gf.exec(o)) !== null;)f += "-" + l[1];
    var u = pf(o) + f;
    return {
        name: u,
        styles: o,
        next: Wt
    };
}
var km = !0;
function qi(t, e, r) {
    var n = "";
    return r.split(" ").forEach(function(o) {
        t[o] !== void 0 ? e.push(t[o] + ";") : o && (n += o + " ");
    }), n;
}
var Om = function(e, r, n) {
    var o = e.key + "-" + r.name;
    (n === !1 || km === !1) && e.registered[o] === void 0 && (e.registered[o] = r.styles);
}, bf = function(e, r, n) {
    Om(e, r, n);
    var o = e.key + "-" + r.name;
    if (e.inserted[r.name] === void 0) {
        var s = r;
        do e.insert(r === s ? "." + o : "", s, e.sheet, !0), s = s.next;
        while (s !== void 0);
    }
};
function Sf(t, e) {
    if (t.inserted[e.name] === void 0) return t.insert("", e, t.sheet, !0);
}
function xf(t, e, r) {
    var n = [], o = qi(t, n, r);
    return n.length < 2 ? r : o + e(n);
}
var zi = function(e) {
    var r = uf(e);
    r.sheet.speedy = function(a) {
        this.isSpeedy = a;
    }, r.compat = !0;
    var n = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered, void 0);
        return bf(r, u, !1), r.key + "-" + u.name;
    }, o = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered), p = "animation-" + u.name;
        return Sf(r, {
            name: u.name,
            styles: "@keyframes " + p + "{" + u.styles + "}"
        }), p;
    }, s = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered);
        Sf(r, u);
    }, i = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        return xf(r.registered, n, Am(f));
    };
    return {
        css: n,
        cx: i,
        injectGlobal: s,
        keyframes: o,
        hydrate: function(c) {
            c.forEach(function(f) {
                r.inserted[f] = !0;
            });
        },
        flush: function() {
            r.registered = {}, r.inserted = {}, r.sheet.flush();
        },
        sheet: r.sheet,
        cache: r,
        getRegisteredStyles: qi.bind(null, r.registered),
        merge: xf.bind(null, r.registered, n)
    };
}, Am = function t(e) {
    for(var r = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (o != null) {
            var s = void 0;
            switch(typeof o){
                case "boolean":
                    break;
                case "object":
                    if (Array.isArray(o)) s = t(o);
                    else {
                        s = "";
                        for(var i in o)o[i] && i && (s && (s += " "), s += i);
                    }
                    break;
                default:
                    s = o;
            }
            s && (r && (r += " "), r += s);
        }
    }
    return r;
};
v();
v();
var Tm = /\s+/g, jv = (t)=>{
    let { key: e } = t;
    t.classlist === !0 ? t.classlist = e : !t.classlist && typeof e == "string" && e.charCodeAt(0) === 95 && e.charCodeAt(1) !== 95 && (t.classlist = e.slice(1));
}, Rm = (t, e)=>{
    let r = "";
    for(let n in t){
        let o = t[n];
        typeof o == "boolean" && o ? r += ` ${n}` : typeof o == "string" ? r += ` ${o}` : typeof o == "function" && (r += ` ${O(o, e)}`);
    }
    return r;
}, Im = (t, e)=>{
    if (!t) return;
    let { key: r } = e;
    return t === !0 && (t = e.classlist = {
        key: r
    }), b(t) && (t = e.classlist = {
        default: t
    }), g(t) && (t = Rm(t, e)), t.replace(Tm, " ").trim();
}, Hi = (t, e, r)=>{
    let n = Im(t, e);
    if (r && typeof r.setAttribute == "function") r.setAttribute("class", n);
    else if (r) try {
        r.className = n;
    } catch  {}
    return n;
};
function Vv(t, e, r) {
    Hi(t, e, r);
}
var Pm = (t = "smbls", e)=>{
    typeof t != "string" && (t = String(t || "smbls"));
    let r = t.replace(/\./g, "-");
    return zi({
        key: r,
        container: e
    });
}, Ct = Pm(), Nm = (t)=>(e, r, n)=>{
        let o = O(e, r);
        if (e) {
            let { __ref: s } = r;
            s.__class.style = o;
        }
        _f(t)(r.classlist, r, r.state, !0);
    }, _f = (t)=>(e, r, n, o)=>{
        if (r.style && !o) return;
        let { __ref: s } = r, { __class: i, __classNames: a } = s;
        if (N(e)) {
            r.props.class && (a.classProps = r.props.class), r.attr?.class && (a.class = r.attr.class);
            for(let c in i){
                let f = i[c];
                if (!f) {
                    delete a[c];
                    continue;
                }
                let l;
                b(f) || ct(f) ? l = f : Pn(f) ? l = r.key : l = t.css(f), a[c] = l;
            }
            for(let c in a)c === "classProps" || c === "class" || i[c] === void 0 && delete a[c];
            r.node && Hi(a, r, r.node);
        }
    }, wf = (t, e)=>(t || (t = zi(e || {
        key: "smbls"
    })), {
        style: Nm(t),
        classlist: _f(t)
    });
var br = {};
Bt(br, {
    CSS_NATIVE_COLOR_REGEX: ()=>te,
    CSS_UNITS: ()=>on,
    applyMediaSequenceVars: ()=>yr,
    applySequenceGlobalVars: ()=>ia,
    applySequenceVars: ()=>$e,
    changeLightness: ()=>Bm,
    colorStringToRgbaArray: ()=>ge,
    convertSvgToSymbol: ()=>aa,
    findHeadingLetter: ()=>Lf,
    findHeadings: ()=>sa,
    generateSequence: ()=>Kt,
    generateSequencePosition: ()=>Yg,
    generateSprite: ()=>go,
    generateSubSequence: ()=>na,
    getColorShade: ()=>Of,
    getDefaultOrFirstKey: ()=>an,
    getFnPrefixAndValue: ()=>Fe,
    getFontFace: ()=>Vm,
    getFontFaceEach: ()=>cn,
    getFontFaceEachString: ()=>If,
    getFontFaceString: ()=>Gi,
    getFontFormat: ()=>Tf,
    getRgbTone: ()=>sn,
    getSequenceValue: ()=>oa,
    getSequenceValueBySymbols: ()=>$f,
    getSequenceValuePropertyPair: ()=>be,
    getSubratio: ()=>ra,
    getSubratioDifference: ()=>ea,
    hexToRgb: ()=>Fm,
    hexToRgbArray: ()=>vf,
    hexToRgba: ()=>Lm,
    hslToRgb: ()=>kf,
    isCSSVar: ()=>nt,
    isGoogleFontsUrl: ()=>fo,
    isResolvedColor: ()=>ye,
    isScalingUnit: ()=>nn,
    mixTwoColors: ()=>Dm,
    mixTwoRgb: ()=>Mm,
    mixTwoRgba: ()=>Af,
    numToLetterMap: ()=>De,
    opacify: ()=>lo,
    parseColorToken: ()=>dr,
    resolveFileUrl: ()=>Gt,
    returnSubThemeOrDefault: ()=>jm,
    rgbArrayToHex: ()=>Cf,
    rgbToHSL: ()=>Ef,
    rgbToHex: ()=>$m,
    setCustomFont: ()=>Wi,
    setCustomFontMedia: ()=>mr,
    setFontImport: ()=>uo,
    setInCustomFontMedia: ()=>Rf,
    setScalingVar: ()=>ta,
    setSubScalingVar: ()=>Ff,
    setVariables: ()=>Qg,
    splitTopLevelCommas: ()=>hr
});
var nn = (t)=>t === "em" || t === "rem" || t === "vw" || t === "vh" || t === "vmax" || t === "vmin", on = [
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    "deg",
    "rad",
    "grad",
    "turn",
    "s",
    "ms",
    "dpi",
    "dpcm",
    "dppx",
    "fr",
    "auto"
];
v();
var ge = (t)=>{
    if (t === "") return [
        0,
        0,
        0,
        0
    ];
    if (t.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    if (t[0] === "#") return t.length < 7 && (t = "#" + t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + (t.length > 4 ? t[4] + t[4] : "")), [
        parseInt(t.substr(1, 2), 16),
        parseInt(t.substr(3, 2), 16),
        parseInt(t.substr(5, 2), 16),
        t.length > 7 ? parseInt(t.substr(7, 2), 16) / 255 : 1
    ];
    if (t.indexOf("rgb") === -1 && z && D) {
        let e = z.body.appendChild(z.createElement("fictum")), r = "rgb(1, 2, 3)";
        if (e.style.color = r, e.style.color !== r) {
            z.body.removeChild(e);
            return;
        }
        if (e.style.color = t, e.style.color === r || e.style.color === "") return z.body.removeChild(e), [
            0,
            0,
            0,
            0
        ];
        t = D.getComputedStyle(e).color, z.body.removeChild(e);
    }
    return t.indexOf("rgb") === 0 ? (t.indexOf("rgba") === -1 && (t = `${t}, 1`), t.match(/[\.\d]+/g).map((e)=>+e)) : [
        0,
        0,
        0,
        0
    ];
}, Dm = (t, e, r = .5)=>(t = ge(t), e = ge(e), Af(t, e, r)), Fm = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgb(${r},${n},${o})`;
}, vf = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return [
        r,
        n,
        o
    ];
}, $m = (t, e, r)=>"#" + (16777216 | t << 16 | e << 8 | r).toString(16).slice(1), Cf = ([t, e, r])=>(16777216 + (t << 16) + (e << 8) + r).toString(16).slice(1), Lm = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgba(${r},${n},${o},${e})`;
}, Mm = (t, e, r = .5)=>{
    let n = [];
    for(let o = 0; o < 3; o++)n[o] = ~~(t[o] + (e[o] - t[o]) * r);
    return `rgb(${n})`;
}, Bm = (t, e)=>{
    let [r, n, o] = e, s = Math.max(0, Math.min(100, o + parseFloat(t)));
    return [
        r,
        n,
        s
    ];
}, Ef = (t, e, r)=>{
    let n = Math.max(t, e, r), o = n - Math.min(t, e, r), s = 1 - Math.abs(n + n - o - 1), i = o && (n == t ? (e - r) / o : n == e ? 2 + (r - t) / o : 4 + (t - e) / o);
    return [
        60 * (i < 0 ? i + 6 : i),
        s ? o / s : 0,
        (n + n - o) / 2
    ];
}, kf = (t, e, r, n = e * Math.min(r, 1 - r), o = (s, i = (s + t / 30) % 12)=>r - n * Math.max(Math.min(i - 3, 9 - i, 1), -1))=>[
        o(0),
        o(8),
        o(4)
    ], Of = (t, e)=>{
    let r = parseInt(t, 16), n = (r >> 16) + e;
    n > 255 ? n = 255 : n < 0 && (n = 0);
    let o = (r >> 8 & 255) + e;
    o > 255 ? o = 255 : o < 0 && (o = 0);
    let s = (r & 255) + e;
    return s > 255 ? s = 255 : s < 0 && (s = 0), ((s | o << 8 | n << 16) + 16777216).toString(16).slice(1);
}, Af = (t, e, r = .5)=>{
    let n = [];
    for(let o = 0; o < 4; o++){
        let s = o === 3 ? (i)=>i : Math.round;
        n[o] = s(t[o] + (e[o] - t[o]) * r);
    }
    return `rgba(${n})`;
}, lo = (t, e)=>{
    let r = ge(t);
    if (!r) {
        Mr() && console.warn(t + " color is not rgba");
        return;
    }
    return r[3] = e, `rgba(${r})`;
}, nt = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, te = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/, Um = /^([a-zA-Z]\w*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/, dr = (t)=>{
    if (!b(t)) return null;
    if (te.test(t)) return {
        passthrough: t
    };
    if (nt(t)) return {
        cssVar: t
    };
    let e = t.match(Um);
    if (!e) return null;
    let [, r, n, o] = e, s = n !== void 0 ? `0.${n}` : void 0, i = o && o[0] === "=" ? o.slice(1) : o;
    return {
        name: r,
        alpha: s,
        tone: i
    };
}, ye = (t)=>b(t) && (t.includes("rgb") || t.includes("var(") || t.includes("#")), hr = (t)=>{
    let e = [], r = "", n = 0;
    for (let o of t){
        if (o === "(" ? n += 1 : o === ")" && n > 0 && (n -= 1), o === "," && n === 0) {
            e.push(r), r = "";
            continue;
        }
        r += o;
    }
    return (r.length || !e.length) && e.push(r), e;
}, sn = (t, e)=>{
    b(t) && t.includes("rgb") && (t = ge(t).join(", ")), b(t) && (t = t.split(",").map((o)=>parseFloat(o.trim()))), ct(e) && (e += "");
    let r = Cf(t), n = e.slice(0, 1);
    if (n === "-" || n === "+") {
        let o = Of(r, parseFloat(e));
        return vf(o).join(", ");
    } else {
        let [o, s, i] = t, a = Ef(o, s, i), [c, f, l] = a;
        return kf(c, f, parseFloat(e) / 100 * 255);
    }
};
var jm = (t, e)=>{
    if (t) return t.themes && t.themes[e] ? t.themes[e] : t[e] ? [
        t,
        t[e]
    ] : t;
};
var Gt = (t, e)=>{
    if (!t || !e) return null;
    try {
        return new URL(t), null;
    } catch  {}
    let r = e[t];
    return r ? r.content && r.content.src : null;
}, an = (t, e)=>{
    if (t[e]) return t[e].value;
    if (t.default) return t[t.default].value;
    let r = Object.keys(t)[0];
    return r && t[r] && t[r].value;
}, Tf = (t)=>{
    let e = t.split(/[#?]/)[0].split(".").pop().trim();
    return [
        "woff2",
        "woff",
        "ttf",
        "otf",
        "eot"
    ].includes(e) ? e : null;
}, fo = (t)=>t && (t.includes("fonts.googleapis.com") || t.includes("fonts.gstatic.com")), uo = (t)=>`@import url('${t}');`, Rf = (t)=>`@font-face { ${t} }`, Wi = (t, e, r, n = {})=>{
    let s = (Array.isArray(e) ? e : [
        e
    ]).map((i)=>{
        let a = Tf(i), c = a ? ` format('${a}')` : "";
        return `url('${i}')${c}`;
    }).join(`,
       `);
    return `
  font-family: '${t}';
  font-style: ${n.fontStyle || "normal"};${r ? `
  font-weight: ${r};` : ""}${n.fontStretch ? `
  font-stretch: ${n.fontStretch};` : ""}${n.fontDisplay ? `
  font-display: ${n.fontDisplay};` : ""}
  src: ${s};`;
}, mr = (t, e, r, n)=>`@font-face {${Wi(t, e, r, n)}
}`, cn = (t, e, r)=>Object.keys(e).map((o)=>{
        let { url: s, fontWeight: i, fontStyle: a, fontDisplay: c, fontStretch: f } = e[o], l = Array.isArray(s) ? s.map((u)=>Gt(u, r) || u) : Gt(s, r) || s;
        return Wi(t, l, i, {
            fontStyle: a,
            fontDisplay: c,
            fontStretch: f
        });
    }), Vm = (t)=>Object.keys(t).map((r)=>cn(r, t[r].value)), If = (t, e, r)=>{
    if (e && e.isVariable) {
        let s = Gt(e.url, r) || e.url;
        return fo(s) ? uo(s) : mr(t, s, e.fontWeight, {
            fontStretch: e.fontStretch,
            fontDisplay: e.fontDisplay || "swap"
        });
    }
    if (e[0]) return cn(t, e, r).map(Rf);
    let o = Array.isArray(e.url) ? e.url.map((s)=>Gt(s, r) || s) : Gt(e.url, r) || e.url;
    return mr(t, o, e.fontWeight, {
        fontStyle: e.fontStyle,
        fontDisplay: e.fontDisplay,
        fontStretch: e.fontStretch
    });
}, Gi = (t, e)=>Object.keys(t).map((n)=>If(n, t[n].value, e));
v();
v();
async function qm(t) {
    if (document.fullscreenElement) await document.exitFullscreen();
    else try {
        await (this.node || document).requestFullscreen();
    } catch (e) {
        console.warn(`Error attempting to enable fullscreen mode: ${e.message} (${e.name})`);
    }
}
v();
var Pf = (t, e)=>(_(e) ? e : Object.values(e)).reduce((r, n)=>Math.abs(n - t) < Math.abs(r - t) ? n : r), zm = (t, e)=>(t = parseFloat(t), g(e) && (e = Object.values(e)), Pf(t, e));
var Hm = (t)=>{
    if (!t) return "";
    let e = new Date(t), r = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(e), n = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(e);
    return `${new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(e)} ${n}, ${r}`;
};
var Wm = function(e) {
    let r = [
        0,
        1
    ];
    for(let n = 2; n <= e; n++)r[n] = r[n - 1] + r[n - 2];
    return r[e];
};
var Gm = (t, e = !1, r = document, n = "text/javascript")=>new Promise((o, s)=>{
        try {
            let i = r.createElement("script");
            i.type = n, i.async = e, i.src = t, i.addEventListener("load", (a)=>{
                o({
                    status: !0
                });
            }), i.addEventListener("error", (a)=>{
                s(new Error({
                    status: !1,
                    message: `Failed to load the script ${t}`
                }));
            }), r.body.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), Km = (t, e = document, r = "text/javascript")=>new Promise((n, o)=>{
        let s = e.createElement("script");
        s.type = r, s.src = t;
        let i = e.createElement("div");
        i.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;", e.body.appendChild(i), s.onload = ()=>{
            console.log(`Successfully loaded: ${t}`), e.body.removeChild(i), n();
        }, s.onerror = ()=>{
            e.body.removeChild(i), o(new Error(`Failed to load: ${t}`));
        }, e.body.appendChild(s);
    }), Ym = (t, e = document, r, n = "text/javascript")=>{
    let o = new window.XMLHttpRequest;
    if (o.open("GET", t, !1), o.send(), o.status === 200) {
        let s = e.createElement("script");
        s.type = n, s.text = o.responseText, e.body.appendChild(s), typeof r == "function" && r();
    } else throw new Error(`Failed to load the script ${t}`);
}, Qm = (t, e = !1, r = document, n = "text/javascript")=>new Promise((o, s)=>{
        try {
            let i = r.createElement("link");
            i.rel = "stylesheet", i.href = t, i.addEventListener("load", (a)=>{
                o({
                    status: !0
                });
            }), r.head.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), Xm = (t, e = !1, r = document, n = "text/javascript", o = "smbls-script")=>{
    try {
        let s = r.createElement("script");
        s.type = n, s.async = e, s.id = o, s.innerHTML = t, r.body.appendChild(s);
    } catch (s) {
        console.warn(s);
    }
};
function po(t, e = {}) {
    let { window: r = globalThis } = e, { document: n = r.document } = e;
    return new Promise((o, s)=>{
        let i = n.querySelector(`script[src="${t}"]`);
        if (i) return o(i);
        let a = n.createElement("script");
        a.src = t, a.async = e.async === !0, a.type = e.type || "text/javascript", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, o(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load script: ${t}`));
        }, n.head.appendChild(a);
    });
}
async function Jm(t, e = {}) {
    let { window: r = globalThis } = e, { document: n = r.document } = e;
    return new Promise((o, s)=>{
        let i = n.querySelector(`link[href="${t}"]`);
        if (i) return o(i);
        let a = n.createElement("link");
        a.href = t, a.rel = e.rel || "stylesheet", a.type = "text/css", a.media = e.media || "all", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, o(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load stylesheet: ${t}`));
        }, n.head.appendChild(a);
    });
}
var Zm = (t)=>[
        "jpeg",
        "gif",
        "jpg",
        "png",
        "tiff",
        "woff"
    ].includes(t);
function tg(t) {
    return /^[0-9.]+$/.test(t) && t !== "";
}
var ee = {
    skypack: {
        url: "https://cdn.skypack.dev",
        formatUrl: (t, e)=>`${ee.skypack.url}/${t}${e !== "latest" ? `@${e}` : ""}`
    },
    esmsh: {
        url: "https://esm.sh",
        formatUrl: (t, e)=>`${ee.esmsh.url}/${t}${e !== "latest" ? `@${e}` : ""}`
    },
    unpkg: {
        url: "https://unpkg.com",
        formatUrl: (t, e)=>`${ee.unpkg.url}/${t}${e !== "latest" ? `@${e}` : ""}?module`
    },
    jsdelivr: {
        url: "https://cdn.jsdelivr.net/npm",
        formatUrl: (t, e)=>`${ee.jsdelivr.url}/${t}${e !== "latest" ? `@${e}` : ""}/+esm`
    },
    symbols: {
        url: "https://pkg.symbo.ls",
        formatUrl: (t, e)=>t.split("/").length > 2 || !tg(e) ? `${ee.symbols.url}/${t}` : `${ee.symbols.url}/${t}/${e}.js`
    }
}, gr = {
    "esm.sh": "esmsh",
    unpkg: "unpkg",
    skypack: "skypack",
    jsdelivr: "jsdelivr",
    "pkg.symbo.ls": "symbols"
}, ho = (t = {})=>{
    let { packageManager: e } = t;
    return gr[e] || null;
}, re = (t, e = "latest", r = "esmsh")=>(ee[r] || ee.esmsh).formatUrl(t, e), eg = (t, e = "skypack")=>{
    let r = t.dependencies || {}, n = Object.keys(r);
    if (!n.length) return "";
    let o = {};
    for (let s of n){
        let i = r[s] || "latest";
        o[s] = re(s, i, e);
    }
    return `<script type="importmap">{
    "imports": ${JSON.stringify(o, null, 2)}
  }<\/script>`;
};
v();
var Dt = (t)=>{
    if (t == null) return "";
    let e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return t.toString().replace(/[&<>"']/g, (r)=>e[r]);
}, rg = (t)=>Object.entries(t || {}).filter(([e, r])=>r !== void 0).map(([e, r])=>`${e}="${Dt(r)}"`).join(" "), ng = (t, e)=>(e || (t = {
        ...t,
        robots: "noindex"
    }), Object.entries(t).reduce((n, [o, s])=>{
        if (!s && s !== 0 && s !== !1) return n;
        if (o === "title") return n.push(`<title>${Dt(s)}</title>`), n;
        if (o === "canonical") return n.push(`<link rel="canonical" href="${Dt(s)}">`), n;
        if (o === "manifest") return n.push(`<link rel="manifest" href="${Dt(s)}">`), n;
        if (o === "favicon" || o === "favicons" || o === "icon" || o === "icons") return (Array.isArray(s) ? s : [
            s
        ]).forEach((l)=>{
            if (typeof l == "string") n.push(`<link rel="icon" href="${Dt(l)}">`);
            else if (typeof l == "object") {
                let u = rg(l);
                /rel=/.test(u) ? n.push(`<link ${u}>`) : n.push(`<link rel="icon" ${u}>`);
            }
        }), n;
        if (o === "alternate") return (Array.isArray(s) ? s : [
            s
        ]).forEach((l)=>{
            if (typeof l == "object") {
                let u = Object.entries(l).filter(([p, h])=>h !== void 0).map(([p, h])=>`${p}="${Dt(h)}"`).join(" ");
                n.push(`<link rel="alternate" ${u}>`);
            }
        }), n;
        let i = (f, l, u = "name")=>{
            if (typeof l == "string" || typeof l == "number" || typeof l == "boolean") n.push(`<meta ${u}="${Dt(f)}" content="${Dt(l)}">`);
            else if (Array.isArray(l)) l.forEach((p)=>{
                if (typeof p == "string" || typeof p == "number" || typeof p == "boolean") n.push(`<meta ${u}="${Dt(f)}" content="${Dt(p)}">`);
                else if (typeof p == "object") {
                    let h = Object.entries(p).filter(([d, m])=>m !== void 0).map(([d, m])=>`${d}="${Dt(m)}"`).join(" ");
                    n.push(`<meta ${h}>`);
                }
            });
            else if (typeof l == "object") {
                let p = Object.entries(l).filter(([h, d])=>d !== void 0).map(([h, d])=>`${h}="${Dt(d)}"`).join(" ");
                n.push(`<meta ${p}>`);
            }
        };
        if (o.startsWith("http-equiv:")) {
            let f = o.replace("http-equiv:", "");
            return i(f, s, "http-equiv"), n;
        }
        if (o.startsWith("itemprop:")) {
            let f = o.replace("itemprop:", "");
            return i(f, s, "itemprop"), n;
        }
        let c = [
            "og:",
            "twitter:",
            "fb:",
            "article:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "product:",
            "video:",
            "DC:",
            "DCTERMS:"
        ].find((f)=>o.startsWith(f));
        if (c) {
            let f = o.replace(c, "");
            return i(`${c.replace(":", "")}:${f}`, s, c === "twitter:" || c === "DC:" || c === "DCTERMS:" ? "name" : "property"), n;
        }
        if (o.startsWith("apple:") || o.startsWith("msapplication:")) {
            let f = o.startsWith("apple:") ? "apple-" : "msapplication-", l = o.replace(/^apple:|^msapplication:/, "");
            return i(`${f}${l}`, s, "name"), n;
        }
        return i(o, s), n;
    }, [
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">'
    ]).join(`
`)), og = (t)=>typeof t == "string" && t.length > 0 && !t.startsWith("/") && !t.startsWith("http");
function sg(t, e) {
    if (!e || typeof e != "object") return t;
    let r = (o)=>{
        if (!og(o)) return o;
        let s = e[o];
        return s?.src ? s.src : o;
    }, n = {
        ...t
    };
    for (let [o, s] of Object.entries(n))typeof s == "string" ? n[o] = r(s) : Array.isArray(s) && (n[o] = s.map((i)=>typeof i == "string" ? r(i) : i));
    return n;
}
function mo(t, e) {
    if (!t || !e) return;
    let r = e.split("."), n = t;
    for (let o of r){
        if (n == null || typeof n != "object") return;
        n = n[o];
    }
    return n;
}
function ig(t, e, r) {
    let o = (e.config || e.settings || {}).polyglot || e.polyglot, s = r?.lang || o?.defaultLang || "en", a = (o?.translations || {})[s] || {}, c = r?.state || {}, f = {
        ...t
    };
    for (let [l, u] of Object.entries(f))typeof u != "string" || !u.includes("{{") || (f[l] = u.replace(/\{\{\s*([^|{}]+?)\s*(?:\|\s*(\w+)\s*)?\}\}/g, (p, h, d)=>{
        let m = h.trim();
        if (d === "polyglot") return a[m] ?? mo(a, m) ?? p;
        if (d === "getLocalStateLang") return mo(c, m + s) ?? p;
        let S = mo(c, m);
        return S !== void 0 ? S : a[m] ?? mo(a, m) ?? p;
    }));
    return f;
}
function Nf(t) {
    let e = {
        ...t
    };
    for (let [r, n] of Object.entries(e))if (typeof n == "function") {
        let o = n.toString(), s = o.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[r] = `{{ ${s[1]} | getLocalStateLang }}`;
            continue;
        }
        let i = o.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (i) {
            e[r] = `{{ ${i[1]} | polyglot }}`;
            continue;
        }
        let a = o.match(/s\.(\w+(?:\.\w+)+)/);
        if (a) {
            e[r] = `{{ ${a[1]} }}`;
            continue;
        }
        delete e[r];
    } else if (typeof n == "string") {
        let o = n.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (o) {
            e[r] = `{{ ${o[1]} | getLocalStateLang }}`;
            continue;
        }
        let s = n.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[r] = `{{ ${s[1]} | polyglot }}`;
            continue;
        }
        if (n.includes("=>") && n.includes("s.")) {
            let i = n.match(/s\.(\w+(?:\.\w+)+)/);
            if (i) {
                e[r] = `{{ ${i[1]} }}`;
                continue;
            }
        }
    }
    return e;
}
function ag(t, e, r) {
    let n = t.pages?.[e], o = g(n?.state) && n?.state, s = n?.metadata || n?.helmet || o || {}, i = Nf(s), a = new Set(Object.keys(i)), c = t.app?.metadata || {}, f = Nf(c), l = {};
    t.integrations?.seo ? l = {
        ...t.integrations.seo,
        ...f,
        ...i
    } : Object.keys(f).length ? l = {
        ...f,
        ...i
    } : l = {
        ...i
    }, l.title || (l.title = t.name + " / symbo.ls"), l = ig(l, t, r), l.title && (a.has("title") || !l["og:title"]) && (a.has("og:title") || (l["og:title"] = l.title)), l.description && (a.has("description") || !l["og:description"]) && (a.has("og:description") || (l["og:description"] = l.description)), l.title && !l["twitter:title"] && (l["twitter:title"] = l.title), l.description && !l["twitter:description"] && (l["twitter:description"] = l.description);
    let u = r?.actualPathname || e;
    if (l["og:url"] || l.url) {
        let h = (l["og:url"] || l.url || "").replace(/\/$/, "");
        if (h && u && u !== "/") {
            let d = u.startsWith("/") ? u : "/" + u;
            l["og:url"] = h + d;
        }
    }
    l = sg(l, t.files);
    let p = t.name || t.app?.metadata?.title || t.app?.name || "";
    for (let [h, d] of Object.entries(l))if (typeof d == "string" && d.includes("{{")) {
        let m = d.replace(/\{\{[^}]*\}\}/g, "").trim();
        m ? l[h] = m : h === "title" ? l[h] = p : delete l[h];
    }
    return l;
}
var cg = async (t)=>{
    try {
        await navigator.clipboard.writeText(t);
    } catch (e) {
        console.warn("Failed to copy text: ", e);
    }
}, lg = async (t)=>{
    try {
        let e = new Blob([
            t
        ], {
            type: "text/javascript"
        }), r = new window.ClipboardItem({
            "text/plain": e
        });
        await navigator.clipboard.write([
            r
        ]), console.log("JavaScript code copied to clipboard as text/javascript");
    } catch (e) {
        console.error("Failed to copy JavaScript code: ", e);
    }
}, fg = (t)=>t.replace(/[^a-zA-Z0-9_]/g, ""), Ki = (t)=>(typeof t != "string" && (t = String(t || "")), t.replace(/(?:^\w|[A-Z]|\b\w)/g, function(e, r) {
        return r === 0 ? e.toLowerCase() : e.toUpperCase();
    }).replace(/\s+/g, "")), ug = (t)=>t && t.replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.substr(1).toLowerCase()), Yi = (t)=>t.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, ""), pg = (t = "")=>{
    if (typeof t != "string") return;
    let e = t.replace(/([A-Z])/g, " $1");
    return e.charAt(0).toUpperCase() + e.slice(1);
}, ln = (t)=>{
    if (_(t)) return t;
    if (b(t)) return t.split(" ");
    if (g(t)) return Object.values(t);
    if (ct(t)) return [
        t
    ];
};
v();
var Xi = {};
Bt(Xi, {
    CLASS: ()=>Ug,
    animation: ()=>Ng,
    breakpoints: ()=>Ig,
    color: ()=>wg,
    devices: ()=>Pg,
    document: ()=>Rg,
    font: ()=>mg,
    font_face: ()=>bg,
    font_family: ()=>gg,
    font_family_types: ()=>yg,
    gradient: ()=>vg,
    grid: ()=>Mg,
    icons: ()=>kg,
    media: ()=>Sg,
    reset: ()=>jg,
    semantic_icons: ()=>Og,
    sequence: ()=>Pe,
    shadow: ()=>Eg,
    spacing: ()=>_g,
    svg: ()=>Dg,
    svg_data: ()=>Fg,
    templates: ()=>$g,
    theme: ()=>Cg,
    timing: ()=>Tg,
    typography: ()=>Qi,
    unit: ()=>dg,
    vars: ()=>Vg
});
var Pe = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};
var dg = {
    default: "em"
};
var hg = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: Pe["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
}, Qi = hg;
var mg = {};
var gg = {}, yg = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
}, bg = {};
var Sg = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var xg = {
    base: Qi.base,
    type: "spacing",
    ratio: Pe.phi,
    range: [
        -5,
        15
    ],
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
}, _g = xg;
var wg = {}, vg = {};
var Cg = {};
var Eg = {};
var kg = {}, Og = {};
var Ag = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: Pe["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: !1,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
}, Tg = Ag;
var Rg = {};
var Ig = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
}, Pg = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};
var Ng = {};
var Dg = {}, Fg = {};
var $g = {};
var Lg = {}, Mg = Lg;
var Bg = {}, Ug = Bg;
var jg = {}, Vg = {};
var qg = {}, zg = {}, fn = Xi, un = {}, Hg = (t)=>t.replace(/_([a-z])/g, (e, r)=>r.toUpperCase()), Wg = (t)=>t.replace(/([A-Z])/g, "_$1").toUpperCase();
for(let t in fn){
    let e = t.toLowerCase();
    un[e] = fn[t];
    let r = Hg(e);
    r !== e && (un[r] = fn[t]), e !== t && (un[t] = fn[t]);
    let n = Wg(t);
    n !== t && (un[n] = fn[t]);
}
var Ji = {
    verbose: !1,
    useVariable: !0,
    useReset: !0,
    globalTheme: "auto",
    CSS_VARS: qg,
    CSS_MEDIA_VARS: zg,
    ...un
}, Gg = j(Ji), Ne = {
    active: "0",
    0: Ji
}, lC = (t)=>(bt(t) && (Ne.active = t), Ne[t || Ne.active]), E = (t)=>Ne[t || Ne.active] || Ji, Df = (t)=>{
    if (g(t)) return Ne.active = "1", Ne[1] = H(t, j(Gg)), t;
};
var De = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
}, Zi = (t, e)=>{
    let { key: r, variable: n, value: o, scaling: s, index: i, scalingVariable: a } = t;
    e.sequence[r] = {
        key: r,
        decimal: ~~(o * 100) / 100,
        val: ~~o,
        scaling: s,
        index: i,
        scalingVariable: a,
        variable: n
    }, e.scales[r] = s, e.vars[n] = s + e.unit;
}, Fe = (t)=>{
    if (!t.includes("(")) return t;
    let e = t.split("(")[0], r = t.slice(t.indexOf("(") + 1, t.lastIndexOf(")"));
    return [
        e,
        r
    ];
}, ta = (t, e)=>{
    let { base: r, type: n, unit: o } = e, s = (nn(o) ? 1 : r) + o;
    if (t === 0) return s;
    let i = "--" + (n && n.replace(".", "-")), a = `${i}-ratio`;
    if (t > 0) {
        let c = De[t - 1];
        return `calc(var(${i}-${c}) * var(${a}))`;
    }
    if (t < 0) {
        let c = De[t + 1];
        return `calc(var(${i}-${c}) / var(${a}))`;
    }
}, Ff = (t, e, r, n)=>{
    let { type: o } = n, i = t === 2 && e.length === 2 ? t + 1 : t, c = `${"--" + (o && o.replace(".", "-"))}-sub-ratio-`;
    return `calc(var(${r}) * var(${c + i}))`;
}, ea = (t, e)=>{
    let n = (t * e - t) / 1.618, o = t * e - n, s = t + n, i = (o + s) / 2;
    return [
        o,
        i,
        s
    ];
}, ra = (t, e)=>ea(t, e).map((r)=>r / t), na = (t, e)=>{
    let { key: r, base: n, value: o, ratio: s, variable: i, index: a } = t, f = ~~(o * s) - ~~o, l, [u, p, h] = ea(o, s);
    f > 16 ? l = [
        u,
        p,
        h
    ] : l = [
        u,
        h
    ], l.forEach((d, m)=>{
        let S = ~~(d / n * 1e3) / 1e3, x = i + (m + 1), w = a + (m + 1) / 10, C = Ff(m + 1, l, i, e), R = {
            key: r + (m + 1),
            variable: x,
            value: d,
            scaling: S,
            scalingVariable: C,
            index: w
        };
        Zi(R, e);
    });
}, Kg = (t, e, r)=>e * Math.pow(r, t), Kt = (t)=>{
    let { type: e, base: r, ratio: n, range: o, subSequence: s } = t, i = Math.abs(o[0]) + Math.abs(o[1]), a = "--" + (e && e.replace(".", "-")) + "-";
    for(let c = 0; c <= i; c++){
        let f = o[1] - c, l = De[f], u = Kg(f, r, n), p = ~~(u / r * 100) / 100, h = a + l, d = ta(f, t), m = {
            key: l,
            variable: h,
            value: u,
            base: r,
            scaling: p,
            scalingVariable: d,
            ratio: n,
            index: f
        };
        Zi(m, t), s && na(m, t);
    }
    return t;
}, Yg = (t, e = 0)=>{
    let { type: r, base: n, ratio: o, subSequence: s } = t, i = b(e) ? e : De[e], a = b(e) ? Object.entries(De).find(([, m])=>m === e)?.[0] : e;
    if (!i) return console.warn(`Position ${e} is out of range in numToLetterMap`), null;
    let c = {
        sequence: {},
        scales: {},
        vars: {},
        ...t
    }, f = n * Math.pow(o, a), l = ~~(f / n * 100) / 100, p = "--" + (r && r.replace(".", "-")) + "-" + i, h = ta(a, t), d = {
        key: i,
        variable: p,
        value: f,
        base: n,
        scaling: l,
        scalingVariable: h,
        ratio: o,
        index: a
    };
    return Zi(d, c), s && na(d, c), c;
}, oa = (t = "A", e)=>{
    let r = E(), { unit: n } = r;
    if (b(t) && nt(t)) return `var(${t})`;
    let { sequence: o, unit: s = n.default, useVariable: i } = e, a = /^-?[a-zA-Z]/i, c = a.test(t);
    if (on.some((w)=>t.includes(w)) || !c || [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ].includes(t)) return t;
    let u = `--${Yi(e.type.replace(".", "-"))}-`, p = t.toUpperCase(), h = p.slice(0, 1) === "-" ? "-" : "", d = h ? p.slice(1) : p, m = "";
    d.includes("_") && (m = "_" + d.split("_")[1].toLowerCase(), d = d.split("_")[0]);
    let S = (w)=>a.test(w) ? `var(${u}${w}${m})` : w;
    if (d.includes("+")) {
        let [w, C] = d.split("+"), R = `${S(w)} + ${S(C)}`;
        return h ? `calc((${R}) * -1)` : `calc(${R})`;
    } else if (d.includes("*")) {
        let [w, C] = d.split("*"), R = `${S(w)} * ${S(C)}`;
        return h ? `calc((${R}) * -1)` : `calc(${R})`;
    } else if (d.includes("-")) {
        let [w, C] = d.split("-"), R = `${S(w)} - ${S(C)}`;
        return h ? `calc((${R}) * -1)` : `calc(${R})`;
    }
    if (!o[d] && d.length === 2 && (r.verbose && console.warn(d, "- value is not found because `subSequence` is set to false"), d = d.slice(0, 1)), i || r.useVariable) {
        let w = `var(${u}${d}${m})`;
        return h ? `calc(${w} * -1)` : w;
    }
    let x = o ? o[d] : null;
    return x ? s === "ms" || s === "s" ? h + x.val + s : h + x.scaling + s : console.warn("can't find", o, d);
}, $f = (t, e)=>{
    let r = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((n)=>t.includes(n + " "));
    return r.length ? r.map((n)=>t.split(n + " ").map((i)=>i.trim()).map((i)=>oa(i, e)).join(" " + n + " ")).join("") : t;
}, be = (t, e, r, n)=>{
    if (typeof t != "string") return E().verbose && console.warn(e, t, "is not a string"), {
        [e]: t
    };
    if (t === "-" || t === "") return {};
    if (!n && t.includes("(")) {
        let s = Fe(t);
        n = s[0], t = s[1];
    }
    return [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((s)=>t.includes(s + " ")).length ? t = $f(t, r) : t = oa(t, r), {
        [e]: n ? `${n}(${t})` : t
    };
}, Lf = (t, e)=>De[t - e], sa = (t)=>{
    let { h1Matches: e, sequence: r } = t;
    return new Array(6).fill(null).map((n, o)=>{
        let s = Lf(e, o);
        return r[s];
    });
};
v();
var Qg = (t, e)=>{
    let r = E(), { CSS_VARS: n } = r;
    N(t.value) || (n[t.var] = t.value);
}, ia = (t, e, r)=>{
    let n = E(), { unit: o } = n, s = e.unit || o.default, { base: i, ratio: a, type: c } = e, f = "--" + (c && c.replace(".", "-"));
    t[`${f}-base`] = i, t[`${f}-unit`] = s;
    let l = `${f}-ratio`;
    t[l] = a;
    let [u, p, h] = ra(i, a);
    t[`${f}-sub-ratio-1`] = `calc(var(${f}-ratio) * ${u / a})`, t[`${f}-sub-ratio-2`] = `calc(var(${f}-ratio) * ${p / a})`, t[`${f}-sub-ratio-3`] = `calc(var(${f}-ratio) * ${h / a})`;
}, $e = (t, e = {})=>{
    let r = E(), { unit: n, timing: o, CSS_VARS: s } = r, i = t.unit || n.default, { mediaRegenerate: a, sequence: c, scales: f } = t;
    a || ia(s, t, e);
    for(let l in c){
        let u = c[l], p = (t.type === o.type ? c[l].val : f[l]) + i;
        if (!a) {
            s[u.variable + "_default"] = p, s[u.variable] = u.scalingVariable;
            continue;
        }
        e.useDefault === !1 ? s[u.variable] = p : (s[u.variable + "_default"] = p, s[u.variable] = `var(${u.variable + "_default"})`);
    }
}, yr = (t, e, r = {})=>{
    let n = E(), { unit: o, media: s, CSS_VARS: i } = n, a = e.slice(1), c = t.unit || o.default, { mediaRegenerate: f } = t, { sequence: l, scales: u } = t[e], p = s[a];
    if (!p && n.verbose && console.warn("Can't find media query ", p), !f) {
        let h = i[`@media ${p}`];
        h || (h = i[`@media ${p}`] = {}), ia(h, t[e], r);
        return;
    }
    for(let h in l){
        let d = l[h], m = (nn(c) ? u[h] : l[h].val) + c;
        !p && n.verbose && console.warn("Can't find query ", p);
        let S = i[`@media ${p}`];
        S || (S = i[`@media ${p}`] = {}), S[d.variable] = `var(${d.variable + "_" + a})`, i[d.variable + "_" + a] = m;
    }
};
v();
var Xg = Mr(), go = (t)=>{
    let e = E(), r = "";
    for(let n in t)e.__svg_cache[n] || (e.__svg_cache[n] = !0, r += t[n]);
    return r;
}, Jg = (t)=>{
    let e = t.default || t;
    if (!b(e)) {
        Xg && console.warn("parseRootAttributes:", e, "is not a string");
        return;
    }
    let r = e.match(/<svg\s+(.*?)>/);
    return !r || !r[1] ? {} : r[1].match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm).reduce((s, i)=>{
        let [a, c] = i.split("=");
        return s[a] = c.replace(/['"]/g, ""), s;
    }, {});
}, Zg = (t, e)=>{
    let r = /id="([^"]*)"/, n = /url\(#([^)]*)\)/g, o = t.match(/id="([^"]*)"/g), s = t;
    return _(o) && o.forEach(()=>{
        let i = Math.floor(Math.random() * 1e5);
        s = t.replace(r, `id="${e}-${i}"`).replace(n, `url(#${e}-${i})`);
    }), s;
}, aa = (t, e)=>{
    let r = Jg(e), { width: n, height: o } = r, s = r.viewBox || `0 0 ${n || 24} ${o || 24}`, c = Zg(e, t).replace("<svg", `<symbol id="${t}" xmlns="http://www.w3.org/2000/svg" viewBox="${s}"`);
    return c = c.replace(/width="[^"]*"/, ""), c = c.replace(/height="[^"]*"/, ""), c = c.replace("</svg", "</symbol"), c;
};
var xo = {};
Bt(xo, {
    appendSVGSprite: ()=>Ca,
    appendSvgIconsSprite: ()=>ka,
    applyDocument: ()=>wa,
    applyHeadings: ()=>jf,
    applyReset: ()=>Oa,
    applySpacingSequence: ()=>ba,
    applyTimingSequence: ()=>_a,
    applyTypographySequence: ()=>ma,
    checkIfBoxSize: ()=>ya,
    getColor: ()=>X,
    getFontFamily: ()=>ha,
    getFontSizeByKey: ()=>ga,
    getMediaColor: ()=>Et,
    getMediaTheme: ()=>Yt,
    getShadow: ()=>xa,
    getSpacingBasedOnRatio: ()=>Le,
    getSpacingByKey: ()=>at,
    getTheme: ()=>fa,
    getTimingByKey: ()=>Ut,
    getTimingFunction: ()=>Ft,
    runThroughMedia: ()=>Uf,
    setColor: ()=>Sr,
    setFont: ()=>da,
    setFontFamily: ()=>bo,
    setGradient: ()=>xr,
    setMediaTheme: ()=>pa,
    setSVG: ()=>So,
    setShadow: ()=>_r,
    setSvgIcon: ()=>Ea,
    setTheme: ()=>ua,
    splitSpacedValue: ()=>Sa
});
v();
var X = (t, e, r)=>{
    let n = r || E();
    if (!b(t)) {
        n.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    e && t[e] && (t = t[e]);
    let o, s, i;
    if (_(t)) [o, s, i] = t;
    else {
        let u = dr(t);
        if (!u) {
            let { color: p, gradient: h } = n, d = h[t] || p[t];
            return d ? n.useVariable ? `var(${d.var})` : d.value : t;
        }
        if (u.passthrough) return u.passthrough;
        if (u.cssVar) return `var(${u.cssVar})`;
        o = u.name, s = u.alpha, i = u.tone;
    }
    let { color: a, gradient: c } = n, f = a[o] || c[o];
    if (!f) return n.verbose && console.warn("Can't find color ", o), t;
    e && (f[e] ? f = f[e] : n.verbose && console.warn(t, " - does not have ", e));
    let l = f.rgb;
    return l ? (i && !f[i] && (l = sn(l, i), f[i] = {
        rgb: l,
        var: `${f.var}-${i}`
    }), f[i] && (l = f[i].rgb), s ? `rgba(${l}, ${s})` : i ? `rgba(${l}, 1)` : n.useVariable ? `var(${f.var})` : `rgb(${l})`) : n.useVariable ? `var(${f.var})` : f.value;
}, Et = (t, e, r)=>{
    let n = r || E();
    if (e || (e = n.globalTheme === "auto" ? null : n.globalTheme), !b(t)) {
        n.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    let o;
    if (_(t)) o = t[0];
    else {
        let f = dr(t);
        if (!f) return t;
        if (f.passthrough) return f.passthrough;
        if (f.cssVar) return `var(${f.cssVar})`;
        o = f.name;
    }
    let { color: s, gradient: i } = n, a = s[o] || i[o], c = g(a);
    if (c && a.value) return X(t, `@${e}`, r);
    if (c) {
        if (e) return X(t, `@${e}`, r);
        {
            let f = {};
            for(let l in a){
                let u = n.media[l.slice(1)], p = "@media " + (u === "print" ? `${u}` : `screen and ${u}`);
                f[p] = X(t, l, r);
            }
            return f;
        }
    } else return n.verbose && console.warn("Can't find color", t), t;
}, Sr = (t, e, r)=>{
    let n = E();
    if (b(t) && nt(t)) {
        let h = t.slice(2);
        if (t = X(h), !(t.includes("rgb") || t.includes("var") || t.includes("#"))) {
            let d = h.split(" "), m = n.color[d[0]];
            if (m && m.value) {
                let S = m.rgb, x = d[1] !== void 0 ? d[1] : "1", w = d[2];
                w && (S = sn(S, w)), t = `rgba(${S}, ${x})`;
            } else {
                let S = d[2], x = d[1] !== void 0 ? d[1] : "1";
                if (S) try {
                    let w = ge(d[0]);
                    w && w.length >= 3 ? t = `rgba(${sn(w.slice(0, 3).join(", "), S)}, ${x})` : t = d[0];
                } catch  {
                    t = d[0];
                }
                else t = d[0];
            }
        }
    }
    if (_(t)) return {
        "@light": Sr(t[0], e, "light"),
        "@dark": Sr(t[1], e, "dark")
    };
    if (g(t)) {
        let h = {};
        for(let d in t)h[d] = Sr(t[d], e, d.slice(0, 1) === "@" ? d.slice(1) : d);
        return h;
    }
    let o = `--color-${e}` + (r ? `-${r}` : ""), s = ge(t.value || t), [i, a, c, f = 1] = s, l = parseFloat(f.toFixed(2)), u = `${i}, ${a}, ${c}`, p = `rgba(${u}, ${l})`;
    return n.useVariable && (n.CSS_VARS[o] = p), {
        var: o,
        rgb: u,
        alpha: l,
        value: p
    };
}, xr = (t, e, r)=>{
    let n = E();
    if (b(t) && nt(t) && (t = X(t.slice(2))), _(t)) return {
        "@light": xr(t[0], e, "light"),
        "@dark": xr(t[0], e, "dark")
    };
    if (g(t)) {
        let s = {};
        for(let i in t)s[i] = xr(t[i], e, i.slice(0, 1) === "@" ? i.slice(1) : i);
        return s;
    }
    let o = `--gradient-${e}` + (r ? `-${r}` : "");
    return n.useVariable && (n.CSS_VARS[o] = t.value || t), {
        var: o,
        value: t.value || t
    };
};
v();
var ty = new Set([
    "black",
    "white",
    "red",
    "green",
    "blue",
    "yellow",
    "orange",
    "purple",
    "pink",
    "brown",
    "gray",
    "grey",
    "cyan",
    "magenta",
    "lime",
    "olive",
    "navy",
    "teal",
    "aqua",
    "maroon",
    "silver",
    "fuchsia",
    "transparent",
    "currentColor",
    "currentcolor",
    "inherit",
    "initial",
    "unset",
    "none",
    "aliceblue",
    "antiquewhite",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "blanchedalmond",
    "blueviolet",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "limegreen",
    "linen",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "oldlace",
    "olivedrab",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "plum",
    "powderblue",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "whitesmoke",
    "yellowgreen",
    "rebeccapurple"
]), yo = (t)=>{
    let e = {}, { state: r, media: n, helpers: o, ...s } = t;
    return Object.keys(s).map((a)=>{
        let f = [
            "color",
            "Color",
            "background",
            "border"
        ].some((l)=>a.includes(l));
        return e[a] = f ? X(t[a]) : t[a];
    }), e;
}, pn = (t)=>(t.value || (t.value = yo(t)), t.value), fa = (t, e)=>{
    let r = E();
    if (r.useVariable) return Yt(t, e);
    let n = r.theme;
    if (b(t)) {
        let [o, s] = t.split(" "), i = n[o];
        if (i) {
            if (!s && !e) return pn(i);
            t = [
                o,
                s || e
            ];
        }
    }
    if (N(t) && t[1]) {
        let o = t[0], s = t[1], { helpers: i, media: a, state: c } = n[o];
        if (a && a[s]) return pn(a[s]);
        if (i && i[s]) return pn(i[s]);
        if (c && c[s]) return pn(c[s]);
    } else if (g(t)) return yo(t);
}, ey = (t, e, r)=>{
    if (g(e)) t.variants.inverse.value = yo(e);
    else if (e === !0) {
        let { color: n, background: o } = r;
        t.variants.inverse = {
            value: {
                color: o,
                background: n
            }
        };
    }
}, ry = (t, e, r, n)=>{
    let o = fa(r);
    n[`&:${e}`] = o, g(r) && !r.value && (r.value = o);
}, ny = (t, e)=>{
    let { state: r } = t;
    return r ? (Object.keys(r).map((o)=>{
        let s = r[o];
        return ry(t, o, s, e), t;
    }), t) : void 0;
}, oy = (t, e, r, n)=>{
    let o = fa(r);
    n[`@media (prefers-color-scheme: ${e})`] = o, g(r) && !r.value && (r.value = o);
}, sy = (t, e)=>{
    let { media: r } = t;
    return r ? (Object.keys(r).map((o)=>{
        let s = r[o];
        return (o === "dark" || o === "light") && oy(t, o, s, e), o === "inverse" && ey(t, s, e), t;
    }), t) : void 0;
}, iy = (t, e)=>{
    let r = E(), { helpers: n } = t;
    return n ? (Object.keys(n).map((s)=>{
        let i = n[s];
        return b(i) ? n[s] = r.theme[i] : pn(n[s]), t;
    }), t) : void 0;
}, ua = (t, e)=>{
    if (E().useVariable) return pa(t, e);
    let { state: n, media: o, helpers: s } = t, i = yo(t, e), a = `--theme-${e}`;
    return ny(t, i), sy(t, i), iy(t, i), {
        var: a,
        value: i,
        state: n,
        media: o,
        helpers: s
    };
};
var ca = (t, e, r)=>{
    let { CSS_VARS: n } = r;
    r.CSS_MEDIA_VARS || (r.CSS_MEDIA_VARS = {});
    let o = r.CSS_MEDIA_VARS, s = r.globalTheme !== void 0 ? r.globalTheme : "auto", i = {}, a = new Set;
    for(let f in t)if (t[f]) for (let l of Object.keys(t[f]))a.add(l);
    let c = new Set;
    if (s === "auto") for (let f of a){
        let l = f.slice(0, 1);
        if (!(l === "@" || l === "." || l === ":")) for(let u in t){
            if (c.has(u)) continue;
            let p = t[u]?.[f];
            if (p === void 0) continue;
            let h = X(p, `@${u}`);
            h !== void 0 && b(h) && /^[a-z][a-zA-Z]+$/.test(h) && !ty.has(h) && c.add(u);
        }
    }
    for (let f of a){
        let l = f.slice(0, 1), u = Object.values(t).some((p)=>N(p?.[f]));
        if (l === "." && u) {
            let p = f.slice(1), h = {};
            for(let d in t)N(t[d]?.[f]) && (h[d] = t[d][f]);
            i[f] = ca(h, `${e}-${p}`, r);
        } else if (l === ":" && u) {
            let p = f.replace(/^:+/, ""), h = {};
            for(let d in t)N(t[d]?.[f]) && (h[d] = t[d][f]);
            i[f] = ca(h, `${e}-${p}`, r);
        } else if (l !== "@" && l !== "." && l !== ":") {
            let p = `--theme-${e}-${f}`;
            if (s === "auto") {
                let h;
                for(let d in t){
                    if (c.has(d)) continue;
                    let m = t[d]?.[f];
                    if (m === void 0) continue;
                    let S = X(m, `@${d}`);
                    if (S === void 0) continue;
                    (d === "light" || h === void 0) && (h = S);
                    let x = `[data-theme="${d}"]`;
                    if (o[x] || (o[x] = {}), o[x][p] = S, d === "dark" || d === "light") {
                        let w = `@media (prefers-color-scheme: ${d})`;
                        o[w] || (o[w] = {}), o[w][p] = S;
                    }
                }
                h !== void 0 && (n[p] = h);
            } else {
                let h = String(s).replace(/^'|'$/g, ""), d = t[h]?.[f];
                if (d !== void 0) {
                    let m = X(d, `@${h}`);
                    m !== void 0 && (n[p] = m);
                }
            }
            i[f] = `var(${p})`, i[`.${f}`] = {
                [f]: i[f]
            };
        }
    }
    return (i.background || i.color || i.backgroundColor) && (i[".inversed"] = {
        color: i.background || i.backgroundColor,
        background: i.color
    }), i;
}, pa = (t, e, r, n)=>{
    let o = E(), { CSS_VARS: s } = o, i = {
        value: t
    }, a = !r && !n;
    if (N(t)) {
        if (a && o.useVariable) {
            let c = {};
            for(let f in t)f.startsWith("@") && N(t[f]) && (c[f.slice(1)] = t[f]);
            if (Object.keys(c).length) {
                let f = ca(c, e, o);
                Object.assign(i, f);
            }
        }
        for(let c in t){
            let f = c.slice(0, 1), l = t[c];
            if (f === "@" || f === ":" || f === ".") {
                let u = f === "@" && c;
                i[c] = pa(l, e, c, n || u);
            } else if (!a) {
                let u = X(l, n), p = [
                    ...new Set([
                        n,
                        r
                    ].filter((m)=>m).map((m)=>m.slice(1)))
                ], h = p.length ? "-" + p.join("-") : "", d = `--theme-${e}${h}-${c}`;
                o.useVariable ? (o.useThemeSuffixedVars && (s[d] = u), i[c] = `var(${d})`) : i[c] = u, i[`.${c}`] = {
                    [c]: i[c]
                };
            }
        }
        !i[".inversed"] && (i.background || i.color || i.backgroundColor) && (i[".inversed"] = {
            color: i.background || i.backgroundColor,
            background: i.color
        });
    }
    if (b(t) && nt(t)) {
        let f = o.theme[t.slice(2)];
        return Yt(f, n);
    }
    return i;
}, la = (t)=>{
    let e = E(), r = {};
    for(let n in t){
        let o = n.slice(0, 1);
        if (N(t[n])) {
            if (o === "@") continue;
            o === ":" ? r[`&${n}`] = la(t[n]) : o === "." && (r[`&${n}`] = la(t[n]));
        } else r[n] = t[n];
    }
    return r;
}, Bf = (t, e)=>{
    let r = e.shift();
    return t[r] ? Bf(t[r], e) : t;
}, Mf = (t, e)=>_(e) ? Bf(t, e) : b(e) && t[e] ? t[e] : t;
var Yt = (t, e)=>{
    let r = E();
    if (b(t) && nt(t) && (t = Yt(t.slice(2))), !t || !b(t)) {
        r.verbose && console.warn(`${t} - Theme is not a string`);
        return;
    }
    let [n, ...o] = _(t) ? t : t.split(" "), s = r.theme[n];
    return s && o.length ? s = Mf(s, o) : s && e && (s = Mf(s, e)), la(s);
};
v();
var da = (t, e)=>{
    let r = E(), n = `--font-${e}`;
    if (!t || _(t) && !t[0]) return;
    let o;
    if (t.isVariable) {
        let s = Gt(t.url, r.files) || t.url;
        fo(s) ? o = uo(s) : o = mr(e, s, t.fontWeight, {
            fontStretch: t.fontStretch,
            fontDisplay: t.fontDisplay || "swap"
        });
    } else if (t[0]) o = cn(e, t, r.files);
    else {
        let s = Array.isArray(t.url) ? t.url.map((i)=>Gt(i, r.files) || i) : Gt(t.url, r.files) || t.url;
        o = mr(e, s, t.fontWeight, {
            fontStyle: t.fontStyle,
            fontDisplay: t.fontDisplay,
            fontStretch: t.fontStretch
        });
    }
    return {
        var: n,
        value: t,
        fontFace: o
    };
}, ha = (t, e)=>{
    let r = E(), { font_family: n } = r;
    return an(e || n, t);
}, bo = (t, e)=>{
    let r = E(), { font_family: n, font_family_types: o } = r, { value: s, type: i } = t;
    t.isDefault && (n.default = e), g(s) && (s = ln(s));
    let a = `--font-family-${e}`, c = `${s.join(", ")}, ${o[i]}`;
    return {
        var: a,
        value: c,
        arr: s,
        type: i
    };
};
v();
var Uf = (t)=>{
    let e = E(), { typography: r, media: n } = e;
    for(let o in t){
        let s = o.slice(0, 1) === "@", i = t[o];
        if (!s) continue;
        let { mediaRegenerate: a } = t, c = o.slice(1), { type: f, base: l, ratio: u, range: p, subSequence: h, h1Matches: d, unit: m } = t;
        Y(i, {
            type: f,
            base: l,
            ratio: u,
            range: p,
            subSequence: h,
            h1Matches: d,
            unit: m
        });
        let S = n[c], x = "@media " + (S === "print" ? `${S}` : `screen and ${S}`);
        if (r.templates[x] = {
            fontSize: i.base / r.browserDefault + m
        }, !a) {
            yr(t, o);
            continue;
        }
        Y(i, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Kt(i), yr(t, o);
    }
}, jf = (t)=>{
    let e = E();
    if (t.h1Matches) {
        let r = t.unit, n = sa(t), { templates: o } = t;
        for(let s in n){
            let i = `h${parseInt(s) + 1}`, a = o[i];
            o[i] = {
                fontSize: e.useVariable ? `var(${n[s]?.variable})` : `${n[s]?.scaling}${r}`,
                margin: a ? a.margin : 0,
                lineHeight: a ? a.lineHeight : t.lineHeight,
                letterSpacing: a ? a.letterSpacing : t.letterSpacing,
                fontWeight: a ? a.fontWeight : 900 - s * 100
            };
        }
    }
}, ma = ()=>{
    let t = E(), { typography: e } = t;
    Kt(e), jf(e), $e(e), Uf(e);
}, ga = (t)=>{
    let e = E(), { typography: r } = e;
    return be(t, "fontSize", r);
};
v();
var ay = (t)=>{
    for(let e in t){
        let r = t[e];
        if (!(e.slice(0, 1) === "@")) continue;
        let { type: o, base: s, ratio: i, range: a, subSequence: c, h1Matches: f, unit: l } = t;
        Y(r, {
            type: o,
            base: s,
            ratio: i,
            range: a,
            subSequence: c,
            h1Matches: f,
            unit: l,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Kt(r), yr(t, e);
    }
}, ya = (t)=>{
    let e = t.toLowerCase(), r = e.includes("width") || e.includes("height"), n = e.includes("border") || e.includes("outline");
    return r && !n;
}, ba = ()=>{
    let t = E(), { spacing: e } = t;
    Kt(e), $e(e), ay(e);
}, cy = (t)=>{
    let e = E(), { spacing: r } = e;
    return !t || !t.sequence ? r : Object.keys(t.sequence).length > 0 ? t : Kt(t);
}, at = (t, e = "padding", r, n)=>{
    let o = cy(r);
    if (b(t) && !n && t.includes("(")) {
        let i = Fe(t);
        n = i[0], t = i[1];
    }
    let s = n ? [
        t
    ] : ln(t);
    if (_(s)) {
        if (s.length > 1) {
            let i = "";
            e === "borderWidth" && (e = "border", i = "Width");
            let a = {
                2: [
                    "Block",
                    "Inline"
                ],
                3: [
                    "BlockStart",
                    "Inline",
                    "BlockEnd"
                ],
                4: [
                    "BlockStart",
                    "InlineEnd",
                    "BlockEnd",
                    "InlineStart"
                ]
            }, c = (f, l)=>be(s[l], e + f + i, o, n);
            return a[s.length].map((f, l)=>c(f, l));
        }
        return be(t, e, o, n);
    }
}, Le = (t, e, r, n)=>{
    let o = E(), { spacing: s } = o, i = r || t[e];
    if (!n && b(i) && i.includes("(")) {
        let a = Fe(i);
        n = a[0], i = a[1];
    }
    if (t.spacingRatio) {
        let a = applyCustomSequence(t);
        return at(i, e, a, n);
    }
    return at(i, e, s, n);
}, Sa = (t)=>{
    let e = (r)=>{
        let n = [
            "+",
            "-",
            "*",
            "/"
        ].includes(r), o = on.some((i)=>t.includes(i));
        return n || o ? r : r.length < 3 && /[A-Z]/.test(r) ? r + "_default" : r;
    };
    return t.split(",").map((r)=>r.trim()).map(e).join(",").split(" ").map(e).join(" ");
};
v();
var _r = (t, e, r, n)=>{
    let o = E();
    if (_(t)) return {
        "@light": _r(t[0], e, "light"),
        "@dark": _r(t[1], e, "dark")
    };
    if (g(t)) {
        let i = {};
        for(let a in t)i[a] = _r(t[a], e, a.startsWith("@") ? a.slice(1) : a);
        return i;
    }
    b(t) && !te.test(t) && (t = hr(t).map((i)=>(i = i.trim(), i.split(/\s+/).map((a)=>{
            if (a = a.trim(), !a) return "";
            if (a.startsWith("--")) return `var(${a})`;
            let c = X(a);
            if (ye(c)) return c;
            if (/^\d/.test(a) || a === "0" || a.includes("px") || a.slice(-2) === "em" || a === "inset" || a === "none") return a;
            let f = at(a, "shadow");
            return f && f.shadow ? f.shadow : a;
        }).join(" "))).join(", "));
    let s = `--shadow-${e}` + (r ? `-${r}` : "");
    return o.useVariable && (o.CSS_VARS[s] = t), {
        var: s,
        value: t
    };
}, xa = (t, e)=>{
    let r = E();
    if (e || (e = r.globalTheme), !b(t)) {
        r.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    let [n] = _(t) ? t : t.split(" "), s = r.shadow[n], i = g(s);
    if (!s) return r.verbose && console.warn("Can't find color ", n), t;
    if (e) {
        if (s[e]) return s[e].value;
        r.verbose && console.warn(t, " - does not have ", e);
    }
    if (i && s.value) return s.value;
    if (i) {
        let a = {};
        for(let c in s){
            let f = r.media[c.slice(1)], l = "@media " + (f === "print" ? `${f}` : `screen and ${f}`);
            a[l] = s.value;
        }
        return a;
    }
    return r.verbose && console.warn("Can't find color", t), t;
};
var _a = ()=>{
    let t = E(), { timing: e } = t;
    Kt(e), $e(e);
}, Ft = (t)=>{
    let e = E(), { timing: r } = e;
    return r[t] || r[Ki(t)] || t;
}, Ut = (t, e = "timing")=>{
    let r = E(), { timing: n } = r;
    return be(t, e, n);
};
v();
var wa = ()=>{
    let t = E(), { document: e, font_family: r, theme: n, typography: o } = t;
    return Y(e, {
        theme: n.document,
        fontFamily: an(r),
        fontSize: o.base,
        lineHeight: o.lineHeight
    });
};
v();
var va = {
    document: z
}, So = (t, e)=>{
    let r = E();
    if (!t) {
        r.verbose && console.warn("setSVG: val is not defined", e);
        return;
    }
    return r.useSvgSprite ? aa(e, t) : t;
}, Ca = (t, e = va)=>{
    let r = E(), n = Object.keys(t).length ? {} : r.svg;
    for(let o in t)n[o] = r.svg[o];
    qf(n, e);
}, Ea = (t, e)=>{
    let r = E();
    return r.useIconSprite && !r.semantic_icons?.[e] ? So(t, e) : t;
}, ka = (t, e = va)=>{
    let r = E(), n = Object.keys(t).length ? {} : r.icons;
    for(let o in t)n[o] = r.icons[o];
    qf(n, e);
}, Vf = (t, e = {
    isRoot: !0
})=>{
    if (!t || !t.createElementNS) return;
    let r = t.createElementNS("http://www.w3.org/2000/svg", "svg");
    return e.isRoot && (r.setAttribute("aria-hidden", "true"), r.setAttribute("width", "0"), r.setAttribute("height", "0"), r.setAttribute("style", "position:absolute"), r.setAttribute("id", "svgSprite")), r;
}, qf = (t, e = va)=>{
    let r = E(), n = e.document || z;
    if (!n || !n.documentElement) return r.verbose && console.warn("To append SVG sprites it should be run in browser environment"), go(t);
    let o = n.querySelector("#svgSprite"), s = go(t), i = `<svg aria-hidden="true" width="0" height="0" style="position:absolute" id="svgSprite">${s}</svg>`;
    if (o) {
        if (n.body.insertAdjacentHTML) o.insertAdjacentHTML("beforeend", s);
        else {
            let a = Vf(n, {
                isRoot: !1
            });
            a.innerHTML = s, o.append(...a.children);
        }
    } else if (n.body.insertAdjacentHTML) n.body.insertAdjacentHTML("afterbegin", i);
    else {
        let a = Vf(n);
        a && a.nodeType && (a.innerHTML = s, n.body.prepend(a));
    }
};
v();
var Oa = (t = {})=>{
    let e = E(), { reset: r, typography: n, document: o } = e;
    if (r) {
        if (r[":root"]) {
            let c = r, f = n.templates;
            c.body = {
                ...e.useDocumentTheme ? Yt("document") : {},
                ...f.body
            }, c.h1 = f.h1, c.h2 = f.h2, c.h3 = f.h3, c.h4 = f.h4, c.h5 = f.h5, c.h6 = f.h6;
        }
        let { body: s, ...i } = n.templates, a = e.useDocumentTheme ? Yt("document") : {};
        return r.html && it(r.html, a), H(Y(r, t), {
            html: {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...a,
                fontSize: n.browserDefault + "px",
                fontFamily: o.fontFamily,
                lineHeight: o.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: o.fontFamily,
                fontSize: n.base / n.browserDefault + e.unit.default,
                ...i,
                ...s
            },
            a: {
                color: "currentColor"
            },
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: o.fontFamily
            }
        });
    }
};
v();
var ly = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "initial"
]), fy = new Set([
    "to",
    "top",
    "bottom",
    "left",
    "right",
    "center",
    "at",
    "circle",
    "ellipse",
    "closest-side",
    "farthest-side",
    "closest-corner",
    "farthest-corner"
]), uy = (t)=>ly.has(t), Se = (t)=>{
    let e = t + "";
    if (te.test(e)) return e;
    let r = e.trim();
    return r === "none" || r === "0" || r === "initial" || r === "inherit" || r === "unset" ? e : e.split(/\s+/).map((o)=>{
        if (o = o.trim(), !o) return "";
        if (nt(o)) return `var(${o})`;
        if (uy(o) || /^\d/.test(o) || o === "0") return o;
        let s = X(o);
        if (ye(s)) return s;
        let i = at(o, "border");
        return i && i.border ? i.border : o;
    }).join(" ");
}, zf = (t)=>te.test(t) ? t : t.split(/\s+/).map((e)=>{
        if (e = e.trim(), !e) return "";
        if (nt(e)) return `var(${e})`;
        if (/^\d/.test(e) || e.includes("px") || e === "0") return e;
        let r = X(e);
        return ye(r) ? r : e;
    }).join(" "), Hf = (t, e)=>xa(t, e), Aa = (t, e)=>te.test(t) ? t : hr(t).map((r)=>(r = r.trim(), r ? r.split(/\s+/).map((n)=>{
            if (n = n.trim(), !n) return "";
            if (nt(n)) return `var(${n})`;
            if (n === "inset" || n === "none") return n;
            let o = X(n);
            if (ye(o)) {
                let i = Et(n, e);
                return g(i) ? Object.values(i).filter((a)=>a.includes(": " + e))[0] : i;
            }
            if (/^\d/.test(n) || n === "0" || n.includes("px") || n.slice(-2) === "em") return n;
            let s = at(n, "shadow");
            return s && s.shadow ? s.shadow : n;
        }).join(" ") : "")).join(", "), Ta = (t, e)=>{
    let r = t.indexOf("(");
    if (r === -1) return t;
    let n = t.slice(0, r + 1), o = t.slice(r + 1, t.lastIndexOf(")")), s = ")", a = hr(o).map((c)=>(c = c.trim(), c.split(/\s+/).map((l)=>{
            if (!l || /^\d/.test(l) || l === "0" || fy.has(l) || l === "transparent" || te.test(l)) return l;
            let u = X(l);
            return ye(u) ? u : l;
        }).join(" ")));
    return n + a.join(", ") + s;
}, Wf = (t, e)=>{
    let r = E();
    return t.split(", ").map((n)=>nt(n) ? `var(${n})` : n.includes("url") ? n : n.includes("gradient") ? Ta(n, e) : r.gradient[t] ? {
            backgroundImage: Et(t, e || r.globalTheme)
        } : n.includes("/") || n.startsWith("http") || n.includes(".") && !dr(n) ? `url(${n})` : n).join(" ");
}, Gf = (t)=>b(t) && t.split(" ").map((e)=>at(e, "gap").gap).join(" "), py = (t)=>{
    let e = t.split(" ");
    return e.length ? e.map((r)=>nt(r) ? `var(${r})` : r.length < 3 || r.includes("ms") ? Ut(r).timing || r : Ft(r) ? Ft(r) : r).join(" ") : t;
}, wr = (t, e, r)=>{
    if (b(t)) return t.split(",").map((n)=>Ut(n).timing || n).join(",");
}, _o = (t)=>{
    let e = t.split(",");
    if (e.length) return e.map(py).join(",");
};
function ot(t, e, r = {}, n = {}) {
    let o = O.call(this, e || r[t]);
    if (o == null) return;
    let s;
    if (b(o)) {
        if (o.includes("(")) {
            let c = Fe(o);
            s = c[0], o = c[1];
        }
        let i = r.scaleBoxSize, a = ya(t);
        !i && a && !n.ratio && (o = Sa(o));
    }
    return n.ratio ? Le(r, t, o, s) : at(o, t, void 0, s);
}
var $ = (t, e = null, r)=>ot(t, e, r, {
        ratio: !0
    }), Ra = (t, e, r)=>{
    if (b(t)) return {
        borderRadius: t.split(" ").map((n, o)=>Le(e, r, n)[r]).join(" ")
    };
};
v();
var dy = (t, e)=>{
    let r = E(), { CSS_VARS: n } = r, o = e.startsWith("--") ? e : `--${e}`;
    return n[o] = t, t;
}, $t = (t)=>t, Kf = {
    color: Sr,
    gradient: xr,
    font: da,
    font_family: bo,
    fontfamily: bo,
    theme: ua,
    icons: Ea,
    semantic_icons: $t,
    semanticicons: $t,
    svg: So,
    svg_data: $t,
    typography: $t,
    shadow: _r,
    spacing: $t,
    media: $t,
    grid: $t,
    class: $t,
    timing: $t,
    reset: $t,
    unit: $t,
    animation: $t,
    vars: dy
}, hy = (t, e, r)=>{
    let n = E(), o = t.toLowerCase(), s = n[o] || n[t];
    if (Kf[o]) try {
        let i = Kf[o](e, r);
        return s[r] = i, s;
    } catch (i) {
        n.verbose && console.warn("Error setting", o, "value", e, r, i);
    }
    n.verbose && console.warn("Can not find", o, "method in scratch");
}, my = (t, e)=>{
    let r = E(), n = t.toLowerCase();
    return Object.keys(e).forEach((s)=>{
        try {
            return hy(n, e[s], s);
        } catch (i) {
            r.verbose && console.warn("Error setting", n, "value", e[s], s, i);
        }
    }), r[n] || r[t];
};
var gy = {}, dn = (t, e = gy)=>{
    let r = E(), { version: n, verbose: o, useVariable: s, useReset: i, useSvgSprite: a, useFontImport: c, useIconSprite: f, globalTheme: l, useDocumentTheme: u, useDefaultConfig: p, semanticIcons: h, SEMANTIC_ICONS: d, semantic_icons: m, files: S, ...x } = t;
    e.newConfig && (r = Df(e.newConfig)), S !== void 0 && (r.files = S), o !== void 0 && (r.verbose = o), s !== void 0 && (r.useVariable = s), i !== void 0 && (r.useReset = i), c !== void 0 && (r.useFontImport = c), a !== void 0 && (r.useSvgSprite = a), f !== void 0 && (r.useIconSprite = f), u !== void 0 && (r.useDocumentTheme = u), l !== void 0 && (r.globalTheme = l), t.useThemeSuffixedVars !== void 0 && (r.useThemeSuffixedVars = t.useThemeSuffixedVars), p !== void 0 && (r.useDefaultConfig = p);
    let w = h || d || m;
    w !== void 0 && (r.semantic_icons = w, r.semanticIcons = r.semantic_icons, r.SEMANTIC_ICONS = r.semantic_icons), r.verbose && console.log(r), typeof document < "u" && r.globalTheme && r.globalTheme !== "auto" && document.documentElement.setAttribute("data-theme", r.globalTheme), r.__svg_cache || (r.__svg_cache = {});
    let C = Object.keys(x), R = new Set(C);
    if (C.forEach((T)=>{
        let A = T.toLowerCase();
        A !== T && R.has(A) && H(x[A], x[T]);
    }), x.theme && !r._originalTheme && (r._originalTheme = JSON.parse(JSON.stringify(x.theme))), C.map((T)=>{
        let A = T.toLowerCase();
        if (!(A !== T && R.has(A))) return my(T, x[T]);
    }), x.typography || x.TYPOGRAPHY) try {
        ma();
    } catch (T) {
        r.verbose && console.warn("Error applying typography sequence", T);
    }
    if (x.spacing || x.SPACING) try {
        ba();
    } catch (T) {
        r.verbose && console.warn("Error applying spacing sequence", T);
    }
    if (x.timing || x.TIMING) try {
        _a();
    } catch (T) {
        r.verbose && console.warn("Error applying timing sequence", T);
    }
    return wa(), Oa(), r;
};
var yy = [
    "ease",
    "linear",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
], by = [
    "none",
    "forwards",
    "backwards",
    "both"
], Sy = [
    "normal",
    "reverse",
    "alternate",
    "alternate-reverse"
], xy = [
    "running",
    "paused"
], _y = (t)=>/^[\d.]+m?s$/.test(t), Ia = (t, e)=>{
    let { emotion: r } = e.context, { keyframes: n } = r || Ct;
    if (g(t)) return {
        animationName: n(t)
    };
    let { ANIMATION: o } = e.context && e.context.designSystem, s = o[t];
    return n(s);
}, wy = (t, e)=>{
    let { ANIMATION: r } = e.context && e.context.designSystem || {}, n = t.split(/\s+/), o = null, s = [], i = null, a = null, c = null, f = null, l = null;
    for (let u of n)r && r[u] ? o = u : _y(u) ? s.push(u) : yy.includes(u) || u.startsWith("cubic-bezier") || u.startsWith("steps(") ? i = u : u === "infinite" || /^\d+$/.test(u) ? a = u === "infinite" ? u : Number(u) : Sy.includes(u) ? c = u : by.includes(u) ? f = u : xy.includes(u) ? l = u : o || (o = u);
    return {
        name: o,
        durations: s,
        timingFunction: i,
        iterationCount: a,
        direction: c,
        fillMode: f,
        playState: l
    };
}, Yf = {
    animation: (t, e)=>{
        if (b(t) && t.includes(" ")) {
            let r = wy(t, e);
            return {
                animationName: Ia(r.name || t, e),
                animationDuration: r.durations[0] || Ut(e.props.animationDuration || "A").timing,
                animationDelay: r.durations[1] || Ut(e.props.animationDelay || "0s").timing,
                animationTimingFunction: r.timingFunction || Ft(e.props.animationTimingFunction || "ease"),
                animationFillMode: r.fillMode || e.props.animationFillMode || "both",
                animationIterationCount: r.iterationCount != null ? r.iterationCount : e.props.animationIterationCount || 1,
                animationPlayState: r.playState || e.props.animationPlayState,
                animationDirection: r.direction || e.props.animationDirection
            };
        }
        return {
            animationName: Ia(t, e),
            animationDuration: Ut(e.props.animationDuration || "A").timing,
            animationDelay: Ut(e.props.animationDelay || "0s").timing,
            animationTimingFunction: Ft(e.props.animationTimingFunction || "ease"),
            animationFillMode: e.props.animationFillMode || "both",
            animationIterationCount: e.props.animationIterationCount || 1,
            animationPlayState: e.props.animationPlayState,
            animationDirection: e.props.animationDirection
        };
    },
    animationName: (t, e)=>({
            animationName: Ia(t, e)
        }),
    animationDuration: (t)=>({
            animationDuration: Ut(t).timing
        }),
    animationDelay: (t)=>({
            animationDelay: Ut(t).timing
        }),
    animationTimingFunction: (t)=>({
            animationTimingFunction: Ft(t)
        }),
    animationIterationCount: (t)=>({
            animationIterationCount: t
        }),
    animationFillMode: (t)=>({
            animationFillMode: t
        }),
    animationPlayState: (t)=>({
            animationPlayState: t
        }),
    animationDirection: (t)=>({
            animationDirection: t
        })
};
v();
var Qf = {
    show: (t, e, r, n)=>n.utils.exec(t, e, r) === !1 && {
            display: "none !important"
        },
    hide: (t, e, r, n)=>!!n.utils.exec(t, e, r) && {
            display: "none !important"
        },
    height: (t, { props: e })=>$("height", t, e),
    width: (t, { props: e })=>$("width", t, e),
    boxSizing: (t)=>K(t) ? {
            boxSizing: "border-box"
        } : {
            boxSizing: t
        },
    boxSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("height", e),
            ...ot("width", r || e)
        };
    },
    inlineSize: (t, { props: e })=>$("inlineSize", t, e),
    blockSize: (t, { props: e })=>$("blockSize", t, e),
    minWidth: (t, { props: e })=>$("minWidth", t, e),
    maxWidth: (t, { props: e })=>$("maxWidth", t, e),
    widthRange: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minWidth", e),
            ...ot("maxWidth", r || e)
        };
    },
    minHeight: (t, { props: e })=>$("minHeight", t, e),
    maxHeight: (t, { props: e })=>$("maxHeight", t, e),
    heightRange: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minHeight", e),
            ...ot("maxHeight", r || e)
        };
    },
    size: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...$("inlineSize", e),
            ...$("blockSize", r || e)
        };
    },
    minBlockSize: (t, { props: e })=>$("minBlockSize", t, e),
    minInlineSize: (t, { props: e })=>$("minInlineSize", t, e),
    maxBlockSize: (t, { props: e })=>$("maxBlockSize", t, e),
    maxInlineSize: (t, { props: e })=>$("maxInlineSize", t, e),
    minSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minInlineSize", e),
            ...ot("minBlockSize", r || e)
        };
    },
    maxSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("maxInlineSize", e),
            ...ot("maxBlockSize", r || e)
        };
    },
    borderWidth: (t, { props: e })=>$("borderWidth", t, e),
    padding: (t, { props: e })=>$("padding", t, e),
    scrollPadding: (t, { props: e })=>$("scrollPadding", t, e),
    paddingInline: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("paddingInlineStart", e),
            ...ot("paddingInlineEnd", r || e)
        };
    },
    paddingBlock: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("paddingBlockStart", e),
            ...ot("paddingBlockEnd", r || e)
        };
    },
    paddingTop: (t, { props: e })=>$("paddingBlockStart", t, e),
    paddingBottom: (t, { props: e })=>$("paddingBlockEnd", t, e),
    paddingLeft: (t, { props: e })=>$("paddingInlineStart", t, e),
    paddingRight: (t, { props: e })=>$("paddingInlineEnd", t, e),
    paddingBlockStart: (t, { props: e })=>$("paddingBlockStart", t, e),
    paddingBlockEnd: (t, { props: e })=>$("paddingBlockEnd", t, e),
    paddingInlineStart: (t, { props: e })=>$("paddingInlineStart", t, e),
    paddingInlineEnd: (t, { props: e })=>$("paddingInlineEnd", t, e),
    margin: (t, { props: e })=>$("margin", t, e),
    marginInline: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("marginInlineStart", e),
            ...ot("marginInlineEnd", r || e)
        };
    },
    marginBlock: (t, { props: e })=>{
        if (!b(e.marginBlock)) return;
        let [r, n] = e.marginBlock.split(" ");
        return {
            ...ot("marginBlockStart", r),
            ...ot("marginBlockEnd", n || r)
        };
    },
    marginTop: (t, { props: e })=>$("marginBlockStart", t, e),
    marginBottom: (t, { props: e })=>$("marginBlockEnd", t, e),
    marginLeft: (t, { props: e })=>$("marginInlineStart", t, e),
    marginRight: (t, { props: e })=>$("marginInlineEnd", t, e),
    marginInlineStart: (t, { props: e })=>$("marginInlineStart", t, e),
    marginInlineEnd: (t, { props: e })=>$("marginInlineEnd", t, e),
    marginBlockStart: (t, { props: e })=>$("marginBlockStart", t, e),
    marginBlockEnd: (t, { props: e })=>$("marginBlockEnd", t, e),
    gap: (t)=>({
            gap: Gf(t)
        }),
    columnGap: (t, { props: e })=>Le(e, "columnGap", t),
    rowGap: (t, { props: e })=>Le(e, "rowGap", t),
    flexWrap: (t, { props: e })=>({
            display: "flex",
            flexFlow: (t || "row").split(" ")[0] + " " + e.flexWrap
        }),
    flexFlow: (t, { props: e })=>{
        let { reverse: r } = e;
        if (!b(t)) return;
        let [n, o] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (n = "row"), (t.startsWith("y") || t === "column") && (n = "column"), {
            display: "flex",
            flexFlow: (n || "") + (!n.includes("-reverse") && r ? "-reverse" : "") + " " + (o || "")
        };
    },
    flexAlign: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            display: "flex",
            alignItems: e,
            justifyContent: r
        };
    },
    round: (t, { props: e })=>Ra(t || e.borderRadius, e, "round"),
    borderRadius: (t, { props: e })=>Ra(t || e.round, e, "borderRadius")
};
var Xf = {
    fontSize: (t)=>ga(t) || t,
    fontFamily: (t)=>({
            fontFamily: ha(t) || t
        }),
    fontWeight: (t)=>({
            fontWeight: t,
            fontVariationSettings: '"wght" ' + t
        })
};
var Pa = {
    overflow: (t)=>({
            overflow: t,
            scrollBehavior: "smooth"
        }),
    cursor: (t, e, r, n)=>{
        if (!t) return;
        let o = n.files && n.files[t];
        return o && o.content && (t = `url(${o.content.src})`), {
            cursor: t
        };
    }
};
var Jf = {
    inset: (t, e)=>{
        if (e.call("isNumber", t)) return {
            inset: t
        };
        if (e.call("isString", t)) return {
            inset: t.split(" ").map((r)=>at(r, "k").k).join(" ")
        };
    },
    left: (t)=>at(t, "left"),
    top: (t)=>at(t, "top"),
    right: (t)=>at(t, "right"),
    bottom: (t)=>at(t, "bottom"),
    verticalInset: (t)=>{
        if (typeof t != "string") return;
        let e = t.split(" ").map((r)=>at(r, "k").k);
        return {
            top: e[0],
            bottom: e[1] || e[0]
        };
    },
    horizontalInset: (t)=>{
        if (typeof t != "string") return;
        let e = t.split(" ").map((r)=>at(r, "k").k);
        return {
            left: e[0],
            right: e[1] || e[0]
        };
    }
};
v();
var jt = ({ context: t, state: e })=>{
    let r = e?.root?.globalTheme || t.designSystem?.globalTheme;
    return r === "auto" ? null : r;
}, Zf = {
    theme: (t, e)=>{
        let { props: r } = e;
        if (t) return r.themeModifier ? Yt(t, `@${r.themeModifier}`) : Yt(t);
    },
    color: (t, e)=>{
        let r = jt(e);
        if (t) return {
            color: Et(t, r)
        };
    },
    background: (t, e)=>{
        let r = jt(e);
        if (t) return b(t) && t.includes("gradient") ? {
            background: Ta(t, r)
        } : {
            background: Et(t, r)
        };
    },
    backgroundColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            backgroundColor: Et(t, r)
        };
    },
    backgroundImage: (t, e, r, n)=>{
        let o = jt(e);
        if (!t) return;
        let s = n.files && n.files[t];
        return s && s.content && (t = s.content.src), {
            backgroundImage: Wf(t, o)
        };
    },
    textStroke: (t)=>({
            WebkitTextStroke: zf(t)
        }),
    outline: (t)=>({
            outline: Se(t)
        }),
    outlineOffset: (t, { props: e })=>$("outlineOffset", t, e),
    border: (t)=>({
            border: Se(t)
        }),
    borderColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            borderColor: Et(t, r)
        };
    },
    borderTopColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            borderTopColor: Et(t, r)
        };
    },
    borderBottomColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            borderBottomColor: Et(t, r)
        };
    },
    borderLeftColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            borderLeftColor: Et(t, r)
        };
    },
    borderRightColor: (t, e)=>{
        let r = jt(e);
        if (t) return {
            borderRightColor: Et(t, r)
        };
    },
    borderLeft: (t)=>({
            borderLeft: Se(t)
        }),
    borderTop: (t)=>({
            borderTop: Se(t)
        }),
    borderRight: (t)=>({
            borderRight: Se(t)
        }),
    borderBottom: (t)=>({
            borderBottom: Se(t)
        }),
    shadow: (t, e)=>{
        let r = jt(e);
        if (t) return {
            boxShadow: Hf(t, r)
        };
    },
    boxShadow: (t, e)=>{
        if (!b(t)) return;
        let [r, n] = t.split("!importan"), o = jt(e), s = n ? " !important" : "";
        return {
            boxShadow: Aa(r.trim(), o) + s
        };
    },
    textShadow: (t, { context: e })=>({
            textShadow: Aa(t, e.designSystem.globalTheme)
        }),
    columnRule: (t)=>({
            columnRule: Se(t)
        })
};
var tu = {
    transition: (t)=>({
            transition: _o(t)
        }),
    transitionDuration: (t)=>({
            transitionDuration: wr(t)
        }),
    transitionDelay: (t)=>({
            transitionDelay: wr(t)
        }),
    transitionTimingFunction: (t)=>({
            transitionTimingFunction: Ft(t)
        }),
    transitionProperty: (t)=>({
            transitionProperty: t,
            willChange: t
        })
};
v();
var eu = {
    flow: (t, e)=>{
        let { props: r } = e, { reverse: n } = r;
        if (!b(t)) return;
        let [o, s] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (o = "row"), (t.startsWith("y") || t === "column") && (o = "column"), {
            display: "flex",
            flexFlow: (o || "") + (!o.includes("-reverse") && n ? "-reverse" : "") + " " + (s || "")
        };
    },
    wrap: (t, { props: e })=>({
            display: "flex",
            flexWrap: t
        }),
    align: (t, { props: e })=>{
        let [r, n] = t.split(" ");
        return {
            display: "flex",
            alignItems: r,
            justifyContent: n
        };
    }
};
var ru = {
    area: (t)=>({
            gridArea: t
        }),
    template: (t)=>({
            gridTemplate: t
        }),
    templateAreas: (t)=>({
            gridTemplateAreas: t
        }),
    column: (t)=>({
            gridColumn: t
        }),
    columns: (t)=>({
            gridTemplateColumns: t
        }),
    templateColumns: (t)=>({
            gridTemplateColumns: t
        }),
    autoColumns: (t)=>({
            gridAutoColumns: t
        }),
    columnStart: (t)=>({
            gridColumnStart: t
        }),
    row: (t)=>({
            gridRow: t
        }),
    rows: (t)=>({
            gridTemplateRows: t
        }),
    templateRows: (t)=>({
            gridTemplateRows: t
        }),
    autoRows: (t)=>({
            gridAutoRows: t
        }),
    rowStart: (t)=>({
            gridRowStart: t
        }),
    autoFlow: (t)=>({
            gridAutoFlow: t
        })
};
var hn = {
    ...Yf,
    ...Qf,
    ...Xf,
    ...Pa,
    ...Pa,
    ...Jf,
    ...Zf,
    ...tu,
    ...eu,
    ...ru
};
var nu = new Set([
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignmentBaseline",
    "all",
    "animation",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "background",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "backgroundImage",
    "backgroundOrigin",
    "backgroundPosition",
    "backgroundPositionX",
    "backgroundPositionY",
    "backgroundRepeat",
    "backgroundRepeatX",
    "backgroundRepeatY",
    "backgroundSize",
    "baselineShift",
    "blockSize",
    "border",
    "borderBlock",
    "borderBlockColor",
    "borderBlockEnd",
    "borderBlockEndColor",
    "borderBlockEndStyle",
    "borderBlockEndWidth",
    "borderBlockStart",
    "borderBlockStartColor",
    "borderBlockStartStyle",
    "borderBlockStartWidth",
    "borderBlockStyle",
    "borderBlockWidth",
    "borderBottom",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderCollapse",
    "borderColor",
    "borderImage",
    "borderImageOutset",
    "borderImageRepeat",
    "borderImageSlice",
    "borderImageSource",
    "borderImageWidth",
    "borderLeft",
    "borderLeftColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderRadius",
    "borderRight",
    "borderRightColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderSpacing",
    "borderStyle",
    "borderTop",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopStyle",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "boxDecorationBreak",
    "boxShadow",
    "boxSizing",
    "breakAfter",
    "breakBefore",
    "breakInside",
    "captionSide",
    "caretColor",
    "clear",
    "clip",
    "clipPath",
    "color",
    "colorAdjust",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorRendering",
    "columnCount",
    "columnFill",
    "columnGap",
    "columnRule",
    "columnRuleColor",
    "columnRuleStyle",
    "columnRuleWidth",
    "columnSpan",
    "columnWidth",
    "columns",
    "contain",
    "content",
    "counterIncrement",
    "counterReset",
    "cursor",
    "direction",
    "display",
    "emptyCells",
    "filter",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexFlow",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "float",
    "font",
    "fontFamily",
    "fontFeatureSettings",
    "fontKerning",
    "fontLanguageOverride",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontVariantAlternates",
    "fontVariantCaps",
    "fontVariantEastAsian",
    "fontVariantNumeric",
    "fontVariantPosition",
    "fontWeight",
    "fontVariationSettings",
    "fontSynthesis",
    "forcedColorAdjust",
    "gap",
    "grid",
    "gridArea",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridColumn",
    "gridColumnEnd",
    "gridColumnGap",
    "gridColumnStart",
    "gridGap",
    "gridRow",
    "gridRowEnd",
    "gridRowGap",
    "gridRowStart",
    "gridTemplate",
    "gridTemplateAreas",
    "gridTemplateColumns",
    "gridTemplateRows",
    "height",
    "hyphens",
    "imageOrientation",
    "imageRendering",
    "imeMode",
    "inset",
    "insetBlock",
    "insetBlockEnd",
    "insetBlockStart",
    "insetInline",
    "insetInlineEnd",
    "insetInlineStart",
    "initialLetter",
    "isolation",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "left",
    "letterSpacing",
    "lineBreak",
    "lineClamp",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBlock",
    "marginBlockEnd",
    "marginBlockStart",
    "marginInline",
    "marginInlineEnd",
    "marginInlineStart",
    "mask",
    "maskBorder",
    "maskBorderImage",
    "maskBorderOutset",
    "maskBorderRepeat",
    "maskBorderSlice",
    "maskBorderSource",
    "maskBorderWidth",
    "maskClip",
    "maskComposite",
    "maskImage",
    "maskOrigin",
    "maskPosition",
    "maskRepeat",
    "maskSize",
    "maskType",
    "maxBlockSize",
    "maxHeight",
    "maxInlineSize",
    "maxWidth",
    "minBlockSize",
    "minHeight",
    "minInlineSize",
    "minWidth",
    "mixBlendMode",
    "objectFit",
    "objectPosition",
    "objectViewBox",
    "offset",
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "opacity",
    "order",
    "orientation",
    "outline",
    "outlineColor",
    "outlineOffset",
    "outlineStyle",
    "outlineWidth",
    "overflow",
    "overflowAnchor",
    "overflowClip",
    "overflowScrolling",
    "overflowWrap",
    "overflowX",
    "overflowY",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "pageBreakAfter",
    "pageBreakBefore",
    "pageBreakInside",
    "paintOrder",
    "perspective",
    "perspectiveOrigin",
    "placeContent",
    "placeItems",
    "placeSelf",
    "pointerEvents",
    "position",
    "resize",
    "right",
    "rotate",
    "rowGap",
    "scrollBehavior",
    "scrollPadding",
    "scrollSnapAlign",
    "scrollSnapType",
    "scrollbarColor",
    "scrollbarWidth",
    "shapeImageThreshold",
    "shapeMargin",
    "shapeOutside",
    "tabSize",
    "tableLayout",
    "textAlign",
    "textAlignLast",
    "textDecoration",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationSkipInk",
    "textDecorationStyle",
    "textDecorationThickness",
    "textIndent",
    "textOverflow",
    "textShadow",
    "textTransform",
    "textUnderlineOffset",
    "top",
    "transform",
    "transformOrigin",
    "transformStyle",
    "transition",
    "transitionDelay",
    "transitionDuration",
    "transitionProperty",
    "transitionTimingFunction",
    "translate",
    "translateX",
    "translateY",
    "translateZ",
    "unicodeBidi",
    "userSelect",
    "verticalAlign",
    "visibility",
    "whiteSpace",
    "widows",
    "width",
    "willChange",
    "wordBreak",
    "wordSpacing",
    "wordWrap",
    "writingMode",
    "zIndex"
]);
v();
var vy = (t, e, r)=>{
    let { context: n } = r;
    if (!n.designSystem?.media) return;
    let o = n.designSystem.media[t.slice(1)], s = Qt(e, r), i;
    return o ? o === "print" ? i = "@media print" : o[0] === "(" ? i = `@media screen and ${o}` : i = `${o} &` : i = t, {
        [i]: s
    };
}, ou = (t, e, r)=>({
        [t]: Qt(e, r)
    }), mn = (t, e, r)=>({
        [`&${t}`]: Qt(e, r)
    }), Na = (t, e)=>{
    let r = e.context?.cases?.[t];
    if (r !== void 0) return y(r) ? r.call(e, e) : !!r;
}, Cy = (t, e, r)=>{
    let n = t.slice(1), o = Na(n, r);
    if (o === void 0 && (o = !!r.props?.[n]), !!o) return Qt(e, r);
}, Ey = (t, e, r)=>({
        [t]: e
    }), ky = (t, e, r)=>{
    let n = t.slice(1), o = r.props[n] === !0 || r.state[n] || r[n];
    if (!o) {
        let s = Na(n, r);
        s !== void 0 && (o = s);
    }
    if (o) return Qt(e, r);
}, Oy = (t, e, r)=>{
    let n = t.slice(1), o = r.props[n] === !0 || r.state[n] || r[n];
    if (!o) {
        let s = Na(n, r);
        s !== void 0 && (o = s);
    }
    if (!o) return Qt(e, r);
}, su = (t, e)=>Qt(t, e), iu = {
    "@": vy,
    ":": mn,
    "[": mn,
    "*": mn,
    "+": mn,
    "~": mn,
    "&": ou,
    ">": ou,
    $: Cy,
    "-": Ey,
    ".": ky,
    "!": Oy
};
var Da = Ge(), Ay = (t, e, r)=>{
    let n = {}, o = {}, s = (i, a)=>{
        if (r.unpack) {
            n = {
                ...n,
                ...a
            };
            return;
        }
        n[i] = a;
    };
    for(let i in t){
        let a = t[i];
        if (i === "class" && e.call("isString", t.class)) {
            let c = a.split(" ");
            if (c.length) {
                let f = e.context.designSystem.class, l = c.reduce((u, p)=>Y(u, f[p]), {});
                n.designSystemClass = l;
            }
        } else if (i === "true") {
            let c = O(a, e);
            Y(n, su(c, e));
        } else if (e.classlist[i]) {
            let c = e.classlist[i], f = y(c) ? c(e, e.state, e.context) : c;
            f && s(i, f), !Da && g(n[i]) && (n[i].label = i);
        } else if (hn[i]) {
            let c = O(a, e);
            _(c) && (c = c.reduce((l, u)=>Y(l, u), {}));
            let f = hn[i](c, e, e.state, e.context);
            _(f) && (f = f.reduce((l, u)=>Y(l, u), {})), f && s(i, f), !Da && g(n[i]) && (n[i].label = i);
        } else if (nu.has(i)) {
            let c = O(a, e);
            typeof c == "string" && c.charCodeAt(0) === 45 && c.charCodeAt(1) === 45 && (c = `var(${c})`), s(i, {
                [i]: c
            }), !Da && g(n[i]) && (n[i].label = i);
        } else o[i] = a;
    }
    return [
        n,
        o
    ];
}, Ty = (t, e)=>{
    let r = {};
    for(let n in t){
        let o = iu[n.slice(0, 1)];
        if (o) {
            let s = o(n, t[n], e);
            if (s) for(let i in s)Object.prototype.hasOwnProperty.call(s, i) && (r[i] && typeof r[i] == "object" && typeof s[i] == "object" ? it(r[i], s[i]) : r[i] = s[i]);
        }
    }
    return r;
}, Qt = (t, e, r = {
    unpack: !0
})=>{
    let [n, o] = Ay(t, e, r), s = Ty(o, e), i = !1;
    for(let a in s){
        i = !0;
        break;
    }
    if (i) {
        if (r.unpack) return fe(n, s);
        n._selectors = s;
    }
    return n;
}, zk = (t, e)=>{
    let r = {};
    if (t.class) for(let n in t.class)r[n] = t.class[n](e);
    return r;
};
v();
var { css: Ry } = Ct, Kk = (t, e)=>y(e) ? e(t) : Ry(t);
var au = {
    transparent: "rgba(0, 0, 0, 0)",
    black: "black",
    white: "white",
    title: [
        "--gray 1 -168",
        "--gray 1 +168"
    ],
    caption: [
        "--gray 1 -68",
        "--gray 1 +68"
    ],
    paragraph: [
        "--gray 1 -42",
        "--gray 1 +42"
    ],
    disabled: [
        "--gray 1 -26",
        "--gray 1 +26"
    ],
    line: [
        "--gray 1 -16",
        "--gray 1 +16"
    ]
}, cu = {};
var Iy = {
    primary: {
        "@dark": {
            color: "white",
            background: "blue"
        },
        "@light": {
            color: "white",
            background: "gradient-blue"
        }
    },
    secondary: {
        "@dark": {
            color: "white",
            background: "gray"
        },
        "@light": {
            color: "white",
            background: "gray"
        }
    },
    tertiary: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        }
    },
    quaternary: {
        "@light": {
            color: "white",
            background: "gradient-light"
        },
        "@dark": {
            color: "white",
            background: "gradient-dark-active"
        }
    },
    quinary: {
        "@dark": {
            color: "gray=90",
            background: "gradient-light"
        },
        "@light": {
            color: "gray3",
            background: "gradient-dark"
        }
    }
}, Py = {
    alert: {
        "@dark": {
            color: "white",
            background: "red"
        }
    },
    warning: {
        "@dark": {
            color: "black",
            background: "yellow"
        }
    },
    success: {
        "@dark": {
            color: "black",
            background: "green"
        }
    }
}, Ny = {
    field: {
        "@light": {
            color: "black",
            background: "gray.975+144",
            borderColor: "gray.975+144",
            "::placeholder": {
                color: "gray-68"
            }
        },
        "@dark": {
            color: "white",
            background: "gray.975-52",
            borderColor: "gray.975-52",
            "::placeholder": {
                color: "gray+68"
            }
        }
    },
    label: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        }
    },
    dialog: {
        "@dark": {
            color: "white",
            background: "gray.92"
        },
        "@light": {
            color: "currentColor",
            background: "gray.1"
        }
    }
}, lu = {
    document: {
        "@light": {
            color: "black",
            background: "white"
        },
        "@dark": {
            color: "white",
            background: "black"
        }
    },
    ...Iy,
    ...Py,
    ...Ny,
    none: {
        color: "none",
        background: "none"
    },
    transparent: {
        color: "currentColor",
        background: "transparent"
    }
};
var fu = {
    base: 16,
    ratio: 1.25,
    subSequence: !0,
    templates: {}
};
var uu = {
    ratio: 1.618,
    subSequence: !0
};
var pu = {}, du = {
    system: {
        value: [
            '"Helvetica Neue"',
            "Helvetica",
            "Arial"
        ],
        type: "sans-serif"
    }
};
var hu = {
    tv: "(min-width: 2780px)",
    screenL: "(max-width: 1920px)",
    "screenL<": "(min-width: 1920px)",
    screenM: "(max-width: 1680px)",
    "screenM<": "(min-width: 1680px)",
    screenS: "(max-width: 1440px)",
    "screenS<": "(min-width: 1440px)",
    tabletL: "(max-width: 1366px)",
    "tabletL<": "(min-width: 1366px)",
    tabletM: "(max-width: 1280px)",
    "tabletM<": "(min-width: 1280px)",
    tabletS: "(max-width: 1024px)",
    "tabletS<": "(min-width: 1024px)",
    mobileL: "(max-width: 768px)",
    "mobileL<": "(min-width: 768px)",
    mobileM: "(max-width: 560px)",
    "mobileM<": "(min-width: 560px)",
    mobileS: "(max-width: 480px)",
    "mobileS<": "(min-width: 480px)",
    mobileXS: "(max-width: 375px)",
    "mobileXS<": "(min-width: 375px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var mu = {
    base: 150,
    ratio: 1.333,
    unit: "ms",
    subSequence: !0
};
var Fa = {
    version: "0.0.1",
    color: au,
    gradient: cu,
    theme: lu,
    typography: fu,
    spacing: uu,
    font: pu,
    font_family: du,
    timing: mu,
    media: hu,
    reset: {
        html: {},
        body: {}
    },
    animation: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    devices: {},
    class: {},
    svg: {},
    grid: {},
    shape: {}
};
var Be = {};
Bt(Be, {
    A: ()=>HS,
    Avatar: ()=>ix,
    B: ()=>yb,
    Block: ()=>Dy,
    Box: ()=>La,
    Br: ()=>wb,
    Button: ()=>KS,
    ButtonSet: ()=>JS,
    Caption: ()=>cb,
    Checkbox: ()=>Ib,
    CheckboxHgroup: ()=>Pb,
    CircleButton: ()=>QS,
    Clickable: ()=>Wy,
    Data: ()=>Sb,
    Dialog: ()=>tx,
    DialogFooter: ()=>rx,
    DialogHeader: ()=>ex,
    DropdownList: ()=>cx,
    DropdownParent: ()=>lx,
    DropdownParentFocus: ()=>fx,
    DropdownSiblingFocus: ()=>ux,
    FileIcon: ()=>jb,
    Flex: ()=>$y,
    Focusable: ()=>Gy,
    FocusableComponent: ()=>Ky,
    Footnote: ()=>gb,
    Form: ()=>Vy,
    Grid: ()=>My,
    Gutter: ()=>Uy,
    H1: ()=>eb,
    H2: ()=>rb,
    H3: ()=>nb,
    H4: ()=>ob,
    H5: ()=>sb,
    H6: ()=>ib,
    Headline: ()=>hb,
    Hgroup: ()=>kb,
    HgroupButton: ()=>Ab,
    HgroupRows: ()=>Ob,
    Hoverable: ()=>Hy,
    Hr: ()=>_b,
    I: ()=>bb,
    Icon: ()=>Bb,
    IconButton: ()=>ZS,
    IconText: ()=>Ub,
    Iframe: ()=>qy,
    Img: ()=>jy,
    Inline: ()=>Fy,
    InlineFlex: ()=>Ly,
    InlineGrid: ()=>By,
    Input: ()=>Tb,
    Italic: ()=>pb,
    KangorooButton: ()=>XS,
    Li: ()=>vb,
    Link: ()=>tp,
    Notification: ()=>px,
    NumberInput: ()=>Rb,
    Ol: ()=>Eb,
    P: ()=>ab,
    Picture: ()=>Xy,
    Radio: ()=>Nb,
    RadioHgroup: ()=>Db,
    Range: ()=>ax,
    RouteLink: ()=>WS,
    RouterLink: ()=>ep,
    SHAPES: ()=>Yy,
    Select: ()=>GS,
    SquareButton: ()=>YS,
    Strong: ()=>lb,
    Subhead: ()=>mb,
    Svg: ()=>Jy,
    Text: ()=>tb,
    Textarea: ()=>Lb,
    TextareaWithButton: ()=>Mb,
    Theme: ()=>Qy,
    Title: ()=>db,
    Toggle: ()=>Fb,
    ToggleHgroup: ()=>$b,
    Tooltip: ()=>nx,
    TooltipHidden: ()=>ox,
    TooltipParent: ()=>sx,
    U: ()=>fb,
    Ul: ()=>Cb,
    Underline: ()=>ub,
    Video: ()=>Zy,
    depth: ()=>$a,
    getSystemGlobalTheme: ()=>vo
});
var Dy = {
    display: "block"
}, Fy = {
    display: "inline"
}, $y = {
    display: "flex"
}, Ly = {
    display: "inline-flex"
}, My = {
    display: "grid"
}, By = {
    display: "inline-grid"
}, Uy = {
    boxSize: "C1"
};
var jy = {
    tag: "img",
    attr: {
        title: ({ props: t })=>t.title || t.alt
    }
};
var Vy = {
    tag: "form"
};
var qy = {
    tag: "iframe",
    position: "relative",
    minWidth: "H",
    minHeight: "H"
};
var zy = {
    appearance: "none",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit"
}, Hy = {
    transition: "C defaultBezier",
    transitionProperty: "opacity, transform",
    opacity: .85,
    ":hover": {
        opacity: .9,
        transform: "scale(1.015)"
    },
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1,
        transform: "scale(1.015)",
        ":hover": {
            opacity: 1
        }
    }
}, Wy = {
    extends: "Hoverable",
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1
    }
}, Gy = {
    border: "none",
    outline: "solid 0 blue.3",
    ":focus-visible": {
        opacity: 1,
        outline: "solid X blue.3"
    },
    attr: {
        tabIndex: ({ props: t })=>t.tabIndex
    }
}, Ky = {
    extends: "Focusable",
    tag: "button",
    fontSize: "A",
    type: "button",
    border: "none",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    style: zy
};
var gu = {
    transition: (t)=>({
            transition: _o(t)
        }),
    transitionDuration: (t)=>({
            transitionDuration: wr(t)
        }),
    transitionDelay: (t)=>({
            transitionDelay: wr(t)
        }),
    transitionTimingFunction: (t)=>({
            transitionTimingFunction: Ft(t)
        }),
    transitionProperty: (t)=>({
            transitionProperty: t,
            willChange: t
        })
};
var Lt = E(), $a = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${Lt.UNIT.default} 4${Lt.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${Lt.UNIT.default} 6${Lt.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${Lt.UNIT.default} 10${Lt.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${Lt.UNIT.default} 16${Lt.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${Lt.UNIT.default} 26${Lt.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${Lt.UNIT.default} 42${Lt.UNIT.default}`
    }
}, vr = ({ props: t })=>X(t.shapeDirectionColor) || X(t.borderColor) || X(t.backgroundColor) || X(t.background), wo = ({ props: t, deps: e })=>{
    let r = gu.transition(t.transition, {
        props: t,
        deps: e
    });
    return r && r.transition;
}, Yy = {
    rectangle: {},
    circle: {
        borderRadius: "100%"
    },
    bubble: {},
    tv: {
        borderRadius: "1.15em/2.5em"
    },
    tooltip: ({ props: t, deps: e })=>({
            position: t.position || "relative",
            "&:before": {
                content: '""',
                display: "block",
                width: "0px",
                height: "0px",
                border: ".35em solid",
                borderColor: vr({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "border-color",
                position: "absolute",
                borderRadius: ".15em"
            }
        }),
    tooltipDirection: {
        top: {
            "&:before": {
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                right: "0",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                left: "0",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        }
    },
    tag: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before": {
                content: '""',
                display: "block",
                background: vr({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background",
                borderRadius: ".25em",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%"
            }
        }),
    tagDirection: {
        top: {
            "&:before": {
                bottom: "100%",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                left: "100%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                right: "100%",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        }
    },
    hexagon: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                borderRadius: ".25em",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%",
                background: vr({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background"
            },
            "&:before": {
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            },
            "&:after": {
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }),
    chevron: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background"
            },
            "&:before": {
                background: `linear-gradient(225deg, ${vr({
                    props: t,
                    deps: e
                })} 25%, transparent 25%), linear-gradient(315deg, ${vr({
                    props: t,
                    deps: e
                })} 25%, transparent 25%)`
            },
            "&:after": {
                background: vr({
                    props: t,
                    deps: e
                }),
                borderRadius: ".25em"
            }
        }),
    chevronDirection: {
        left: {
            "&:before": {
                height: "100%",
                left: "100%",
                transform: "translate3d(-1%, -50%, 1px) scale(-1, 1)"
            },
            "&:after": {
                height: "73%",
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                height: "100%",
                left: "0",
                transform: "translate3d(-99%, -50%, 1px)"
            },
            "&:after": {
                height: "73%",
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }
    }
};
v();
var vo = ({ context: t, state: e })=>{
    let r = e && e.root, n = r && r.globalTheme || t.designSystem && t.designSystem.globalTheme;
    return n === "auto" ? null : n;
}, Qy = {
    deps: {
        depth: $a
    },
    classlist: {
        depth: ({ props: t, deps: e })=>!K(t.depth) && e.depth[t.depth]
    }
};
var Xy = {
    deps: {
        getSystemGlobalTheme: vo
    },
    tag: "picture",
    childExtends: {
        deps: {
            getSystemGlobalTheme: vo
        },
        tag: "source",
        attr: {
            media: (t)=>{
                let { props: e, key: r, context: n, deps: o } = t, { media: s } = n.designSystem, i = o.getSystemGlobalTheme(t), a = (e.media || r).slice(1);
                return a === i ? "(min-width: 0px)" : a === "dark" || a === "light" ? "(max-width: 0px)" : s[a];
            }
        }
    },
    Img: {
        width: "inherit",
        ignoreChildExtends: !0,
        height: "inherit",
        src: (t, e)=>t.parent?.props?.src || t.parent?.src || e.src
    }
};
var Jy = {
    tag: "svg",
    attr: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    html: (t)=>{
        let { props: e, context: r } = t;
        if (e.semantic_symbols) return;
        if (e.html) return t.call("exec", e.html, t);
        let { designSystem: n, utils: o } = r, s = n && n.svg, i = e.spriteId || r.designSystem && r.designSystem.useSvgSprite, a = t.call("exec", e.src, t);
        if (!i && a) return a;
        let c = (p)=>`<use xlink:href="#${p}" />`, f = e.spriteId;
        if (f) return c(f);
        if (s && s[a]) return c(a);
        let l = Symbol.for(a), u = s[l];
        return u && s[u] || (u = s[l] = Math.random(), a && o.init({
            svg: {
                [u]: a
            }
        }, {
            document: r.document,
            emotion: r.emotion
        })), c(u);
    }
};
var Zy = {
    tag: "video",
    controls: !0,
    childExtends: {
        tag: "source"
    }
};
var tb = {}, eb = {
    tag: "h1"
}, rb = {
    tag: "h2"
}, nb = {
    tag: "h3"
}, ob = {
    tag: "h4"
}, sb = {
    tag: "h5"
}, ib = {
    tag: "h6"
}, ab = {
    tag: "p"
}, cb = {
    tag: "caption"
}, lb = {
    tag: "strong",
    fontWeight: "700"
}, fb = {
    tag: "u"
}, ub = {
    tag: "u"
}, pb = {
    tag: "i"
}, db = {}, hb = {
    tag: "h6",
    fontSize: "B",
    fontWeight: 500
}, mb = {
    tag: "span",
    fontSize: "Z1"
}, gb = {
    tag: "span",
    fontSize: "Z"
}, yb = {
    tag: "b"
}, bb = {
    tag: "i"
}, Sb = {
    tag: "data"
};
var xb = (t)=>{
    if (!t.context) return;
    let { props: e, __ref: r } = t, n = Qt(e, t, {
        unpack: !1
    });
    r.__class = n;
}, La = {
    extends: [
        "Shape",
        "Theme"
    ],
    boxSizing: "border-box",
    onBeforeClassAssign: xb
}, _b = {
    tag: "hr",
    margin: "C1 0"
}, wb = {
    tag: "br"
}, vb = {
    tag: "li"
}, Cb = {
    tag: "ul",
    childExtends: {
        extends: "Li"
    }
}, Eb = {
    tag: "ol",
    childExtends: {
        extends: "Li"
    }
};
var kb = {
    display: "flex",
    tag: "hgroup",
    flow: "y",
    gap: "Y2",
    H: {
        color: "title",
        tag: "h3",
        lineHeight: "1em",
        margin: "0"
    },
    P: {
        margin: "0",
        color: "paragraph"
    }
}, Ob = {
    extends: "Hgroup",
    H: {
        display: "flex",
        color: "title",
        align: "center space-between"
    },
    P: {
        color: "paragraph",
        align: "center space-between"
    }
}, Ab = {
    extends: "HgroupRows",
    H: {
        justifyContent: "space-between",
        Span: {},
        Button: {
            background: "transparent",
            color: "currentColor",
            padding: "0",
            Icon: {
                name: "x",
                fontSize: "C"
            }
        }
    },
    P: {}
};
var Tb = {
    extends: [
        "Focusable"
    ],
    tag: "input",
    border: "none",
    type: "input",
    theme: "field",
    fontSize: "A",
    round: "C",
    lineHeight: "1",
    padding: "Z2 B",
    attr: {
        pattern: ({ props: t })=>t.pattern,
        minLength: ({ props: t })=>t.minlength,
        maxLength: ({ props: t })=>t.maxlength,
        name: ({ props: t })=>t.name,
        autocomplete: ({ props: t })=>t.autocomplete,
        placeholder: ({ props: t })=>t.placeholder,
        value: (t)=>{
            if (!t.props || !t.props.value) return;
            let e = t.call("exec", t.props.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        },
        checked: (t)=>t.call("exec", t.props.checked, t),
        disabled: ({ props: t })=>t.disabled || null,
        readonly: ({ props: t })=>t.readonly,
        required: ({ props: t })=>t.required,
        type: ({ props: t })=>t.type
    }
};
var Rb = {
    extends: [
        "Flex",
        "Input"
    ],
    type: "number",
    boxSize: "C+X",
    align: "center center",
    textAlign: "center",
    round: "Y1",
    theme: "transparent",
    border: "solid gray3",
    borderWidth: "1px",
    placeholder: "0",
    fontWeight: "400",
    "::-webkit-inner-spin-button": {
        appearance: "none"
    },
    attr: {
        step: ({ props: t })=>t.step,
        min: ({ props: t })=>t.min,
        max: ({ props: t })=>t.max
    }
};
var Ib = {
    extends: "Focusable",
    tag: "label",
    boxSize: "fit-content fit-content",
    cursor: "pointer",
    round: "Y",
    Input: {
        type: "checkbox",
        display: "none",
        ":checked + div": {
            theme: "primary"
        },
        ":checked + div > svg": {
            transform: "none",
            opacity: "1"
        },
        attr: {
            checked: (t)=>t.call("exec", t.parent.props.checked)
        }
    },
    Flex: {
        align: "center center",
        fontSize: "B1",
        padding: "V",
        theme: "field",
        round: "X2",
        transition: "background A defaultBezier",
        Icon: {
            icon: "check",
            opacity: "0",
            transform: "scale(0.9) rotate(-15deg)",
            transition: "opacity B defaultBezier"
        }
    }
}, Pb = {
    display: "flex",
    tag: "label",
    boxSize: "fit-content",
    align: "flex-start flex-start",
    gap: "A",
    Checkbox: {
        tag: "div"
    },
    HgroupRows: {
        gap: "Z1",
        margin: "Y - - -"
    }
};
var Nb = {
    extends: "Checkbox",
    Input: {
        type: "radio",
        ":checked + div:after": {
            opacity: "1"
        }
    },
    Flex: {
        round: "100%",
        padding: "Y",
        ":after": {
            content: '""',
            display: "block",
            boxSize: "X+W1",
            round: "100%",
            background: "white",
            opacity: "0",
            transition: "opacity .15s ease-in-out"
        },
        Icon: null
    }
}, Db = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Radio: {}
};
var Fb = {
    extends: "Checkbox",
    Input: {
        ":checked + div": {
            background: "green2+8",
            justifyContent: "flex-end"
        }
    },
    Flex: {
        boxSize: "A1 B1",
        padding: "- W_default",
        round: "D",
        align: "center flex-start",
        theme: "field",
        border: "none",
        transition: "opacity .15s ease",
        ":after": {
            content: '""',
            boxSize: "A A",
            round: "100%",
            background: "white",
            boxShadow: "gray.2 1px 1px Z"
        },
        Icon: null
    }
}, $b = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Toggle: {}
};
var Lb = {
    tag: "textarea",
    extends: [
        "Input",
        "Flex"
    ],
    fontfamily: "Avenir",
    placeholder: "Leave us a message...",
    padding: "A",
    theme: "field",
    border: "none",
    minHeight: "E_default",
    width: "100%",
    height: "E1_default",
    fontFamily: "inherit",
    round: "Z2",
    lineHeight: 1.4,
    ".outlined": {
        borderWidth: "1px",
        borderStyle: "solid"
    },
    html: (t, e)=>t.props.value
}, Mb = {
    display: "flex",
    gap: "Y2",
    Textarea: {
        height: "C2+W",
        minWidth: "H",
        padding: "A",
        fontSize: "Z1",
        round: "Z2",
        minHeight: "fit-content"
    },
    SquareButton: {
        background: "blue",
        Icon: {
            name: "send"
        }
    }
};
var Bb = {
    extends: "Svg",
    width: "A",
    height: "A",
    display: "inline-block",
    style: {
        fill: "currentColor",
        "*": {
            fill: "currentColor"
        }
    },
    props: (t, e, r)=>{
        let { props: n, parent: o } = t, { icons: s, useIconSprite: i, verbose: a } = r && r.designSystem, { toCamelCase: c } = r && r.utils, f = (A)=>{
            let { props: k } = A, L = k[".isActive"];
            if (L) return A.call("exec", L.name || L.icon);
        }, l = (A, k, L)=>{
            let { semanticIcons: P } = L && L.designSystem, { toCamelCase: F } = L && L.utils, U = u(A, k), tt = F(U).split(/([a-z])([A-Z])/g), pt = tt[1] ? tt[0] : U.split(".")[0].split(" ")[0], _t = P && P[pt];
            if (_t) {
                let Mt = U.includes(".") ? "sfsymbols." + U.split(".").slice(1).join(".") : "sfsymbols";
                return U = _t[Mt] || _t[U.split(".")[0].split(" ")[0]], {
                    tag: "span",
                    semantic_symbols: !0,
                    width: "A",
                    height: "A",
                    lineHeight: "1em",
                    ":after": {
                        fontSize: "Z",
                        fontWeight: "300",
                        content: `"${U}"`,
                        textAlign: "center",
                        display: "inline-block",
                        style: {
                            color: "currentColor",
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        }, u = (A, k)=>{
            let { key: L, props: P } = A, F = A.call("exec", P.name || P.icon || L, A);
            return A.call("isString", F) && F.includes("{{") && (F = A.call("replaceLiteralsWithObjectFields", F)), A.call("isString", F) ? F : L;
        }, p = u(t, e), h = c(p), d = h.split(/([a-z])([A-Z])/g), m = l(t, e, r);
        if (m) return m;
        let S;
        n.isActive && (S = f(t));
        let x = o.props, w = x[".isActive"];
        o && x && x.isActive && w && w.icon && (S = t.call("exec", w.icon || w.Icon.name || w.Icon.icon, t)), t.call("isString", S) && S.includes("{{") && (S = t.call("replaceLiteralsWithObjectFields", S));
        let C;
        s[S] && (C = S), s[h] ? C = h : s[d[0] + d[1]] ? C = d[0] + d[1] : s[d[0]] ? C = d[0] : a && t.warn("Can't find icon:", p, C);
        let R = s[C], T = o && o.props && o.props.src || n.src;
        return {
            spriteId: i && C,
            src: R || T || s.noIcon
        };
    },
    attr: {
        viewBox: "0 0 24 24"
    }
}, Ub = {
    display: "flex",
    align: "center center",
    lineHeight: 1,
    ".reversed": {
        flow: "row-reverse"
    },
    ".vertical": {
        flow: "column"
    },
    Icon: {
        if: (t)=>{
            let { parent: e, props: r } = t;
            return t.call("exec", e.props.icon || r.name || r.sfSymbols || e.props.sfSymbols, t);
        },
        icon: (t)=>t.call("exec", t.parent.props.icon, t.parent)
    },
    text: ({ props: t })=>t.text
}, jb = {
    display: "flex",
    theme: "tertiary",
    boxSize: "C1",
    align: "center center",
    round: "Z",
    Icon: {
        fontSize: "B",
        margin: "auto",
        icon: "file"
    }
};
var tc = {};
Bt(tc, {
    default: ()=>zS,
    getActiveRoute: ()=>Za,
    lastLevel: ()=>No,
    lastPathname: ()=>Po,
    matchRoute: ()=>Qa,
    parseQuery: ()=>Xa,
    parseRoutePattern: ()=>Ya,
    router: ()=>oe,
    runGuards: ()=>Ja
});
v();
v();
v();
v();
v();
var Vb = (t, e)=>{
    let r = e.on?.[t];
    if (r) return r;
    let n = e.props;
    if (!n) return;
    let o = "on" + t.charAt(0).toUpperCase() + t.slice(1);
    return n[o];
}, qb = (t, e, r, n)=>{
    let o = Ye(Vb(t, e), e);
    if (y(o)) {
        let { __ref: s } = e;
        s.__eventListeners || (s.__eventListeners = {}), s.__eventListeners[t] && r.removeEventListener(t, s.__eventListeners[t]);
        let i = (a)=>{
            let { state: c, context: f } = e;
            try {
                let l = o.call(e, a, e, c, f, n);
                l && typeof l.then == "function" && l.catch((u)=>{
                    e.error = u, console.error("[DOMQL] Async DOM event error:", u);
                });
            } catch (l) {
                if (e.error = l, console.error("[DOMQL] DOM event error:", l), f?.strictMode) throw l;
            }
        };
        s.__eventListeners[t] = i, r.addEventListener(t, i);
    }
}, yu = (t, e)=>{
    let { node: r, on: n } = t;
    for(let o in n)ls.has(o) || qb(o, t, r, e);
};
var bu = {
    en: {
        DocumentNotDefined: {
            title: "Document is undefined",
            description: "To tweak with DOM, you should use browser."
        },
        OverwriteToBuiltin: {
            title: "Overwriting to builtin method",
            description: "Overwriting a builtin method in the window define is not possible, please choose different name"
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: "Environment should be browser application, that can run Javascript"
        },
        SetQuickPreferancesIsNotObject: {
            title: "Quick preferances object is required",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: "Params are invalid",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: "You must provide node",
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: "Element tag name (or DOM nodeName) is invalid",
            description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
        },
        HTMLInvalidAttr: {
            title: "Attibutes object is invalid",
            description: "Please pass a valid plain object to apply as an attributes for a DOM node"
        },
        HTMLInvalidData: {
            title: "Data object is invalid",
            description: "Please pass a valid plain object to apply as an dataset for a DOM node"
        },
        HTMLInvalidStyles: {
            title: "Styles object is invalid",
            description: "Please pass a valid plain object to apply as an style for a DOM node"
        },
        HTMLInvalidText: {
            title: "Text string is invalid",
            description: "Please pass a valid string to apply text to DOM node"
        },
        ElementOnStateIsNotDefined: {
            title: "Element on state is not defined",
            description: "Please check the element object"
        }
    }
}, gt = (t, e, r)=>{
    let o;
    t && typeof t == "string" && (o = bu.en[t]);
    let s = o ? `

${o.description}` : "", i = r ? `

${r}` : "";
    return new Error(`"${t}", "${e}"${s}${i}`);
};
v();
var Su = (t)=>ke(t || "div") || gt("HTMLInvalidTag");
var zb = (t)=>{
    if (!t || !t.__ref) throw new Error("Element reference is invalid");
    let { __ref: e } = t;
    if (!e.root) throw new Error("Root reference is invalid");
    if (!e.root.data) throw new Error("Data are undefined");
    let { frameListeners: r } = e.root.data;
    r && !r.has(t) && r.add(t);
}, Hb = (t)=>{
    for (let e of t){
        if (!e.__ref.__frameHandler) {
            let r = e.on?.frame || e.onFrame || e.props?.onFrame;
            if (r) e.__ref.__frameHandler = r;
            else {
                t.delete(e);
                continue;
            }
        }
        if (!e.node?.parentNode) t.delete(e), delete e.__ref.__frameHandler;
        else try {
            e.__ref.__frameHandler(e, e.state, e.context);
        } catch (r) {
            console.warn(r), t.delete(e), delete e.__ref.__frameHandler;
        }
    }
}, xu = (t)=>{
    let e = typeof window < "u" && window.requestAnimationFrame;
    if (Ma || !e) return;
    Ma = !0;
    function r() {
        if (t.size === 0) {
            Ma = !1;
            return;
        }
        Hb(t), e(r);
    }
    e(r);
}, _u = (t)=>{
    if (!t) throw new Error("Element is invalid");
    let { on: e, props: r, __ref: n } = t;
    if (!n.root || !n.root.data) return;
    let { frameListeners: o } = n.root.data;
    o && (e?.frame || t.onFrame || r?.onFrame) && (zb(t), xu(o));
}, Ma = !1, wu = ()=>{
    let t = new Set;
    return xu(t), t;
};
v();
var vu = (t)=>{
    let { props: e, on: r } = t;
    for(let n in e){
        if (n.charCodeAt(0) !== 111 || n.charCodeAt(1) !== 110) continue;
        let o = ce(n.slice(2)), s = r[o], i = e[n];
        y(s) ? r[o] = (...a)=>{
            if (s(...a) !== !1 && y(i)) return i(...a);
        } : r[o] = i;
    }
}, Cu = (t)=>{
    let { on: e } = t, r = Ke(t.context);
    for(let n in t){
        if (n.charCodeAt(0) !== 111 || n.charCodeAt(1) !== 110 || !Object.prototype.hasOwnProperty.call(t, n)) continue;
        let o = t[n];
        if (!y(o) && !(r && o != null)) continue;
        let s = ce(n.slice(2)), i = e[s];
        y(i) ? e[s] = (...a)=>{
            if (i(...a) !== !1 && y(o)) return o(...a);
        } : e[s] = o;
    }
};
v();
var Ba = "http://www.w3.org/2000/svg", Wb = (t)=>{
    let { tag: e, context: r } = t, n = r.document || z;
    return e ? e === "string" ? n.createTextNode(t.text) : e === "fragment" ? n.createDocumentFragment() : Qe.has(e) && (e === "svg" || t.parent?.node?.namespaceURI === Ba) ? n.createElementNS(Ba, e) : n.createElement(e) : n.createElement("div");
}, Ua = (t)=>{
    let { tag: e, key: r, props: n } = t;
    if (e = O(e, t), e === !0 && (e = r), g(n) && b(n.tag) && ke(n.tag)) return n.tag;
    if (b(e)) {
        if (ke(e)) return e;
    } else {
        let o = r.toLowerCase();
        if (o.includes(".") && (o = o.split(".")[0]), o.includes("_") && (o = o.split("_")[0]), ke(o)) return o;
    }
    return "div";
}, Eu = (t)=>{
    let { context: e } = t, r = e.window || window, n = t.tag = Ua(t);
    if (!Su(n)) return gt("HTMLInvalidTag", t.tag, t);
    r.nodeCaches || (r.nodeCaches = {});
    let s = Qe.has(n) && (n === "svg" || t.parent?.node?.namespaceURI === Ba) ? "svg:" + n : n, i = r.nodeCaches[s];
    i || (i = r.nodeCaches[s] = Wb(t));
    let a = i.cloneNode(!0);
    return n === "string" && (a.nodeValue = t.text), a;
};
var Gb = (t, e)=>{
    try {
        return e.appendChild(t), t;
    } catch  {
        console.error("Does not support to append", e, t);
    }
}, Kb = (t, e, r)=>{
    if (!t) throw new Error("Node is required");
    let n = r || e?.parentNode;
    e?.nextSibling ? n?.insertBefore(t, e.nextSibling) : e?.insertAdjacentElement ? e.insertAdjacentElement("afterend", t) : n?.insertBefore(t, e);
}, Yb = (t, e, r)=>{
    if (!t) throw new Error("Node is required");
    (r || e.parentNode)?.insertBefore(t, e);
}, ja = (t, e, r, n)=>{
    if (!t) throw new Error("Element is required");
    if (!e) throw new Error("Parent is required");
    return e[r || t.key] = t, t.tag !== "shadow" && (n && n.position ? (n.position === "before" ? Yb : Kb)(t.node, n.node || e.node) : Gb(t.node, e.node, t)), t;
};
v();
var Co = (t, e = {})=>{
    let { __ref: r } = t;
    for(let n in t){
        if (e[n]) continue;
        let o = t[n];
        if (y(o) && !Ht(n, t)) {
            r.__exec[n] = o;
            try {
                let s = o(t, t.state, t.context);
                s && typeof s.then == "function" ? s.then((i)=>{
                    t[n] = i;
                }).catch((i)=>{
                    console.warn("[DOMQL] Async exec error in", n, ":", i?.message || i);
                }) : t[n] = s;
            } catch (s) {
                console.warn("[DOMQL] Exec error in", n, ":", s?.message || s);
            }
        }
    }
}, ku = (t, e = {})=>{
    let { __ref: r } = t, n = {};
    for(let o in r.__exec){
        let s = t[o];
        if (r.__defineCache[o]) continue;
        let a = r.__exec[o](t, t.state, t.context);
        if (a && typeof a.then == "function") {
            a.then((f)=>{
                t[o] = f;
            });
            continue;
        }
        let c = b(a) || ct(a);
        if (s?.node && c) fe(s, {
            text: a
        });
        else if (a !== s) {
            if (It(o)) {
                let { extends: f, ...l } = $s(a, t, o);
                fe(s, l);
            } else n[o] = s, t[o] = a;
        }
    }
    return n;
}, Eo = (t)=>{
    let { __ref: e } = t, { props: r } = t;
    for(let n in r){
        let o = n.charCodeAt(0), s = n.charCodeAt(1), i = o === 105 && s === 115 || o === 104 && s === 97 && n.charCodeAt(2) === 115 || o === 117 && s === 115 && n.charCodeAt(2) === 101, a = e.__execProps[n];
        if (y(a)) {
            let c = O(a, t);
            c && typeof c.then == "function" ? c.then((f)=>{
                r[n] = f;
            }) : r[n] = c;
        } else if (i && y(r[n])) {
            e.__execProps[n] = r[n];
            let c = O(r[n], t);
            c && typeof c.then == "function" ? c.then((f)=>{
                r[n] = f;
            }) : r[n] = c;
        }
    }
}, ko = (t)=>{
    let { define: e, context: r, __ref: n } = t, o = g(e), s = r && g(r.define);
    if (!o && !s) return t;
    let i = o && s ? {
        ...e,
        ...r.define
    } : o ? e : r.define;
    for(let a in i){
        let c = t[a];
        if (y(c) && !Ht(a, t)) {
            n.__exec[a] = c;
            let l = O(c, t);
            l && typeof l.then == "function" ? l.then((u)=>{
                c = t[a] = u && u.parse ? u.parse() : u, u && (n.__defineCache[a] = c);
            }) : (c = t[a] = l && l.parse ? l.parse() : l, l && (n.__defineCache[a] = c));
        }
        let f = i[a](c, t, t.state, t.context);
        f && typeof f.then == "function" ? f.then((l)=>{
            l && (t[a] = l);
        }) : f && (t[a] = f);
    }
    return t;
}, Ou = (t)=>{
    let { context: e, define: r, __ref: n } = t, o = g(r), s = g(e?.define);
    if (!o && !s) return;
    let i = o && s ? {
        ...r,
        ...e.define
    } : o ? r : e.define;
    for(let a in i){
        let c = n.__exec[a];
        if (c) {
            let u = c(t, t.state, t.context);
            u && typeof u.then == "function" ? u.then((p)=>{
                n.__defineCache[a] = p;
            }) : n.__defineCache[a] = u;
        }
        let f = O(n.__defineCache[a], t);
        if (f && typeof f.then == "function") {
            f.then((u)=>{});
            continue;
        }
        let l = typeof i[a] == "function" ? i[a](f, t, t.state, t.context) : void 0;
        l && typeof l.then == "function" ? l.then((u)=>{
            t[a] = u;
        }) : l && (t[a] = l);
    }
};
v();
function Au(t, e, r) {
    let { __ref: n, props: o } = e, { __attr: s } = n;
    if (Dr(t)("object") && gt("HTMLInvalidAttr", t), t) {
        let i = O(t, e);
        o.attr && H(i, o.attr);
        for(let a in i){
            let c = O(i[a], e);
            b(c) && c.includes("{{") && e.call && (c = e.call("replaceLiteralsWithObjectFields", c, e.state)), c !== s[a] && (c !== !1 && c !== void 0 && c !== null && r.setAttribute ? r.setAttribute(a, c) : r.removeAttribute && r.removeAttribute(a), s[a] = c);
        }
    }
}
v();
var Tu = (t)=>{
    let { key: e } = t;
    t.classlist === !0 ? t.classlist = e : !t.classlist && typeof e == "string" && e.charAt(0) === "_" && e.charAt(1) !== "_" && (t.classlist = e.slice(1));
}, Qb = (t, e)=>{
    let r = "";
    for(let n in t){
        let o = t[n];
        typeof o == "boolean" && o ? r += ` ${n}` : typeof o == "string" ? r += ` ${o}` : typeof o == "function" && (r += ` ${O(o, e)}`);
    }
    return r;
}, Ru = (t, e)=>{
    if (!t) return;
    let { key: r } = e;
    return t === !0 && (t = e.classlist = {
        key: r
    }), b(t) && (t = e.classlist = {
        default: t
    }), g(t) && (t = Qb(t, e)), t.replace(/\s+/g, " ").trim();
};
v();
function Xb(t, e, r) {
    if (t && (e.props.data && H(t, e.props.data), t.showOnNode)) {
        g(t) || gt("HTMLInvalidData", t);
        for(let n in t)n !== "showOnNode" && (r.dataset[n] = O(t[n], e));
    }
}
var Iu = Xb;
v();
function Jb(t, e, r) {
    let n = O(t ?? e?.props?.html, e), { __ref: o } = e;
    n !== o.__html && (r.nodeName === "SVG" ? r.textContent = n : r.innerHTML = n, o.__html = n);
}
var Pu = Jb;
v();
function Zb(t, e, r) {
    if (t) {
        if (g(t)) {
            let { __ref: n } = e;
            n.__style || (n.__style = {});
            let o = n.__style;
            for(let s in t){
                let i = O(t[s], e);
                i !== o[s] && (o[s] = i, r.style[s] = i);
            }
        } else gt("HTMLInvalidStyles", t);
    }
}
var Nu = Zb;
v();
function tS(t, e, r) {
    let n = O(e.props.text || t, e);
    if (y(n) && (n = O(n, e)), b(n) && n.includes("{{") && (n = e.call("replaceLiteralsWithObjectFields", n, e.state)), e.tag === "string") r.nodeValue = n;
    else if (t != null) {
        if (Qe.has(e.tag)) {
            r && (r.textContent = n);
            return;
        }
        if (e.__text) {
            if (e.__text.text === n) return;
            e.__text.text = n, e.__text.node && (e.__text.node.nodeValue = n);
        } else Vt({
            tag: "string",
            text: n
        }, e, "__text");
    }
}
var Du = tS;
v();
function eS(t, e, r) {
    let n = O(t, e);
    if (g(n)) for(let o in n)Tt.has(o) || Object.prototype.hasOwnProperty.call(n, o);
    return e;
}
var Fu = eS;
v();
function rS(t, e, r) {
    if (g(t)) for(let n in t){
        let o = t[n];
        y(o) ? e.scope[n] = o.bind(e) : e.scope[n] = o;
    }
}
var $u = rS;
var ne = {
    attr: Au,
    style: Nu,
    text: Du,
    html: Pu,
    data: Iu,
    classlist: Ru,
    state: Fu,
    scope: $u,
    fetch: {},
    deps: (t, e)=>t || e.parent.deps,
    extends: {},
    children: {},
    content: {},
    childExtend: {},
    childExtends: {},
    childExtendRecursive: {},
    childExtendsRecursive: {},
    props: {},
    if: {},
    define: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    variables: {},
    on: {},
    component: {},
    context: {}
};
v();
var Oo = (t, e, r)=>{
    let { node: n, context: o, __ref: s } = e, i = O(e[t], e), { onlyUpdate: a } = r, c = ne[t], l = o?.registry?.[t] || c, u = e.define?.[t], p = o?.define?.[t];
    if (!s.__if) return;
    let h = a ? a === t || e.lookup(a) : !0;
    if (l && !p && h) {
        y(l) && l(i, e, n, r);
        return;
    }
    return {
        hasDefine: u,
        hasContextDefine: p
    };
};
v();
var Va = (t, e)=>{
    if (t === e) return !0;
    if (!t || !e) return !1;
    let r = typeof t, n = typeof e;
    if (r === "function" && n === "function") return !0;
    if (r !== n) return !1;
    if (_(t) && _(e)) {
        if (t.length !== e.length) return !1;
        for(let o = 0; o < t.length; o++)if (!Va(t[o], e[o])) return !1;
        return !0;
    }
    if (g(t) && g(e)) {
        let o = Object.keys(t), s = Object.keys(e);
        if (o.length !== s.length) return !1;
        for(let i = 0; i < o.length; i++){
            let a = o[i];
            if (!Va(t[a], e[a])) return !1;
        }
        return !0;
    }
    return t === e;
}, Lu = new Set([
    ".",
    "/",
    "./"
]), nS = (t, e)=>{
    if (!b(t) || !e) return;
    if (Lu.has(t)) return e.parse ? e.parse() : e;
    let r = Xe(t, e);
    if (r) {
        let o = t.replaceAll("~/", "");
        return Ze(o, r);
    }
    let n = Je(t, e);
    if (n) {
        let o = t.replaceAll("../", "");
        return Ze(o, n);
    }
    return Ze(t, e);
};
function oS(t, e, r) {
    let { children: n, __ref: o, state: s } = e, { childrenAs: i } = e.props || {}, a = O(t, e, s), c = O(n, e, s);
    n = a || c;
    let f;
    if (n) {
        if (Wn(n) && (i = i || "state", n = n.parse()), b(n) || ct(n)) {
            let p = nS(n, s);
            p !== void 0 ? (f = Lu.has(n) ? "" : n, n = Wn(p) ? p.parse() : p) : n = {
                text: n
            };
        }
        if (g(n)) {
            if (n.$$typeof) return e.call("renderReact", n, e);
            n = Object.keys(n).map((p)=>{
                let h = n[p];
                return It(p) ? Ts(p, h) : h;
            });
        }
    }
    if (!n || Dr(n)("array", "object")) return;
    if (_(n) && n.some((p)=>p?.$$typeof)) {
        let p = [], h = [];
        for(let d = 0; d < n.length; d++)n[d]?.$$typeof ? h.push(n[d]) : p.push(n[d]);
        h.length && e.call("renderReact", h, e), n = p;
    }
    let l;
    o.__childrenCache ? Va(n, o.__childrenCache) ? o.__noChildrenDifference = !0 : (l = j(n), o.__childrenCache = l, delete o.__noChildrenDifference) : (l = j(n), o.__childrenCache = l), (g(n) || _(n)) && (n = l || j(n));
    let u = {
        tag: "fragment"
    };
    for(let p in n){
        let h = Object.prototype.hasOwnProperty.call(n, p) && n[p];
        if (bt(h) && h !== null && h !== !1) {
            if (f !== void 0 && i !== "props") {
                let d = f ? `${f}/${p}` : p;
                u[p] = {
                    state: d
                };
            } else u[p] = N(h) ? i ? {
                [i]: h
            } : h : i ? {
                [i]: i === "state" ? {
                    value: h
                } : {
                    text: h
                }
            } : {
                text: h
            };
        }
    }
    return u;
}
var Ao = oS;
var Mu = "production", Bu = (t, e)=>{
    let { node: r, tag: n, __ref: o } = t;
    if (!o.__if) return t;
    let s;
    r || (s = !0, n === "shadow" ? r = t.node = t.parent.node.attachShadow({
        mode: "open"
    }) : r = t.node = Eu(t), W("attachNode", t, e)), (Mu === "test" || Mu === "development" || e.alowRefReference) && (r.ref = t, y(r.setAttribute) && r.setAttribute("key", t.key)), Eo(t), ko(t), Co(t), vu(t), Cu(t), yu(t, {
        isNewNode: s,
        ...e
    });
    for(let a in t){
        let c = t[a];
        if (!Object.prototype.hasOwnProperty.call(t, a) || c === void 0 || Ht(a, t) || g(ne[a]) || a.length > 2 && a.charCodeAt(0) === 111 && a.charCodeAt(1) === 110 && a.charCodeAt(2) >= 65 && a.charCodeAt(2) <= 90) continue;
        let f = Oo(a, t, e);
        if (f) {
            let { hasDefine: l, hasContextDefine: u } = f;
            if (t[a] && !l && !u) {
                let p = ()=>{
                    Vt(c, t, a, e);
                };
                t.props && t.props.lazyLoad || e.lazyLoad ? window.requestAnimationFrame(()=>{
                    p(), e.preventUpdateListener || W("lazyLoad", t, e);
                }) : p();
            }
        }
    }
    let i = t.children ? Ao(t.children, t, e) : t.children || t.content;
    return i && gn(i, t, e), t;
};
v();
var qa = {
    key: ":root",
    node: z ? z.body : gt("DocumentNotDefined", z)
}, za = qa;
v();
v();
v();
v();
var Uu = {
    overwrite: !0,
    preventHoistElementUpdate: !1,
    updateByState: !0,
    isHoisted: !0
}, ju = function(t, e = Uu) {
    let r = this, n = r.__element;
    if (e.onEach && e.onEach(n, r, n.context, e), e.updateByState || Y(e, Uu), r.__element || gt("ElementOnStateIsNotDefined"), e.preventInheritAtCurrentState === !0) e.preventInheritAtCurrentState = r;
    else if (e.preventInheritAtCurrentState) return;
    return !e.preventBeforeStateUpdateListener && vt("beforeStateUpdate", t, n, e) === !1 ? n : (ti(r, t, e), sS(r, t, e) || (iS(r, t, e), aS(r, t, e), e.preventStateUpdateListener || vt("stateUpdate", t, n, e)), r);
}, sS = (t, e, r)=>{
    let n = t.__element, { parent: o, __ref: s } = n, i = s?.__state, a = s?.__stateType;
    if (!i) return;
    let c = er(n), f = tr(n, o, {
        returnParent: !0
    });
    if (!(c && f && !r.stopStatePropagation)) return;
    let u = a === "string" || a === "number" || a === "boolean", p = u ? t.value : t.parse(), h = u ? t.value : e, d = Xe(i, o.state), m = Je(i, o.state), S = i.replaceAll("~/", "").replaceAll("../", ""), x = Js(S, h), w = d || m || o.state;
    r.replace && it(w, x || p), w.update(x, {
        ...r,
        isHoisted: !0,
        preventUpdate: r.preventHoistElementUpdate,
        overwrite: !r.replace
    });
    let C = r.preventUpdate !== !0 || !r.preventHoistElementUpdate;
    return !r.preventStateUpdateListener && C && vt("stateUpdate", e, n, r), !0;
}, iS = (t, e, r)=>{
    if (t.__depends) for(let n in t.__depends)t.__depends[n].clean().update(t.parse(), r);
}, aS = (t, e, r)=>{
    let n = t.__element;
    r.preventUpdate !== !0 ? n.update({}, {
        ...r,
        updateByState: !0
    }) : r.preventUpdate === "recursive" && n.update({}, {
        ...r,
        isHoisted: !1,
        updateByState: !0,
        preventUpdate: !0
    });
};
var cS = function() {
    let t = this;
    if (g(t)) {
        let e = {};
        for(let r in t)Tt.has(r) || (e[r] = t[r]);
        return e;
    } else if (_(t)) return t.filter((e)=>!Tt.has(e));
}, lS = function(t = {}) {
    let e = this;
    for(let r in e)!Tt.has(r) && Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
    return t.preventStateUpdate || e.update(e, {
        replace: !0,
        ...t
    }), e;
}, fS = function(t = {}) {
    let e = this, r = e.__element, n = r.__ref.__state;
    if (b(n)) return r.parent.state.remove(n, {
        isHoisted: !0,
        ...t
    }), r.state;
    if (delete r.state, r.state = e.parent, e.parent && delete e.parent.__children[r.key], e.__children) for(let o in e.__children){
        let s = e.__children[o];
        s.state && (_(s.state) ? Object.defineProperty(s.state, "parent", {
            value: e.parent,
            enumerable: !1,
            configurable: !0,
            writable: !0
        }) : Object.setPrototypeOf(s, {
            parent: e.parent
        }));
    }
    return r.state.update({}, {
        isHoisted: !0,
        ...t
    }), r.state;
}, uS = function(t, e = {}) {
    let r = this;
    if (!(!r || !r.parent)) return r.parent.update(t, {
        isHoisted: !0,
        ...e
    });
}, pS = function(t, e = {}) {
    let r = this;
    return r ? r.__element.__ref.root.state.update(t, {
        isHoisted: !1,
        ...e
    }) : void 0;
}, dS = function(t, e = {}) {
    let r = this;
    if (_(r)) r.push(t), r.update(r.parse(), {
        overwrite: !0,
        ...e
    });
    else if (g(r)) {
        let n = Object.keys(r).length;
        r.update({
            [n]: t
        }, e);
    }
}, hS = function(t, e = {}) {
    let r = this;
    r.update({
        [t]: !r[t]
    }, e);
}, mS = function(t, e = {}) {
    let r = this;
    return _(r) ? rs(r, t) : g(r) && hs(r, t), e.applyReset ? r.set(r.parse(), {
        replace: !0,
        ...e
    }) : r.update({}, e);
}, gS = function(t, e = {}) {
    let r = this, n = j(t);
    return r.clean({
        preventStateUpdate: !0,
        ...e
    }).update(n, {
        replace: !0,
        ...e
    });
}, Vu = function(t, e, r = {}) {
    let n = this, o = j(e);
    r.preventReplace || ys(n, t, e);
    let s = ms(t, o);
    return r.preventStateUpdate ? s : n.update(s, r);
}, yS = function(t, e = {}) {
    let r = this, n = t.reduce((o, s)=>{
        if (s[0] === "update") {
            let i = Vu.call(r, s[1], s[2], {
                preventStateUpdate: !0
            });
            return it(o, i);
        } else s[0] === "delete" && Ha.call(r, s[1], {
            ...e,
            preventUpdate: !0
        });
        return o;
    }, {});
    return r.update(n, e);
}, Ha = function(t, e = {}) {
    let r = this;
    return gs(r, t), e.preventUpdate ? t : r.update({}, e);
}, bS = function(t, e = {}) {
    let r = this;
    for(let n = 0; n < t.length; n++)Ha(t[n], {
        preventUpdate: !0
    });
    return r.update({}, e);
}, SS = function(t, e = {}) {
    return bs(this, t);
}, xS = function(t = {}) {
    let e = this, r = j(e.parse());
    return e.set(r, {
        replace: !0,
        ...t
    });
}, _S = function(t, e = {}) {
    let r = this;
    if (y(t)) {
        let n = t(r);
        return r.update(n, {
            replace: !0,
            ...e
        });
    }
}, wS = function(t, e = {}) {
    let r = this;
    if (y(t)) {
        let n = t(r);
        return r.replace(n, e);
    }
}, vS = function(t, e = {}) {
    let r = this;
    if (y(t)) return t(r), r.update(r.parse(), {
        replace: !0,
        ...e
    });
}, CS = function(t, e = {}) {
    return this.update(t, {
        preventUpdate: !0,
        ...e
    });
}, ES = function(t, e = {}) {
    let r = this;
    for(let n in t)r[n] = t[n];
    return r.update(t, e);
}, kS = function(t, e = {}) {
    return this.replace(t, {
        preventUpdate: !0,
        ...e
    });
}, OS = function(t, e = {}) {
    return Object.keys(this);
}, AS = function(t, e = {}) {
    return Object.values(this);
}, qu = (t)=>{
    let e = t.state, r = t.__ref, n = {
        clean: lS.bind(e),
        parse: cS.bind(e),
        destroy: fS.bind(e),
        update: ju.bind(e),
        rootUpdate: pS.bind(e),
        parentUpdate: uS.bind(e),
        create: Me.bind(e),
        add: dS.bind(e),
        toggle: hS.bind(e),
        remove: mS.bind(e),
        apply: _S.bind(e),
        applyReplace: wS.bind(e),
        applyFunction: vS.bind(e),
        set: gS.bind(e),
        quietUpdate: CS.bind(e),
        replace: ES.bind(e),
        quietReplace: kS.bind(e),
        reset: xS.bind(e),
        parent: t.parent?.state || e,
        setByPath: Vu.bind(e),
        setPathCollection: yS.bind(e),
        removeByPath: Ha.bind(e),
        removePathCollection: bS.bind(e),
        getByPath: SS.bind(e),
        keys: OS.bind(e),
        values: AS.bind(e),
        __element: t,
        __children: {},
        root: r?.root ? r.root.state : e
    };
    _(e) ? Fr(e, n) : Object.setPrototypeOf(e, n), e.parent && e.parent.__children && (e.parent.__children[t.key] = e);
};
var Me = function(t, e, r) {
    return t.state = TS(t, e, r), t.state;
}, TS = function(t, e, r) {
    let n = Qs(t);
    if (n === !1) return e.state || {};
    if (t.state = n, W("stateInit", t, r) === !1) return t.state;
    if (er(t)) {
        let i = Xs(t, e);
        t.state = K(i) ? {} : i;
    }
    let s = Zs(t, t.state || e.state || {});
    return s && (t.state = s), qu(t), W("stateCreated", t), t.state;
};
v();
v();
var zu = [];
var To = {
    stackChanges: !1,
    cleanExec: !0,
    preventRecursive: !1,
    currentSnapshot: !1,
    calleeElement: !1,
    exclude: zu
}, yn = function(t = {}, e) {
    let r = g(e) ? {
        ...To,
        ...e
    } : {
        ...To
    }, n = this, o = n.__ref;
    o || (o = n.__ref = {});
    let [s, i, a] = Fi(n, r);
    if (a) return;
    r.preventListeners || vt("startUpdate", t, n, r);
    let { parent: c, node: f, key: l } = n, { exclude: u, preventInheritAtCurrentState: p } = r;
    if (p && p.__element === n || (u || Y(r, To), (b(t) || ct(t)) && (t = {
        text: t
    }), t = js.call(n, t), PS(n, r) === !1) || IS(n, c, r)) return;
    if (o.__if && !r.preventPropsUpdate) {
        let P = c.props && (c.props[l] || c.props.childProps), F = o.__propsStack.some(y), U = t.props || P || F;
        U && Ws(U, n, c);
    }
    if (!r.preventBeforeUpdateListener && !r.preventListeners && (n.on?.beforeUpdate || n.props?.onBeforeUpdate)) {
        let F = {
            ...t,
            ...n
        };
        if (Object.setPrototypeOf(F, Object.getPrototypeOf(n)), vt("beforeUpdate", t, F, r) === !1) return n;
    }
    if (it(n, t), Eo(n), ku(n, {
        ignore: To
    }), Ou(n), !r.isForced && !r.preventListeners && W("beforeClassAssign", n, r), !o.__if) return !1;
    if (!f) return;
    let { preventUpdate: m, preventDefineUpdate: S, preventContentUpdate: x, preventStateUpdate: w, preventRecursive: C, preventUpdateListener: R, preventUpdateAfter: T, preventUpdateAfterCount: A } = r;
    if (T) {
        if (ct(A) && T <= A) return;
        r.preventUpdateAfterCount === void 0 ? r.preventUpdateAfterCount = 1 : r.preventUpdateAfterCount++;
    }
    let k = _(m) ? new Set(m) : null, L = _(S) ? new Set(S) : null;
    for(let P in n){
        let F = n[P];
        if (!Object.prototype.hasOwnProperty.call(n, P)) continue;
        let U = k && k.has(P), Z = L && L.has(P), tt = y(F) && P.length > 2 && P.charCodeAt(0) === 111 && P.charCodeAt(1) === 110 && P.charCodeAt(2) >= 65 && P.charCodeAt(2) <= 90;
        if (K(F) || U || Z || S === !0 || S === P || w && P === "state" || Ht(P, n) || tt || g(ne[P])) continue;
        w === "once" && (r.preventStateUpdate = !1);
        let pt = Oo(P, n, r);
        if (pt) {
            let { hasDefine: _t, hasContextDefine: Mt } = pt;
            if (!(g(F) && !_t && !Mt && !C)) continue;
            let Qo = n.props.lazyLoad || r.lazyLoad;
            r.onEachUpdate && r.onEachUpdate(P, n, n.state, n.context);
            let st = t[P];
            if (st === void 0 && !r.isForced) {
                if (r.onlyUpdate) {
                    if (P !== r.onlyUpdate) continue;
                } else if (!r.updateByState) continue;
            }
            let Xo = r.onlyUpdate && P === r.onlyUpdate ? {
                ...r,
                onlyUpdate: void 0,
                currentSnapshot: s,
                calleeElement: i
            } : {
                ...r,
                currentSnapshot: s,
                calleeElement: i
            }, Jo = ()=>yn.call(F, st, Xo);
            Qo ? D.requestAnimationFrame(()=>{
                Jo(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
            }) : Jo();
        }
    }
    if (!x) {
        let P = o.contentElementKey || "content", F = n[P], U = r.updateByState ? t.children || (o.__exec?.children ? n.children : void 0) : t.children || n.children;
        if (U) {
            let Z = Ao(U, n, e);
            if (Z && !o.__noChildrenDifference) gn(Z, n, r);
            else if (F?.__ref && y(F.update)) {
                let tt = n.props?.lazyLoad || r.lazyLoad, pt = ()=>yn.call(F, t[P], {
                        ...r,
                        currentSnapshot: s,
                        calleeElement: i
                    });
                tt ? D.requestAnimationFrame(()=>{
                    pt(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
                }) : pt();
            }
        } else if (F?.__ref && y(F.update)) {
            let Z = n.props?.lazyLoad || r.lazyLoad, tt = ()=>yn.call(F, t[P], {
                    ...r,
                    currentSnapshot: s,
                    calleeElement: i
                });
            Z ? D.requestAnimationFrame(()=>{
                tt(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
            }) : tt();
        } else {
            let Z = n.children || t.content;
            Z && !r.updateByState && gn(Z, n, r);
        }
    }
    !R && !r.preventListeners && W("update", n, r), !r.preventFetch && o.__fetchOnStateChange && o.__fetchOnStateChange();
}, RS = (t, e)=>{
    let { __children: r } = e.__ref || {};
    if (!r) return !1;
    let n = r.indexOf(t.key), o;
    for(let i = n - 1; i >= 0; i--){
        let a = e[r[i]];
        if (a?.node?.parentNode) {
            o = a.node;
            break;
        }
    }
    if (o) return {
        position: "after",
        node: o
    };
    let s;
    for(let i = n + 1; i < r.length; i++){
        let a = e[r[i]];
        if (a?.node?.parentNode) {
            s = a.node;
            break;
        }
    }
    return s ? {
        position: "before",
        node: s
    } : !1;
}, IS = (t, e, r)=>{
    if (!y(t.if) && !y(t.props?.if) || !e) return;
    let n = t.__ref, o;
    try {
        o = (t.if || t.props?.if)(t, t.state, t.context, r);
    } catch (i) {
        console.warn("[DOMQL] if condition error:", i);
        return;
    }
    let s = n.__if !== !0;
    if (o) {
        if (n.__if = !0, s) {
            delete t.__hash, delete t.__text, delete t.extends, n.__hasRootState || delete t.state, n.__state ? t.state = n.__state : n.__hasRootState || delete t.state, t.node && (t.node.remove(), delete t.node);
            let i = n.contentElementKey;
            t.children ? t.removeContent() : t[i]?.parseDeep && (t[i] = t[i].parseDeep());
            let a = RS(t, e);
            delete t.__ref, delete t.parent;
            let c = Vt(t, e, t.key, ut.create, a);
            return r.preventUpdate !== !0 && t.on && y(t.on.update) && jr(t.on.update, c, c.state), c;
        }
    } else t.node && !o && (t.node.remove(), delete n.__if);
}, PS = (t, e)=>{
    let { __ref: r } = t, n = r.__state, { parent: o } = t, { preventUpdateTriggerStateUpdate: s } = e;
    if (s) return;
    if (!n && !r.__hasRootState) {
        t.state = o?.state || {};
        return;
    }
    let i = tr(t, t.parent);
    if (!i || e.preventInheritedStateUpdate) return;
    if (!e.preventBeforeStateUpdateListener && !e.preventListeners && vt("beforeStateUpdate", i, t, e) === !1) return t;
    let a = NS(t, o, e);
    !e.preventStateUpdateListener && !e.preventListeners && vt("stateUpdate", a.parse(), t, e);
}, NS = (t, e, r)=>{
    let n = t.state.__children, o = Me(t, e);
    t.state = o;
    for(let s in n)o[s] && (o.__children[s] = n[s]), Object.getPrototypeOf(n[s]).parent = o;
    return o;
};
Di();
var Wa = (t, e, r = {})=>{
    let n = {
        set: Ka,
        reset: Hu,
        update: yn,
        variables: Ri,
        remove: yi,
        updateContent: Wu,
        removeContent: Ga,
        setProps: bi,
        lookup: hi,
        lookdown: mi,
        lookdownAll: gi,
        getRef: Si,
        getDB: Pi,
        getPath: xi,
        getQuery: Ni,
        getRootState: _i,
        getRoot: wi,
        getRootData: vi,
        getRootContext: Ci,
        getContext: Ei,
        setNodeStyles: Xn,
        spotByPath: di,
        parse: Zn,
        parseDeep: Yr,
        keys: Jn,
        nextElement: Ai,
        previousElement: Ti,
        log: ki,
        verbose: to,
        warn: Oi,
        error: Qr,
        call: Ii
    };
    t.context.methods && (r.strict ? Y : fe)(n, t.context.methods), Object.setPrototypeOf(t, n);
};
var Gu = new Set([
    "class",
    "style"
]), DS = (t)=>{
    let { tag: e, props: r, context: n } = t;
    if (!e || !r) return;
    let o = n?.cssPropsRegistry, s = Ul(e, r, o), i = jl(r, e, o), a = {};
    for(let f in s)Gu.has(f) || (a[f] = Xr[f] ? Xr[f] : s[f]);
    for(let f in i)Gu.has(f) || (a[f] = i[f]);
    let c = !1;
    for(let f in a){
        c = !0;
        break;
    }
    c && (t.attr ? typeof t.attr == "object" && (t.attr = {
        ...a,
        ...t.attr
    }) : t.attr = a);
}, Ro = "production", Vt = (t, e, r, n = ut.create || {}, o)=>{
    FS(n);
    let s = Ys(t, e, r, n, qa);
    if (!s) return;
    let { key: i, parent: a, __ref: c } = s;
    return Ks(s, a), Ds(s, a, n), n.onlyResolveExtends ? BS(s, a, i, n) : (zn.call(s, s), W("start", s, n), $S(s, a, n), Wa(s, a, n), Gn(s, a), Me(s, a), Br(s, a), Hn(s, a, n), Ur.call(s, s, {
        cachedKeys: []
    }), s.tag || (s.tag = Ua(s)), DS(s), Br(s, a), s.node && c.__if ? ja(s, a, i, o) : (W("init", s, n) === !1 || (W("beforeClassAssign", s, n), Tu(s), MS(s, a, n, o), Yu(s, a), W("complete", s, n)), s));
}, FS = (t)=>{
    t && !ut.create && (ut.create = t, ut.create.context = t.context);
}, $S = (t, e, r)=>{
    let n = !1;
    for(let o in r){
        n = !0;
        break;
    }
    n && (ut.defaultOptions = r, r.ignoreChildExtends && delete r.ignoreChildExtends);
}, Yu = (t, e)=>{
    e.__ref && e.__ref.__children && (e.__ref.__children.includes(t.key) || e.__ref.__children.push(t.key));
}, LS = 1, Ku = new WeakMap, MS = (t, e, r, n)=>{
    Ku.has(t) && (Ro === "test" || Ro === "development") && console.warn("Cyclic rendering detected:", t.__ref.path), Ku.set(t, !0);
    let { __ref: o, key: s } = t, i = ()=>{
        let a = Ss(o.path);
        o.__uniqId || a || (Bu(t, r), o.__uniqId = LS++);
    };
    if (Ro === "test" || Ro === "development" || t.context?.strictMode) i();
    else try {
        i();
    } catch (a) {
        t.error = a;
        let c = o.path;
        c.includes("ComponentsGrid") && c.splice(0, c.indexOf("ComponentsGrid") + 2), c.includes("demoComponent") && c.splice(0, c.indexOf("demoComponent") + 1);
        let f = t.lookup((l)=>l.state.key)?.state?.key;
        t.warn("Error happened in:", f ? f + " " : "" + c.join(".")), t.verbose(), a instanceof ReferenceError ? console.warn("[DOMQL] Render warning:", a.message) : console.error("[DOMQL] Render error:", a), t.on?.error && t.on.error(a, t, t.state, t.context, r);
    }
    if (!o.__if) return e[s || t.key] = t, t;
    ja(t, e, s, n), _u(t, r), W("render", t, r), W("renderRouter", t, r), W("done", t, r), W("create", t, r);
}, BS = (t, e, r, n)=>{
    let { __ref: o } = t;
    if (Wa(t, e, n), Gn(t, e), Me(t, e), Br(t, e), Hn(t, e, n), Ur.call(t, t, {
        cachedKeys: []
    }), t.node && o.__if && (e[r || t.key] = t), t.props || (t.props = {}), Yu(t, e), t.tag !== "string" && t.tag !== "fragment") {
        ko(t), Co(t);
        for(let s in t){
            if (K(t[s]) || Ht(s, t) || g(ne[s])) continue;
            let i = t.define?.[s], a = t.context?.define?.[s], c = n.define?.[s];
            if (!(!o.__skipCreate && ne[s] && !c) && t[s] && !i && !c && !a) try {
                Vt(O(t[s], t), t, s, n);
            } catch (f) {
                console.warn("[DOMQL] onlyResolveExtends child error in", s, ":", f?.message || f);
            }
        }
    }
    return e[r || t.key] = t, delete t.update, delete t.__element, t.props && (delete t.props.update, delete t.props.__element), t;
}, Io = Vt;
var Cr = (t, e = {})=>{
    let { __ref: r } = t, n = e.contentElementKey;
    return (!r.contentElementKey || n !== r.contentElementKey) && (r.contentElementKey = n || "content"), r.contentElementKey;
};
function Hu(t) {
    let e = this;
    Vt(e, e.parent, void 0, {
        ignoreChildExtends: !0,
        ...ut.defaultOptions,
        ...ut.create,
        ...t
    });
}
var Qu = (t, e, r)=>{
    let n = Cr(e, r);
    e[n]?.node && Ga(e, r);
    let o = Vt(t, e, n || "content", {
        ignoreChildExtends: !0,
        ...ut.defaultOptions,
        ...ut.create,
        ...r
    });
    return n !== "content" && (r.contentElementKey = "content"), o;
}, Wu = function(t, e) {
    let r = this, n = Cr(r, e);
    r[n] && r[n].update && r[n].update(t, e);
};
function gn(t, e, r) {
    let n = O(t, e);
    n && e && Ka.call(e, n, r);
}
var Ga = function(t, e = {}) {
    let r = t || this, n = Cr(r, e);
    e.contentElementKey !== "content" && (e.contentElementKey = "content");
    let o = r[n];
    if (o) {
        if (o.tag === "fragment" && o.__ref?.__children) {
            let s = o.__ref.__children;
            for(let i = 0; i < s.length; i++){
                let a = o[s[i]];
                a.node && a.node.parentNode && a.node.parentNode.removeChild(a.node), y(a.remove) && a.remove();
            }
        } else o.node && o.node.parentNode && o.node.parentNode.removeChild(o.node), y(o.remove) && o.remove();
        delete r[n];
    }
}, Ka = function(t, e = {}, r) {
    let n = r || this, { __ref: o } = n;
    if (o.__settingContent) return n;
    o.__settingContent = !0;
    try {
        return US(t, e, n);
    } finally{
        o.__settingContent = !1;
    }
}, US = function(t, e, r) {
    let { __ref: n } = r, o = Cr(r, e), s = r[o], i = s && s.__ref, a = r.props && r.props.lazyLoad, c = r.children;
    if (e.preventContentUpdate === !0 && !c) return;
    let f = !n.__noChildrenDifference, l = f && i && Object.keys(t).length === Object.keys(s).length && ds(t, s);
    if (s?.update && !f && !l) {
        if (!e.preventBeforeUpdateListener && !e.preventListeners && vt("beforeUpdate", t, r, e) === !1) return r;
        s.update(t), !e.preventUpdateListener && !e.preventListeners && W("update", r, e);
        return;
    }
    if (!t || typeof t != "object") return r;
    let { childExtends: u, props: p, tag: h } = t;
    if (p || (p = t.props = {}), h === "fragment") {
        let d = r.childExtends || r.childExtend;
        !u && d && (t.childExtends = d, p.ignoreChildExtends = !0);
        let m = r.childProps || r.props?.childProps;
        !p?.childProps && m && (p.childProps = m), p.ignoreChildProps = !0;
    }
    a ? window.requestAnimationFrame(()=>{
        Qu(t, r, e), e.preventUpdateListener || W("lazyLoad", r, e);
    }) : Qu(t, r, e);
};
var Ju = /^:(.+)/, Zu = /^\*$/, Xu = new Map, Ya = (t)=>{
    let e = Xu.get(t);
    if (e) return e;
    let r = t.replace(/^\//, "").split("/"), n = [], o = !1;
    for(let i = 0; i < r.length; i++){
        let a = r[i].match(Ju);
        a ? n.push({
            index: i,
            name: a[1]
        }) : Zu.test(r[i]) && (o = !0);
    }
    let s = {
        segments: r,
        params: n,
        hasWildcard: o,
        pattern: t
    };
    return Xu.set(t, s), s;
}, Qa = (t, e, r = 0)=>{
    let o = t.replace(/^\//, "").split("/").filter(Boolean).slice(r), s = "/" + (o[0] || ""), i = null, a = -1, c = {};
    for(let f in e){
        if (f === "/*") continue;
        let l = Ya(f), u = jS(o, l);
        u > a && (a = u, i = f, c = VS(o, l));
    }
    return !i && e["/*"] && (i = "/*"), {
        key: i,
        content: i ? e[i] : null,
        params: c,
        routePath: s
    };
}, jS = (t, e)=>{
    let { segments: r, hasWildcard: n } = e;
    if (!n && r.length !== t.length && r.length !== 1 && r.length > t.length) return -1;
    let o = 0, s = Math.min(r.length, t.length);
    for(let i = 0; i < s; i++)if (r[i] === t[i]) o += 3;
    else if (Ju.test(r[i])) o += 1;
    else if (Zu.test(r[i])) o += .5;
    else return -1;
    return o;
}, VS = (t, e)=>{
    let r = {};
    for (let { index: n, name: o } of e.params)t[n] && (r[o] = decodeURIComponent(t[n]));
    return r;
}, Xa = (t)=>{
    if (!t || t === "?") return {};
    let e = {};
    return new URLSearchParams(t).forEach((n, o)=>{
        e[o] !== void 0 ? (Array.isArray(e[o]) || (e[o] = [
            e[o]
        ]), e[o].push(n)) : e[o] = n;
    }), e;
}, Ja = async (t, e)=>{
    if (!t || !t.length) return !0;
    for (let r of t){
        let n = await r(e);
        if (n === !1) return !1;
        if (typeof n == "string") return n;
    }
    return !0;
}, Za = (t = 0, e = D.location.pathname)=>{
    let n = e.split("/")[t + 1];
    if (n) return `/${n}`;
}, Po, No = 0, qS = {
    level: No,
    pushState: !0,
    initialRender: !1,
    scrollToTop: !0,
    scrollToNode: !1,
    scrollNode: z && z.documentElement,
    scrollBody: !1,
    useFragment: !1,
    updateState: !0,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    },
    useParamsMatching: !0
}, oe = (t, e, r = {}, n = {})=>{
    let o = e || void 0, s = o.context.window || D, i = o.context.document || z, a = {
        ...qS,
        ...o.context.routerOptions,
        ...n
    };
    No = a.lastLevel;
    let c = o.__ref;
    (a.contentElementKey !== "content" && a.contentElementKey !== c.contentElementKey || !c.contentElementKey) && (c.contentElementKey = a.contentElementKey || "content");
    let f = Cr(o, a), l = s.location.origin !== "null" ? s.location.origin : "http://localhost", u = new s.URL(l + t), { pathname: p, search: h, hash: d } = u, m = Xa(h), S = o.node, x = d && d !== s.location.hash.slice(1), w = p !== Po;
    Po = p;
    let C, R, T;
    if (a.useParamsMatching) {
        let k = Qa(p, o.routes, a.level);
        C = k.routePath, R = k.content, T = k.params;
    } else C = Za(a.level, p), R = o.routes[C || "/"] || o.routes["/*"], T = {};
    let A = a.scrollToNode ? S : a.scrollNode;
    if (!R || o.state.root.debugging) {
        o.state.root.debugging = !1, a.onNotFound && a.onNotFound({
            pathname: p,
            route: C,
            element: o
        });
        return;
    }
    if (a.guards && a.guards.length) {
        let k = {
            pathname: p,
            route: C,
            params: T,
            query: m,
            hash: d,
            element: o,
            state: r
        }, L = Ja(a.guards, k);
        if (L === !1) return;
        if (typeof L == "string") return oe(L, e, r, {
            ...n,
            guards: []
        });
    }
    if (a.pushState) try {
        s.history.pushState(r, null, p + (h || "") + (d || ""));
    } catch  {}
    if (w || !x) {
        let k = {
            route: C,
            hash: d,
            debugging: !1
        };
        Object.keys(T).length && (k.params = T), Object.keys(m).length && (k.query = m), a.updateState && o.state.update(k, {
            preventContentUpdate: !0
        }), f && a.removeOldElement && o[f].remove();
        let L = o.__ref?.origin?.content, P = {};
        if (L) for(let F in L){
            let U = L[F];
            F === "__ref" || F === "props" || F === "node" || F === "parent" || F === "key" || (typeof U == "string" || typeof U == "number" || typeof U == "boolean" || typeof U == "object" && U !== null && !U.node && !U.__ref) && (P[F] = U);
        }
        o.set({
            ...P,
            tag: a.useFragment && "fragment",
            extends: R
        }, {
            contentElementKey: f
        });
    }
    if (a.scrollToTop && A?.scrollTo && A.scrollTo({
        ...a.scrollToOptions || {},
        top: 0,
        left: 0
    }), a.scrollToNode && R[f]?.node?.scrollTo && R[f].node.scrollTo({
        ...a.scrollToOptions || {},
        top: 0,
        left: 0
    }), d) {
        let k = i.getElementById(d);
        if (k && A?.scrollTo) {
            let L = k.getBoundingClientRect().top + S.scrollTop - (a.scrollToOffset || 0);
            A.scrollTo({
                ...a.scrollToOptions || {},
                top: L,
                left: 0
            });
        }
    }
    W("routeChanged", o, a);
}, zS = oe;
var tp = {
    extends: "Focusable",
    tag: "a",
    aria: {},
    fontWeight: "bold",
    textDecoration: "none",
    color: "currentColor",
    draggable: !1,
    attr: {
        href: (t)=>{
            let e = t.props;
            return Te(t, e.href) || Te(t, t.call("exec", e, t).href);
        },
        "aria-label": ({ props: t })=>t.aria ? t.aria.label : t.text
    }
}, HS = {
    extends: "Link"
}, ep = {
    onClick: (t, e, r)=>{
        let { props: n, context: o } = e, { href: s, scrollToTop: i, stopPropagation: a } = n, c = e.call("exec", s, e);
        if (e.call("isString", c) && c.includes("{{") && (c = e.call("replaceLiteralsWithObjectFields", c)), a && t.stopPropagation(), !c) return;
        let { utils: f, snippets: l, functions: u, routerOptions: p } = o, h = e.__ref.root, d = c.startsWith("http://") || c.startsWith("https://") || c.startsWith("mailto:") || c.startsWith("tel:") || c.startsWith("sketch:") || c.startsWith("whatsapp:") || c.startsWith("sms:") || c.startsWith("skype:") || c.startsWith("viber:") || c.startsWith("callto:") || c.startsWith("facetime:") || c.startsWith("facetime-audio:") || c.startsWith("geo:") || c.startsWith("maps:");
        if (c && !d) {
            t.preventDefault();
            try {
                let m = h;
                if (p && p.customRouterElement) {
                    let S = Array.isArray(p.customRouterElement) ? p.customRouterElement : p.customRouterElement.split("."), x = h;
                    for (let w of S){
                        if (!x || !x[w]) {
                            x = null;
                            break;
                        }
                        x = x[w];
                    }
                    x && (m = x, h.routes && (m.routes = h.routes));
                }
                (u.router || l.router || f.router || oe)(c, m, {}, {
                    scrollToOptions: {
                        behaviour: "instant"
                    },
                    scrollToTop: e.call("isDefined", i) ? i : !0,
                    ...p,
                    ...n.routerOptions
                });
            } catch (m) {
                console.warn(m);
            }
        }
    }
}, WS = {
    extends: [
        tp,
        ep
    ]
};
var GS = {
    extends: "Focusable",
    tag: "select",
    fontSize: "A",
    border: "none",
    boxSizing: "border-box",
    theme: "field",
    cursor: "pointer",
    childProps: {
        tag: "option",
        attr: {
            value: ({ props: t })=>t.value,
            selected: ({ props: t })=>t.selected,
            disabled: ({ props: t })=>t.disabled
        }
    },
    attr: {
        name: ({ props: t })=>t.name,
        disabled: ({ props: t })=>t.disabled,
        value: (t)=>{
            if (!t.props || !t.props.value) return;
            let e = t.call("exec", t.props.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        }
    }
};
var KS = {
    extends: [
        "IconText",
        "FocusableComponent"
    ],
    tag: "button",
    fontSize: "A",
    type: "button",
    borderStyle: "none",
    display: "inline-flex",
    align: "center center",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    padding: "Z B2",
    fontWeight: "500",
    fontFamily: "inherit",
    round: "C2",
    disabled: (t)=>t.call("exec", t.props.disabled)
}, YS = {
    extends: "Button",
    fontSize: "A",
    width: "A",
    padding: "Z",
    aspectRatio: "1 / 1",
    icon: "smile",
    boxSize: "fit-content fit-content",
    justifyContent: "center",
    round: "Z",
    boxSizing: "content-box"
}, QS = {
    extends: "SquareButton",
    round: "C"
}, XS = {
    extends: "Button",
    childExtends: "IconText"
}, JS = {
    tag: "nav",
    display: "flex",
    childExtends: "SquareButton"
}, ZS = {
    extends: [
        "SquareButton",
        "ClickableItem"
    ],
    round: "Z"
};
var tx = {
    display: "flex",
    tag: "dialog",
    flow: "column",
    border: "0",
    theme: "dialog",
    round: "Z2"
}, ex = {
    extends: "Hgroup",
    minWidth: "100%",
    gap: "A",
    Title: {
        align: "center space-between",
        Text: {
            text: "Title"
        },
        SquareButton: {
            icon: "x",
            theme: "transparent"
        }
    },
    Paragraph: {
        color: "caption"
    }
}, rx = {
    display: "flex",
    align: "center flex-end",
    gap: "X2",
    margin: "auto - -",
    padding: "Y2 X2",
    childExtends: {
        extends: "Button",
        textTransform: "uppercase",
        background: "transparent",
        "@dark": {
            theme: "primary @dark .color-only"
        },
        "@light": {
            theme: "primary @light .color-only"
        },
        "&": {
            padding: "Z A"
        },
        ":hover": {
            theme: "tertiary"
        },
        ":active": {
            background: "white.1"
        }
    },
    Cancel: {
        text: "cancel"
    },
    Ok: {
        text: "ok"
    }
};
v();
var nx = {
    display: "flex",
    theme: "dialog",
    background: "black",
    flow: "column",
    shape: "tooltip",
    shapeDirection: "left",
    padding: "Z1 A",
    round: "Y2",
    width: "fit-content",
    minWidth: "D2",
    maxWidth: "F2",
    gap: "X",
    textAlign: "center",
    attr: {
        tooltip: !0
    },
    Title: {
        if: ({ parent: t, props: e })=>bt(t.props.title) || e.text,
        width: "fit-content",
        fontWeight: 500,
        color: "gray12",
        text: ({ parent: t })=>t.props.title
    },
    P: {
        if: (t, e)=>t.call("isDefined", t.call("exec", t.parent.props.description, t)) || t.props.text,
        width: "fit-content",
        fontSize: "Z2",
        margin: "0",
        color: "gray6",
        fontWeight: "400",
        text: (t, e)=>t.call("exec", t.parent.props.description, t)
    }
}, ox = {
    extends: "Tooltip",
    position: "absolute",
    pointerEvents: "none",
    opacity: "0",
    visibility: "hidden",
    transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
    props: ({ props: t })=>({
            ...!t.shapeDirection || t.shapeDirection === "top" ? {
                top: "112%",
                left: "50%",
                transform: "translate3d(-50%,10%,0)",
                ".isActive": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : t.shapeDirection === "right" ? {
                transform: "translate3d(10%,-50%,0)",
                left: "112%",
                top: "50%",
                ".isActive": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : ({ props: e })=>e.shapeDirection === "bottom" ? {
                    transform: "translate3d(-50%,-10%,0)",
                    bottom: "112%",
                    left: "50%",
                    ".isActive": {
                        transform: "translate3d(-50%,0,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                } : e.shapeDirection === "left" ? {
                    transform: "translate3d(10%,-50%,0)",
                    right: "112%",
                    top: "50%",
                    ".isActive": {
                        transform: "translate3d(0%,-50%,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                } : {}
        })
}, sx = {
    position: "relative",
    zIndex: 999,
    props: (t)=>{
        let { Tooltip: e, TooltipHidden: r } = t, n = e || r;
        return n ? {
            ":hover, &:focus-visible": {
                zIndex: 1e3,
                "& [tooltip]": n && n.props && n.props[".isActive"] || {
                    transform: "translate3d(-50%, 0, 0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        } : void 0;
    }
};
var ix = {
    extends: "Img",
    display: "block",
    avatarType: "adventurer-neutral",
    borderRadius: "100%",
    boxSize: "C+X C+X",
    src: (t)=>`https://api.dicebear.com/7.x/${t.props.avatarType || "initials"}/svg?seed=${t.props.key || t.key || "no-avatar"}`
};
var ax = {
    tag: "input",
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    onInput: (t, e, r)=>{
        let n = e.props;
        e.call("isFunction", n.onInput) ? n.onInput(t, e, r) : r.update({
            value: parseFloat(e.node.value)
        });
    },
    onChange: (t, e, r)=>{
        let n = e.props;
        e.call("isFunction", n.onChange) ? n.onChange(t, e, r) : r.update({
            value: parseFloat(e.node.value)
        });
    },
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8",
        appearance: "none"
    },
    "::-webkit-slider-runnable-track": {},
    "@dark": {
        background: "white.2",
        "::-webkit-slider-thumb": {
            background: "#232526",
            borderColor: lo("#454646", .75)
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: lo("#fff", .35)
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "#3C6AC0"
            }
        }
    },
    "@light": {
        background: "gray9",
        "::-webkit-slider-thumb": {
            background: "white",
            borderColor: "gray9"
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: "gray7"
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "blue"
            }
        }
    },
    deps: {
        returnPropertyValue: (t, e, r)=>{
            let n = t.props && t.call("exec", t.props[e], t);
            return (t.call("isFunction", n) ? n(t, t.state) : n !== void 0 ? n : r !== void 0 ? r : 0) + "";
        }
    },
    attr: {
        type: "range",
        value: (t, e)=>t.call("exec", e.value || t.props.value || t.props.defaultValue, t),
        min: (t, e)=>t.deps.returnPropertyValue(t, "min", 0),
        max: (t, e)=>t.deps.returnPropertyValue(t, "max", 100),
        step: (t, e)=>t.deps.returnPropertyValue(t, "step", 1)
    }
};
var cx = {
    display: "flex",
    attr: {
        dropdown: !0
    },
    padding: "0 Y",
    maxHeight: "G",
    flow: "column",
    theme: "quaternary",
    overflow: "hidden auto",
    style: {
        listStyleType: "none"
    },
    transition: "B defaultBezier",
    transitionProperty: "transform, opacity, visibility",
    children: ({ props: t })=>t.options || [],
    childrenAs: "props",
    ".hidden": {
        transform: "translate3d(0,10%,0)",
        opacity: 0,
        visibility: "hidden"
    },
    childExtends: {
        extends: "Button",
        state: {},
        isActive: ({ key: t, state: e })=>e.active === t,
        position: "relative",
        round: "0",
        align: "center flex-end",
        flow: "row-reverse",
        padding: "Z2 C Z2 Y2",
        margin: "0",
        gap: "Y2",
        theme: "quaternary .child",
        ":hover": {
            style: {
                svg: {
                    opacity: "0.5"
                }
            }
        },
        Icon: {
            isActive: ({ key: t, state: e })=>e.active === t,
            name: "checkmark",
            opacity: "0.1",
            ".active": {
                opacity: "1"
            }
        },
        ":not(:first-child)": {
            "@dark": {
                border: "solid gray4.65"
            },
            "@light": {
                border: "solid gray11"
            },
            borderWidth: "1px 0 0"
        }
    }
}, lx = {
    position: "relative",
    zIndex: 999,
    style: {
        "&:hover": {
            zIndex: 1e3,
            "& [dropdown]": {
                transform: "translate3d(0,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        }
    }
}, fx = {
    position: "relative",
    tabindex: "0",
    style: {
        "&:focus-within": {
            zIndex: 1e3,
            "& [dropdown]": {
                transform: "translate3d(0,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        }
    },
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        visibility: "hidden",
        position: "absolute",
        inset: "0",
        onUpdate: (t)=>t.node.blur()
    },
    Dropdown: {
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
}, ux = {
    props: {
        position: "relative",
        tabindex: "0",
        style: {
            "&:focus-within": {
                zIndex: 1e3,
                "& ~ [dropdown]": {
                    transform: "translate3d(0,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        }
    },
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        visibility: "hidden",
        position: "absolute",
        inset: "0",
        onUpdate: (t)=>t.node.blur()
    }
};
var px = {
    display: "flex",
    theme: "alert",
    padding: "Z1 B Z A",
    round: "A A A Y2",
    gap: "X2",
    cursor: "pointer",
    align: "flex-start center",
    IconText: {
        Icon: {
            name: "info outline"
        },
        Text: {
            ":empty": {
                hide: !0
            }
        }
    },
    Hgroup: {
        extends: [
            "Flex",
            "Hgroup"
        ],
        flow: "y",
        align: "flex-start",
        gap: "X2",
        H: {
            tag: "h6",
            margin: "0",
            fontWeight: "600",
            lineHeight: "1em",
            text: "Notification",
            ":empty": {
                hide: !0
            }
        },
        P: {
            fontSize: "Z",
            margin: "0",
            text: "is not always a distraction",
            ":empty": {
                hide: !0
            }
        }
    }
};
v();
var bn = {};
Bt(bn, {
    CDN_PROVIDERS: ()=>ee,
    DOMQL_EVENTS: ()=>ls,
    DOMQ_PROPERTIES: ()=>ze,
    ENV: ()=>th,
    ERRORS_REGISTRY: ()=>bu,
    HTML_TAGS: ()=>Un,
    METHODS: ()=>Fn,
    METHODS_EXL: ()=>cs,
    NODE_ENV: ()=>Jt,
    OPTIONS: ()=>ut,
    PACKAGE_MANAGER_TO_CDN: ()=>gr,
    PARSED_DOMQ_PROPERTIES: ()=>as,
    PROPS_METHODS: ()=>He,
    STATE_METHODS: ()=>Tt,
    STATE_PROPERTIES: ()=>jd,
    SVG_TAGS: ()=>Qe,
    TYPES: ()=>es,
    addCaching: ()=>ul,
    addContext: ()=>fl,
    addExtend: ()=>wh,
    addExtends: ()=>Rt,
    addItemAfterEveryElement: ()=>Cd,
    addProtoToArray: ()=>Fr,
    addRef: ()=>al,
    applyCSS: ()=>op,
    applyDependentState: ()=>Zs,
    applyEvent: ()=>jr,
    applyEventUpdate: ()=>ei,
    applyExtends: ()=>Ds,
    applyProps: ()=>Ms,
    arrayContainsOtherArray: ()=>bd,
    arraysEqual: ()=>kd,
    arrayzeValue: ()=>ln,
    cache: ()=>Th,
    call: ()=>Ii,
    captureSnapshot: ()=>Fi,
    checkForStateTypes: ()=>Qs,
    checkIfInherits: ()=>er,
    checkIfStringIsInArray: ()=>Td,
    clone: ()=>qd,
    cloneAndMergeArrayExtend: ()=>ks,
    cloneFunction: ()=>fh,
    concatAddExtends: ()=>Ts,
    copyJavaScriptToClipboard: ()=>lg,
    copyStringToClipboard: ()=>cg,
    createBasedOnType: ()=>il,
    createElement: ()=>Ys,
    createElementExtends: ()=>Hc,
    createExtends: ()=>As,
    createExtendsFromKeys: ()=>jn,
    createExtendsStack: ()=>Yc,
    createIfConditionFlag: ()=>Br,
    createInheritedState: ()=>Xs,
    createKey: ()=>ws,
    createNestedObject: ()=>ms,
    createNestedObjectByKeyPath: ()=>Js,
    createObjectWithoutPrototype: ()=>Dc,
    createParent: ()=>cl,
    createPath: ()=>ll,
    createProps: ()=>Us,
    createPropsStack: ()=>nl,
    createRoot: ()=>Ks,
    createScope: ()=>Gn,
    createSnapshotId: ()=>_s,
    customDecodeURIComponent: ()=>Ud,
    customEncodeURIComponent: ()=>Bd,
    cutArrayAfterValue: ()=>wd,
    cutArrayBeforeValue: ()=>_d,
    debounce: ()=>sh,
    debounceOnContext: ()=>ih,
    decodeNewlines: ()=>Ld,
    deepClone: ()=>j,
    deepContains: ()=>ds,
    deepDestringifyFunctions: ()=>le,
    deepExtend: ()=>qc,
    deepMerge: ()=>H,
    deepMergeExtends: ()=>ue,
    deepStringifyFunctions: ()=>fs,
    defineSetter: ()=>Xh,
    destringifyGlobalScope: ()=>ps,
    detectInfiniteLoop: ()=>Ss,
    document: ()=>z,
    encodeNewlines: ()=>$d,
    error: ()=>Qr,
    excludeKeysFromObject: ()=>Zd,
    exec: ()=>O,
    extendCachedRegistry: ()=>Sh,
    extendStackRegistry: ()=>Rs,
    extractArrayExtend: ()=>Ps,
    fibonacciNumberByIndex: ()=>Wm,
    filterArrays: ()=>Od,
    filterArraysFast: ()=>Ad,
    finalizeExtends: ()=>Qc,
    findClosestNumber: ()=>Pf,
    findClosestNumberInFactory: ()=>zm,
    findInheritedState: ()=>tr,
    findKeyPosition: ()=>Nd,
    flattenExtend: ()=>Vn,
    formatDate: ()=>Hm,
    generateHash: ()=>Uc,
    generateKey: ()=>xs,
    generateMetaTags: ()=>ng,
    get: ()=>Yh,
    getActiveRoute: ()=>Za,
    getCDNUrl: ()=>re,
    getCapitalCaseKeys: ()=>Ch,
    getCdnProviderFromConfig: ()=>ho,
    getChildStateInKey: ()=>Ze,
    getChildren: ()=>Qh,
    getContext: ()=>Ei,
    getCookie: ()=>mh,
    getDB: ()=>Pi,
    getExtendsInElement: ()=>vh,
    getExtendsStack: ()=>Os,
    getExtendsStackRegistry: ()=>Vc,
    getFrequencyInArray: ()=>Sd,
    getHashedExtend: ()=>Is,
    getImportMapScript: ()=>eg,
    getInObjectByPath: ()=>bs,
    getLocalStorage: ()=>yh,
    getNev: ()=>oh,
    getPageMetadata: ()=>ag,
    getParentStateInKey: ()=>Je,
    getPath: ()=>xi,
    getQuery: ()=>Ni,
    getRef: ()=>Si,
    getRoot: ()=>wi,
    getRootContext: ()=>Ci,
    getRootData: ()=>vi,
    getRootState: ()=>_i,
    getRootStateInKey: ()=>Xe,
    getSpreadChildren: ()=>Eh,
    global: ()=>gd,
    hasFunction: ()=>$n,
    hasHandlerPlugin: ()=>Ke,
    hasOwnProperty: ()=>Kd,
    inheritChildExtends: ()=>Gc,
    inheritChildPropsExtends: ()=>Wc,
    inheritParentProps: ()=>Vs,
    inheritRecursiveChildExtends: ()=>Kc,
    init: ()=>Ue,
    initProps: ()=>Hn,
    is: ()=>At,
    isArray: ()=>_,
    isBoolean: ()=>Pn,
    isContextComponent: ()=>$s,
    isCyclic: ()=>Jd,
    isDOMNode: ()=>Ot,
    isDate: ()=>Rc,
    isDefined: ()=>bt,
    isDevelopment: ()=>Zt,
    isEmpty: ()=>Pc,
    isEmptyObject: ()=>Yd,
    isEqualDeep: ()=>Nc,
    isFunction: ()=>y,
    isHtmlElement: ()=>ts,
    isLocal: ()=>nh,
    isMethod: ()=>Ht,
    isMobile: ()=>dh,
    isNode: ()=>Ce,
    isNot: ()=>Dr,
    isNotProduction: ()=>Mr,
    isNull: ()=>Tc,
    isNumber: ()=>ct,
    isObject: ()=>g,
    isObjectLike: ()=>N,
    isPhoto: ()=>Zm,
    isProduction: ()=>Ge,
    isStaging: ()=>rh,
    isState: ()=>Wn,
    isString: ()=>b,
    isStringFunction: ()=>lh,
    isTest: ()=>Fc,
    isTesting: ()=>eh,
    isUndefined: ()=>K,
    isValidHtmlTag: ()=>ke,
    joinArrays: ()=>Nn,
    jointStacks: ()=>_h,
    keys: ()=>Jn,
    lastLevel: ()=>No,
    lastPathname: ()=>Po,
    loadCssFile: ()=>Qm,
    loadJavascript: ()=>Xm,
    loadJavascriptFile: ()=>Gm,
    loadJavascriptFileEmbedSync: ()=>Ym,
    loadJavascriptFileSync: ()=>Km,
    loadRemoteCSS: ()=>Jm,
    loadRemoteScript: ()=>po,
    log: ()=>ki,
    logGroupIf: ()=>ph,
    logIf: ()=>uh,
    lookdown: ()=>mi,
    lookdownAll: ()=>gi,
    lookup: ()=>hi,
    lowercaseFirstLetter: ()=>ce,
    makeObjectWithoutPrototype: ()=>Qd,
    map: ()=>Vd,
    mapStringsWithContextComponents: ()=>Ns,
    matchRoute: ()=>Qa,
    matchesComponentNaming: ()=>It,
    memoize: ()=>ah,
    merge: ()=>Y,
    nextElement: ()=>Ai,
    objectToString: ()=>us,
    objectizeStringProperty: ()=>Ls,
    overwrite: ()=>fe,
    overwriteDeep: ()=>it,
    overwriteShallow: ()=>Lr,
    overwriteState: ()=>ti,
    parse: ()=>Zn,
    parseDeep: ()=>Yr,
    parseQuery: ()=>Xa,
    parseRoutePattern: ()=>Ya,
    pickupElementFromProps: ()=>Ur,
    pickupPropsFromElement: ()=>el,
    previousElement: ()=>Ti,
    propExists: ()=>Ah,
    propertizeElement: ()=>zn,
    propertizeUpdate: ()=>js,
    reinit: ()=>np,
    remove: ()=>yi,
    removeChars: ()=>fg,
    removeCookie: ()=>gh,
    removeDuplicateProps: ()=>zs,
    removeDuplicatesInArray: ()=>Dn,
    removeFromArray: ()=>rs,
    removeFromObject: ()=>hs,
    removeNestedKeyByPath: ()=>gs,
    removeValueFromArray: ()=>os,
    removeValueFromArrayAll: ()=>vd,
    reorderArrayByValues: ()=>Ed,
    replaceLiteralsWithObjectFields: ()=>Pd,
    replaceOctalEscapeSequences: ()=>Fd,
    report: ()=>gt,
    resolveHandler: ()=>Ye,
    returnValueAsText: ()=>sl,
    router: ()=>oe,
    runGuards: ()=>Ja,
    runPluginHook: ()=>Mn,
    scratchSystem: ()=>xo,
    scratchUtils: ()=>br,
    self: ()=>yd,
    set: ()=>dn,
    setCookie: ()=>hh,
    setHashedExtend: ()=>jc,
    setInObjectByPath: ()=>ys,
    setLocalStorage: ()=>bh,
    setNodeStyles: ()=>Xn,
    setProps: ()=>bi,
    setPropsPrototype: ()=>qs,
    spotByPath: ()=>di,
    stringIncludesAny: ()=>is,
    stringToObject: ()=>Gd,
    swapItemsInArray: ()=>xd,
    syncProps: ()=>Hs,
    toCamelCase: ()=>Ki,
    toDashCase: ()=>Yi,
    toDescriptionCase: ()=>pg,
    toTitleCase: ()=>ug,
    toggleFullscreen: ()=>qm,
    triggerEventOn: ()=>W,
    triggerEventOnUpdate: ()=>vt,
    trimStringFromSymbols: ()=>Rd,
    unstackArrayOfObjects: ()=>ns,
    update: ()=>rl,
    updateProps: ()=>Ws,
    variables: ()=>Ri,
    verbose: ()=>to,
    warn: ()=>Oi,
    window: ()=>D
});
v();
v();
var dx = E(), rp = (t = dx, e)=>{
    let r = g(e.localFile) ? e.localFile : {}, n = j(r.designSystem || {});
    return H(t, n);
}, hx = {
    emotion: Ct,
    useVariable: !0,
    useReset: !0,
    useFontImport: !0,
    useIconSprite: !0,
    useDocumentTheme: !0,
    useSvgSprite: !0
}, Ue = (t, e = hx)=>{
    let r = e.emotion || Ct, n = rp(t || {}, e), o = dn({
        verbose: e.verbose,
        useReset: e.useReset,
        useFontImport: e.useFontImport,
        useVariable: e.useVariable,
        useSvgSprite: e.useSvgSprite,
        useDocumentTheme: e.useDocumentTheme,
        useIconSprite: e.useIconSprite,
        useDefaultConfig: e.useDefaultConfig,
        globalTheme: e.globalTheme,
        files: e.files,
        ...n
    }, {
        newConfig: e.newConfig
    }), s = Gi(o.font, o.files), i = o.useReset, a = o.useVariable, c = o.useFontImport, f = o.useSvgSprite, l = t.svg, u = o.useIconSprite, p = t.icons;
    if (c && r.injectGlobal(s), a && (r.injectGlobal({
        ":root": o.CSS_VARS
    }), o.CSS_MEDIA_VARS)) {
        let d = {};
        for(let m in o.CSS_MEDIA_VARS)m.startsWith("@media") ? d[m] = {
            ":root:not([data-theme])": o.CSS_MEDIA_VARS[m]
        } : d[m] = o.CSS_MEDIA_VARS[m];
        r.injectGlobal(d);
    }
    i && r.injectGlobal(o.reset);
    let h = o.animation;
    if (h) {
        let d = {};
        for(let m in h)d[`@keyframes ${m}`] = h[m];
        r.injectGlobal(d);
    }
    return (l || f) && Ca(o.svg, {
        document: e.document
    }), (p || u) && ka(o.icons, {
        document: e.document
    }), o;
}, Do = {
    emotion: Ct
}, np = (t, e = Do)=>{
    let r = e.emotion || Ct, n = rp(t || {}, e), o = dn({
        verbose: !1,
        ...n
    });
    if (!e.preventInject) {
        if (r.injectGlobal({
            ":root": o.CSS_VARS
        }), o.CSS_MEDIA_VARS) {
            let s = {};
            for(let i in o.CSS_MEDIA_VARS)i.startsWith("@media") ? s[i] = {
                ":root:not([data-theme])": o.CSS_MEDIA_VARS[i]
            } : s[i] = o.CSS_MEDIA_VARS[i];
            r.injectGlobal(s);
        }
        r.injectGlobal(o.reset);
    }
    return o;
}, op = (t, e = Do)=>{
    (e.emotion || Ct).injectGlobal(t);
}, $T = (t, e = Do)=>{
    let r = e.emotion || Ct;
    if (r.injectGlobal({
        ":root": t.CSS_VARS
    }), t.CSS_MEDIA_VARS) {
        let n = {};
        for(let o in t.CSS_MEDIA_VARS)o.startsWith("@media") ? n[o] = {
            ":root:not([data-theme])": t.CSS_MEDIA_VARS[o]
        } : n[o] = t.CSS_MEDIA_VARS[o];
        r.injectGlobal(n);
    }
};
var LT = (t, e = Do)=>{};
v();
var ec = {
    initRouter: !0,
    injectRouterInLinkComponent: !0,
    popState: !0
}, sp = (t, e)=>{
    if (!e) return t;
    let r = Array.isArray(e) ? e : e.split("."), n = t;
    for (let o of r){
        if (!n || !n[o]) return null;
        n = n[o];
    }
    return n;
}, ip = (t, e)=>{
    if (e.router === !1) return;
    e.router === !0 ? e.router = ec : e.router = Y(e.router || {}, ec);
    let r = e.router, n = async (s, i)=>{
        if (!D.location) return;
        let { pathname: a, search: c, hash: f } = D.location, l = a + c + f, u = s;
        if (r.customRouterElement) {
            let p = sp(s, r.customRouterElement);
            p && (u = p, s.routes && (u.routes = s.routes));
        }
        u.routes && await oe(l, u, {}, {
            initialRender: !0
        });
    }, o = t.on && !K(t.on.renderRouter) || !K(t.onRenderRouter);
    return r && r.initRouter && !o && (t.on ? t.on.renderRouter = n : t.on = {
        renderRouter: n
    }), mx(e, r), r;
}, ap = (t, e)=>{
    let r = e.router || ec;
    if (!r.popState) return;
    let n = e.utils && e.utils.router ? e.utils.router : oe;
    D.onpopstate = async (o)=>{
        let { pathname: s, search: i, hash: a } = D.location, c = s + i + a, f = t;
        if (r.customRouterElement) {
            let l = sp(t, r.customRouterElement);
            l && (f = l, t.routes && (f.routes = t.routes));
        }
        await f.call("router", c, f, {}, {
            pushState: !1,
            scrollToTop: !1,
            level: 0,
            event: o
        });
    };
}, mx = (t, e)=>{
    let { components: r } = t;
    if (e && e.injectRouterInLinkComponent) return H(r.Link || r["smbls.Link"], r.RouterLink || r["smbls.RouterLink"]);
};
v();
var rc = D && D.location ? D.location.host.includes("dev.") : Zt(), cp = rc ? "http://localhost:8080/get" : "https://api.symbols.app/get", gx = {
    endpoint: cp
}, lp = async (t, e = gx)=>{
    let r = e.endpoint || cp, n = e.serviceRoute ? _(e.serviceRoute) ? e.serviceRoute.map((s)=>s.toLowerCase() + "=true").join("&") : e.serviceRoute : "", o;
    try {
        return o = await globalThis.fetch(r + "/?" + n, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": t,
                "X-Metadata": e.metadata
            }
        }), await o.json();
    } catch (s) {
        if (y(e.onError)) return e.onError(s);
        console.error(s);
    }
}, yx = async (t, e)=>{
    let { editor: r } = e;
    if (r && r.remote) {
        let n = await lp(t, r), o = rc || e.isDevelopment ? le(n) : le(n.releases[0]);
        r.serviceRoute ? _(r.serviceRoute) ? r.serviceRoute.forEach((s)=>{
            it(e[s], o[s.toLowerCase()]);
        }) : it(e[r.serviceRoute], o) : [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages",
            "utils",
            "files",
            "packages",
            "functions",
            "globalScope"
        ].forEach((s)=>{
            it(e[s], o[s.toLowerCase()]);
        });
    }
    return e;
}, bx = async (t, e, r)=>{
    let { editor: n } = e;
    if (n && n.remote) {
        let o = await lp(t, n), s = rc || e.isDevelopment ? le(o) : le(o.releases[0]);
        r(s);
    }
}, fp = async (t, e)=>{
    if (t && e.editor) try {
        e.editor.async || await yx(t, e);
    } catch (r) {
        console.error(r);
    }
}, up = (t, e, r, n)=>{
    if (e && r.editor) try {
        r.editor.async && bx(e, r, n || ((o)=>{
            let s = o.designSystem;
            g(s) && r.utils.init(s), g(o.state) && t.state.set(o.state);
        }));
    } catch (o) {
        console.error(o);
    }
};
v();
var Sx = {
    title: {
        tag: "title"
    },
    description: {
        tag: "meta",
        attr: "name",
        key: "description"
    },
    keywords: {
        tag: "meta",
        attr: "name",
        key: "keywords"
    },
    robots: {
        tag: "meta",
        attr: "name",
        key: "robots"
    },
    author: {
        tag: "meta",
        attr: "name",
        key: "author"
    },
    canonical: {
        tag: "link",
        attr: "rel",
        key: "canonical",
        valueAttr: "href"
    },
    image: {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    url: {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    siteName: {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    type: {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    locale: {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "og:title": {
        tag: "meta",
        attr: "property",
        key: "og:title"
    },
    "og:description": {
        tag: "meta",
        attr: "property",
        key: "og:description"
    },
    "og:image": {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    "og:url": {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    "og:type": {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    "og:site_name": {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    "og:locale": {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "twitter:card": {
        tag: "meta",
        attr: "name",
        key: "twitter:card"
    },
    "twitter:title": {
        tag: "meta",
        attr: "name",
        key: "twitter:title"
    },
    "twitter:description": {
        tag: "meta",
        attr: "name",
        key: "twitter:description"
    },
    "twitter:image": {
        tag: "meta",
        attr: "name",
        key: "twitter:image"
    },
    "twitter:site": {
        tag: "meta",
        attr: "name",
        key: "twitter:site"
    },
    "theme-color": {
        tag: "meta",
        attr: "name",
        key: "theme-color"
    }
}, xx = (t)=>{
    if (t.tag === "link") return `link[${t.attr}="${t.key}"]`;
    if (t.tag && !t.attr && !t.key) return t.tag;
    if (t.tag && t.attr && t.key) return `${t.tag}[${t.attr}="${t.key}"]`;
}, Fo = (t, e, r)=>{
    if (!t) return {};
    let n = y(t) ? O(t, e, r) : {
        ...t
    };
    if (!g(n)) return {};
    for(let o in n){
        let s = n[o];
        y(s) && (s = O(s, e, r)), b(s) && s.includes("{{") && e?.call && (s = e.call("replaceLiteralsWithObjectFields", s, r)), n[o] = s;
    }
    return n;
};
var _x = (t, e)=>{
    let r = e.createElement(t.tag);
    return t.attr && r.setAttribute(t.attr, t.key), (e.head || e.querySelector("head")).appendChild(r), r;
}, $o = (t, e)=>{
    if (!(!g(t) || !e)) for(let r in t){
        let n = t[r];
        if (n == null) continue;
        let o = Sx[r];
        if (!o) continue;
        let s = xx(o), i = e.querySelector(s) || _x(o, e);
        i && (r === "title" ? i.textContent = n : o.valueAttr ? i.setAttribute(o.valueAttr, n) : i.setAttribute("content", n));
    }
};
var pp = {
    name: "helmet",
    create (t) {
        let e = t.metadata || t.props?.metadata;
        if (!e) return;
        let r = t.context?.document || typeof document < "u" && document;
        if (!r) return;
        let n = Fo(e, t, t.state);
        $o(n, r);
    },
    update (t) {
        let e = t.metadata || t.props?.metadata;
        if (!e) return;
        let r = t.context?.document || typeof document < "u" && document;
        if (!r) return;
        let n = Fo(e, t, t.state);
        $o(n, r);
    }
};
Ae();
var dp = (t, e, r, n)=>{
    t && Gr(t, e, r, n);
}, hp = (t, e, r)=>{
    if (!t) return;
    let n = e.context?.document || typeof document < "u" && document;
    if (!n) return;
    let o = Fo(t, e, r);
    $o(o, n);
}, mp = async (t, e)=>{
    if (!t) return;
    let r = {
        tag: "fragment",
        ...t
    }, n = async ()=>{
        await e.set(r, {
            preventDefineUpdate: "$router"
        });
    };
    return e.props && e.props.lazyLoad ? window.requestAnimationFrame(n) : await n(), r;
}, Sn = {
    routes: (t)=>t,
    metadata: hp,
    fetch: dp,
    $router: mp
}, wx = (t = {})=>{
    let e = {
        routes: (r)=>r
    };
    return t.metadata !== !1 && (e.metadata = hp), t.fetch !== !1 && (e.fetch = dp), t.router !== !1 && (e.$router = mp), e;
};
var gp = {
    useReset: !0,
    useVariable: !0,
    useIconSprite: !0,
    useSvgSprite: !0,
    useDocumentTheme: !0,
    useDefaultIcons: !0,
    useFontImport: !0,
    useDefaultConfig: !0
}, nc = {
    initRouter: !0,
    popState: !0,
    injectRouterInLinkComponent: !0
}, oc = {
    ...gp,
    router: nc
}, vx = {
    state: {},
    pages: {},
    components: {},
    router: nc,
    define: Sn
}, xe = vx;
var Cx = (t, e, r, n)=>{
    let o = (Io.default || Io)(t, e, r, n);
    return o.on?.complete && o.on.complete(t, t.state, t.context, n), o.props?.onComplete && o.props?.onComplete(t, t.state, t.context, n), o.on?.initInspect && o.on.initInspect(t, t.state, t.context, n), o.on?.initSync && o.on.initSync(t, t.state, t.context, n), o;
}, Lo = {
    TREE: za,
    create: Cx
};
v();
v();
var qt = Object.create(null);
qt.open = "0";
qt.close = "1";
qt.ping = "2";
qt.pong = "3";
qt.message = "4";
qt.upgrade = "5";
qt.noop = "6";
var xn = Object.create(null);
Object.keys(qt).forEach((t)=>{
    xn[qt[t]] = t;
});
var _n = {
    type: "error",
    data: "parser error"
};
var Sp = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", xp = typeof ArrayBuffer == "function", _p = (t)=>typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t && t.buffer instanceof ArrayBuffer, wn = ({ type: t, data: e }, r, n)=>Sp && e instanceof Blob ? r ? n(e) : yp(e, n) : xp && (e instanceof ArrayBuffer || _p(e)) ? r ? n(e) : yp(new Blob([
        e
    ]), n) : n(qt[t] + (e || "")), yp = (t, e)=>{
    let r = new FileReader;
    return r.onload = function() {
        let n = r.result.split(",")[1];
        e("b" + (n || ""));
    }, r.readAsDataURL(t);
};
function bp(t) {
    return t instanceof Uint8Array ? t : t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
}
var sc;
function wp(t, e) {
    if (Sp && t.data instanceof Blob) return t.data.arrayBuffer().then(bp).then(e);
    if (xp && (t.data instanceof ArrayBuffer || _p(t.data))) return e(bp(t.data));
    wn(t, !1, (r)=>{
        sc || (sc = new TextEncoder), e(sc.encode(r));
    });
}
var vp = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", vn = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for(let t = 0; t < vp.length; t++)vn[vp.charCodeAt(t)] = t;
var Cp = (t)=>{
    let e = t.length * .75, r = t.length, n, o = 0, s, i, a, c;
    t[t.length - 1] === "=" && (e--, t[t.length - 2] === "=" && e--);
    let f = new ArrayBuffer(e), l = new Uint8Array(f);
    for(n = 0; n < r; n += 4)s = vn[t.charCodeAt(n)], i = vn[t.charCodeAt(n + 1)], a = vn[t.charCodeAt(n + 2)], c = vn[t.charCodeAt(n + 3)], l[o++] = s << 2 | i >> 4, l[o++] = (i & 15) << 4 | a >> 2, l[o++] = (a & 3) << 6 | c & 63;
    return f;
};
var Ex = typeof ArrayBuffer == "function", Cn = (t, e)=>{
    if (typeof t != "string") return {
        type: "message",
        data: Ep(t, e)
    };
    let r = t.charAt(0);
    return r === "b" ? {
        type: "message",
        data: kx(t.substring(1), e)
    } : xn[r] ? t.length > 1 ? {
        type: xn[r],
        data: t.substring(1)
    } : {
        type: xn[r]
    } : _n;
}, kx = (t, e)=>{
    if (Ex) {
        let r = Cp(t);
        return Ep(r, e);
    } else return {
        base64: !0,
        data: t
    };
}, Ep = (t, e)=>e === "blob" ? t instanceof Blob ? t : new Blob([
        t
    ]) : t instanceof ArrayBuffer ? t : t.buffer;
var kp = "", Op = (t, e)=>{
    let r = t.length, n = new Array(r), o = 0;
    t.forEach((s, i)=>{
        wn(s, !1, (a)=>{
            n[i] = a, ++o === r && e(n.join(kp));
        });
    });
}, Ap = (t, e)=>{
    let r = t.split(kp), n = [];
    for(let o = 0; o < r.length; o++){
        let s = Cn(r[o], e);
        if (n.push(s), s.type === "error") break;
    }
    return n;
};
function Tp() {
    return new TransformStream({
        transform (t, e) {
            wp(t, (r)=>{
                let n = r.length, o;
                if (n < 126) o = new Uint8Array(1), new DataView(o.buffer).setUint8(0, n);
                else if (n < 65536) {
                    o = new Uint8Array(3);
                    let s = new DataView(o.buffer);
                    s.setUint8(0, 126), s.setUint16(1, n);
                } else {
                    o = new Uint8Array(9);
                    let s = new DataView(o.buffer);
                    s.setUint8(0, 127), s.setBigUint64(1, BigInt(n));
                }
                t.data && typeof t.data != "string" && (o[0] |= 128), e.enqueue(o), e.enqueue(r);
            });
        }
    });
}
var ic;
function Mo(t) {
    return t.reduce((e, r)=>e + r.length, 0);
}
function Bo(t, e) {
    if (t[0].length === e) return t.shift();
    let r = new Uint8Array(e), n = 0;
    for(let o = 0; o < e; o++)r[o] = t[0][n++], n === t[0].length && (t.shift(), n = 0);
    return t.length && n < t[0].length && (t[0] = t[0].slice(n)), r;
}
function Rp(t, e) {
    ic || (ic = new TextDecoder);
    let r = [], n = 0, o = -1, s = !1;
    return new TransformStream({
        transform (i, a) {
            for(r.push(i);;){
                if (n === 0) {
                    if (Mo(r) < 1) break;
                    let c = Bo(r, 1);
                    s = (c[0] & 128) === 128, o = c[0] & 127, o < 126 ? n = 3 : o === 126 ? n = 1 : n = 2;
                } else if (n === 1) {
                    if (Mo(r) < 2) break;
                    let c = Bo(r, 2);
                    o = new DataView(c.buffer, c.byteOffset, c.length).getUint16(0), n = 3;
                } else if (n === 2) {
                    if (Mo(r) < 8) break;
                    let c = Bo(r, 8), f = new DataView(c.buffer, c.byteOffset, c.length), l = f.getUint32(0);
                    if (l > Math.pow(2, 21) - 1) {
                        a.enqueue(_n);
                        break;
                    }
                    o = l * Math.pow(2, 32) + f.getUint32(4), n = 3;
                } else {
                    if (Mo(r) < o) break;
                    let c = Bo(r, o);
                    a.enqueue(Cn(s ? c : ic.decode(c), e)), n = 0;
                }
                if (o === 0 || o > t) {
                    a.enqueue(_n);
                    break;
                }
            }
        }
    });
}
var ac = 4;
function Q(t) {
    if (t) return Ox(t);
}
function Ox(t) {
    for(var e in Q.prototype)t[e] = Q.prototype[e];
    return t;
}
Q.prototype.on = Q.prototype.addEventListener = function(t, e) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
};
Q.prototype.once = function(t, e) {
    function r() {
        this.off(t, r), e.apply(this, arguments);
    }
    return r.fn = e, this.on(t, r), this;
};
Q.prototype.off = Q.prototype.removeListener = Q.prototype.removeAllListeners = Q.prototype.removeEventListener = function(t, e) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0) return this._callbacks = {}, this;
    var r = this._callbacks["$" + t];
    if (!r) return this;
    if (arguments.length == 1) return delete this._callbacks["$" + t], this;
    for(var n, o = 0; o < r.length; o++)if (n = r[o], n === e || n.fn === e) {
        r.splice(o, 1);
        break;
    }
    return r.length === 0 && delete this._callbacks["$" + t], this;
};
Q.prototype.emit = function(t) {
    this._callbacks = this._callbacks || {};
    for(var e = new Array(arguments.length - 1), r = this._callbacks["$" + t], n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
    if (r) {
        r = r.slice(0);
        for(var n = 0, o = r.length; n < o; ++n)r[n].apply(this, e);
    }
    return this;
};
Q.prototype.emitReserved = Q.prototype.emit;
Q.prototype.listeners = function(t) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
};
Q.prototype.hasListeners = function(t) {
    return !!this.listeners(t).length;
};
var se = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e)=>Promise.resolve().then(e) : (e, r)=>r(e, 0), yt = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), Ip = "arraybuffer";
function Uo(t, ...e) {
    return e.reduce((r, n)=>(t.hasOwnProperty(n) && (r[n] = t[n]), r), {});
}
var Ax = yt.setTimeout, Tx = yt.clearTimeout;
function ie(t, e) {
    e.useNativeTimers ? (t.setTimeoutFn = Ax.bind(yt), t.clearTimeoutFn = Tx.bind(yt)) : (t.setTimeoutFn = yt.setTimeout.bind(yt), t.clearTimeoutFn = yt.clearTimeout.bind(yt));
}
var Rx = 1.33;
function Pp(t) {
    return typeof t == "string" ? Ix(t) : Math.ceil((t.byteLength || t.size) * Rx);
}
function Ix(t) {
    let e = 0, r = 0;
    for(let n = 0, o = t.length; n < o; n++)e = t.charCodeAt(n), e < 128 ? r += 1 : e < 2048 ? r += 2 : e < 55296 || e >= 57344 ? r += 3 : (n++, r += 4);
    return r;
}
function jo() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function Np(t) {
    let e = "";
    for(let r in t)t.hasOwnProperty(r) && (e.length && (e += "&"), e += encodeURIComponent(r) + "=" + encodeURIComponent(t[r]));
    return e;
}
function Dp(t) {
    let e = {}, r = t.split("&");
    for(let n = 0, o = r.length; n < o; n++){
        let s = r[n].split("=");
        e[decodeURIComponent(s[0])] = decodeURIComponent(s[1]);
    }
    return e;
}
var Vo = class extends Error {
    constructor(e, r, n){
        super(e), this.description = r, this.context = n, this.type = "TransportError";
    }
}, ae = class extends Q {
    constructor(e){
        super(), this.writable = !1, ie(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
    }
    onError(e, r, n) {
        return super.emitReserved("error", new Vo(e, r, n)), this;
    }
    open() {
        return this.readyState = "opening", this.doOpen(), this;
    }
    close() {
        return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
    }
    send(e) {
        this.readyState === "open" && this.write(e);
    }
    onOpen() {
        this.readyState = "open", this.writable = !0, super.emitReserved("open");
    }
    onData(e) {
        let r = Cn(e, this.socket.binaryType);
        this.onPacket(r);
    }
    onPacket(e) {
        super.emitReserved("packet", e);
    }
    onClose(e) {
        this.readyState = "closed", super.emitReserved("close", e);
    }
    pause(e) {}
    createUri(e, r = {}) {
        return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(r);
    }
    _hostname() {
        let e = this.opts.hostname;
        return e.indexOf(":") === -1 ? e : "[" + e + "]";
    }
    _port() {
        return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
    }
    _query(e) {
        let r = Np(e);
        return r.length ? "?" + r : "";
    }
};
var En = class extends ae {
    constructor(){
        super(...arguments), this._polling = !1;
    }
    get name() {
        return "polling";
    }
    doOpen() {
        this._poll();
    }
    pause(e) {
        this.readyState = "pausing";
        let r = ()=>{
            this.readyState = "paused", e();
        };
        if (this._polling || !this.writable) {
            let n = 0;
            this._polling && (n++, this.once("pollComplete", function() {
                --n || r();
            })), this.writable || (n++, this.once("drain", function() {
                --n || r();
            }));
        } else r();
    }
    _poll() {
        this._polling = !0, this.doPoll(), this.emitReserved("poll");
    }
    onData(e) {
        let r = (n)=>{
            if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close") return this.onClose({
                description: "transport closed by the server"
            }), !1;
            this.onPacket(n);
        };
        Ap(e, this.socket.binaryType).forEach(r), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
    }
    doClose() {
        let e = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        this.readyState === "open" ? e() : this.once("open", e);
    }
    write(e) {
        this.writable = !1, Op(e, (r)=>{
            this.doWrite(r, ()=>{
                this.writable = !0, this.emitReserved("drain");
            });
        });
    }
    uri() {
        let e = this.opts.secure ? "https" : "http", r = this.query || {};
        return this.opts.timestampRequests !== !1 && (r[this.opts.timestampParam] = jo()), !this.supportsBinary && !r.sid && (r.b64 = 1), this.createUri(e, r);
    }
};
var Fp = !1;
try {
    Fp = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest;
} catch  {}
var $p = Fp;
function Px() {}
var cc = class extends En {
    constructor(e){
        if (super(e), typeof location < "u") {
            let r = location.protocol === "https:", n = location.port;
            n || (n = r ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
        }
    }
    doWrite(e, r) {
        let n = this.request({
            method: "POST",
            data: e
        });
        n.on("success", r), n.on("error", (o, s)=>{
            this.onError("xhr post error", o, s);
        });
    }
    doPoll() {
        let e = this.request();
        e.on("data", this.onData.bind(this)), e.on("error", (r, n)=>{
            this.onError("xhr poll error", r, n);
        }), this.pollXhr = e;
    }
}, _e = class t extends Q {
    constructor(e, r, n){
        super(), this.createRequest = e, ie(this, n), this._opts = n, this._method = n.method || "GET", this._uri = r, this._data = n.data !== void 0 ? n.data : null, this._create();
    }
    _create() {
        var e;
        let r = Uo(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        r.xdomain = !!this._opts.xd;
        let n = this._xhr = this.createRequest(r);
        try {
            n.open(this._method, this._uri, !0);
            try {
                if (this._opts.extraHeaders) {
                    n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
                    for(let o in this._opts.extraHeaders)this._opts.extraHeaders.hasOwnProperty(o) && n.setRequestHeader(o, this._opts.extraHeaders[o]);
                }
            } catch  {}
            if (this._method === "POST") try {
                n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch  {}
            try {
                n.setRequestHeader("Accept", "*/*");
            } catch  {}
            (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = ()=>{
                var o;
                n.readyState === 3 && ((o = this._opts.cookieJar) === null || o === void 0 || o.parseCookies(n.getResponseHeader("set-cookie"))), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(()=>{
                    this._onError(typeof n.status == "number" ? n.status : 0);
                }, 0));
            }, n.send(this._data);
        } catch (o) {
            this.setTimeoutFn(()=>{
                this._onError(o);
            }, 0);
            return;
        }
        typeof document < "u" && (this._index = t.requestsCount++, t.requests[this._index] = this);
    }
    _onError(e) {
        this.emitReserved("error", e, this._xhr), this._cleanup(!0);
    }
    _cleanup(e) {
        if (!(typeof this._xhr > "u" || this._xhr === null)) {
            if (this._xhr.onreadystatechange = Px, e) try {
                this._xhr.abort();
            } catch  {}
            typeof document < "u" && delete t.requests[this._index], this._xhr = null;
        }
    }
    _onLoad() {
        let e = this._xhr.responseText;
        e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
    }
    abort() {
        this._cleanup();
    }
};
_e.requestsCount = 0;
_e.requests = {};
if (typeof document < "u") {
    if (typeof attachEvent == "function") attachEvent("onunload", Lp);
    else if (typeof addEventListener == "function") {
        let t = "onpagehide" in yt ? "pagehide" : "unload";
        addEventListener(t, Lp, !1);
    }
}
function Lp() {
    for(let t in _e.requests)_e.requests.hasOwnProperty(t) && _e.requests[t].abort();
}
var Nx = function() {
    let t = Mp({
        xdomain: !1
    });
    return t && t.responseType !== null;
}(), we = class extends cc {
    constructor(e){
        super(e);
        let r = e && e.forceBase64;
        this.supportsBinary = Nx && !r;
    }
    request(e = {}) {
        return Object.assign(e, {
            xd: this.xd
        }, this.opts), new _e(Mp, this.uri(), e);
    }
};
function Mp(t) {
    let e = t.xdomain;
    try {
        if (typeof XMLHttpRequest < "u" && (!e || $p)) return new XMLHttpRequest;
    } catch  {}
    if (!e) try {
        return new yt[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch  {}
}
var Bp = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", fc = class extends ae {
    get name() {
        return "websocket";
    }
    doOpen() {
        let e = this.uri(), r = this.opts.protocols, n = Bp ? {} : Uo(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
        try {
            this.ws = this.createSocket(e, r, n);
        } catch (o) {
            return this.emitReserved("error", o);
        }
        this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
    }
    addEventListeners() {
        this.ws.onopen = ()=>{
            this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
        }, this.ws.onclose = (e)=>this.onClose({
                description: "websocket connection closed",
                context: e
            }), this.ws.onmessage = (e)=>this.onData(e.data), this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(e) {
        this.writable = !1;
        for(let r = 0; r < e.length; r++){
            let n = e[r], o = r === e.length - 1;
            wn(n, this.supportsBinary, (s)=>{
                try {
                    this.doWrite(n, s);
                } catch  {}
                o && se(()=>{
                    this.writable = !0, this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        typeof this.ws < "u" && (this.ws.onerror = ()=>{}, this.ws.close(), this.ws = null);
    }
    uri() {
        let e = this.opts.secure ? "wss" : "ws", r = this.query || {};
        return this.opts.timestampRequests && (r[this.opts.timestampParam] = jo()), this.supportsBinary || (r.b64 = 1), this.createUri(e, r);
    }
}, lc = yt.WebSocket || yt.MozWebSocket, ve = class extends fc {
    createSocket(e, r, n) {
        return Bp ? new lc(e, r, n) : r ? new lc(e, r) : new lc(e);
    }
    doWrite(e, r) {
        this.ws.send(r);
    }
};
var Er = class extends ae {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (e) {
            return this.emitReserved("error", e);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((e)=>{
            this.onError("webtransport error", e);
        }), this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((e)=>{
                let r = Rp(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = e.readable.pipeThrough(r).getReader(), o = Tp();
                o.readable.pipeTo(e.writable), this._writer = o.writable.getWriter();
                let s = ()=>{
                    n.read().then(({ done: a, value: c })=>{
                        a || (this.onPacket(c), s());
                    }).catch((a)=>{});
                };
                s();
                let i = {
                    type: "open"
                };
                this.query.sid && (i.data = `{"sid":"${this.query.sid}"}`), this._writer.write(i).then(()=>this.onOpen());
            });
        });
    }
    write(e) {
        this.writable = !1;
        for(let r = 0; r < e.length; r++){
            let n = e[r], o = r === e.length - 1;
            this._writer.write(n).then(()=>{
                o && se(()=>{
                    this.writable = !0, this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var e;
        (e = this._transport) === null || e === void 0 || e.close();
    }
};
var uc = {
    websocket: ve,
    webtransport: Er,
    polling: we
};
var Dx = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Fx = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function kr(t) {
    if (t.length > 8e3) throw "URI too long";
    let e = t, r = t.indexOf("["), n = t.indexOf("]");
    r != -1 && n != -1 && (t = t.substring(0, r) + t.substring(r, n).replace(/:/g, ";") + t.substring(n, t.length));
    let o = Dx.exec(t || ""), s = {}, i = 14;
    for(; i--;)s[Fx[i]] = o[i] || "";
    return r != -1 && n != -1 && (s.source = e, s.host = s.host.substring(1, s.host.length - 1).replace(/;/g, ":"), s.authority = s.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), s.ipv6uri = !0), s.pathNames = $x(s, s.path), s.queryKey = Lx(s, s.query), s;
}
function $x(t, e) {
    let r = /\/{2,9}/g, n = e.replace(r, "/").split("/");
    return (e.slice(0, 1) == "/" || e.length === 0) && n.splice(0, 1), e.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function Lx(t, e) {
    let r = {};
    return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, o, s) {
        o && (r[o] = s);
    }), r;
}
var pc = typeof addEventListener == "function" && typeof removeEventListener == "function", qo = [];
pc && addEventListener("offline", ()=>{
    qo.forEach((t)=>t());
}, !1);
var je = class t extends Q {
    constructor(e, r){
        if (super(), this.binaryType = Ip, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (r = e, e = null), e) {
            let n = kr(e);
            r.hostname = n.host, r.secure = n.protocol === "https" || n.protocol === "wss", r.port = n.port, n.query && (r.query = n.query);
        } else r.host && (r.hostname = kr(r.host).host);
        ie(this, r), this.secure = r.secure != null ? r.secure : typeof location < "u" && location.protocol === "https:", r.hostname && !r.port && (r.port = this.secure ? "443" : "80"), this.hostname = r.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = r.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, r.transports.forEach((n)=>{
            let o = n.prototype.name;
            this.transports.push(o), this._transportsByName[o] = n;
        }), this.opts = Object.assign({
            path: "/engine.io",
            agent: !1,
            withCredentials: !1,
            upgrade: !0,
            timestampParam: "t",
            rememberUpgrade: !1,
            addTrailingSlash: !0,
            rejectUnauthorized: !0,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: !1
        }, r), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = Dp(this.opts.query)), pc && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = ()=>{
            this.transport && (this.transport.removeAllListeners(), this.transport.close());
        }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = ()=>{
            this._onClose("transport close", {
                description: "network connection lost"
            });
        }, qo.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
    }
    createTransport(e) {
        let r = Object.assign({}, this.opts.query);
        r.EIO = ac, r.transport = e, this.id && (r.sid = this.id);
        let n = Object.assign({}, this.opts, {
            query: r,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[e]);
        return new this._transportsByName[e](n);
    }
    _open() {
        if (this.transports.length === 0) {
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        let e = this.opts.rememberUpgrade && t.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        let r = this.createTransport(e);
        r.open(), this.setTransport(r);
    }
    setTransport(e) {
        this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (r)=>this._onClose("transport close", r));
    }
    onOpen() {
        this.readyState = "open", t.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
    }
    _onPacket(e) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") switch(this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type){
            case "open":
                this.onHandshake(JSON.parse(e.data));
                break;
            case "ping":
                this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
                break;
            case "error":
                let r = new Error("server error");
                r.code = e.data, this._onError(r);
                break;
            case "message":
                this.emitReserved("data", e.data), this.emitReserved("message", e.data);
                break;
        }
    }
    onHandshake(e) {
        this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
    }
    _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        let e = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
    }
    _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
    }
    flush() {
        if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            let e = this._getWritablePackets();
            this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
        }
    }
    _getWritablePackets() {
        if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1)) return this.writeBuffer;
        let r = 1;
        for(let n = 0; n < this.writeBuffer.length; n++){
            let o = this.writeBuffer[n].data;
            if (o && (r += Pp(o)), n > 0 && r > this._maxPayload) return this.writeBuffer.slice(0, n);
            r += 2;
        }
        return this.writeBuffer;
    }
    _hasPingExpired() {
        if (!this._pingTimeoutTime) return !0;
        let e = Date.now() > this._pingTimeoutTime;
        return e && (this._pingTimeoutTime = 0, se(()=>{
            this._onClose("ping timeout");
        }, this.setTimeoutFn)), e;
    }
    write(e, r, n) {
        return this._sendPacket("message", e, r, n), this;
    }
    send(e, r, n) {
        return this._sendPacket("message", e, r, n), this;
    }
    _sendPacket(e, r, n, o) {
        if (typeof r == "function" && (o = r, r = void 0), typeof n == "function" && (o = n, n = null), this.readyState === "closing" || this.readyState === "closed") return;
        n = n || {}, n.compress = n.compress !== !1;
        let s = {
            type: e,
            data: r,
            options: n
        };
        this.emitReserved("packetCreate", s), this.writeBuffer.push(s), o && this.once("flush", o), this.flush();
    }
    close() {
        let e = ()=>{
            this._onClose("forced close"), this.transport.close();
        }, r = ()=>{
            this.off("upgrade", r), this.off("upgradeError", r), e();
        }, n = ()=>{
            this.once("upgrade", r), this.once("upgradeError", r);
        };
        return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", ()=>{
            this.upgrading ? n() : e();
        }) : this.upgrading ? n() : e()), this;
    }
    _onError(e) {
        if (t.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") return this.transports.shift(), this._open();
        this.emitReserved("error", e), this._onClose("transport error", e);
    }
    _onClose(e, r) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
            if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), pc && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
                let n = qo.indexOf(this._offlineEventListener);
                n !== -1 && qo.splice(n, 1);
            }
            this.readyState = "closed", this.id = null, this.emitReserved("close", e, r), this.writeBuffer = [], this._prevBufferLen = 0;
        }
    }
};
je.protocol = ac;
var zo = class extends je {
    constructor(){
        super(...arguments), this._upgrades = [];
    }
    onOpen() {
        if (super.onOpen(), this.readyState === "open" && this.opts.upgrade) for(let e = 0; e < this._upgrades.length; e++)this._probe(this._upgrades[e]);
    }
    _probe(e) {
        let r = this.createTransport(e), n = !1;
        je.priorWebsocketSuccess = !1;
        let o = ()=>{
            n || (r.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]), r.once("packet", (u)=>{
                if (!n) {
                    if (u.type === "pong" && u.data === "probe") {
                        if (this.upgrading = !0, this.emitReserved("upgrading", r), !r) return;
                        je.priorWebsocketSuccess = r.name === "websocket", this.transport.pause(()=>{
                            n || this.readyState !== "closed" && (l(), this.setTransport(r), r.send([
                                {
                                    type: "upgrade"
                                }
                            ]), this.emitReserved("upgrade", r), r = null, this.upgrading = !1, this.flush());
                        });
                    } else {
                        let p = new Error("probe error");
                        p.transport = r.name, this.emitReserved("upgradeError", p);
                    }
                }
            }));
        };
        function s() {
            n || (n = !0, l(), r.close(), r = null);
        }
        let i = (u)=>{
            let p = new Error("probe error: " + u);
            p.transport = r.name, s(), this.emitReserved("upgradeError", p);
        };
        function a() {
            i("transport closed");
        }
        function c() {
            i("socket closed");
        }
        function f(u) {
            r && u.name !== r.name && s();
        }
        let l = ()=>{
            r.removeListener("open", o), r.removeListener("error", i), r.removeListener("close", a), this.off("close", c), this.off("upgrading", f);
        };
        r.once("open", o), r.once("error", i), r.once("close", a), this.once("close", c), this.once("upgrading", f), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(()=>{
            n || r.open();
        }, 200) : r.open();
    }
    onHandshake(e) {
        this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
    }
    _filterUpgrades(e) {
        let r = [];
        for(let n = 0; n < e.length; n++)~this.transports.indexOf(e[n]) && r.push(e[n]);
        return r;
    }
}, Or = class extends zo {
    constructor(e, r = {}){
        let n = typeof e == "object" ? e : r;
        (!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((o)=>uc[o]).filter((o)=>!!o)), super(e, n);
    }
};
var hI = Or.protocol;
function Up(t, e = "", r) {
    let n = t;
    r = r || typeof location < "u" && location, t == null && (t = r.protocol + "//" + r.host), typeof t == "string" && (t.charAt(0) === "/" && (t.charAt(1) === "/" ? t = r.protocol + t : t = r.host + t), /^(https?|wss?):\/\//.test(t) || (typeof r < "u" ? t = r.protocol + "//" + t : t = "https://" + t), n = kr(t)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
    let s = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
    return n.id = n.protocol + "://" + s + ":" + n.port + e, n.href = n.protocol + "://" + s + (r && r.port === n.port ? "" : ":" + n.port), n;
}
var bc = {};
Bt(bc, {
    Decoder: ()=>gc,
    Encoder: ()=>mc,
    PacketType: ()=>I,
    isPacketValid: ()=>Gx,
    protocol: ()=>Hp
});
var Bx = typeof ArrayBuffer == "function", Ux = (t)=>typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t.buffer instanceof ArrayBuffer, jp = Object.prototype.toString, jx = typeof Blob == "function" || typeof Blob < "u" && jp.call(Blob) === "[object BlobConstructor]", Vx = typeof File == "function" || typeof File < "u" && jp.call(File) === "[object FileConstructor]";
function On(t) {
    return Bx && (t instanceof ArrayBuffer || Ux(t)) || jx && t instanceof Blob || Vx && t instanceof File;
}
function kn(t, e) {
    if (!t || typeof t != "object") return !1;
    if (Array.isArray(t)) {
        for(let r = 0, n = t.length; r < n; r++)if (kn(t[r])) return !0;
        return !1;
    }
    if (On(t)) return !0;
    if (t.toJSON && typeof t.toJSON == "function" && arguments.length === 1) return kn(t.toJSON(), !0);
    for(let r in t)if (Object.prototype.hasOwnProperty.call(t, r) && kn(t[r])) return !0;
    return !1;
}
function Vp(t) {
    let e = [], r = t.data, n = t;
    return n.data = dc(r, e), n.attachments = e.length, {
        packet: n,
        buffers: e
    };
}
function dc(t, e) {
    if (!t) return t;
    if (On(t)) {
        let r = {
            _placeholder: !0,
            num: e.length
        };
        return e.push(t), r;
    } else if (Array.isArray(t)) {
        let r = new Array(t.length);
        for(let n = 0; n < t.length; n++)r[n] = dc(t[n], e);
        return r;
    } else if (typeof t == "object" && !(t instanceof Date)) {
        let r = {};
        for(let n in t)Object.prototype.hasOwnProperty.call(t, n) && (r[n] = dc(t[n], e));
        return r;
    }
    return t;
}
function qp(t, e) {
    return t.data = hc(t.data, e), delete t.attachments, t;
}
function hc(t, e) {
    if (!t) return t;
    if (t && t._placeholder === !0) {
        if (typeof t.num == "number" && t.num >= 0 && t.num < e.length) return e[t.num];
        throw new Error("illegal attachments");
    } else if (Array.isArray(t)) for(let r = 0; r < t.length; r++)t[r] = hc(t[r], e);
    else if (typeof t == "object") for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && (t[r] = hc(t[r], e));
    return t;
}
var zp = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
], Hp = 5, I;
(function(t) {
    t[t.CONNECT = 0] = "CONNECT", t[t.DISCONNECT = 1] = "DISCONNECT", t[t.EVENT = 2] = "EVENT", t[t.ACK = 3] = "ACK", t[t.CONNECT_ERROR = 4] = "CONNECT_ERROR", t[t.BINARY_EVENT = 5] = "BINARY_EVENT", t[t.BINARY_ACK = 6] = "BINARY_ACK";
})(I || (I = {}));
var mc = class {
    constructor(e){
        this.replacer = e;
    }
    encode(e) {
        return (e.type === I.EVENT || e.type === I.ACK) && kn(e) ? this.encodeAsBinary({
            type: e.type === I.EVENT ? I.BINARY_EVENT : I.BINARY_ACK,
            nsp: e.nsp,
            data: e.data,
            id: e.id
        }) : [
            this.encodeAsString(e)
        ];
    }
    encodeAsString(e) {
        let r = "" + e.type;
        return (e.type === I.BINARY_EVENT || e.type === I.BINARY_ACK) && (r += e.attachments + "-"), e.nsp && e.nsp !== "/" && (r += e.nsp + ","), e.id != null && (r += e.id), e.data != null && (r += JSON.stringify(e.data, this.replacer)), r;
    }
    encodeAsBinary(e) {
        let r = Vp(e), n = this.encodeAsString(r.packet), o = r.buffers;
        return o.unshift(n), o;
    }
}, gc = class t extends Q {
    constructor(e){
        super(), this.reviver = e;
    }
    add(e) {
        let r;
        if (typeof e == "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            r = this.decodeString(e);
            let n = r.type === I.BINARY_EVENT;
            n || r.type === I.BINARY_ACK ? (r.type = n ? I.EVENT : I.ACK, this.reconstructor = new yc(r), r.attachments === 0 && super.emitReserved("decoded", r)) : super.emitReserved("decoded", r);
        } else if (On(e) || e.base64) {
            if (this.reconstructor) r = this.reconstructor.takeBinaryData(e), r && (this.reconstructor = null, super.emitReserved("decoded", r));
            else throw new Error("got binary data when not reconstructing a packet");
        } else throw new Error("Unknown type: " + e);
    }
    decodeString(e) {
        let r = 0, n = {
            type: Number(e.charAt(0))
        };
        if (I[n.type] === void 0) throw new Error("unknown packet type " + n.type);
        if (n.type === I.BINARY_EVENT || n.type === I.BINARY_ACK) {
            let s = r + 1;
            for(; e.charAt(++r) !== "-" && r != e.length;);
            let i = e.substring(s, r);
            if (i != Number(i) || e.charAt(r) !== "-") throw new Error("Illegal attachments");
            n.attachments = Number(i);
        }
        if (e.charAt(r + 1) === "/") {
            let s = r + 1;
            for(; ++r && !(e.charAt(r) === "," || r === e.length););
            n.nsp = e.substring(s, r);
        } else n.nsp = "/";
        let o = e.charAt(r + 1);
        if (o !== "" && Number(o) == o) {
            let s = r + 1;
            for(; ++r;){
                let i = e.charAt(r);
                if (i == null || Number(i) != i) {
                    --r;
                    break;
                }
                if (r === e.length) break;
            }
            n.id = Number(e.substring(s, r + 1));
        }
        if (e.charAt(++r)) {
            let s = this.tryParse(e.substr(r));
            if (t.isPayloadValid(n.type, s)) n.data = s;
            else throw new Error("invalid payload");
        }
        return n;
    }
    tryParse(e) {
        try {
            return JSON.parse(e, this.reviver);
        } catch  {
            return !1;
        }
    }
    static isPayloadValid(e, r) {
        switch(e){
            case I.CONNECT:
                return Ho(r);
            case I.DISCONNECT:
                return r === void 0;
            case I.CONNECT_ERROR:
                return typeof r == "string" || Ho(r);
            case I.EVENT:
            case I.BINARY_EVENT:
                return Array.isArray(r) && (typeof r[0] == "number" || typeof r[0] == "string" && zp.indexOf(r[0]) === -1);
            case I.ACK:
            case I.BINARY_ACK:
                return Array.isArray(r);
        }
    }
    destroy() {
        this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
    }
}, yc = class {
    constructor(e){
        this.packet = e, this.buffers = [], this.reconPack = e;
    }
    takeBinaryData(e) {
        if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
            let r = qp(this.reconPack, this.buffers);
            return this.finishedReconstruction(), r;
        }
        return null;
    }
    finishedReconstruction() {
        this.reconPack = null, this.buffers = [];
    }
};
function qx(t) {
    return typeof t == "string";
}
var zx = Number.isInteger || function(t) {
    return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
};
function Hx(t) {
    return t === void 0 || zx(t);
}
function Ho(t) {
    return Object.prototype.toString.call(t) === "[object Object]";
}
function Wx(t, e) {
    switch(t){
        case I.CONNECT:
            return e === void 0 || Ho(e);
        case I.DISCONNECT:
            return e === void 0;
        case I.EVENT:
            return Array.isArray(e) && (typeof e[0] == "number" || typeof e[0] == "string" && zp.indexOf(e[0]) === -1);
        case I.ACK:
            return Array.isArray(e);
        case I.CONNECT_ERROR:
            return typeof e == "string" || Ho(e);
        default:
            return !1;
    }
}
function Gx(t) {
    return qx(t.nsp) && Hx(t.id) && Wx(t.type, t.data);
}
function kt(t, e, r) {
    return t.on(e, r), function() {
        t.off(e, r);
    };
}
var Kx = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    newListener: 1,
    removeListener: 1
}), Ar = class extends Q {
    constructor(e, r, n){
        super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = r, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
    }
    get disconnected() {
        return !this.connected;
    }
    subEvents() {
        if (this.subs) return;
        let e = this.io;
        this.subs = [
            kt(e, "open", this.onopen.bind(this)),
            kt(e, "packet", this.onpacket.bind(this)),
            kt(e, "error", this.onerror.bind(this)),
            kt(e, "close", this.onclose.bind(this))
        ];
    }
    get active() {
        return !!this.subs;
    }
    connect() {
        return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
    }
    open() {
        return this.connect();
    }
    send(...e) {
        return e.unshift("message"), this.emit.apply(this, e), this;
    }
    emit(e, ...r) {
        var n, o, s;
        if (Kx.hasOwnProperty(e)) throw new Error('"' + e.toString() + '" is a reserved event name');
        if (r.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(r), this;
        let i = {
            type: I.EVENT,
            data: r
        };
        if (i.options = {}, i.options.compress = this.flags.compress !== !1, typeof r[r.length - 1] == "function") {
            let l = this.ids++, u = r.pop();
            this._registerAckCallback(l, u), i.id = l;
        }
        let a = (o = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || o === void 0 ? void 0 : o.writable, c = this.connected && !(!((s = this.io.engine) === null || s === void 0) && s._hasPingExpired());
        return this.flags.volatile && !a || (c ? (this.notifyOutgoingListeners(i), this.packet(i)) : this.sendBuffer.push(i)), this.flags = {}, this;
    }
    _registerAckCallback(e, r) {
        var n;
        let o = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
        if (o === void 0) {
            this.acks[e] = r;
            return;
        }
        let s = this.io.setTimeoutFn(()=>{
            delete this.acks[e];
            for(let a = 0; a < this.sendBuffer.length; a++)this.sendBuffer[a].id === e && this.sendBuffer.splice(a, 1);
            r.call(this, new Error("operation has timed out"));
        }, o), i = (...a)=>{
            this.io.clearTimeoutFn(s), r.apply(this, a);
        };
        i.withError = !0, this.acks[e] = i;
    }
    emitWithAck(e, ...r) {
        return new Promise((n, o)=>{
            let s = (i, a)=>i ? o(i) : n(a);
            s.withError = !0, r.push(s), this.emit(e, ...r);
        });
    }
    _addToQueue(e) {
        let r;
        typeof e[e.length - 1] == "function" && (r = e.pop());
        let n = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: !1,
            args: e,
            flags: Object.assign({
                fromQueue: !0
            }, this.flags)
        };
        e.push((o, ...s)=>(this._queue[0], o !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), r && r(o)) : (this._queue.shift(), r && r(null, ...s)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
    }
    _drainQueue(e = !1) {
        if (!this.connected || this._queue.length === 0) return;
        let r = this._queue[0];
        r.pending && !e || (r.pending = !0, r.tryCount++, this.flags = r.flags, this.emit.apply(this, r.args));
    }
    packet(e) {
        e.nsp = this.nsp, this.io._packet(e);
    }
    onopen() {
        typeof this.auth == "function" ? this.auth((e)=>{
            this._sendConnectPacket(e);
        }) : this._sendConnectPacket(this.auth);
    }
    _sendConnectPacket(e) {
        this.packet({
            type: I.CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, e) : e
        });
    }
    onerror(e) {
        this.connected || this.emitReserved("connect_error", e);
    }
    onclose(e, r) {
        this.connected = !1, delete this.id, this.emitReserved("disconnect", e, r), this._clearAcks();
    }
    _clearAcks() {
        Object.keys(this.acks).forEach((e)=>{
            if (!this.sendBuffer.some((n)=>String(n.id) === e)) {
                let n = this.acks[e];
                delete this.acks[e], n.withError && n.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    onpacket(e) {
        if (e.nsp === this.nsp) switch(e.type){
            case I.CONNECT:
                e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case I.EVENT:
            case I.BINARY_EVENT:
                this.onevent(e);
                break;
            case I.ACK:
            case I.BINARY_ACK:
                this.onack(e);
                break;
            case I.DISCONNECT:
                this.ondisconnect();
                break;
            case I.CONNECT_ERROR:
                this.destroy();
                let n = new Error(e.data.message);
                n.data = e.data.data, this.emitReserved("connect_error", n);
                break;
        }
    }
    onevent(e) {
        let r = e.data || [];
        e.id != null && r.push(this.ack(e.id)), this.connected ? this.emitEvent(r) : this.receiveBuffer.push(Object.freeze(r));
    }
    emitEvent(e) {
        if (this._anyListeners && this._anyListeners.length) {
            let r = this._anyListeners.slice();
            for (let n of r)n.apply(this, e);
        }
        super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
    }
    ack(e) {
        let r = this, n = !1;
        return function(...o) {
            n || (n = !0, r.packet({
                type: I.ACK,
                id: e,
                data: o
            }));
        };
    }
    onack(e) {
        let r = this.acks[e.id];
        typeof r == "function" && (delete this.acks[e.id], r.withError && e.data.unshift(null), r.apply(this, e.data));
    }
    onconnect(e, r) {
        this.id = e, this.recovered = r && this._pid === r, this._pid = r, this.connected = !0, this.emitBuffered(), this._drainQueue(!0), this.emitReserved("connect");
    }
    emitBuffered() {
        this.receiveBuffer.forEach((e)=>this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e)=>{
            this.notifyOutgoingListeners(e), this.packet(e);
        }), this.sendBuffer = [];
    }
    ondisconnect() {
        this.destroy(), this.onclose("io server disconnect");
    }
    destroy() {
        this.subs && (this.subs.forEach((e)=>e()), this.subs = void 0), this.io._destroy(this);
    }
    disconnect() {
        return this.connected && this.packet({
            type: I.DISCONNECT
        }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }
    close() {
        return this.disconnect();
    }
    compress(e) {
        return this.flags.compress = e, this;
    }
    get volatile() {
        return this.flags.volatile = !0, this;
    }
    timeout(e) {
        return this.flags.timeout = e, this;
    }
    onAny(e) {
        return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
    }
    prependAny(e) {
        return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
    }
    offAny(e) {
        if (!this._anyListeners) return this;
        if (e) {
            let r = this._anyListeners;
            for(let n = 0; n < r.length; n++)if (e === r[n]) return r.splice(n, 1), this;
        } else this._anyListeners = [];
        return this;
    }
    listenersAny() {
        return this._anyListeners || [];
    }
    onAnyOutgoing(e) {
        return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
    }
    prependAnyOutgoing(e) {
        return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
    }
    offAnyOutgoing(e) {
        if (!this._anyOutgoingListeners) return this;
        if (e) {
            let r = this._anyOutgoingListeners;
            for(let n = 0; n < r.length; n++)if (e === r[n]) return r.splice(n, 1), this;
        } else this._anyOutgoingListeners = [];
        return this;
    }
    listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    notifyOutgoingListeners(e) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            let r = this._anyOutgoingListeners.slice();
            for (let n of r)n.apply(this, e.data);
        }
    }
};
function Ve(t) {
    t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
}
Ve.prototype.duration = function() {
    var t = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var e = Math.random(), r = Math.floor(e * this.jitter * t);
        t = (Math.floor(e * 10) & 1) == 0 ? t - r : t + r;
    }
    return Math.min(t, this.max) | 0;
};
Ve.prototype.reset = function() {
    this.attempts = 0;
};
Ve.prototype.setMin = function(t) {
    this.ms = t;
};
Ve.prototype.setMax = function(t) {
    this.max = t;
};
Ve.prototype.setJitter = function(t) {
    this.jitter = t;
};
var Tr = class extends Q {
    constructor(e, r){
        var n;
        super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (r = e, e = void 0), r = r || {}, r.path = r.path || "/socket.io", this.opts = r, ie(this, r), this.reconnection(r.reconnection !== !1), this.reconnectionAttempts(r.reconnectionAttempts || 1 / 0), this.reconnectionDelay(r.reconnectionDelay || 1e3), this.reconnectionDelayMax(r.reconnectionDelayMax || 5e3), this.randomizationFactor((n = r.randomizationFactor) !== null && n !== void 0 ? n : .5), this.backoff = new Ve({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        }), this.timeout(r.timeout == null ? 2e4 : r.timeout), this._readyState = "closed", this.uri = e;
        let o = r.parser || bc;
        this.encoder = new o.Encoder, this.decoder = new o.Decoder, this._autoConnect = r.autoConnect !== !1, this._autoConnect && this.open();
    }
    reconnection(e) {
        return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
    }
    reconnectionAttempts(e) {
        return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
    }
    reconnectionDelay(e) {
        var r;
        return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (r = this.backoff) === null || r === void 0 || r.setMin(e), this);
    }
    randomizationFactor(e) {
        var r;
        return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (r = this.backoff) === null || r === void 0 || r.setJitter(e), this);
    }
    reconnectionDelayMax(e) {
        var r;
        return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (r = this.backoff) === null || r === void 0 || r.setMax(e), this);
    }
    timeout(e) {
        return arguments.length ? (this._timeout = e, this) : this._timeout;
    }
    maybeReconnectOnOpen() {
        !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
    }
    open(e) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new Or(this.uri, this.opts);
        let r = this.engine, n = this;
        this._readyState = "opening", this.skipReconnect = !1;
        let o = kt(r, "open", function() {
            n.onopen(), e && e();
        }), s = (a)=>{
            this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), e ? e(a) : this.maybeReconnectOnOpen();
        }, i = kt(r, "error", s);
        if (this._timeout !== !1) {
            let a = this._timeout, c = this.setTimeoutFn(()=>{
                o(), s(new Error("timeout")), r.close();
            }, a);
            this.opts.autoUnref && c.unref(), this.subs.push(()=>{
                this.clearTimeoutFn(c);
            });
        }
        return this.subs.push(o), this.subs.push(i), this;
    }
    connect(e) {
        return this.open(e);
    }
    onopen() {
        this.cleanup(), this._readyState = "open", this.emitReserved("open");
        let e = this.engine;
        this.subs.push(kt(e, "ping", this.onping.bind(this)), kt(e, "data", this.ondata.bind(this)), kt(e, "error", this.onerror.bind(this)), kt(e, "close", this.onclose.bind(this)), kt(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    onping() {
        this.emitReserved("ping");
    }
    ondata(e) {
        try {
            this.decoder.add(e);
        } catch (r) {
            this.onclose("parse error", r);
        }
    }
    ondecoded(e) {
        se(()=>{
            this.emitReserved("packet", e);
        }, this.setTimeoutFn);
    }
    onerror(e) {
        this.emitReserved("error", e);
    }
    socket(e, r) {
        let n = this.nsps[e];
        return n ? this._autoConnect && !n.active && n.connect() : (n = new Ar(this, e, r), this.nsps[e] = n), n;
    }
    _destroy(e) {
        let r = Object.keys(this.nsps);
        for (let n of r)if (this.nsps[n].active) return;
        this._close();
    }
    _packet(e) {
        let r = this.encoder.encode(e);
        for(let n = 0; n < r.length; n++)this.engine.write(r[n], e.options);
    }
    cleanup() {
        this.subs.forEach((e)=>e()), this.subs.length = 0, this.decoder.destroy();
    }
    _close() {
        this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
    }
    disconnect() {
        return this._close();
    }
    onclose(e, r) {
        var n;
        this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, r), this._reconnection && !this.skipReconnect && this.reconnect();
    }
    reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        let e = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
        else {
            let r = this.backoff.duration();
            this._reconnecting = !0;
            let n = this.setTimeoutFn(()=>{
                e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((o)=>{
                    o ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", o)) : e.onreconnect();
                }));
            }, r);
            this.opts.autoUnref && n.unref(), this.subs.push(()=>{
                this.clearTimeoutFn(n);
            });
        }
    }
    onreconnect() {
        let e = this.backoff.attempts;
        this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
    }
};
var An = {};
function Tn(t, e) {
    typeof t == "object" && (e = t, t = void 0), e = e || {};
    let r = Up(t, e.path || "/socket.io"), n = r.source, o = r.id, s = r.path, i = An[o] && s in An[o].nsps, a = e.forceNew || e["force new connection"] || e.multiplex === !1 || i, c;
    return a ? c = new Tr(n, e) : (An[o] || (An[o] = new Tr(n, e)), c = An[o]), r.query && !e.query && (e.query = r.queryKey), c.socket(r.path, e);
}
Object.assign(Tn, {
    Manager: Tr,
    Socket: Ar,
    io: Tn,
    connect: Tn
});
v();
var Yx = {
    success: "green",
    error: "red",
    warning: "yellow"
}, Wp = (t, e, r)=>{
    if (t.symbols) {
        if (!r.connected) {
            r.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            }, r.update({
                connected: !0
            });
            let n = setTimeout(()=>{
                delete r.notifications.connected, e.notifications.content.connected.setProps({
                    animation: "fadeOutDown"
                }), r.update({
                    connected: !0
                }), clearTimeout(n);
            }, 3e3);
        }
    } else if (r.connected) {
        r.notifications.connected = {
            title: "Disconnected",
            type: "error"
        }, r.update({
            connected: !1
        });
        let n = setTimeout(()=>{
            delete r.notifications.connected, e.notifications.content.connected && e.notifications.content.connected.setProps({
                animation: "fadeOutDown"
            }), r.update({
                connected: !0
            }), clearTimeout(n);
        }, 3e3);
    }
}, Rn = {
    state: {
        notifications: []
    },
    Notifications: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999",
        childExtends: "Notification",
        childProps: ({ state: t })=>({
                animationDuration: "C",
                background: Yx[t.type || "success"],
                icon: null,
                Flex: {
                    Title: {
                        text: "{{ title }}"
                    },
                    P: {
                        text: "{{ title }}"
                    }
                },
                onRender: (e, r, n)=>{
                    r.setProps({
                        animation: "fadeInUp"
                    });
                },
                onClick: (e, r, n)=>{
                    delete n.notifications[r.key], r.setProps({
                        animation: "fadeOutDown"
                    }), n.onClose && n.onClose(e, r, n);
                }
            }),
        IconText: null,
        childrenAs: "state",
        children: ({ state: t })=>t.notifications
    }
};
var Gp = false, Qx = (t, e)=>{
    !t || !Array.isArray(e) || e.reduce((r, n, o, s)=>{
        if (r && n in r) {
            if (o !== s.length - 1) return r[n];
            delete r[n];
        }
    }, t);
}, Xx = (t, e, r, n = !1)=>{
    !t || !Array.isArray(e) || e.reduce((o, s, i, a)=>{
        if (o) {
            if (i !== a.length - 1) return !o[s] && n && (o[s] = {}), o[s];
            o[s] = r;
        }
    }, t);
}, Jx = (t, e)=>{
    let r = new Set;
    if (!Array.isArray(e)) return r;
    for (let [n, o, s] of e)if (!(!Array.isArray(o) || !o.length)) switch(r.add(o[0]), n){
        case "delete":
            Qx(t, o);
            break;
        case "update":
        case "set":
            Xx(t, o, s, !0);
            break;
        default:
            break;
    }
    return r;
}, Zx = async ()=>{
    try {
        let t = Gp ? "http://localhost:8080" : "https://api.symbols.app", e = await D.fetch(`${t}/service-token`, {
            method: "GET"
        }), r;
        try {
            let n = await e.clone().json();
            if (n && typeof n.token == "string") return n.token.trim();
            r = await e.text();
        } catch  {
            r = await e.text();
        }
        return (r || "").replace(/\s+/gu, "") || void 0;
    } catch (t) {
        console.error("[sync] Failed to fetch service-token", t);
    }
}, t_ = (t, e, r)=>(n = {})=>{
        let { data: o } = n, { schema: s } = n;
        o && (o = t.call("deepDestringifyFunctions", o, Array.isArray(o) ? [] : {}), Object.entries(o).forEach(([i, a])=>{
            r[i] && typeof r[i] == "object" ? i === "designSystem" ? Ue(a) : Lr(r[i], a) : r[i] = a;
        }), s && (r.schema = s));
    }, e_ = (t, e, r)=>(n = {})=>{
        let { changes: o } = n;
        if (!o || !Array.isArray(o) || !o.length) return;
        o = t.call("deepDestringifyFunctions", o, Array.isArray(o) ? [] : {});
        let s = Jx(r, o);
        if (s.has("state")) {
            let i = r.state?.route;
            i ? t.call("router", i.replace("/state", "") || "/", t.__ref.root, {}, {
                scrollToTop: !1
            }) : e.update(r.state);
        }
        if ([
            "pages",
            "components",
            "snippets",
            "functions"
        ].some((i)=>s.has(i))) {
            let { pathname: i, search: a, hash: c } = r.window.location;
            t.call("router", i + a + c, t.__ref.root, {}, {
                scrollToTop: !1
            });
        }
        s.has("designSystem") && Ue(r.designSystem);
    }, r_ = async (t, e, r)=>{
    let n = await Zx();
    if (!n) return console.warn("[sync] No service token \u2013 live collaboration disabled"), null;
    let o = r.key;
    if (!o) return console.warn("[sync] ctx.key missing \u2013 cannot establish collaborative connection"), null;
    let i = Tn(Gp ? "http://localhost:8080" : "https://api.symbols.app", {
        path: "/collab-socket",
        transports: [
            "websocket"
        ],
        auth: {
            token: n,
            projectKey: o,
            branch: "main",
            live: !0,
            clientType: "platform"
        },
        reconnectionAttempts: 1 / 0,
        reconnectionDelayMax: 4e3
    });
    return i.on("connect", ()=>{
        r.editor?.verbose && console.info("[sync] Connected to collab socket");
    }), i.on("snapshot", t_(t, e, r)), i.on("ops", e_(t, e, r)), i.on("clients", (a)=>{
        r.editor?.verbose && Wp(a, t, e);
    }), i.on("disconnect", (a)=>{
        r.editor?.verbose && console.info("[sync] Disconnected from collab socket", a);
    }), i;
}, Wo = {
    onInitSync: r_
};
var Kp = (t, e)=>N(t.extends) ? t.extends : [], Yp = (t, e)=>{
    let { editor: r } = e;
    if (!r) return;
    (K(r.liveSync) ? Zt() : r.liveSync) && (_(t.extends) ? t.extends.push(Wo) : t.extends ? t.extends = [
        t.extends,
        Wo
    ] : t.extends = [
        Wo
    ]);
};
var Qp = (t, e)=>{
    let { editor: r } = e;
    if (!r) return;
    (K(r.verbose) ? Zt() || e.verbose : r.verbose) && (_(t.extends) ? t.extends.push(Rn) : t.extends ? t.extends = [
        t.extends,
        Rn
    ] : t.extends = [
        Rn
    ]);
};
v();
v();
var n_ = [
    "useReset",
    "useVariable",
    "useFontImport",
    "useIconSprite",
    "useSvgSprite",
    "useDocumentTheme",
    "useDefaultIcons",
    "useDefaultConfig",
    "verbose",
    "globalTheme"
], Xp = (t, e = {})=>{
    let r = e.document || (e.parent && e.parent.documentElement ? e.parent : null) || document, n = e.initOptions || {}, o = n.emotion;
    n.emotion || (n.emotion = Ct);
    let s = e.registry || wf(n.emotion, e), i = e.designSystem ? H(j(e.designSystem), Fa) : j(Fa), a = {};
    for (let f of n_)e[f] !== void 0 && (a[f] = e[f]);
    return [
        Ue(i, {
            key: t,
            emotion: o,
            document: r,
            files: e.files,
            ...oc,
            ...a,
            ...n
        }),
        o,
        s
    ];
};
var td = (t)=>{
    let e = typeof window < "u" ? window : globalThis || {};
    e.document || (e.document = {
        body: {}
    });
    let r = typeof document < "u" ? document : e.document;
    return t.document = t.document || r, t.window = t.window || e, t.window;
}, Jp = (t = "smbls")=>{
    let e = {};
    for(let r in Be)Object.prototype.hasOwnProperty.call(Be, r) && (It(r) ? e[`smbls.${r}`] = Be[r] : e[r] = Be[r]);
    return e;
}, ed = (t)=>t.components ? {
        ...Jp(),
        ...t.components
    } : Jp(), rd = (t)=>({
        ...bn,
        ...tc,
        ...br,
        ...t.utils,
        ...t.snippets,
        ...t.functions
    }), nd = (t)=>({
        ...t.methods || {},
        require: t.utils.require,
        requireOnDemand: t.utils.requireOnDemand,
        router: t.utils.router
    }), Zp = {}, od = async ({ dependencies: t, dependenciesOnDemand: e, document: r, preventCaching: n = !1, cdnProvider: o, packageManager: s, symbolsConfig: i })=>{
    if (o || (o = gr[s] || ho(i) || "esmsh"), !t) return null;
    let a = !1;
    for(let c in t){
        a = !0;
        break;
    }
    if (!a) return null;
    for(let c in t){
        let f = t[c];
        if (e && e[c]) continue;
        let l = Zt() && n ? `?${Math.random()}` : "", u = re(c, f, o) + l;
        try {
            if (Zp[c]) return;
            Zp[c] = !0, await po(u, {
                document: r,
                type: "module"
            });
        } catch (p) {
            if (console.error(`Failed to load ${c} from ${o}:`, p), o !== "symbols") try {
                let h = re(c, f, "symbols") + l;
                await po(h, {
                    document: r
                }), console.log(`Successfully loaded ${c} from fallback (symbols.ls)`);
            } catch (h) {
                console.error(`Failed to load ${c} from fallback:`, h);
            }
        }
    }
    return t;
}, sd = async (t, e)=>{
    let r = e.window || window, n = e.cdnProvider || ho(e.symbolsConfig) || "esmsh", o = async (i)=>async (a, c)=>{
            let l = (i.window || window).packages[a];
            return typeof l == "function" ? l() : l;
        }, s = async (i)=>async (a, c = n)=>{
            let { dependenciesOnDemand: f } = i, l = i.document || document, u = i.window || window;
            if (!u.packages[a]) {
                let p = Zt() ? `?${Math.random()}` : "";
                if (f && f[a]) {
                    let h = f[a], d = re(a, h, c) + p;
                    try {
                        await i.utils.loadRemoteScript(d, {
                            window: u,
                            document: l
                        });
                    } catch (m) {
                        if (console.error(`Failed to load ${a} from ${c}:`, m), c !== "symbols") {
                            let S = re(a, h, "symbols") + p;
                            await i.utils.loadRemoteScript(S, {
                                window: u,
                                document: l
                            });
                        }
                    }
                } else {
                    let h = re(a, "latest", c) + p;
                    try {
                        await i.utils.loadRemoteScript(h, {
                            window: u,
                            document: l
                        });
                    } catch (d) {
                        if (console.error(`Failed to load ${a} from ${c}:`, d), c !== "symbols") {
                            let m = re(a, "latest", "symbols") + p;
                            await i.utils.loadRemoteScript(m, {
                                window: u,
                                document: l
                            });
                        }
                    }
                    u.packages[a] = "loadedOnDeman";
                }
            }
            return await u.require(a, c);
        };
    r.packages ? r.packages = Y(r.packages, t) : r.packages = t, r.require || (e.utils.require = await o(e), r.require = e.utils.require), r.requireOnDemand || (e.utils.requireOnDemand = await s(e), r.requireOnDemand = e.utils.requireOnDemand);
}, id = (t, e)=>{
    let [r, n, o] = Xp(t, e);
    return [
        r,
        n,
        o
    ];
}, ad = (t, e)=>{
    let r = {};
    return e.state && H(r, e.state), t && t.state && H(r, t.state), r.isRootState = !0, j(r);
}, cd = (t, e)=>{
    g(t.routes) && g(e.pages) && Y(t.routes, e.pages);
    let r = t.routes || e.pages || {};
    for(let n in r){
        if (n.charCodeAt(0) === 47) continue;
        let o = n === "index" ? "" : n;
        r["/" + o] = r[n], delete r[n];
    }
    return r;
}, ld = (t, e)=>{
    for(let r in e)r in t ? g(t[r]) && g(e[r]) && ld(t[r], e[r]) : t[r] = e[r];
}, fd = (t)=>{
    let e = t.sharedLibraries;
    for(let r = 0; r < e.length; r++){
        let n = e[r];
        for(let o in n)if (Object.prototype.hasOwnProperty.call(n, o)) {
            if (g(n[o]) && g(t[o])) {
                if (o === "designSystem") ld(t[o], n[o]);
                else for(let s in n[o])s in t[o] || (t[o][s] = n[o][s]);
            } else o in t || (t[o] = n[o]);
        }
    }
};
v();
var pd = "smbls_lang", o_ = "smbls_t_", s_ = "smbls_tv_", Rr = {
    get (t) {
        try {
            return window?.localStorage.getItem(t);
        } catch  {
            return null;
        }
    },
    set (t, e) {
        try {
            window?.localStorage.setItem(t, e);
        } catch (r) {
            console.warn("[polyglot] localStorage unavailable:", r.message);
        }
    },
    remove (t) {
        try {
            window?.localStorage.removeItem(t);
        } catch (e) {
            console.warn("[polyglot] localStorage unavailable:", e.message);
        }
    }
}, In = {};
function Ko() {
    let t = this?.context, e = t?.polyglot;
    return (this?.state?.root || t?.state?.root)?.lang || e?.defaultLang || "en";
}
function Sc() {
    let t = this?.context?.polyglot;
    return t ? t.languages ? t.languages : t.translations ? Object.keys(t.translations) : [] : [];
}
var Go = (t, e)=>{
    if (!t || !e) return;
    if (t[e] !== void 0) return t[e];
    if (e.indexOf(".") === -1) return;
    let r = e.split("."), n = t;
    for(let o = 0; o < r.length; o++){
        if (n == null) return;
        n = n[r[o]];
    }
    return n;
}, ud = (t, e, r)=>{
    let n = e.lastIndexOf(".");
    if (n === -1) return t[e + "_" + r];
    let o = Go(t, e.substring(0, n));
    if (o != null) return o[e.substring(n + 1) + "_" + r];
};
function xc(t, e) {
    if (!t) return "";
    let r = this?.context, n = r?.polyglot, o = e || this.call("getActiveLang"), s = this?.state;
    if (s) {
        let f = ud(s, t, o);
        if (f !== void 0) return f;
    }
    if (n?.translations) {
        let f = n.translations[o];
        if (f) {
            let l = Go(f, t);
            if (l !== void 0) return l;
        }
    }
    let a = (s?.root || r?.state?.root)?.translations;
    if (a) {
        let f = a[o];
        if (f) {
            let l = Go(f, t);
            if (l !== void 0) return l;
        }
    }
    let c = n?.defaultLang || "en";
    if (s) {
        let f = ud(s, t, c);
        if (f !== void 0) return f;
    }
    if (n?.translations) {
        let f = n.translations[c];
        if (f) {
            let l = Go(f, t);
            if (l !== void 0) return l;
        }
    }
    return t;
}
async function _c(t) {
    let e = this?.context, r = e?.polyglot, n = this?.state?.root || e?.state?.root;
    if (!r || !n) return;
    let o = r.storagePrefix || o_, s = r.storageVersionPrefix || (r.storagePrefix ? r.storagePrefix.replace(/_$/, "v_") : s_);
    if (r.translations && r.translations[t] && !r.fetch || !r.fetch || r._fetchFailed?.[t]) return;
    if (!n.translations?.[t]) {
        let c = Rr.get(o + t);
        if (c) try {
            let f = JSON.parse(c), l = {
                translations: {
                    ...n.translations || {}
                }
            };
            l.translations[t] = f, n.update && n.update(l);
        } catch (f) {
            console.warn("[polyglot] Failed to apply language update:", f.message);
        }
    }
    let i = (r.storagePrefix || "smbls") + ":" + t;
    if (In[i]) return In[i];
    let a = this;
    return In[i] = (async ()=>{
        try {
            let c = r.fetch, f = parseInt(Rr.get(s + t), 10) || 0, l, u, p;
            if (y(c)) {
                let d = await c(t, f, a);
                if (!d || d.changed === !1) return;
                l = d.translations || d.data || d, u = d.version || 0, p = !0;
            } else if (g(c)) {
                let d = a.getDB || (()=>e.fetch), m = y(d) ? await d.call(a) : e.fetch;
                if (!m) return;
                let S = c.rpc || c.from || "get_translations_if_changed", x = {
                    p_lang: t,
                    p_cached_version: f,
                    ...c.params || {}
                }, w = await m.rpc({
                    from: S,
                    params: x
                });
                if (w.error) throw r._fetchFailed || (r._fetchFailed = {}), r._fetchFailed[t] = !0, w.error;
                let C = w.data;
                if (!C || !C.changed) return;
                l = C.translations || {}, u = C.version || 0, p = !0;
            } else return;
            if (!p || !l) return;
            Rr.set(o + t, JSON.stringify(l)), u && Rr.set(s + t, String(u));
            let h = {
                translations: {
                    ...n.translations || {}
                }
            };
            h.translations[t] = l, n.update && n.update(h);
        } catch (c) {
            if (r.verbose !== !1) {
                let f = c?.message || c?.details || (typeof c == "object" ? JSON.stringify(c) : String(c));
                console.warn("[polyglot] Failed to load translations for", t, "-", f);
            }
        } finally{
            delete In[i];
        }
    })(), In[i];
}
async function wc(t) {
    let e = this?.context, r = e?.polyglot, n = this?.state?.root || e?.state?.root;
    if (!n || this.call("getActiveLang") === t) return;
    let o = r?.storageLangKey || pd;
    Rr.set(o, t), r?.fetch && await this.call("loadTranslations", t), n.update && n.update({
        lang: t
    });
}
async function vc(t, e, r) {
    let n = this?.context, o = n?.polyglot, s = this?.state?.root || n?.state?.root;
    if (s?.translations?.[e] && (s.translations[e][t] = r), o?.translations?.[e] && (o.translations[e][t] = r), o?.fetch && g(o.fetch)) {
        let i = this.getDB || (()=>n.fetch), a = y(i) ? await i.call(this) : n.fetch;
        if (!a) return;
        let c = o.fetch.table || "translations", f = await a.upsert({
            from: c,
            data: {
                key: t,
                lang: e,
                text: r
            }
        });
        if (f?.error) throw f.error;
        return f.data;
    }
}
async function dd() {
    let t = this?.context, e = t?.polyglot;
    if (!e) return;
    let r = this?.state?.root || t?.state?.root;
    if (!r) return;
    let n = e.storageLangKey || pd, s = Rr.get(n) || e.defaultLang || r.lang || "en";
    r.update && r.lang !== s && r.update({
        lang: s
    }), e.fetch && !(e.translations && e.translations[s]) && await this.call("loadTranslations", s);
}
function Cc(t) {
    try {
        let e = this?.context?.polyglot, n = (this?.state?.root || this?.context?.state?.root)?.lang || e?.defaultLang || "en", o = this?.state;
        if (!o) return "";
        let s = t.lastIndexOf(".");
        if (s === -1) return o[t + n] ?? "";
        let i = t.substring(0, s).split("."), a = o;
        for(let c = 0; c < i.length; c++){
            if (a == null) return "";
            a = a[i[c]];
        }
        return a == null ? "" : a[t.substring(s + 1) + n] ?? "";
    } catch  {
        return "";
    }
}
var Ec = {
    name: "polyglot",
    render (t) {
        t.parent && t.parent.parent || t.__polyglotInitialized || (t.__polyglotInitialized = !0, dd.call(t));
    }
};
var Yo = {
    polyglot: xc,
    getLocalStateLang: Cc,
    getActiveLang: Ko,
    getLang: Ko,
    setLang: wc,
    getLanguages: Sc,
    loadTranslations: _c,
    upsertTranslation: vc
};
Ae();
var i_ = async (t, e = {})=>{
    let r = e.key = e.key || (b(t) ? t : "smblsapp");
    e.define = e.define || Sn, e.cssPropsRegistry = hn, e.window = td(e), e.sharedLibraries && e.sharedLibraries.length && fd(e);
    let [n, o, s] = id(r, e);
    e.designSystem = n, e.registry = s, e.emotion = o, e.cases || (e.cases = {});
    let i = ad(t, e);
    e.state = i, e.pages = cd(t, e), e.components = ed(e), e.utils = rd(e), gr[e.packageManager] && (e.dependencies = await od(e)), e.methods = nd(e), e.routerOptions = ip(t, e), e.defaultExtends = [
        La
    ], e.snippets = e.snippets || {}, e.functions = e.functions || {}, e.plugins = e.plugins || [], e.globalScope && g(e.globalScope) && (e.globalScope = ps(e.globalScope));
    let a = (c)=>e.plugins.some((f)=>f.name === c);
    if (e.polyglot && !a("polyglot")) {
        e.plugins.push(Ec);
        for(let c in Yo)c in e.functions || (e.functions[c] = Yo[c]);
    }
    return a("helmet") || e.plugins.push(pp), e.fetch && !a("fetch") && e.plugins.push(ui), e;
}, kc = async (t, e)=>{
    g(e) || (e = {}), Ce(t) ? (t = {}, e.parent = t) : b(t) ? (t = {}, e.key = t) : g(t) || (t = {});
    let r = e.window || (typeof window < "u" ? window : null), n = r?.__BRENDER__, o = null;
    if (n) {
        let f = e.document || (typeof document < "u" ? document : null);
        f && (o = Array.from(f.head.querySelectorAll("style")));
    }
    await i_(t, e), t.extends = Kp(t, e), t.routes = e.pages, t.state = e.state, t.context = e, t.data = t.data || {}, t.data.frameListeners = wu(e), await sd({
        functions: e.functions,
        utils: e.utils,
        snippets: e.snippets,
        ...e.files
    }, e), Yp(t, e), Qp(t, e);
    let s = e.document;
    if (!s || !s.createElement) return t;
    let i = e.parent || s.body, a = Lo.default && Lo.default.create || Lo.create;
    return n ? a_(a, t, i, e, r, o) : await a(t, i, e.key, {
        verbose: e.verbose,
        ...e.domqlOptions
    });
}, a_ = async (t, e, r, n, o, s)=>{
    let i = r.ownerDocument || document;
    s && s.forEach((f)=>{
        f.parentNode && f.remove();
    });
    let a = [];
    for (let f of r.childNodes){
        if (f.nodeType === 1) {
            let l = f.tagName.toLowerCase();
            if (l === "script" || l === "link" || l === "style" || l === "svg" && f.id) continue;
        }
        a.push(f);
    }
    a.forEach((f)=>f.remove()), i.querySelectorAll("[data-br]").forEach((f)=>f.removeAttribute("data-br"));
    let c = await t(e, r, n.key, {
        verbose: n.verbose,
        ...n.domqlOptions
    });
    return c_(o), c;
}, c_ = (t)=>{
    t && (delete t.__BRENDER__, delete t.__BR_REGISTRY__);
};
var Oc = (t, e)=>H(t, g(e) ? e : {}), hd = (t, e = xe, r)=>{
    let n = {
        ...xe,
        ...Oc(e, r)
    }, o = kc(t, n).then((s)=>{
        ap(s, n), n.on && n.on.create && n.on.create(o, o.state, o.context, n);
    });
    return o;
}, qP = (t, e = xe, r)=>{
    let n = hd(t, e, r), o = {
        ...xe,
        ...Oc(e, r)
    }, s = o.key;
    return up(n, s, {
        utils: bn,
        ...o
    }), n;
}, zP = async (t, e = xe, r)=>{
    let n = {
        ...xe,
        ...Oc(e, r)
    }, o = e.key;
    await fp(o, n);
    let s = await kc(t, n);
    return n.on && n.on.create && await n.on.create(s, s.state, s.context, n), s;
}, HP = (t = {}, e = xe, r)=>hd({
        deps: {
            isUndefined: K
        },
        ...t
    }, H({
        domqlOptions: {
            onlyResolveExtends: !0
        }
    }, e), r);
 // @preserve-env

});
parcelRegister("dNnfS", function(module, exports) {

$parcel$export(module.exports, "SupabaseClient", () => $5e33485c08cd650a$export$1bfe63e045eb2ffa);
$parcel$export(module.exports, "createClient", () => $5e33485c08cd650a$export$5d730b7aed1a3eb0);
$parcel$export(module.exports, "FunctionRegion", () => (parcelRequire("1oqCS")).FunctionRegion);
$parcel$export(module.exports, "FunctionsError", () => (parcelRequire("1oqCS")).FunctionsError);
$parcel$export(module.exports, "FunctionsFetchError", () => (parcelRequire("1oqCS")).FunctionsFetchError);
$parcel$export(module.exports, "FunctionsHttpError", () => (parcelRequire("1oqCS")).FunctionsHttpError);
$parcel$export(module.exports, "FunctionsRelayError", () => (parcelRequire("1oqCS")).FunctionsRelayError);
$parcel$export(module.exports, "PostgrestError", () => (parcelRequire("4yorG")).PostgrestError);

var $1oqCS = parcelRequire("1oqCS");
var $9A7Ck = parcelRequire("9A7Ck");

var $4yorG = parcelRequire("4yorG");
parcelRequire("izHZ4");
var $eWiay = parcelRequire("eWiay");
var $izHZ4 = parcelRequire("izHZ4");

var $9Yl9w = parcelRequire("9Yl9w");
parcelRequire("lpqci");
var $aALRH = parcelRequire("aALRH");
var $lpqci = parcelRequire("lpqci");
//#region src/lib/version.ts
const $5e33485c08cd650a$var$version = "2.100.1";
//#endregion
//#region src/lib/constants.ts
let $5e33485c08cd650a$var$JS_ENV = "";
if (typeof Deno !== "undefined") $5e33485c08cd650a$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $5e33485c08cd650a$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $5e33485c08cd650a$var$JS_ENV = "react-native";
else $5e33485c08cd650a$var$JS_ENV = "node";
const $5e33485c08cd650a$var$DEFAULT_HEADERS = {
    "X-Client-Info": `supabase-js-${$5e33485c08cd650a$var$JS_ENV}/${$5e33485c08cd650a$var$version}`
};
const $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $5e33485c08cd650a$var$DEFAULT_HEADERS
};
const $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS = {};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $5e33485c08cd650a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e33485c08cd650a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $5e33485c08cd650a$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $5e33485c08cd650a$var$toPrimitive(t, r) {
    if ("object" != $5e33485c08cd650a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5e33485c08cd650a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $5e33485c08cd650a$var$toPropertyKey(t) {
    var i = $5e33485c08cd650a$var$toPrimitive(t, "string");
    return "symbol" == $5e33485c08cd650a$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $5e33485c08cd650a$var$_defineProperty(e, r, t) {
    return (r = $5e33485c08cd650a$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $5e33485c08cd650a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e33485c08cd650a$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e33485c08cd650a$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $5e33485c08cd650a$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e33485c08cd650a$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/fetch.ts
const $5e33485c08cd650a$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $5e33485c08cd650a$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
const $5e33485c08cd650a$var$fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch$1 = $5e33485c08cd650a$var$resolveFetch(customFetch);
    const HeadersConstructor = $5e33485c08cd650a$var$resolveHeadersConstructor();
    return async (input, init)=>{
        var _await$getAccessToken;
        const accessToken = (_await$getAccessToken = await getAccessToken()) !== null && _await$getAccessToken !== void 0 ? _await$getAccessToken : supabaseKey;
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
        return fetch$1(input, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, init), {}, {
            headers: headers
        }));
    };
};
//#endregion
//#region src/lib/helpers.ts
function $5e33485c08cd650a$var$ensureTrailingSlash(url) {
    return url.endsWith("/") ? url : url + "/";
}
function $5e33485c08cd650a$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const result = {
        db: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
/**
* Validates a Supabase client URL
*
* @param {string} supabaseUrl - The Supabase client URL string.
* @returns {URL} - The validated base URL.
* @throws {Error}
*/ function $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($5e33485c08cd650a$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
//#endregion
//#region src/lib/SupabaseAuthClient.ts
var $5e33485c08cd650a$var$SupabaseAuthClient = class extends (0, $aALRH.default) {
    constructor(options){
        super(options);
    }
};
//#endregion
//#region src/SupabaseClient.ts
/**
* Supabase Client.
*
* An isomorphic Javascript client for interacting with Postgres.
*/ var $5e33485c08cd650a$export$1bfe63e045eb2ffa = class {
    /**
	* Create a new client for use in the browser.
	*
	* @category Initializing
	*
	* @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
	* @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
	* @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
	* @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
	* @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
	* @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
	* @param options.realtime Options passed along to realtime-js constructor.
	* @param options.storage Options passed along to the storage-js constructor.
	* @param options.global.fetch A custom fetch implementation.
	* @param options.global.headers Any additional headers to send with each network request.
	*
	* @example Creating a client
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Create a single supabase client for interacting with your database
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key')
	* ```
	*
	* @example With a custom domain
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Use a custom domain as the supabase URL
	* const supabase = createClient('https://my-custom-domain.com', 'publishable-or-anon-key')
	* ```
	*
	* @example With additional parameters
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const options = {
	*   db: {
	*     schema: 'public',
	*   },
	*   auth: {
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: true
	*   },
	*   global: {
	*     headers: { 'x-my-custom-header': 'my-app-name' },
	*   },
	* }
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", options)
	* ```
	*
	* @exampleDescription With custom schemas
	* By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
	* Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
	*
	* Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
	*
	* @example With custom schemas
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key', {
	*   // Provide a custom schema. Defaults to "public".
	*   db: { schema: 'other_schema' }
	* })
	* ```
	*
	* @exampleDescription Custom fetch implementation
	* `supabase-js` uses the [`cross-fetch`](https://www.npmjs.com/package/cross-fetch) library to make HTTP requests,
	* but an alternative `fetch` implementation can be provided as an option.
	* This is most useful in environments where `cross-fetch` is not compatible (for instance Cloudflare Workers).
	*
	* @example Custom fetch implementation
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key', {
	*   global: { fetch: fetch.bind(globalThis) }
	* })
	* ```
	*
	* @exampleDescription React Native options with AsyncStorage
	* For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
	*
	* @example React Native options with AsyncStorage
	* ```js
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from "@react-native-async-storage/async-storage";
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", {
	*   auth: {
	*     storage: AsyncStorage,
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @exampleDescription React Native options with Expo SecureStore
	* If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
	* The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
	* A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
	* This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
	*
	* Please make sure that:
	* - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
	* - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
	*   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
	* - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
	*
	* @example React Native options with Expo SecureStore
	* ```ts
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from '@react-native-async-storage/async-storage';
	* import * as SecureStore from 'expo-secure-store';
	* import * as aesjs from 'aes-js';
	* import 'react-native-get-random-values';
	*
	* // As Expo's SecureStore does not support values larger than 2048
	* // bytes, an AES-256 key is generated and stored in SecureStore, while
	* // it is used to encrypt/decrypt values stored in AsyncStorage.
	* class LargeSecureStore {
	*   private async _encrypt(key: string, value: string) {
	*     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
	*     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
	*
	*     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
	*
	*     return aesjs.utils.hex.fromBytes(encryptedBytes);
	*   }
	*
	*   private async _decrypt(key: string, value: string) {
	*     const encryptionKeyHex = await SecureStore.getItemAsync(key);
	*     if (!encryptionKeyHex) {
	*       return encryptionKeyHex;
	*     }
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
	*     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
	*
	*     return aesjs.utils.utf8.fromBytes(decryptedBytes);
	*   }
	*
	*   async getItem(key: string) {
	*     const encrypted = await AsyncStorage.getItem(key);
	*     if (!encrypted) { return encrypted; }
	*
	*     return await this._decrypt(key, encrypted);
	*   }
	*
	*   async removeItem(key: string) {
	*     await AsyncStorage.removeItem(key);
	*     await SecureStore.deleteItemAsync(key);
	*   }
	*
	*   async setItem(key: string, value: string) {
	*     const encrypted = await this._encrypt(key, value);
	*
	*     await AsyncStorage.setItem(key, encrypted);
	*   }
	* }
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", {
	*   auth: {
	*     storage: new LargeSecureStore(),
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @example With a database query
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'public-anon-key')
	*
	* const { data } = await supabase.from('profiles').select('*')
	* ```
	*/ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS,
            realtime: $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS,
            auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = $5e33485c08cd650a$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $5e33485c08cd650a$var$fetchWithAuth(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient($5e33485c08cd650a$var$_objectSpread2({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e)=>console.warn("Failed to set initial Realtime auth token:", e));
        this.rest = new (0, $4yorG.PostgrestClient)(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit
        });
        this.storage = new (0, $9Yl9w.StorageClient)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
	* Supabase Functions allows you to deploy and invoke edge functions.
	*/ get functions() {
        return new (0, $9A7Ck.FunctionsClient)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*/ from(relation) {
        return this.rest.from(relation);
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*/ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*/ rpc(fn, args = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args, options);
    }
    /**
	* Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
	*
	* @param {string} name - The name of the Realtime channel.
	* @param {Object} opts - The options to pass to the Realtime channel.
	*
	*/ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
	* Returns all Realtime channels.
	*
	* @category Initializing
	*
	* @example Get all channels
	* ```js
	* const channels = supabase.getChannels()
	* ```
	*/ getChannels() {
        return this.realtime.getChannels();
    }
    /**
	* Unsubscribes and removes Realtime channel from Realtime client.
	*
	* @param {RealtimeChannel} channel - The name of the Realtime channel.
	*
	*
	* @category Initializing
	*
	* @remarks
	* - Removing a channel is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Removes a channel
	* ```js
	* supabase.removeChannel(myChannel)
	* ```
	*/ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
	* Unsubscribes and removes all Realtime channels from Realtime client.
	*
	* @category Initializing
	*
	* @remarks
	* - Removing channels is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Remove all channels
	* ```js
	* supabase.removeAllChannels()
	* ```
	*/ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    async _getAccessToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : _this.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $5e33485c08cd650a$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            fetch: fetch$1,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new (0, $eWiay.default)(this.realtimeUrl.href, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, options), {}, {
            params: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
//#endregion
//#region src/index.ts
/**
* Creates a new Supabase Client.
*
* @example Creating a Supabase client
* ```ts
* import { createClient } from '@supabase/supabase-js'
*
* const supabase = createClient('https://xyzcompany.supabase.co', 'public-anon-key')
* const { data, error } = await supabase.from('profiles').select('*')
* ```
*/ const $5e33485c08cd650a$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new $5e33485c08cd650a$export$1bfe63e045eb2ffa(supabaseUrl, supabaseKey, options);
};
function $5e33485c08cd650a$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined") return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 18;
}
if ($5e33485c08cd650a$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");
$parcel$exportWildcard(module.exports, $izHZ4);
$parcel$exportWildcard(module.exports, $lpqci);

});
parcelRegister("1oqCS", function(module, exports) {

$parcel$export(module.exports, "FunctionsError", () => $103cafb5d5f4c571$export$738689d52335bb3c);
$parcel$export(module.exports, "FunctionsFetchError", () => $103cafb5d5f4c571$export$14f2b6540d498ce);
$parcel$export(module.exports, "FunctionsRelayError", () => $103cafb5d5f4c571$export$d08a45df86040161);
$parcel$export(module.exports, "FunctionsHttpError", () => $103cafb5d5f4c571$export$761f8c0e0fa4624f);
$parcel$export(module.exports, "FunctionRegion", () => $103cafb5d5f4c571$export$9b19f1a5abf91e06);
/**
 * Base error for Supabase Edge Function invocations.
 *
 * @example
 * ```ts
 * import { FunctionsError } from '@supabase/functions-js'
 *
 * throw new FunctionsError('Unexpected error invoking function', 'FunctionsError', {
 *   requestId: 'abc123',
 * })
 * ```
 */ class $103cafb5d5f4c571$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $103cafb5d5f4c571$export$14f2b6540d498ce extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $103cafb5d5f4c571$export$d08a45df86040161 extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $103cafb5d5f4c571$export$761f8c0e0fa4624f extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $103cafb5d5f4c571$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($103cafb5d5f4c571$export$9b19f1a5abf91e06 || ($103cafb5d5f4c571$export$9b19f1a5abf91e06 = {}));

});

parcelRegister("9A7Ck", function(module, exports) {

$parcel$export(module.exports, "FunctionsClient", () => $6f9d627d4ebb0255$export$1d0b400bf8a0fa55);

var $7WQrb = parcelRequire("7WQrb");

var $ffULL = parcelRequire("ffULL");

var $1oqCS = parcelRequire("1oqCS");
class $6f9d627d4ebb0255$export$1d0b400bf8a0fa55 {
    /**
     * Creates a new Functions client bound to an Edge Functions URL.
     *
     * @example
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'public-anon-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     *
     * @category Functions
     *
     * @example Creating a Functions client
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'public-anon-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     */ constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $1oqCS.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $ffULL.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     *
     * @category Functions
     *
     * @example Setting the authorization header
     * ```ts
     * functions.setAuth(session.access_token)
     * ```
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     * @example
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     *
     * @category Functions
     *
     * @remarks
     * - Requires an Authorization header.
     * - Invoke params generally match the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) spec.
     * - When you pass in a body to your function, we automatically attach the Content-Type header for `Blob`, `ArrayBuffer`, `File`, `FormData` and `String`. If it doesn't match any of these types we assume the payload is `json`, serialize it and attach the `Content-Type` header as `application/json`. You can override this behavior by passing in a `Content-Type` header of your own.
     * - Responses are automatically parsed as `json`, `blob` and `form-data` depending on the `Content-Type` header sent by your function. Responses are parsed as `text` by default.
     *
     * @example Basic invocation
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Error handling
     * A `FunctionsHttpError` error is returned if your function throws an error, `FunctionsRelayError` if the Supabase Relay has an error processing your function and `FunctionsFetchError` if there is a network error in calling your function.
     *
     * @example Error handling
     * ```js
     * import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from "@supabase/supabase-js";
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     *
     * if (error instanceof FunctionsHttpError) {
     *   const errorMessage = await error.context.json()
     *   console.log('Function returned an error', errorMessage)
     * } else if (error instanceof FunctionsRelayError) {
     *   console.log('Relay error:', error.message)
     * } else if (error instanceof FunctionsFetchError) {
     *   console.log('Fetch error:', error.message)
     * }
     * ```
     *
     * @exampleDescription Passing custom headers
     * You can pass custom headers to your function. Note: supabase-js automatically passes the `Authorization` header with the signed in user's JWT.
     *
     * @example Passing custom headers
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Calling with DELETE HTTP verb
     * You can also set the HTTP verb to `DELETE` when calling your Edge Function.
     *
     * @example Calling with DELETE HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' },
     *   method: 'DELETE'
     * })
     * ```
     *
     * @exampleDescription Invoking a Function in the UsEast1 region
     * Here are the available regions:
     * - `FunctionRegion.Any`
     * - `FunctionRegion.ApNortheast1`
     * - `FunctionRegion.ApNortheast2`
     * - `FunctionRegion.ApSouth1`
     * - `FunctionRegion.ApSoutheast1`
     * - `FunctionRegion.ApSoutheast2`
     * - `FunctionRegion.CaCentral1`
     * - `FunctionRegion.EuCentral1`
     * - `FunctionRegion.EuWest1`
     * - `FunctionRegion.EuWest2`
     * - `FunctionRegion.EuWest3`
     * - `FunctionRegion.SaEast1`
     * - `FunctionRegion.UsEast1`
     * - `FunctionRegion.UsWest1`
     * - `FunctionRegion.UsWest2`
     *
     * @example Invoking a Function in the UsEast1 region
     * ```js
     * import { createClient, FunctionRegion } from '@supabase/supabase-js'
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' },
     *   region: FunctionRegion.UsEast1
     * })
     * ```
     *
     * @exampleDescription Calling with GET HTTP verb
     * You can also set the HTTP verb to `GET` when calling your Edge Function.
     *
     * @example Calling with GET HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   method: 'GET'
     * })
     * ```
     *
     * @example Example 7
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     */ invoke(functionName_1) {
        return (0, $7WQrb.__awaiter)(this, arguments, void 0, function*(functionName, options = {}) {
            var _a;
            let timeoutId;
            let timeoutController;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== 'string' && !(typeof Blob !== 'undefined' && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== 'undefined' && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                // Handle timeout by creating an AbortController
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    // If user provided their own signal, we need to respect both
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        // If the user's signal is aborted, abort our timeout controller too
                        signal.addEventListener('abort', ()=>timeoutController.abort());
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new (0, $1oqCS.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $1oqCS.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, $1oqCS.FunctionsHttpError)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream' || responseType === 'application/pdf') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $1oqCS.FunctionsHttpError) || error instanceof (0, $1oqCS.FunctionsRelayError) ? error.context : undefined
                };
            } finally{
                // Clear the timeout if it was set
                if (timeoutId) clearTimeout(timeoutId);
            }
        });
    }
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("ffULL", function(module, exports) {

$parcel$export(module.exports, "resolveFetch", () => $b1b44af3c77a62f9$export$98d92b1aa79f8cc7);
const $b1b44af3c77a62f9$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};

});


parcelRegister("4yorG", function(module, exports) {

$parcel$export(module.exports, "PostgrestError", () => $cfc0ca97c19fecec$export$445b7e3a323f992f);
$parcel$export(module.exports, "PostgrestClient", () => $cfc0ca97c19fecec$export$796f32e2ee984aaa);
//#region src/PostgrestError.ts
/**
* Error format
*
* {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
*/ var $cfc0ca97c19fecec$export$445b7e3a323f992f = class extends Error {
    /**
	* @example
	* ```ts
	* import PostgrestError from '@supabase/postgrest-js'
	*
	* throw new PostgrestError({
	*   message: 'Row level security prevented the request',
	*   details: 'RLS denied the insert',
	*   hint: 'Check your policies',
	*   code: 'PGRST301',
	* })
	* ```
	*/ constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
};
//#endregion
//#region src/PostgrestBuilder.ts
var $cfc0ca97c19fecec$export$3106e21688a06353 = class {
    /**
	* Creates a builder configured for a specific PostgREST request.
	*
	* @example
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'public-anon-key' }) }
	* )
	* ```
	*
	* @category Database
	*
	* @example Creating a Postgrest query builder
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'public-anon-key' }) }
	* )
	* ```
	*/ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$urlLengthLim;
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
	* If there's an error with the query, throwOnError will reject the promise by
	* throwing the error instead of returning it as part of a successful response.
	*
	* {@link https://github.com/supabase/supabase-js/issues/92}
	*
	* @category Database
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	*
	* @category Database
	*/ setHeader(name, value) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value);
        return this;
    }
    /**  *
	* @category Database
	*/ then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res$1)=>{
            let error = null;
            let data = null;
            let count = null;
            let status = res$1.status;
            let statusText = res$1.statusText;
            if (res$1.ok) {
                var _this$headers$get2, _res$headers$get;
                if (_this.method !== "HEAD") {
                    var _this$headers$get;
                    const body = await res$1.text();
                    if (body === "") ;
                    else if (_this.headers.get("Accept") === "text/csv") data = body;
                    else if (_this.headers.get("Accept") && ((_this$headers$get = _this.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_this$headers$get2 = _this.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
                const contentRange = (_res$headers$get = res$1.headers.get("content-range")) === null || _res$headers$get === void 0 ? void 0 : _res$headers$get.split("/");
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                if (_this.isMaybeSingle && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            code: "PGRST116",
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: "JSON object requested, multiple (or no) rows returned"
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = "Not Acceptable";
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res$1.text();
                try {
                    error = JSON.parse(body);
                    if (Array.isArray(error) && res$1.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = "OK";
                    }
                } catch (_unused) {
                    if (res$1.status === 404 && body === "") {
                        status = 204;
                        statusText = "No Content";
                    } else error = {
                        message: body
                    };
                }
                if (error && _this.shouldThrowOnError) throw new $cfc0ca97c19fecec$export$445b7e3a323f992f(error);
            }
            return {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `\n\nCaused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `\n${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*/ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
	* Override the type of the returned `data` field in the response.
	*
	* @typeParam NewResult - The new type to cast the response data to
	* @typeParam Options - Optional type configuration (defaults to { merge: true })
	* @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
	* @example
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	* @returns A PostgrestBuilder instance with the new type
	*
	* @category Database
	*
	* @example Complete Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<MyType>, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of successful response
	* ```ts
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Complete Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<MyType, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of object response
	* ```ts
	* let x: typeof data // MyType | null
	* ```
	*
	* @example Partial Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<{ status: "A" | "B" }>>()
	* ```
	*
	* @exampleResponse Partial Override type of successful response
	* ```ts
	* let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
	* ```
	*
	* @example Partial Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<{ status: "A" | "B" }>()
	* ```
	*
	* @exampleResponse Partial Override type of object response
	* ```ts
	* let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
	* ```
	*
	* @example Example 5
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	*/ overrideTypes() {
        return this;
    }
};
//#endregion
//#region src/PostgrestTransformBuilder.ts
var $cfc0ca97c19fecec$export$7b4361bb87e3030c = class extends $cfc0ca97c19fecec$export$3106e21688a06353 {
    /**
	* Perform a SELECT on the query result.
	*
	* By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
	* return modified rows. By calling this method, modified rows are returned in
	* `data`.
	*
	* @param columns - The columns to retrieve, separated by commas
	*
	* @category Database
	*
	* @example With `upsert()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .upsert({ id: 1, name: 'Han Solo' })
	*   .select()
	* ```
	*
	* @exampleSql With `upsert()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Han');
	* ```
	*
	* @exampleResponse With `upsert()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Han Solo"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*/ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
	* Order the query result by `column`.
	*
	* You can call this method multiple times to order by multiple columns.
	*
	* You can order referenced tables, but it only affects the ordering of the
	* parent table if you use `!inner` in the query.
	*
	* @param column - The column to order by
	* @param options - Named parameters
	* @param options.ascending - If `true`, the result will be in ascending order
	* @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
	* `null`s appear last.
	* @param options.referencedTable - Set this to order a referenced table by
	* its columns
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('id, name')
	*   .order('id', { ascending: false })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On a referenced table
	* Ordering with `referencedTable` doesn't affect the ordering of the
	* parent table.
	*
	* @example On a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('orchestral_sections')
	*     .select(`
	*       name,
	*       instruments (
	*         name
	*       )
	*     `)
	*     .order('name', { referencedTable: 'instruments', ascending: false })
	*
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         },
	*         {
	*           "name": "harp"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": []
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Order parent table by a referenced table
	* Ordering with `referenced_table(col)` affects the ordering of the
	* parent table.
	*
	* @example Order parent table by a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('instruments')
	*     .select(`
	*       name,
	*       section:orchestral_sections (
	*         name
	*       )
	*     `)
	*     .order('section(name)', { ascending: true })
	*
	* ```
	*
	* @exampleSql Order parent table by a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Order parent table by a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "violin",
	*       "orchestral_sections": {"name": "strings"}
	*     },
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
	* Limit the query result by `count`.
	*
	* @param count - The maximum number of rows to return
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	*   .limit(1, { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
	* Limit the query result by starting at an offset `from` and ending at the offset `to`.
	* Only records within this range are returned.
	* This respects the query order and if there is no order clause the range could behave unexpectedly.
	* The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
	* and fourth rows of the query.
	*
	* @param from - The starting index from which to limit the result
	* @param to - The last index to which to limit the result
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .range(0, 1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     },
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
	* Set the AbortSignal for the fetch request.
	*
	* @param signal - The AbortSignal to use for the fetch request
	*
	* @category Database
	*
	* @remarks
	* You can use this to set a timeout for the request.
	*
	* @exampleDescription Aborting requests in-flight
	* You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
	* Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
	*
	* @example Aborting requests in-flight
	* ```ts
	* const ac = new AbortController()
	*
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(ac.signal)
	*
	* // Abort the request after 100 ms
	* setTimeout(() => ac.abort(), 100)
	* ```
	*
	* @exampleResponse Aborting requests in-flight
	* ```json
	*   {
	*     "error": {
	*       "message": "AbortError: The user aborted a request.",
	*       "details": "",
	*       "hint": "The request was aborted locally via the provided AbortSignal.",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*
	* @example Set a timeout
	* ```ts
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
	* ```
	*
	* @exampleResponse Set a timeout
	* ```json
	*   {
	*     "error": {
	*       "message": "FetchError: The user aborted a request.",
	*       "details": "",
	*       "hint": "",
	*       "code": ""
	*     },
	*     "status": 400,
	*     "statusText": "Bad Request"
	*   }
	*
	* ```
	*/ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be one row (e.g. using `.limit(1)`), otherwise this
	* returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	*   .single()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": {
	*     "name": "Luke"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
	* this returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Katniss')
	*   .maybeSingle()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ maybeSingle() {
        this.isMaybeSingle = true;
        return this;
    }
    /**
	* Return `data` as a string in CSV format.
	*
	* @category Database
	*
	* @exampleDescription Return data as CSV
	* By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
	*
	* @example Return data as CSV
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .csv()
	* ```
	*
	* @exampleSql Return data as CSV
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Return data as CSV
	* ```json
	* {
	*   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
	* Return `data` as an object in [GeoJSON](https://geojson.org) format.
	*
	* @category Database
	*/ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
	* Return `data` as the EXPLAIN plan for the query.
	*
	* You need to enable the
	* [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
	* setting before using this method.
	*
	* @param options - Named parameters
	*
	* @param options.analyze - If `true`, the query will be executed and the
	* actual run time will be returned
	*
	* @param options.verbose - If `true`, the query identifier will be returned
	* and `data` will include the output columns of the query
	*
	* @param options.settings - If `true`, include information on configuration
	* parameters that affect query planning
	*
	* @param options.buffers - If `true`, include information on buffer usage
	*
	* @param options.wal - If `true`, include information on WAL record generation
	*
	* @param options.format - The format of the output, can be `"text"` (default)
	* or `"json"`
	*
	* @category Database
	*
	* @exampleDescription Get the execution plan
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain()
	* ```
	*
	* @exampleSql Get the execution plan
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
	*         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
	* ```
	*
	* @exampleDescription Get the execution plan with analyze and verbose
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan with analyze and verbose
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain({analyze:true,verbose:true})
	* ```
	*
	* @exampleSql Get the execution plan with analyze and verbose
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan with analyze and verbose
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
	*   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
	*         Output: characters.id, characters.name
	*         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
	*               Output: characters.id, characters.name
	* Query Identifier: -4730654291623321173
	* Planning Time: 0.407 ms
	* Execution Time: 0.119 ms
	* ```
	*/ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
	* Rollback the query.
	*
	* `data` will still be returned, but the query is not committed.
	*
	* @category Database
	*/ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*
	* @remarks
	* - Deprecated: use overrideTypes method instead
	*
	* @example Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .returns<Array<MyType>>()
	* ```
	*
	* @exampleResponse Override type of successful response
	* ```js
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .returns<MyType>()
	* ```
	*
	* @exampleResponse Override type of object response
	* ```js
	* let x: typeof data // MyType | null
	* ```
	*/ returns() {
        return this;
    }
    /**
	* Set the maximum number of rows that can be affected by the query.
	* Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
	*
	* @param value - The maximum number of rows that can be affected
	*
	* @category Database
	*/ maxAffected(value) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestFilterBuilder.ts
const $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $cfc0ca97c19fecec$export$3158317c13bdc93a = class extends $cfc0ca97c19fecec$export$7b4361bb87e3030c {
    /**
	* Match only rows where `column` is equal to `value`.
	*
	* To check if the value of `column` is NULL, you should use `.is()` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is not equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .neq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* When using [reserved words](https://www.postgresql.org/docs/current/sql-keywords-appendix.html) for column names you need
	* to add double quotes e.g. `.gt('"order"', 2)`
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-sensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .like('name', '%Lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-insensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .ilike('name', '%lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-sensitively (using the `~` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-insensitively (using the `~*` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` IS `value`.
	*
	* For non-boolean columns, this is only relevant for checking if the value of
	* `column` is NULL by setting `value` to `null`.
	*
	* For boolean columns, you can also set `value` to `true` or `false` and it
	* will behave the same way as `.eq()`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription Checking for nullness, true or false
	* Using the `eq()` filter doesn't work when filtering for `null`.
	*
	* Instead, you need to use `is()`.
	*
	* @example Checking for nullness, true or false
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .is('name', null)
	* ```
	*
	* @exampleSql Checking for nullness, true or false
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse Checking for nullness, true or false
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "null"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` IS DISTINCT FROM `value`.
	*
	* Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
	* are considered equal (not distinct), and comparing `NULL` with any non-NULL
	* value returns true (distinct).
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*/ isDistinct(column, value) {
        this.url.searchParams.append(column, `isdistinct.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .in('name', ['Leia', 'Han'])
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
	* Match only rows where `column` is NOT included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*/ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* `column` contains every element appearing in `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select()
	*   .contains('tags', ['is:open', 'priority:low'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .contains('during', '[2000-01-01 13:00, 2000-01-01 13:30)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .contains('address', { postcode: 90210 })
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Michael"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ contains(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* every element appearing in `column` is contained by `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('classes')
	*   .select('name')
	*   .containedBy('days', ['monday', 'tuesday', 'wednesday', 'friday'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   classes (
	*     id int8 primary key,
	*     name text,
	*     days text[]
	*   );
	*
	* insert into
	*   classes (id, name, days)
	* values
	*   (1, 'Chemistry', array['monday', 'friday']),
	*   (2, 'History', array['monday', 'wednesday', 'thursday']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Chemistry"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .containedBy('during', '[2000-01-01 00:00, 2000-01-01 23:59)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .containedBy('address', {})
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Jane"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ containedBy(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is greater than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGt('during', '[2000-01-02 08:00, 2000-01-02 09:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or greater than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGte('during', '[2000-01-02 08:30, 2000-01-02 09:30)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is less than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLt('during', '[2000-01-01 15:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or less than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLte('during', '[2000-01-01 14:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "room_name": "Emerald",
	*         "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where `column` is
	* mutually exclusive to `range` and there can be no element between the two
	* ranges.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeAdjacent('during', '[2000-01-01 12:00, 2000-01-01 13:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
	* Only relevant for array and range columns. Match only rows where
	* `column` and `value` have an element in common.
	*
	* @param column - The array or range column to filter on
	* @param value - The array or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select('title')
	*   .overlaps('tags', ['is:closed', 'severity:high'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .overlaps('during', '[2000-01-01 12:45, 2000-01-01 13:15)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ overlaps(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `ov.${value}`);
        else this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
	* Only relevant for text and tsvector columns. Match only rows where
	* `column` matches the query string in `query`.
	*
	* @param column - The text or tsvector column to filter on
	* @param query - The query text to match with
	* @param options - Named parameters
	* @param options.config - The text search configuration to use
	* @param options.type - Change how the `query` text is interpreted
	*
	* @category Database
	*
	* @remarks
	* - For more information, see [Postgres full text search](/docs/guides/database/full-text-search).
	*
	* @example Text search
	* ```ts
	* const result = await supabase
	*   .from("texts")
	*   .select("content")
	*   .textSearch("content", `'eggs' & 'ham'`, {
	*     config: "english",
	*   });
	* ```
	*
	* @exampleSql Text search
	* ```sql
	* create table texts (
	*   id      bigint
	*           primary key
	*           generated always as identity,
	*   content text
	* );
	*
	* insert into texts (content) values
	*     ('Four score and seven years ago'),
	*     ('The road goes ever on and on'),
	*     ('Green eggs and ham')
	* ;
	* ```
	*
	* @exampleResponse Text search
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "Green eggs and ham"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Basic normalization
	* Uses PostgreSQL's `plainto_tsquery` function.
	*
	* @example Basic normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'plain',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Full normalization
	* Uses PostgreSQL's `phraseto_tsquery` function.
	*
	* @example Full normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'phrase',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Websearch
	* Uses PostgreSQL's `websearch_to_tsquery` function.
	* This function will never raise syntax errors, which makes it possible to use raw user-supplied input for search, and can be used
	* with advanced operators.
	*
	* - `unquoted text`: text not inside quote marks will be converted to terms separated by & operators, as if processed by plainto_tsquery.
	* - `"quoted text"`: text inside quote marks will be converted to terms separated by `<->` operators, as if processed by phraseto_tsquery.
	* - `OR`: the word “or” will be converted to the | operator.
	* - `-`: a dash will be converted to the ! operator.
	*
	* @example Websearch
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat or cat'`, {
	*     type: 'websearch',
	*     config: 'english'
	*   })
	* ```
	*/ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
	* Match only rows where each column in `query` keys is equal to its
	* associated value. Shorthand for multiple `.eq()`s.
	*
	* @param query - The object to filter with, with column names as keys mapped
	* to their filter values
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .match({ id: 2, name: 'Leia' })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ match(query) {
        Object.entries(query).filter(([_, value])=>value !== void 0).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
	* Match only rows which doesn't satisfy the filter.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to be negated to filter with, following
	* PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* not() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .not('name', 'is', null)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "name": "null"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
	* Match only rows which satisfy at least one of the filters.
	*
	* Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure it's properly sanitized.
	*
	* It's currently not possible to do an `.or()` filter across multiple tables.
	*
	* @param filters - The filters to use, following PostgREST syntax
	* @param options - Named parameters
	* @param options.referencedTable - Set this to filter on referenced tables
	* instead of the parent table
	* @param options.foreignTable - Deprecated, use `referencedTable` instead
	*
	* @category Database
	*
	* @remarks
	* or() expects you to use the raw PostgREST syntax for the filter names and values.
	*
	* ```ts
	* .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
	* .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.eq.2,name.eq.Han')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     },
	*     {
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` with `and`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
	* ```
	*
	* @exampleSql Use `or` with `and`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Use `or` with `and`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` on referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql Use `or` on referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Use `or` on referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
	* Match only rows which satisfy the filter. This is an escape hatch - you
	* should use the specific filter methods wherever possible.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to filter with, following PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* filter() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .filter('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .filter('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .filter('name', 'in', '("Han","Yoda")')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .filter('instruments.name', 'eq', 'flute')
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*    instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestQueryBuilder.ts
var $cfc0ca97c19fecec$export$a81993b50ca081ad = class {
    /**
	* Creates a query builder scoped to a Postgres table or view.
	*
	* @category Database
	*
	* @example Creating a Postgrest query builder
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'public-anon-key' } }
	* )
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3 }){
        this.url = url;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
    }
    /**
	* Clone URL and headers to prevent shared state between operations.
	*/ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
	* Perform a SELECT query on the table or view.
	*
	* @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
	*
	* @param options - Named parameters
	*
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	*
	* @param options.count - Count algorithm to use to count rows in the table or view.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @remarks
	* When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
	* that match your filters, not the number of rows in the current page. Use this to build pagination UI.
	
	* - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
	* - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
	* - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
	* - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
	* @category Database
	*
	* @example Getting your data
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	* ```
	*
	* @exampleSql Getting your data
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Harry'),
	*   (2, 'Frodo'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Getting your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Harry"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Frodo"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Selecting specific columns
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	* ```
	*
	* @exampleSql Selecting specific columns
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Frodo'),
	*   (2, 'Harry'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Selecting specific columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Frodo"
	*     },
	*     {
	*       "name": "Harry"
	*     },
	*     {
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables
	* If your database has foreign key relationships, you can query related tables too.
	*
	* @example Query referenced tables
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables with spaces in their names
	* If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
	*
	* @example Query referenced tables with spaces in their names
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral sections')
	*   .select(`
	*     name,
	*     "musical instruments" (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables with spaces in their names
	* ```sql
	* create table
	*   "orchestral sections" (id int8 primary key, name text);
	* create table
	*   "musical instruments" (
	*     id int8 primary key,
	*     section_id int8 not null references "orchestral sections",
	*     name text
	*   );
	*
	* insert into
	*   "orchestral sections" (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   "musical instruments" (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables with spaces in their names
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "musical instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "musical instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables through a join table
	* If you're in a situation where your tables are **NOT** directly
	* related, but instead are joined by a _join table_, you can still use
	* the `select()` method to query the related data. The join table needs
	* to have the foreign keys as part of its composite primary key.
	*
	* @example Query referenced tables through a join table
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     name,
	*     teams (
	*       name
	*     )
	*   `)
	*   
	* ```
	*
	* @exampleSql Query referenced tables through a join table
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*     -- both foreign keys must be part of a composite primary key
	*     primary key (user_id, team_id)
	*   );
	*
	* insert into
	*   users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* ```
	*
	* @exampleResponse Query referenced tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Kiran",
	*         "teams": [
	*           {
	*             "name": "Green"
	*           },
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       },
	*       {
	*         "name": "Evan",
	*         "teams": [
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Query the same referenced table multiple times
	* If you need to query the same referenced table twice, use the name of the
	* joined column to identify which join to use. You can also give each
	* column an alias.
	*
	* @example Query the same referenced table multiple times
	* ```ts
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:sender_id(name),
	*     to:receiver_id(name)
	*   `)
	*
	* // To infer types, use the name of the table (in this case `users`) and
	* // the name of the foreign key constraint.
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:users!messages_sender_id_fkey(name),
	*     to:users!messages_receiver_id_fkey(name)
	*   `)
	* ```
	*
	* @exampleSql Query the same referenced table multiple times
	* ```sql
	*  create table
	*  users (id int8 primary key, name text);
	*
	*  create table
	*    messages (
	*      sender_id int8 not null references users,
	*      receiver_id int8 not null references users,
	*      content text
	*    );
	*
	*  insert into
	*    users (id, name)
	*  values
	*    (1, 'Kiran'),
	*    (2, 'Evan');
	*
	*  insert into
	*    messages (sender_id, receiver_id, content)
	*  values
	*    (1, 2, '👋');
	*  ```
	* ```
	*
	* @exampleResponse Query the same referenced table multiple times
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "👋",
	*       "from": {
	*         "name": "Kiran"
	*       },
	*       "to": {
	*         "name": "Evan"
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query nested foreign tables through a join table
	* You can use the result of a joined table to gather data in
	* another foreign table. With multiple references to the same foreign
	* table you must specify the column on which to conduct the join.
	*
	* @example Query nested foreign tables through a join table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('games')
	*     .select(`
	*       game_id:id,
	*       away_team:teams!games_away_team_fkey (
	*         users (
	*           id,
	*           name
	*         )
	*       )
	*     `)
	*   
	* ```
	*
	* @exampleSql Query nested foreign tables through a join table
	* ```sql
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*
	*     primary key (user_id, team_id)
	*   );
	* create table
	*   games (
	*     id int8 primary key,
	*     home_team int8 not null references teams,
	*     away_team int8 not null references teams,
	*     name text
	*   );
	*
	* insert into users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* insert into
	*   games (id, home_team, away_team, name)
	* values
	*   (1, 1, 2, 'Green vs Blue'),
	*   (2, 2, 1, 'Blue vs Green');
	* ```
	*
	* @exampleResponse Query nested foreign tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "game_id": 1,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             },
	*             {
	*               "id": 2,
	*               "name": "Evan"
	*             }
	*           ]
	*         }
	*       },
	*       {
	*         "game_id": 2,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             }
	*           ]
	*         }
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Filtering through referenced tables
	* If the filter on a referenced table's column is not satisfied, the referenced
	* table returns `[]` or `null` but the parent table is not filtered out.
	* If you want to filter out the parent table rows, use the `!inner` hint
	*
	* @example Filtering through referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections(*)')
	*   .eq('orchestral_sections.name', 'percussion')
	* ```
	*
	* @exampleSql Filtering through referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Filtering through referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": null
	*     },
	*     {
	*       "name": "violin",
	*       "orchestral_sections": null
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with count
	* You can get the number of rows in a related table by using the
	* **count** property.
	*
	* @example Querying referenced table with count
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`*, instruments(count)`)
	* ```
	*
	* @exampleSql Querying referenced table with count
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table characters (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('strings') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('violin', (select id from section)),
	* ('viola', (select id from section)),
	* ('cello', (select id from section)),
	* ('double bass', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with count
	* ```json
	* [
	*   {
	*     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
	*     "name": "strings",
	*     "instruments": [
	*       {
	*         "count": 4
	*       }
	*     ]
	*   }
	* ]
	* ```
	*
	* @exampleDescription Querying with count option
	* You can get the number of rows by using the
	* [count](/docs/reference/javascript/select#parameters) option.
	*
	* @example Querying with count option
	* ```ts
	* const { count, error } = await supabase
	*   .from('characters')
	*   .select('*', { count: 'exact', head: true })
	* ```
	*
	* @exampleSql Querying with count option
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Querying with count option
	* ```json
	* {
	*   "count": 3,
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying JSON data
	* You can select and filter data inside of
	* [JSON](/docs/guides/database/json) columns. Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* querying JSON data.
	*
	* @example Querying JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     id, name,
	*     address->city
	*   `)
	* ```
	*
	* @exampleSql Querying JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Frodo', '{"city":"Hobbiton"}');
	* ```
	*
	* @exampleResponse Querying JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Frodo",
	*       "city": "Hobbiton"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with inner join
	* If you don't want to return the referenced table contents, you can leave the parenthesis empty.
	* Like `.select('name, orchestral_sections!inner()')`.
	*
	* @example Querying referenced table with inner join
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections!inner(name)')
	*   .eq('orchestral_sections.name', 'woodwinds')
	*   .limit(1)
	* ```
	*
	* @exampleSql Querying referenced table with inner join
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table instruments (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('woodwinds') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('flute', (select id from section)),
	* ('clarinet', (select id from section)),
	* ('bassoon', (select id from section)),
	* ('piccolo', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with inner join
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Switching schemas per query
	* In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
	* Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
	*
	* @example Switching schemas per query
	* ```ts
	* const { data, error } = await supabase
	*   .schema('myschema')
	*   .from('mytable')
	*   .select()
	* ```
	*
	* @exampleSql Switching schemas per query
	* ```sql
	* create schema myschema;
	*
	* create table myschema.mytable (
	*   id uuid primary key default gen_random_uuid(),
	*   data text
	* );
	*
	* insert into myschema.mytable (data) values ('mydata');
	* ```
	*
	* @exampleResponse Switching schemas per query
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
	*       "data": "mydata"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ select(columns, options) {
        const { head: head = false, count: count } = options !== null && options !== void 0 ? options : {};
        const method = head ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        const { url: url, headers: headers } = this.cloneRequestState();
        url.searchParams.set("select", cleanedColumns);
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an INSERT into the table or view.
	*
	* By default, inserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to insert. Pass an object to insert a single row
	* or an array to insert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count inserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. Only applies for bulk
	* inserts.
	*
	* @category Database
	*
	* @example Create a record
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	* ```
	*
	* @exampleSql Create a record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record
	* ```json
	* {
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Create a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	*   .select()
	* ```
	*
	* @exampleSql Create a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Bulk create
	* A bulk create operation is handled in a single transaction.
	* If any of the inserts fail, none of the rows are inserted.
	*
	* @example Bulk create
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert([
	*     { id: 1, name: 'Mordor' },
	*     { id: 1, name: 'The Shire' },
	*   ])
	* ```
	*
	* @exampleSql Bulk create
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Bulk create
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (id)=(1) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"countries_pkey\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an UPSERT on the table or view. Depending on the column(s) passed
	* to `onConflict`, `.upsert()` allows you to perform the equivalent of
	* `.insert()` if a row with the corresponding `onConflict` columns doesn't
	* exist, or if it does exist, perform an alternative action depending on
	* `ignoreDuplicates`.
	*
	* By default, upserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to upsert with. Pass an object to upsert a
	* single row or an array to upsert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
	* duplicate rows are determined. Two rows are duplicates if all the
	* `onConflict` columns are equal.
	*
	* @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
	* `false`, duplicate rows are merged with existing rows.
	*
	* @param options.count - Count algorithm to use to count upserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. This only applies when
	* inserting new rows, not when merging with existing rows under
	* `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
	*
	* @example Upsert a single row using a unique key
	* ```ts
	* // Upserting a single row, overwriting based on the 'username' unique column
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ username: 'supabot' }, { onConflict: 'username' })
	*
	* // Example response:
	* // {
	* //   data: [
	* //     { id: 4, message: 'bar', username: 'supabot' }
	* //   ],
	* //   error: null
	* // }
	* ```
	*
	* @example Upsert with conflict resolution and exact row counting
	* ```ts
	* // Upserting and returning exact count
	* const { data, error, count } = await supabase
	*   .from('users')
	*   .upsert(
	*     {
	*       id: 3,
	*       message: 'foo',
	*       username: 'supabot'
	*     },
	*     {
	*       onConflict: 'username',
	*       count: 'exact'
	*     }
	*   )
	*
	* // Example response:
	* // {
	* //   data: [
	* //     {
	* //       id: 42,
	* //       handle: "saoirse",
	* //       display_name: "Saoirse"
	* //     }
	* //   ],
	* //   count: 1,
	* //   error: null
	* // }
	* ```
	*
	* @category Database
	*
	* @remarks
	* - Primary keys must be included in `values` to use upsert.
	*
	* @example Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert({ id: 1, name: 'piano' })
	*   .select()
	* ```
	*
	* @exampleSql Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Bulk Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert([
	*     { id: 1, name: 'piano' },
	*     { id: 2, name: 'harp' },
	*   ])
	*   .select()
	* ```
	*
	* @exampleSql Bulk Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Bulk Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     },
	*     {
	*       "id": 2,
	*       "name": "harp"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Upserting into tables with constraints
	* In the following query, `upsert()` implicitly uses the `id`
	* (primary key) column to determine conflicts. If there is no existing
	* row with the same `id`, `upsert()` inserts a new row, which
	* will fail in this case as there is already a row with `handle` `"saoirse"`.
	* Using the `onConflict` option, you can instruct `upsert()` to use
	* another column with a unique constraint to determine conflicts.
	*
	* @example Upserting into tables with constraints
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
	*   .select()
	* ```
	*
	* @exampleSql Upserting into tables with constraints
	* ```sql
	* create table
	*   users (
	*     id int8 generated by default as identity primary key,
	*     handle text not null unique,
	*     display_name text
	*   );
	*
	* insert into
	*   users (id, handle, display_name)
	* values
	*   (1, 'saoirse', null);
	* ```
	*
	* @exampleResponse Upserting into tables with constraints
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (handle)=(saoirse) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"users_handle_key\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url.searchParams.set("on_conflict", onConflict);
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an UPDATE on the table or view.
	*
	* By default, updated rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param values - The values to update with
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count updated rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
	*
	* @example Updating your data
	* ```ts
	* const { error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Updating your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Updating your data
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Update a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Update a record and return it
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Update a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Updating JSON data
	* Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* working with JSON data. Currently, it is only possible to update the entire JSON document.
	*
	* @example Updating JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .update({
	*     address: {
	*       street: 'Melrose Place',
	*       postcode: 90210
	*     }
	*   })
	*   .eq('address->postcode', 90210)
	*   .select()
	* ```
	*
	* @exampleSql Updating JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210 }');
	* ```
	*
	* @exampleResponse Updating JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Michael",
	*       "address": {
	*         "street": "Melrose Place",
	*         "postcode": 90210
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ update(values, { count: count } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform a DELETE on the table or view.
	*
	* By default, deleted rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count deleted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
	* - If you use `delete()` with filters and you have
	*   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
	*   rows visible through `SELECT` policies are deleted. Note that by default
	*   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
	*   makes the rows visible.
	* - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
	*
	* @example Delete a single record
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Delete a single record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a single record
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Delete a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Delete a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Delete multiple records
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .in('id', [1, 2, 3])
	* ```
	*
	* @exampleSql Delete multiple records
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
	* ```
	*
	* @exampleResponse Delete multiple records
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*/ delete({ count: count } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $cfc0ca97c19fecec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cfc0ca97c19fecec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $cfc0ca97c19fecec$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $cfc0ca97c19fecec$var$toPrimitive(t, r) {
    if ("object" != $cfc0ca97c19fecec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cfc0ca97c19fecec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $cfc0ca97c19fecec$var$toPropertyKey(t) {
    var i = $cfc0ca97c19fecec$var$toPrimitive(t, "string");
    return "symbol" == $cfc0ca97c19fecec$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $cfc0ca97c19fecec$var$_defineProperty(e, r, t) {
    return (r = $cfc0ca97c19fecec$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $cfc0ca97c19fecec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfc0ca97c19fecec$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfc0ca97c19fecec$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $cfc0ca97c19fecec$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfc0ca97c19fecec$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/PostgrestClient.ts
/**
* PostgREST client.
*
* @typeParam Database - Types for the schema from the [type
* generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
*
* @typeParam SchemaName - Postgres schema to switch to. Must be a string
* literal, the same one passed to the constructor. If the schema is not
* `"public"`, this must be supplied manually.
*/ var $cfc0ca97c19fecec$export$796f32e2ee984aaa = class PostgrestClient {
    /**
	* Creates a PostgREST client.
	*
	* @param url - URL of the PostgREST endpoint
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to switch to
	* @param options.fetch - Custom fetch
	* @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
	* @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
	* @example
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*
	* @category Database
	*
	* @remarks
	* - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
	* - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
	*
	* @example Creating a Postgrest client
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	* })
	* ```
	*
	* @example With timeout
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3 } = {}){
        this.url = url;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*
	* @category Database
	*/ from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $cfc0ca97c19fecec$export$a81993b50ca081ad(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*
	* @category Database
	*/ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @example
	* ```ts
	* // For cross-schema functions where type inference fails, use overrideTypes:
	* const { data } = await supabase
	*   .schema('schema_b')
	*   .rpc('function_a', {})
	*   .overrideTypes<{ id: string; user_id: string }[]>()
	* ```
	*
	* @category Database
	*
	* @example Call a Postgres function without arguments
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world')
	* ```
	*
	* @exampleSql Call a Postgres function without arguments
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function without arguments
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a Postgres function with arguments
	* ```ts
	* const { data, error } = await supabase.rpc('echo', { say: '👋' })
	* ```
	*
	* @exampleSql Call a Postgres function with arguments
	* ```sql
	* create function echo(say text) returns text as $$
	*   select say;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with arguments
	* ```json
	*   {
	*     "data": "👋",
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*
	* @exampleDescription Bulk processing
	* You can process large payloads by passing in an array as an argument.
	*
	* @example Bulk processing
	* ```ts
	* const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
	* ```
	*
	* @exampleSql Bulk processing
	* ```sql
	* create function add_one_each(arr int[]) returns int[] as $$
	*   select array_agg(n + 1) from unnest(arr) as n;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Bulk processing
	* ```json
	* {
	*   "data": [
	*     2,
	*     3,
	*     4
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Call a Postgres function with filters
	* Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
	*
	* @example Call a Postgres function with filters
	* ```ts
	* const { data, error } = await supabase
	*   .rpc('list_stored_countries')
	*   .eq('id', 1)
	*   .single()
	* ```
	*
	* @exampleSql Call a Postgres function with filters
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'),
	*   (2, 'The Shire');
	*
	* create function list_stored_countries() returns setof countries as $$
	*   select * from countries;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with filters
	* ```json
	* {
	*   "data": {
	*     "id": 1,
	*     "name": "Rohan"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a read-only Postgres function
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
	* ```
	*
	* @exampleSql Call a read-only Postgres function
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a read-only Postgres function
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        var _this$fetch;
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v)=>v !== null && typeof v === "object" && (!Array.isArray(v) || v.some(_isObject));
        const _hasObjectArg = head && Object.values(args).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args;
        } else if (head || get) {
            method = head ? "HEAD" : "GET";
            Object.entries(args).filter(([_, value])=>value !== void 0).map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(",")}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count ? `count=${count},return=minimal` : "return=minimal");
        else if (count) headers.set("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
};
//#endregion
//#region src/index.ts
var $cfc0ca97c19fecec$export$2e2bcd8739ae039 = {
    PostgrestClient: $cfc0ca97c19fecec$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $cfc0ca97c19fecec$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $cfc0ca97c19fecec$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $cfc0ca97c19fecec$export$7b4361bb87e3030c,
    PostgrestBuilder: $cfc0ca97c19fecec$export$3106e21688a06353,
    PostgrestError: $cfc0ca97c19fecec$export$445b7e3a323f992f
};

});

parcelRegister("izHZ4", function(module, exports) {

$parcel$export(module.exports, "RealtimePresence", () => (parcelRequire("6zp63")).default);
$parcel$export(module.exports, "RealtimeChannel", () => (parcelRequire("IhlL5")).default);
$parcel$export(module.exports, "RealtimeClient", () => (parcelRequire("eWiay")).default);
$parcel$export(module.exports, "REALTIME_LISTEN_TYPES", () => (parcelRequire("IhlL5")).REALTIME_LISTEN_TYPES);
$parcel$export(module.exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", () => (parcelRequire("IhlL5")).REALTIME_POSTGRES_CHANGES_LISTEN_EVENT);
$parcel$export(module.exports, "REALTIME_PRESENCE_LISTEN_EVENTS", () => (parcelRequire("6zp63")).REALTIME_PRESENCE_LISTEN_EVENTS);
$parcel$export(module.exports, "REALTIME_SUBSCRIBE_STATES", () => (parcelRequire("IhlL5")).REALTIME_SUBSCRIBE_STATES);
$parcel$export(module.exports, "REALTIME_CHANNEL_STATES", () => (parcelRequire("IhlL5")).REALTIME_CHANNEL_STATES);
$parcel$export(module.exports, "WebSocketFactory", () => (parcelRequire("hnThW")).default);

var $eWiay = parcelRequire("eWiay");

var $IhlL5 = parcelRequire("IhlL5");

var $6zp63 = parcelRequire("6zp63");

var $hnThW = parcelRequire("hnThW");

});
parcelRegister("eWiay", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae049384a7d1c7c8$export$2e2bcd8739ae039);

var $hnThW = parcelRequire("hnThW");

var $5gqEk = parcelRequire("5gqEk");

var $8VIf2 = parcelRequire("8VIf2");

var $5po7o = parcelRequire("5po7o");

var $IhlL5 = parcelRequire("IhlL5");

var $iCjex = parcelRequire("iCjex");
// Connection-related constants
const $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $ae049384a7d1c7c8$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK = 10000;
const $ae049384a7d1c7c8$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class $ae049384a7d1c7c8$export$2e2bcd8739ae039 {
    get endPoint() {
        return this.socketAdapter.endPoint;
    }
    get timeout() {
        return this.socketAdapter.timeout;
    }
    get transport() {
        return this.socketAdapter.transport;
    }
    get heartbeatCallback() {
        return this.socketAdapter.heartbeatCallback;
    }
    get heartbeatIntervalMs() {
        return this.socketAdapter.heartbeatIntervalMs;
    }
    get heartbeatTimer() {
        if (this.worker) return this._workerHeartbeatTimer;
        return this.socketAdapter.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        if (this.worker) return this._pendingWorkerHeartbeatRef;
        return this.socketAdapter.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socketAdapter.reconnectTimer;
    }
    get vsn() {
        return this.socketAdapter.vsn;
    }
    get encode() {
        return this.socketAdapter.encode;
    }
    get decode() {
        return this.socketAdapter.decode;
    }
    get reconnectAfterMs() {
        return this.socketAdapter.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socketAdapter.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socketAdapter.stateChangeCallbacks;
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
     *
     * @category Realtime
     *
     * @example Example for a public channel
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'public-anon-key' },
     * })
     * client.connect()
     * ```
     */ constructor(endPoint, options){
        var _a;
        this.channels = new Array();
        this.accessTokenValue = null;
        this.accessToken = null;
        this.apiKey = null;
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.ref = 0;
        this.serializer = new (0, $8VIf2.default)();
        this._manuallySetToken = false;
        this._authPromise = null;
        this._workerHeartbeatTimer = undefined;
        this._pendingWorkerHeartbeatRef = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args)=>customFetch(...args);
            return (...args)=>fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        const socketAdapterOptions = this._initializeOptions(options);
        this.socketAdapter = new (0, $iCjex.default)(endPoint, socketAdapterOptions);
        this.httpEndpoint = (0, $5po7o.httpEndpointURL)(endPoint);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     *
     * @category Realtime
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.isConnected()) return;
        // Trigger auth if needed and not already in progress
        // This ensures auth is called for standalone RealtimeClient usage
        // while avoiding race conditions with SupabaseClient's immediate setAuth call
        if (this.accessToken && !this._authPromise) this._setAuthSafely('connect');
        this._setupConnectionHandlers();
        try {
            this.socketAdapter.connect();
        } catch (error) {
            const errorMessage = error.message;
            // Provide helpful error message based on environment
            if (errorMessage.includes('Node.js')) throw new Error(`${errorMessage}\n\n` + 'To use Realtime in Node.js, you need to provide a WebSocket implementation:\n\n' + 'Option 1: Use Node.js 22+ which has native WebSocket support\n' + 'Option 2: Install and provide the "ws" package:\n\n' + '  npm install ws\n\n' + '  import ws from "ws"\n' + '  const client = new RealtimeClient(url, {\n' + '    ...options,\n' + '    transport: ws\n' + '  })');
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._handleNodeJsRaceCondition();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     *
     * @category Realtime
     */ endpointURL() {
        return this.socketAdapter.endPointURL();
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     *
     * @category Realtime
     */ async disconnect(code, reason) {
        if (this.isDisconnecting()) return 'ok';
        return await this.socketAdapter.disconnect(()=>{
            clearInterval(this._workerHeartbeatTimer);
            this._terminateWorker();
        }, code, reason);
    }
    /**
     * Returns all created channels
     *
     * @category Realtime
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes, removes and tears down a single channel
     * @param channel A RealtimeChannel instance
     *
     * @category Realtime
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (status === 'ok') channel.teardown();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes, removes and tears down all channels
     *
     * @category Realtime
     */ async removeAllChannels() {
        const promises = this.channels.map(async (channel)=>{
            const result = await channel.unsubscribe();
            channel.teardown();
            return result;
        });
        const result = await Promise.all(promises);
        this.disconnect();
        return result;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden in Client constructor.
     *
     * @category Realtime
     */ log(kind, msg, data) {
        this.socketAdapter.log(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     *
     * @category Realtime
     */ connectionState() {
        return this.socketAdapter.connectionState() || (0, $5gqEk.CONNECTION_STATE).closed;
    }
    /**
     * Returns `true` is the connection is open.
     *
     * @category Realtime
     */ isConnected() {
        return this.socketAdapter.isConnected();
    }
    /**
     * Returns `true` if the connection is currently connecting.
     *
     * @category Realtime
     */ isConnecting() {
        return this.socketAdapter.isConnecting();
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     *
     * @category Realtime
     */ isDisconnecting() {
        return this.socketAdapter.isDisconnecting();
    }
    /**
     * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
     *
     * Topics are automatically prefixed with `realtime:` to match the Realtime service.
     * If a channel with the same topic already exists it will be returned instead of creating
     * a duplicate connection.
     *
     * @category Realtime
     */ channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $IhlL5.default)(`realtime:${topic}`, params, this);
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     *
     * @category Realtime
     */ push(data) {
        this.socketAdapter.push(data);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * When a token is explicitly provided, it will be preserved across channel operations
     * (including removeChannel and resubscribe). The `accessToken` callback will not be
     * invoked until `setAuth()` is called without arguments.
     *
     * @param token A JWT string to override the token set on the client.
     *
     * @example Setting the authorization header
     * // Use a manual token (preserved across resubscribes, ignores accessToken callback)
     * client.realtime.setAuth('my-custom-jwt')
     *
     * // Switch back to using the accessToken callback
     * client.realtime.setAuth()
     *
     * @category Realtime
     */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
     * Returns true if the current access token was explicitly set via setAuth(token),
     * false if it was obtained via the accessToken callback.
     * @internal
     */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     *
     * @category Realtime
     */ async sendHeartbeat() {
        this.socketAdapter.sendHeartbeat();
    }
    /**
     * Sets a callback that receives lifecycle events for internal heartbeat messages.
     * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
     *
     * @category Realtime
     */ onHeartbeat(callback) {
        this.socketAdapter.heartbeatCallback = this._wrapHeartbeatCallback(callback);
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        return this.socketAdapter.makeRef();
    }
    /**
     * Removes a channel from RealtimeClient
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token = null) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            // Track if this is a manually-provided token
            isManualToken = true;
        } else if (this.accessToken) // Call the accessToken callback to get fresh token
        try {
            tokenToSend = await this.accessToken();
        } catch (e) {
            this.log('error', 'Error fetching access token from callback', e);
            // Fall back to cached value if callback fails
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        // Track whether this token was manually set or fetched via callback
        if (isManualToken) this._manuallySetToken = true;
        else if (this.accessToken) // If we used the callback, clear the manual flag
        this._manuallySetToken = false;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $5gqEk.DEFAULT_VERSION)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel.channelAdapter.isJoined()) channel.channelAdapter.push((0, $5gqEk.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        // Only refresh auth if using callback-based tokens
        if (!this._isManualToken()) this.setAuth().catch((e)=>{
            this.log('error', `Error setting auth in ${context}`, e);
        });
    }
    /** @internal */ _setupConnectionHandlers() {
        this.socketAdapter.onOpen(()=>{
            const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
            authPromise.catch((e)=>{
                this.log('error', 'error waiting for auth on connect', e);
            });
            if (this.worker && !this.workerRef) this._startWorkerHeartbeat();
        });
        this.socketAdapter.onClose(()=>{
            if (this.worker && this.workerRef) this._terminateWorker();
        });
        this.socketAdapter.onMessage((message)=>{
            if (message.ref && message.ref === this._pendingWorkerHeartbeatRef) this._pendingWorkerHeartbeatRef = null;
        });
    }
    /** @internal */ _handleNodeJsRaceCondition() {
        if (this.socketAdapter.isConnected()) // hack: ensure onConnOpen is called
        this.socketAdapter.getSocket().onConnOpen();
    }
    /** @internal */ _wrapHeartbeatCallback(heartbeatCallback) {
        return (status, latency)=>{
            if (status == 'sent') this._setAuthSafely();
            if (heartbeatCallback) heartbeatCallback(status, latency);
        };
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this._terminateWorker();
            this.disconnect();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /**
     * Terminate the Web Worker and clear the reference
     * @internal
     */ _terminateWorker() {
        if (this.workerRef) {
            this.log('worker', 'terminating worker');
            this.workerRef.terminate();
            this.workerRef = undefined;
        }
    }
    /** @internal */ _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $ae049384a7d1c7c8$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Initialize socket options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.worker = (_a = options === null || options === void 0 ? void 0 : options.worker) !== null && _a !== void 0 ? _a : false;
        this.accessToken = (_b = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _b !== void 0 ? _b : null;
        const result = {};
        result.timeout = (_c = options === null || options === void 0 ? void 0 : options.timeout) !== null && _c !== void 0 ? _c : (0, $5gqEk.DEFAULT_TIMEOUT);
        result.heartbeatIntervalMs = (_d = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _d !== void 0 ? _d : $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        // @ts-ignore - mismatch between phoenix and supabase
        result.transport = (_e = options === null || options === void 0 ? void 0 : options.transport) !== null && _e !== void 0 ? _e : (0, $hnThW.default).getWebSocketConstructor();
        result.params = options === null || options === void 0 ? void 0 : options.params;
        result.logger = options === null || options === void 0 ? void 0 : options.logger;
        result.heartbeatCallback = this._wrapHeartbeatCallback(options === null || options === void 0 ? void 0 : options.heartbeatCallback);
        result.reconnectAfterMs = (_f = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _f !== void 0 ? _f : (tries)=>{
            return $ae049384a7d1c7c8$var$RECONNECT_INTERVALS[tries - 1] || $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK;
        };
        let defaultEncode;
        let defaultDecode;
        const vsn = (_g = options === null || options === void 0 ? void 0 : options.vsn) !== null && _g !== void 0 ? _g : (0, $5gqEk.DEFAULT_VSN);
        switch(vsn){
            case 0, $5gqEk.VSN_1_0_0:
                defaultEncode = (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                defaultDecode = (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case 0, $5gqEk.VSN_2_0_0:
                defaultEncode = this.serializer.encode.bind(this.serializer);
                defaultDecode = this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${result.vsn}`);
        }
        result.vsn = vsn;
        result.encode = (_h = options === null || options === void 0 ? void 0 : options.encode) !== null && _h !== void 0 ? _h : defaultEncode;
        result.decode = (_j = options === null || options === void 0 ? void 0 : options.decode) !== null && _j !== void 0 ? _j : defaultDecode;
        result.beforeReconnect = this._reconnectAuth.bind(this);
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            result.params = Object.assign(Object.assign({}, result.params), {
                log_level: this.logLevel
            });
        }
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
            result.autoSendHeartbeat = !this.worker;
        }
        return result;
    }
    /** @internal */ async _reconnectAuth() {
        await this._waitForAuthIfNeeded();
        if (!this.isConnected()) this.connect();
    }
}

});
parcelRegister("hnThW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7f78c8d4f60723$export$2e2bcd8739ae039);
/**
 * Utilities for creating WebSocket instances across runtimes.
 */ class $ca7f78c8d4f60723$export$67be75336dea7fb5 {
    /**
     * Static-only utility – prevent instantiation.
     */ constructor(){}
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            constructor: WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: globalThis.WebSocket
        };
        if (typeof $parcel$global !== 'undefined' && typeof $parcel$global.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: $parcel$global.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && globalThis.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        // Use dynamic property access to avoid Next.js Edge Runtime static analysis warnings
        const _process = globalThis['process'];
        if (_process) {
            const processVersions = _process['versions'];
            if (processVersions && processVersions['node']) {
                // Remove 'v' prefix if present and parse the major version
                const versionString = processVersions['node'];
                const nodeVersion = parseInt(versionString.replace(/^v/, '').split('.')[0]);
                // Node.js 22+ should have native WebSocket
                if (nodeVersion >= 22) {
                    // Check if native WebSocket is available (should be in Node.js 22+)
                    if (typeof globalThis.WebSocket !== 'undefined') return {
                        type: 'native',
                        constructor: globalThis.WebSocket
                    };
                    // If not available, user needs to provide it
                    return {
                        type: 'unsupported',
                        error: `Node.js ${nodeVersion} detected but native WebSocket not found.`,
                        workaround: 'Provide a WebSocket implementation via the transport option.'
                    };
                }
                // Node.js < 22 doesn't have native WebSocket
                return {
                    type: 'unsupported',
                    error: `Node.js ${nodeVersion} detected without native WebSocket support.`,
                    workaround: 'For Node.js < 22, install "ws" package and provide it via the transport option:\nimport ws from "ws"\nnew RealtimeClient(url, { transport: ws })'
                };
            }
        }
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
     * Returns the best available WebSocket constructor for the current runtime.
     *
     * @category Realtime
     *
     * @example Example with error handling
     * ```ts
     * try {
     *   const WS = WebSocketFactory.getWebSocketConstructor()
     *   const socket = new WS('wss://example.com/socket')
     * } catch (error) {
     *   console.error('WebSocket not available in this environment.', error)
     * }
     * ```
     */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.constructor) return env.constructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
     * Detects whether the runtime can establish WebSocket connections.
     *
     * @category Realtime
     *
     * @example Example in a Node.js script
     * ```ts
     * if (!WebSocketFactory.isWebSocketSupported()) {
     *   console.error('WebSockets are required for this script.')
     *   process.exitCode = 1
     * }
     * ```
     */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native' || env.type === 'ws';
        } catch (_a) {
            return false;
        }
    }
}
var $ca7f78c8d4f60723$export$2e2bcd8739ae039 = $ca7f78c8d4f60723$export$67be75336dea7fb5;

});

parcelRegister("5gqEk", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VERSION", () => $3d531e63e1ea7f53$export$363ebe89e6e7aeef);
$parcel$export(module.exports, "VSN_1_0_0", () => $3d531e63e1ea7f53$export$b8f6d7e635d6c56b);
$parcel$export(module.exports, "VSN_2_0_0", () => $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a);
$parcel$export(module.exports, "DEFAULT_VSN", () => $3d531e63e1ea7f53$export$90c89f9664aa9117);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $3d531e63e1ea7f53$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "MAX_PUSH_BUFFER_SIZE", () => $3d531e63e1ea7f53$export$f227fe8351a81f4a);
$parcel$export(module.exports, "CHANNEL_STATES", () => $3d531e63e1ea7f53$export$b83816118db74fe7);
$parcel$export(module.exports, "CHANNEL_EVENTS", () => $3d531e63e1ea7f53$export$8db7548e65d6ea55);
$parcel$export(module.exports, "CONNECTION_STATE", () => $3d531e63e1ea7f53$export$deda39003d27273);

var $6BQLu = parcelRequire("6BQLu");
const $3d531e63e1ea7f53$export$363ebe89e6e7aeef = `realtime-js/${(0, $6BQLu.version)}`;
const $3d531e63e1ea7f53$export$b8f6d7e635d6c56b = '1.0.0';
const $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a = '2.0.0';
const $3d531e63e1ea7f53$export$90c89f9664aa9117 = $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a;
const $3d531e63e1ea7f53$export$a4ad2735b021c132 = (0, $6BQLu.version);
const $3d531e63e1ea7f53$export$7bd623b29ec8e1eb = 10000;
const $3d531e63e1ea7f53$export$5e80cf62e56a877b = 1000;
const $3d531e63e1ea7f53$export$f227fe8351a81f4a = 100;
const $3d531e63e1ea7f53$export$a6d0320a1563d49e = {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
const $3d531e63e1ea7f53$export$b83816118db74fe7 = {
    closed: 'closed',
    errored: 'errored',
    joined: 'joined',
    joining: 'joining',
    leaving: 'leaving'
};
const $3d531e63e1ea7f53$export$8db7548e65d6ea55 = {
    close: 'phx_close',
    error: 'phx_error',
    join: 'phx_join',
    reply: 'phx_reply',
    leave: 'phx_leave',
    access_token: 'access_token'
};
const $3d531e63e1ea7f53$export$b2688bfb999f5751 = {
    websocket: 'websocket'
};
const $3d531e63e1ea7f53$export$deda39003d27273 = {
    connecting: 'connecting',
    open: 'open',
    closing: 'closing',
    closed: 'closed'
};

});
parcelRegister("6BQLu", function(module, exports) {

$parcel$export(module.exports, "version", () => $4cff20d240de2de4$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $4cff20d240de2de4$export$83d89fbfd8236492 = '2.100.1';

});


parcelRegister("8VIf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6805f7080ae1d67f$export$2e2bcd8739ae039);
class $6805f7080ae1d67f$export$2e2bcd8739ae039 {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = 'broadcast';
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === 'string') return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a;
        if (this._isArrayBuffer((_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a, _b;
        const topic = message.topic;
        const ref = (_a = message.ref) !== null && _a !== void 0 ? _a : '';
        const joinRef = (_b = message.join_ref) !== null && _b !== void 0 ? _b : '';
        const userEvent = message.payload.event;
        // Filter metadata based on allowed keys
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = Object.keys(rest).length === 0 ? '' : JSON.stringify(rest);
        // Validate lengths don't exceed uint8 max value (255)
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref.length > 255) throw new Error(`ref length ${ref.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.userBroadcastPush); // kind
        view.setUint8(offset++, joinRef.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, userEvent.length);
        view.setUint8(offset++, metadata.length);
        view.setUint8(offset++, encodingType);
        Array.from(joinRef, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(userEvent, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(metadata, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === 'string') {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset, offset + userEventSize));
        offset = offset + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset, offset + metadataSize));
        offset = offset + metadataSize;
        const payload = buffer.slice(offset, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        // Metadata is optional and always JSON encoded
        if (metadataSize > 0) data['meta'] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data
        };
    }
    _isArrayBuffer(buffer) {
        var _a;
        return buffer instanceof ArrayBuffer || ((_a = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'ArrayBuffer';
    }
    _pick(obj, keys) {
        if (!obj || typeof obj !== 'object') return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
    }
}

});

parcelRegister("5po7o", function(module, exports) {

$parcel$export(module.exports, "convertChangeData", () => $3f01feefa94fd48b$export$20ce708a1f594c5e);
$parcel$export(module.exports, "httpEndpointURL", () => $3f01feefa94fd48b$export$976fda7151b30cae);
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $3f01feefa94fd48b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($3f01feefa94fd48b$export$4d213a7d364021dc || ($3f01feefa94fd48b$export$4d213a7d364021dc = {}));
const $3f01feefa94fd48b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $3f01feefa94fd48b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $3f01feefa94fd48b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $3f01feefa94fd48b$export$3df02a362b86a91(colType, value);
    return $3f01feefa94fd48b$var$noop(value);
};
const $3f01feefa94fd48b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $3f01feefa94fd48b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $3f01feefa94fd48b$export$4d213a7d364021dc.bool:
            return $3f01feefa94fd48b$export$3c2e6d1b7583eee6(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int2:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.numeric:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.oid:
            return $3f01feefa94fd48b$export$a0a81dc3380ce7d3(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.json:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.jsonb:
            return $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamp:
            return $3f01feefa94fd48b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $3f01feefa94fd48b$export$4d213a7d364021dc.abstime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.date:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.daterange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.money:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.reltime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.text:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.time:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamptz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timetz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tsrange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tstzrange:
            return $3f01feefa94fd48b$var$noop(value);
        default:
            // Return the value for remaining types
            return $3f01feefa94fd48b$var$noop(value);
    }
};
const $3f01feefa94fd48b$var$noop = (value)=>{
    return value;
};
const $3f01feefa94fd48b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $3f01feefa94fd48b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
    return value;
};
const $3f01feefa94fd48b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$3f01feefa94fd48b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $3f01feefa94fd48b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $3f01feefa94fd48b$export$976fda7151b30cae = (socketUrl)=>{
    const wsUrl = new URL(socketUrl);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, 'http');
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, '') // remove all trailing slashes
    .replace(/\/socket\/websocket$/i, '') // remove the socket/websocket path
    .replace(/\/socket$/i, '') // remove the socket path
    .replace(/\/websocket$/i, ''); // remove the websocket path
    if (wsUrl.pathname === '' || wsUrl.pathname === '/') wsUrl.pathname = '/api/broadcast';
    else wsUrl.pathname = wsUrl.pathname + '/api/broadcast';
    return wsUrl.href;
};

});

parcelRegister("IhlL5", function(module, exports) {

$parcel$export(module.exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", () => $0851918337283a61$export$bc171c571098b6c4);
$parcel$export(module.exports, "REALTIME_LISTEN_TYPES", () => $0851918337283a61$export$9e3fe8e487ef792e);
$parcel$export(module.exports, "REALTIME_SUBSCRIBE_STATES", () => $0851918337283a61$export$a6885b926af646a2);
$parcel$export(module.exports, "REALTIME_CHANNEL_STATES", () => $0851918337283a61$export$154db638d9c0559e);
$parcel$export(module.exports, "default", () => $0851918337283a61$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");

var $6zp63 = parcelRequire("6zp63");

var $5po7o = parcelRequire("5po7o");

var $7bMKy = parcelRequire("7bMKy");
var $0851918337283a61$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0851918337283a61$export$bc171c571098b6c4 || ($0851918337283a61$export$bc171c571098b6c4 = {}));
var $0851918337283a61$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($0851918337283a61$export$9e3fe8e487ef792e || ($0851918337283a61$export$9e3fe8e487ef792e = {}));
var $0851918337283a61$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0851918337283a61$export$a6885b926af646a2 || ($0851918337283a61$export$a6885b926af646a2 = {}));
const $0851918337283a61$export$154db638d9c0559e = (0, $5gqEk.CHANNEL_STATES);
class $0851918337283a61$export$2e2bcd8739ae039 {
    get state() {
        return this.channelAdapter.state;
    }
    set state(state) {
        this.channelAdapter.state = state;
    }
    get joinedOnce() {
        return this.channelAdapter.joinedOnce;
    }
    get timeout() {
        return this.socket.timeout;
    }
    get joinPush() {
        return this.channelAdapter.joinPush;
    }
    get rejoinTimer() {
        return this.channelAdapter.rejoinTimer;
    }
    /**
     * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
     *
     * The topic determines which realtime stream you are subscribing to. Config options let you
     * enable acknowledgement for broadcasts, presence tracking, or private channels.
     *
     * @category Realtime
     *
     * @example Example for a public channel
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'public-anon-key' },
     * })
     * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
     * ```
     */ constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        var _a, _b;
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.channelAdapter = new (0, $7bMKy.default)(this.socket.socketAdapter, topic, this.params);
        this.presence = new (0, $6zp63.default)(this);
        this._onClose(()=>{
            this.socket._remove(this);
        });
        this._updateFilterTransform();
        this.broadcastEndpointURL = (0, $5po7o.httpEndpointURL)(this.socket.socketAdapter.endPointURL());
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a = this.params.config) === null || _a === void 0 ? void 0 : _a.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw `tried to use replay on public channel '${this.topic}'. It must be a private channel.`;
    }
    /**
     * Subscribe registers your client with the server
     * @category Realtime
     */ subscribe(callback, timeout = this.timeout) {
        var _a, _b, _c;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.channelAdapter.isClosed()) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((reason)=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, reason);
            });
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this._updateFilterMessage();
            this.channelAdapter.subscribe(timeout).receive('ok', async ({ postgres_changes: postgres_changes })=>{
                // Only refresh auth if using callback-based tokens
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
                this._updatePostgresBindings(postgres_changes, callback);
            }).receive('error', (error)=>{
                this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.TIMED_OUT);
            });
        }
        return this;
    }
    _updatePostgresBindings(postgres_changes, callback) {
        var _a;
        const clientPostgresBindings = this.bindings.postgres_changes;
        const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
        const newPostgresBindings = [];
        for(let i = 0; i < bindingsLen; i++){
            const clientPostgresBinding = clientPostgresBindings[i];
            const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
            const serverPostgresFilter = postgres_changes && postgres_changes[i];
            if (serverPostgresFilter && serverPostgresFilter.event === event && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.schema, schema) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.table, table) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                id: serverPostgresFilter.id
            }));
            else {
                this.unsubscribe();
                this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                return;
            }
        }
        this.bindings.postgres_changes = newPostgresBindings;
        if (this.state != (0, $5gqEk.CHANNEL_STATES).errored && callback) callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
    }
    /**
     * Returns the current presence state for this channel.
     *
     * The shape is a map keyed by presence key (for example a user id) where each entry contains the
     * tracked metadata for that user.
     *
     * @category Realtime
     */ presenceState() {
        return this.presence.state;
    }
    /**
     * Sends the supplied payload to the presence tracker so other subscribers can see that this
     * client is online. Use `untrack` to stop broadcasting presence for the same key.
     *
     * @category Realtime
     */ async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    /**
     * Removes the current presence state for this client.
     *
     * @category Realtime
     */ async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    /**
     * Listen to realtime events on this channel.
     * @category Realtime
     *
     * @remarks
     * - By default, Broadcast and Presence are enabled for all projects.
     * - By default, listening to database changes is disabled for new projects due to database performance and security concerns. You can turn it on by managing Realtime's [replication](/docs/guides/api#realtime-api-overview).
     * - You can receive the "previous" data for updates and deletes by setting the table's `REPLICA IDENTITY` to `FULL` (e.g., `ALTER TABLE your_table REPLICA IDENTITY FULL;`).
     * - Row level security is not applied to delete statements. When RLS is enabled and replica identity is set to full, only the primary key is sent to clients.
     *
     * @example Listen to broadcast messages
     * ```js
     * const channel = supabase.channel("room1")
     *
     * channel.on("broadcast", { event: "cursor-pos" }, (payload) => {
     *   console.log("Cursor position received!", payload);
     * }).subscribe((status) => {
     *   if (status === "SUBSCRIBED") {
     *     channel.send({
     *       type: "broadcast",
     *       event: "cursor-pos",
     *       payload: { x: Math.random(), y: Math.random() },
     *     });
     *   }
     * });
     * ```
     *
     * @example Listen to presence sync
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'sync' }, () => {
     *     console.log('Synced presence state: ', channel.presenceState())
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence join
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'join' }, ({ newPresences }) => {
     *     console.log('Newly joined presences: ', newPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence leave
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'leave' }, ({ leftPresences }) => {
     *     console.log('Newly left presences: ', leftPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *       await channel.untrack()
     *     }
     *   })
     * ```
     *
     * @example Listen to all database changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: '*' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to a specific table
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to inserts
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to updates
     * By default, Supabase will send only the updated record. If you want to receive the previous values as well you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to updates
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to deletes
     * By default, Supabase does not send deleted records. If you want to receive the deleted record you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to deletes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to multiple events
     * You can chain listeners if you want to listen to multiple events for each table.
     *
     * @example Listen to multiple events
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, handleRecordInserted)
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, handleRecordDeleted)
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to row level changes
     * You can listen to individual rows using the format `{table}:{col}=eq.{val}` - where `{col}` is the column name, and `{val}` is the value which you want to match.
     *
     * @example Listen to row level changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries', filter: 'id=eq.200' }, handleRecordUpdated)
     *   .subscribe()
     * ```
     */ on(type, filter, callback) {
        if (this.channelAdapter.isJoined() && type === $0851918337283a61$export$9e3fe8e487ef792e.PRESENCE) {
            this.socket.log('channel', `cannot add presence callbacks for ${this.topic} after joining.`);
            throw new Error('cannot add presence callbacks after joining a channel');
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a broadcast message explicitly via REST API.
     *
     * This method always uses the REST API endpoint regardless of WebSocket connection state.
     * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
     *
     * @param event The name of the broadcast event
     * @param payload Payload to be sent (required)
     * @param opts Options including timeout
     * @returns Promise resolving to object with success status, and error details if failed
     *
     * @category Realtime
     */ async httpSend(event, payload, opts = {}) {
        var _a;
        if (payload === undefined || payload === null) return Promise.reject('Payload is required for httpSend()');
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : '',
            'Content-Type': 'application/json'
        };
        if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                messages: [
                    {
                        topic: this.subTopic,
                        event: event,
                        payload: payload,
                        private: this.private
                    }
                ]
            })
        };
        const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     *
     * @category Realtime
     *
     * @remarks
     * - When using REST you don't need to subscribe to the channel
     * - REST calls are only available from 2.37.0 onwards
     *
     * @example Send a message via websocket
     * ```js
     * const channel = supabase.channel('room1')
     *
     * channel.subscribe((status) => {
     *   if (status === 'SUBSCRIBED') {
     *     channel.send({
     *       type: 'broadcast',
     *       event: 'cursor-pos',
     *       payload: { x: Math.random(), y: Math.random() },
     *     })
     *   }
     * })
     * ```
     *
     * @exampleResponse Send a message via websocket
     * ```js
     * ok | timed out | error
     * ```
     *
     * @example Send a message via REST
     * ```js
     * supabase
     *   .channel('room1')
     *   .httpSend('cursor-pos', { x: Math.random(), y: Math.random() })
     * ```
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this.channelAdapter.canPush() && args.type === 'broadcast') {
            console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
            const { event: event, payload: endpoint_payload } = args;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : '',
                'Content-Type': 'application/json'
            };
            if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this.channelAdapter.push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    /**
     * Updates the payload that will be sent the next time the channel joins (reconnects).
     * Useful for rotating access tokens or updating config without re-creating the channel.
     *
     * @category Realtime
     */ updateJoinPayload(payload) {
        this.channelAdapter.updateJoinPayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     *
     * @category Realtime
     */ async unsubscribe(timeout = this.timeout) {
        return new Promise((resolve)=>{
            this.channelAdapter.unsubscribe(timeout).receive('ok', ()=>resolve('ok')).receive('timeout', ()=>resolve('timed out')).receive('error', ()=>resolve('error'));
        });
    }
    /**
     * Destroys and stops related timers.
     *
     * @category Realtime
     */ teardown() {
        this.channelAdapter.teardown();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const ref = this.channelAdapter.on(type, callback);
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback,
            ref: ref
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        this._updateFilterMessage();
        return this;
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this.channelAdapter.onClose(callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this.channelAdapter.onError(callback);
    }
    /** @internal */ _updateFilterMessage() {
        this.channelAdapter.updateFilterBindings((binding, payload, ref)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const typeLower = binding.event.toLocaleLowerCase();
            if (this._notThisChannelEvent(typeLower, ref)) return false;
            const bind = (_a = this.bindings[typeLower]) === null || _a === void 0 ? void 0 : _a.find((bind)=>bind.ref === binding.ref);
            if (!bind) return true;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event;
                    return bindId && ((_c = payload.ids) === null || _c === void 0 ? void 0 : _c.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_f = (_e = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_g = payload === null || payload === void 0 ? void 0 : payload.event) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        });
    }
    /** @internal */ _notThisChannelEvent(event, ref) {
        const { close: close, error: error, leave: leave, join: join } = (0, $5gqEk.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        return ref && events.includes(event) && ref !== this.joinPush.ref;
    }
    /** @internal */ _updateFilterTransform() {
        this.channelAdapter.updatePayloadTransform((event, payload, ref)=>{
            if (typeof payload === 'object' && 'ids' in payload) {
                const postgresChanges = payload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                return Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            return payload;
        });
    }
    /**
     * Compares two optional filter values for equality.
     * Treats undefined, null, and empty string as equivalent empty values.
     * @internal
     */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : undefined;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : undefined;
        return normalizedServer === normalizedClient;
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $5po7o.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $5po7o.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}

});
parcelRegister("6zp63", function(module, exports) {

$parcel$export(module.exports, "REALTIME_PRESENCE_LISTEN_EVENTS", () => $4c897aa496ab948f$export$f1ce049df2794fb4);
$parcel$export(module.exports, "default", () => $4c897aa496ab948f$export$2e2bcd8739ae039);
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ 
var $4YKUg = parcelRequire("4YKUg");
var $4c897aa496ab948f$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($4c897aa496ab948f$export$f1ce049df2794fb4 || ($4c897aa496ab948f$export$f1ce049df2794fb4 = {}));
class $4c897aa496ab948f$export$2e2bcd8739ae039 {
    get state() {
        return this.presenceAdapter.state;
    }
    /**
     * Creates a Presence helper that keeps the local presence state in sync with the server.
     *
     * @param channel - The realtime channel to bind to.
     * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
     *
     * @category Realtime
     *
     * @example Example for a presence channel
     * ```ts
     * const presence = new RealtimePresence(channel)
     *
     * channel.on('presence', ({ event, key }) => {
     *   console.log(`Presence ${event} on ${key}`)
     * })
     * ```
     */ constructor(channel, opts){
        this.channel = channel;
        this.presenceAdapter = new (0, $4YKUg.default)(this.channel.channelAdapter, opts);
    }
}

});
parcelRegister("4YKUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0126ade0ecba43$export$2e2bcd8739ae039);

var $gS6ap = parcelRequire("gS6ap");
class $3a0126ade0ecba43$export$2e2bcd8739ae039 {
    constructor(channel, opts){
        const phoenixOptions = $3a0126ade0ecba43$var$phoenixPresenceOptions(opts);
        this.presence = new (0, $gS6ap.Presence)(channel.getChannel(), phoenixOptions);
        this.presence.onJoin((key, currentPresence, newPresence)=>{
            const onJoinPayload = $3a0126ade0ecba43$export$2e2bcd8739ae039.onJoinPayload(key, currentPresence, newPresence);
            channel.getChannel().trigger('presence', onJoinPayload);
        });
        this.presence.onLeave((key, currentPresence, leftPresence)=>{
            const onLeavePayload = $3a0126ade0ecba43$export$2e2bcd8739ae039.onLeavePayload(key, currentPresence, leftPresence);
            channel.getChannel().trigger('presence', onLeavePayload);
        });
        this.presence.onSync(()=>{
            channel.getChannel().trigger('presence', {
                event: 'sync'
            });
        });
    }
    get state() {
        return $3a0126ade0ecba43$export$2e2bcd8739ae039.transformState(this.presence.state);
    }
    /**
     * @private
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example Transform state
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     */ static transformState(state) {
        state = $3a0126ade0ecba43$var$cloneState(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            newState[key] = $3a0126ade0ecba43$var$transformState(presences);
            return newState;
        }, {});
    }
    static onJoinPayload(key, currentPresence, newPresence) {
        const currentPresences = $3a0126ade0ecba43$var$parseCurrentPresences(currentPresence);
        const newPresences = $3a0126ade0ecba43$var$transformState(newPresence);
        return {
            event: 'join',
            key: key,
            currentPresences: currentPresences,
            newPresences: newPresences
        };
    }
    static onLeavePayload(key, currentPresence, leftPresence) {
        const currentPresences = $3a0126ade0ecba43$var$parseCurrentPresences(currentPresence);
        const leftPresences = $3a0126ade0ecba43$var$transformState(leftPresence);
        return {
            event: 'leave',
            key: key,
            currentPresences: currentPresences,
            leftPresences: leftPresences
        };
    }
}
function $3a0126ade0ecba43$var$transformState(presences) {
    return presences.metas.map((presence)=>{
        presence['presence_ref'] = presence['phx_ref'];
        delete presence['phx_ref'];
        delete presence['phx_ref_prev'];
        return presence;
    });
}
function $3a0126ade0ecba43$var$cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
function $3a0126ade0ecba43$var$phoenixPresenceOptions(opts) {
    return (opts === null || opts === void 0 ? void 0 : opts.events) && {
        events: opts.events
    };
}
function $3a0126ade0ecba43$var$parseCurrentPresences(currentPresences) {
    return (currentPresences === null || currentPresences === void 0 ? void 0 : currentPresences.metas) ? $3a0126ade0ecba43$var$transformState(currentPresences) : [];
}

});
parcelRegister("gS6ap", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $af64141737efe14a$export$99c2b779aa4e8b8b);
$parcel$export(module.exports, "Socket", () => $af64141737efe14a$export$4798917dbf149b79);
// js/phoenix/utils.js
var $af64141737efe14a$var$closure = (value)=>{
    if (typeof value === "function") return /** @type {() => T} */ value;
    else {
        let closure2 = function() {
            return value;
        };
        return closure2;
    }
};
// js/phoenix/constants.js
var $af64141737efe14a$var$globalSelf = typeof self !== "undefined" ? self : null;
var $af64141737efe14a$var$phxWindow = typeof window !== "undefined" ? window : null;
var $af64141737efe14a$var$global = $af64141737efe14a$var$globalSelf || $af64141737efe14a$var$phxWindow || globalThis;
var $af64141737efe14a$var$DEFAULT_VSN = "2.0.0";
var $af64141737efe14a$var$DEFAULT_TIMEOUT = 1e4;
var $af64141737efe14a$var$WS_CLOSE_NORMAL = 1e3;
var $af64141737efe14a$var$SOCKET_STATES = /** @type {const} */ {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $af64141737efe14a$var$CHANNEL_STATES = /** @type {const} */ {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $af64141737efe14a$var$CHANNEL_EVENTS = /** @type {const} */ {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $af64141737efe14a$var$TRANSPORTS = /** @type {const} */ {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $af64141737efe14a$var$XHR_STATES = /** @type {const} */ {
    complete: 4
};
var $af64141737efe14a$var$AUTH_TOKEN_PREFIX = "base64url.bearer.phx.";
// js/phoenix/push.js
var $af64141737efe14a$export$fb87db22c6b0e2ba = class {
    /**
   * Initializes the Push
   * @param {Channel} channel - The Channel
   * @param {ChannelEvent} event - The event, for example `"phx_join"`
   * @param {() => Record<string, unknown>} payload - The payload, for example `{user_id: 123}`
   * @param {number} timeout - The push timeout in milliseconds
   */ constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
        this.ref = void 0;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {string} status
   * @param {(response: any) => void} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    destroy() {
        this.cancelRefEvent();
        this.cancelTimeout();
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
// js/phoenix/timer.js
var $af64141737efe14a$export$c57e9b2d8b9e4de = class {
    /**
  * @param {() => void} callback
  * @param {(tries: number) => number} timerCalc
  */ constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = void 0;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
// js/phoenix/channel.js
var $af64141737efe14a$export$cfdacaa37f9b4dd7 = class {
    /**
   * @param {string} topic
   * @param {Params | (() => Params)} params
   * @param {Socket} socket
   */ constructor(topic, params, socket){
        this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
        this.topic = topic;
        this.params = $af64141737efe14a$var$closure(params || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $af64141737efe14a$export$c57e9b2d8b9e4de(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $af64141737efe14a$var$CHANNEL_STATES.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", (reason)=>{
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic}`);
            this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            let leavePush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.leave, $af64141737efe14a$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($af64141737efe14a$var$CHANNEL_EVENTS.reply, (payload, ref)=>{
            this.trigger(this.replyEventName(ref), payload);
        });
    }
    /**
   * Join the channel
   * @param {number} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Teardown the channel.
   *
   * Destroys and stops related timers.
   */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
        this.bindings = [];
    }
    /**
   * Hook into channel close
   * @param {ChannelBindingCallback} callback
   */ onClose(callback) {
        this.on($af64141737efe14a$var$CHANNEL_EVENTS.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {ChannelOnErrorCallback} callback
   * @return {number}
   */ onError(callback) {
        return this.on($af64141737efe14a$var$CHANNEL_EVENTS.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {ChannelBindingCallback} callback
   * @returns {number} ref
   */ on(event, callback) {
        let ref = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref,
            callback: callback
        });
        return ref;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {number} [ref]
   */ off(event, ref) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref === "undefined" || ref === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {number} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $af64141737efe14a$var$CHANNEL_STATES.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($af64141737efe14a$var$CHANNEL_EVENTS.close, "leave");
        };
        let leavePush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.leave, $af64141737efe14a$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @type{ChannelOnMessage}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * Overridable filter hook
   *
   * If this function returns `true`, `binding`'s callback will be called.
   *
   * @type{ChannelFilterBindings}
   */ filterBindings(_binding, _payload, _ref) {
        return true;
    }
    isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $af64141737efe14a$var$CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @param {string} event
   * @param {unknown} [payload]
   * @param {?string} [ref]
   * @param {?string} [joinRef]
   */ trigger(event, payload, ref, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event && this.filterBindings(bind, payload, ref));
        for(let i = 0; i < eventBindings.length; i++){
            let bind = eventBindings[i];
            bind.callback(handledPayload, ref, joinRef || this.joinRef());
        }
    }
    /**
  * @param {string} ref
  */ replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    isClosed() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.closed;
    }
    isErrored() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.errored;
    }
    isJoined() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.joined;
    }
    isJoining() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.joining;
    }
    isLeaving() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.leaving;
    }
};
// js/phoenix/ajax.js
var $af64141737efe14a$var$Ajax = class {
    static request(method, endPoint, headers, body, timeout, ontimeout, callback) {
        if ($af64141737efe14a$var$global.XDomainRequest) {
            let req = new $af64141737efe14a$var$global.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else if ($af64141737efe14a$var$global.XMLHttpRequest) {
            let req = new $af64141737efe14a$var$global.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback);
        } else if ($af64141737efe14a$var$global.fetch && $af64141737efe14a$var$global.AbortController) return this.fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback);
        else throw new Error("No suitable XMLHttpRequest implementation found");
    }
    static fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback) {
        let options = {
            method: method,
            headers: headers,
            body: body
        };
        let controller = null;
        if (timeout) {
            controller = new AbortController();
            const _timeoutId = setTimeout(()=>controller.abort(), timeout);
            options.signal = controller.signal;
        }
        $af64141737efe14a$var$global.fetch(endPoint, options).then((response)=>response.text()).then((data)=>this.parseJSON(data)).then((data)=>callback && callback(data)).catch((err)=>{
            if (err.name === "AbortError" && ontimeout) ontimeout();
            else callback && callback(null);
        });
        return controller;
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        for (let [key, value] of Object.entries(headers))req.setRequestHeader(key, value);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $af64141737efe14a$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch  {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        let prefix = url.match(/\?/) ? "&" : "?";
        return `${url}${prefix}${this.serialize(params)}`;
    }
};
// js/phoenix/longpoll.js
var $af64141737efe14a$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
var $af64141737efe14a$export$57a2cdf8ead4f893 = class {
    constructor(endPoint, protocols){
        if (protocols && protocols.length === 2 && protocols[1].startsWith($af64141737efe14a$var$AUTH_TOKEN_PREFIX)) this.authToken = atob(protocols[1].slice($af64141737efe14a$var$AUTH_TOKEN_PREFIX.length));
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.connecting;
        setTimeout(()=>this.poll(), 0);
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $af64141737efe14a$var$TRANSPORTS.websocket), "$1/" + $af64141737efe14a$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $af64141737efe14a$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $af64141737efe14a$var$SOCKET_STATES.open || this.readyState === $af64141737efe14a$var$SOCKET_STATES.connecting;
    }
    poll() {
        const headers = {
            "Accept": "application/json"
        };
        if (this.authToken) headers["X-Phoenix-AuthToken"] = this.authToken;
        this.ajax("GET", headers, null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                if (status === 410 && this.token !== null) {
                    this.onerror(410);
                    this.closeAndRetry(3410, "session_gone", false);
                    return;
                }
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $af64141737efe14a$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $af64141737efe14a$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages) {
        this.awaitingBatchAck = true;
        this.ajax("POST", {
            "Content-Type": "application/x-ndjson"
        }, messages.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            this.awaitingBatchAck = false;
            if (!resp || resp.status !== 200) {
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            }
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, headers, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $af64141737efe14a$var$Ajax.request(method, this.endpointURL(), headers, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
// js/phoenix/presence.js
var $af64141737efe14a$export$99c2b779aa4e8b8b = class _Presence {
    /**
   * Initializes the Presence
   * @param {Channel} channel - The Channel
   * @param {PresenceOptions} [opts] - The options, for example `{events: {state: "state", diff: "diff"}}`
   */ constructor(channel, opts = {}){
        let events = opts.events || /** @type {PresenceEvents} */ {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = {};
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = _Presence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    /**
   * @param {PresenceOnJoin} callback
   */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /**
   * @param {PresenceOnLeave} callback
   */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /**
   * @param {PresenceOnSync} callback
   */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {((key: string, obj: PresenceState) => T)} [by]
   *
   * @returns {T[]}
   */ list(by) {
        return _Presence.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @param {Record<string, PresenceState>} currentState
   * @param {Record<string, PresenceState>} newState
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.clone(currentState);
        let joins = {};
        let leaves = {};
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m)=>m.phx_ref);
                let curRefs = currentPresence.metas.map((m)=>m.phx_ref);
                let joinedMetas = newPresence.metas.filter((m)=>curRefs.indexOf(m.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m)=>newRefs.indexOf(m.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @param {Record<string, PresenceState>} state
   * @param {PresenceDiff} diff
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m)=>m.phx_ref);
                let curMetas = currentPresence.metas.filter((m)=>joinedRefs.indexOf(m.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m)=>m.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p)=>{
                return refsToRemove.indexOf(p.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {Record<string, PresenceState>} presences
   * @param {((key: string, obj: PresenceState) => T)} [chooser]
   *
   * @returns {T[]}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    /**
  * @template T
  * @param {Record<string, PresenceState>} obj
  * @param {(key: string, obj: PresenceState) => T} func
  */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
  * @template T
  * @param {T} obj
  * @returns {T}
  */ static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
// js/phoenix/serializer.js
var $af64141737efe14a$export$ef852775387a0be7 = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    /**
  * @template T
  * @param {Message<Record<string, any>>} msg
  * @param {(msg: ArrayBuffer | string) => T} callback
  * @returns {T}
  */ encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    /**
  * @template T
  * @param {ArrayBuffer | string} rawPayload
  * @param {(msg: Message<unknown>) => T} callback
  * @returns {T}
  */ decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    /** @private */ binaryEncode (message) {
        let { join_ref: join_ref, ref: ref, event: event, topic: topic, payload: payload } = message;
        let metaLength = this.META_LENGTH + join_ref.length + ref.length + topic.length + event.length;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.push);
        view.setUint8(offset++, join_ref.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, event.length);
        Array.from(join_ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(event, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    /**
  * @private
  */ binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    /** @private */ decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    },
    /** @private */ decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let ref = decoder.decode(buffer.slice(offset, offset + refSize));
        offset = offset + refSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        let payload = {
            status: event,
            response: data
        };
        return {
            join_ref: joinRef,
            ref: ref,
            topic: topic,
            event: $af64141737efe14a$var$CHANNEL_EVENTS.reply,
            payload: payload
        };
    },
    /** @private */ decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
};
// js/phoenix/socket.js
var $af64141737efe14a$export$4798917dbf149b79 = class {
    /** Initializes the Socket *
   *
   * For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
   *
   * @constructor
   * @param {string} endPoint - The string WebSocket endpoint, ie, `"ws://example.com/socket"`,
   *                                               `"wss://example.com"`
   *                                               `"/socket"` (inherited host & protocol)
   * @param {SocketOptions} [opts] - Optional configuration
   */ constructor(endPoint, opts = {}){
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.fallbackRef = null;
        this.timeout = opts.timeout || $af64141737efe14a$var$DEFAULT_TIMEOUT;
        this.transport = opts.transport || $af64141737efe14a$var$global.WebSocket || $af64141737efe14a$export$57a2cdf8ead4f893;
        this.conn = void 0;
        this.primaryPassedHealthCheck = false;
        this.longPollFallbackMs = opts.longPollFallbackMs;
        this.fallbackTimer = null;
        this.sessionStore = opts.sessionStorage || $af64141737efe14a$var$global && $af64141737efe14a$var$global.sessionStorage;
        this.establishedConnections = 0;
        this.defaultEncoder = $af64141737efe14a$export$ef852775387a0be7.encode.bind($af64141737efe14a$export$ef852775387a0be7);
        this.defaultDecoder = $af64141737efe14a$export$ef852775387a0be7.decode.bind($af64141737efe14a$export$ef852775387a0be7);
        this.closeWasClean = true;
        this.disconnecting = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        this.pageHidden = false;
        this.encode = void 0;
        this.decode = void 0;
        if (this.transport !== $af64141737efe14a$export$57a2cdf8ead4f893) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($af64141737efe14a$var$phxWindow && $af64141737efe14a$var$phxWindow.addEventListener) {
            $af64141737efe14a$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $af64141737efe14a$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
            $af64141737efe14a$var$phxWindow.addEventListener("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") this.pageHidden = true;
                else {
                    this.pageHidden = false;
                    if (!this.isConnected() && !this.closeWasClean) this.teardown(()=>this.connect());
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.autoSendHeartbeat = opts.autoSendHeartbeat ?? true;
        this.heartbeatCallback = opts.heartbeatCallback ?? (()=>{});
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        if (!this.logger && opts.debug) this.logger = (kind, msg, data)=>{
            console.log(`${kind}: ${msg}`, data);
        };
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $af64141737efe14a$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$af64141737efe14a$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $af64141737efe14a$var$DEFAULT_VSN;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.heartbeatSentAt = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $af64141737efe14a$export$c57e9b2d8b9e4de(()=>{
            if (this.pageHidden) {
                this.log("Not reconnecting as page is hidden!");
                this.teardown();
                return;
            }
            this.teardown(async ()=>{
                if (opts.beforeReconnect) await opts.beforeReconnect();
                this.connect();
            });
        }, this.reconnectAfterMs);
        this.authToken = opts.authToken;
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $af64141737efe14a$export$57a2cdf8ead4f893;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {SocketTransport} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {"wss" | "ws"}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $af64141737efe14a$var$Ajax.appendParams($af64141737efe14a$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {() => void} [callback] - Optional callback which is called after socket is disconnected.
   * @param {number} [code] - A status code for disconnection (Optional).
   * @param {string} [reason] - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.disconnecting = true;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        this.teardown(()=>{
            this.disconnecting = false;
            callback && callback();
        }, code, reason);
    }
    /**
   * @param {Params} [params] - [DEPRECATED] The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params) {
        if (params) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $af64141737efe14a$var$closure(params);
        }
        if (this.conn && !this.disconnecting) return;
        if (this.longPollFallbackMs && this.transport !== $af64141737efe14a$export$57a2cdf8ead4f893) this.connectWithFallback($af64141737efe14a$export$57a2cdf8ead4f893, this.longPollFallbackMs);
        else this.transportConnect();
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data) {
        this.logger && this.logger(kind, msg, data);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {SocketOnOpen} callback
   */ onOpen(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection close events
   * @param {SocketOnClose} callback
   * @returns {string}
   */ onClose(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {SocketOnError} callback
   * @returns {string}
   */ onError(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection message events
   * @param {SocketOnMessage} callback
   * @returns {string}
   */ onMessage(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   * @param {HeartbeatCallback} callback
   */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {(timeDelta: number) => void} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   *
   * @param {Function}
   */ transportName(transport) {
        switch(transport){
            case $af64141737efe14a$export$57a2cdf8ead4f893:
                return "LongPoll";
            default:
                return transport.name;
        }
    }
    /**
   * @private
   */ transportConnect() {
        this.connectClock++;
        this.closeWasClean = false;
        let protocols = void 0;
        if (this.authToken) protocols = [
            "phoenix",
            `${$af64141737efe14a$var$AUTH_TOKEN_PREFIX}${btoa(this.authToken).replace(/=/g, "")}`
        ];
        this.conn = new this.transport(this.endPointURL(), protocols);
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    getSession(key) {
        return this.sessionStore && this.sessionStore.getItem(key);
    }
    storeSession(key, val) {
        this.sessionStore && this.sessionStore.setItem(key, val);
    }
    connectWithFallback(fallbackTransport, fallbackThreshold = 2500) {
        clearTimeout(this.fallbackTimer);
        let established = false;
        let primaryTransport = true;
        let openRef, errorRef;
        let fallbackTransportName = this.transportName(fallbackTransport);
        let fallback = (reason)=>{
            this.log("transport", `falling back to ${fallbackTransportName}...`, reason);
            this.off([
                openRef,
                errorRef
            ]);
            primaryTransport = false;
            this.replaceTransport(fallbackTransport);
            this.transportConnect();
        };
        if (this.getSession(`phx:fallback:${fallbackTransportName}`)) return fallback("memorized");
        this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
        errorRef = this.onError((reason)=>{
            this.log("transport", "error", reason);
            if (primaryTransport && !established) {
                clearTimeout(this.fallbackTimer);
                fallback(reason);
            }
        });
        if (this.fallbackRef) this.off([
            this.fallbackRef
        ]);
        this.fallbackRef = this.onOpen(()=>{
            established = true;
            if (!primaryTransport) {
                let fallbackTransportName2 = this.transportName(fallbackTransport);
                if (!this.primaryPassedHealthCheck) this.storeSession(`phx:fallback:${fallbackTransportName2}`, "true");
                return this.log("transport", `established ${fallbackTransportName2} fallback`);
            }
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
            this.ping((rtt)=>{
                this.log("transport", "connected to primary after", rtt);
                this.primaryPassedHealthCheck = true;
                clearTimeout(this.fallbackTimer);
            });
        });
        this.transportConnect();
    }
    clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.disconnecting = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (this.autoSendHeartbeat) this.resetHeartbeat();
        this.triggerStateCallbacks("open");
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.heartbeatSentAt = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            try {
                this.heartbeatCallback("timeout");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            this.triggerChanError();
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $af64141737efe14a$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        const connToClose = this.conn;
        this.waitForBufferDone(connToClose, ()=>{
            if (code) connToClose.close(code, reason || "");
            else connToClose.close();
            this.waitForSocketClosed(connToClose, ()=>{
                if (this.conn === connToClose) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(conn, callback, tries = 1) {
        if (tries === 5 || !conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(conn, callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(conn, callback, tries = 1) {
        if (tries === 5 || conn.readyState === $af64141737efe14a$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(conn, callback, tries + 1);
        }, 150 * tries);
    }
    /**
  * @param {CloseEvent} event
  */ onConnClose(event) {
        if (this.conn) this.conn.onclose = ()=>{};
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError();
        this.clearHeartbeats();
        if (!this.closeWasClean) this.reconnectTimer.scheduleTimeout();
        this.triggerStateCallbacks("close", event);
    }
    /**
   * @private
   * @param {Event} error
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.triggerStateCallbacks("error", error, transportBefore, establishedBefore);
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError();
    }
    /**
   * @private
   */ triggerChanError() {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($af64141737efe14a$var$CHANNEL_EVENTS.error);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $af64141737efe14a$var$SOCKET_STATES.connecting:
                return "connecting";
            case $af64141737efe14a$var$SOCKET_STATES.open:
                return "open";
            case $af64141737efe14a$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   *
   * @param {Channel} channel
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c)=>c !== channel);
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {string[]} refs - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref])=>{
            return refs.indexOf(ref) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Params | (() => Params)} [chanParams]- Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $af64141737efe14a$export$cfdacaa37f9b4dd7(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Message<Record<string, any>>} data
   */ push(data) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = data;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref})`, payload);
        }
        if (this.isConnected()) this.encode(data, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback("disconnected");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.heartbeatTimeout();
            return;
        }
        this.pendingHeartbeatRef = this.makeRef();
        this.heartbeatSentAt = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback("sent");
        } catch (e) {
            this.log("error", "error in heartbeat callback", e);
        }
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
  * @param {MessageEvent<any>} rawMessage
  */ onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) {
                const latency = this.heartbeatSentAt ? Date.now() - this.heartbeatSentAt : void 0;
                this.clearHeartbeats();
                try {
                    this.heartbeatCallback(payload.status === "ok" ? "ok" : "error", latency);
                } catch (e) {
                    this.log("error", "error in heartbeat callback", e);
                }
                this.pendingHeartbeatRef = null;
                this.heartbeatSentAt = null;
                if (this.autoSendHeartbeat) this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`.trim(), payload);
            for(let i = 0; i < this.channels.length; i++){
                const channel = this.channels[i];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref, join_ref);
            }
            this.triggerStateCallbacks("message", msg);
        });
    }
    /**
   * @private
   * @template {keyof SocketStateChangeCallbacks} K
   * @param {K} event
   * @param {...Parameters<SocketStateChangeCallbacks[K][number][1]>} args
   * @returns {void}
   */ triggerStateCallbacks(event, ...args) {
        try {
            this.stateChangeCallbacks[event].forEach(([_, callback])=>{
                try {
                    callback(...args);
                } catch (e) {
                    this.log("error", `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log("error", `error triggering ${event} callbacks`, e);
        }
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c.isJoined() || c.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};

});



parcelRegister("7bMKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $53bf60346326a17f$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");
class $53bf60346326a17f$export$2e2bcd8739ae039 {
    constructor(socket, topic, params){
        const phoenixParams = $53bf60346326a17f$var$phoenixChannelParams(params);
        this.channel = socket.getSocket().channel(topic, phoenixParams);
        this.socket = socket;
    }
    get state() {
        return this.channel.state;
    }
    set state(state) {
        this.channel.state = state;
    }
    get joinedOnce() {
        return this.channel.joinedOnce;
    }
    get joinPush() {
        return this.channel.joinPush;
    }
    get rejoinTimer() {
        return this.channel.rejoinTimer;
    }
    on(event, callback) {
        return this.channel.on(event, callback);
    }
    off(event, refNumber) {
        this.channel.off(event, refNumber);
    }
    subscribe(timeout) {
        return this.channel.join(timeout);
    }
    unsubscribe(timeout) {
        return this.channel.leave(timeout);
    }
    teardown() {
        this.channel.teardown();
    }
    onClose(callback) {
        this.channel.onClose(callback);
    }
    onError(callback) {
        return this.channel.onError(callback);
    }
    push(event, payload, timeout) {
        let push;
        try {
            push = this.channel.push(event, payload, timeout);
        } catch (error) {
            throw `tried to push '${event}' to '${this.channel.topic}' before joining. Use channel.subscribe() before pushing events`;
        }
        if (this.channel.pushBuffer.length > (0, $5gqEk.MAX_PUSH_BUFFER_SIZE)) {
            const removedPush = this.channel.pushBuffer.shift();
            removedPush.cancelTimeout();
            this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload());
        }
        return push;
    }
    updateJoinPayload(payload) {
        const oldPayload = this.channel.joinPush.payload();
        this.channel.joinPush.payload = ()=>Object.assign(Object.assign({}, oldPayload), payload);
    }
    canPush() {
        return this.socket.isConnected() && this.state === (0, $5gqEk.CHANNEL_STATES).joined;
    }
    isJoined() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joined;
    }
    isJoining() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joining;
    }
    isClosed() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).closed;
    }
    isLeaving() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).leaving;
    }
    updateFilterBindings(filterBindings) {
        this.channel.filterBindings = filterBindings;
    }
    updatePayloadTransform(callback) {
        this.channel.onMessage = callback;
    }
    /**
     * @internal
     */ getChannel() {
        return this.channel;
    }
}
function $53bf60346326a17f$var$phoenixChannelParams(options) {
    return {
        config: Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, options.config)
    };
}

});


parcelRegister("iCjex", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8dab1f89bf5036d$export$2e2bcd8739ae039);

var $gS6ap = parcelRequire("gS6ap");

var $5gqEk = parcelRequire("5gqEk");
class $d8dab1f89bf5036d$export$2e2bcd8739ae039 {
    constructor(endPoint, options){
        this.socket = new (0, $gS6ap.Socket)(endPoint, options);
    }
    get timeout() {
        return this.socket.timeout;
    }
    get endPoint() {
        return this.socket.endPoint;
    }
    get transport() {
        return this.socket.transport;
    }
    get heartbeatIntervalMs() {
        return this.socket.heartbeatIntervalMs;
    }
    get heartbeatCallback() {
        return this.socket.heartbeatCallback;
    }
    set heartbeatCallback(callback) {
        this.socket.heartbeatCallback = callback;
    }
    get heartbeatTimer() {
        return this.socket.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        return this.socket.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socket.reconnectTimer;
    }
    get vsn() {
        return this.socket.vsn;
    }
    get encode() {
        return this.socket.encode;
    }
    get decode() {
        return this.socket.decode;
    }
    get reconnectAfterMs() {
        return this.socket.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socket.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socket.stateChangeCallbacks;
    }
    connect() {
        this.socket.connect();
    }
    disconnect(callback, code, reason, timeout = 10000) {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve('timeout'), timeout);
            this.socket.disconnect(()=>{
                callback();
                resolve('ok');
            }, code, reason);
        });
    }
    push(data) {
        this.socket.push(data);
    }
    log(kind, msg, data) {
        this.socket.log(kind, msg, data);
    }
    makeRef() {
        return this.socket.makeRef();
    }
    onOpen(callback) {
        this.socket.onOpen(callback);
    }
    onClose(callback) {
        this.socket.onClose(callback);
    }
    onError(callback) {
        this.socket.onError(callback);
    }
    onMessage(callback) {
        this.socket.onMessage(callback);
    }
    isConnected() {
        return this.socket.isConnected();
    }
    isConnecting() {
        return this.socket.connectionState() == (0, $5gqEk.CONNECTION_STATE).connecting;
    }
    isDisconnecting() {
        return this.socket.connectionState() == (0, $5gqEk.CONNECTION_STATE).closing;
    }
    connectionState() {
        // @ts-ignore - requires better typing and exposing type in phoenix
        return this.socket.connectionState();
    }
    endPointURL() {
        return this.socket.endPointURL();
    }
    sendHeartbeat() {
        this.socket.sendHeartbeat();
    }
    /**
     * @internal
     */ getSocket() {
        return this.socket;
    }
}

});



parcelRegister("9Yl9w", function(module, exports) {

$parcel$export(module.exports, "StorageClient", () => $d3773c76b69f8b27$export$6c85f5032e75eff9);

var $b8Rhd = parcelRequire("b8Rhd");

var $6ZWSX = parcelRequire("6ZWSX");
var $d3773c76b69f8b27$require$Buffer = $6ZWSX.Buffer;
//#region src/lib/common/errors.ts
/**
* Base error class for all Storage errors
* Supports both 'storage' and 'vectors' namespaces
*/ var $d3773c76b69f8b27$export$697502632950e9d3 = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
};
/**
* Type guard to check if an error is a StorageError
* @param error - The error to check
* @returns True if the error is a StorageError
*/ function $d3773c76b69f8b27$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
/**
* API error returned from Storage service
* Includes HTTP status code and service-specific error code
*/ var $d3773c76b69f8b27$export$ca9ecfd959b3871c = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, status, statusCode, namespace = "storage"){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
/**
* Unknown error that doesn't match expected error patterns
* Wraps the original error for debugging
*/ var $d3773c76b69f8b27$export$29127ca2e1a271d = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
/**
* @deprecated Use StorageError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$92ae90d5da46e8c0 = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message){
        super(message, "vectors");
    }
};
/**
* Type guard to check if an error is a StorageVectorsError
* @param error - The error to check
* @returns True if the error is a StorageVectorsError
*/ function $d3773c76b69f8b27$export$95bc534aa9e6b2f1(error) {
    return $d3773c76b69f8b27$export$5a322e77e5eb0561(error) && error["namespace"] === "vectors";
}
/**
* @deprecated Use StorageApiError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$22e4871ee01e8e3f = class extends $d3773c76b69f8b27$export$ca9ecfd959b3871c {
    constructor(message, status, statusCode){
        super(message, status, statusCode, "vectors");
    }
};
/**
* @deprecated Use StorageUnknownError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$26d7e1f64f113285 = class extends $d3773c76b69f8b27$export$29127ca2e1a271d {
    constructor(message, originalError){
        super(message, originalError, "vectors");
    }
};
/**
* Error codes specific to S3 Vectors API
* Maps AWS service errors to application-friendly error codes
*/ let $d3773c76b69f8b27$export$2f60cecd2e35a5da = /* @__PURE__ */ function(StorageVectorsErrorCode$1) {
    /** Internal server fault (HTTP 500) */ StorageVectorsErrorCode$1["InternalError"] = "InternalError";
    /** Resource already exists / conflict (HTTP 409) */ StorageVectorsErrorCode$1["S3VectorConflictException"] = "S3VectorConflictException";
    /** Resource not found (HTTP 404) */ StorageVectorsErrorCode$1["S3VectorNotFoundException"] = "S3VectorNotFoundException";
    /** Delete bucket while not empty (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorBucketNotEmpty"] = "S3VectorBucketNotEmpty";
    /** Exceeds bucket quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxBucketsExceeded"] = "S3VectorMaxBucketsExceeded";
    /** Exceeds index quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxIndexesExceeded"] = "S3VectorMaxIndexesExceeded";
    return StorageVectorsErrorCode$1;
}({});
//#endregion
//#region src/lib/common/helpers.ts
/**
* Resolves the fetch implementation to use
* Uses custom fetch if provided, otherwise uses native fetch
*
* @param customFetch - Optional custom fetch implementation
* @returns Resolved fetch function
*/ const $d3773c76b69f8b27$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
/**
* Determine if input is a plain object
* An object is plain if it's created by either {}, new Object(), or Object.create(null)
*
* @param value - Value to check
* @returns True if value is a plain object
* @source https://github.com/sindresorhus/is-plain-obj
*/ const $d3773c76b69f8b27$var$isPlainObject = (value)=>{
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
/**
* Recursively converts object keys from snake_case to camelCase
* Used for normalizing API responses
*
* @param item - Object to convert
* @returns Converted object with camelCase keys
*/ const $d3773c76b69f8b27$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$d3773c76b69f8b27$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $d3773c76b69f8b27$var$recursiveToCamel(value);
    });
    return result;
};
/**
* Validates if a given bucket name is valid according to Supabase Storage API rules
* Mirrors backend validation from: storage/src/storage/limits.ts:isValidBucketName()
*
* Rules:
* - Length: 1-100 characters
* - Allowed characters: alphanumeric (a-z, A-Z, 0-9), underscore (_), and safe special characters
* - Safe special characters: ! - . * ' ( ) space & $ @ = ; : + , ?
* - Forbidden: path separators (/, \), path traversal (..), leading/trailing whitespace
*
* AWS S3 Reference: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
*
* @param bucketName - The bucket name to validate
* @returns true if valid, false otherwise
*/ const $d3773c76b69f8b27$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $d3773c76b69f8b27$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d3773c76b69f8b27$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $d3773c76b69f8b27$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $d3773c76b69f8b27$var$toPrimitive(t, r) {
    if ("object" != $d3773c76b69f8b27$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d3773c76b69f8b27$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $d3773c76b69f8b27$var$toPropertyKey(t) {
    var i = $d3773c76b69f8b27$var$toPrimitive(t, "string");
    return "symbol" == $d3773c76b69f8b27$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $d3773c76b69f8b27$var$_defineProperty(e, r, t) {
    return (r = $d3773c76b69f8b27$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $d3773c76b69f8b27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3773c76b69f8b27$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3773c76b69f8b27$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $d3773c76b69f8b27$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3773c76b69f8b27$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/common/fetch.ts
/**
* Extracts error message from various error response formats
* @param err - Error object from API
* @returns Human-readable error message
*/ const $d3773c76b69f8b27$var$_getErrorMessage = (err)=>{
    var _err$error;
    return err.msg || err.message || err.error_description || (typeof err.error === "string" ? err.error : (_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.message) || JSON.stringify(err);
};
/**
* Handles fetch errors and converts them to Storage error types
* @param error - The error caught from fetch
* @param reject - Promise rejection function
* @param options - Fetch options that may affect error handling
* @param namespace - Error namespace ('storage' or 'vectors')
*/ const $d3773c76b69f8b27$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(responseError.status, 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c($d3773c76b69f8b27$var$_getErrorMessage(err), status, statusCode, namespace));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $d3773c76b69f8b27$export$29127ca2e1a271d($d3773c76b69f8b27$var$_getErrorMessage(error), error, namespace));
};
/**
* Builds request parameters for fetch calls
* @param method - HTTP method
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters like AbortSignal
* @param body - Request body (will be JSON stringified if plain object)
* @returns Complete fetch request parameters
*/ const $d3773c76b69f8b27$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
    if ($d3773c76b69f8b27$var$isPlainObject(body)) {
        params.headers = $d3773c76b69f8b27$var$_objectSpread2({
            "Content-Type": "application/json"
        }, options === null || options === void 0 ? void 0 : options.headers);
        params.body = JSON.stringify(body);
    } else params.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params.duplex = options.duplex;
    return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
};
/**
* Internal request handler that wraps fetch with error handling
* @param fetcher - Fetch function to use
* @param method - HTTP method
* @param url - Request URL
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters
* @param body - Request body
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Promise with parsed response or error
*/ async function $d3773c76b69f8b27$var$_handleRequest(fetcher, method, url, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url, $d3773c76b69f8b27$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data)=>resolve(data)).catch((error)=>$d3773c76b69f8b27$var$handleError(error, reject, options, namespace));
    });
}
/**
* Creates a fetch API with the specified namespace
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Object with HTTP method functions
*/ function $d3773c76b69f8b27$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "GET", url, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "POST", url, options, parameters, body, namespace);
        },
        put: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "PUT", url, options, parameters, body, namespace);
        },
        head: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "HEAD", url, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body, namespace);
        }
    };
}
const $d3773c76b69f8b27$var$defaultApi = $d3773c76b69f8b27$var$createFetchApi("storage");
const { get: $d3773c76b69f8b27$var$get, post: $d3773c76b69f8b27$var$post, put: $d3773c76b69f8b27$var$put, head: $d3773c76b69f8b27$var$head, remove: $d3773c76b69f8b27$var$remove } = $d3773c76b69f8b27$var$defaultApi;
const $d3773c76b69f8b27$var$vectorsApi = $d3773c76b69f8b27$var$createFetchApi("vectors");
//#endregion
//#region src/lib/common/BaseApiClient.ts
/**
* @ignore
* Base API client class for all Storage API classes
* Provides common infrastructure for error handling and configuration
*
* @typeParam TError - The error type (StorageError or subclass)
*/ var $d3773c76b69f8b27$var$BaseApiClient = class {
    /**
	* Creates a new BaseApiClient instance
	* @param url - Base URL for API requests
	* @param headers - Default headers for API requests
	* @param fetch - Optional custom fetch implementation
	* @param namespace - Error namespace ('storage' or 'vectors')
	*/ constructor(url, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url;
        this.headers = headers;
        this.fetch = $d3773c76b69f8b27$var$resolveFetch(fetch$1);
        this.namespace = namespace;
    }
    /**
	* Enable throwing errors instead of returning them.
	* When enabled, errors are thrown instead of returned in { data, error } format.
	*
	* @returns this - For method chaining
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	* Creates a shallow copy of headers to avoid mutating shared state.
	*
	* @param name - Header name
	* @param value - Header value
	* @returns this - For method chaining
	*/ setHeader(name, value) {
        this.headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, this.headers), {}, {
            [name]: value
        });
        return this;
    }
    /**
	* Handles API operation with standardized error handling
	* Eliminates repetitive try-catch blocks across all API methods
	*
	* This wrapper:
	* 1. Executes the operation
	* 2. Returns { data, error: null } on success
	* 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
	* 4. Throws error on failure (if shouldThrowOnError is true)
	*
	* @typeParam T - The expected data type from the operation
	* @param operation - Async function that performs the API call
	* @returns Promise with { data, error } tuple
	*
	* @example Handling an operation
	* ```typescript
	* async listBuckets() {
	*   return this.handleOperation(async () => {
	*     return await get(this.fetch, `${this.url}/bucket`, {
	*       headers: this.headers,
	*     })
	*   })
	* }
	* ```
	*/ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StreamDownloadBuilder.ts
var $d3773c76b69f8b27$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
    }
    then(onfulfilled, onrejected) {
        return this.execute().then(onfulfilled, onrejected);
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/BlobDownloadBuilder.ts
let $d3773c76b69f8b27$var$_Symbol$toStringTag;
$d3773c76b69f8b27$var$_Symbol$toStringTag = Symbol.toStringTag;
var $d3773c76b69f8b27$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$d3773c76b69f8b27$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $d3773c76b69f8b27$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StorageFileApi.ts
const $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $d3773c76b69f8b27$var$StorageFileApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, bucketId, fetch$1){
        super(url, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
	* Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
	*
	* @param method HTTP method.
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	*/ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, headers), fileOptions.headers);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data = await (method == "PUT" ? $d3773c76b69f8b27$var$put : $d3773c76b69f8b27$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $d3773c76b69f8b27$var$_objectSpread2({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data.Id,
                fullPath: data.Key
            };
        });
    }
    /**
	* Uploads a file to an existing bucket.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Upload file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: false
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Upload file using `ArrayBuffer` from base64 file data
	* ```js
	* import { decode } from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: only `insert` when you are uploading new files and `select`, `insert` and `update` when you are upserting files
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Upload file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
	* Upload a file with a token generated from `createSignedUploadUrl`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param token The token generated from `createSignedUploadUrl`
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions HTTP headers (cacheControl, contentType, etc.).
	* **Note:** The `upsert` option has no effect here. To enable upsert behavior,
	* pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
	* @returns Promise with response containing file path and fullPath or error
	*
	* @example Upload to a signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "folder/cat.jpg",
	*     "fullPath": "avatars/folder/cat.jpg"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS), fileOptions);
            const headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                body.append("cacheControl", options.cacheControl);
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
            }
            return {
                path: cleanPath,
                fullPath: (await $d3773c76b69f8b27$var$put(_this3.fetch, url.toString(), body, {
                    headers: headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed upload URL.
	* Signed upload URLs can be used to upload files to the bucket without further authentication.
	* They are valid for 2 hours.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param options.upsert If set to true, allows the file to be overwritten if it already exists.
	* @returns Promise with response containing signed upload URL, token, and path or error
	*
	* @example Create Signed Upload URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUploadUrl('folder/cat.jpg')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
	*     "path": "folder/cat.jpg",
	*     "token": "<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $d3773c76b69f8b27$var$_objectSpread2({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data = await $d3773c76b69f8b27$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url = new URL(_this4.url + data.url);
            const token = url.searchParams.get("token");
            if (!token) throw new $d3773c76b69f8b27$export$697502632950e9d3("No token returned by API");
            return {
                signedUrl: url.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
	* Replaces an existing file at the specified path with a new one.
	*
	* @category File Buckets
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Update file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: true
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Update file using `ArrayBuffer` from base64 file data
	* ```js
	* import {decode} from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Update file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
	* Moves an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
	* @param options The destination options.
	* @returns Promise with response containing success message or error
	*
	* @example Move file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .move('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully moved"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Copies an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
	* @param options The destination options.
	* @returns Promise with response containing copied file path or error
	*
	* @example Copy file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .copy('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "avatars/private/avatar2.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return {
                path: (await $d3773c76b69f8b27$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @returns Promise with response containing signed URL or error
	*
	* @example Create Signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Create a signed URL for an asset with transformations
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Create a signed URL which triggers the download of the asset
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data = await $d3773c76b69f8b27$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $d3773c76b69f8b27$var$_objectSpread2({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), {
                headers: _this8.headers
            });
            const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
            const returnedPath = hasTransform && data.signedURL.includes("/object/sign/") ? data.signedURL.replace("/object/sign/", "/render/image/sign/") : data.signedURL;
            return {
                signedUrl: encodeURI(`${_this8.url}${returnedPath}${downloadQueryParam}`)
            };
        });
    }
    /**
	* Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
	* @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @returns Promise with response containing array of objects with signedUrl, path, and error or error
	*
	* @example Create Signed URLs
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "error": null,
	*       "path": "folder/avatar1.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*     },
	*     {
	*       "error": null,
	*       "path": "folder/avatar2.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data = await $d3773c76b69f8b27$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
            return data.map((datum)=>$d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${downloadQueryParam}`) : null
                }));
        });
    }
    /**
	* Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
	*
	* @category File Buckets
	* @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
	* @param options.transform Transform the asset before serving it to the client.
	* @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
	* @returns BlobDownloadBuilder instance for downloading the file
	*
	* @example Download file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": <BLOB>,
	*   "error": null
	* }
	* ```
	*
	* @example Download file with transformations
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*       quality: 80
	*     }
	*   })
	* ```
	*
	* @example Download with cache control (useful in Edge Functions)
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { cache: 'no-store' })
	* ```
	*
	* @example Download with abort signal
	* ```js
	* const controller = new AbortController()
	* setTimeout(() => controller.abort(), 5000)
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { signal: controller.signal })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined" ? "render/image/authenticated" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        const queryString = transformationQuery ? `?${transformationQuery}` : "";
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$d3773c76b69f8b27$var$get(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $d3773c76b69f8b27$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
	* Retrieves the details of an existing file.
	*
	* Returns detailed file metadata including size, content type, and timestamps.
	* Note: The API returns `last_modified` field, not `updated_at`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing file metadata or error
	*
	* @example Get file info
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .info('folder/avatar1.png')
	*
	* if (data) {
	*   console.log('Last modified:', data.lastModified)
	*   console.log('Size:', data.size)
	* }
	* ```
	*/ async info(path) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        return _this10.handleOperation(async ()=>{
            return $d3773c76b69f8b27$var$recursiveToCamel(await $d3773c76b69f8b27$var$get(_this10.fetch, `${_this10.url}/object/info/${_path}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
	* Checks the existence of a file.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing boolean indicating file existence or error
	*
	* @example Check file existence
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .exists('folder/avatar1.png')
	* ```
	*/ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $d3773c76b69f8b27$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) {
                var _error$originalError;
                const status = error instanceof $d3773c76b69f8b27$export$ca9ecfd959b3871c ? error.status : error instanceof $d3773c76b69f8b27$export$29127ca2e1a271d ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
	* A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
	* This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
	*
	* @category File Buckets
	* @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
	* @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @returns Object with public URL
	*
	* @example Returns the URL for an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
	*   }
	* }
	* ```
	*
	* @example Returns the URL for an asset in a public bucket with transformations
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Returns the URL which triggers the download of an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - The bucket needs to be set to public, either via [updateBucket()](/docs/reference/javascript/storage-updatebucket) or by going to Storage on [supabase.com/dashboard](https://supabase.com/dashboard), clicking the overflow menu on a bucket and choosing "Make public"
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? "" : options.download}` : "";
        if (downloadQueryParam !== "") _queryString.push(downloadQueryParam);
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined" ? "render/image" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== "") _queryString.push(transformationQuery);
        let queryString = _queryString.join("&");
        if (queryString !== "") queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
	* Deletes files within the same bucket
	*
	* Returns an array of FileObject entries for the deleted files. Note that deprecated
	* fields like `bucket_id` may or may not be present in the response - do not rely on them.
	*
	* @category File Buckets
	* @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
	* @returns Promise with response containing array of deleted file objects or error
	*
	* @example Delete file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove(['folder/avatar1.png'])
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `delete` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
	* Get file metadata
	* @param id the file id to retrieve metadata
	*/ /**
	* Update file metadata
	* @param id the file id to update metadata
	* @param meta the new file metadata
	*/ /**
	* Lists all the files and folders within a path of the bucket.
	*
	* **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
	* `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
	* Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
	* by this method.
	*
	* @category File Buckets
	* @param path The folder path.
	* @param options Search options including limit (defaults to 100), offset, sortBy, and search
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing array of files/folders or error
	*
	* @example List files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*   })
	*
	* // Handle files vs folders
	* data?.forEach(item => {
	*   if (item.id !== null) {
	*     // It's a file
	*     console.log('File:', item.name, 'Size:', item.metadata?.size)
	*   } else {
	*     // It's a folder
	*     console.log('Folder:', item.name)
	*   }
	* })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "avatar1.png",
	*       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
	*       "updated_at": "2024-05-22T23:06:05.580Z",
	*       "created_at": "2024-05-22T23:04:34.443Z",
	*       "last_accessed_at": "2024-05-22T23:04:34.443Z",
	*       "metadata": {
	*         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
	*         "size": 32175,
	*         "mimetype": "image/png",
	*         "cacheControl": "max-age=3600",
	*         "lastModified": "2024-05-22T23:06:05.574Z",
	*         "contentLength": 32175,
	*         "httpStatusCode": 200
	*       }
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @example Search files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*     search: 'jon'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async list(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                prefix: path || ""
            });
            return await $d3773c76b69f8b27$var$post(_this13.fetch, `${_this13.url}/object/list/${_this13.bucketId}`, body, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
	* Lists all the files and folders within a bucket using the V2 API with pagination support.
	*
	* **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
	* they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
	* on entries in the `objects` array.
	*
	* @experimental this method signature might change in the future
	*
	* @category File Buckets
	* @param options Search options including prefix, cursor for pagination, limit, with_delimiter
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing folders/objects arrays with pagination info or error
	*
	* @example List files with pagination
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .listV2({
	*     prefix: 'folder/',
	*     limit: 100,
	*   })
	*
	* // Handle pagination
	* if (data?.hasNext) {
	*   const nextPage = await supabase
	*     .storage
	*     .from('avatars')
	*     .listV2({
	*       prefix: 'folder/',
	*       cursor: data.nextCursor,
	*     })
	* }
	*
	* // Handle files vs folders
	* data?.objects.forEach(file => {
	*   if (file.id !== null) {
	*     console.log('File:', file.name, 'Size:', file.metadata?.size)
	*   }
	* })
	* data?.folders.forEach(folder => {
	*   console.log('Folder:', folder.name)
	* })
	* ```
	*/ async listV2(options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2({}, options);
            return await $d3773c76b69f8b27$var$post(_this14.fetch, `${_this14.url}/object/list-v2/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $d3773c76b69f8b27$require$Buffer !== "undefined") return $d3773c76b69f8b27$require$Buffer.from(data).toString("base64");
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join("&");
    }
};
//#endregion
//#region src/lib/version.ts
const $d3773c76b69f8b27$var$version = "2.100.1";
//#endregion
//#region src/lib/constants.ts
const $d3773c76b69f8b27$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$d3773c76b69f8b27$var$version}`
};
//#endregion
//#region src/packages/StorageBucketApi.ts
var $d3773c76b69f8b27$var$StorageBucketApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* Retrieves the details of all Storage buckets within an existing project.
	*
	* @category File Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of buckets or error
	*
	* @example List buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets()
	* ```
	*
	* @example List buckets with options
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc',
	*     search: 'prod'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $d3773c76b69f8b27$var$get(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
	* Retrieves the details of an existing Storage bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to retrieve.
	* @returns Promise with response containing bucket details or error
	*
	* @example Get bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "id": "avatars",
	*     "name": "avatars",
	*     "owner": "",
	*     "public": false,
	*     "file_size_limit": 1024,
	*     "allowed_mime_types": [
	*       "image/png"
	*     ],
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async getBucket(id) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$get(_this2.fetch, `${_this2.url}/bucket/${id}`, {
                headers: _this2.headers
            });
        });
    }
    /**
	* Creates a new Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are creating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
	*   - default bucket type is `STANDARD`
	* @returns Promise with response containing newly created bucket name or error
	*
	* @example Create bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .createBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "avatars"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `insert`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createBucket(id, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id,
                name: id,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
	* Updates a Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are updating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @returns Promise with response containing success message or error
	*
	* @example Update bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully updated"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async updateBucket(id, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$put(_this4.fetch, `${_this4.url}/bucket/${id}`, {
                id: id,
                name: id,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
	* Removes all objects inside a single bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to empty.
	* @returns Promise with success message or error
	*
	* @example Empty bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .emptyBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully emptied"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: `select` and `delete`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async emptyBucket(id) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this5.fetch, `${_this5.url}/bucket/${id}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
	* Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
	* You must first `empty()` the bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to delete.
	* @returns Promise with success message or error
	*
	* @example Delete bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `delete`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async deleteBucket(id) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this6.fetch, `${_this6.url}/bucket/${id}`, {}, {
                headers: _this6.headers
            });
        });
    }
    listBucketOptionsToQueryString(options) {
        const params = {};
        if (options) {
            if ("limit" in options) params.limit = String(options.limit);
            if ("offset" in options) params.offset = String(options.offset);
            if (options.search) params.search = options.search;
            if (options.sortColumn) params.sortColumn = options.sortColumn;
            if (options.sortOrder) params.sortOrder = options.sortOrder;
        }
        return Object.keys(params).length > 0 ? "?" + new URLSearchParams(params).toString() : "";
    }
};
//#endregion
//#region src/packages/StorageAnalyticsClient.ts
/**
* Client class for managing Analytics Buckets using Iceberg tables
* Provides methods for creating, listing, and deleting analytics buckets
*/ var $d3773c76b69f8b27$export$6be1752cbca4e2bf = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /**
	* @alpha
	*
	* Creates a new StorageAnalyticsClient instance
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param url - The base URL for the storage API
	* @param headers - HTTP headers to include in requests
	* @param fetch - Optional custom fetch implementation
	*
	* @example Creating a StorageAnalyticsClient instance
	* ```typescript
	* const client = new StorageAnalyticsClient(url, headers)
	* ```
	*/ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* @alpha
	*
	* Creates a new analytics bucket using Iceberg tables
	* Analytics buckets are optimized for analytical queries and data processing
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param name A unique name for the bucket you are creating
	* @returns Promise with response containing newly created analytics bucket or error
	*
	* @example Create analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "analytics-data",
	*     "type": "ANALYTICS",
	*     "format": "iceberg",
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Creates a new analytics bucket using Iceberg tables
	* - Analytics buckets are optimized for analytical queries and data processing
	*/ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Retrieves the details of all Analytics Storage buckets within an existing project
	* Only returns buckets of type 'ANALYTICS'
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of analytics buckets or error
	*
	* @example List analytics buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "analytics-data",
	*       "type": "ANALYTICS",
	*       "format": "iceberg",
	*       "created_at": "2024-05-22T22:26:05.100Z",
	*       "updated_at": "2024-05-22T22:26:05.100Z"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Retrieves the details of all Analytics Storage buckets within an existing project
	* - Only returns buckets of type 'ANALYTICS'
	*/ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $d3773c76b69f8b27$var$get(_this2.fetch, url, {
                headers: _this2.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Deletes an existing analytics bucket
	* A bucket can't be deleted with existing objects inside it
	* You must first empty the bucket before deletion
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName The unique identifier of the bucket you would like to delete
	* @returns Promise with response containing success message or error
	*
	* @example Delete analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .deleteBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Deletes an analytics bucket
	*/ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Get an Iceberg REST Catalog client configured for a specific analytics bucket
	* Use this to perform advanced table and namespace operations within the bucket
	* The returned client provides full access to the Apache Iceberg REST Catalog API
	* with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName - The name of the analytics bucket (warehouse) to connect to
	* @returns The wrapped Iceberg catalog client
	* @throws {StorageError} If the bucket name is invalid
	*
	* @example Get catalog and create table
	* ```js
	* // First, create an analytics bucket
	* const { data: bucket, error: bucketError } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	*
	* // Get the Iceberg catalog for that bucket
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Create a namespace
	* const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
	*
	* // Create a table with schema
	* const { data: tableMetadata, error: tableError } = await catalog.createTable(
	*   { namespace: ['default'] },
	*   {
	*     name: 'events',
	*     schema: {
	*       type: 'struct',
	*       fields: [
	*         { id: 1, name: 'id', type: 'long', required: true },
	*         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
	*         { id: 3, name: 'user_id', type: 'string', required: false }
	*       ],
	*       'schema-id': 0,
	*       'identifier-field-ids': [1]
	*     },
	*     'partition-spec': {
	*       'spec-id': 0,
	*       fields: []
	*     },
	*     'write-order': {
	*       'order-id': 0,
	*       fields: []
	*     },
	*     properties: {
	*       'write.format.default': 'parquet'
	*     }
	*   }
	* )
	* ```
	*
	* @example List tables in namespace
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all tables in the default namespace
	* const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
	* if (listError) {
	*   if (listError.isNotFound()) {
	*     console.log('Namespace not found')
	*   }
	*   return
	* }
	* console.log(tables) // [{ namespace: ['default'], name: 'events' }]
	* ```
	*
	* @example Working with namespaces
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all namespaces
	* const { data: namespaces } = await catalog.listNamespaces()
	*
	* // Create namespace with properties
	* await catalog.createNamespace(
	*   { namespace: ['production'] },
	*   { properties: { owner: 'data-team', env: 'prod' } }
	* )
	* ```
	*
	* @example Cleanup operations
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Drop table with purge option (removes all data)
	* const { error: dropError } = await catalog.dropTable(
	*   { namespace: ['default'], name: 'events' },
	*   { purge: true }
	* )
	*
	* if (dropError?.isNotFound()) {
	*   console.log('Table does not exist')
	* }
	*
	* // Drop namespace (must be empty)
	* await catalog.dropNamespace({ namespace: ['default'] })
	* ```
	*
	* @remarks
	* This method provides a bridge between Supabase's bucket management and the standard
	* Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
	* All authentication and configuration is handled automatically using your Supabase credentials.
	*
	* **Error Handling**: Invalid bucket names throw immediately. All catalog
	* operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
	* Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
	* Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
	*
	* **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
	* deletes all table data. Without it, the table is marked as deleted but data remains.
	*
	* **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
	* For complete API documentation and advanced usage, refer to the
	* [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
	*/ from(bucketName) {
        var _this4 = this;
        if (!$d3773c76b69f8b27$var$isValidBucketName(bucketName)) throw new $d3773c76b69f8b27$export$697502632950e9d3("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new (0, $b8Rhd.IcebergRestCatalog)({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value = target[prop];
                if (typeof value !== "function") return value;
                return async (...args)=>{
                    try {
                        return {
                            data: await value.apply(target, args),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
//#endregion
//#region src/packages/VectorIndexApi.ts
/**
* @hidden
* Base implementation for vector index operations.
* Use {@link VectorBucketScope} via `supabase.storage.vectors.from('bucket')` instead.
*/ var $d3773c76b69f8b27$export$50097ff1e36420b1 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorDataApi.ts
/**
* @hidden
* Base implementation for vector data operations.
* Use {@link VectorIndexScope} via `supabase.storage.vectors.from('bucket').index('idx')` instead.
*/ var $d3773c76b69f8b27$export$5f2a4b6b8397c039 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorBucketApi.ts
/**
* @hidden
* Base implementation for vector bucket operations.
* Use {@link StorageVectorsClient} via `supabase.storage.vectors` instead.
*/ var $d3773c76b69f8b27$export$e8b640c07a633e69 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/StorageVectorsClient.ts
/**
*
* @alpha
*
* Main client for interacting with S3 Vectors API
* Provides access to bucket, index, and vector data operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*
* **Usage Patterns:**
*
* ```typescript
* const { data, error } = await supabase
*  .storage
*  .vectors
*  .createBucket('embeddings-prod')
*
* // Access index operations via buckets
* const bucket = supabase.storage.vectors.from('embeddings-prod')
* await bucket.createIndex({
*   indexName: 'documents',
*   dataType: 'float32',
*   dimension: 1536,
*   distanceMetric: 'cosine'
* })
*
* // Access vector operations via index
* const index = bucket.index('documents')
* await index.putVectors({
*   vectors: [
*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
*   ]
* })
*
* // Query similar vectors
* const { data } = await index.queryVectors({
*   queryVector: { float32: [...] },
*   topK: 5,
*   returnDistance: true
* })
* ```
*/ var $d3773c76b69f8b27$export$f8cb34cab8a13f87 = class extends $d3773c76b69f8b27$export$e8b640c07a633e69 {
    /**
	* @alpha
	*
	* Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param url - Base URL of the Storage Vectors REST API.
	* @param options.headers - Optional headers (for example `Authorization`) applied to every request.
	* @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
	*
	* @example Creating a StorageVectorsClient instance
	* ```typescript
	* const client = new StorageVectorsClient(url, options)
	* ```
	*/ constructor(url, options = {}){
        super(url, options.headers || {}, options.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific vector bucket
	* Returns a scoped client for index and vector operations within the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Bucket-scoped client with index and vector operations
	*
	* @example Accessing a vector bucket
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ from(vectorBucketName) {
        return new $d3773c76b69f8b27$export$5a6e64e51df41f53(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector bucket
	* Vector buckets are containers for vector indexes and their data
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Unique name for the vector bucket
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .createBucket('embeddings-prod')
	* ```
	*/ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific vector bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Promise with bucket metadata or error
	*
	* @example Get bucket metadata
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .getBucket('embeddings-prod')
	*
	* console.log('Bucket created:', data?.vectorBucket.creationTime)
	* ```
	*/ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Lists all vector buckets with optional filtering and pagination
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Optional filters (prefix, maxResults, nextToken)
	* @returns Promise with list of buckets or error
	*
	* @example List vector buckets
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .listBuckets({ prefix: 'embeddings-' })
	*
	* data?.vectorBuckets.forEach(bucket => {
	*   console.log(bucket.vectorBucketName)
	* })
	* ```
	*/ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
	*
	* @alpha
	*
	* Deletes a vector bucket (bucket must be empty)
	* All indexes must be deleted before deleting the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .deleteBucket('embeddings-old')
	* ```
	*/ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector bucket
* Provides index management and access to vector operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$5a6e64e51df41f53 = class extends $d3773c76b69f8b27$export$50097ff1e36420b1 {
    /**
	* @alpha
	*
	* Creates a helper that automatically scopes all index operations to the provided bucket.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example Creating a vector bucket scope
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ constructor(url, headers, vectorBucketName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Index configuration (vectorBucketName is automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.createIndex({
	*   indexName: 'documents-openai',
	*   dataType: 'float32',
	*   dimension: 1536,
	*   distanceMetric: 'cosine',
	*   metadataConfiguration: {
	*     nonFilterableMetadataKeys: ['raw_text']
	*   }
	* })
	* ```
	*/ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists indexes in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (vectorBucketName is automatically set)
	* @returns Promise with response containing indexes array and pagination token or error
	*
	* @example List indexes
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.listIndexes({ prefix: 'documents-' })
	* ```
	*/ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to retrieve
	* @returns Promise with index metadata or error
	*
	* @example Get index metadata
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.getIndex('documents-openai')
	* console.log('Dimension:', data?.index.dimension)
	* ```
	*/ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Deletes an index from this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete an index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.deleteIndex('old-index')
	* ```
	*/ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific index within this bucket
	* Returns a scoped client for vector data operations
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index
	* @returns Index-scoped client with vector data operations
	*
	* @example Accessing an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	*
	* // Insert vectors
	* await index.putVectors({
	*   vectors: [
	*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
	*   ]
	* })
	*
	* // Query similar vectors
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [...] },
	*   topK: 5
	* })
	* ```
	*/ index(indexName) {
        return new $d3773c76b69f8b27$export$bb92e54e27a7dace(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector index
* Provides vector data operations (put, get, list, query, delete)
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$bb92e54e27a7dace = class extends $d3773c76b69f8b27$export$5f2a4b6b8397c039 {
    /**
	*
	* @alpha
	*
	* Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example Creating a vector index scope
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* ```
	*/ constructor(url, headers, vectorBucketName, indexName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
	*
	* @alpha
	*
	* Inserts or updates vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector insertion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Insert vectors into an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.putVectors({
	*   vectors: [
	*     {
	*       key: 'doc-1',
	*       data: { float32: [0.1, 0.2, ...] },
	*       metadata: { title: 'Introduction', page: 1 }
	*     }
	*   ]
	* })
	* ```
	*/ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector retrieval options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array or error
	*
	* @example Get vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.getVectors({
	*   keys: ['doc-1', 'doc-2'],
	*   returnMetadata: true
	* })
	* ```
	*/ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists vectors in this index with pagination
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array and pagination token or error
	*
	* @example List vectors with pagination
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.listVectors({
	*   maxResults: 500,
	*   returnMetadata: true
	* })
	* ```
	*/ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Queries for similar vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Query options (bucket and index names automatically set)
	* @returns Promise with response containing matches array of similar vectors ordered by distance or error
	*
	* @example Query similar vectors
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [0.1, 0.2, ...] },
	*   topK: 5,
	*   filter: { category: 'technical' },
	*   returnDistance: true,
	*   returnMetadata: true
	* })
	* ```
	*/ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Deletes vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Deletion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Delete vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.deleteVectors({
	*   keys: ['doc-1', 'doc-2', 'doc-3']
	* })
	* ```
	*/ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
//#endregion
//#region src/StorageClient.ts
var $d3773c76b69f8b27$export$6c85f5032e75eff9 = class extends $d3773c76b69f8b27$var$StorageBucketApi {
    /**
	* Creates a client for Storage buckets, files, analytics, and vectors.
	*
	* @category File Buckets
	* @example Creating a Storage client
	* ```ts
	* import { StorageClient } from '@supabase/storage-js'
	*
	* const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
	*   apikey: 'public-anon-key',
	* })
	* const avatars = storage.from('avatars')
	* ```
	*/ constructor(url, headers = {}, fetch$1, opts){
        super(url, headers, fetch$1, opts);
    }
    /**
	* Perform file operation in a bucket.
	*
	* @category File Buckets
	* @param id The bucket id to operate on.
	*
	* @example Accessing a bucket
	* ```typescript
	* const avatars = supabase.storage.from('avatars')
	* ```
	*/ from(id) {
        return new $d3773c76b69f8b27$var$StorageFileApi(this.url, this.headers, id, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access vector storage operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @returns A StorageVectorsClient instance configured with the current storage settings.
	*/ get vectors() {
        return new $d3773c76b69f8b27$export$f8cb34cab8a13f87(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
	*
	* @alpha
	*
	* Access analytics storage operations using Iceberg tables.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @returns A StorageAnalyticsClient instance configured with the current storage settings.
	*/ get analytics() {
        return new $d3773c76b69f8b27$export$6be1752cbca4e2bf(this.url + "/iceberg", this.headers, this.fetch);
    }
};

});
parcelRegister("b8Rhd", function(module, exports) {

$parcel$export(module.exports, "IcebergRestCatalog", () => $9d579afbf8f344f3$export$1ccb0cb30480e317);
// src/errors/IcebergError.ts
var $9d579afbf8f344f3$export$5625de1fddd06f76 = class extends Error {
    constructor(message, opts){
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && opts.icebergType?.includes("CommitState") === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
// src/utils/url.ts
function $9d579afbf8f344f3$var$buildUrl(baseUrl, path, query) {
    const url = new URL(path, baseUrl);
    if (query) {
        for (const [key, value] of Object.entries(query))if (value !== void 0) url.searchParams.set(key, value);
    }
    return url.toString();
}
// src/http/createFetchClient.ts
async function $9d579afbf8f344f3$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $9d579afbf8f344f3$var$createFetchClient(options) {
    const fetchFn = options.fetchImpl ?? globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            const url = $9d579afbf8f344f3$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $9d579afbf8f344f3$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data = isJson && text ? JSON.parse(text) : text;
            if (!res.ok) {
                const errBody = isJson ? data : void 0;
                const errorDetail = errBody?.error;
                throw new $9d579afbf8f344f3$export$5625de1fddd06f76(errorDetail?.message ?? `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail?.type,
                    icebergCode: errorDetail?.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data
            };
        }
    };
}
// src/catalog/namespaces.ts
function $9d579afbf8f344f3$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $9d579afbf8f344f3$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id, metadata) {
        const request = {
            namespace: id.namespace,
            properties: metadata?.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
    }
    async loadNamespaceMetadata(id) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id, metadata) {
        try {
            return await this.createNamespace(id, metadata);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return;
            throw error;
        }
    }
};
// src/catalog/tables.ts
function $9d579afbf8f344f3$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id, options) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            query: {
                purgeRequested: String(options?.purge ?? false)
            }
        });
    }
    async loadTable(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
// src/catalog/IcebergRestCatalog.ts
var $9d579afbf8f344f3$export$1ccb0cb30480e317 = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $9d579afbf8f344f3$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = options.accessDelegation?.join(",");
        this.namespaceOps = new $9d579afbf8f344f3$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $9d579afbf8f344f3$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id, metadata) {
        return this.namespaceOps.createNamespace(id, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id) {
        await this.namespaceOps.dropNamespace(id);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id) {
        return this.namespaceOps.loadNamespaceMetadata(id);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id, request) {
        return this.tableOps.updateTable(id, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id, options) {
        await this.tableOps.dropTable(id, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id) {
        return this.tableOps.loadTable(id);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id) {
        return this.namespaceOps.namespaceExists(id);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id) {
        return this.tableOps.tableExists(id);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// src/catalog/types.ts
var $9d579afbf8f344f3$var$DECIMAL_REGEX = /^decimal\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/;
var $9d579afbf8f344f3$var$FIXED_REGEX = /^fixed\s*\[\s*(\d+)\s*\]$/;
function $9d579afbf8f344f3$export$31eb975fa3e9c1f6(type) {
    const match = type.match($9d579afbf8f344f3$var$DECIMAL_REGEX);
    if (!match) return null;
    return {
        precision: parseInt(match[1], 10),
        scale: parseInt(match[2], 10)
    };
}
function $9d579afbf8f344f3$export$43d56cf6240a0c0e(type) {
    const match = type.match($9d579afbf8f344f3$var$FIXED_REGEX);
    if (!match) return null;
    return {
        length: parseInt(match[1], 10)
    };
}
function $9d579afbf8f344f3$export$ec8cf417183662a1(type) {
    return $9d579afbf8f344f3$var$DECIMAL_REGEX.test(type);
}
function $9d579afbf8f344f3$export$9fafc1fb79bd852e(type) {
    return $9d579afbf8f344f3$var$FIXED_REGEX.test(type);
}
function $9d579afbf8f344f3$export$84255940fed2ec86(a, b) {
    const decimalA = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(a);
    const decimalB = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(b);
    if (decimalA && decimalB) return decimalA.precision === decimalB.precision && decimalA.scale === decimalB.scale;
    const fixedA = $9d579afbf8f344f3$export$43d56cf6240a0c0e(a);
    const fixedB = $9d579afbf8f344f3$export$43d56cf6240a0c0e(b);
    if (fixedA && fixedB) return fixedA.length === fixedB.length;
    return a === b;
}
function $9d579afbf8f344f3$export$d26e6db8c278e564(metadata) {
    return metadata.schemas.find((s)=>s["schema-id"] === metadata["current-schema-id"]);
}
 //# sourceMappingURL=index.mjs.map

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("lpqci", function(module, exports) {

$parcel$export(module.exports, "GoTrueAdminApi", () => (parcelRequire("f8esb")).default);
$parcel$export(module.exports, "GoTrueClient", () => (parcelRequire("b083j")).default);
$parcel$export(module.exports, "AuthAdminApi", () => (parcelRequire("fCilG")).default);
$parcel$export(module.exports, "AuthClient", () => (parcelRequire("aALRH")).default);
$parcel$export(module.exports, "navigatorLock", () => (parcelRequire("gn0EB")).navigatorLock);
$parcel$export(module.exports, "NavigatorLockAcquireTimeoutError", () => (parcelRequire("gn0EB")).NavigatorLockAcquireTimeoutError);
$parcel$export(module.exports, "lockInternals", () => (parcelRequire("gn0EB")).internals);
$parcel$export(module.exports, "processLock", () => (parcelRequire("gn0EB")).processLock);

var $f8esb = parcelRequire("f8esb");

var $b083j = parcelRequire("b083j");

var $fCilG = parcelRequire("fCilG");

var $aALRH = parcelRequire("aALRH");

var $39QCi = parcelRequire("39QCi");

var $fTIQY = parcelRequire("fTIQY");

var $gn0EB = parcelRequire("gn0EB");
$parcel$exportWildcard(module.exports, $39QCi);
$parcel$exportWildcard(module.exports, $fTIQY);

});
parcelRegister("f8esb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b042d08e69f8c3c9$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $39QCi = parcelRequire("39QCi");

var $fTIQY = parcelRequire("fTIQY");
class $b042d08e69f8c3c9$export$2e2bcd8739ae039 {
    /**
     * Creates an admin API client that can be used to manage users and OAuth clients.
     *
     * @example
     * ```ts
     * import { GoTrueAdminApi } from '@supabase/auth-js'
     *
     * const admin = new GoTrueAdminApi({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SERVICE_ROLE_KEY}` },
     * })
     * ```
     */ constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $98hXt.resolveFetch)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     *
     * @category Auth
     */ async signOut(jwt, scope = (0, $39QCi.SIGN_OUT_SCOPES)[0]) {
        if ((0, $39QCi.SIGN_OUT_SCOPES).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $39QCi.SIGN_OUT_SCOPES).join(', ')}`);
        try {
            await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     *
     * @category Auth
     *
     * @remarks
     * - Sends an invite link to the user's email address.
     * - The `inviteUserByEmail()` method is typically used by administrators to invite users to join the application.
     * - Note that PKCE is not supported when using `inviteUserByEmail`. This is because the browser initiating the invite is often different from the browser accepting the invite which makes it difficult to provide the security guarantees required of the PKCE flow.
     *
     * @example Invite a user
     * ```js
     * const { data, error } = await supabase.auth.admin.inviteUserByEmail('email@example.com')
     * ```
     *
     * @exampleResponse Invite a user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "invited_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     *
     * @category Auth
     *
     * @remarks
     * - The following types can be passed into `generateLink()`: `signup`, `magiclink`, `invite`, `recovery`, `email_change_current`, `email_change_new`, `phone_change`.
     * - `generateLink()` only generates the email link for `email_change_email` if the **Secure email change** is enabled in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     * - `generateLink()` handles the creation of the user for `signup`, `invite` and `magiclink`.
     *
     * @example Generate a signup link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   password: 'secret'
     * })
     * ```
     *
     * @exampleResponse Generate a signup link
     * ```json
     * {
     *   "data": {
     *     "properties": {
     *       "action_link": "<LINK_TO_SEND_TO_USER>",
     *       "email_otp": "999999",
     *       "hashed_token": "<HASHED_TOKEN",
     *       "redirect_to": "<REDIRECT_URL>",
     *       "verification_type": "signup"
     *     },
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "email@example.com",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "email@example.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Generate an invite link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'invite',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a magic link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'magiclink',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a recovery link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'recovery',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate links to change current email address
     * ```js
     * // generate an email change link to be sent to the current email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_current',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     *
     * // generate an email change link to be sent to the new email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_new',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     * ```
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = (0, $7WQrb.__rest)(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $doWUR._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - To confirm the user's email address or phone number, set `email_confirm` or `phone_confirm` to true. Both arguments default to false.
     * - `createUser()` will not send a confirmation email to the user. You can use [`inviteUserByEmail()`](/docs/reference/javascript/auth-admin-inviteuserbyemail) if you want to send them an email invite instead.
     * - If you are sure that the created user's email or phone number is legitimate and verified, you can set the `email_confirm` or `phone_confirm` param to `true`.
     *
     * @example With custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   password: 'password',
     *   user_metadata: { name: 'Yoda' }
     * })
     * ```
     *
     * @exampleResponse With custom user metadata
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     *
     * @example Auto-confirm the user's email
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   email_confirm: true
     * })
     * ```
     *
     * @example Auto-confirm the user's phone number
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   phone: '1234567890',
     *   phone_confirm: true
     * })
     * ```
     */ async createUser(attributes) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     *
     * @category Auth
     *
     * @remarks
     * - Defaults to return 50 users per page.
     *
     * @example Get a page of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Paginated list of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers({
     *   page: 1,
     *   perPage: 1000
     * })
     * ```
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - Fetches the user object from the database based on the user's id.
     * - The `getUserById()` method requires the user's id which maps to the `auth.users.id` column.
     *
     * @example Fetch the user object using the access_token jwt
     * ```js
     * const { data, error } = await supabase.auth.admin.getUserById(1)
     * ```
     *
     * @exampleResponse Fetch the user object using the access_token jwt
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     */ async getUserById(uid) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data. Changes are applied directly without confirmation flows.
     *
     * @param uid The user's unique identifier
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @remarks
     * **Important:** This is a server-side operation and does **not** trigger client-side
     * `onAuthStateChange` listeners. The admin API has no connection to client state.
     *
     * To sync changes to the client after calling this method:
     * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
     * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
     *
     * @example
     * ```typescript
     * // Server-side (Edge Function)
     * const { data, error } = await supabase.auth.admin.updateUserById(
     *   userId,
     *   { user_metadata: { preferences: { theme: 'dark' } } }
     * )
     *
     * // Client-side (to sync the changes)
     * const { data, error } = await supabase.auth.refreshSession()
     * // onAuthStateChange listeners will now be notified with updated user
     * ```
     *
     * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
     * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
     *
     * @category Auth
     *
     * @example Updates a user's email
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '11111111-1111-1111-1111-111111111111',
     *   { email: 'new@email.com' }
     * )
     * ```
     *
     * @exampleResponse Updates a user's email
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "new@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Updates a user's password
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { password: 'new_password' }
     * )
     * ```
     *
     * @example Updates a user's metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { user_metadata: { hello: 'world' } }
     * )
     * ```
     *
     * @example Updates a user's app_metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { app_metadata: { plan: 'trial' } }
     * )
     * ```
     *
     * @example Confirms a user's email address
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { email_confirm: true }
     * )
     * ```
     *
     * @example Confirms a user's phone number
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { phone_confirm: true }
     * )
     * ```
     *
     * @example Ban a user for 100 years
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { ban_duration: '876000h' }
     * )
     * ```
     */ async updateUserById(uid, attributes) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     *
     * @remarks
     * - The `deleteUser()` method requires the user's ID, which maps to the `auth.users.id` column.
     *
     * @example Removes a user
     * ```js
     * const { data, error } = await supabase.auth.admin.deleteUser(
     *   '715ed5db-f090-4b8c-a067-640ecee36aa0'
     * )
     * ```
     *
     * @exampleResponse Removes a user
     * ```json
     * {
     *   "data": {
     *     "user": {}
     *   },
     *   "error": null
     * }
     * ```
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $98hXt.validateUUID)(id);
        try {
            return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $98hXt.validateUUID)(params.userId);
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $98hXt.validateUUID)(params.userId);
        (0, $98hXt.validateUUID)(params.id);
        try {
            const data = await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all OAuth clients with optional pagination.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listOAuthClients(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createOAuthClient(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getOAuthClient(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateOAuthClient(clientId, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteOAuthClient(clientId) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Regenerates the secret for an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all custom providers with optional type filter.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listCustomProviders(params) {
        try {
            const query = {};
            if (params === null || params === void 0 ? void 0 : params.type) query.type = params.type;
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data)=>{
                    var _a;
                    return {
                        data: {
                            providers: (_a = data === null || data === void 0 ? void 0 : data.providers) !== null && _a !== void 0 ? _a : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new custom OIDC/OAuth provider.
     *
     * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
     * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
     * This may return a validation error (`error_code: "validation_failed"`) if the discovery
     * document is unreachable, not valid JSON, missing required fields, or if the issuer
     * in the document does not match the expected issuer.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createCustomProvider(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/custom-providers`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific custom provider by identifier.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getCustomProvider(identifier) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing custom provider.
     *
     * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
     * validates the discovery document before persisting. This may return a validation error
     * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
     * the issuer does not match.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateCustomProvider(identifier, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/custom-providers/${identifier}`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a custom provider.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteCustomProvider(identifier) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}

});
parcelRegister("doWUR", function(module, exports) {

$parcel$export(module.exports, "_request", () => $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd);
$parcel$export(module.exports, "_sessionResponse", () => $9c1b37c8edd4ca2b$export$273fe4673a018c2e);
$parcel$export(module.exports, "_sessionResponsePassword", () => $9c1b37c8edd4ca2b$export$db83aade1c2922c7);
$parcel$export(module.exports, "_userResponse", () => $9c1b37c8edd4ca2b$export$e20f488897843593);
$parcel$export(module.exports, "_ssoResponse", () => $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b);
$parcel$export(module.exports, "_generateLinkResponse", () => $9c1b37c8edd4ca2b$export$f5eaa950605b2146);
$parcel$export(module.exports, "_noResolveJsonResponse", () => $9c1b37c8edd4ca2b$export$7aed01df6e045e31);

var $7WQrb = parcelRequire("7WQrb");

var $44TzP = parcelRequire("44TzP");

var $98hXt = parcelRequire("98hXt");

var $fTIQY = parcelRequire("fTIQY");
const $9c1b37c8edd4ca2b$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $98hXt.looksLikeFetchResponse)(error)) throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), 0);
    if ($9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $fTIQY.AuthUnknownError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $98hXt.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $44TzP.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $fTIQY.AuthSessionMissingError)();
    throw new (0, $fTIQY.AuthApiError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $9c1b37c8edd4ca2b$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $44TzP.API_VERSION_HEADER_NAME]) headers[0, $44TzP.API_VERSION_HEADER_NAME] = (0, $44TzP.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $9c1b37c8edd4ca2b$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(e);
    }
}
function $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($9c1b37c8edd4ca2b$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $98hXt.expiresAt)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$db83aade1c2922c7(data) {
    const response = $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $9c1b37c8edd4ca2b$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = (0, $7WQrb.__rest)(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $9c1b37c8edd4ca2b$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}

});
parcelRegister("44TzP", function(module, exports) {

$parcel$export(module.exports, "AUTO_REFRESH_TICK_DURATION_MS", () => $2f82a590c21cea7a$export$a4558fee79d6c8ae);
$parcel$export(module.exports, "AUTO_REFRESH_TICK_THRESHOLD", () => $2f82a590c21cea7a$export$f20a97df8f5fe223);
$parcel$export(module.exports, "EXPIRY_MARGIN_MS", () => $2f82a590c21cea7a$export$a36ad0026e55ac00);
$parcel$export(module.exports, "GOTRUE_URL", () => $2f82a590c21cea7a$export$7fedf552187f0c3d);
$parcel$export(module.exports, "STORAGE_KEY", () => $2f82a590c21cea7a$export$86880b4b2e1a2384);
$parcel$export(module.exports, "DEFAULT_HEADERS", () => $2f82a590c21cea7a$export$88a84136db6a4b64);
$parcel$export(module.exports, "API_VERSION_HEADER_NAME", () => $2f82a590c21cea7a$export$e4f5507f88977535);
$parcel$export(module.exports, "API_VERSIONS", () => $2f82a590c21cea7a$export$1f9a66038489bdeb);
$parcel$export(module.exports, "BASE64URL_REGEX", () => $2f82a590c21cea7a$export$7a68c9e70b9d3911);
$parcel$export(module.exports, "JWKS_TTL", () => $2f82a590c21cea7a$export$5bd768495200f133);

var $iIHZ2 = parcelRequire("iIHZ2");
const $2f82a590c21cea7a$export$a4558fee79d6c8ae = 30000;
const $2f82a590c21cea7a$export$f20a97df8f5fe223 = 3;
const $2f82a590c21cea7a$export$a36ad0026e55ac00 = $2f82a590c21cea7a$export$f20a97df8f5fe223 * $2f82a590c21cea7a$export$a4558fee79d6c8ae;
const $2f82a590c21cea7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $2f82a590c21cea7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $2f82a590c21cea7a$export$2f9161bad044dacb = '';
const $2f82a590c21cea7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $iIHZ2.version)}`
};
const $2f82a590c21cea7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $2f82a590c21cea7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $2f82a590c21cea7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $2f82a590c21cea7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $2f82a590c21cea7a$export$5bd768495200f133 = 600000; // 10 minutes

});
parcelRegister("iIHZ2", function(module, exports) {

$parcel$export(module.exports, "version", () => $da0e74438356dc28$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $da0e74438356dc28$export$83d89fbfd8236492 = '2.100.1';

});


parcelRegister("98hXt", function(module, exports) {

$parcel$export(module.exports, "expiresAt", () => $6a62ca85cf697dd5$export$e02d0a488392f690);
$parcel$export(module.exports, "generateCallbackId", () => $6a62ca85cf697dd5$export$16db4ce6a8dfc285);
$parcel$export(module.exports, "isBrowser", () => $6a62ca85cf697dd5$export$4e09c449d6c407f7);
$parcel$export(module.exports, "supportsLocalStorage", () => $6a62ca85cf697dd5$export$9ec034ee80211814);
$parcel$export(module.exports, "parseParametersFromURL", () => $6a62ca85cf697dd5$export$7a29392fb778224c);
$parcel$export(module.exports, "resolveFetch", () => $6a62ca85cf697dd5$export$98d92b1aa79f8cc7);
$parcel$export(module.exports, "looksLikeFetchResponse", () => $6a62ca85cf697dd5$export$e8ad6599be1036a7);
$parcel$export(module.exports, "setItemAsync", () => $6a62ca85cf697dd5$export$e82c36d29078a87f);
$parcel$export(module.exports, "getItemAsync", () => $6a62ca85cf697dd5$export$ba6fcb7c333d32c0);
$parcel$export(module.exports, "removeItemAsync", () => $6a62ca85cf697dd5$export$d35c645d585317ec);
$parcel$export(module.exports, "Deferred", () => $6a62ca85cf697dd5$export$85f6557964517f1a);
$parcel$export(module.exports, "decodeJWT", () => $6a62ca85cf697dd5$export$9a62e6c0a30e00bc);
$parcel$export(module.exports, "sleep", () => $6a62ca85cf697dd5$export$e772c8ff12451969);
$parcel$export(module.exports, "retryable", () => $6a62ca85cf697dd5$export$9e1b8e833f44ff21);
$parcel$export(module.exports, "getCodeChallengeAndMethod", () => $6a62ca85cf697dd5$export$81b177cadfcf873c);
$parcel$export(module.exports, "parseResponseAPIVersion", () => $6a62ca85cf697dd5$export$5f69ecf1c14d56fd);
$parcel$export(module.exports, "validateExp", () => $6a62ca85cf697dd5$export$a5850868adeb9253);
$parcel$export(module.exports, "getAlgorithm", () => $6a62ca85cf697dd5$export$fa59f625ab60cb91);
$parcel$export(module.exports, "validateUUID", () => $6a62ca85cf697dd5$export$a4c72ae47296db0c);
$parcel$export(module.exports, "userNotAvailableProxy", () => $6a62ca85cf697dd5$export$52c7f0d8a78626b);
$parcel$export(module.exports, "insecureUserWarningProxy", () => $6a62ca85cf697dd5$export$28f3a5de6111309a);
$parcel$export(module.exports, "deepClone", () => $6a62ca85cf697dd5$export$b7d58db314e0ac27);

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $iSR6L = parcelRequire("iSR6L");
function $6a62ca85cf697dd5$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6a62ca85cf697dd5$export$16db4ce6a8dfc285() {
    return Symbol('auth-callback');
}
const $6a62ca85cf697dd5$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6a62ca85cf697dd5$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6a62ca85cf697dd5$export$9ec034ee80211814 = ()=>{
    if (!$6a62ca85cf697dd5$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6a62ca85cf697dd5$var$localStorageWriteTests.tested) return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = false;
    }
    return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
};
function $6a62ca85cf697dd5$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const $6a62ca85cf697dd5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $6a62ca85cf697dd5$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6a62ca85cf697dd5$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6a62ca85cf697dd5$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $6a62ca85cf697dd5$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6a62ca85cf697dd5$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor = Promise;
function $6a62ca85cf697dd5$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $44TzP.BASE64URL_REGEX).test(parts[i])) throw new (0, $fTIQY.AuthInvalidJwtError)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[0])),
        payload: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[1])),
        signature: (0, $iSR6L.base64UrlToUint8Array)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6a62ca85cf697dd5$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6a62ca85cf697dd5$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6a62ca85cf697dd5$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6a62ca85cf697dd5$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6a62ca85cf697dd5$var$dec2hex).join('');
}
async function $6a62ca85cf697dd5$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6a62ca85cf697dd5$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6a62ca85cf697dd5$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $6a62ca85cf697dd5$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $6a62ca85cf697dd5$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $6a62ca85cf697dd5$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $6a62ca85cf697dd5$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6a62ca85cf697dd5$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6a62ca85cf697dd5$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $44TzP.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match($6a62ca85cf697dd5$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $6a62ca85cf697dd5$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6a62ca85cf697dd5$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $6a62ca85cf697dd5$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $6a62ca85cf697dd5$export$a4c72ae47296db0c(str) {
    if (!$6a62ca85cf697dd5$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $6a62ca85cf697dd5$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $6a62ca85cf697dd5$export$28f3a5de6111309a(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            // Allow internal checks without warning
            if (prop === '__isInsecureUserWarningProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)' || sProp === 'Symbol(nodejs.util.inspect.custom)') // Return the actual value for these symbols to allow proper inspection
                return Reflect.get(target, prop, receiver);
            }
            // Emit warning on first property access
            if (!suppressWarningRef.value && typeof prop === 'string') {
                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $6a62ca85cf697dd5$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}

});
parcelRegister("fTIQY", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $b92ec9013174409a$export$145273558d58e0ac);
$parcel$export(module.exports, "isAuthError", () => $b92ec9013174409a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "AuthApiError", () => $b92ec9013174409a$export$45fde0b55b14f37b);
$parcel$export(module.exports, "isAuthApiError", () => $b92ec9013174409a$export$4fe744aeb810d543);
$parcel$export(module.exports, "AuthUnknownError", () => $b92ec9013174409a$export$f7559805d4a50078);
$parcel$export(module.exports, "CustomAuthError", () => $b92ec9013174409a$export$823c745ae0673c5e);
$parcel$export(module.exports, "AuthSessionMissingError", () => $b92ec9013174409a$export$403b3fc0d3ad5f0c);
$parcel$export(module.exports, "isAuthSessionMissingError", () => $b92ec9013174409a$export$3e849aa4db565c1d);
$parcel$export(module.exports, "AuthInvalidTokenResponseError", () => $b92ec9013174409a$export$7e277b620449c1b4);
$parcel$export(module.exports, "AuthInvalidCredentialsError", () => $b92ec9013174409a$export$9ef583f0381b4cc);
$parcel$export(module.exports, "AuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$bf5df8e043856ef5);
$parcel$export(module.exports, "isAuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$45edea3999507afd);
$parcel$export(module.exports, "AuthPKCEGrantCodeExchangeError", () => $b92ec9013174409a$export$39583657eb2a7027);
$parcel$export(module.exports, "AuthPKCECodeVerifierMissingError", () => $b92ec9013174409a$export$11e8e15400b7b336);
$parcel$export(module.exports, "isAuthPKCECodeVerifierMissingError", () => $b92ec9013174409a$export$398e1f2bb2c7a92);
$parcel$export(module.exports, "AuthRetryableFetchError", () => $b92ec9013174409a$export$2423b763f68be1b4);
$parcel$export(module.exports, "isAuthRetryableFetchError", () => $b92ec9013174409a$export$a77af358da5fb874);
$parcel$export(module.exports, "AuthWeakPasswordError", () => $b92ec9013174409a$export$b034076aa04913a6);
$parcel$export(module.exports, "isAuthWeakPasswordError", () => $b92ec9013174409a$export$dac36143fd8a46ef);
$parcel$export(module.exports, "AuthInvalidJwtError", () => $b92ec9013174409a$export$d04cb18528f2043e);
/**
 * Base error thrown by Supabase Auth helpers.
 *
 * @example
 * ```ts
 * import { AuthError } from '@supabase/auth-js'
 *
 * throw new AuthError('Unexpected auth error', 500, 'unexpected')
 * ```
 */ class $b92ec9013174409a$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $b92ec9013174409a$export$45fde0b55b14f37b extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$4fe744aeb810d543(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $b92ec9013174409a$export$f7559805d4a50078 extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $b92ec9013174409a$export$823c745ae0673c5e extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $b92ec9013174409a$export$403b3fc0d3ad5f0c extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $b92ec9013174409a$export$3e849aa4db565c1d(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $b92ec9013174409a$export$7e277b620449c1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $b92ec9013174409a$export$9ef583f0381b4cc extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $b92ec9013174409a$export$bf5df8e043856ef5 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $b92ec9013174409a$export$45edea3999507afd(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $b92ec9013174409a$export$39583657eb2a7027 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $b92ec9013174409a$export$11e8e15400b7b336 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", 'AuthPKCECodeVerifierMissingError', 400, 'pkce_code_verifier_not_found');
    }
}
function $b92ec9013174409a$export$398e1f2bb2c7a92(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthPKCECodeVerifierMissingError';
}
class $b92ec9013174409a$export$2423b763f68be1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $b92ec9013174409a$export$a77af358da5fb874(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $b92ec9013174409a$export$b034076aa04913a6 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $b92ec9013174409a$export$dac36143fd8a46ef(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $b92ec9013174409a$export$d04cb18528f2043e extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}

});

parcelRegister("iSR6L", function(module, exports) {

$parcel$export(module.exports, "stringFromBase64URL", () => $dbf67752838ebc66$export$bd5d476f823ea024);
$parcel$export(module.exports, "base64UrlToUint8Array", () => $dbf67752838ebc66$export$9cae2cd6076b8fb6);
$parcel$export(module.exports, "stringToUint8Array", () => $dbf67752838ebc66$export$a098e7b533f96db3);
$parcel$export(module.exports, "bytesToBase64URL", () => $dbf67752838ebc66$export$3f156efe462a835e);
/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $dbf67752838ebc66$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $dbf67752838ebc66$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $dbf67752838ebc66$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $dbf67752838ebc66$var$IGNORE_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $dbf67752838ebc66$var$TO_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $dbf67752838ebc66$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $dbf67752838ebc66$export$403e86c86002a137(charCode, state, emit) {
    const bits = $dbf67752838ebc66$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $dbf67752838ebc66$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>{
        $dbf67752838ebc66$export$744f452403189a3e(byte, state, emitter);
    });
    $dbf67752838ebc66$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $dbf67752838ebc66$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $dbf67752838ebc66$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $dbf67752838ebc66$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit);
    }
}
function $dbf67752838ebc66$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $dbf67752838ebc66$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$a098e7b533f96db3(str) {
    const result = [];
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$dbf67752838ebc66$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $dbf67752838ebc66$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}

});



parcelRegister("39QCi", function(module, exports) {

$parcel$export(module.exports, "SIGN_OUT_SCOPES", () => $24cb06f66874b0a4$export$9a0f1d0c97ce73ca);
const $24cb06f66874b0a4$var$WeakPasswordReasons = [
    'length',
    'characters',
    'pwned'
];
const $24cb06f66874b0a4$var$AMRMethods = [
    'password',
    'otp',
    'oauth',
    'totp',
    'mfa/totp',
    'mfa/phone',
    'mfa/webauthn',
    'anonymous',
    'sso/saml',
    'magiclink',
    'web3',
    'oauth_provider/authorization_code'
];
const $24cb06f66874b0a4$var$FactorTypes = [
    'totp',
    'phone',
    'webauthn'
];
const $24cb06f66874b0a4$var$FactorVerificationStatuses = [
    'verified',
    'unverified'
];
const $24cb06f66874b0a4$var$MFATOTPChannels = [
    'sms',
    'whatsapp'
];
const $24cb06f66874b0a4$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];

});


parcelRegister("b083j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8025f0dcbc879582$export$2e2bcd8739ae039);

var $f8esb = parcelRequire("f8esb");

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $a7BAw = parcelRequire("a7BAw");

var $gn0EB = parcelRequire("gn0EB");

var $8WDEC = parcelRequire("8WDEC");

var $iIHZ2 = parcelRequire("iIHZ2");

var $iSR6L = parcelRequire("iSR6L");

var $baxuF = parcelRequire("baxuF");

var $2GmzD = parcelRequire("2GmzD");
(0, $8WDEC.polyfillGlobalThis)(); // Make "globalThis" available
const $8025f0dcbc879582$var$DEFAULT_OPTIONS = {
    url: (0, $44TzP.GOTRUE_URL),
    storageKey: (0, $44TzP.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $44TzP.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5000,
    skipAutoInitialize: false
};
async function $8025f0dcbc879582$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $8025f0dcbc879582$var$GLOBAL_JWKS = {};
class $8025f0dcbc879582$var$GoTrueClient {
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    /**
     * Create a new client for use in the browser.
     *
     * @example
     * ```ts
     * import { GoTrueClient } from '@supabase/auth-js'
     *
     * const auth = new GoTrueClient({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { apikey: 'public-anon-key' },
     *   storageKey: 'supabase-auth',
     * })
     * ```
     */ constructor(options){
        var _a, _b, _c;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the auth state is known and it's safe to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $8025f0dcbc879582$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a = $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a !== void 0 ? _a : 0;
        $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        if (this.instanceID > 0 && (0, $98hXt.isBrowser)()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $f8esb.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $98hXt.resolveFetch)(settings.fetch);
        this.lock = settings.lock || $8025f0dcbc879582$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        if (settings.lock) this.lock = settings.lock;
        else if (this.persistSession && (0, $98hXt.isBrowser)() && ((_b = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _b === void 0 ? void 0 : _b.locks)) this.lock = (0, $gn0EB.navigatorLock);
        else this.lock = $8025f0dcbc879582$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new (0, $2GmzD.WebAuthnApi)(this)
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $98hXt.supportsLocalStorage)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, $98hXt.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_c = this.broadcastChannel) === null || _c === void 0 || _c.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
                } catch (error) {
                    this._debug('#broadcastChannel', 'error', error);
                }
            });
        }
        // Only auto-initialize if not explicitly disabled. Skipped in SSR contexts
        // where initialization timing must be controlled. All public methods have
        // lazy initialization, so the client remains fully functional.
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug('#initialize()', 'error', error);
        });
    }
    /**
     * Returns whether error throwing mode is enabled for this client.
     */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
     * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
     * and the provided result contains a non-nullish error, the error is thrown instead of
     * being returned. This ensures consistent behavior across all public API methods.
     */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return 'GoTrueClient@' + `${this.storageKey}:${this.instanceID} (${0, $iIHZ2.version}) ${new Date().toISOString()}`;
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     *
     * @category Auth
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            let params = {};
            let callbackUrlType = 'none';
            if ((0, $98hXt.isBrowser)()) {
                params = (0, $98hXt.parseParametersFromURL)(window.location.href);
                if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
                else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            }
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $98hXt.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $fTIQY.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // Don't remove existing session on URL login failure.
                    // A failed attempt (e.g. reused magic link) shouldn't invalidate a valid session.
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error during initialization', error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     *
     * @category Auth
     *
     * @remarks
     * - Returns an anonymous user
     * - It is recommended to set up captcha for anonymous sign-ins to prevent abuse. You can pass in the captcha token in the `options` param.
     *
     * @example Create an anonymous user
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     captchaToken
     *   }
     * });
     * ```
     *
     * @exampleResponse Create an anonymous user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {},
     *       "user_metadata": {},
     *       "identities": [],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": true
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {},
     *         "user_metadata": {},
     *         "identities": [],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": true
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Create an anonymous user with custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     data
     *   }
     * })
     * ```
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error || !data) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     *
     * @category Auth
     *
     * @remarks
     * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
     * - **Confirm email** determines if users need to confirm their email address after signing up.
     *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
     *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
     * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
     * - If signUp() is called for an existing confirmed user:
     *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
     *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
     * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
     *
     * @example Sign up with an email and password
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign up with an email and password
     * ```json
     * // Some fields may be null if "confirm email" is enabled.
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign up with a phone number and password (SMS)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'sms'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign up with a phone number and password (whatsapp)
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign up with a phone number and password (whatsapp)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'whatsapp'
     *   }
     * })
     * ```
     *
     * @example Sign up with additional user metadata
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       data: {
     *         first_name: 'John',
     *         age: 27,
     *       }
     *     }
     *   }
     * )
     * ```
     *
     * @exampleDescription Sign up with a redirect URL
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign up with a redirect URL
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       emailRedirectTo: 'https://example.com/welcome'
     *     }
     *   }
     * )
     * ```
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email and password or a phone number and password.
     *
     * @example Sign in with email and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign in with email and password
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign in with phone and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   phone: '+13334445555',
     *   password: 'some-password',
     * })
     * ```
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used for signing in using [Social Login (OAuth) providers](/docs/guides/auth#configure-third-party-providers).
     * - It works by redirecting your application to the provider's authorization screen, before bringing back the user to your app.
     *
     * @example Sign in using a third-party provider
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Sign in using a third-party provider
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     *
     * @exampleDescription Sign in using a third-party provider with redirect
     * - When the OAuth provider successfully authenticates the user, they are redirected to the URL specified in the `redirectTo` parameter. This parameter defaults to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls). It does not redirect the user immediately after invoking this method.
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign in using a third-party provider with redirect
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     redirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign in with scopes and access provider tokens
     * If you need additional access from an OAuth provider, in order to access provider specific APIs in the name of the user, you can do this by passing in the scopes the user should authorize for your application. Note that the `scopes` option takes in **a space-separated list** of scopes.
     *
     * Because OAuth sign-in often includes redirects, you should register an `onAuthStateChange` callback immediately after you create the Supabase client. This callback will listen for the presence of `provider_token` and `provider_refresh_token` properties on the `session` object and store them in local storage. The client library will emit these values **only once** immediately after the user signs in. You can then access them by looking them up in local storage, or send them to your backend servers for further processing.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Sign in with scopes and access provider tokens
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     *
     * // Call this on your Sign in with GitHub button to initiate OAuth
     * // with GitHub with the requested elevated scopes.
     * await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     scopes: 'repo gist notifications'
     *   }
     * })
     * ```
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - Used when `flowType` is set to `pkce` in client options.
     *
     * @example Exchange Auth Code
     * ```js
     * supabase.auth.exchangeCodeForSession('34e770dd-9ff9-416c-87fa-43b31d7ef225')
     * ```
     *
     * @exampleResponse Exchange Auth Code
     * ```json
     * {
     *   "data": {
     *     session: {
     *       access_token: '<ACCESS_TOKEN>',
     *       token_type: 'bearer',
     *       expires_in: 3600,
     *       expires_at: 1700000000,
     *       refresh_token: '<REFRESH_TOKEN>',
     *       user: {
     *         id: '11111111-1111-1111-1111-111111111111',
     *         aud: 'authenticated',
     *         role: 'authenticated',
     *         email: 'example@email.com'
     *         email_confirmed_at: '2024-01-01T00:00:00Z',
     *         phone: '',
     *         confirmation_sent_at: '2024-01-01T00:00:00Z',
     *         confirmed_at: '2024-01-01T00:00:00Z',
     *         last_sign_in_at: '2024-01-01T00:00:00Z',
     *         app_metadata: {
     *           "provider": "email",
     *           "providers": [
     *             "email",
     *             "<OTHER_PROVIDER>"
     *           ]
     *         },
     *         user_metadata: {
     *           email: 'email@email.com',
     *           email_verified: true,
     *           full_name: 'User Name',
     *           iss: '<ISS>',
     *           name: 'User Name',
     *           phone_verified: false,
     *           provider_id: '<PROVIDER_ID>',
     *           sub: '<SUB>'
     *         },
     *         identities: [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "email@example.com"
     *           },
     *           {
     *             "identity_id": "33333333-3333-3333-3333-333333333333",
     *             "id": "<ID>",
     *             "user_id": "<USER_ID>",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": true,
     *               "full_name": "User Name",
     *               "iss": "<ISS>",
     *               "name": "User Name",
     *               "phone_verified": false,
     *               "provider_id": "<PROVIDER_ID>",
     *               "sub": "<SUB>"
     *             },
     *             "provider": "<PROVIDER>",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         created_at: '2024-01-01T00:00:00Z',
     *         updated_at: '2024-01-01T00:00:00Z',
     *         is_anonymous: false
     *       },
     *       provider_token: '<PROVIDER_TOKEN>',
     *       provider_refresh_token: '<PROVIDER_REFRESH_TOKEN>'
     *     },
     *     user: {
     *       id: '11111111-1111-1111-1111-111111111111',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {
     *         provider: 'email',
     *         providers: [
     *           "email",
     *           "<OTHER_PROVIDER>"
     *         ]
     *       },
     *       user_metadata: {
     *         email: 'email@email.com',
     *         email_verified: true,
     *         full_name: 'User Name',
     *         iss: '<ISS>',
     *         name: 'User Name',
     *         phone_verified: false,
     *         provider_id: '<PROVIDER_ID>',
     *         sub: '<SUB>'
     *       },
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *         {
     *           "identity_id": "33333333-3333-3333-3333-333333333333",
     *           "id": "<ID>",
     *           "user_id": "<USER_ID>",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "full_name": "User Name",
     *             "iss": "<ISS>",
     *             "name": "User Name",
     *             "phone_verified": false,
     *             "provider_id": "<PROVIDER_ID>",
     *             "sub": "<SUB>"
     *           },
     *           "provider": "<PROVIDER>",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false
     *     },
     *     redirectType: null
     *   },
     *   "error": null
     * }
     * ```
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
     * both of which derive from the EIP-4361 standard
     * With slight variation on Solana's side.
     * @reference https://eips.ethereum.org/EIPS/eip-4361
     *
     * @category Auth
     *
     * @remarks
     * - Uses a Web3 (Ethereum, Solana) wallet to sign a user in.
     * - Read up on the [potential for abuse](/docs/guides/auth/auth-web3#potential-for-abuse) before using it.
     *
     * @example Sign in with Solana or Ethereum (Window API)
     * ```js
     *   // uses window.ethereum for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     *
     *   // uses window.solana for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     * ```
     *
     * @example Sign in with Ethereum (Message and Signature)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     message: '<sign in with ethereum message>',
     *     signature: '<hex of the ethereum signature over the message>',
     *   })
     * ```
     *
     * @example Sign in with Solana (Brave)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos',
     *     wallet: window.braveSolana
     *   })
     * ```
     *
     * @example Sign in with Solana (Wallet Adapter)
     * ```jsx
     *   function SignInButton() {
     *   const wallet = useWallet()
     *
     *   return (
     *     <>
     *       {wallet.connected ? (
     *         <button
     *           onClick={() => {
     *             supabase.auth.signInWithWeb3({
     *               chain: 'solana',
     *               statement: 'I accept the Terms of Service at https://example.com/tos',
     *               wallet,
     *             })
     *           }}
     *         >
     *           Sign in with Solana
     *         </button>
     *       ) : (
     *         <WalletMultiButton />
     *       )}
     *     </>
     *   )
     * }
     *
     * function App() {
     *   const endpoint = clusterApiUrl('devnet')
     *   const wallets = useMemo(() => [], [])
     *
     *   return (
     *     <ConnectionProvider endpoint={endpoint}>
     *       <WalletProvider wallets={wallets}>
     *         <WalletModalProvider>
     *           <SignInButton />
     *         </WalletModalProvider>
     *       </WalletProvider>
     *     </ConnectionProvider>
     *   )
     * }
     * ```
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case 'ethereum':
                return await this.signInWithEthereum(credentials);
            case 'solana':
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // TODO: flatten type
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('ethereum' in windowAny && typeof windowAny.ethereum === 'object' && 'request' in windowAny.ethereum && typeof windowAny.ethereum.request === 'function') resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            const accounts = await resolvedWallet.request({
                method: 'eth_requestAccounts'
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = (0, $baxuF.getAddress)(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: 'eth_chainId'
                });
                chainId = (0, $baxuF.fromHex)(chainIdHex);
            }
            const siweMessage = {
                domain: url.host,
                address: address,
                statement: statement,
                uri: url.href,
                version: '1',
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_e = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _e !== void 0 ? _e : new Date(),
                expirationTime: (_f = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _f === void 0 ? void 0 : _f.expirationTime,
                notBefore: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.notBefore,
                requestId: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.requestId,
                resources: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.resources
            };
            message = (0, $baxuF.createSiweMessage)(siweMessage);
            // Sign message
            signature = await resolvedWallet.request({
                method: 'personal_sign',
                params: [
                    (0, $baxuF.toHex)(message),
                    address
                ]
            });
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'ethereum',
                    message: message,
                    signature: signature
                }, ((_k = credentials.options) === null || _k === void 0 ? void 0 : _k.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $iSR6L.bytesToBase64URL)(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            if (!codeVerifier && this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCECodeVerifierMissingError)();
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $doWUR._sessionResponse)
            });
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     *
     * @category Auth
     *
     * @remarks
     * - Use an ID token to sign in.
     * - Especially useful when implementing sign in using native platform dialogs in mobile or desktop apps using Sign in with Apple or Sign in with Google on iOS and Android.
     * - You can also use Google's [One Tap](https://developers.google.com/identity/gsi/web/guides/display-google-one-tap) and [Automatic sign-in](https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out) via this API.
     *
     * @example Sign In using ID Token
     * ```js
     * const { data, error } = await supabase.auth.signInWithIdToken({
     *   provider: 'google',
     *   token: 'your-id-token'
     * })
     * ```
     *
     * @exampleResponse Sign In using ID Token
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         ...
     *       },
     *       "user_metadata": {
     *         ...
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "provider": "google",
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           ...
     *         },
     *         "user_metadata": {
     *           ...
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "provider": "google",
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email or phone number.
     * - This method is used for passwordless sign-ins where a OTP is sent to the user's email or phone number.
     * - If the user doesn't exist, `signInWithOtp()` will signup the user instead. To restrict this behavior, you can set `shouldCreateUser` in `SignInWithPasswordlessCredentials.options` to `false`.
     * - If you're using an email, you can configure whether you want the user to receive a magiclink or a OTP.
     * - If you're using phone, you can configure whether you want the user to receive a OTP.
     * - The magic link's destination URL is determined by the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls).
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - Magic links and OTPs share the same implementation. To send users a one-time code instead of a magic link, [modify the magic link email template](/dashboard/project/_/auth/templates) to include `{{ .Token }}` instead of `{{ .ConfirmationURL }}`.
     * - See our [Twilio Phone Auth Guide](/docs/guides/auth/phone-login?showSMSProvider=Twilio) for details about configuring WhatsApp sign in.
     *
     * @exampleDescription Sign in with email
     * The user will be sent an email which contains either a magiclink or a OTP or both. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with email
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   email: 'example@email.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleResponse Sign in with email
     * ```json
     * {
     *   "data": {
     *     "user": null,
     *     "session": null
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Sign in with SMS OTP
     * The user will be sent a SMS which contains a OTP. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with SMS OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     * })
     * ```
     *
     * @exampleDescription Sign in with WhatsApp OTP
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign in with WhatsApp OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     *   options: {
     *     channel:'whatsapp',
     *   }
     * })
     * ```
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     *
     * @category Auth
     *
     * @remarks
     * - The `verifyOtp` method takes in different verification types.
     * - If a phone number is used, the type can either be:
     *   1. `sms` – Used when verifying a one-time password (OTP) sent via SMS during sign-up or sign-in.
     *   2. `phone_change` – Used when verifying an OTP sent to a new phone number during a phone number update process.
     * - If an email address is used, the type can be one of the following (note: `signup` and `magiclink` types are deprecated):
     *   1. `email` – Used when verifying an OTP sent to the user's email during sign-up or sign-in.
     *   2. `recovery` – Used when verifying an OTP sent for account recovery, typically after a password reset request.
     *   3. `invite` – Used when verifying an OTP sent as part of an invitation to join a project or organization.
     *   4. `email_change` – Used when verifying an OTP sent to a new email address during an email update process.
     * - The verification type used should be determined based on the corresponding auth method called before `verifyOtp` to sign up / sign-in a user.
     * - The `TokenHash` is contained in the [email templates](/docs/guides/auth/auth-email-templates) and can be used to sign in.  You may wish to use the hash for the PKCE flow for Server Side Auth. Read [the Password-based Auth guide](/docs/guides/auth/passwords) for more details.
     *
     * @example Verify Signup One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email'})
     * ```
     *
     * @exampleResponse Verify Signup One-Time Password (OTP)
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "recovery_sent_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Verify SMS One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ phone, token, type: 'sms'})
     * ```
     *
     * @example Verify Email Auth (Token Hash)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: 'email'})
     * ```
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data) {
                const tokenVerificationError = new Error('An error occurred on token verification.');
                throw tokenVerificationError;
            }
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     *
     * @category Auth
     *
     * @remarks
     * - Before you can call this method you need to [establish a connection](/docs/guides/auth/sso/auth-sso-saml#managing-saml-20-connections) to an identity provider. Use the [CLI commands](/docs/reference/cli/supabase-sso) to do this.
     * - If you've associated an email domain to the identity provider, you can use the `domain` property to start a sign-in flow.
     * - In case you need to use a different way to start the authentication flow with an identity provider, you can use the `providerId` property. For example:
     *     - Mapping specific user email addresses with an identity provider.
     *     - Using different hints to identity the identity provider to be used by the user, like a company-specific page, IP address or other tracking information.
     *
     * @example Sign in with email domain
     * ```js
     *   // You can extract the user's email domain and use it to trigger the
     *   // authentication flow with the correct identity provider.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     domain: 'company.com'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     *
     * @example Sign in with provider UUID
     * ```js
     *   // Useful when you need to map a user's sign in request according
     *   // to different rules that can't use email domains.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     providerId: '21648a9d-8d5a-4555-a9d1-d6375dc14e92'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     */ async signInWithSSO(params) {
        var _a, _b, _c, _d, _e;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const result = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $doWUR._ssoResponse)
            });
            // Automatically redirect in browser unless skipBrowserRedirect is true
            if (((_d = result.data) === null || _d === void 0 ? void 0 : _d.url) && (0, $98hXt.isBrowser)() && !((_e = params.options) === null || _e === void 0 ? void 0 : _e.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used together with `updateUser()` when a user's password needs to be updated.
     * - If you require your user to reauthenticate before updating their password, you need to enable the **Secure password change** option in your [project's email provider settings](/dashboard/project/_/auth/providers).
     * - A user is only require to reauthenticate before updating their password if **Secure password change** is enabled and the user **hasn't recently signed in**. A user is deemed recently signed in if the session was created in the last 24 hours.
     * - This method will send a nonce to the user's email. If the user doesn't have a confirmed email address, the method will send the nonce to the user's confirmed phone number instead.
     * - After receiving the OTP, include it as the `nonce` in your `updateUser()` call to finalize the password change.
     *
     * @exampleDescription Send reauthentication nonce
     * Sends a reauthentication nonce to the user's email or phone number.
     *
     * @example Send reauthentication nonce
     * ```js
     * const { error } = await supabase.auth.reauthenticate()
     * ```
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     *
     * @category Auth
     *
     * @remarks
     * - Resends a signup confirmation, email change or phone change email to the user.
     * - Passwordless sign-ins can be resent by calling the `signInWithOtp()` method again.
     * - Password recovery emails can be resent by calling the `resetPasswordForEmail()` method again.
     * - This method will only resend an email or phone OTP to the user if there was an initial signup, email change or phone change request being made(note: For existing users signing in with OTP, you should use `signInWithOtp()` again to resend the OTP).
     * - You can specify a redirect url when you resend an email link using the `emailRedirectTo` option.
     *
     * @exampleDescription Resend an email signup confirmation
     * Resends the email signup confirmation to the user
     *
     * @example Resend an email signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Resend a phone signup confirmation
     * Resends the phone signup confirmation email to the user
     *
     * @example Resend a phone signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'sms',
     *   phone: '1234567890'
     * })
     * ```
     *
     * @exampleDescription Resend email change email
     * Resends the email change email to the user
     *
     * @example Resend email change email
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'email_change',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @exampleDescription Resend phone change OTP
     * Resends the phone change OTP to the user
     *
     * @example Resend phone change OTP
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'phone_change',
     *   phone: '1234567890'
     * })
     * ```
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     *
     * @category Auth
     *
     * @remarks
     * - Since the introduction of [asymmetric JWT signing keys](/docs/guides/auth/signing-keys), this method is considered low-level and we encourage you to use `getClaims()` or `getUser()` instead.
     * - Retrieves the current [user session](/docs/guides/auth/sessions) from the storage medium (local storage, cookies).
     * - The session contains an access token (signed JWT), a refresh token and the user object.
     * - If the session's access token is expired or is about to expire, this method will use the refresh token to refresh the session.
     * - When using in a browser, or you've called `startAutoRefresh()` in your environment (React Native, etc.) this function always returns a valid access token without refreshing the session itself, as this is done in the background. This function returns very fast.
     * - **IMPORTANT SECURITY NOTICE:** If using an insecure storage medium, such as cookies or request headers, the user object returned by this function **must not be trusted**. Always verify the JWT using `getClaims()` or your own JWT verification library to securely establish the user's identity and access. You can also use `getUser()` to fetch the user object directly from the Auth server for this purpose.
     * - When using in a browser, this function is synchronized across all tabs using the [LockManager](https://developer.mozilla.org/en-US/docs/Web/API/LockManager) API. In other environments make sure you've defined a proper `lock` property, if necessary, to make sure there are no race conditions while the session is being refreshed.
     *
     * @example Get the session data
     * ```js
     * const { data, error } = await supabase.auth.getSession()
     * ```
     *
     * @exampleResponse Get the session data
     * ```json
     * {
     *   "data": {
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
                // Wrap the user object with a warning proxy on the server
                // This warns when properties of the user are accessed, not when session.user itself is accessed
                if (this.storage.isServer && currentSession.user && !currentSession.user.__isUserNotAvailableProxy) {
                    const suppressWarningRef = {
                        value: this.suppressGetSessionWarning
                    };
                    currentSession.user = (0, $98hXt.insecureUserWarningProxy)(currentSession.user, suppressWarningRef);
                    // Update the client-level suppression flag when the proxy suppresses the warning
                    if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return this._returnResult({
                data: {
                    session: null
                },
                error: error
            });
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     *
     * @category Auth
     *
     * @remarks
     * - This method fetches the user object from the database instead of local session.
     * - This method is useful for checking if the user is authorized because it validates the user's access token JWT on the server.
     * - Should always be used when checking for user authorization on the server. On the client, you can instead use `getSession().session.user` for faster results. `getSession` is insecure on the server.
     *
     * @example Get the logged in user with the current existing session
     * ```js
     * const { data: { user } } = await supabase.auth.getUser()
     * ```
     *
     * @exampleResponse Get the logged in user with the current existing session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Get the logged in user with a custom access token jwt
     * ```js
     * const { data: { user } } = await supabase.auth.getUser(jwt)
     * ```
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $doWUR._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                };
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $doWUR._userResponse)
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) {
                if ((0, $fTIQY.isAuthSessionMissingError)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `updateUser()` method, the user needs to be signed in first.
     * - By default, email updates sends a confirmation link to both the user's current and new email.
     * To only send a confirmation link to the user's new email, disable **Secure email change** in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     *
     * @exampleDescription Update the email for an authenticated user
     * Sends a "Confirm Email Change" email to the new address. If **Secure Email Change** is enabled (default), confirmation is also required from the **old email** before the change is applied. To skip dual confirmation and apply the change after only the new email is verified, disable **Secure Email Change** in the [Email Auth Provider settings](/dashboard/project/_/auth/providers?provider=Email).
     *
     * @example Update the email for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   email: 'new@email.com'
     * })
     * ```
     *
     * @exampleResponse Update the email for an authenticated user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "new_email": "new@email.com",
     *       "email_change_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Update the phone number for an authenticated user
     * Sends a one-time password (OTP) to the new phone number.
     *
     * @example Update the phone number for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   phone: '123456789'
     * })
     * ```
     *
     * @example Update the password for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password'
     * })
     * ```
     *
     * @exampleDescription Update the user's metadata
     * Updates the user's custom metadata.
     *
     * **Note**: The `data` field maps to the `auth.users.raw_user_meta_data` column in your Supabase database. When calling `getUser()`, the data will be available as `user.user_metadata`.
     *
     * @example Update the user's metadata
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   data: { hello: 'world' }
     * })
     * ```
     *
     * @exampleDescription Update the user's password with a nonce
     * If **Secure password change** is enabled in your [project's email provider settings](/dashboard/project/_/auth/providers), updating the user's password would require a nonce if the user **hasn't recently signed in**. The nonce is sent to the user's email or phone number. A user is deemed recently signed in if the session was created in the last 24 hours.
     *
     * @example Update the user's password with a nonce
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password',
     *   nonce: '123456'
     * })
     * ```
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $doWUR._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method sets the session using an `access_token` and `refresh_token`.
     * - If successful, a `SIGNED_IN` event is emitted.
     *
     * @exampleDescription Set the session
     * Sets the session data from an access_token and refresh_token, then returns an auth response or error.
     *
     * @example Set the session
     * ```js
     *   const { data, error } = await supabase.auth.setSession({
     *     access_token,
     *     refresh_token
     *   })
     * ```
     *
     * @exampleResponse Set the session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "11111111-1111-1111-1111-111111111111",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "2024-01-01T00:00:00Z",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       },
     *       "token_type": "bearer",
     *       "expires_in": 3500,
     *       "expires_at": 1700000000
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $fTIQY.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $98hXt.decodeJWT)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method will refresh and return a new session whether the current one is expired or not.
     *
     * @example Refresh session using the current session
     * ```js
     * const { data, error } = await supabase.auth.refreshSession()
     * const { session, user } = data
     * ```
     *
     * @exampleResponse Refresh session using the current session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Refresh session using a refresh token
     * ```js
     * const { data, error } = await supabase.auth.refreshSession({ refresh_token })
     * const { session, user } = data
     * ```
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $98hXt.isBrowser)()) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $fTIQY.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     *
     * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
     * if the URL should be processed as a Supabase auth callback. This allows users to exclude
     * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
     */ _isImplicitGrantCallback(params) {
        if (typeof this.detectSessionInUrl === 'function') return this.detectSessionInUrl(new URL(window.location.href), params);
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `signOut()` method, the user needs to be signed in first.
     * - By default, `signOut()` uses the global scope, which signs out all other sessions that the user is logged into as well. Customize this behavior by passing a scope parameter.
     * - Since Supabase Auth uses JWTs for authentication, the access token JWT will be valid until it's expired. When the user signs out, Supabase revokes the refresh token and deletes the JWT from the client-side. This does not revoke the JWT and it will still be valid until it expires.
     *
     * @example Sign out (all sessions)
     * ```js
     * const { error } = await supabase.auth.signOut()
     * ```
     *
     * @example Sign out (current session)
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'local' })
     * ```
     *
     * @example Sign out (other sessions)
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'others' })
     * ```
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError && !(0, $fTIQY.isAuthSessionMissingError)(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $fTIQY.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403) || (0, $fTIQY.isAuthSessionMissingError)(error))) return this._returnResult({
                        error: error
                    });
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return this._returnResult({
                error: null
            });
        });
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - Subscribes to important events occurring on the user's session.
     * - Use on the frontend/client. It is less useful on the server.
     * - Events are emitted across tabs to keep your application's UI up-to-date. Some events can fire very frequently, based on the number of tabs open. Use a quick and efficient callback function, and defer or debounce as many operations as you can to be performed outside of the callback.
     * - **Important:** A callback can be an `async` function and it runs synchronously during the processing of the changes causing the event. You can easily create a dead-lock by using `await` on a call to another method of the Supabase library.
     *   - Avoid using `async` functions as callbacks.
     *   - Limit the number of `await` calls in `async` callbacks.
     *   - Do not use other Supabase functions in the callback function. If you must, dispatch the functions once the callback has finished executing. Use this as a quick way to achieve this:
     *     ```js
     *     supabase.auth.onAuthStateChange((event, session) => {
     *       setTimeout(async () => {
     *         // await on other Supabase function here
     *         // this runs right after the callback has finished
     *       }, 0)
     *     })
     *     ```
     * - Emitted events:
     *   - `INITIAL_SESSION`
     *     - Emitted right after the Supabase client is constructed and the initial session from storage is loaded.
     *   - `SIGNED_IN`
     *     - Emitted each time a user session is confirmed or re-established, including on user sign in and when refocusing a tab.
     *     - Avoid making assumptions as to when this event is fired, this may occur even when the user is already signed in. Instead, check the user object attached to the event to see if a new user has signed in and update your application's UI.
     *     - This event can fire very frequently depending on the number of tabs open in your application.
     *   - `SIGNED_OUT`
     *     - Emitted when the user signs out. This can be after:
     *       - A call to `supabase.auth.signOut()`.
     *       - After the user's session has expired for any reason:
     *         - User has signed out on another device.
     *         - The session has reached its timebox limit or inactivity timeout.
     *         - User has signed in on another device with single session per user enabled.
     *         - Check the [User Sessions](/docs/guides/auth/sessions) docs for more information.
     *     - Use this to clean up any local storage your application has associated with the user.
     *   - `TOKEN_REFRESHED`
     *     - Emitted each time a new access and refresh token are fetched for the signed in user.
     *     - It's best practice and highly recommended to extract the access token (JWT) and store it in memory for further use in your application.
     *       - Avoid frequent calls to `supabase.auth.getSession()` for the same purpose.
     *     - There is a background process that keeps track of when the session should be refreshed so you will always receive valid tokens by listening to this event.
     *     - The frequency of this event is related to the JWT expiry limit configured on your project.
     *   - `USER_UPDATED`
     *     - Emitted each time the `supabase.auth.updateUser()` method finishes successfully. Listen to it to update your application's UI based on new profile information.
     *   - `PASSWORD_RECOVERY`
     *     - Emitted instead of the `SIGNED_IN` event when the user lands on a page that includes a password recovery link in the URL.
     *     - Use it to show a UI to the user where they can [reset their password](/docs/guides/auth/passwords#resetting-a-users-password-forgot-password).
     *
     * @example Listen to auth changes
     * ```js
     * const { data } = supabase.auth.onAuthStateChange((event, session) => {
     *   console.log(event, session)
     *
     *   if (event === 'INITIAL_SESSION') {
     *     // handle initial session
     *   } else if (event === 'SIGNED_IN') {
     *     // handle sign in event
     *   } else if (event === 'SIGNED_OUT') {
     *     // handle sign out event
     *   } else if (event === 'PASSWORD_RECOVERY') {
     *     // handle password recovery event
     *   } else if (event === 'TOKEN_REFRESHED') {
     *     // handle token refreshed event
     *   } else if (event === 'USER_UPDATED') {
     *     // handle user updated event
     *   }
     * })
     *
     * // call unsubscribe to remove the callback
     * data.subscription.unsubscribe()
     * ```
     *
     * @exampleDescription Listen to sign out
     * Make sure you clear out any local data, such as local and session storage, after the client library has detected the user's sign out.
     *
     * @example Listen to sign out
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_OUT') {
     *     console.log('SIGNED_OUT', session)
     *
     *     // clear local and session storage
     *     [
     *       window.localStorage,
     *       window.sessionStorage,
     *     ].forEach((storage) => {
     *       Object.entries(storage)
     *         .forEach(([key]) => {
     *           storage.removeItem(key)
     *         })
     *     })
     *   }
     * })
     * ```
     *
     * @exampleDescription Store OAuth provider tokens on sign in
     * When using [OAuth (Social Login)](/docs/guides/auth/social-login) you sometimes wish to get access to the provider's access token and refresh token, in order to call provider APIs in the name of the user.
     *
     * For example, if you are using [Sign in with Google](/docs/guides/auth/social-login/auth-google) you may want to use the provider token to call Google APIs on behalf of the user. Supabase Auth does not keep track of the provider access and refresh token, but does return them for you once, immediately after sign in. You can use the `onAuthStateChange` method to listen for the presence of the provider tokens and store them in local storage. You can further send them to your server's APIs for use on the backend.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Store OAuth provider tokens on sign in
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     * ```
     *
     * @exampleDescription Use React Context for the User's session
     * Instead of relying on `supabase.auth.getSession()` within your React components, you can use a [React Context](https://react.dev/reference/react/createContext) to store the latest session information from the `onAuthStateChange` callback and access it that way.
     *
     * @example Use React Context for the User's session
     * ```js
     * const SessionContext = React.createContext(null)
     *
     * function main() {
     *   const [session, setSession] = React.useState(null)
     *
     *   React.useEffect(() => {
     *     const {data: { subscription }} = supabase.auth.onAuthStateChange(
     *       (event, session) => {
     *         if (event === 'SIGNED_OUT') {
     *           setSession(null)
     *         } else if (session) {
     *           setSession(session)
     *         }
     *       })
     *
     *     return () => {
     *       subscription.unsubscribe()
     *     }
     *   }, [])
     *
     *   return (
     *     <SessionContext.Provider value={session}>
     *       <App />
     *     </SessionContext.Provider>
     *   )
     * }
     * ```
     *
     * @example Listen to password recovery events
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'PASSWORD_RECOVERY') {
     *     console.log('PASSWORD_RECOVERY', session)
     *     // show screen to update user's password
     *     showPasswordResetScreen(true)
     *   }
     * })
     * ```
     *
     * @example Listen to sign in
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_IN') console.log('SIGNED_IN', session)
     * })
     * ```
     *
     * @example Listen to token refresh
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'TOKEN_REFRESHED') console.log('TOKEN_REFRESHED', session)
     * })
     * ```
     *
     * @example Listen to user updates
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'USER_UPDATED') console.log('USER_UPDATED', session)
     * })
     * ```
     */ onAuthStateChange(callback) {
        const id = (0, $98hXt.generateCallbackId)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     *
     * @category Auth
     *
     * @remarks
     * - The password reset flow consist of 2 broad steps: (i) Allow the user to login via the password reset link; (ii) Update the user's password.
     * - The `resetPasswordForEmail()` only sends a password reset link to the user's email.
     * To update the user's password, see [`updateUser()`](/docs/reference/javascript/auth-updateuser).
     * - A `PASSWORD_RECOVERY` event will be emitted when the password recovery link is clicked.
     * You can use [`onAuthStateChange()`](/docs/reference/javascript/auth-onauthstatechange) to listen and invoke a callback function on these events.
     * - When the user clicks the reset link in the email they are redirected back to your application.
     * You can configure the URL that the user is redirected to with the `redirectTo` parameter.
     * See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - After the user has been redirected successfully, prompt them for a new password and call `updateUser()`:
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: new_password
     * })
     * ```
     *
     * @example Reset password
     * ```js
     * const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
     *   redirectTo: 'https://example.com/update-password',
     * })
     * ```
     *
     * @exampleResponse Reset password
     * ```json
     * {
     *   data: {}
     *   error: null
     * }
     * ```
     *
     * @example Reset password (React)
     * ```js
     * /**
     *  * Step 1: Send the user an email to get a password reset token.
     *  * This email contains a link which sends the user back to your application.
     *  *\/
     * const { data, error } = await supabase.auth
     *   .resetPasswordForEmail('user@email.com')
     *
     * /**
     *  * Step 2: Once the user is redirected back to your application,
     *  * ask the user to reset their password.
     *  *\/
     *  useEffect(() => {
     *    supabase.auth.onAuthStateChange(async (event, session) => {
     *      if (event == "PASSWORD_RECOVERY") {
     *        const newPassword = prompt("What would you like your new password to be?");
     *        const { data, error } = await supabase.auth
     *          .updateUser({ password: newPassword })
     *
     *        if (data) alert("Password updated successfully!")
     *        if (error) alert("There was an error updating your password.")
     *      }
     *    })
     *  }, [])
     * ```
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     *
     * @category Auth
     *
     * @remarks
     * - The user needs to be signed in to call `getUserIdentities()`.
     *
     * @example Returns a list of identities linked to the user
     * ```js
     * const { data, error } = await supabase.auth.getUserIdentities()
     * ```
     *
     * @exampleResponse Returns a list of identities linked to the user
     * ```json
     * {
     *   "data": {
     *     "identities": [
     *       {
     *         "identity_id": "22222222-2222-2222-2222-222222222222",
     *         "id": "2024-01-01T00:00:00Z",
     *         "user_id": "2024-01-01T00:00:00Z",
     *         "identity_data": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "provider": "email",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "email": "example@email.com"
     *       }
     *     ]
     *   },
     *   "error": null
     * }
     * ```
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `linkIdentity()`.
     * - If the candidate identity is already linked to the existing user or another user, `linkIdentity()` will fail.
     * - If `linkIdentity` is run in the browser, the user is automatically redirected to the returned URL. On the server, you should handle the redirect.
     *
     * @example Link an identity to a user
     * ```js
     * const { data, error } = await supabase.auth.linkIdentity({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Link an identity to a user
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     */ async linkIdentity(credentials) {
        if ('token' in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $98hXt.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a !== void 0 ? _a : undefined,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
                const { data: data, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data || !data.session || !data.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new (0, $fTIQY.AuthInvalidTokenResponseError)()
                });
                if (data.session) {
                    await this._saveSession(data.session);
                    await this._notifyAllSubscribers('USER_UPDATED', data.session);
                }
                return this._returnResult({
                    data: data,
                    error: error
                });
            } catch (error) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `unlinkIdentity()`.
     * - The user must have at least 2 identities in order to unlink an identity.
     * - The identity to be unlinked must belong to the user.
     *
     * @example Unlink an identity
     * ```js
     * // retrieve all identities linked to a user
     * const identities = await supabase.auth.getUserIdentities()
     *
     * // find the google identity
     * const googleIdentity = identities.find(
     *   identity => identity.provider === 'google'
     * )
     *
     * // unlink the google identity
     * const { error } = await supabase.auth.unlinkIdentity(googleIdentity)
     * ```
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $98hXt.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, $98hXt.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $doWUR._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $fTIQY.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $98hXt.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $98hXt.userNotAvailableProxy)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
                        await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $44TzP.EXPIRY_MARGIN_MS)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $fTIQY.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $98hXt.Deferred)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $fTIQY.AuthSessionMissingError)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                data: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $98hXt.deepClone)(mainSessionData);
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $98hXt.deepClone)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        this.suppressGetSessionWarning = false;
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey);
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-code-verifier');
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $98hXt.removeItemAsync)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $98hXt.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === 'object' && typeof timeout.unref === 'function') timeout.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(timeout);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - To give this hint to the application, you should be calling this method when the app is in focus and calling `supabase.auth.stopAutoRefresh()` when it's out of focus.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - When your application goes in the background or out of focus, call this method to stop the proactive refreshing of the session.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                            if (expiresInTicks <= (0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $gn0EB.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $98hXt.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug('#visibilityChangedCallback', 'error', error);
                }
            };
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : params.factorType === 'totp' ? {
                    issuer: params.issuer
                } : {});
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params.factorType === 'totp' && data.type === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params.challengeId
                    }, 'webauthn' in params ? {
                        webauthn: Object.assign(Object.assign({}, params.webauthn), {
                            credential_response: params.webauthn.type === 'create' ? (0, $2GmzD.serializeCredentialCreationResponse)(params.webauthn.credential_response) : (0, $2GmzD.serializeCredentialRequestResponse)(params.webauthn.credential_response)
                        })
                    } : {
                        code: params.code
                    });
                    const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return this._returnResult({
                        data: data,
                        error: error
                    });
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    async _challenge(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: params,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (response.error) return response;
                    const { data: data } = response;
                    if (data.type !== 'webauthn') return {
                        data: data,
                        error: null
                    };
                    switch(data.webauthn.type){
                        case 'create':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialCreationOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case 'request':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialRequestOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        var _a;
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data = {
            all: [],
            phone: [],
            totp: [],
            webauthn: []
        };
        // loop over the factors ONCE
        for (const factor of (_a = user === null || user === void 0 ? void 0 : user.factors) !== null && _a !== void 0 ? _a : []){
            data.all.push(factor);
            if (factor.status === 'verified') data[factor.factor_type].push(factor);
        }
        return {
            data: data,
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a, _b, _c, _d;
        if (jwt) try {
            const { payload: payload } = (0, $98hXt.decodeJWT)(jwt);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors = (_b = (_a = user === null || user === void 0 ? void 0 : user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = 'aal2';
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = (0, $98hXt.decodeJWT)(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === 'verified')) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = 'aal2';
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
     * Retrieves details about an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * Returns authorization details including client info, scopes, and user information.
     * If the response includes only a redirect_url field, it means consent was already given - the caller
     * should handle the redirect manually if needed.
     */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Approves an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'approve'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Denies an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'deny'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Lists all OAuth grants that the authenticated user has authorized.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Revokes a user's OAuth grant for a specific client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $44TzP.JWKS_TTL) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     *
     * @category Auth
     *
     * @remarks
     * - Parses the user's [access token](/docs/guides/auth/sessions#access-token-jwt-claims) as a [JSON Web Token (JWT)](/docs/guides/auth/jwts) and returns its components if valid and not expired.
     * - If your project is using asymmetric JWT signing keys, then the verification is done locally usually without a network request using the [WebCrypto API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API).
     * - A network request is sent to your project's JWT signing key discovery endpoint `https://project-id.supabase.co/auth/v1/.well-known/jwks.json`, which is cached locally. If your environment is ephemeral, such as a Lambda function that is destroyed after every request, a network request will be sent for each new invocation. Supabase provides a network-edge cache providing fast responses for these situations.
     * - If the user's access token is about to expire when calling this function, the user's session will first be refreshed before validating the JWT.
     * - If your project is using a symmetric secret to sign the JWT, it always sends a request similar to `getUser()` to validate the JWT at the server before returning the decoded token. This is also used if the WebCrypto API is not available in the environment. Make sure you polyfill it in such situations.
     * - The returned claims can be customized per project using the [Custom Access Token Hook](/docs/guides/auth/auth-hooks/custom-access-token-hook).
     *
     * @example Get JWT claims, header and signature
     * ```js
     * const { data, error } = await supabase.auth.getClaims()
     * ```
     *
     * @exampleResponse Get JWT claims, header and signature
     * ```json
     * {
     *   "data": {
     *     "claims": {
     *       "aal": "aal1",
     *       "amr": [{
     *         "method": "email",
     *         "timestamp": 1715766000
     *       }],
     *       "app_metadata": {},
     *       "aud": "authenticated",
     *       "email": "example@email.com",
     *       "exp": 1715769600,
     *       "iat": 1715766000,
     *       "is_anonymous": false,
     *       "iss": "https://project-id.supabase.co/auth/v1",
     *       "phone": "+13334445555",
     *       "role": "authenticated",
     *       "session_id": "11111111-1111-1111-1111-111111111111",
     *       "sub": "11111111-1111-1111-1111-111111111111",
     *       "user_metadata": {}
     *     },
     *     "header": {
     *       "alg": "RS256",
     *       "typ": "JWT",
     *       "kid": "11111111-1111-1111-1111-111111111111"
     *     },
     *     "signature": [/** Uint8Array *\/],
     *   },
     *   "error": null
     * }
     * ```
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $98hXt.decodeJWT)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $98hXt.validateExp)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $98hXt.getAlgorithm)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $iSR6L.stringToUint8Array)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
}
$8025f0dcbc879582$var$GoTrueClient.nextInstanceID = {};
var $8025f0dcbc879582$export$2e2bcd8739ae039 = $8025f0dcbc879582$var$GoTrueClient;

});
parcelRegister("a7BAw", function(module, exports) {

$parcel$export(module.exports, "memoryLocalStorageAdapter", () => $75e7b709645121aa$export$d791f66d7e5710cf);
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $75e7b709645121aa$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

});

parcelRegister("gn0EB", function(module, exports) {

$parcel$export(module.exports, "internals", () => $031357f45f79c67e$export$e368aba7747330f2);
$parcel$export(module.exports, "LockAcquireTimeoutError", () => $031357f45f79c67e$export$23e9464cc010dff9);
$parcel$export(module.exports, "NavigatorLockAcquireTimeoutError", () => $031357f45f79c67e$export$4aa56776043a4631);
$parcel$export(module.exports, "navigatorLock", () => $031357f45f79c67e$export$f4ff21938fb7af3c);
$parcel$export(module.exports, "processLock", () => $031357f45f79c67e$export$b21ec9b2268372c7);

var $98hXt = parcelRequire("98hXt");
const $031357f45f79c67e$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $98hXt.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $031357f45f79c67e$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $031357f45f79c67e$export$4aa56776043a4631 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
class $031357f45f79c67e$export$4b982ee840d3d915 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
async function $031357f45f79c67e$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                // Lock acquired — cancel the acquire-timeout timer so it cannot fire
                // while fn() is running. Without this, a delayed timeout abort would
                // set signal.aborted = true even though we already hold the lock,
                // causing a subsequent steal to be misclassified as "our timeout
                // fired" and triggering a spurious steal-back cascade.
                clearTimeout(acquireTimeoutTimer);
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e) {
        // Always clear the acquire timeout once the request settles, so it cannot
        // fire later and incorrectly abort/log after a rejection.
        if (acquireTimeout > 0) clearTimeout(acquireTimeoutTimer);
        if ((e === null || e === void 0 ? void 0 : e.name) === 'AbortError' && acquireTimeout > 0) {
            if (abortController.signal.aborted) {
                // OUR timeout fired — the lock is genuinely orphaned. Steal it.
                //
                // The lock acquisition was aborted because the timeout fired while the
                // request was still pending. This typically means another lock holder is
                // not releasing the lock, possibly due to React Strict Mode's
                // double-mount/unmount behavior or a component unmounting mid-operation,
                // leaving an orphaned lock.
                //
                // Recovery: use { steal: true } to forcefully acquire the lock. Per the
                // Web Locks API spec, this releases any currently held lock with the same
                // name and grants the request immediately, preempting any queued requests.
                // The previous holder's callback continues running to completion but no
                // longer holds the lock for exclusion purposes.
                //
                // See: https://github.com/supabase/supabase/issues/42505
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock', name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. ` + 'This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). ' + 'Forcefully acquiring the lock to recover.');
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: 'exclusive',
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: recovered (stolen)', name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released (stolen)', name, lock.name);
                            }
                        } else {
                            // This should not happen with steal: true, but handle gracefully.
                            console.warn('@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true');
                            return await fn();
                        }
                    }));
            } else {
                // We HELD the lock but another request stole it from us.
                // Per the Web Locks spec, our fn() callback is still running as an
                // orphaned background task — do NOT steal back. Stealing back would
                // cause a cascade (A steals B, B steals A, ...) and run fn() a second
                // time concurrently, corrupting auth state.
                // Convert to a typed error so callers (e.g. _autoRefreshTokenTick)
                // can handle/filter it without it leaking to Sentry as a raw AbortError.
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: lock was stolen by another request', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e;
    }
}
const $031357f45f79c67e$var$PROCESS_LOCKS = {};
async function $031357f45f79c67e$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $031357f45f79c67e$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    // Wrap previousOperation to handle errors without using .catch()
    // This avoids Firefox content script security errors
    const previousOperationHandled = (async ()=>{
        try {
            await previousOperation;
            return null;
        } catch (e) {
            // ignore error of previous operation that we're waiting to finish
            return null;
        }
    })();
    const currentOperation = (async ()=>{
        let timeoutId = null;
        try {
            // Wait for either previous operation or timeout
            const timeoutPromise = acquireTimeout >= 0 ? new Promise((_, reject)=>{
                timeoutId = setTimeout(()=>{
                    console.warn(`@supabase/gotrue-js: Lock "${name}" acquisition timed out after ${acquireTimeout}ms. ` + 'This may be caused by another operation holding the lock. ' + 'Consider increasing lockAcquireTimeout or checking for stuck operations.');
                    reject(new $031357f45f79c67e$export$4b982ee840d3d915(`Acquiring process lock with name "${name}" timed out`));
                }, acquireTimeout);
            }) : null;
            await Promise.race([
                previousOperationHandled,
                timeoutPromise
            ].filter((x)=>x));
            // If we reach here, previousOperationHandled won the race
            // Clear the timeout to prevent false warnings
            if (timeoutId !== null) clearTimeout(timeoutId);
        } catch (e) {
            // Clear the timeout on error path as well
            if (timeoutId !== null) clearTimeout(timeoutId);
            // Re-throw timeout errors, ignore others
            if (e && e.isAcquireTimeout) throw e;
        // Fall through to run fn() - previous operation finished with error
        }
        // Previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    })();
    $031357f45f79c67e$var$PROCESS_LOCKS[name] = (async ()=>{
        try {
            return await currentOperation;
        } catch (e) {
            if (e && e.isAcquireTimeout) {
                // if the current operation timed out, it doesn't mean that the previous
                // operation finished, so we need continue waiting for it to finish
                try {
                    await previousOperation;
                } catch (prevError) {
                // Ignore previous operation errors
                }
                return null;
            }
            throw e;
        }
    })();
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

});

parcelRegister("8WDEC", function(module, exports) {

$parcel$export(module.exports, "polyfillGlobalThis", () => $68327ffe4e2befb5$export$ad067ce270531206);
/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $68327ffe4e2befb5$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

});

parcelRegister("baxuF", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $821a9c05c0953df2$export$88411125f012957a);
$parcel$export(module.exports, "fromHex", () => $821a9c05c0953df2$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $821a9c05c0953df2$export$7ea66e3774a60b67);
$parcel$export(module.exports, "createSiweMessage", () => $821a9c05c0953df2$export$7ee2e5fde403d4c8);
// types and functions copied over from viem so this library doesn't depend on it
function $821a9c05c0953df2$export$88411125f012957a(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $821a9c05c0953df2$export$1a8ceedbd5845648(hex) {
    return parseInt(hex, 16);
}
function $821a9c05c0953df2$export$7ea66e3774a60b67(value) {
    const bytes = new TextEncoder().encode(value);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0')).join('');
    return '0x' + hex;
}
function $821a9c05c0953df2$export$7ee2e5fde403d4c8(parameters) {
    var _a;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version !== '1') throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version}`);
    if ((_a = parameters.statement) === null || _a === void 0 ? void 0 : _a.includes('\n')) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    // Construct message
    const address = $821a9c05c0953df2$export$88411125f012957a(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}\n` : '';
    const prefix = `${origin} wants you to sign in with your Ethereum account:\n${address}\n\n${statement}`;
    let suffix = `URI: ${uri}\nVersion: ${version}\nChain ID: ${chainId}${nonce ? `\nNonce: ${nonce}` : ''}\nIssued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `\nExpiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `\nNot Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `\nRequest ID: ${requestId}`;
    if (resources) {
        let content = '\nResources:';
        for (const resource of resources){
            if (!resource || typeof resource !== 'string') throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `\n- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}\n${suffix}`;
}

});

parcelRegister("2GmzD", function(module, exports) {

$parcel$export(module.exports, "deserializeCredentialCreationOptions", () => $1f4103b2c99735be$export$d02e6c69c68605f0);
$parcel$export(module.exports, "deserializeCredentialRequestOptions", () => $1f4103b2c99735be$export$943ff00a541d1017);
$parcel$export(module.exports, "serializeCredentialCreationResponse", () => $1f4103b2c99735be$export$4b534f6222f6d585);
$parcel$export(module.exports, "serializeCredentialRequestResponse", () => $1f4103b2c99735be$export$b3350da6d3acaa5a);
$parcel$export(module.exports, "isValidDomain", () => $1f4103b2c99735be$export$59e759560deddc3c);
$parcel$export(module.exports, "WebAuthnApi", () => $1f4103b2c99735be$export$23264e48ebb7dee0);

var $7WQrb = parcelRequire("7WQrb");

var $iSR6L = parcelRequire("iSR6L");

var $fTIQY = parcelRequire("fTIQY");

var $98hXt = parcelRequire("98hXt");

var $3SAvc = parcelRequire("3SAvc");
class $1f4103b2c99735be$export$442ada5d34ca6e87 {
    /**
     * Create an abort signal for a new WebAuthn operation.
     * Automatically cancels any existing operation.
     *
     * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
     */ createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
     * Manually cancel the current WebAuthn operation.
     * Useful for cleaning up when user cancels or navigates away.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
     */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $1f4103b2c99735be$export$4109de07ec7c8bef = new $1f4103b2c99735be$export$442ada5d34ca6e87();
function $1f4103b2c99735be$export$d02e6c69c68605f0(options) {
    if (!options) throw new Error('Credential creation options are required');
    // Check if the native parseCreationOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseCreationOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Convert user.id from base64url to ArrayBuffer
    const user = Object.assign(Object.assign({}, userOpts), {
        id: (0, $iSR6L.base64UrlToUint8Array)(userOpts.id).buffer
    });
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    // Only add excludeCredentials if it exists
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i = 0; i < excludeCredentials.length; i++){
            const cred = excludeCredentials[i];
            result.excludeCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$943ff00a541d1017(options) {
    if (!options) throw new Error('Credential request options are required');
    // Check if the native parseRequestOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseRequestOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "allowCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    // Only add allowCredentials if it exists
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i = 0; i < allowCredentials.length; i++){
            const cred = allowCredentials[i];
            result.allowCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$4b534f6222f6d585(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.clientDataJSON))
        },
        type: 'public-key',
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$b3350da6d3acaa5a(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    // Fallback to manual conversion for browsers that don't support toJSON
    // Access authenticatorAttachment via type assertion to handle TypeScript version differences
    // @simplewebauthn/types includes this property but base TypeScript 4.7.4 doesn't
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            authenticatorData: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.userHandle)) : undefined
        },
        type: 'public-key',
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
/**
 * Determine if the browser is capable of WebAuthn.
 * Checks for necessary Web APIs: PublicKeyCredential and Credential Management.
 *
 * @returns {boolean} True if browser supports WebAuthn
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential#browser_compatibility MDN - PublicKeyCredential Browser Compatibility}
 */ function $1f4103b2c99735be$var$browserSupportsWebAuthn() {
    var _a, _b;
    return !!((0, $98hXt.isBrowser)() && 'PublicKeyCredential' in window && window.PublicKeyCredential && 'credentials' in navigator && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a === void 0 ? void 0 : _a.create) === 'function' && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === 'function');
}
async function $1f4103b2c99735be$export$e4658562cd85d5e4(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyRegistrationError)({
                error: err,
                options: options
            })
        };
    }
}
async function $1f4103b2c99735be$export$298c59008c641b3e(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyAuthenticationError)({
                error: err,
                options: options
            })
        };
    }
}
const $1f4103b2c99735be$export$315ccaead2259c48 = {
    hints: [
        'security-key'
    ],
    authenticatorSelection: {
        authenticatorAttachment: 'cross-platform',
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
        residentKey: 'discouraged'
    },
    attestation: 'direct'
};
const $1f4103b2c99735be$export$26eadd1e9f10eb21 = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
    hints: [
        'security-key'
    ],
    attestation: 'direct'
};
function $1f4103b2c99735be$var$deepMerge(...sources) {
    const isObject = (val)=>val !== null && typeof val === 'object' && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value = source[key];
            if (value === undefined) continue;
            if (Array.isArray(value)) // preserve array reference, including unions like AuthenticatorTransport[]
            result[key] = value;
            else if (isArrayBufferLike(value)) result[key] = value;
            else if (isObject(value)) {
                const existing = result[key];
                if (isObject(existing)) result[key] = $1f4103b2c99735be$var$deepMerge(existing, value);
                else result[key] = $1f4103b2c99735be$var$deepMerge(value);
            } else result[key] = value;
        }
    }
    return result;
}
function $1f4103b2c99735be$export$3be75f4dca600793(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$315ccaead2259c48, baseOptions, overrides || {});
}
function $1f4103b2c99735be$export$dd12a9ca29190b76(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$26eadd1e9f10eb21, baseOptions, overrides || {});
}
class $1f4103b2c99735be$export$23264e48ebb7dee0 {
    constructor(client){
        this.client = client;
        // Bind all methods so they can be destructured
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
     * Enroll a new WebAuthn factor.
     * Creates an unverified WebAuthn factor that must be verified with a credential.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
     * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
     */ async _enroll(params) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params), {
            factorType: 'webauthn'
        }));
    }
    /**
     * Challenge for WebAuthn credential creation or authentication.
     * Combines server challenge with browser credential operations.
     * Handles both registration (create) and authentication (request) flows.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
     * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
     * @returns {Promise<RequestResult>} Challenge response with credential or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
     */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a;
        try {
            // Get challenge from server using the client's MFA methods
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $1f4103b2c99735be$export$4109de07ec7c8bef.createNewAbortSignal();
            /** webauthn will fail if either of the name/displayname are blank */ if (challengeResponse.webauthn.type === 'create') {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    // Preserve original format: use friendlyName if provided, otherwise fetch fallback
                    // This maintains backward compatibility with the ${user.id}:${name} format
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        // Only fetch user data if friendlyName is not provided (bug fix for null friendlyName)
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a === void 0 ? void 0 : _a.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || 'User';
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case 'create':
                    {
                        const options = $1f4103b2c99735be$export$3be75f4dca600793(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$e4658562cd85d5e4({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case 'request':
                    {
                        const options = $1f4103b2c99735be$export$dd12a9ca29190b76(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$298c59008c641b3e(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in challenge', error)
            };
        }
    }
    /**
     * Verify a WebAuthn credential with the server.
     * Completes the WebAuthn ceremony by sending the credential to the server for verification.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Verification parameters
     * @param {string} params.challengeId - ID of the challenge being verified
     * @param {string} params.factorId - ID of the WebAuthn factor
     * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
     * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
     * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
     * Complete WebAuthn authentication flow.
     * Performs challenge and verification in a single operation for existing credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Authentication parameters
     * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
     * @param {Object} params.webauthn - WebAuthn configuration
     * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.webauthn.signal - Optional abort signal
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
     * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
     */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn authentication')
        };
        try {
            if (!$1f4103b2c99735be$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Get challenge and credential
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            // Verify credential
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in authenticate', error)
            };
        }
    }
    /**
     * Complete WebAuthn registration flow.
     * Performs enrollment, challenge, and verification in a single operation for new credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Registration parameters
     * @param {string} params.friendlyName - User-friendly name for the credential
     * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.signal - Optional abort signal
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
     */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn registration')
        };
        try {
            if (!$1f4103b2c99735be$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Enroll factor
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a;
                    return (_a = factors.data) === null || _a === void 0 ? void 0 : _a.all.find((v)=>v.factor_type === 'webauthn' && v.friendly_name === friendlyName && v.status !== 'unverified');
                }).then((factor)=>factor ? this.client.mfa.unenroll({
                        factorId: factor === null || factor === void 0 ? void 0 : factor.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            // Get challenge and create credential
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in register', error)
            };
        }
    }
}

});
parcelRegister("3SAvc", function(module, exports) {

$parcel$export(module.exports, "WebAuthnUnknownError", () => $2d32bad54faaeecf$export$2799e3b911935b0d);
$parcel$export(module.exports, "identifyRegistrationError", () => $2d32bad54faaeecf$export$1c18a773f8a28a92);
$parcel$export(module.exports, "identifyAuthenticationError", () => $2d32bad54faaeecf$export$9b62fd498befe529);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
var $2GmzD = parcelRequire("2GmzD");
class $2d32bad54faaeecf$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : undefined) !== null && _a !== void 0 ? _a : 'Unknown Error';
        this.code = code;
    }
}
class $2d32bad54faaeecf$export$2799e3b911935b0d extends $2d32bad54faaeecf$export$90f0c14a652de832 {
    constructor(message, originalError){
        super({
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: originalError,
            message: message
        });
        this.name = 'WebAuthnUnknownError';
        this.originalError = originalError;
    }
}
function $2d32bad54faaeecf$export$8596540875e19045(error) {
    return typeof error === 'object' && error !== null && '__isWebAuthnError' in error;
}
function $2d32bad54faaeecf$export$1c18a773f8a28a92({ error: error, options: options }) {
    var _a, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (((_a = publicKey.authenticatorSelection) === null || _a === void 0 ? void 0 : _a.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}
function $2d32bad54faaeecf$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}

});



parcelRegister("fCilG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e8a3473c3df521$export$2e2bcd8739ae039);

var $f8esb = parcelRequire("f8esb");
const $b5e8a3473c3df521$var$AuthAdminApi = (0, $f8esb.default);
var $b5e8a3473c3df521$export$2e2bcd8739ae039 = $b5e8a3473c3df521$var$AuthAdminApi;

});

parcelRegister("aALRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b62653534e595bb$export$2e2bcd8739ae039);

var $b083j = parcelRequire("b083j");
const $7b62653534e595bb$var$AuthClient = (0, $b083j.default);
var $7b62653534e595bb$export$2e2bcd8739ae039 = $7b62653534e595bb$var$AuthClient;

});





var $iTneE = parcelRequire("iTneE");
var $85274e1cff99deb2$export$2e2bcd8739ae039 = {};


var $583e5c65243bf299$export$2e2bcd8739ae039 = {
    page: '/',
    loggedIn: false,
    userType: null,
    darkMode: true,
    scrolled: false,
    sidebarOpen: true,
    activeCaseId: null,
    activeClientId: null,
    activeInvoiceId: null,
    selectedSlot: null,
    selectedTemplate: 'demand',
    generatingDoc: false,
    docOutput: null,
    analysisOutput: null,
    researchMessages: [],
    researchInput: '',
    activeTab: 'all',
    aiTab: 'draft',
    settingsTab: 'profile',
    alertDismissed: false,
    activeLangMenu: false,
    lawyers: [],
    lawyersLoaded: false,
    totalLawyers: 0,
    totalFirms: 0,
    lawyersVisible: 24,
    firms: [],
    firmsLoaded: false,
    directoryFilter: '',
    directoryView: 'all',
    areaFilter: '',
    cityFilter: '',
    verificationFilter: '',
    statusFilter: '',
    chatMessages: [],
    chatInput: '',
    chatTyping: false,
    _chatLastArea: null,
    publicBookingStep: 'select',
    showNewBooking: false,
    selectedBookingId: null,
    loginTab: 'lawyer',
    clientDashboardTab: 'cases',
    firm: {
        name: '\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8 "\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8"',
        lawyer: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        initials: "\u10DC\u10D1",
        publicBookingUrl: 'legalos.ge/book/barateli'
    },
    stats: {
        openCases: 14,
        todayBookings: 3,
        unpaidInvoices: "\u20BE1,840",
        overdueDeadlines: 2,
        aiUsageThisMonth: 23
    },
    bookings: [
        {
            id: 1,
            client: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            time: '10:00',
            type: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
            status: 'confirmed',
            phone: '599123456'
        },
        {
            id: 2,
            client: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
            time: '11:30',
            type: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
            status: 'pending',
            phone: '577234567'
        },
        {
            id: 3,
            client: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
            time: '14:00',
            type: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8",
            status: 'confirmed',
            phone: '598345678'
        }
    ],
    cases: [
        {
            id: 1,
            num: '#2024-047',
            client: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            type: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
            status: 'active',
            nextDeadline: "20 \u10DB\u10D0\u10E0",
            deadlineUrgent: true,
            updated: "18 \u10DB\u10D0\u10E0"
        },
        {
            id: 2,
            num: '#2024-046',
            client: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
            type: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
            status: 'pending',
            nextDeadline: "25 \u10DB\u10D0\u10E0",
            deadlineUrgent: false,
            updated: "17 \u10DB\u10D0\u10E0"
        },
        {
            id: 3,
            num: '#2024-045',
            client: "\u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            type: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8",
            status: 'court',
            nextDeadline: "19 \u10DB\u10D0\u10E0",
            deadlineUrgent: true,
            updated: "15 \u10DB\u10D0\u10E0"
        },
        {
            id: 4,
            num: '#2024-044',
            client: "\u10D6\u10E3\u10E0\u10D0\u10D1 \u10D9\u10DD\u10D1\u10D0\u10EE\u10D8\u10EB\u10D4",
            type: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
            status: 'closed',
            nextDeadline: null,
            deadlineUrgent: false,
            updated: "10 \u10DB\u10D0\u10E0"
        }
    ],
    clients: [
        {
            id: 1,
            name: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            phone: '599123456',
            email: 'g.mamulasvili@gmail.com',
            activeCases: 1,
            totalBilled: "\u20BE2,400",
            lastContact: "18 \u10DB\u10D0\u10E0"
        },
        {
            id: 2,
            name: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
            phone: '577234567',
            email: 'mari.k@mail.ru',
            activeCases: 1,
            totalBilled: "\u20BE800",
            lastContact: "17 \u10DB\u10D0\u10E0"
        },
        {
            id: 3,
            name: "\u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            phone: '571456789',
            email: 'lela.g@inbox.ge',
            activeCases: 0,
            totalBilled: "\u20BE1,800",
            lastContact: "15 \u10DB\u10D0\u10E0"
        },
        {
            id: 4,
            name: "\u10D6\u10E3\u10E0\u10D0\u10D1 \u10D9\u10DD\u10D1\u10D0\u10EE\u10D8\u10EB\u10D4",
            phone: '593567890',
            email: 'zurab.k@gmail.com',
            activeCases: 0,
            totalBilled: "\u20BE950",
            lastContact: "10 \u10DB\u10D0\u10E0"
        }
    ],
    invoices: [
        {
            id: 1,
            num: 'INV-2024-031',
            client: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            caseNum: '#2024-047',
            amount: "\u20BE1,200",
            status: 'unpaid',
            due: "25 \u10DB\u10D0\u10E0"
        },
        {
            id: 2,
            num: 'INV-2024-030',
            client: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
            caseNum: '#2024-046',
            amount: "\u20BE640",
            status: 'paid',
            due: "15 \u10DB\u10D0\u10E0"
        },
        {
            id: 3,
            num: 'INV-2024-029',
            client: "\u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
            caseNum: '#2024-045',
            amount: "\u20BE1,800",
            status: 'overdue',
            due: "10 \u10DB\u10D0\u10E0"
        }
    ],
    documents: [
        {
            id: 1,
            name: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
            type: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8",
            caseNum: '#2024-047',
            date: "15 \u10DB\u10D0\u10E0"
        },
        {
            id: 2,
            name: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 - \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0.pdf",
            type: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0",
            caseNum: '#2024-046',
            date: "12 \u10DB\u10D0\u10E0"
        }
    ],
    teamMembers: [
        {
            id: 1,
            name: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
            role: "\u10DB\u10E4\u10DA\u10DD\u10D1\u10D4\u10DA\u10D8",
            email: 'nino@barateli.ge',
            active: true
        },
        {
            id: 2,
            name: "\u10D2\u10D8\u10D2\u10D0 \u10D0\u10E1\u10DA\u10D0\u10DC\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
            role: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
            email: 'giga@barateli.ge',
            active: true
        }
    ],
    clientPortal: {
        clientName: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8",
        cases: [
            {
                num: '#2024-047',
                type: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
                status: 'active',
                progress: 3,
                totalSteps: 5,
                nextStep: "\u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0 25 \u10DB\u10D0\u10E0\u10E2\u10E1",
                lastUpdate: "18 \u10DB\u10D0\u10E0"
            }
        ],
        invoices: [
            {
                num: 'INV-2024-031',
                amount: "\u20BE1,200",
                due: "25 \u10DB\u10D0\u10E0",
                status: 'unpaid'
            }
        ],
        messages: [
            {
                from: 'lawyer',
                text: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8, \u10E1\u10D0\u10E5\u10DB\u10D4\u10D6\u10D4 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D2\u10D5\u10D0\u10E5\u10D5\u10E1.",
                time: '10:30'
            },
            {
                from: 'client',
                text: "\u10DB\u10D0\u10D3\u10DA\u10DD\u10D1\u10D0, \u10D5\u10D4\u10DA\u10DD\u10D3\u10D4\u10D1\u10D8 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10E1.",
                time: '10:45'
            }
        ]
    }
};


var $ffee29e35474451f$export$2e2bcd8739ae039 = {
    '@supabase/supabase-js': '^2.99.2'
};


var $b940b823876787d8$exports = {};
var $d5e26d212c5263dc$exports = {};

$parcel$export($d5e26d212c5263dc$exports, "LandingNav", () => $d5e26d212c5263dc$export$40934c0e6bd15738);
const $d5e26d212c5263dc$export$40934c0e6bd15738 = {
    tag: 'nav',
    flow: 'x',
    align: 'center space-between',
    padding: 'A C',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    zIndex: '100',
    background: 'neutral950',
    borderBottom: 'none',
    transition: 'background 300ms',
    '@mobileL': {
        padding: 'A Z'
    },
    LogoLink: {
        extends: 'Link',
        href: '/',
        text: 'TrustLegal',
        fontSize: 'B',
        fontWeight: '800',
        color: 'green',
        textDecoration: 'none',
        flex: '1'
    },
    NavLinks: {
        flow: 'x',
        gap: 'B',
        align: 'center center',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        '@tabletS': {
            gap: 'A'
        },
        '@mobileL': {
            display: 'none'
        },
        NavLink1: {
            extends: 'Link',
            href: '/for-lawyers',
            text: 'For Lawyers',
            color: 'textSoft',
            fontSize: 'A',
            textDecoration: 'none',
            '@tabletS': {
                fontSize: 'Z'
            }
        },
        NavLink4: {
            extends: 'Link',
            href: '/for-clients',
            text: 'For Clients',
            color: 'textSoft',
            fontSize: 'A',
            textDecoration: 'none',
            '@tabletS': {
                fontSize: 'Z'
            }
        },
        NavLink5: {
            extends: 'Link',
            href: '/lawyers',
            text: '{{ lawyersNav | polyglot }}',
            color: 'green',
            fontSize: 'A',
            fontWeight: '600',
            textDecoration: 'none',
            '@tabletS': {
                fontSize: 'Z'
            }
        },
        NavLinkChat: {
            extends: 'Link',
            href: '/chat',
            text: 'AI Assistant',
            color: 'green',
            fontSize: 'A',
            fontWeight: '600',
            textDecoration: 'none',
            '@tabletS': {
                fontSize: 'Z'
            }
        }
    },
    NavActions: {
        flow: 'x',
        gap: 'A',
        align: 'center center',
        flex: '1',
        justifyContent: 'flex-end',
        '@mobileL': {
            gap: 'Y'
        },
        LangMenu: {
            position: 'relative',
            align: 'center center',
            LangBtn: {
                tag: 'button',
                align: 'center center',
                gap: 'Y',
                padding: 'Z A',
                borderRadius: 'Z',
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                ':hover': {
                    background: 'white .08'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root.update({
                        activeLangMenu: !s.root.activeLangMenu
                    });
                },
                LangFlag: {
                    fontSize: 'B',
                    text: (el, s)=>{
                        const flags = {
                            en: '\uD83C\uDDEC\uD83C\uDDE7',
                            ka: '\uD83C\uDDEC\uD83C\uDDEA',
                            ru: '\uD83C\uDDF7\uD83C\uDDFA',
                            uk: '\uD83C\uDDFA\uD83C\uDDE6',
                            tr: '\uD83C\uDDF9\uD83C\uDDF7',
                            zh: '\uD83C\uDDE8\uD83C\uDDF3',
                            hi: '\uD83C\uDDEE\uD83C\uDDF3',
                            msa: '\uD83C\uDDF8\uD83C\uDDE6'
                        };
                        const lang = s.root?.lang || 'en';
                        return flags[lang] || flags.en;
                    }
                },
                LangCode: {
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'textSoft',
                    '@mobileL': {
                        display: 'none'
                    },
                    text: (el, s)=>{
                        const codes = {
                            en: 'EN',
                            ka: 'GE',
                            ru: 'RU',
                            uk: 'UA',
                            tr: 'TR',
                            zh: 'ZH',
                            hi: 'HI',
                            msa: 'MSA'
                        };
                        const lang = s.root?.lang || 'en';
                        return codes[lang] || codes.en;
                    }
                }
            },
            LangDropdown: {
                flow: 'y',
                position: 'absolute',
                top: 'calc(100% + Z)',
                right: '0',
                background: 'neutral800',
                borderRadius: 'Z',
                boxShadow: 'black .2 0 Y Z, black .3 0 Z B',
                padding: 'X',
                minWidth: 'E',
                zIndex: '300',
                opacity: (el, s)=>s.root.activeLangMenu ? '1' : '0',
                pointerEvents: (el, s)=>s.root.activeLangMenu ? 'auto' : 'none',
                transition: 'opacity 0.15s ease, transform 0.15s ease',
                transform: (el, s)=>s.root.activeLangMenu ? 'translateY(0)' : 'translateY(-6px)',
                LangEn: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'en'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDEC\uD83C\uDDE7',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: 'English',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangKa: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'ka'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDEC\uD83C\uDDEA',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangRu: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'ru'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDF7\uD83C\uDDFA',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangUk: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'uk'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDFA\uD83C\uDDE6',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangTr: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'tr'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDF9\uD83C\uDDF7',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: 'T\u00FCrk\u00E7e',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangZh: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'zh'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDE8\uD83C\uDDF3',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u4E2D\u6587',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangHi: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'hi'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDEE\uD83C\uDDF3',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u0939\u093F\u0928\u094D\u0926\u0940',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                },
                LangMsa: {
                    align: 'center flex-start',
                    gap: 'X',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    cursor: 'pointer',
                    props: {
                        langCode: 'msa'
                    },
                    ':hover': {
                        background: 'white .08'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            lang: el.props.langCode,
                            activeLangMenu: false
                        });
                        try {
                            localStorage.setItem('legal_lang', el.props.langCode);
                        } catch (e) {}
                    },
                    FlagEl: {
                        text: '\uD83C\uDDF8\uD83C\uDDE6',
                        fontSize: 'A'
                    },
                    NameEl: {
                        text: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629',
                        fontSize: 'Z',
                        color: 'text',
                        fontWeight: '500'
                    }
                }
            }
        },
        LoginLink: {
            extends: 'Link',
            href: '/login',
            text: '{{ login | polyglot }}',
            theme: 'ghost',
            padding: 'Z B',
            fontSize: 'A',
            borderRadius: 'Z',
            textDecoration: 'none',
            '@mobileL': {
                display: 'none'
            }
        },
        CtaLink: {
            extends: 'Link',
            href: '/dashboard',
            text: '{{ getStarted | polyglot }}',
            background: 'green',
            color: 'neutral950',
            padding: 'Z B',
            fontSize: 'A',
            fontWeight: '600',
            borderRadius: 'D',
            textDecoration: 'none',
            transition: 'transform 200ms',
            ':hover': {
                transform: 'scale(0.98)'
            },
            onClick: (e, el, s)=>s.root.update({
                    loggedIn: true
                }),
            '@mobileL': {
                padding: 'Z A',
                fontSize: 'Z'
            }
        }
    }
};


var $a45233490d2462db$exports = {};

$parcel$export($a45233490d2462db$exports, "Sidebar", () => $a45233490d2462db$export$1ba59dacbcbf90fe);
const $a45233490d2462db$export$1ba59dacbcbf90fe = {
    tag: 'aside',
    flow: 'y',
    width: 'G',
    minWidth: 'G',
    height: '100vh',
    background: 'surfaceMid',
    padding: 'B A 0 A',
    position: 'sticky',
    top: '0',
    flexShrink: '0',
    justifyContent: 'space-between',
    overflow: 'auto',
    transition: 'width 200ms, min-width 200ms, padding 200ms',
    '@tabletS': {
        width: 'C',
        minWidth: 'C',
        padding: 'B Y'
    },
    '@mobileL': {
        display: 'none'
    },
    TopSection: {
        flow: 'y',
        gap: 'C',
        LogoBrand: {
            extends: 'Link',
            href: '/dashboard',
            text: 'TrustLegal',
            fontSize: 'B',
            fontWeight: '800',
            color: 'green',
            padding: '0 A',
            textDecoration: 'none',
            '@tabletS': {
                fontSize: 'A',
                padding: '0',
                textAlign: 'center'
            }
        },
        NavItems: {
            flow: 'y',
            gap: 'Z',
            NavDashboard: {
                extends: 'SidebarNavItem',
                href: '/dashboard',
                background: (el)=>window.location.pathname === '/dashboard' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'dashboard',
                    color: (el)=>window.location.pathname === '/dashboard' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarMain | polyglot }}',
                    color: (el)=>window.location.pathname === '/dashboard' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/dashboard' ? '600' : '500'
                }
            },
            NavBookings: {
                extends: 'SidebarNavItem',
                href: '/bookings',
                background: (el)=>window.location.pathname === '/bookings' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'calendar',
                    color: (el)=>window.location.pathname === '/bookings' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarBookings | polyglot }}',
                    color: (el)=>window.location.pathname === '/bookings' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/bookings' ? '600' : '500'
                }
            },
            NavCases: {
                extends: 'SidebarNavItem',
                href: '/cases',
                background: (el)=>window.location.pathname === '/cases' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'briefcase',
                    color: (el)=>window.location.pathname === '/cases' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarCases | polyglot }}',
                    color: (el)=>window.location.pathname === '/cases' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/cases' ? '600' : '500'
                }
            },
            NavClients: {
                extends: 'SidebarNavItem',
                href: '/clients',
                background: (el)=>window.location.pathname === '/clients' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'user',
                    color: (el)=>window.location.pathname === '/clients' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarClients | polyglot }}',
                    color: (el)=>window.location.pathname === '/clients' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/clients' ? '600' : '500'
                }
            },
            NavDocs: {
                extends: 'SidebarNavItem',
                href: '/documents',
                background: (el)=>window.location.pathname === '/documents' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'document',
                    color: (el)=>window.location.pathname === '/documents' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarDocs | polyglot }}',
                    color: (el)=>window.location.pathname === '/documents' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/documents' ? '600' : '500'
                }
            },
            NavBilling: {
                extends: 'SidebarNavItem',
                href: '/billing',
                background: (el)=>window.location.pathname === '/billing' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'briefcase',
                    color: (el)=>window.location.pathname === '/billing' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarPayments | polyglot }}',
                    color: (el)=>window.location.pathname === '/billing' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/billing' ? '600' : '500'
                }
            },
            NavAI: {
                extends: 'SidebarNavItem',
                href: '/ai',
                background: (el)=>window.location.pathname === '/ai' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'ai',
                    color: (el)=>window.location.pathname === '/ai' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: 'AI',
                    color: (el)=>window.location.pathname === '/ai' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/ai' ? '600' : '500'
                }
            },
            NavSettings: {
                extends: 'SidebarNavItem',
                href: '/settings',
                background: (el)=>window.location.pathname === '/settings' ? 'greenBg' : 'transparent',
                NavIcon: {
                    icon: 'settings',
                    color: (el)=>window.location.pathname === '/settings' ? 'green' : 'textSoft'
                },
                NavLabel: {
                    text: '{{ sidebarSettings | polyglot }}',
                    color: (el)=>window.location.pathname === '/settings' ? 'green' : 'textSoft',
                    fontWeight: (el)=>window.location.pathname === '/settings' ? '600' : '500'
                }
            }
        }
    },
    BottomSection: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        padding: 'A',
        borderTop: '1px solid surfaceBorderStrong',
        '@tabletS': {
            display: 'none'
        },
        AvatarCircle: {
            width: 'B',
            height: 'B',
            borderRadius: '100%',
            background: 'greenBg',
            color: 'green',
            flow: 'x',
            align: 'center center',
            fontSize: 'Z',
            fontWeight: '700',
            text: (el, s)=>s.root.firm.initials,
            flexShrink: '0'
        },
        UserInfo: {
            flow: 'y',
            gap: '0',
            flex: '1',
            UserName: {
                text: (el, s)=>s.root.firm.lawyer,
                fontSize: 'Z',
                fontWeight: '600',
                color: 'text'
            },
            LogoutLink: {
                extends: 'Link',
                href: '/',
                text: '{{ sidebarLogout | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                textDecoration: 'none',
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: false
                    })
            }
        }
    }
};


var $3e7d9d0c898609d2$exports = {};

$parcel$export($3e7d9d0c898609d2$exports, "SidebarNavItem", () => $3e7d9d0c898609d2$export$1e8e95432f1f72fa);
const $3e7d9d0c898609d2$export$1e8e95432f1f72fa = {
    extends: 'Link',
    flow: 'x',
    gap: 'Z',
    align: 'center',
    padding: 'Z A',
    borderRadius: 'Z',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background 150ms, border 150ms',
    '@tabletS': {
        padding: 'Z',
        justifyContent: 'center'
    },
    NavIcon: {
        extends: 'Icon',
        width: 'A',
        height: 'A',
        color: 'textSoft'
    },
    NavLabel: {
        fontSize: 'A',
        fontWeight: '500',
        color: 'textSoft',
        '@tabletS': {
            display: 'none'
        }
    }
};


var $ec3f9d7c7c1f789a$exports = {};

$parcel$export($ec3f9d7c7c1f789a$exports, "StatCard", () => $ec3f9d7c7c1f789a$export$b5cddb1a6bf990a0);
const $ec3f9d7c7c1f789a$export$b5cddb1a6bf990a0 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A B',
    background: 'surfaceBorder',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    flex: '1',
    minWidth: 'E',
    StatValue: {
        tag: 'span',
        fontSize: 'B',
        fontWeight: '800',
        color: 'green'
    },
    StatLabel: {
        fontSize: 'Z',
        color: 'textSoft'
    }
};


var $5981d6f3f1a42892$exports = {};

$parcel$export($5981d6f3f1a42892$exports, "StatusChip", () => $5981d6f3f1a42892$export$fd5345d4562e9833);
$parcel$export($5981d6f3f1a42892$exports, "StatusConfirmed", () => $5981d6f3f1a42892$export$872b1e036f2374c9);
$parcel$export($5981d6f3f1a42892$exports, "StatusPending", () => $5981d6f3f1a42892$export$4d17129c98f9758e);
$parcel$export($5981d6f3f1a42892$exports, "StatusActive", () => $5981d6f3f1a42892$export$cf45ffb1c7eaff53);
$parcel$export($5981d6f3f1a42892$exports, "StatusClosed", () => $5981d6f3f1a42892$export$24e52d5ee0a61c69);
const $5981d6f3f1a42892$export$fd5345d4562e9833 = {
    tag: 'span',
    padding: 'Y Z',
    borderRadius: 'Z',
    fontSize: 'Y',
    fontWeight: '600'
};
const $5981d6f3f1a42892$export$872b1e036f2374c9 = {
    extends: 'StatusChip',
    background: 'greenBg',
    color: 'green',
    border: '1px solid greenBorder'
};
const $5981d6f3f1a42892$export$4d17129c98f9758e = {
    extends: 'StatusChip',
    background: 'amberBg',
    color: 'amber',
    border: '1px solid amberBorder'
};
const $5981d6f3f1a42892$export$cf45ffb1c7eaff53 = {
    extends: 'StatusChip',
    background: 'greenBg',
    color: 'green',
    border: '1px solid greenBorder'
};
const $5981d6f3f1a42892$export$24e52d5ee0a61c69 = {
    extends: 'StatusChip',
    background: 'surfaceBorder',
    color: 'textMuted',
    border: '1px solid surfaceBorderStrong'
};


var $532d64a7f4495861$exports = {};

$parcel$export($532d64a7f4495861$exports, "QuickActionBtn", () => $532d64a7f4495861$export$3c0575ff673af3f5);
const $532d64a7f4495861$export$3c0575ff673af3f5 = {
    extends: 'Link',
    flow: 'x',
    gap: 'Z',
    align: 'center center',
    padding: 'Z A',
    background: 'surfaceBorder',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    color: 'text',
    fontSize: 'A',
    fontWeight: '500',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background 150ms',
    href: '#',
    ActionIcon: {
        extends: 'Icon',
        icon: 'plus',
        width: 'Z',
        height: 'Z',
        color: 'green'
    },
    ActionText: {}
};


var $d39763d811cd1e53$exports = {};

$parcel$export($d39763d811cd1e53$exports, "PricingCard", () => $d39763d811cd1e53$export$668dae926a178a9f);
$parcel$export($d39763d811cd1e53$exports, "PricingCardHighlighted", () => $d39763d811cd1e53$export$9230686bb0bde3e8);
const $d39763d811cd1e53$export$668dae926a178a9f = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    background: 'surfaceBorder',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    flex: '1',
    minWidth: 'F',
    BadgeText: {
        if: false,
        color: 'green',
        fontSize: 'Z',
        fontWeight: '700'
    },
    TierName: {
        fontSize: 'B',
        fontWeight: '600',
        color: 'text'
    },
    TierTarget: {
        fontSize: 'A',
        color: 'textMuted'
    },
    TierPrice: {
        tag: 'span',
        fontSize: 'C',
        fontWeight: '800',
        color: 'text'
    },
    TierPeriod: {
        text: "\u10D7\u10D5\u10D4\u10E8\u10D8",
        fontSize: 'A',
        color: 'textMuted'
    },
    FeaturesList: {
        flow: 'y',
        gap: 'Z',
        padding: 'A 0 0 0',
        borderTop: '1px solid surfaceBorderStrong',
        childExtends: {
            fontSize: 'A',
            color: 'textSoft',
            lineHeight: '1.5'
        }
    },
    TierCta: {
        extends: 'Link',
        href: '/dashboard',
        text: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u2192",
        background: 'transparent',
        color: 'text',
        border: '1px solid surfaceBorderStrong',
        padding: 'Z A',
        fontSize: 'A',
        borderRadius: 'Z',
        width: '100%',
        textAlign: 'center',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'transform 200ms',
        ':hover': {
            transform: 'scale(0.98)'
        },
        onClick: (e, el, s)=>s.root.update({
                loggedIn: true
            })
    }
};
const $d39763d811cd1e53$export$9230686bb0bde3e8 = {
    extends: 'PricingCard',
    background: 'greenBg',
    border: '2px solid green',
    TierPrice: {
        color: 'green'
    },
    TierCta: {
        background: 'green',
        color: 'neutral950',
        border: '1px solid green'
    }
};


var $b11e431348e0cc21$exports = {};

$parcel$export($b11e431348e0cc21$exports, "ThemeToggle", () => $b11e431348e0cc21$export$173e0a822059eddc);
const $b11e431348e0cc21$export$173e0a822059eddc = {
    extends: 'Button',
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    padding: 'Y Z',
    fontSize: 'Z',
    borderRadius: 'Z',
    cursor: 'pointer',
    background: 'surfaceBorder',
    border: '1px solid surfaceBorderStrong',
    color: 'textSoft',
    text: (el, s)=>s.root.darkMode !== false ? "\u2600" : "\u263E",
    onClick: (e, el, s)=>{
        const isDark = s.root.darkMode !== false;
        s.root.update({
            darkMode: !isDark
        });
        document.documentElement.setAttribute('theme', isDark ? 'light' : 'dark');
    }
};


var $9bc8f6741bc9ecc2$exports = {};

$parcel$export($9bc8f6741bc9ecc2$exports, "LawyerCard", () => $9bc8f6741bc9ecc2$export$3c307f982e6589a4);
const $9bc8f6741bc9ecc2$export$3c307f982e6589a4 = {
    extends: 'Link',
    href: (el, s)=>'/lawyer?id=' + s.id,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    theme: 'card',
    cursor: 'pointer',
    transition: 'all 0.25s ease',
    border: (el, s)=>s.isSubscribed ? '1px solid green.3' : '1px solid transparent',
    ':hover': {
        boxShadow: 'black.08 0 Z B',
        transform: 'translateY(-2px)'
    },
    CardHeader: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'A',
        HeaderLeft: {
            flow: 'x',
            align: 'flex-start flex-start',
            gap: 'A',
            flex: '1',
            minWidth: '0',
            LawyerAvatar: {
                tag: 'img',
                width: 'C',
                height: 'C',
                round: 'C',
                flexShrink: '0',
                objectFit: 'cover',
                src: (el, s)=>s.photoUrl || s.avatar || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn) + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
            },
            NameGroup: {
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                LawyerName: {
                    text: (el, s)=>s.nameEn,
                    fontSize: 'A',
                    fontWeight: '600',
                    letterSpacing: '-0.01em'
                },
                LawyerNameKa: {
                    text: (el, s)=>s.nameKa,
                    fontSize: 'Z',
                    opacity: '0.6'
                },
                FirmRow: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    LawyerFirm: {
                        text: (el, s)=>s.firmNameEn || 'Independent',
                        fontSize: 'Z',
                        opacity: '0.5',
                        fontStyle: (el, s)=>s.firmNameEn ? 'normal' : 'italic'
                    },
                    VerifiedBadge: {
                        show: (el, s)=>s.isSubscribed,
                        text: '\u2605 Verified',
                        fontSize: 'X',
                        fontWeight: '700',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        padding: 'V Y',
                        background: 'greenBg',
                        round: 'W'
                    }
                }
            }
        },
        StatusRating: {
            flow: 'y',
            gap: 'Z',
            align: 'flex-end flex-end',
            flexShrink: '0',
            RatingBadge: {
                flow: 'x',
                gap: 'Y',
                align: 'center center',
                padding: 'Y Z',
                round: 'Z',
                theme: 'success',
                show: (el, s)=>s.reviews > 40,
                RatingStar: {
                    text: '\u2605',
                    fontSize: 'Z'
                },
                RatingVal: {
                    text: (el, s)=>String(s.rating),
                    fontSize: 'Z',
                    fontWeight: '600'
                }
            },
            StatusBadge: {
                flow: 'x',
                gap: 'Y',
                align: 'center center',
                StatusDot: {
                    width: 'Y',
                    height: 'Y',
                    borderRadius: '100%',
                    background: (el, s)=>s.status === 'active' ? 'green' : 'red'
                },
                StatusText: {
                    text: (el, s)=>s.status,
                    fontSize: 'Z',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: (el, s)=>s.status === 'active' ? 'green' : 'red'
                }
            }
        }
    },
    CardMeta: {
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        align: 'center flex-start',
        marginTop: 'Z',
        opacity: '0.6',
        fontSize: 'Z',
        MetaCity: {
            text: (el, s)=>s.city
        },
        MetaDot1: {
            text: '\u00B7'
        },
        MetaReviews: {
            text: (el, s)=>s.reviews + ' reviews'
        },
        MetaDot2: {
            text: '\u00B7'
        },
        MetaBarId: {
            text: (el, s)=>s.barId
        }
    },
    CardSpecializations: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        marginTop: 'Z',
        children: (el, s)=>(s.specializations || []).slice(0, 3).map((sp)=>({
                    label: sp
                })),
        childrenAs: 'state',
        childProps: {
            text: (el, s)=>s.label,
            fontSize: 'Z',
            padding: 'Y Z',
            round: 'C',
            theme: 'secondary',
            fontWeight: '500'
        }
    }
};


var $9e21a4fe46547042$exports = {};

$parcel$export($9e21a4fe46547042$exports, "FirmCard", () => $9e21a4fe46547042$export$1de24f5e36d66330);
const $9e21a4fe46547042$export$1de24f5e36d66330 = {
    extends: 'Link',
    href: (el, s)=>'/firm?id=' + s.id,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    theme: 'card',
    cursor: 'pointer',
    transition: 'all 0.25s ease',
    ':hover': {
        boxShadow: 'black.08 0 Z B',
        transform: 'translateY(-2px)'
    },
    CardHeader: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Z',
        FirmLogo: {
            tag: 'img',
            width: 'C1',
            height: 'C1',
            round: 'Z',
            flexShrink: '0',
            src: (el, s)=>s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn) + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
        },
        NameGroup: {
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            FirmName: {
                text: (el, s)=>s.nameEn,
                fontSize: 'A',
                fontWeight: '700',
                letterSpacing: '-0.01em'
            },
            FirmNameKa: {
                text: (el, s)=>s.nameKa,
                fontSize: 'Y',
                opacity: '0.6'
            },
            FirmCity: {
                flow: 'x',
                gap: 'W',
                align: 'center flex-start',
                CityDot: {
                    text: '\u2022',
                    fontSize: 'Y',
                    opacity: '0.4'
                },
                CityText: {
                    text: (el, s)=>s.city,
                    fontSize: 'Y',
                    opacity: '0.5'
                },
                YearDot: {
                    text: '\u2022',
                    fontSize: 'Y',
                    opacity: '0.4'
                },
                YearText: {
                    text: (el, s)=>s.foundedYear ? 'Est. ' + s.foundedYear : '',
                    fontSize: 'Y',
                    opacity: '0.5'
                }
            }
        }
    },
    CardMeta: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        marginTop: 'Y',
        opacity: '0.6',
        fontSize: 'Y',
        MetaLawyers: {
            text: (el, s)=>(s.lawyerCount || 0) + ' lawyers'
        },
        MetaDot: {
            text: '\u00B7'
        },
        MetaPhone: {
            text: (el, s)=>s.phone
        }
    },
    CardAreas: {
        flow: 'x',
        gap: 'W',
        flexWrap: 'wrap',
        marginTop: 'Y',
        children: (el, s)=>(s.practiceAreas || []).slice(0, 4).map((a)=>({
                    label: a
                })),
        childrenAs: 'state',
        childProps: {
            text: (el, s)=>s.label,
            fontSize: 'Y',
            padding: 'V Y',
            round: 'C',
            theme: 'secondary',
            fontWeight: '500'
        }
    }
};


var $c271a94a78f00513$exports = {};

$parcel$export($c271a94a78f00513$exports, "DirectoryCard", () => $c271a94a78f00513$export$9e70dcebe7eb40cd);
const $c271a94a78f00513$export$9e70dcebe7eb40cd = {
    extends: 'Link',
    href: (el, s)=>(s._type === 'firm' ? '/firm' : '/lawyer') + '?slug=' + (s.slug || s.id),
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    theme: 'card',
    cursor: 'pointer',
    transition: 'all 0.25s ease',
    border: (el, s)=>s.isSubscribed ? '1px solid green.3' : '1px solid transparent',
    ':hover': {
        boxShadow: 'black.08 0 Z B',
        transform: 'translateY(-2px)'
    },
    CardHeader: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'A',
        HeaderLeft: {
            flow: 'x',
            align: 'flex-start flex-start',
            gap: 'A',
            flex: '1',
            minWidth: '0',
            Avatar: {
                tag: 'img',
                width: 'C',
                height: 'C',
                round: (el, s)=>s._type === 'firm' ? 'Z' : 'C',
                flexShrink: '0',
                objectFit: 'cover',
                src: (el, s)=>s.photoUrl || s.avatar || s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn || '') + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
            },
            NameGroup: {
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                Name: {
                    text: (el, s)=>s.nameEn,
                    fontSize: 'A',
                    fontWeight: '600',
                    letterSpacing: '-0.01em'
                },
                NameKa: {
                    text: (el, s)=>s.nameKa,
                    fontSize: 'Z',
                    opacity: '0.6'
                },
                SubLine: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    SubText: {
                        text: (el, s)=>{
                            if (s._type === 'firm') {
                                const parts = [
                                    s.city
                                ];
                                if (s.foundedYear) parts.push('Est. ' + s.foundedYear);
                                return parts.join(' \u00B7 ');
                            }
                            return s.firmNameEn || 'Independent';
                        },
                        fontSize: 'Z',
                        opacity: '0.5',
                        fontStyle: (el, s)=>s._type !== 'firm' && !s.firmNameEn ? 'italic' : 'normal'
                    },
                    VerifiedBadge: {
                        show: (el, s)=>s.isSubscribed,
                        text: '\u2605 Verified',
                        fontSize: 'X',
                        fontWeight: '700',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        padding: 'V Y',
                        background: 'greenBg',
                        round: 'W'
                    }
                }
            }
        },
        StatusRating: {
            show: (el, s)=>s._type !== 'firm',
            flow: 'y',
            gap: 'Z',
            align: 'flex-end flex-end',
            flexShrink: '0',
            RatingBadge: {
                flow: 'x',
                gap: 'Y',
                align: 'center center',
                padding: 'Y Z',
                round: 'Z',
                theme: 'success',
                show: (el, s)=>s.reviews > 40,
                RatingStar: {
                    text: '\u2605',
                    fontSize: 'Z'
                },
                RatingVal: {
                    text: (el, s)=>String(s.rating),
                    fontSize: 'Z',
                    fontWeight: '600'
                }
            },
            StatusBadge: {
                flow: 'x',
                gap: 'Y',
                align: 'center center',
                StatusDot: {
                    width: 'Y',
                    height: 'Y',
                    borderRadius: '100%',
                    background: (el, s)=>s.status === 'active' ? 'green' : 'red'
                },
                StatusText: {
                    text: (el, s)=>s.status,
                    fontSize: 'Z',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: (el, s)=>s.status === 'active' ? 'green' : 'red'
                }
            }
        }
    },
    CardMeta: {
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        align: 'center flex-start',
        marginTop: 'Z',
        opacity: '0.6',
        fontSize: 'Z',
        MetaCity: {
            text: (el, s)=>s.city
        },
        MetaDot1: {
            text: '\u00B7'
        },
        MetaDetail: {
            text: (el, s)=>{
                if (s._type === 'firm') return (s.lawyerCount || 0) + ' lawyers';
                return (s.reviews || 0) + ' reviews';
            }
        },
        MetaDot2: {
            show: (el, s)=>s._type !== 'firm',
            text: '\u00B7'
        },
        MetaExtra: {
            show: (el, s)=>s._type !== 'firm',
            text: (el, s)=>s.barId || ''
        },
        MetaPhone: {
            show: (el, s)=>s._type === 'firm' && s.phone,
            text: (el, s)=>'\u00B7 ' + (s.phone || '')
        }
    },
    CardTags: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        marginTop: 'Z',
        children: (el, s)=>{
            const tags = s._type === 'firm' ? s.practiceAreas || [] : s.specializations || [];
            return tags.slice(0, 3).map((t)=>({
                    label: t
                }));
        },
        childrenAs: 'state',
        childProps: {
            text: (el, s)=>s.label,
            fontSize: 'Z',
            padding: 'Y Z',
            round: 'C',
            theme: 'secondary',
            fontWeight: '500'
        }
    }
};


$parcel$exportWildcard($b940b823876787d8$exports, $d5e26d212c5263dc$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a45233490d2462db$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $3e7d9d0c898609d2$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ec3f9d7c7c1f789a$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $5981d6f3f1a42892$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $532d64a7f4495861$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d39763d811cd1e53$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b11e431348e0cc21$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9bc8f6741bc9ecc2$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9e21a4fe46547042$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $c271a94a78f00513$exports);


var $5006d5ef181f83de$exports = {};


const $8d2c7cae8dfd7a3b$export$a9ae88069d8ac14e = {
    extends: 'Page',
    flow: 'y',
    background: 'surface',
    LandingNav: {},
    // ═══════════════════════════════════════════════════
    // HERO — Good Fella style: big text left, ASCII art right
    // ═══════════════════════════════════════════════════
    HeroSection: {
        tag: 'section',
        flow: 'x',
        align: 'flex-end',
        gap: 'C',
        padding: 'F D E D',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        maxWidth: 'K',
        margin: '0 auto',
        width: '100%',
        '@tabletS': {
            padding: 'E B D B'
        },
        '@mobileL': {
            flow: 'y',
            padding: 'D A C A',
            gap: 'B'
        },
        HeroLeft: {
            flow: 'y',
            gap: 'B',
            flex: '1',
            zIndex: '1',
            HeroTitle: {
                tag: 'h1',
                flow: 'y',
                gap: '0',
                TitleLine1: {
                    text: '{{ heroLine1 | polyglot }}',
                    fontSize: 'C',
                    fontWeight: '300',
                    color: 'text',
                    lineHeight: '1.15',
                    letterSpacing: '-Z',
                    '@mobileL': {
                        fontSize: 'B'
                    }
                },
                TitleLine2: {
                    text: '{{ heroLine2 | polyglot }}',
                    fontSize: 'C',
                    fontWeight: '300',
                    color: 'text',
                    lineHeight: '1.15',
                    letterSpacing: '-Z',
                    '@mobileL': {
                        fontSize: 'B'
                    }
                },
                TitleLine3: {
                    text: '{{ heroLine3 | polyglot }}',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1.15',
                    letterSpacing: '-Z',
                    '@mobileL': {
                        fontSize: 'B'
                    }
                }
            },
            HeroDesc: {
                text: '{{ heroSubtitle | polyglot }}',
                fontSize: 'A',
                color: 'textMuted',
                lineHeight: '1.6',
                maxWidth: 'H'
            },
            HeroCtas: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flow: 'y',
                    width: '100%'
                },
                TrialLink: {
                    extends: 'Link',
                    href: '/login',
                    text: '{{ tryFree | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    padding: 'Z B',
                    fontSize: 'Z',
                    fontWeight: '600',
                    borderRadius: 'B',
                    textDecoration: 'none',
                    transition: 'transform 200ms',
                    ':hover': {
                        transform: 'scale(0.98)'
                    },
                    '@mobileL': {
                        width: '100%',
                        textAlign: 'center'
                    }
                },
                DemoLink: {
                    extends: 'Link',
                    href: '/dashboard',
                    text: '{{ liveDemo | polyglot }}',
                    background: 'transparent',
                    color: 'text',
                    border: '1px solid surfaceBorderStrong',
                    padding: 'Z B',
                    fontSize: 'Z',
                    fontWeight: '500',
                    borderRadius: 'B',
                    textDecoration: 'none',
                    transition: 'transform 200ms',
                    ':hover': {
                        transform: 'scale(0.98)'
                    },
                    onClick: (e, el, s)=>s.root.update({
                            loggedIn: true
                        }),
                    '@mobileL': {
                        width: '100%',
                        textAlign: 'center'
                    }
                }
            }
        },
        // Trust bar — pinned to bottom of hero, visible above the fold
        TrustBar: {
            tag: 'section',
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            flow: 'x',
            gap: 'B',
            padding: 'A D',
            align: 'center',
            background: 'black .75',
            backdropFilter: 'blur(8px)',
            borderTop: '1px solid surfaceBorderStrong',
            zIndex: '2',
            '@mobileL': {
                flow: 'y',
                padding: 'A',
                gap: 'Z'
            },
            TrustLabel: {
                text: '{{ trustedBrands | polyglot }}',
                fontSize: 'Y',
                color: 'textMuted',
                textTransform: 'uppercase',
                letterSpacing: 'X',
                flex: '1',
                '@mobileL': {
                    textAlign: 'center'
                }
            },
            TrustLogos: {
                flow: 'x',
                gap: 'C',
                align: 'center',
                opacity: '.5',
                '@mobileL': {
                    gap: 'A',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                },
                Logo1: {
                    text: "\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'text'
                },
                Logo2: {
                    text: 'LegalHub',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'text'
                },
                Logo3: {
                    text: 'JustiCo',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'text'
                }
            }
        },
        // ASCII Lady Justice
        HeroAscii: {
            position: 'absolute',
            top: '0',
            right: '0',
            bottom: '0',
            width: '65%',
            overflow: 'visible',
            pointerEvents: 'none',
            '@mobileL': {
                display: 'none'
            },
            AsciiArt: {
                tag: 'pre',
                position: 'absolute',
                top: 'C',
                right: '0',
                overflow: 'visible',
                fontFamily: 'monospace',
                fontSize: 'B',
                lineHeight: '1.2',
                color: 'green',
                whiteSpace: 'pre',
                textAlign: 'left',
                text: '                                                                             .:                            \n                                                                            .*#:                           \n                                                                             #%.                           \n                                                                           :=*%:                           \n                                                                           *%%%%.                          \n                                                                           *#%%%-                          \n                                                                            -*@@:                          \n                                                      .::                   -*@%                           \n                                                  +*+*##*#%*                **%=                           \n                                                .**%*#%#%%%@%=            :**#%                            \n                                                *#%**%%%%##%@:           -#=*%-                            \n                                                :%*%%*=+****#           -%=*#%-                            \n                                                 =*#%+==%%%##          :%#*#*%=                            \n                                                 :*%%==#%#%%*        :*+=*%-#%%                            \n                                                :#@@*%**%%%%       .*+%%%* :%+:                            \n                                               .*%*@*-*@@%=:     :*+#@%%=%@%-:%-=-                         \n                                               +#%#@#=%*%:     :**#%%%=--..*%@@%@*@*-#                     \n                                              =*%@#%=:*-%#.  =%#*%*##*-     -:   =+:*=                     \n                                             :*%#++#+-##%%***#***#*::+:             +:                     \n                                          :*=+*+=*+==++*++=+*+*%%=  .=-             ==                     \n                                         :-:#*#*==**+++==+++++*%+   :=-.            -=                     \n                                        :=:%%%+====+:--**+=--=%*    :=::            :::                    \n                                        ==%%@@@*=-. #%##**#*%+=%    :-.=           ::.:                    \n                                       -=*+#--@***-*%#+#*#**=###   ..:.-           ::.:                    \n                                      ::*=*= :@*#**+*##*#**+*#%=   - :..:          :.::                    \n                                     -:+=*-  :*++****++#**=+**#:   = :: :          :.::.                   \n                                    ::+*#=    #@#**=%%%#**=*##     : :: :         ...:.:                   \n                                   .:+#%-     .*%*+*##%%###*#*    .: :: -         . .: =                   \n                                  :=**%:    ==%%%*+**#%***#%%     .. .: :.        : .: -                   \n                                 +=*#*:    :#*#%*=+=-++***%%%.    :  .:  :        - .: ..                  \n                                =***#=     :**#*+=*##+*=+#%#*=    =  .:  =        :  :  :                  \n                               -=*-*=      =*+*==-*#%%==*#%*%=    =   :  .       :.  :  :                  \n                              :=*=*:       =-*-:++=#%%=.=#**#-   ::   :  ..      -   -  :                  \n                             :-+-*.       =*+::--*+*#%*:+#*%#=   -    :   :      :   -  ..                 \n                             -+=+         :*:..=*#***#*+*****=   :    :   -      :   -   :                 \n                       :-=  -=::          :*:..*###%*%*#%#%#*=  .-::====+***:   :++**####%*                \n                        -=:::==           +*=..*#+*%%%%%*%#*#=   .*%%%%%%%*       -%%%%%+.                 \n                         :+:#*            **-::##:+*%%%++#****:      .:.                                   \n                         :==**=           **-=*%#.-*##*=***+##*                                            \n                          =*#*= .==       *#+**%#:+*%*+=**+#*#=                                            \n                           :==+++:        *+=***#=**%==***+=**%.                                           \n                          :-+**=+.        *#=*****#%*++*#=***+%*                                           \n                          .   =+#*:       %%+*****#@*=%*=:+***%*                                           \n                               :+**:     =@%=*##**%@**##:*+*+*%%:                                          \n                                :***-   =%@%****#*%@#%%#==#%*=*%+                                          \n                                 :**#- =*@@%#*=**#%@%%@%*#@%#=*#:                                          \n                                  :*#****@@@%%*:+*%@%%@@%%*%%===                                           \n                                   :*****%@@%%%*-**@@%@@%%+*%===                                           \n                                    :##***@@%%%%++*#@%@%%@%=%+:=                                           \n                                   .+%##**@@%#%%*+*%%%%%%@@%%#+:                                           \n                                    +**##*#@%*%@#**%%#%@@@@#**%.                                           \n                                     =**##**%#%@@*%@%*%@@@@@@%:                                            \n                                      .*%##**%@@@#*%@**@@@%@@+                                             \n                                       -*###*++%@@*%@%*%@%@@#                                              \n                                     .==+##%%++%@%%#@%*%@%@%.                                              \n                                    :=-:-+*%##++@##%@**%@@%:                                               \n                                    .-=--=*##%%+=%%@%**%@@-                                                \n                                    :==-=+%#=%#%+=%%%##@@#                                                 \n                                     *=-+#@%+*%##==%*%%@%*                                                 \n                                     +==*%@@*=%#%#+=*#%@@%+                                                \n                                     =-+*#@@%=##@%#+=*%@@@**.                                              \n                                     -+#*#@@@+*%%%%#+-*%@@@%@*                                             \n                                     =%%%##%@#+%%%@%#+-#%%@%@@%.                                           \n                                      *%%***@%+%%@@@%%*-%@@@@@@**+*++-                                     \n                                       --=*##@%%#@@@@%#+:%@@@@@@@@@@%%                                     \n                                         :*%%@%%%%@@@@%%+-*%@@@@@@@%%#                                     \n                                          .*@@@*-*%@@@@%%+-+*%@@%%@@%=                                     \n                                       +%%%%@@@%=-+*%@%@%%+-%@%#*#%%@%+                                    \n                                   =*=*#@@@%%%%@%***#%%%%@@++%@@%@%%%%%%*=.                                \n                                   -*#%%%%##%%%%%%%@%%%#%@%@*%%%%%%%%%%%%##%%.                             \n                                  *%%%%%%%%%%%%%%#%%%%#%##%%%%%%%%%%%%%%%%%%@*+=                           \n                              *###%%%%%%%%%%%%%%%%%%##**%%%%%%%%%%%%%%%%#####%%%:                          \n                              *#####%###############****%%%####*****##########%%:                          \n                              +###%#%%#####*###########*###******#########%%%%%%:                          \n                              =##########******###**#***#####**#%#########%##%%%-                          \n                               :-==+*****************####%%%%########***=-::.                              \n                                            .:::-==++**##%#*+=-:.                                          ',
                onRender: (el)=>{
                    if (el.__animInit) return;
                    el.__animInit = true;
                    if (!el.node) return;
                    setTimeout(function() {
                        var txt = el.node.textContent;
                        el.node.textContent = '';
                        var spans = [];
                        var row = 0;
                        var col = 0;
                        for(var i = 0; i < txt.length; i++){
                            var c = txt[i];
                            if (c === '\n') {
                                el.node.appendChild(document.createTextNode('\n'));
                                row++;
                                col = 0;
                            } else if (c !== ' ') {
                                var s = document.createElement('span');
                                s.textContent = c;
                                s.style.display = 'inline-block';
                                s.style.width = '1ch';
                                s.style.textAlign = 'center';
                                s._row = row;
                                s._col = col;
                                el.node.appendChild(s);
                                spans.push(s);
                                col++;
                            } else {
                                var sp = document.createElement('span');
                                sp.textContent = ' ';
                                sp.style.display = 'inline-block';
                                sp.style.width = '1ch';
                                el.node.appendChild(sp);
                                col++;
                            }
                        }
                        var mouseX = -1000;
                        var mouseY = -1000;
                        var preRect = null;
                        setTimeout(function() {
                            var hero = el.node.closest('section') || document.body;
                            hero.addEventListener('mousemove', function(e) {
                                preRect = el.node.getBoundingClientRect();
                                mouseX = e.clientX;
                                mouseY = e.clientY;
                            });
                            hero.addEventListener('mouseleave', function() {
                                mouseX = -1000;
                                mouseY = -1000;
                            });
                        }, 100);
                        for(var k = 0; k < spans.length; k++){
                            spans[k]._tx = 0;
                            spans[k]._ty = 0;
                            spans[k].style.transition = 'transform 0.4s ease-out';
                        }
                        var draw = function(time) {
                            var t = time * 0.0008;
                            if (!preRect) preRect = el.node.getBoundingClientRect();
                            for(var j = 0; j < spans.length; j++){
                                var s = spans[j];
                                var w1 = Math.sin(s._row * 0.15 + t * 1.8 + s._col * 0.03);
                                var w2 = Math.cos(s._col * 0.1 + t * 1.3 + s._row * 0.05);
                                var w3 = Math.sin((s._row + s._col) * 0.08 + t * 0.7);
                                var mix = (w1 + w2 + w3) / 3;
                                var brightness = 0.15 + (mix * 0.5 + 0.5) * 0.7;
                                var hueShift = Math.sin(t * 0.5 + s._row * 0.04) * 0.3;
                                var r = Math.floor((198 + hueShift * 60) * brightness);
                                var g = Math.floor((172 - hueShift * 20) * brightness);
                                var b = Math.floor((143 - hueShift * 40) * brightness);
                                r = Math.min(255, Math.max(0, r));
                                g = Math.min(255, Math.max(0, g));
                                b = Math.min(255, Math.max(0, b));
                                s.style.color = 'rgb(' + r + ',' + g + ',' + b + ')';
                                var sx = preRect.left + s._col * (s.offsetWidth || 10);
                                var sy = preRect.top + s._row * (s.offsetHeight || 20);
                                var dx = sx - mouseX;
                                var dy = sy - mouseY;
                                var dist = Math.sqrt(dx * dx + dy * dy);
                                var radius = 150;
                                if (dist < radius && mouseX > -999) {
                                    var force = 1 - dist / radius;
                                    var hr = Math.floor(255 * force + r * (1 - force));
                                    var hg = Math.floor(230 * force + g * (1 - force));
                                    var hb = Math.floor(200 * force + b * (1 - force));
                                    s.style.color = 'rgb(' + hr + ',' + hg + ',' + hb + ')';
                                }
                            }
                            requestAnimationFrame(draw);
                        };
                        requestAnimationFrame(draw);
                    }, 200);
                }
            }
        }
    },
    // Lawyer search bar
    LawyerSearch: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        gap: 'X2',
        padding: 'D D',
        background: 'surfaceMid',
        borderTop: '1px solid surfaceBorderStrong',
        borderBottom: '1px solid surfaceBorderStrong',
        '@mobileL': {
            padding: 'B A'
        },
        maxWidth: 'K',
        width: '100%',
        margin: '0 auto',
        SearchTitle: {
            text: '{{ findLawyer | polyglot }}',
            fontSize: 'C',
            fontWeight: '700',
            color: 'text'
        },
        SearchSub: {
            text: (el, s)=>{
                const l = s.root.totalLawyers || (s.root.lawyers || []).length;
                const f = s.root.totalFirms || (s.root.firms || []).length;
                const lStr = l > 0 ? l.toLocaleString() + '+' : '5,700+';
                const fStr = f > 0 ? f.toLocaleString() + '+' : '300+';
                return lStr + " Lawyers \xb7 " + fStr + ' Firms registered in Georgia';
            },
            fontSize: 'A',
            color: 'textMuted'
        },
        SearchRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            width: '100%',
            maxWidth: 'J',
            margin: 'A -',
            '@mobileL': {
                flow: 'y'
            },
            SearchInput: {
                tag: 'input',
                type: 'text',
                placeholder: '{{ searchPlaceholder | polyglot }}',
                flex: '1',
                padding: 'Z A',
                fontSize: 'A',
                borderRadius: 'Z',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                color: 'text',
                outline: 'none',
                onInput: (e, el, s)=>s.root.update({
                        directoryFilter: el.node.value
                    }),
                onKeyDown: (e, el, s)=>{
                    if (e.key === 'Enter') {
                        const q = el.node.value.trim();
                        s.root.update({
                            directoryFilter: q
                        });
                        window.location.href = q ? '/lawyers?q=' + encodeURIComponent(q) : '/lawyers';
                    }
                }
            },
            SearchBtn: {
                tag: 'button',
                text: '{{ searchBtn | polyglot }}',
                background: 'green',
                color: 'neutral950',
                border: 'none',
                fontWeight: '600',
                padding: 'Z B',
                fontSize: 'A',
                borderRadius: 'Z',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                onClick: (e, el, s)=>{
                    const input = el.parent?.SearchInput?.node;
                    const q = (input ? input.value : s.root.directoryFilter || '').trim();
                    s.root.update({
                        directoryFilter: q
                    });
                    window.location.href = q ? '/lawyers?q=' + encodeURIComponent(q) : '/lawyers';
                }
            }
        },
        QuickFilters: {
            flow: 'x',
            gap: 'Y',
            flexWrap: 'wrap',
            align: 'center center',
            childExtends: 'Link',
            childProps: {
                textDecoration: 'none',
                padding: 'Y Z',
                fontSize: 'Z',
                borderRadius: 'Z',
                background: 'transparent',
                color: 'textMuted',
                border: '1px solid surfaceBorderStrong',
                ':hover': {
                    borderColor: 'green',
                    color: 'green'
                }
            },
            F1: {
                href: '/lawyers?area=Corporate+Law',
                text: 'Corporate Law'
            },
            F2: {
                href: '/lawyers?area=Criminal+Law',
                text: 'Criminal Law'
            },
            F3: {
                href: '/lawyers?area=Family+Law',
                text: 'Family Law'
            },
            F4: {
                href: '/lawyers?area=Real+Estate',
                text: 'Real Estate'
            },
            F5: {
                href: '/lawyers?area=Immigration',
                text: 'Immigration'
            },
            F6: {
                href: '/lawyers',
                text: "{{ viewAll | polyglot }} \u2192"
            }
        },
        // ── Preview listings with gradient fade ──────────────
        PreviewWrap: {
            position: 'relative',
            width: '100%',
            maxWidth: 'K',
            margin: 'B auto 0',
            overflow: 'hidden',
            PreviewGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                '@tabletS': {
                    gridTemplateColumns: 'repeat(2, 1fr)'
                },
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                gap: 'B',
                pointerEvents: 'none',
                children: [
                    {
                        nameEn: 'Giorgi Beridze',
                        nameKa: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10D1\u10D4\u10E0\u10D8\u10EB\u10D4",
                        firmNameEn: 'Beridze & Partners',
                        city: 'Tbilisi',
                        specializations: [
                            'Corporate Law',
                            'M&A'
                        ],
                        rating: 4.9,
                        reviews: 87,
                        status: 'active',
                        isSubscribed: true,
                        barId: 'GBA-1042'
                    },
                    {
                        nameEn: 'Nino Tsiklauri',
                        nameKa: "\u10DC\u10D8\u10DC\u10DD \u10EC\u10D8\u10D9\u10DA\u10D0\u10E3\u10E0\u10D8",
                        firmNameEn: 'Tsiklauri Law Group',
                        city: 'Tbilisi',
                        specializations: [
                            'Family Law',
                            'Civil Law'
                        ],
                        rating: 4.7,
                        reviews: 61,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-2318'
                    },
                    {
                        nameEn: 'David Kvaratskhelia',
                        nameKa: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
                        firmNameEn: null,
                        city: 'Kutaisi',
                        specializations: [
                            'Criminal Law',
                            'Human Rights'
                        ],
                        rating: 4.8,
                        reviews: 54,
                        status: 'active',
                        isSubscribed: true,
                        barId: 'GBA-0891'
                    },
                    {
                        nameEn: 'Tamar Jikia',
                        nameKa: "\u10D7\u10D0\u10DB\u10D0\u10E0 \u10EF\u10D8\u10E5\u10D8\u10D0",
                        firmNameEn: 'Jikia Legal',
                        city: 'Tbilisi',
                        specializations: [
                            'Real Estate',
                            'Tax Law'
                        ],
                        rating: 4.6,
                        reviews: 43,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-3104'
                    },
                    {
                        nameEn: "Levan Chikovan\u0438",
                        nameKa: "\u10DA\u10D4\u10D5\u10D0\u10DC \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
                        firmNameEn: 'Chikovani & Associates',
                        city: 'Batumi',
                        specializations: [
                            'Immigration',
                            'Administrative Law'
                        ],
                        rating: 4.5,
                        reviews: 38,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-1775'
                    },
                    {
                        nameEn: 'Ana Maisuradze',
                        nameKa: "\u10D0\u10DC\u10D0 \u10DB\u10D0\u10D8\u10E1\u10E3\u10E0\u10D0\u10EB\u10D4",
                        firmNameEn: 'Maisuradze Law Firm',
                        city: 'Tbilisi',
                        specializations: [
                            'IP Law',
                            'Corporate Law'
                        ],
                        rating: 4.9,
                        reviews: 102,
                        status: 'active',
                        isSubscribed: true,
                        barId: 'GBA-0567'
                    },
                    {
                        nameEn: 'Irakli Lomidze',
                        nameKa: "\u10D8\u10E0\u10D0\u10D9\u10DA\u10D8 \u10DA\u10DD\u10DB\u10D8\u10EB\u10D4",
                        firmNameEn: null,
                        city: 'Tbilisi',
                        specializations: [
                            'Banking & Finance',
                            'M&A'
                        ],
                        rating: 4.7,
                        reviews: 49,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-2240'
                    },
                    {
                        nameEn: 'Khatia Gambashidze',
                        nameKa: "\u10EE\u10D0\u10D7\u10D8\u10D0 \u10D2\u10D0\u10DB\u10D1\u10D0\u10E8\u10D8\u10EB\u10D4",
                        firmNameEn: 'GambaLex',
                        city: 'Rustavi',
                        specializations: [
                            'Labor Law',
                            'Employment'
                        ],
                        rating: 4.6,
                        reviews: 31,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-3891'
                    },
                    {
                        nameEn: 'Zurab Melikidze',
                        nameKa: "\u10D6\u10E3\u10E0\u10D0\u10D1 \u10DB\u10D4\u10DA\u10D8\u10E5\u10D8\u10EB\u10D4",
                        firmNameEn: 'Melikidze & Sons',
                        city: 'Tbilisi',
                        specializations: [
                            'Criminal Law',
                            'Constitutional Law'
                        ],
                        rating: 4.8,
                        reviews: 76,
                        status: 'active',
                        isSubscribed: true,
                        barId: 'GBA-0123'
                    },
                    {
                        nameEn: 'Salome Kirtadze',
                        nameKa: "\u10E1\u10D0\u10DA\u10DD\u10DB\u10D4 \u10D9\u10D8\u10E0\u10D7\u10D0\u10EB\u10D4",
                        firmNameEn: null,
                        city: 'Gori',
                        specializations: [
                            'Civil Law',
                            'Real Estate'
                        ],
                        rating: 4.4,
                        reviews: 28,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-4412'
                    },
                    {
                        nameEn: 'Mikheil Aptsiauri',
                        nameKa: "\u10DB\u10D8\u10EE\u10D4\u10D8\u10DA \u10D0\u10E4\u10EA\u10D8\u10D0\u10E3\u10E0\u10D8",
                        firmNameEn: 'Aptsiauri Legal Group',
                        city: 'Tbilisi',
                        specializations: [
                            'Tax Law',
                            'Banking & Finance'
                        ],
                        rating: 4.7,
                        reviews: 55,
                        status: 'active',
                        isSubscribed: false,
                        barId: 'GBA-1980'
                    },
                    {
                        nameEn: 'Eka Surmanidze',
                        nameKa: "\u10D4\u10D9\u10D0 \u10E1\u10E3\u10E0\u10DB\u10D0\u10DC\u10D8\u10EB\u10D4",
                        firmNameEn: 'Surmanidze Partners',
                        city: 'Batumi',
                        specializations: [
                            'Family Law',
                            'Juvenile Justice'
                        ],
                        rating: 4.8,
                        reviews: 67,
                        status: 'active',
                        isSubscribed: true,
                        barId: 'GBA-2755'
                    }
                ].map((l)=>({
                        ...l,
                        _type: 'lawyer'
                    })),
                childrenAs: 'state',
                childExtends: 'DirectoryCard'
            },
            PreviewFade: {
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                height: 'E1',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(22,26,29,0.75) 50%, rgba(22,26,29,1) 100%)',
                pointerEvents: 'none'
            },
            PreviewCta: {
                position: 'absolute',
                bottom: 'B',
                left: '0',
                right: '0',
                flow: 'y',
                align: 'center center',
                gap: 'Z',
                CtaBtn: {
                    extends: 'Link',
                    href: '/lawyers',
                    text: "View Full Directory \u2192",
                    background: 'green',
                    color: 'neutral950',
                    fontWeight: '700',
                    padding: 'Z C',
                    fontSize: 'A',
                    borderRadius: 'D',
                    textDecoration: 'none',
                    transition: 'transform 200ms',
                    ':hover': {
                        transform: 'scale(0.98)'
                    }
                },
                CtaText: {
                    text: 'Browse all 5,700+ verified lawyers',
                    fontSize: 'A',
                    color: 'textMuted'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // CTA
    // ═══════════════════════════════════════════════════
    CtaBanner: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        padding: 'F D',
        gap: 'B',
        textAlign: 'center',
        maxWidth: 'K',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        CtaTitle: {
            tag: 'h2',
            text: 'Are you a lawyer?',
            fontSize: 'D',
            fontWeight: '700',
            color: 'text',
            '@mobileL': {
                fontSize: 'C'
            }
        },
        CtaSub: {
            text: 'Join 5,700+ verified lawyers on TrustLegal. First 30 days free.',
            fontSize: 'A',
            color: 'textMuted',
            maxWidth: 'H'
        },
        CtaCtas: {
            flow: 'x',
            gap: 'A',
            align: 'center',
            CtaBtn: {
                extends: 'Link',
                href: '/login',
                text: "Try for Free \u2192",
                background: 'green',
                color: 'neutral950',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '600',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                }
            },
            DemoBtn: {
                extends: 'Link',
                href: '/dashboard',
                text: 'See Demo',
                background: 'transparent',
                color: 'text',
                border: '1px solid surfaceBorderStrong',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '500',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: true
                    })
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // FOOTER
    // ═══════════════════════════════════════════════════
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'C',
        padding: 'D 0',
        borderTop: '1px solid surfaceBorderStrong',
        maxWidth: 'K',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'C A'
        },
        FooterTop: {
            flow: 'x',
            gap: 'C',
            '@mobileL': {
                flow: 'y',
                gap: 'B'
            },
            FooterBrand: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                minWidth: 'F',
                FooterLogo: {
                    extends: 'Link',
                    href: '/',
                    text: 'TrustLegal',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'green',
                    textDecoration: 'none'
                },
                FooterTagline: {
                    text: '{{ footerTagline | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.6'
                }
            },
            FooterLinks: {
                flow: 'x',
                gap: 'C',
                flex: '2',
                '@mobileL': {
                    flow: 'y',
                    gap: 'B'
                },
                FooterCol1: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ productLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: 'X',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/bookings',
                        text: '{{ bookingsLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/cases',
                        text: '{{ casesLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink3: {
                        extends: 'Link',
                        href: '/documents',
                        text: '{{ aiDocsLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    }
                },
                FooterCol2: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ companyLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: 'X',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ aboutUs | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ careers | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                }
            }
        },
        FooterBottom: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            '@mobileL': {
                flow: 'y',
                gap: 'Z',
                align: 'center center'
            },
            CopyText: {
                text: '{{ copyrightText | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            },
            BuiltWith: {
                text: '{{ builtWith | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            }
        }
    }
};


const $979c3c60351c1a32$export$596d806903d1f59e = {
    extends: 'Page',
    flow: 'y',
    align: 'center center',
    minHeight: '100vh',
    background: 'surface',
    padding: 'B',
    LoginCard: {
        flow: 'y',
        gap: 'B',
        padding: 'D',
        background: 'surfaceCard',
        border: '1px solid surfaceBorderStrong',
        borderRadius: 'A',
        width: '100%',
        maxWidth: 'H',
        '@mobileL': {
            padding: 'B',
            borderRadius: 'Z'
        },
        LogoLink: {
            extends: 'Link',
            href: '/',
            text: 'TrustLegal',
            fontSize: 'C',
            fontWeight: '800',
            color: 'green',
            textAlign: 'center',
            textDecoration: 'none'
        },
        LoginSubtitle: {
            text: '{{ loginSubtitle | polyglot }}',
            fontSize: 'A',
            color: 'textMuted',
            textAlign: 'center'
        },
        LoginTabs: {
            flow: 'x',
            gap: '0',
            borderRadius: 'Z',
            overflow: 'hidden',
            border: '1px solid surfaceBorderStrong',
            background: 'surfaceMid',
            LawyerTab: {
                extends: 'Button',
                text: '{{ loginLawyer | polyglot }}',
                flex: '1',
                padding: 'Z',
                fontSize: 'Z',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '0',
                background: (el, s)=>s.root.loginTab === 'lawyer' ? 'green' : 'transparent',
                color: (el, s)=>s.root.loginTab === 'lawyer' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.loginTab === 'lawyer' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        loginTab: 'lawyer'
                    })
            },
            ClientTab: {
                extends: 'Button',
                text: '{{ loginClient | polyglot }}',
                flex: '1',
                padding: 'Z',
                fontSize: 'Z',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '0',
                background: (el, s)=>s.root.loginTab === 'client' ? 'green' : 'transparent',
                color: (el, s)=>s.root.loginTab === 'client' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.loginTab === 'client' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        loginTab: 'client'
                    })
            }
        },
        LawyerForm: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.loginTab === 'lawyer',
            EmailLabel: {
                tag: 'label',
                text: '{{ loginEmail | polyglot }}',
                fontSize: 'Z',
                color: 'textSoft',
                fontWeight: '500'
            },
            EmailInput: {
                tag: 'input',
                type: 'email',
                name: 'email',
                placeholder: 'name@firm.ge',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                width: '100%'
            },
            PassLabel: {
                tag: 'label',
                text: '{{ loginPassword | polyglot }}',
                fontSize: 'Z',
                color: 'textSoft',
                fontWeight: '500'
            },
            PassInput: {
                tag: 'input',
                type: 'password',
                name: 'password',
                placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                width: '100%'
            },
            SubmitLink: {
                extends: 'Link',
                href: '/dashboard',
                text: '{{ loginSubmit | polyglot }}',
                background: 'green',
                color: 'neutral950',
                padding: 'A',
                fontSize: 'A',
                fontWeight: '600',
                borderRadius: 'Z',
                width: '100%',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: true,
                        userType: 'lawyer'
                    })
            }
        },
        ClientForm: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.loginTab === 'client',
            ClientEmailLabel: {
                tag: 'label',
                text: '{{ loginEmail | polyglot }}',
                fontSize: 'Z',
                color: 'textSoft',
                fontWeight: '500'
            },
            ClientEmailInput: {
                tag: 'input',
                type: 'email',
                name: 'email',
                placeholder: 'your@email.ge',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                width: '100%'
            },
            CaseNumLabel: {
                tag: 'label',
                text: '{{ loginCaseNumber | polyglot }}',
                fontSize: 'Z',
                color: 'textSoft',
                fontWeight: '500'
            },
            CaseNumInput: {
                tag: 'input',
                type: 'text',
                name: 'caseNum',
                placeholder: '#2024-047',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                width: '100%'
            },
            ClientSubmitLink: {
                extends: 'Link',
                href: '/client',
                text: '{{ loginSubmit | polyglot }}',
                background: 'green',
                color: 'neutral950',
                padding: 'A',
                fontSize: 'A',
                fontWeight: '600',
                borderRadius: 'Z',
                width: '100%',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: true,
                        userType: 'client'
                    })
            }
        },
        Divider: {
            width: '100%',
            borderTop: '1px solid surfaceBorderStrong'
        },
        BackLink: {
            extends: 'Link',
            href: '/',
            text: '{{ loginBackLink | polyglot }}',
            textAlign: 'center',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': {
                color: 'green'
            }
        }
    }
};


const $4a3b6042fbd7c8f3$export$a5f98448b9315739 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        TopHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            GreetingText: {
                tag: 'h1',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                text: '{{ dashGreeting | polyglot }}',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flexWrap: 'wrap'
                },
                DateText: {
                    text: '{{ dashDate | polyglot }}',
                    fontSize: 'A',
                    color: 'textSoft'
                },
                ThemeToggle: {}
            }
        },
        AlertBanner: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z A',
            background: 'amberBg',
            border: '1px solid amberBorder',
            borderRadius: 'Z',
            show: (el, s)=>!s.root.alertDismissed,
            AlertIcon: {
                extends: 'Icon',
                icon: 'warning',
                width: 'A',
                height: 'A',
                color: 'amber'
            },
            AlertText: {
                text: '{{ dashAlertText | polyglot }}',
                fontSize: 'Z',
                color: 'amber',
                fontWeight: '500',
                flex: '1',
                padding: '0 A'
            },
            DismissBtn: {
                extends: 'Button',
                text: "\u2715",
                theme: 'transparent',
                color: 'amber',
                fontSize: 'Z',
                padding: 'Y',
                cursor: 'pointer',
                onClick: (e, el, s)=>s.root.update({
                        alertDismissed: true
                    })
            }
        },
        StatsRow: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            Stat1: {
                extends: 'StatCard',
                StatValue: {
                    text: '14'
                },
                StatLabel: {
                    text: '{{ casesTitle | polyglot }}'
                }
            },
            Stat2: {
                extends: 'StatCard',
                StatValue: {
                    text: '3'
                },
                StatLabel: {
                    text: '{{ dashTodayBookings | polyglot }}'
                }
            },
            Stat3: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE1,840",
                    color: 'amber'
                },
                StatLabel: {
                    text: '{{ dashUnpaid | polyglot }}'
                }
            },
            Stat4: {
                extends: 'StatCard',
                StatValue: {
                    text: '2',
                    color: 'red'
                },
                StatLabel: {
                    text: '{{ dashOverdue | polyglot }}'
                }
            },
            Stat5: {
                extends: 'StatCard',
                StatValue: {
                    text: '23'
                },
                StatLabel: {
                    text: '{{ dashAiGenerations | polyglot }}'
                }
            }
        },
        ContentColumns: {
            flow: 'x',
            gap: 'B',
            flexWrap: 'wrap',
            '@tabletS': {
                flow: 'y'
            },
            BookingsCol: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                minWidth: 'F',
                ColTitle: {
                    tag: 'h2',
                    text: '{{ dashTodaysBookings | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                Booking1: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    BookingInfo: {
                        flow: 'y',
                        gap: 'Z',
                        ClientName: {
                            text: '{{ clientName1 | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        BookingTime: {
                            text: '{{ dashBooking1Time | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    BookingChip: {
                        extends: 'StatusConfirmed',
                        text: '{{ dashConfirmed | polyglot }}'
                    }
                },
                Booking2: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    BookingInfo: {
                        flow: 'y',
                        gap: 'Z',
                        ClientName: {
                            text: '{{ clientName2 | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        BookingTime: {
                            text: '{{ dashBooking2Time | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    BookingChip: {
                        extends: 'StatusPending',
                        text: '{{ pendingTab | polyglot }}'
                    }
                },
                Booking3: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    BookingInfo: {
                        flow: 'y',
                        gap: 'Z',
                        ClientName: {
                            text: '{{ dashClient3Name | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        BookingTime: {
                            text: '{{ dashBooking3Time | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    BookingChip: {
                        extends: 'StatusConfirmed',
                        text: '{{ dashConfirmed | polyglot }}'
                    }
                }
            },
            CasesCol: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                minWidth: 'F',
                ColTitle: {
                    tag: 'h2',
                    text: '{{ dashRecentCases | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                Case1: {
                    extends: 'Link',
                    href: '/cases',
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    textDecoration: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 1
                        }),
                    CaseInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNum: {
                            text: '{{ caseRow1Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMeta: {
                            text: '{{ dashCaseMeta1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    CaseChip: {
                        extends: 'StatusActive',
                        text: '{{ activeTab | polyglot }}'
                    }
                },
                Case2: {
                    extends: 'Link',
                    href: '/cases',
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    textDecoration: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 2
                        }),
                    CaseInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNum: {
                            text: '{{ caseRow2Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMeta: {
                            text: '{{ dashCaseMeta2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    CaseChip: {
                        extends: 'StatusPending',
                        text: '{{ pendingTab | polyglot }}'
                    }
                },
                Case3: {
                    extends: 'Link',
                    href: '/cases',
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    textDecoration: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 3
                        }),
                    CaseInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNum: {
                            text: '{{ caseRow3Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMeta: {
                            text: '{{ dashCaseMeta3 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        }
                    },
                    CaseChip: {
                        extends: 'StatusClosed',
                        text: '{{ closedTab | polyglot }}'
                    }
                }
            }
        },
        QuickActions: {
            flow: 'x',
            gap: 'A',
            padding: 'A 0',
            flexWrap: 'wrap',
            Action1: {
                extends: 'QuickActionBtn',
                href: '/bookings',
                ActionIcon: {
                    icon: 'plus'
                },
                ActionText: {
                    text: '{{ dashNewBooking | polyglot }}'
                }
            },
            Action2: {
                extends: 'QuickActionBtn',
                href: '/cases',
                ActionIcon: {
                    icon: 'plus'
                },
                ActionText: {
                    text: '{{ dashNewCase | polyglot }}'
                }
            },
            Action3: {
                extends: 'QuickActionBtn',
                href: '/documents',
                ActionIcon: {
                    icon: 'ai'
                },
                ActionText: {
                    text: '{{ dashAiDocument | polyglot }}'
                }
            }
        }
    }
};


const $53ee824ff1ce7457$export$dbeef2c344004b5e = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    state: {
        showNewBooking: false,
        selectedBookingId: null
    },
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ bookingsTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flexWrap: 'wrap'
                },
                NewBookingBtn: {
                    extends: 'Button',
                    text: '{{ newBooking | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.update({
                            showNewBooking: !s.showNewBooking,
                            selectedBookingId: null
                        })
                },
                ThemeToggle: {}
            }
        },
        // ─── New Booking Form ─────────────────────────
        NewBookingForm: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            padding: 'B',
            background: 'surfaceMid',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            show: (el, s)=>s.showNewBooking,
            FormTitle: {
                tag: 'h2',
                text: '{{ newBookingTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'green'
            },
            FieldsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                ClientInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'client',
                    placeholder: '{{ clientName | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1',
                    minWidth: 'E'
                },
                PhoneInput: {
                    tag: 'input',
                    type: 'tel',
                    name: 'phone',
                    placeholder: '{{ phoneNumber | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1',
                    minWidth: 'E'
                }
            },
            FieldsRow2: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                TypeSelect: {
                    tag: 'select',
                    name: 'caseType',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1',
                    minWidth: 'E',
                    Opt1: {
                        tag: 'option',
                        text: '{{ civilLaw | polyglot }}',
                        value: 'civil'
                    },
                    Opt2: {
                        tag: 'option',
                        text: '{{ criminalLaw2 | polyglot }}',
                        value: 'criminal'
                    },
                    Opt3: {
                        tag: 'option',
                        text: '{{ administrativeLaw | polyglot }}',
                        value: 'admin'
                    },
                    Opt4: {
                        tag: 'option',
                        text: '{{ otherType | polyglot }}',
                        value: 'other'
                    }
                },
                TimeInput: {
                    tag: 'input',
                    type: 'time',
                    name: 'time',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1',
                    minWidth: 'E'
                }
            },
            NotesInput: {
                tag: 'textarea',
                name: 'notes',
                placeholder: '{{ notesPlaceholder | polyglot }}',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                minHeight: 'C'
            },
            FormActions: {
                flow: 'x',
                gap: 'Z',
                ConfirmBtn: {
                    extends: 'Button',
                    text: '{{ confirmBooking | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.update({
                            showNewBooking: false
                        });
                    }
                },
                CancelBtn: {
                    extends: 'Button',
                    text: '{{ cancelBtn | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.update({
                            showNewBooking: false
                        })
                }
            }
        },
        // Calendar sync banner
        CalendarSyncBanner: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            cursor: 'pointer',
            transition: 'opacity 150ms',
            ':hover': {
                opacity: '.85'
            },
            onClick: (e, el, s)=>s.update({
                    calSyncDemo: !s.calSyncDemo
                }),
            BannerDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0'
            },
            BannerText: {
                text: '{{ calendarSyncNote | polyglot }}',
                fontSize: 'Y',
                color: 'green',
                flex: '1',
                lineHeight: '1.4'
            },
            SyncStatus: {
                tag: 'span',
                text: '{{ synced | polyglot }}',
                padding: 'Y Z',
                background: 'greenBg',
                border: '1px solid greenBorder',
                borderRadius: 'Z',
                fontSize: 'Y',
                color: 'green',
                fontWeight: '600'
            },
            BannerAction: {
                text: "\u2192",
                fontSize: 'Z',
                color: 'green',
                fontWeight: '600'
            }
        },
        // Calendar sync demo
        CalSyncDemoPanel: {
            flow: 'y',
            gap: 'A',
            padding: 'A',
            background: 'surfaceMid',
            border: '1px solid surfaceBorderStrong',
            borderRadius: 'Z',
            if: (el, s)=>s.calSyncDemo,
            DemoHeader: {
                flow: 'x',
                align: 'center space-between',
                DemoTitle: {
                    tag: 'h3',
                    text: '{{ calendarSync2 | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'green'
                },
                CloseBtn: {
                    text: "\u2715",
                    color: 'textMuted',
                    cursor: 'pointer',
                    fontSize: 'A',
                    onClick: (e, el, s)=>s.update({
                            calSyncDemo: false
                        })
                }
            },
            DemoCards: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                childExtends: {
                    cursor: 'pointer',
                    transition: 'transform 150ms, border-color 150ms',
                    ':hover': {
                        borderColor: 'green',
                        transform: 'translateY(-2px)'
                    }
                },
                Card1: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ googleCalendar | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: '{{ syncedStatus | polyglot }}',
                        fontSize: 'Y',
                        color: 'green'
                    },
                    CardItem2: {
                        text: '{{ bookingsToday | polyglot }}',
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ settingsLink | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                },
                Card2: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ outlook | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: '{{ pendingStatus | polyglot }}',
                        fontSize: 'Y',
                        color: 'amber'
                    },
                    CardItem2: {
                        text: '{{ connectionNeeded | polyglot }}',
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ connectLink | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                },
                Card3: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ appleCalendar | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: '{{ syncedStatus | polyglot }}',
                        fontSize: 'Y',
                        color: 'green'
                    },
                    CardItem2: {
                        text: '{{ lastSync | polyglot }}',
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ settingsLink | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                }
            }
        },
        ContentArea: {
            flow: 'x',
            gap: 'B',
            flexWrap: 'wrap',
            '@tabletS': {
                flow: 'y'
            },
            // ─── Calendar Week View ─────────────────────
            CalendarView: {
                flow: 'y',
                gap: 'A',
                flex: '2',
                minWidth: 'G',
                '@mobileL': {
                    overflow: 'auto'
                },
                WeekHeader: {
                    flow: 'x',
                    gap: '0',
                    DayH0: {
                        width: 'C',
                        text: '',
                        padding: 'Z'
                    },
                    DayH1: {
                        flex: '1',
                        text: '{{ mon | polyglot }}',
                        textAlign: 'center',
                        fontSize: 'Z',
                        color: 'textSoft',
                        fontWeight: '600',
                        padding: 'Z'
                    },
                    DayH2: {
                        flex: '1',
                        text: '{{ tue | polyglot }}',
                        textAlign: 'center',
                        fontSize: 'Z',
                        color: 'textSoft',
                        fontWeight: '600',
                        padding: 'Z'
                    },
                    DayH3: {
                        flex: '1',
                        text: '{{ wed | polyglot }}',
                        textAlign: 'center',
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '700',
                        padding: 'Z'
                    },
                    DayH4: {
                        flex: '1',
                        text: '{{ thu | polyglot }}',
                        textAlign: 'center',
                        fontSize: 'Z',
                        color: 'textSoft',
                        fontWeight: '600',
                        padding: 'Z'
                    },
                    DayH5: {
                        flex: '1',
                        text: '{{ fri | polyglot }}',
                        textAlign: 'center',
                        fontSize: 'Z',
                        color: 'textSoft',
                        fontWeight: '600',
                        padding: 'Z'
                    }
                },
                TimeGrid: {
                    flow: 'y',
                    gap: 'Y',
                    childExtends: {
                        flow: 'x',
                        gap: 'Y'
                    },
                    Row0800: {
                        TimeLabel: {
                            width: 'C',
                            text: '08:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row0830: {
                        TimeLabel: {
                            width: 'C',
                            text: '08:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row0900: {
                        TimeLabel: {
                            width: 'C',
                            text: '09:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row0930: {
                        TimeLabel: {
                            width: 'C',
                            text: '09:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1000: {
                        TimeLabel: {
                            width: 'C',
                            text: '10:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'greenBg',
                            borderRadius: 'Y',
                            border: '1px solid greenBorder',
                            cursor: 'pointer',
                            flow: 'x',
                            align: 'center center',
                            gap: 'Y',
                            overflow: 'hidden',
                            SlotName: {
                                text: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB.",
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            onClick: (e, el, s)=>s.update({
                                    selectedBookingId: 1,
                                    showNewBooking: false
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1030: {
                        TimeLabel: {
                            width: 'C',
                            text: '10:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'greenBg',
                            borderRadius: 'Y',
                            border: '1px solid greenBorder',
                            opacity: '.5'
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1100: {
                        TimeLabel: {
                            width: 'C',
                            text: '11:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1130: {
                        TimeLabel: {
                            width: 'C',
                            text: '11:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'amberBg',
                            borderRadius: 'Y',
                            border: '1px solid amberBorder',
                            cursor: 'pointer',
                            flow: 'x',
                            align: 'center center',
                            gap: 'Y',
                            overflow: 'hidden',
                            SlotName: {
                                text: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9.",
                                fontSize: 'Y',
                                color: 'amber',
                                fontWeight: '600',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            onClick: (e, el, s)=>s.update({
                                    selectedBookingId: 2,
                                    showNewBooking: false
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1200: {
                        TimeLabel: {
                            width: 'C',
                            text: '12:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'amberBg',
                            borderRadius: 'Y',
                            border: '1px solid amberBorder',
                            opacity: '.5'
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        }
                    },
                    Row1230: {
                        TimeLabel: {
                            width: 'C',
                            text: '12:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            opacity: '.35'
                        }
                    },
                    Row1300: {
                        TimeLabel: {
                            width: 'C',
                            text: '13:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1330: {
                        TimeLabel: {
                            width: 'C',
                            text: '13:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1400: {
                        TimeLabel: {
                            width: 'C',
                            text: '14:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'greenBg',
                            borderRadius: 'Y',
                            border: '1px solid greenBorder',
                            cursor: 'pointer',
                            flow: 'x',
                            align: 'center center',
                            gap: 'Y',
                            overflow: 'hidden',
                            SlotName: {
                                text: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9.",
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            onClick: (e, el, s)=>s.update({
                                    selectedBookingId: 3,
                                    showNewBooking: false
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1430: {
                        TimeLabel: {
                            width: 'C',
                            text: '14:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'greenBg',
                            borderRadius: 'Y',
                            border: '1px solid greenBorder',
                            opacity: '.5'
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1500: {
                        TimeLabel: {
                            width: 'C',
                            text: '15:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1530: {
                        TimeLabel: {
                            width: 'C',
                            text: '15:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1600: {
                        TimeLabel: {
                            width: 'C',
                            text: '16:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1630: {
                        TimeLabel: {
                            width: 'C',
                            text: '16:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1700: {
                        TimeLabel: {
                            width: 'C',
                            text: '17:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1730: {
                        TimeLabel: {
                            width: 'C',
                            text: '17:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1800: {
                        TimeLabel: {
                            width: 'C',
                            text: '18:00',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    },
                    Row1830: {
                        TimeLabel: {
                            width: 'C',
                            text: '18:30',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'right',
                            padding: 'Y Z 0 0'
                        },
                        S1: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S2: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S3: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S4: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        },
                        S5: {
                            flex: '1',
                            height: 'A',
                            background: 'surfaceBorder',
                            borderRadius: 'Y',
                            border: '1px solid surfaceBorderStrong',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    showNewBooking: true,
                                    selectedBookingId: null
                                })
                        }
                    }
                }
            },
            // ─── Right Panel ────────────────────────────
            BookingsPanel: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                minWidth: 'E',
                '@tabletS': {
                    maxWidth: '100%',
                    width: '100%'
                },
                // ─── Selected booking detail ──────────────
                SelectedDetail: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'A',
                    background: 'surfaceMid',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    show: (el, s)=>s.selectedBookingId !== null,
                    '@tabletS': {
                        maxWidth: '100%',
                        width: '100%'
                    },
                    DetailTitle: {
                        tag: 'h2',
                        text: '{{ bookingDetails | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'green'
                    },
                    Detail1: {
                        flow: 'y',
                        gap: 'Z',
                        show: (el, s)=>s.selectedBookingId === 1,
                        DName: {
                            text: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        DTime: {
                            text: "10:00 \u2014 \u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        DType: {
                            text: '{{ civilLaw | polyglot }}',
                            fontSize: 'Z',
                            color: 'blue'
                        },
                        DStatus: {
                            extends: 'StatusConfirmed',
                            text: '{{ confirmed | polyglot }}'
                        }
                    },
                    Detail2: {
                        flow: 'y',
                        gap: 'Z',
                        show: (el, s)=>s.selectedBookingId === 2,
                        DName: {
                            text: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        DTime: {
                            text: "11:30 \u2014 \u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        DType: {
                            text: '{{ administrativeLaw | polyglot }}',
                            fontSize: 'Z',
                            color: 'purple'
                        },
                        DStatus: {
                            extends: 'StatusPending',
                            text: '{{ pending | polyglot }}'
                        }
                    },
                    Detail3: {
                        flow: 'y',
                        gap: 'Z',
                        show: (el, s)=>s.selectedBookingId === 3,
                        DName: {
                            text: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        DTime: {
                            text: "14:00 \u2014 \u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        DType: {
                            text: '{{ criminalLaw2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'red'
                        },
                        DStatus: {
                            extends: 'StatusConfirmed',
                            text: '{{ confirmed | polyglot }}'
                        }
                    },
                    CloseDetailBtn: {
                        extends: 'Button',
                        text: '{{ closeBtn | polyglot }}',
                        theme: 'ghost',
                        padding: 'Z A',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.update({
                                selectedBookingId: null
                            })
                    }
                },
                // ─── Upcoming list ────────────────────────
                PanelTitle: {
                    tag: 'h2',
                    text: '{{ upcomingBookings | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text',
                    show: (el, s)=>s.selectedBookingId === null
                },
                UpcomingItem1: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    show: (el, s)=>s.selectedBookingId === null,
                    onClick: (e, el, s)=>s.update({
                            selectedBookingId: 1
                        }),
                    ItemTop: {
                        flow: 'x',
                        align: 'center space-between',
                        ItemClient: {
                            text: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        ItemChip: {
                            extends: 'StatusConfirmed',
                            text: '{{ confirmed | polyglot }}'
                        }
                    },
                    ItemDetails: {
                        flow: 'x',
                        gap: 'A',
                        ItemTime: {
                            text: '10:00',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        },
                        ItemType: {
                            tag: 'span',
                            text: '{{ civilLaw | polyglot }}',
                            fontSize: 'Y',
                            padding: 'Y Z',
                            background: 'blueBg',
                            border: '1px solid blueBorder',
                            borderRadius: 'Z',
                            color: 'blue'
                        }
                    }
                },
                UpcomingItem2: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    show: (el, s)=>s.selectedBookingId === null,
                    onClick: (e, el, s)=>s.update({
                            selectedBookingId: 2
                        }),
                    ItemTop: {
                        flow: 'x',
                        align: 'center space-between',
                        ItemClient: {
                            text: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        ItemChip: {
                            extends: 'StatusPending',
                            text: '{{ pending | polyglot }}'
                        }
                    },
                    ItemDetails: {
                        flow: 'x',
                        gap: 'A',
                        ItemTime: {
                            text: '11:30',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        },
                        ItemType: {
                            tag: 'span',
                            text: '{{ administrativeLaw | polyglot }}',
                            fontSize: 'Y',
                            padding: 'Y Z',
                            background: 'purpleBg',
                            border: '1px solid purpleBorder',
                            borderRadius: 'Z',
                            color: 'purple'
                        }
                    }
                },
                UpcomingItem3: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'surfaceBorder',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    show: (el, s)=>s.selectedBookingId === null,
                    onClick: (e, el, s)=>s.update({
                            selectedBookingId: 3
                        }),
                    ItemTop: {
                        flow: 'x',
                        align: 'center space-between',
                        ItemClient: {
                            text: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        ItemChip: {
                            extends: 'StatusConfirmed',
                            text: '{{ confirmed | polyglot }}'
                        }
                    },
                    ItemDetails: {
                        flow: 'x',
                        gap: 'A',
                        ItemTime: {
                            text: '14:00',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        },
                        ItemType: {
                            tag: 'span',
                            text: '{{ criminalLaw2 | polyglot }}',
                            fontSize: 'Y',
                            padding: 'Y Z',
                            background: 'redBg',
                            border: '1px solid redBorder',
                            borderRadius: 'Z',
                            color: 'red'
                        }
                    }
                }
            }
        }
    }
};


const $2b330bdbd1b280b3$export$3ee8813cfb9a6bdd = {
    extends: 'Page',
    flow: 'y',
    minHeight: '100vh',
    background: 'surface',
    color: 'text',
    // Header
    PublicNav: {
        tag: 'nav',
        flow: 'x',
        align: 'center space-between',
        padding: 'A C',
        borderBottom: '1px solid surfaceBorder',
        '@mobileL': {
            padding: 'A'
        },
        NavLogo: {
            extends: 'Link',
            href: '/',
            text: 'TrustLegal',
            fontSize: 'B',
            fontWeight: '800',
            color: 'green',
            textDecoration: 'none'
        },
        NavRight: {
            flow: 'x',
            gap: 'A',
            align: 'center',
            ThemeToggle: {},
            NavLogin: {
                extends: 'Link',
                href: '/login',
                text: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0",
                fontSize: 'Z',
                color: 'textSoft',
                textDecoration: 'none'
            }
        }
    },
    // Main content
    PublicContent: {
        flow: 'y',
        align: 'center',
        flex: '1',
        padding: 'C',
        '@mobileL': {
            padding: 'A'
        },
        PublicCard: {
            flow: 'y',
            gap: 'B',
            padding: 'C',
            background: 'white',
            borderRadius: 'Z',
            width: '100%',
            maxWidth: 'H',
            border: '1px solid neutral200',
            '@mobileL': {
                padding: 'A'
            },
            FirmInfo: {
                flow: 'y',
                gap: 'Z',
                textAlign: 'center',
                FirmName: {
                    tag: 'h1',
                    text: '{{ lawGroupBarateli | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'neutral900'
                },
                LawyerName: {
                    text: '{{ ninoBarateli | polyglot }}',
                    fontSize: 'B',
                    color: 'neutral500'
                }
            },
            // ─── Select slot view ─────────────────────────
            SelectView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.publicBookingStep === 'select',
                SelectTitle: {
                    tag: 'h2',
                    text: '{{ selectDateTime | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'neutral900'
                },
                WeekRow: {
                    flow: 'x',
                    gap: 'Z',
                    flexWrap: 'wrap',
                    Day1: {
                        flow: 'y',
                        gap: 'Z',
                        flex: '1',
                        minWidth: 'D',
                        DayLabel: {
                            text: "\u10DD\u10E0\u10E8 17",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'neutral500',
                            textAlign: 'center'
                        },
                        SlotA: {
                            extends: 'Button',
                            text: '09:00',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '09:00',
                                    publicBookingStep: 'form'
                                })
                        },
                        SlotB: {
                            extends: 'Button',
                            text: '10:30',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '10:30',
                                    publicBookingStep: 'form'
                                })
                        },
                        SlotC: {
                            extends: 'Button',
                            text: '14:00',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '14:00',
                                    publicBookingStep: 'form'
                                })
                        }
                    },
                    Day2: {
                        flow: 'y',
                        gap: 'Z',
                        flex: '1',
                        minWidth: 'D',
                        DayLabel: {
                            text: "\u10E1\u10D0\u10DB 18",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'neutral500',
                            textAlign: 'center'
                        },
                        SlotA: {
                            extends: 'Button',
                            text: '09:30',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '09:30',
                                    publicBookingStep: 'form'
                                })
                        },
                        SlotB: {
                            extends: 'Button',
                            text: '11:00',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '11:00',
                                    publicBookingStep: 'form'
                                })
                        },
                        SlotC: {
                            extends: 'Button',
                            text: '15:30',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '15:30',
                                    publicBookingStep: 'form'
                                })
                        }
                    },
                    Day3: {
                        flow: 'y',
                        gap: 'Z',
                        flex: '1',
                        minWidth: 'D',
                        DayLabel: {
                            text: "\u10DD\u10D7\u10EE 19",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'neutral500',
                            textAlign: 'center'
                        },
                        SlotA: {
                            extends: 'Button',
                            text: '10:00',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '10:00',
                                    publicBookingStep: 'form'
                                })
                        },
                        SlotB: {
                            extends: 'Button',
                            text: '13:00',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            background: 'neutral100',
                            color: 'neutral800',
                            border: '1px solid neutral200',
                            textAlign: 'center',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: '13:00',
                                    publicBookingStep: 'form'
                                })
                        }
                    }
                }
            },
            // ─── Form view ────────────────────────────────
            FormView: {
                tag: 'form',
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.publicBookingStep === 'form',
                FormTitle: {
                    tag: 'h2',
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'neutral900',
                    TitleText: {
                        text: '{{ fillInfo | polyglot }}'
                    },
                    SelectedTime: {
                        text: (el, s)=>s.root.selectedSlot,
                        color: 'neutral800',
                        fontWeight: '700'
                    }
                },
                NameInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'firstName',
                    placeholder: '{{ firstName | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    color: 'neutral900',
                    background: 'neutral50'
                },
                SurnameInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'lastName',
                    placeholder: '{{ lastName | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    color: 'neutral900',
                    background: 'neutral50'
                },
                PhoneInput: {
                    tag: 'input',
                    type: 'tel',
                    name: 'phone',
                    placeholder: '{{ phoneField | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    color: 'neutral900',
                    background: 'neutral50'
                },
                EmailInput: {
                    tag: 'input',
                    type: 'email',
                    name: 'email',
                    placeholder: '{{ emailField | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    color: 'neutral900',
                    background: 'neutral50'
                },
                DescInput: {
                    tag: 'textarea',
                    name: 'description',
                    placeholder: '{{ caseDescription | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    color: 'neutral900',
                    background: 'neutral50',
                    minHeight: 'D'
                },
                ConfirmBtn: {
                    extends: 'Button',
                    text: '{{ confirmBookingPublic | polyglot }}',
                    background: 'neutral900',
                    color: 'neutral50',
                    padding: 'Z A',
                    fontSize: 'A',
                    fontWeight: '600',
                    borderRadius: 'Z',
                    width: '100%',
                    textAlign: 'center',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.root.update({
                            publicBookingStep: 'payment'
                        });
                    }
                },
                BackBtn: {
                    tag: 'a',
                    text: '{{ goBack | polyglot }}',
                    textAlign: 'center',
                    fontSize: 'A',
                    color: 'neutral500',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            publicBookingStep: 'select'
                        })
                }
            },
            // ─── Payment view ────────────────────────────
            PaymentView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.publicBookingStep === 'payment',
                PaymentTitle: {
                    tag: 'h2',
                    text: 'Payment',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'neutral900'
                },
                PaymentDesc: {
                    text: "Consultation fee \u2014 pay securely to confirm your booking",
                    fontSize: 'Z',
                    color: 'neutral500',
                    lineHeight: '1.5'
                },
                PaymentSummary: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'neutral100',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    SumRow1: {
                        flow: 'x',
                        align: 'center space-between',
                        SumLabel: {
                            text: 'Consultation (1 hr)',
                            fontSize: 'Z',
                            color: 'neutral500'
                        },
                        SumVal: {
                            text: "\u20BE75",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'neutral900'
                        }
                    },
                    SumRow2: {
                        flow: 'x',
                        align: 'center space-between',
                        SumLabel: {
                            text: 'Platform fee',
                            fontSize: 'Z',
                            color: 'neutral500'
                        },
                        SumVal: {
                            text: "\u20BE5",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'neutral900'
                        }
                    },
                    SumDivider: {
                        height: '1',
                        background: 'neutral200',
                        margin: 'Y 0'
                    },
                    SumTotal: {
                        flow: 'x',
                        align: 'center space-between',
                        SumLabel: {
                            text: 'Total',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'neutral900'
                        },
                        SumVal: {
                            text: "\u20BE80",
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'neutral900'
                        }
                    }
                },
                PaymentMethod: {
                    flow: 'y',
                    gap: 'Z',
                    MethodTitle: {
                        text: 'Payment method',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'neutral900'
                    },
                    MethodCards: {
                        flow: 'x',
                        gap: 'Z',
                        CardOption: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            padding: 'Z A',
                            background: 'neutral100',
                            border: '2px solid neutral900',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            CardDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'neutral900'
                            },
                            CardLabel: {
                                text: 'Card',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'neutral900'
                            }
                        },
                        BankOption: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            padding: 'Z A',
                            background: 'neutral50',
                            border: '1px solid neutral200',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            CardLabel: {
                                text: 'Bank transfer',
                                fontSize: 'Z',
                                color: 'neutral500'
                            }
                        }
                    }
                },
                CardForm: {
                    flow: 'y',
                    gap: 'Z',
                    width: '100%',
                    CardNumberInput: {
                        tag: 'input',
                        type: 'text',
                        name: 'cardNumber',
                        placeholder: '4242 4242 4242 4242',
                        padding: 'Z A',
                        fontSize: 'A',
                        border: '1px solid neutral200',
                        borderRadius: 'Z',
                        color: 'neutral900',
                        background: 'neutral50',
                        width: '100%',
                        boxSizing: 'border-box'
                    },
                    CardRow: {
                        flow: 'x',
                        gap: 'Z',
                        width: '100%',
                        ExpiryInput: {
                            tag: 'input',
                            type: 'text',
                            name: 'expiry',
                            placeholder: 'MM / YY',
                            padding: 'Z A',
                            fontSize: 'A',
                            border: '1px solid neutral200',
                            borderRadius: 'Z',
                            color: 'neutral900',
                            background: 'neutral50',
                            flex: '1',
                            minWidth: '0'
                        },
                        CvcInput: {
                            tag: 'input',
                            type: 'text',
                            name: 'cvc',
                            placeholder: 'CVC',
                            padding: 'Z A',
                            fontSize: 'A',
                            border: '1px solid neutral200',
                            borderRadius: 'Z',
                            color: 'neutral900',
                            background: 'neutral50',
                            flex: '1',
                            minWidth: '0'
                        }
                    }
                },
                PayBtn: {
                    extends: 'Button',
                    text: "Pay \u20BE80",
                    background: 'neutral900',
                    color: 'neutral50',
                    padding: 'Z A',
                    fontSize: 'A',
                    fontWeight: '600',
                    borderRadius: 'Z',
                    width: '100%',
                    textAlign: 'center',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.root.update({
                            publicBookingStep: 'success'
                        });
                    }
                },
                PayBackBtn: {
                    tag: 'a',
                    text: '{{ goBack | polyglot }}',
                    textAlign: 'center',
                    fontSize: 'A',
                    color: 'neutral500',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            publicBookingStep: 'form'
                        })
                },
                SecureNote: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    marginTop: 'Y',
                    LockIcon: {
                        text: "\uD83D\uDD12",
                        fontSize: 'Y'
                    },
                    SecureText: {
                        text: "Secure payment \xb7 SSL encrypted",
                        fontSize: 'Y',
                        color: 'neutral400'
                    }
                }
            },
            // ─── Success view ─────────────────────────────
            SuccessView: {
                flow: 'y',
                gap: 'A',
                align: 'center center',
                textAlign: 'center',
                padding: 'C',
                show: (el, s)=>s.root.publicBookingStep === 'success',
                SuccessIcon: {
                    extends: 'Icon',
                    icon: 'check',
                    color: 'neutral800',
                    width: 'C',
                    height: 'C'
                },
                SuccessTitle: {
                    tag: 'h2',
                    text: '{{ bookingConfirmedMsg | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'neutral900'
                },
                SuccessDetails: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'neutral100',
                    border: '1px solid neutral200',
                    borderRadius: 'Z',
                    width: '100%',
                    DetailFirm: {
                        text: '{{ lawGroupBarateli | polyglot }}',
                        fontSize: 'A',
                        color: 'neutral900',
                        fontWeight: '600'
                    },
                    DetailLawyer: {
                        text: '{{ ninoBarateli | polyglot }}',
                        fontSize: 'A',
                        color: 'neutral500'
                    },
                    DetailTime: {
                        text: (el, s)=>'{{ timeLabel | polyglot }}' + (s.root.selectedSlot || ''),
                        fontSize: 'A',
                        color: 'neutral800',
                        fontWeight: '600'
                    }
                }
            }
        }
    },
    // Footer
    PublicFooter: {
        tag: 'footer',
        flow: 'x',
        align: 'center space-between',
        padding: 'A C',
        borderTop: '1px solid surfaceBorder',
        '@mobileL': {
            flow: 'y',
            gap: 'Z',
            padding: 'A',
            align: 'center center'
        },
        FooterCopy: {
            text: "\xa9 2026 TrustLegal",
            fontSize: 'Z',
            color: 'textMuted'
        },
        FooterLinks: {
            flow: 'x',
            gap: 'A',
            align: 'center',
            FooterLink1: {
                extends: 'Link',
                href: '/',
                text: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8",
                fontSize: 'Z',
                color: 'textMuted',
                textDecoration: 'none'
            },
            FooterLink2: {
                extends: 'Link',
                href: '/login',
                text: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0",
                fontSize: 'Z',
                color: 'textMuted',
                textDecoration: 'none'
            }
        }
    }
};


const $e27b5f5bbb7cc435$export$3931a0da49df8dc0 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'A',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            flexWrap: 'wrap',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ casesTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                whiteSpace: 'nowrap',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                flexShrink: '0',
                '@mobileL': {
                    flexWrap: 'wrap',
                    width: '100%'
                },
                SearchInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'search',
                    placeholder: '{{ searchPlaceholder2 | polyglot }}',
                    padding: 'Y Z',
                    fontSize: 'Z',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    outline: 'none',
                    width: 'E',
                    minWidth: 'D'
                },
                NewCaseBtn: {
                    extends: 'Button',
                    text: '{{ newCase | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    border: 'none',
                    fontWeight: '600',
                    padding: 'Y Z',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: null,
                            detailTab: 'info'
                        })
                },
                ThemeToggle: {}
            }
        },
        // Filter tabs + integration pills
        FilterBar: {
            flow: 'x',
            gap: 'Z',
            align: 'center space-between',
            '@mobileL': {
                flexWrap: 'wrap',
                gap: 'Y'
            },
            TabsRow: {
                flow: 'x',
                gap: 'Z',
                TabAll: {
                    extends: 'Button',
                    text: '{{ allTab | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.activeTab === 'all' ? 'green' : 'surfaceBorder',
                    color: (el, s)=>s.root.activeTab === 'all' ? 'black' : 'textSoft',
                    fontWeight: (el, s)=>s.root.activeTab === 'all' ? '700' : '400',
                    onClick: (e, el, s)=>s.root.update({
                            activeTab: 'all'
                        })
                },
                TabActive: {
                    extends: 'Button',
                    text: '{{ activeTab | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.activeTab === 'active' ? 'green' : 'surfaceBorder',
                    color: (el, s)=>s.root.activeTab === 'active' ? 'black' : 'textSoft',
                    fontWeight: (el, s)=>s.root.activeTab === 'active' ? '700' : '400',
                    onClick: (e, el, s)=>s.root.update({
                            activeTab: 'active'
                        })
                },
                TabPending: {
                    extends: 'Button',
                    text: '{{ pendingTab | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.activeTab === 'pending' ? 'green' : 'surfaceBorder',
                    color: (el, s)=>s.root.activeTab === 'pending' ? 'black' : 'textSoft',
                    fontWeight: (el, s)=>s.root.activeTab === 'pending' ? '700' : '400',
                    onClick: (e, el, s)=>s.root.update({
                            activeTab: 'pending'
                        })
                },
                TabClosed: {
                    extends: 'Button',
                    text: '{{ closedTab | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.activeTab === 'closed' ? 'green' : 'surfaceBorder',
                    color: (el, s)=>s.root.activeTab === 'closed' ? 'black' : 'textSoft',
                    fontWeight: (el, s)=>s.root.activeTab === 'closed' ? '700' : '400',
                    onClick: (e, el, s)=>s.root.update({
                            activeTab: 'closed'
                        })
                }
            },
            IntPills: {
                flow: 'x',
                gap: 'Y',
                align: 'center',
                EcourtPill: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    padding: 'Y Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.detailTab === 'ecourt' ? 'greenBg' : 'transparent',
                    border: (el, s)=>s.root.detailTab === 'ecourt' ? '1px solid green' : '1px solid surfaceBorderStrong',
                    transition: 'all 150ms',
                    ':hover': {
                        borderColor: 'green'
                    },
                    onClick: (e, el, s)=>s.root.update({
                            detailTab: s.root.detailTab === 'ecourt' ? 'info' : 'ecourt'
                        }),
                    PillIcon: {
                        text: "\u2696\uFE0F",
                        fontSize: 'Y'
                    },
                    PillLabel: {
                        text: 'ecourt',
                        fontSize: 'Y',
                        color: (el, s)=>s.root.detailTab === 'ecourt' ? 'green' : 'textMuted',
                        fontWeight: '500'
                    }
                },
                ReestryPill: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    padding: 'Y Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.detailTab === 'reestry' ? 'blueBg' : 'transparent',
                    border: (el, s)=>s.root.detailTab === 'reestry' ? '1px solid blue' : '1px solid surfaceBorderStrong',
                    transition: 'all 150ms',
                    ':hover': {
                        borderColor: 'blue'
                    },
                    onClick: (e, el, s)=>s.root.update({
                            detailTab: s.root.detailTab === 'reestry' ? 'info' : 'reestry'
                        }),
                    PillIcon: {
                        text: "\uD83C\uDFDB\uFE0F",
                        fontSize: 'Y'
                    },
                    PillLabel: {
                        text: '{{ registry | polyglot }}',
                        fontSize: 'Y',
                        color: (el, s)=>s.root.detailTab === 'reestry' ? 'blue' : 'textMuted',
                        fontWeight: '500'
                    }
                },
                MatsnePill: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    padding: 'Y Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.detailTab === 'matsne' ? 'purpleBg' : 'transparent',
                    border: (el, s)=>s.root.detailTab === 'matsne' ? '1px solid purple' : '1px solid surfaceBorderStrong',
                    transition: 'all 150ms',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    onClick: (e, el, s)=>s.root.update({
                            detailTab: s.root.detailTab === 'matsne' ? 'info' : 'matsne'
                        }),
                    PillIcon: {
                        text: "\uD83D\uDCDC",
                        fontSize: 'Y'
                    },
                    PillLabel: {
                        text: 'matsne',
                        fontSize: 'Y',
                        color: (el, s)=>s.root.detailTab === 'matsne' ? 'purple' : 'textMuted',
                        fontWeight: '500'
                    }
                }
            }
        },
        // Two-column layout
        CasesContent: {
            flow: 'x',
            gap: 'B',
            flex: '1',
            alignItems: 'flex-start',
            '@tabletS': {
                flow: 'y'
            },
            // Left: Cases list
            CasesList: {
                flow: 'y',
                gap: 'Z',
                flex: '1',
                CaseRow1: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeCaseId === 1 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeCaseId === 1 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms, border 150ms',
                    show: (el, s)=>s.root.activeTab === 'all' || s.root.activeTab === 'active',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 1,
                            detailTab: 'info'
                        }),
                    CaseMainInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNumClient: {
                            text: '{{ caseRow1Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMetaRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            TypeBadge: {
                                tag: 'span',
                                text: '{{ typeCivil | polyglot }}',
                                fontSize: 'Y',
                                padding: 'Y Z',
                                background: 'blueBg',
                                border: '1px solid blueBorder',
                                borderRadius: 'Z',
                                color: 'blue'
                            },
                            UpdateDate: {
                                text: '{{ dateMar18 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    RowStatus: {
                        extends: 'StatusActive',
                        text: '{{ activeTab | polyglot }}'
                    }
                },
                CaseRow2: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeCaseId === 2 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeCaseId === 2 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms, border 150ms',
                    show: (el, s)=>s.root.activeTab === 'all' || s.root.activeTab === 'pending',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 2,
                            detailTab: 'info'
                        }),
                    CaseMainInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNumClient: {
                            text: '{{ caseRow2Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMetaRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            TypeBadge: {
                                tag: 'span',
                                text: '{{ typeAdministrative | polyglot }}',
                                fontSize: 'Y',
                                padding: 'Y Z',
                                background: 'purpleBg',
                                border: '1px solid purpleBorder',
                                borderRadius: 'Z',
                                color: 'purple'
                            },
                            UpdateDate: {
                                text: '{{ dateMar17 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    RowStatus: {
                        extends: 'StatusPending',
                        text: '{{ pendingTab | polyglot }}'
                    }
                },
                CaseRow3: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeCaseId === 3 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeCaseId === 3 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms, border 150ms',
                    show: (el, s)=>s.root.activeTab === 'all' || s.root.activeTab === 'closed',
                    onClick: (e, el, s)=>s.root.update({
                            activeCaseId: 3,
                            detailTab: 'info'
                        }),
                    CaseMainInfo: {
                        flow: 'y',
                        gap: 'Z',
                        CaseNumClient: {
                            text: '{{ caseRow3Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseMetaRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            TypeBadge: {
                                tag: 'span',
                                text: '{{ typeCriminal | polyglot }}',
                                fontSize: 'Y',
                                padding: 'Y Z',
                                background: 'redBg',
                                border: '1px solid redBorder',
                                borderRadius: 'Z',
                                color: 'red'
                            },
                            UpdateDate: {
                                text: '{{ dateMar15 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    RowStatus: {
                        extends: 'StatusClosed',
                        text: '{{ closedTab | polyglot }}'
                    }
                },
                // Empty state hint
                SelectHint: {
                    flow: 'y',
                    align: 'center center',
                    padding: 'C',
                    gap: 'Z',
                    show: (el, s)=>s.root.activeCaseId === null,
                    HintIcon: {
                        text: "\u2190",
                        fontSize: 'C',
                        color: 'textMuted'
                    },
                    HintText: {
                        text: '{{ selectCasePrompt | polyglot }}',
                        fontSize: 'A',
                        color: 'textMuted',
                        textAlign: 'center'
                    }
                }
            },
            // Right: Case detail with tabbed content
            CaseDetail: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'A',
                minWidth: 'G3',
                maxWidth: 'H',
                '@tabletS': {
                    maxWidth: '100%',
                    width: '100%'
                },
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                if: (el, s)=>s.root.activeCaseId !== null,
                overflow: 'auto',
                maxHeight: '80vh',
                // Header
                DetailHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    DetailLeft: {
                        flow: 'y',
                        gap: 'Y',
                        DetailTitle: {
                            text: (el, s)=>{
                                if (s.root.activeCaseId === 1) return '{{ caseRow1Title | polyglot }}';
                                if (s.root.activeCaseId === 2) return '{{ caseRow2Title | polyglot }}';
                                return '{{ caseRow3Title | polyglot }}';
                            },
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'text'
                        },
                        StatusRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            Case1Status: {
                                extends: 'StatusActive',
                                text: '{{ activeTab | polyglot }}',
                                show: (el, s)=>s.root.activeCaseId === 1
                            },
                            Case2Status: {
                                extends: 'StatusPending',
                                text: '{{ pendingTab | polyglot }}',
                                show: (el, s)=>s.root.activeCaseId === 2
                            },
                            Case3Status: {
                                extends: 'StatusClosed',
                                text: '{{ closedTab | polyglot }}',
                                show: (el, s)=>s.root.activeCaseId === 3
                            }
                        }
                    },
                    CloseBtn: {
                        text: "\u2715",
                        background: 'transparent',
                        border: 'none',
                        color: 'textSoft',
                        fontSize: 'A',
                        padding: 'Z',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.root.update({
                                activeCaseId: null
                            })
                    }
                },
                // Detail tabs: info, ecourt, reestry, matsne
                DetailTabs: {
                    flow: 'x',
                    gap: 'Y',
                    borderBottom: '1px solid surfaceBorderStrong',
                    padding: '0 0 Z 0',
                    '@mobileL': {
                        flexWrap: 'wrap'
                    },
                    TabInfo: {
                        text: '{{ info | polyglot }}',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        borderRadius: 'Y',
                        background: (el, s)=>s.root.detailTab === 'info' ? 'green' : 'transparent',
                        color: (el, s)=>s.root.detailTab === 'info' ? 'neutral950' : 'textSoft',
                        fontWeight: (el, s)=>s.root.detailTab === 'info' ? '600' : '400',
                        onClick: (e, el, s)=>s.root.update({
                                detailTab: 'info'
                            })
                    },
                    TabEcourt: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        borderRadius: 'Y',
                        background: (el, s)=>s.root.detailTab === 'ecourt' ? 'greenBg' : 'transparent',
                        color: (el, s)=>s.root.detailTab === 'ecourt' ? 'green' : 'textMuted',
                        fontWeight: (el, s)=>s.root.detailTab === 'ecourt' ? '600' : '400',
                        border: (el, s)=>s.root.detailTab === 'ecourt' ? '1px solid greenBorder' : '1px solid transparent',
                        onClick: (e, el, s)=>s.root.update({
                                detailTab: 'ecourt'
                            }),
                        PillIcon: {
                            text: "\u2696\uFE0F",
                            fontSize: 'Y'
                        },
                        PillLabel: {
                            text: '{{ ecourt | polyglot }}'
                        }
                    },
                    TabReestry: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        borderRadius: 'Y',
                        background: (el, s)=>s.root.detailTab === 'reestry' ? 'blueBg' : 'transparent',
                        color: (el, s)=>s.root.detailTab === 'reestry' ? 'blue' : 'textMuted',
                        fontWeight: (el, s)=>s.root.detailTab === 'reestry' ? '600' : '400',
                        border: (el, s)=>s.root.detailTab === 'reestry' ? '1px solid blueBorder' : '1px solid transparent',
                        onClick: (e, el, s)=>s.root.update({
                                detailTab: 'reestry'
                            }),
                        PillIcon: {
                            text: "\uD83C\uDFDB\uFE0F",
                            fontSize: 'Y'
                        },
                        PillLabel: {
                            text: '{{ registry | polyglot }}'
                        }
                    },
                    TabMatsne: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        borderRadius: 'Y',
                        background: (el, s)=>s.root.detailTab === 'matsne' ? 'purpleBg' : 'transparent',
                        color: (el, s)=>s.root.detailTab === 'matsne' ? 'purple' : 'textMuted',
                        fontWeight: (el, s)=>s.root.detailTab === 'matsne' ? '600' : '400',
                        border: (el, s)=>s.root.detailTab === 'matsne' ? '1px solid purpleBorder' : '1px solid transparent',
                        onClick: (e, el, s)=>s.root.update({
                                detailTab: 'matsne'
                            }),
                        PillIcon: {
                            text: "\uD83D\uDCDC",
                            fontSize: 'Y'
                        },
                        PillLabel: {
                            text: '{{ matsne | polyglot }}'
                        }
                    }
                },
                // ═══ Tab: Info ═══
                InfoContent: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.detailTab === 'info',
                    ClientInfo: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        background: 'surfaceCard',
                        border: '1px solid surfaceBorder',
                        borderRadius: 'Z',
                        InfoLabel: {
                            text: '{{ clientInfo | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'textMuted'
                        },
                        InfoName: {
                            text: (el, s)=>{
                                if (s.root.activeCaseId === 1) return '{{ clientName1 | polyglot }}';
                                if (s.root.activeCaseId === 2) return '{{ clientName2 | polyglot }}';
                                return '{{ clientName3 | polyglot }}';
                            },
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        ContactRow: {
                            flow: 'x',
                            gap: 'B',
                            flexWrap: 'wrap',
                            PhoneInfo: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center',
                                PhoneIcon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'textMuted'
                                },
                                PhoneText: {
                                    text: '+995 555 123 456',
                                    fontSize: 'Z',
                                    color: 'textSoft'
                                }
                            },
                            EmailInfo: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center',
                                MailIcon: {
                                    extends: 'Icon',
                                    icon: 'mail',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'textMuted'
                                },
                                EmailText: {
                                    text: (el, s)=>{
                                        if (s.root.activeCaseId === 1) return 'giorgi@mail.ge';
                                        if (s.root.activeCaseId === 2) return 'mariam@mail.ge';
                                        return 'lela@mail.ge';
                                    },
                                    fontSize: 'Z',
                                    color: 'textSoft'
                                }
                            }
                        }
                    },
                    TimelineSection: {
                        flow: 'y',
                        gap: 'Z',
                        TimelineTitle: {
                            text: '{{ chronology | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text',
                            padding: '0 0 Z 0'
                        },
                        TimeEntry1: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'Z A',
                            borderLeft: '2px solid green',
                            TimeDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'green',
                                flexShrink: '0',
                                marginTop: 'X'
                            },
                            EntryContent: {
                                flow: 'y',
                                gap: 'Z',
                                EntryDate: {
                                    text: '{{ timeEntry1Date | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'textMuted',
                                    fontWeight: '500'
                                },
                                EntryText: {
                                    text: '{{ timeEntry1Text | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'textSoft',
                                    lineHeight: '1.5'
                                }
                            }
                        },
                        TimeEntry2: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'Z A',
                            borderLeft: '2px solid surfaceBorderStrong',
                            TimeDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'surfaceBorderStrong',
                                flexShrink: '0',
                                marginTop: 'X'
                            },
                            EntryContent: {
                                flow: 'y',
                                gap: 'Z',
                                EntryDate: {
                                    text: '{{ timeEntry2Date | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'textMuted',
                                    fontWeight: '500'
                                },
                                EntryText: {
                                    text: '{{ timeEntry2Text | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'textSoft',
                                    lineHeight: '1.5'
                                }
                            }
                        },
                        TimeEntry3: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'Z A',
                            borderLeft: '2px solid surfaceBorderStrong',
                            TimeDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'surfaceBorderStrong',
                                flexShrink: '0',
                                marginTop: 'X'
                            },
                            EntryContent: {
                                flow: 'y',
                                gap: 'Z',
                                EntryDate: {
                                    text: '{{ timeEntry3Date | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'textMuted',
                                    fontWeight: '500'
                                },
                                EntryText: {
                                    text: '{{ timeEntry3Text | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'textSoft',
                                    lineHeight: '1.5'
                                }
                            }
                        }
                    },
                    AddNoteSection: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A 0 0 0',
                        borderTop: '1px solid surfaceBorderStrong',
                        NoteTitle: {
                            text: '{{ addNote | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text',
                            padding: 'Z 0'
                        },
                        NoteInput: {
                            tag: 'textarea',
                            name: 'note',
                            placeholder: '{{ enterNote | polyglot }}',
                            padding: 'Z',
                            fontSize: 'Z',
                            background: 'surfaceCard',
                            border: '1px solid surfaceBorderStrong',
                            borderRadius: 'Z',
                            color: 'text',
                            minHeight: 'C'
                        },
                        AddNoteBtn: {
                            extends: 'Button',
                            text: '{{ addBtn | polyglot }}',
                            background: 'green',
                            color: 'neutral950',
                            border: 'none',
                            fontWeight: '600',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer'
                        }
                    },
                    DocsSection: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A 0 0 0',
                        borderTop: '1px solid surfaceBorderStrong',
                        DocsHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            DocsTitle: {
                                text: '{{ documentsLabel | polyglot }}',
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'text'
                            },
                            CreateDocLink: {
                                extends: 'Link',
                                href: '/documents',
                                text: '{{ createBtn | polyglot }}',
                                fontSize: 'Z',
                                color: 'green',
                                textDecoration: 'none'
                            }
                        },
                        EmptyDocs: {
                            flow: 'y',
                            align: 'center center',
                            padding: 'A',
                            background: 'surfaceCard',
                            border: '1px solid surfaceBorderStrong',
                            borderRadius: 'Z',
                            EmptyDocIcon: {
                                extends: 'Icon',
                                icon: 'document',
                                color: 'textMuted',
                                width: 'A',
                                height: 'A'
                            },
                            EmptyDocText: {
                                text: '{{ noDocs | polyglot }}',
                                fontSize: 'A',
                                color: 'textMuted'
                            }
                        }
                    }
                },
                // ═══ Tab: ecourt.ge ═══
                EcourtContent: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.detailTab === 'ecourt',
                    Desc: {
                        text: '{{ ecourtDesc | polyglot }}',
                        fontSize: 'Z',
                        color: 'textSoft',
                        lineHeight: '1.5'
                    },
                    Card1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'greenBg',
                        border: '1px solid greenBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ hearingSchedule | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CardItem1: {
                            text: '{{ hearingItem1 | polyglot }}',
                            fontSize: 'Y',
                            color: 'textSoft'
                        },
                        CardItem2: {
                            text: '{{ hearingItem2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'textSoft'
                        }
                    },
                    Card2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'greenBg',
                        border: '1px solid greenBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ caseStatus | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Step1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            StepDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'green',
                                flexShrink: '0'
                            },
                            StepText: {
                                text: '{{ claimFiled | polyglot }}',
                                fontSize: 'Y',
                                color: 'text'
                            },
                            StepStatus: {
                                text: "\u2713",
                                color: 'green'
                            }
                        },
                        Step2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            StepDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'green',
                                flexShrink: '0'
                            },
                            StepText: {
                                text: '{{ claimAccepted | polyglot }}',
                                fontSize: 'Y',
                                color: 'text'
                            },
                            StepStatus: {
                                text: "\u2713",
                                color: 'green'
                            }
                        },
                        Step3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            StepDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'amber',
                                flexShrink: '0'
                            },
                            StepText: {
                                text: '{{ prepHearing | polyglot }}',
                                fontSize: 'Y',
                                color: 'text'
                            },
                            StepStatus: {
                                text: "\u27F3",
                                color: 'amber'
                            }
                        }
                    },
                    Card3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'greenBg',
                        border: '1px solid greenBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ electronicFiling | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Doc1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            DocIcon: {
                                text: "\uD83D\uDCC4",
                                fontSize: 'Z'
                            },
                            DocInfo: {
                                text: '{{ claimFiledDoc | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            DocStatus: {
                                text: "\u2713",
                                color: 'green'
                            }
                        },
                        Doc2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            DocIcon: {
                                text: "\uD83D\uDCC4",
                                fontSize: 'Z'
                            },
                            DocInfo: {
                                text: '{{ evidencePending | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                flex: '1'
                            },
                            DocStatus: {
                                text: "\u27F3",
                                color: 'amber'
                            }
                        }
                    }
                },
                // ═══ Tab: საჯარო რეესტრი ═══
                ReestryContent: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.detailTab === 'reestry',
                    Desc: {
                        text: '{{ registryDesc | polyglot }}',
                        fontSize: 'Z',
                        color: 'textSoft',
                        lineHeight: '1.5'
                    },
                    Card1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'blueBg',
                        border: '1px solid blueBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ companyName | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Row1: {
                            flow: 'x',
                            gap: 'Z',
                            Label: {
                                text: '{{ idCode | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted',
                                minWidth: 'D'
                            },
                            Val: {
                                text: '404789012',
                                fontSize: 'Y',
                                color: 'text'
                            }
                        },
                        Row2: {
                            flow: 'x',
                            gap: 'Z',
                            Label: {
                                text: '{{ director | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted',
                                minWidth: 'D'
                            },
                            Val: {
                                text: '{{ clientName1 | polyglot }}',
                                fontSize: 'Y',
                                color: 'text'
                            }
                        },
                        Row3: {
                            flow: 'x',
                            gap: 'Z',
                            Label: {
                                text: '{{ address | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted',
                                minWidth: 'D'
                            },
                            Val: {
                                text: '{{ addressVal | polyglot }}',
                                fontSize: 'Y',
                                color: 'text'
                            }
                        },
                        Row4: {
                            flow: 'x',
                            gap: 'Z',
                            Label: {
                                text: '{{ statusLabel | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted',
                                minWidth: 'D'
                            },
                            Val: {
                                text: '{{ activeTab | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    Card2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'blueBg',
                        border: '1px solid blueBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ registeredProperty | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Prop1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            PropIcon: {
                                text: "\uD83C\uDFE0",
                                fontSize: 'Z'
                            },
                            PropText: {
                                text: '{{ propertyApartment | polyglot }}',
                                fontSize: 'Y',
                                color: 'textSoft'
                            }
                        },
                        Prop2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            PropIcon: {
                                text: "\uD83D\uDE97",
                                fontSize: 'Z'
                            },
                            PropText: {
                                text: '{{ propertyCar | polyglot }}',
                                fontSize: 'Y',
                                color: 'textSoft'
                            }
                        }
                    },
                    Card3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'blueBg',
                        border: '1px solid blueBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ extract | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Ext1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            ExtDate: {
                                text: '{{ dateMar18 | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            },
                            ExtInfo: {
                                text: '{{ companyExtractLoaded | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            ExtStatus: {
                                text: "\u2713",
                                color: 'blue'
                            }
                        },
                        Ext2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            ExtDate: {
                                text: '{{ dateMar18 | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            },
                            ExtInfo: {
                                text: '{{ propertyExtractAdded | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            ExtStatus: {
                                text: "\u2713",
                                color: 'blue'
                            }
                        }
                    }
                },
                // ═══ Tab: matsne.gov.ge ═══
                MatsneContent: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.detailTab === 'matsne',
                    Desc: {
                        text: '{{ matsneDesc | polyglot }}',
                        fontSize: 'Z',
                        color: 'textSoft',
                        lineHeight: '1.5'
                    },
                    Card1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'purpleBg',
                        border: '1px solid purpleBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ recentChanges | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Change1: {
                            flow: 'y',
                            gap: 'Y',
                            padding: 'Z 0',
                            borderBottom: '1px solid surfaceBorderStrong',
                            ChangeName: {
                                text: '{{ change1Name | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '500',
                                color: 'text'
                            },
                            ChangeDesc: {
                                text: '{{ change1Desc | polyglot }}',
                                fontSize: 'Y',
                                color: 'textSoft'
                            },
                            ChangeDate: {
                                text: '{{ change1Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'purple'
                            }
                        },
                        Change2: {
                            flow: 'y',
                            gap: 'Y',
                            padding: 'Z 0',
                            ChangeName: {
                                text: '{{ change2Name | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '500',
                                color: 'text'
                            },
                            ChangeDesc: {
                                text: '{{ change2Desc | polyglot }}',
                                fontSize: 'Y',
                                color: 'textSoft'
                            },
                            ChangeDate: {
                                text: '{{ change2Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'purple'
                            }
                        }
                    },
                    Card2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'purpleBg',
                        border: '1px solid purpleBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ yourFieldChanges | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Field1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            FieldDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'purple',
                                flexShrink: '0'
                            },
                            FieldText: {
                                text: '{{ field1Text | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            FieldStatus: {
                                text: '{{ newLabel | polyglot }}',
                                fontSize: 'Y',
                                color: 'purple',
                                fontWeight: '600'
                            }
                        },
                        Field2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            FieldDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'purple',
                                flexShrink: '0'
                            },
                            FieldText: {
                                text: '{{ field2Text | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            FieldStatus: {
                                text: '{{ newLabel | polyglot }}',
                                fontSize: 'Y',
                                color: 'purple',
                                fontWeight: '600'
                            }
                        },
                        Field3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            FieldDot: {
                                width: 'Y',
                                height: 'Y',
                                borderRadius: '100%',
                                background: 'blue',
                                flexShrink: '0'
                            },
                            FieldText: {
                                text: '{{ field3Text | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            FieldStatus: {
                                text: '{{ newLabel | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    Card3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z A',
                        background: 'purpleBg',
                        border: '1px solid purpleBorder',
                        borderRadius: 'Z',
                        CardTitle: {
                            text: '{{ notifications | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        Setting1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            SettingLabel: {
                                text: '{{ typeCivil | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            SettingVal: {
                                text: '{{ enabledStatus | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        },
                        Setting2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            SettingLabel: {
                                text: '{{ typeAdministrative | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            SettingVal: {
                                text: '{{ enabledStatus | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        },
                        Setting3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            SettingLabel: {
                                text: '{{ typeCriminal | polyglot }}',
                                fontSize: 'Y',
                                color: 'text',
                                flex: '1'
                            },
                            SettingVal: {
                                text: '{{ disabledStatus | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            }
                        }
                    }
                }
            }
        }
    }
};


const $3b8c74c1f9bd59bc$export$a985976c39663a82 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ clientsTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flexWrap: 'wrap'
                },
                SearchInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'search',
                    placeholder: '{{ clientsSearchPlaceholder | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    width: 'F'
                },
                ThemeToggle: {}
            }
        },
        ClientsList: {
            flow: 'x',
            gap: 'B',
            '@tabletS': {
                flow: 'y'
            },
            ClientCards: {
                flow: 'y',
                gap: 'Z',
                flex: '1',
                Client1: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeClientId === 1 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeClientId === 1 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms',
                    onClick: (e, el, s)=>s.root.update({
                            activeClientId: 1
                        }),
                    ClientLeft: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        ClientAvatar: {
                            width: 'B',
                            height: 'B',
                            borderRadius: '100%',
                            background: 'greenBg',
                            color: 'green',
                            flow: 'x',
                            align: 'center center',
                            fontSize: 'Z',
                            fontWeight: '700',
                            text: '{{ clientsAvatar1 | polyglot }}',
                            flexShrink: '0'
                        },
                        ClientInfo: {
                            flow: 'y',
                            gap: 'Y',
                            ClientName: {
                                text: '{{ clientName1 | polyglot }}',
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'text'
                            },
                            ClientContact: {
                                text: '{{ clientsContact1 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    ClientRight: {
                        flow: 'y',
                        gap: 'Y',
                        align: 'flex-end',
                        CasesCount: {
                            text: '{{ clientsActiveCases1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'green'
                        },
                        TotalBilled: {
                            text: '{{ clientsPaid1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                Client2: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeClientId === 2 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeClientId === 2 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms',
                    onClick: (e, el, s)=>s.root.update({
                            activeClientId: 2
                        }),
                    ClientLeft: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        ClientAvatar: {
                            width: 'B',
                            height: 'B',
                            borderRadius: '100%',
                            background: 'purpleBg',
                            color: 'purple',
                            flow: 'x',
                            align: 'center center',
                            fontSize: 'Z',
                            fontWeight: '700',
                            text: '{{ clientsAvatar2 | polyglot }}',
                            flexShrink: '0'
                        },
                        ClientInfo: {
                            flow: 'y',
                            gap: 'Y',
                            ClientName: {
                                text: '{{ clientName2 | polyglot }}',
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'text'
                            },
                            ClientContact: {
                                text: '{{ clientsContact2 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    ClientRight: {
                        flow: 'y',
                        gap: 'Y',
                        align: 'flex-end',
                        CasesCount: {
                            text: '{{ clientsActiveCases2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'green'
                        },
                        TotalBilled: {
                            text: '{{ clientsPaid2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                Client3: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'A',
                    background: (el, s)=>s.root.activeClientId === 3 ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.root.activeClientId === 3 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    transition: 'background 150ms',
                    onClick: (e, el, s)=>s.root.update({
                            activeClientId: 3
                        }),
                    ClientLeft: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        ClientAvatar: {
                            width: 'B',
                            height: 'B',
                            borderRadius: '100%',
                            background: 'blueBg',
                            color: 'blue',
                            flow: 'x',
                            align: 'center center',
                            fontSize: 'Z',
                            fontWeight: '700',
                            text: '{{ clientsAvatar3 | polyglot }}',
                            flexShrink: '0'
                        },
                        ClientInfo: {
                            flow: 'y',
                            gap: 'Y',
                            ClientName: {
                                text: '{{ clientName3 | polyglot }}',
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'text'
                            },
                            ClientContact: {
                                text: '{{ clientsContact3 | polyglot }}',
                                fontSize: 'Z',
                                color: 'textMuted'
                            }
                        }
                    },
                    ClientRight: {
                        flow: 'y',
                        gap: 'Y',
                        align: 'flex-end',
                        CasesCount: {
                            text: '{{ clientsActiveCases3 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        },
                        TotalBilled: {
                            text: '{{ clientsPaid3 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                }
            },
            // Client detail
            ClientDetail: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                maxWidth: 'H',
                '@tabletS': {
                    maxWidth: '100%',
                    width: '100%'
                },
                padding: 'B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                show: (el, s)=>s.root.activeClientId !== null,
                DetailHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: '0 0 A 0',
                    borderBottom: '1px solid surfaceBorderStrong',
                    DetailTitle: {
                        tag: 'h3',
                        text: '{{ clientsProfile | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    CloseBtn: {
                        extends: 'Button',
                        text: "\u2715",
                        theme: 'transparent',
                        color: 'textSoft',
                        fontSize: 'A',
                        padding: 'Z',
                        cursor: 'pointer',
                        borderRadius: 'Z',
                        onClick: (e, el, s)=>s.root.update({
                                activeClientId: null
                            })
                    }
                },
                ContactSection: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorder',
                    borderRadius: 'Z',
                    SectionLabel: {
                        text: '{{ clientsContactLabel | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'textMuted'
                    },
                    ContactName: {
                        text: (el, s)=>{
                            if (s.root.activeClientId === 1) return '{{ clientName1 | polyglot }}';
                            if (s.root.activeClientId === 2) return '{{ clientName2 | polyglot }}';
                            return '{{ clientName3 | polyglot }}';
                        },
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    },
                    ContactDetails: {
                        flow: 'x',
                        gap: 'B',
                        flexWrap: 'wrap',
                        PhoneRow: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            PhoneIcon: {
                                extends: 'Icon',
                                icon: 'phone',
                                width: 'Z',
                                height: 'Z',
                                color: 'textMuted'
                            },
                            PhoneVal: {
                                text: (el, s)=>{
                                    if (s.root.activeClientId === 1) return '599123456';
                                    if (s.root.activeClientId === 2) return '577234567';
                                    return '571456789';
                                },
                                fontSize: 'Z',
                                color: 'textSoft'
                            }
                        },
                        EmailRow: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            MailIcon: {
                                extends: 'Icon',
                                icon: 'mail',
                                width: 'Z',
                                height: 'Z',
                                color: 'textMuted'
                            },
                            EmailVal: {
                                text: (el, s)=>{
                                    if (s.root.activeClientId === 1) return 'g.mamulasvili@gmail.com';
                                    if (s.root.activeClientId === 2) return 'mari.k@mail.ru';
                                    return 'lela.g@inbox.ge';
                                },
                                fontSize: 'Z',
                                color: 'textSoft'
                            }
                        }
                    }
                },
                CasesSection: {
                    flow: 'y',
                    gap: 'Z',
                    SectionLabel: {
                        text: '{{ casesTitle | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CaseLink1: {
                        extends: 'Link',
                        href: '/cases',
                        text: '{{ clientsCaseLink1 | polyglot }}',
                        fontSize: 'Z',
                        color: 'green',
                        textDecoration: 'none',
                        show: (el, s)=>s.root.activeClientId === 1,
                        onClick: (e, el, s)=>s.root.update({
                                activeCaseId: 1
                            })
                    },
                    CaseLink2: {
                        extends: 'Link',
                        href: '/cases',
                        text: '{{ clientsCaseLink2 | polyglot }}',
                        fontSize: 'Z',
                        color: 'green',
                        textDecoration: 'none',
                        show: (el, s)=>s.root.activeClientId === 2,
                        onClick: (e, el, s)=>s.root.update({
                                activeCaseId: 2
                            })
                    },
                    CaseLink3: {
                        text: '{{ clientsNoCases | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        fontStyle: 'italic',
                        show: (el, s)=>s.root.activeClientId === 3
                    }
                },
                InvoicesSection: {
                    flow: 'y',
                    gap: 'Z',
                    SectionLabel: {
                        text: '{{ clientsInvoiceHistory | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    },
                    InvRow1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        background: 'surfaceCard',
                        borderRadius: 'Z',
                        show: (el, s)=>s.root.activeClientId === 1,
                        InvNum: {
                            text: 'INV-2024-031',
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        InvAmount: {
                            text: "\u20BE1,200",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        InvStatus: {
                            extends: 'StatusPending',
                            text: '{{ clientsUnpaid | polyglot }}'
                        }
                    },
                    InvRow2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        background: 'surfaceCard',
                        borderRadius: 'Z',
                        show: (el, s)=>s.root.activeClientId === 2,
                        InvNum: {
                            text: 'INV-2024-030',
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        InvAmount: {
                            text: "\u20BE640",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        InvStatus: {
                            extends: 'StatusConfirmed',
                            text: '{{ clientsPaid | polyglot }}'
                        }
                    }
                },
                PortalInviteBtn: {
                    extends: 'Button',
                    text: '{{ clientsPortalInvite | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    width: '100%',
                    textAlign: 'center'
                }
            }
        }
    }
};


const $d7f053e17fe69c28$export$3260cc9ddc8b12d = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    state: {
        docTab: 'create',
        ocrModalOpen: false,
        ocrStep: 'upload'
    },
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ docsTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            ThemeToggle: {}
        },
        // ─── Tabs ─────────────────────────────────────
        DocTabs: {
            flow: 'x',
            gap: 'Z',
            borderBottom: '1px solid surfaceBorderStrong',
            padding: '0 0 Z 0',
            '@mobileL': {
                flexWrap: 'wrap'
            },
            TabCreate: {
                extends: 'Button',
                text: '{{ docsCreate | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.docTab === 'create' ? 'green' : 'transparent',
                color: (el, s)=>s.docTab === 'create' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.docTab === 'create' ? '600' : '400',
                onClick: (e, el, s)=>s.update({
                        docTab: 'create'
                    })
            },
            TabExisting: {
                extends: 'Button',
                text: '{{ docsExisting | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.docTab === 'existing' ? 'green' : 'transparent',
                color: (el, s)=>s.docTab === 'existing' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.docTab === 'existing' ? '600' : '400',
                onClick: (e, el, s)=>s.update({
                        docTab: 'existing'
                    })
            },
            TabFiles: {
                extends: 'Button',
                text: '{{ docsFiles | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.docTab === 'files' ? 'green' : 'transparent',
                color: (el, s)=>s.docTab === 'files' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.docTab === 'files' ? '600' : '400',
                onClick: (e, el, s)=>s.update({
                        docTab: 'files'
                    })
            }
        },
        // OCR integration banner
        OcrBanner: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            BannerDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0'
            },
            BannerText: {
                text: '{{ docsOcrNote | polyglot }}',
                fontSize: 'Y',
                color: 'green',
                flex: '1',
                lineHeight: '1.4'
            },
            OcrBtn: {
                extends: 'Button',
                text: '{{ docsOcrScan | polyglot }}',
                background: 'transparent',
                color: 'green',
                border: '1px solid greenBorder',
                padding: 'Y Z',
                fontSize: 'Y',
                borderRadius: 'Z',
                cursor: 'pointer',
                onClick: (e, el, s)=>s.update({
                        ocrModalOpen: true,
                        ocrStep: 'upload'
                    })
            }
        },
        // ─── OCR Modal ──────────────────────────────
        OcrModalOverlay: {
            if: (el, s)=>s.ocrModalOpen,
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            zIndex: '1000',
            background: 'black.7',
            flow: 'x',
            align: 'center center',
            onClick: (e, el, s)=>{
                if (e.target === el.node) s.update({
                    ocrModalOpen: false
                });
            },
            OcrModal: {
                flow: 'y',
                gap: 'A',
                padding: 'C',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                width: '100%',
                maxWidth: 'I',
                height: '85vh',
                maxHeight: '85vh',
                overflow: 'auto',
                // Modal header
                OcrHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    OcrTitle: {
                        tag: 'h2',
                        text: '{{ docsOcrTitle | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    OcrCloseBtn: {
                        extends: 'Button',
                        text: "\u2715",
                        theme: 'transparent',
                        background: 'transparent',
                        border: 'none',
                        color: 'textSoft',
                        fontSize: 'A',
                        padding: 'Z',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.update({
                                ocrModalOpen: false
                            })
                    }
                },
                // Step 1 — Upload
                OcrUploadStep: {
                    flow: 'y',
                    gap: 'A',
                    align: 'center center',
                    show: (el, s)=>s.ocrStep === 'upload',
                    UploadZone: {
                        flow: 'y',
                        gap: 'Z',
                        align: 'center center',
                        padding: 'D B',
                        border: '2px dashed surfaceBorderStrong',
                        borderRadius: 'Z',
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'border-color 200ms',
                        ':hover': {
                            borderColor: 'green'
                        },
                        onClick: (e, el, s)=>{
                            s.update({
                                ocrStep: 'scanning'
                            });
                            setTimeout(()=>s.update({
                                    ocrStep: 'result'
                                }), 2500);
                        },
                        UploadIcon: {
                            text: "\uD83D\uDCC4",
                            fontSize: 'D'
                        },
                        UploadText: {
                            text: '{{ docsUploadText | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text',
                            textAlign: 'center'
                        },
                        UploadSub: {
                            text: '{{ docsUploadSub | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted',
                            textAlign: 'center'
                        },
                        UploadFormats: {
                            text: '{{ docsUploadFormats | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                // Step 2 — Scanning animation
                OcrScanningStep: {
                    flow: 'y',
                    gap: 'A',
                    align: 'center center',
                    padding: 'C',
                    show: (el, s)=>s.ocrStep === 'scanning',
                    ScanIcon: {
                        text: "\uD83D\uDD0D",
                        fontSize: 'D'
                    },
                    ScanText: {
                        text: '{{ docsScanning | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'green'
                    },
                    ScanProgress: {
                        width: '100%',
                        maxWidth: 'F',
                        height: 'Y',
                        background: 'surfaceBorder',
                        borderRadius: 'Z',
                        ScanFill: {
                            width: '70%',
                            height: '100%',
                            background: 'green',
                            borderRadius: 'Z',
                            transition: 'width 2s'
                        }
                    },
                    ScanDetails: {
                        flow: 'y',
                        gap: 'Y',
                        align: 'center',
                        ScanDetail1: {
                            text: "\u2713 {{ docsTextRecognition | polyglot }}",
                            fontSize: 'Z',
                            color: 'green'
                        },
                        ScanDetail2: {
                            text: "\u2713 {{ docsGeorgianSymbols | polyglot }}",
                            fontSize: 'Z',
                            color: 'green'
                        },
                        ScanDetail3: {
                            text: "\u27F3 {{ docsFormatAnalysis | polyglot }}",
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                // Step 3 — Result
                OcrResultStep: {
                    flow: 'y',
                    gap: 'A',
                    flex: '1',
                    show: (el, s)=>s.ocrStep === 'result',
                    ResultBadge: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        alignSelf: 'flex-start',
                        padding: 'Y Z',
                        background: 'greenBg',
                        border: '1px solid greenBorder',
                        borderRadius: 'Z',
                        BadgeDot: {
                            width: 'Y',
                            height: 'Y',
                            borderRadius: '100%',
                            background: 'green'
                        },
                        BadgeText: {
                            text: '{{ docsOcrSuccess | polyglot }}',
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    ResultMeta: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        MetaItem1: {
                            flow: 'y',
                            gap: 'Y',
                            MetaLabel: {
                                text: '{{ docsFile | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            },
                            MetaVal: {
                                text: '{{ docsContractScanPdf | polyglot }}',
                                fontSize: 'Z',
                                color: 'text',
                                fontWeight: '500'
                            }
                        },
                        MetaItem2: {
                            flow: 'y',
                            gap: 'Y',
                            MetaLabel: {
                                text: '{{ docsPages | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            },
                            MetaVal: {
                                text: '3',
                                fontSize: 'Z',
                                color: 'text',
                                fontWeight: '500'
                            }
                        },
                        MetaItem3: {
                            flow: 'y',
                            gap: 'Y',
                            MetaLabel: {
                                text: '{{ docsLanguage | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            },
                            MetaVal: {
                                text: '{{ docsGeorgian | polyglot }}',
                                fontSize: 'Z',
                                color: 'text',
                                fontWeight: '500'
                            }
                        }
                    },
                    ResultText: {
                        padding: 'A',
                        background: 'surfaceCard',
                        borderRadius: 'Z',
                        border: '1px solid surfaceBorder',
                        flex: '1',
                        minHeight: 'G',
                        overflow: 'auto',
                        text: '{{ docsOcrResultText | polyglot }}',
                        fontSize: 'Z',
                        color: 'textSoft',
                        lineHeight: '1.8',
                        whiteSpace: 'pre-wrap'
                    },
                    ResultActions: {
                        flow: 'x',
                        gap: 'Z',
                        flexWrap: 'wrap',
                        SaveDocBtn: {
                            extends: 'Button',
                            text: '{{ docsAddToCase | polyglot }}',
                            background: 'green',
                            color: 'neutral950',
                            fontWeight: '600',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            border: 'none',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.update({
                                    ocrModalOpen: false
                                })
                        },
                        CopyOcrBtn: {
                            extends: 'Button',
                            text: '{{ docsCopy | polyglot }}',
                            background: 'transparent',
                            color: 'neutral300',
                            border: '1px solid neutral700',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer'
                        },
                        RescanBtn: {
                            extends: 'Button',
                            text: '{{ docsRescan | polyglot }}',
                            background: 'transparent',
                            color: 'neutral300',
                            border: '1px solid neutral700',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>{
                                s.update({
                                    ocrStep: 'scanning'
                                });
                                setTimeout(()=>s.update({
                                        ocrStep: 'result'
                                    }), 2500);
                            }
                        }
                    }
                }
            }
        },
        // ═══════════════════════════════════════════════
        // TAB 1 — Create document (AI drafting)
        // ═══════════════════════════════════════════════
        CreateView: {
            flow: 'x',
            gap: 'A',
            flex: '1',
            show: (el, s)=>s.docTab === 'create',
            '@tabletS': {
                flow: 'y'
            },
            TemplateList: {
                flow: 'y',
                gap: 'Z',
                width: 'G',
                flexShrink: '0',
                TplDemand: {
                    padding: 'Z A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    fontSize: 'A',
                    fontWeight: (el, s)=>s.root.selectedTemplate === 'demand' ? '600' : '400',
                    background: (el, s)=>s.root.selectedTemplate === 'demand' ? 'greenBg' : 'transparent',
                    color: (el, s)=>s.root.selectedTemplate === 'demand' ? 'green' : 'textSoft',
                    border: 'none',
                    text: '{{ docsClaim | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            selectedTemplate: 'demand',
                            docOutput: null
                        })
                },
                TplPower: {
                    padding: 'Z A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    fontSize: 'A',
                    fontWeight: (el, s)=>s.root.selectedTemplate === 'power' ? '600' : '400',
                    background: (el, s)=>s.root.selectedTemplate === 'power' ? 'greenBg' : 'transparent',
                    color: (el, s)=>s.root.selectedTemplate === 'power' ? 'green' : 'textSoft',
                    border: 'none',
                    text: '{{ docsPowerOfAttorney | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            selectedTemplate: 'power',
                            docOutput: null
                        })
                },
                TplTermination: {
                    padding: 'Z A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    fontSize: 'A',
                    fontWeight: (el, s)=>s.root.selectedTemplate === 'termination' ? '600' : '400',
                    background: (el, s)=>s.root.selectedTemplate === 'termination' ? 'greenBg' : 'transparent',
                    color: (el, s)=>s.root.selectedTemplate === 'termination' ? 'green' : 'textSoft',
                    border: 'none',
                    text: '{{ docsNotification | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            selectedTemplate: 'termination',
                            docOutput: null
                        })
                },
                TplContract: {
                    padding: 'Z A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    fontSize: 'A',
                    fontWeight: (el, s)=>s.root.selectedTemplate === 'contract' ? '600' : '400',
                    background: (el, s)=>s.root.selectedTemplate === 'contract' ? 'greenBg' : 'transparent',
                    color: (el, s)=>s.root.selectedTemplate === 'contract' ? 'green' : 'textSoft',
                    border: 'none',
                    text: '{{ docsContractReview | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            selectedTemplate: 'contract',
                            docOutput: null
                        })
                },
                TplFree: {
                    padding: 'Z A',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    fontSize: 'A',
                    fontWeight: (el, s)=>s.root.selectedTemplate === 'free' ? '600' : '400',
                    background: (el, s)=>s.root.selectedTemplate === 'free' ? 'greenBg' : 'transparent',
                    color: (el, s)=>s.root.selectedTemplate === 'free' ? 'green' : 'textSoft',
                    border: 'none',
                    text: '{{ docsFreeForm | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            selectedTemplate: 'free',
                            docOutput: null
                        })
                }
            },
            DocForm: {
                margin: '0',
                tag: 'form',
                flow: 'y',
                gap: 'A',
                flex: '1',
                maxWidth: 'G',
                padding: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                FormTitle: {
                    tag: 'h2',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text',
                    text: (el, s)=>{
                        const n = {
                            demand: '{{ docsClaim | polyglot }}',
                            power: '{{ docsPowerOfAttorney | polyglot }}',
                            termination: '{{ docsNotification | polyglot }}',
                            contract: '{{ docsContractReview | polyglot }}',
                            free: '{{ docsFreeForm | polyglot }}'
                        };
                        return n[s.root.selectedTemplate] || '{{ docsDocument | polyglot }}';
                    }
                },
                Party1Label: {
                    tag: 'label',
                    text: '{{ docsParty1 | polyglot }}',
                    fontSize: 'Z',
                    color: 'textSoft',
                    fontWeight: '500'
                },
                Party1Input: {
                    tag: 'input',
                    type: 'text',
                    name: 'party1',
                    placeholder: '{{ docsNameCompany | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text'
                },
                Party2Label: {
                    tag: 'label',
                    text: '{{ docsParty2 | polyglot }}',
                    fontSize: 'Z',
                    color: 'textSoft',
                    fontWeight: '500'
                },
                Party2Input: {
                    tag: 'input',
                    type: 'text',
                    name: 'party2',
                    placeholder: '{{ docsNameCompany | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text'
                },
                DateLabel: {
                    tag: 'label',
                    text: '{{ docsDate | polyglot }}',
                    fontSize: 'Z',
                    color: 'textSoft',
                    fontWeight: '500'
                },
                DateInput: {
                    tag: 'input',
                    type: 'date',
                    name: 'date',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text'
                },
                NotesLabel: {
                    tag: 'label',
                    text: '{{ docsAdditionalInfo | polyglot }}',
                    fontSize: 'Z',
                    color: 'textSoft',
                    fontWeight: '500'
                },
                NotesInput: {
                    tag: 'textarea',
                    name: 'notes',
                    placeholder: '{{ docsFreeText | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    minHeight: 'D'
                },
                GenerateBtn: {
                    extends: 'Button',
                    text: (el, s)=>s.root.generatingDoc ? '{{ docsGenerating | polyglot }}' : '{{ docsGenerate | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    border: 'none',
                    padding: 'Z A',
                    fontSize: 'A',
                    fontWeight: '700',
                    borderRadius: 'Z',
                    width: '100%',
                    textAlign: 'center',
                    cursor: 'pointer',
                    opacity: (el, s)=>s.root.generatingDoc ? '.6' : '1',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.root.update({
                            generatingDoc: true
                        });
                        setTimeout(()=>{
                            s.root.update({
                                generatingDoc: false,
                                docOutput: '{{ docsGeneratedClaimText | polyglot }}'
                            });
                        }, 2000);
                    }
                }
            },
            DocOutput: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                padding: 'A',
                background: 'surfaceMid',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                minHeight: 'G',
                '@tabletS': {
                    maxWidth: '100%',
                    width: '100%'
                },
                OutputTitle: {
                    tag: 'h2',
                    text: '{{ docsGeneratedDocument | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                LoadingState: {
                    flow: 'y',
                    align: 'center center',
                    flex: '1',
                    show: (el, s)=>s.root.generatingDoc,
                    Spinner: {
                        text: "\u27F3",
                        fontSize: 'D',
                        color: 'green'
                    },
                    LoadingText: {
                        text: '{{ docsGenerating | polyglot }}',
                        fontSize: 'A',
                        color: 'textSoft'
                    }
                },
                EmptyState: {
                    flow: 'y',
                    align: 'center center',
                    flex: '1',
                    gap: 'A',
                    show: (el, s)=>!s.root.generatingDoc && !s.root.docOutput,
                    EmptyIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        color: 'surfaceBorderStrong',
                        width: 'C',
                        height: 'C'
                    },
                    EmptyText: {
                        text: '{{ docsEmptyState | polyglot }}',
                        fontSize: 'A',
                        color: 'textMuted',
                        textAlign: 'center'
                    },
                    DemoBtn: {
                        extends: 'Button',
                        text: '{{ docsShowDemo | polyglot }}',
                        background: 'transparent',
                        color: 'green',
                        border: '1px solid greenBorder',
                        padding: 'Z A',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.root.update({
                                docOutput: '{{ docsDemoClaimText | polyglot }}'
                            })
                    }
                },
                OutputContent: {
                    if: (el, s)=>s.root.docOutput,
                    flow: 'y',
                    gap: 'A',
                    flex: '1',
                    DocText: {
                        text: (el, s)=>s.root.docOutput || '',
                        fontSize: 'A',
                        color: 'textSoft',
                        lineHeight: '1.8',
                        whiteSpace: 'pre-wrap',
                        padding: 'A',
                        background: 'surfaceCard',
                        borderRadius: 'Z'
                    },
                    OutputActions: {
                        flow: 'x',
                        gap: 'Z',
                        CopyBtn: {
                            extends: 'Button',
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            background: 'transparent',
                            color: 'neutral300',
                            border: '1px solid neutral700',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            BtnIcon: {
                                extends: 'Icon',
                                icon: 'copy',
                                width: 'Z',
                                height: 'Z'
                            },
                            BtnText: {
                                text: '{{ docsCopy | polyglot }}'
                            }
                        },
                        DownloadBtn: {
                            extends: 'Button',
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            background: 'transparent',
                            color: 'neutral300',
                            border: '1px solid neutral700',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            BtnIcon: {
                                extends: 'Icon',
                                icon: 'download',
                                width: 'Z',
                                height: 'Z'
                            },
                            BtnText: {
                                text: '{{ docsDownload | polyglot }}'
                            }
                        },
                        SendBtn: {
                            extends: 'Button',
                            flow: 'x',
                            gap: 'Z',
                            align: 'center',
                            background: 'green',
                            color: 'neutral950',
                            border: 'none',
                            fontWeight: '600',
                            padding: 'Z A',
                            fontSize: 'Z',
                            borderRadius: 'Z',
                            cursor: 'pointer',
                            BtnIcon: {
                                extends: 'Icon',
                                icon: 'mail',
                                width: 'Z',
                                height: 'Z'
                            },
                            BtnText: {
                                text: '{{ docsSend | polyglot }}'
                            }
                        }
                    }
                }
            }
        },
        // ═══════════════════════════════════════════════
        // TAB 2 — Existing documents
        // ═══════════════════════════════════════════════
        ExistingView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.docTab === 'existing',
            ExistingHeader: {
                flow: 'x',
                align: 'center space-between',
                ExistingTitle: {
                    tag: 'h2',
                    text: '{{ docsCreatedDocuments | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                SearchDocs: {
                    tag: 'input',
                    type: 'text',
                    name: 'searchDocs',
                    placeholder: '{{ docsSearch | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'Z',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    width: 'F'
                }
            },
            DocRow1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                DocLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocFileIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'A',
                        height: 'A',
                        color: 'red'
                    },
                    DocInfo: {
                        flow: 'y',
                        gap: 'Y',
                        DocName: {
                            text: '{{ docsRow1Name | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '500',
                            color: 'text'
                        },
                        DocMeta: {
                            text: '{{ docsRow1Meta | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                DocActions: {
                    flow: 'x',
                    gap: 'Z',
                    DlBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'download',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsDownload | polyglot }}'
                        }
                    },
                    ShareBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'mail',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsSend | polyglot }}'
                        }
                    }
                }
            },
            DocRow2: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                DocLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocFileIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'A',
                        height: 'A',
                        color: 'blue'
                    },
                    DocInfo: {
                        flow: 'y',
                        gap: 'Y',
                        DocName: {
                            text: '{{ docsRow2Name | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '500',
                            color: 'text'
                        },
                        DocMeta: {
                            text: '{{ docsRow2Meta | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                DocActions: {
                    flow: 'x',
                    gap: 'Z',
                    DlBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'download',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsDownload | polyglot }}'
                        }
                    },
                    ShareBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'mail',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsSend | polyglot }}'
                        }
                    }
                }
            },
            DocRow3: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                DocLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocFileIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'A',
                        height: 'A',
                        color: 'purple'
                    },
                    DocInfo: {
                        flow: 'y',
                        gap: 'Y',
                        DocName: {
                            text: '{{ docsRow3Name | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '500',
                            color: 'text'
                        },
                        DocMeta: {
                            text: '{{ docsRow3Meta | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                DocActions: {
                    flow: 'x',
                    gap: 'Z',
                    DlBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'download',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsDownload | polyglot }}'
                        }
                    },
                    ShareBtn: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        background: 'transparent',
                        color: 'neutral300',
                        border: '1px solid neutral700',
                        padding: 'Y Z',
                        fontSize: 'Z',
                        borderRadius: 'Z',
                        cursor: 'pointer',
                        BtnIcon: {
                            extends: 'Icon',
                            icon: 'mail',
                            width: 'Z',
                            height: 'Z'
                        },
                        BtnText: {
                            text: '{{ docsSend | polyglot }}'
                        }
                    }
                }
            }
        },
        // ═══════════════════════════════════════════════
        // TAB 3 — Files (folder structure)
        // ═══════════════════════════════════════════════
        FilesView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.docTab === 'files',
            FilesHeader: {
                flow: 'x',
                align: 'center space-between',
                FilesTitle: {
                    tag: 'h2',
                    text: '{{ docsFileManager | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                UploadBtn: {
                    extends: 'Button',
                    text: '+ {{ docsUpload | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    border: 'none',
                    fontWeight: '600',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            },
            // Path breadcrumb
            PathBreadcrumb: {
                flow: 'x',
                gap: 'Y',
                align: 'center',
                padding: 'Z 0',
                PathRoot: {
                    text: '{{ docsFiles | polyglot }}',
                    fontSize: 'Z',
                    color: 'green',
                    cursor: 'pointer',
                    fontWeight: '500'
                },
                PathSep1: {
                    text: '/',
                    fontSize: 'Z',
                    color: 'textMuted'
                },
                PathCurrent: {
                    text: '{{ docsCases | polyglot }}',
                    fontSize: 'Z',
                    color: 'textSoft'
                }
            },
            // Folder grid
            FoldersRow: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                Folder1: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    minWidth: 'E',
                    FolderIcon: {
                        text: "\uD83D\uDCC1",
                        fontSize: 'A'
                    },
                    FolderInfo: {
                        flow: 'y',
                        FolderName: {
                            text: '{{ docsFolder1Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FolderCount: {
                            text: '{{ docsFolder1Count | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                Folder2: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    minWidth: 'E',
                    FolderIcon: {
                        text: "\uD83D\uDCC1",
                        fontSize: 'A'
                    },
                    FolderInfo: {
                        flow: 'y',
                        FolderName: {
                            text: '{{ docsFolder2Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FolderCount: {
                            text: '{{ docsFolder2Count | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                Folder3: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    minWidth: 'E',
                    FolderIcon: {
                        text: "\uD83D\uDCC1",
                        fontSize: 'A'
                    },
                    FolderInfo: {
                        flow: 'y',
                        FolderName: {
                            text: '{{ docsFolder3Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FolderCount: {
                            text: '{{ docsFolder3Count | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FolderTemplates: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    minWidth: 'E',
                    FolderIcon: {
                        text: "\uD83D\uDCC1",
                        fontSize: 'A'
                    },
                    FolderInfo: {
                        flow: 'y',
                        FolderName: {
                            text: '{{ docsTemplates | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FolderCount: {
                            text: '{{ docsFolder4Count | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                }
            },
            // Files list
            FilesSectionTitle: {
                text: '{{ docsRecentFiles | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'text',
                padding: 'Z 0 0 0'
            },
            FileRow1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                FileLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileIcon: {
                        text: "\uD83D\uDCC4",
                        fontSize: 'A'
                    },
                    FileInfo: {
                        flow: 'y',
                        FileName: {
                            text: '{{ docsFile1Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FileMeta: {
                            text: '{{ docsFile1Meta | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FileRight: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileDlBtn: {
                        extends: 'Icon',
                        icon: 'download',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted',
                        cursor: 'pointer'
                    }
                }
            },
            FileRow2: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                FileLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileIcon: {
                        text: "\uD83D\uDCC4",
                        fontSize: 'A'
                    },
                    FileInfo: {
                        flow: 'y',
                        FileName: {
                            text: '{{ docsFile2Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FileMeta: {
                            text: '{{ docsFile2Meta | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FileRight: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileDlBtn: {
                        extends: 'Icon',
                        icon: 'download',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted',
                        cursor: 'pointer'
                    }
                }
            },
            FileRow3: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                FileLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileIcon: {
                        text: "\uD83D\uDCCB",
                        fontSize: 'A'
                    },
                    FileInfo: {
                        flow: 'y',
                        FileName: {
                            text: '{{ docsFile3Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FileMeta: {
                            text: '{{ docsFile3Meta | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FileRight: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileDlBtn: {
                        extends: 'Icon',
                        icon: 'download',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted',
                        cursor: 'pointer'
                    }
                }
            },
            FileRow4: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                FileLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileIcon: {
                        text: "\uD83D\uDDBC",
                        fontSize: 'A'
                    },
                    FileInfo: {
                        flow: 'y',
                        FileName: {
                            text: '{{ docsFile4Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FileMeta: {
                            text: '{{ docsFile4Meta | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FileRight: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileDlBtn: {
                        extends: 'Icon',
                        icon: 'download',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted',
                        cursor: 'pointer'
                    }
                }
            },
            FileRow5: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                FileLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileIcon: {
                        text: "\uD83D\uDCC4",
                        fontSize: 'A'
                    },
                    FileInfo: {
                        flow: 'y',
                        FileName: {
                            text: '{{ docsFile5Name | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'text'
                        },
                        FileMeta: {
                            text: '{{ docsFile5Meta | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                },
                FileRight: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    FileDlBtn: {
                        extends: 'Icon',
                        icon: 'download',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted',
                        cursor: 'pointer'
                    }
                }
            }
        }
    }
};


const $942c0fe183543074$export$d87cfcc979a5825c = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ billingTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flexWrap: 'wrap'
                },
                NewInvoiceBtn: {
                    extends: 'Button',
                    text: '+ {{ billingNewInvoice | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'A',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                },
                ThemeToggle: {}
            }
        },
        StatsRow: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            Stat1: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE3,640"
                },
                StatLabel: {
                    text: '{{ billingTotalSent | polyglot }}'
                }
            },
            Stat2: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE640",
                    color: 'green'
                },
                StatLabel: {
                    text: '{{ billingPaid | polyglot }}'
                }
            },
            Stat3: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE1,200",
                    color: 'amber'
                },
                StatLabel: {
                    text: '{{ billingUnpaid | polyglot }}'
                }
            },
            Stat4: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE1,800",
                    color: 'red'
                },
                StatLabel: {
                    text: '{{ billingOverdue | polyglot }}'
                }
            }
        },
        // Integration banner
        RsBanner: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            padding: 'Z A',
            background: 'greenBg',
            border: '1px solid greenBorder',
            borderRadius: 'Z',
            cursor: 'pointer',
            transition: 'opacity 150ms',
            ':hover': {
                opacity: '.85'
            },
            onClick: (e, el, s)=>s.root.update({
                    rsDemo: !s.root.rsDemo
                }),
            BannerDot: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                background: 'green',
                flexShrink: '0'
            },
            BannerText: {
                text: '{{ billingRsBanner | polyglot }}',
                fontSize: 'Y',
                color: 'green',
                flex: '1',
                lineHeight: '1.4'
            },
            BannerStatus: {
                tag: 'span',
                text: '{{ billingActive | polyglot }}',
                padding: 'Y Z',
                background: 'greenBg',
                border: '1px solid greenBorder',
                borderRadius: 'Z',
                fontSize: 'Y',
                color: 'green',
                fontWeight: '600'
            },
            BannerAction: {
                text: "\u2192",
                fontSize: 'Z',
                color: 'green',
                fontWeight: '600'
            }
        },
        // rs.ge demo
        RsDemoPanel: {
            flow: 'y',
            gap: 'A',
            padding: 'A',
            background: 'surfaceMid',
            border: '1px solid surfaceBorderStrong',
            borderRadius: 'Z',
            if: (el, s)=>s.root.rsDemo,
            DemoHeader: {
                flow: 'x',
                align: 'center space-between',
                DemoTitle: {
                    tag: 'h3',
                    text: "\uD83D\uDCB0 {{ billingRsTaxSystem | polyglot }}",
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'green'
                },
                CloseBtn: {
                    text: "\u2715",
                    color: 'textMuted',
                    cursor: 'pointer',
                    fontSize: 'A',
                    onClick: (e, el, s)=>s.root.update({
                            rsDemo: false
                        })
                }
            },
            DemoCards: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                childExtends: {
                    cursor: 'pointer',
                    transition: 'transform 150ms, border-color 150ms',
                    ':hover': {
                        borderColor: 'green',
                        transform: 'translateY(-2px)'
                    }
                },
                Card1: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ billingClientStatus | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: '{{ billingClientName | polyglot }}',
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardItem2: {
                        text: "\u2713 {{ billingNoDebt | polyglot }}",
                        fontSize: 'Y',
                        color: 'green'
                    },
                    CardItem3: {
                        text: '{{ billingLastCheck | polyglot }}',
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ billingViewFull | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                },
                Card2: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ billingEInvoice | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: "\uD83D\uDCC4 INV-2024-031 \u2014 {{ billingStatusSent | polyglot }}",
                        fontSize: 'Y',
                        color: 'green'
                    },
                    CardItem2: {
                        text: "\uD83D\uDCC4 INV-2024-030 \u2014 {{ billingStatusPaid | polyglot }}",
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ billingViewInvoices | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                },
                Card3: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: 'D',
                    CardTitle: {
                        text: '{{ billingAutoCheck | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'text'
                    },
                    CardItem1: {
                        text: "\uD83D\uDD14 {{ billingWeeklyEnabled | polyglot }}",
                        fontSize: 'Y',
                        color: 'green'
                    },
                    CardItem2: {
                        text: "\uD83D\uDCE7 {{ billingEmailNotification | polyglot }}",
                        fontSize: 'Y',
                        color: 'textSoft'
                    },
                    CardLink: {
                        text: '{{ billingSettings | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600',
                        marginTop: 'Y'
                    }
                }
            }
        },
        InvoiceList: {
            flow: 'y',
            gap: 'Z',
            InvHeader: {
                flow: 'x',
                padding: 'Z A',
                gap: 'A',
                borderBottom: '1px solid surfaceBorderStrong',
                '@mobileL': {
                    display: 'none'
                },
                ColNum: {
                    flex: '1',
                    text: '{{ billingInvoice | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                ColClient: {
                    flex: '2',
                    text: '{{ billingClient | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                ColCase: {
                    flex: '1',
                    text: '{{ billingCase | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                ColAmount: {
                    flex: '1',
                    text: '{{ billingAmount | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                ColDue: {
                    flex: '1',
                    text: '{{ billingDue | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                ColStatus: {
                    flex: '1',
                    text: '{{ billingStatus | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                }
            },
            InvRow1: {
                flow: 'x',
                padding: 'A',
                gap: 'A',
                align: 'center',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                cursor: 'pointer',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Y'
                },
                Col1: {
                    flex: '1',
                    text: 'INV-2024-031',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'text'
                },
                Col2: {
                    flex: '2',
                    text: '{{ billingClient1 | polyglot }}',
                    fontSize: 'Z',
                    color: 'text'
                },
                Col3: {
                    flex: '1',
                    text: '#2024-047',
                    fontSize: 'Z',
                    color: 'textMuted'
                },
                Col4: {
                    flex: '1',
                    text: "\u20BE1,200",
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'text'
                },
                Col5: {
                    flex: '1',
                    text: '{{ billingDue1 | polyglot }}',
                    fontSize: 'Z',
                    color: 'amber'
                },
                Col6: {
                    flex: '1',
                    InvChip: {
                        extends: 'StatusPending',
                        text: '{{ billingUnpaid | polyglot }}'
                    }
                }
            },
            InvRow2: {
                flow: 'x',
                padding: 'A',
                gap: 'A',
                align: 'center',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                cursor: 'pointer',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Y'
                },
                Col1: {
                    flex: '1',
                    text: 'INV-2024-030',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'text'
                },
                Col2: {
                    flex: '2',
                    text: '{{ billingClient2 | polyglot }}',
                    fontSize: 'Z',
                    color: 'text'
                },
                Col3: {
                    flex: '1',
                    text: '#2024-046',
                    fontSize: 'Z',
                    color: 'textMuted'
                },
                Col4: {
                    flex: '1',
                    text: "\u20BE640",
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'text'
                },
                Col5: {
                    flex: '1',
                    text: '{{ billingDue2 | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted'
                },
                Col6: {
                    flex: '1',
                    InvChip: {
                        extends: 'StatusConfirmed',
                        text: '{{ billingPaid | polyglot }}'
                    }
                }
            },
            InvRow3: {
                flow: 'x',
                padding: 'A',
                gap: 'A',
                align: 'center',
                background: 'surfaceCard',
                border: '1px solid redBorder',
                borderRadius: 'Z',
                cursor: 'pointer',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Y'
                },
                Col1: {
                    flex: '1',
                    text: 'INV-2024-029',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'text'
                },
                Col2: {
                    flex: '2',
                    text: '{{ billingClient3 | polyglot }}',
                    fontSize: 'Z',
                    color: 'text'
                },
                Col3: {
                    flex: '1',
                    text: '#2024-045',
                    fontSize: 'Z',
                    color: 'textMuted'
                },
                Col4: {
                    flex: '1',
                    text: "\u20BE1,800",
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'red'
                },
                Col5: {
                    flex: '1',
                    text: '{{ billingDue3 | polyglot }}',
                    fontSize: 'Z',
                    color: 'red',
                    fontWeight: '600'
                },
                Col6: {
                    flex: '1',
                    InvChip: {
                        tag: 'span',
                        text: '{{ billingOverdue | polyglot }}',
                        padding: 'Y Z',
                        borderRadius: 'Z',
                        fontSize: 'Y',
                        fontWeight: '600',
                        background: 'redBg',
                        color: 'red',
                        border: '1px solid redBorder'
                    }
                }
            }
        }
    }
};


const $4f74f4715283edb5$export$f3fdf23dea88dbed = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            flow: 'x',
            align: 'center space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ aiTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            HeaderRight: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    flexWrap: 'wrap'
                },
                GeminiBadge: {
                    tag: 'span',
                    text: '{{ aiPowered | polyglot }}',
                    fontSize: 'Z',
                    color: 'green',
                    fontWeight: '500',
                    padding: 'Y Z',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z'
                },
                ThemeToggle: {}
            }
        },
        // Tabs
        TabsRow: {
            flow: 'x',
            gap: 'Z',
            borderBottom: '1px solid surfaceBorderStrong',
            padding: '0 0 Z 0',
            '@mobileL': {
                flexWrap: 'wrap'
            },
            TabDraft: {
                extends: 'Button',
                text: '{{ aiDraftDocs | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.aiTab === 'draft' ? 'green' : 'transparent',
                color: (el, s)=>s.root.aiTab === 'draft' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.aiTab === 'draft' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        aiTab: 'draft'
                    })
            },
            TabAnalysis: {
                extends: 'Button',
                text: '{{ aiContractAnalysis | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.aiTab === 'analysis' ? 'green' : 'transparent',
                color: (el, s)=>s.root.aiTab === 'analysis' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.aiTab === 'analysis' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        aiTab: 'analysis'
                    })
            },
            TabResearch: {
                extends: 'Button',
                text: '{{ aiLegalResearch | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.aiTab === 'research' ? 'green' : 'transparent',
                color: (el, s)=>s.root.aiTab === 'research' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.aiTab === 'research' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        aiTab: 'research'
                    })
            }
        },
        // Tab 1 — Document drafting (link to /documents)
        DraftView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.aiTab === 'draft',
            DraftInfo: {
                text: '{{ aiDraftAvailable | polyglot }}',
                fontSize: 'A',
                color: 'textSoft'
            },
            GoToDocsLink: {
                extends: 'Link',
                href: '/documents',
                text: '{{ aiGoToDocuments | polyglot }}',
                fontSize: 'A',
                color: 'green',
                textDecoration: 'none'
            }
        },
        // Tab 2 — Contract analysis
        AnalysisView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.aiTab === 'analysis',
            AnalysisInput: {
                tag: 'textarea',
                name: 'contract',
                placeholder: '{{ aiPasteContract | polyglot }}',
                padding: 'A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text',
                minHeight: 'E',
                lineHeight: '1.6'
            },
            AnalyzeBtn: {
                extends: 'Button',
                text: (el, s)=>s.root.analysisOutput ? '{{ aiReanalyze | polyglot }}' : '{{ aiAnalyze | polyglot }}',
                theme: 'primary',
                padding: 'Z B',
                fontSize: 'A',
                borderRadius: 'Z',
                cursor: 'pointer',
                onClick: (e, el, s)=>s.root.update({
                        analysisOutput: {
                            parties: '{{ aiPartiesData | polyglot }}',
                            obligations: '{{ aiObligationsData | polyglot }}',
                            risks: '{{ aiRisksData | polyglot }}',
                            deadlines: '{{ aiDeadlinesData | polyglot }}',
                            recommendations: '{{ aiRecommendationsData | polyglot }}'
                        }
                    })
            },
            AnalysisResult: {
                flow: 'y',
                gap: 'A',
                if: (el, s)=>s.root.analysisOutput,
                PartiesCard: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorder',
                    borderRadius: 'Z',
                    CardLabel: {
                        text: '{{ aiParties | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'textMuted'
                    },
                    CardContent: {
                        text: (el, s)=>s.root.analysisOutput ? s.root.analysisOutput.parties : '',
                        fontSize: 'A',
                        color: 'text',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.6'
                    }
                },
                ObligationsCard: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorder',
                    borderRadius: 'Z',
                    CardLabel: {
                        text: '{{ aiObligations | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'textMuted'
                    },
                    CardContent: {
                        text: (el, s)=>s.root.analysisOutput ? s.root.analysisOutput.obligations : '',
                        fontSize: 'A',
                        color: 'text',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.6'
                    }
                },
                RisksCard: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    background: 'redBg',
                    border: '1px solid redBorder',
                    borderRadius: 'Z',
                    CardLabel: {
                        text: '{{ aiRiskFactors | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'red'
                    },
                    CardContent: {
                        text: (el, s)=>s.root.analysisOutput ? s.root.analysisOutput.risks : '',
                        fontSize: 'A',
                        color: 'text',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.6'
                    }
                },
                DeadlinesCard: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorder',
                    borderRadius: 'Z',
                    CardLabel: {
                        text: '{{ aiDeadlines | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'textMuted'
                    },
                    CardContent: {
                        text: (el, s)=>s.root.analysisOutput ? s.root.analysisOutput.deadlines : '',
                        fontSize: 'A',
                        color: 'text',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.6'
                    }
                },
                RecommendationsCard: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    background: 'greenBg',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    CardLabel: {
                        text: '{{ aiRecommendations | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'green'
                    },
                    CardContent: {
                        text: (el, s)=>s.root.analysisOutput ? s.root.analysisOutput.recommendations : '',
                        fontSize: 'A',
                        color: 'text',
                        whiteSpace: 'pre-wrap',
                        lineHeight: '1.6'
                    }
                }
            }
        },
        // Tab 3 — Legal research
        ResearchView: {
            flow: 'y',
            gap: 'A',
            flex: '1',
            show: (el, s)=>s.root.aiTab === 'research',
            ResearchTitle: {
                text: '{{ aiAskQuestion | polyglot }}',
                fontSize: 'A',
                color: 'textSoft'
            },
            ExampleChips: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                Chip1: {
                    extends: 'Button',
                    text: '{{ aiChip1 | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            researchInput: '{{ aiChip1Question | polyglot }}'
                        })
                },
                Chip2: {
                    extends: 'Button',
                    text: '{{ aiChip2 | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            researchInput: '{{ aiChip2Question | polyglot }}'
                        })
                },
                Chip3: {
                    extends: 'Button',
                    text: '{{ aiChip3 | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            researchInput: '{{ aiChip3Question | polyglot }}'
                        })
                }
            },
            ChatArea: {
                flow: 'y',
                gap: 'Z',
                flex: '1',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                minHeight: 'F',
                EmptyChat: {
                    flow: 'y',
                    align: 'center center',
                    flex: '1',
                    gap: 'Z',
                    show: (el, s)=>!s.root.researchMessages || s.root.researchMessages.length === 0,
                    EmptyChatIcon: {
                        extends: 'Icon',
                        icon: 'ai',
                        color: 'textMuted',
                        width: 'C',
                        height: 'C'
                    },
                    EmptyChatText: {
                        text: '{{ aiLegalResearchTitle | polyglot }}',
                        fontSize: 'A',
                        color: 'textMuted'
                    },
                    EmptyChatSub: {
                        text: '{{ aiEmptyChatSub | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted'
                    }
                }
            },
            InputRow: {
                flow: 'x',
                gap: 'Z',
                ResearchInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'research',
                    placeholder: '{{ aiAskPlaceholder | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1',
                    value: (el, s)=>s.root.researchInput || '',
                    onInput: (e, el, s)=>s.root.update({
                            researchInput: e.target.value
                        })
                },
                SendBtn: {
                    extends: 'Button',
                    text: '{{ aiSend | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'A',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            }
        }
    }
};


const $e3c2d50ee9db0663$export$34ad2f35a149a126 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'surface',
    Sidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        padding: 'B C',
        gap: 'B',
        overflow: 'auto',
        '@tabletS': {
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'A'
        },
        PageHeader: {
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HeaderTitle: {
                tag: 'h1',
                text: '{{ settingsTitle | polyglot }}',
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            ThemeToggle: {}
        },
        TabsRow: {
            flow: 'x',
            gap: 'Z',
            borderBottom: '1px solid surfaceBorderStrong',
            padding: '0 0 Z 0',
            '@mobileL': {
                flexWrap: 'wrap'
            },
            TabProfile: {
                extends: 'Button',
                text: '{{ settingsTabProfile | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.settingsTab === 'profile' ? 'green' : 'transparent',
                color: (el, s)=>s.root.settingsTab === 'profile' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.settingsTab === 'profile' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        settingsTab: 'profile'
                    })
            },
            TabFirm: {
                extends: 'Button',
                text: '{{ settingsTabFirm | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.settingsTab === 'firm' ? 'green' : 'transparent',
                color: (el, s)=>s.root.settingsTab === 'firm' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.settingsTab === 'firm' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        settingsTab: 'firm'
                    })
            },
            TabTeam: {
                extends: 'Button',
                text: '{{ settingsTabTeam | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.settingsTab === 'team' ? 'green' : 'transparent',
                color: (el, s)=>s.root.settingsTab === 'team' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.settingsTab === 'team' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        settingsTab: 'team'
                    })
            },
            TabNotify: {
                extends: 'Button',
                text: '{{ settingsTabNotifications | polyglot }}',
                padding: 'Z A',
                fontSize: 'Z',
                cursor: 'pointer',
                borderRadius: 'Z',
                background: (el, s)=>s.root.settingsTab === 'notifications' ? 'green' : 'transparent',
                color: (el, s)=>s.root.settingsTab === 'notifications' ? 'black' : 'textSoft',
                fontWeight: (el, s)=>s.root.settingsTab === 'notifications' ? '600' : '400',
                onClick: (e, el, s)=>s.root.update({
                        settingsTab: 'notifications'
                    })
            }
        },
        // Profile
        ProfileView: {
            flow: 'y',
            gap: 'A',
            maxWidth: 'H',
            show: (el, s)=>s.root.settingsTab === 'profile',
            AvatarRow: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                AvatarPlaceholder: {
                    width: 'D',
                    height: 'D',
                    borderRadius: '100%',
                    background: 'greenBg',
                    color: 'green',
                    flow: 'x',
                    align: 'center center',
                    fontSize: 'B',
                    fontWeight: '700',
                    text: (el, s)=>s.root.firm.initials
                },
                UploadBtn: {
                    extends: 'Button',
                    text: '{{ settingsUploadPhoto | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            },
            NameInput: {
                tag: 'input',
                type: 'text',
                name: 'name',
                value: '{{ settingsProfileName | polyglot }}',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            EmailInput: {
                tag: 'input',
                type: 'email',
                name: 'email',
                value: 'nino@barateli.ge',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            PhoneInput: {
                tag: 'input',
                type: 'tel',
                name: 'phone',
                value: '599111222',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            SaveBtn: {
                extends: 'Button',
                text: '{{ settingsSave | polyglot }}',
                theme: 'primary',
                padding: 'Z B',
                fontSize: 'A',
                borderRadius: 'Z',
                cursor: 'pointer'
            }
        },
        // Firm
        FirmView: {
            flow: 'y',
            gap: 'A',
            maxWidth: 'H',
            show: (el, s)=>s.root.settingsTab === 'firm',
            FirmNameInput: {
                tag: 'input',
                type: 'text',
                name: 'firmName',
                value: '{{ settingsFirmName | polyglot }}',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            FirmAddressInput: {
                tag: 'input',
                type: 'text',
                name: 'address',
                placeholder: '{{ settingsFirmAddress | polyglot }}',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            FirmRegInput: {
                tag: 'input',
                type: 'text',
                name: 'regNum',
                placeholder: '{{ settingsFirmRegNumber | polyglot }}',
                padding: 'Z A',
                fontSize: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                color: 'text'
            },
            PublicUrlRow: {
                flow: 'y',
                gap: 'Y',
                UrlLabel: {
                    text: '{{ settingsPublicBookingUrl | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'textMuted'
                },
                UrlValue: {
                    text: (el, s)=>s.root.firm.publicBookingUrl,
                    fontSize: 'A',
                    color: 'green',
                    fontWeight: '500'
                }
            },
            SaveFirmBtn: {
                extends: 'Button',
                text: '{{ settingsSave | polyglot }}',
                theme: 'primary',
                padding: 'Z B',
                fontSize: 'A',
                borderRadius: 'Z',
                cursor: 'pointer'
            }
        },
        // Team
        TeamView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.settingsTab === 'team',
            TeamHeader: {
                flow: 'x',
                align: 'center space-between',
                TeamTitle: {
                    text: '{{ settingsTeamMembers | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                },
                InviteBtn: {
                    extends: 'Button',
                    text: '{{ settingsInvite | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            },
            Member1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                MemberInfo: {
                    flow: 'y',
                    gap: 'Y',
                    MemberName: {
                        text: '{{ settingsMember1Name | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    },
                    MemberEmail: {
                        text: 'nino@barateli.ge',
                        fontSize: 'Z',
                        color: 'textMuted'
                    }
                },
                MemberRole: {
                    tag: 'span',
                    text: '{{ settingsRoleOwner | polyglot }}',
                    padding: 'Y Z',
                    background: 'greenBg',
                    color: 'green',
                    border: '1px solid greenBorder',
                    borderRadius: 'Z',
                    fontSize: 'Z',
                    fontWeight: '600'
                }
            },
            Member2: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                MemberInfo: {
                    flow: 'y',
                    gap: 'Y',
                    MemberName: {
                        text: '{{ settingsMember2Name | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    },
                    MemberEmail: {
                        text: 'giga@barateli.ge',
                        fontSize: 'Z',
                        color: 'textMuted'
                    }
                },
                MemberRole: {
                    tag: 'span',
                    text: '{{ settingsRoleLawyer | polyglot }}',
                    padding: 'Y Z',
                    background: 'blueBg',
                    color: 'blue',
                    border: '1px solid blueBorder',
                    borderRadius: 'Z',
                    fontSize: 'Z',
                    fontWeight: '600'
                }
            }
        },
        // Notifications
        NotifyView: {
            flow: 'y',
            gap: 'A',
            maxWidth: 'H',
            show: (el, s)=>s.root.settingsTab === 'notifications',
            NotifyTitle: {
                text: '{{ settingsNotifyTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            Toggle1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                ToggleLabel: {
                    text: '{{ settingsNotifyNewBookingEmail | polyglot }}',
                    fontSize: 'A',
                    color: 'text'
                },
                ToggleVal: {
                    text: '{{ settingsToggleOn | polyglot }}',
                    fontSize: 'Z',
                    color: 'green',
                    fontWeight: '600'
                }
            },
            Toggle2: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                ToggleLabel: {
                    text: '{{ settingsNotifyNewBookingWhatsapp | polyglot }}',
                    fontSize: 'A',
                    color: 'text'
                },
                ToggleVal: {
                    text: '{{ settingsToggleOn | polyglot }}',
                    fontSize: 'Z',
                    color: 'green',
                    fontWeight: '600'
                }
            },
            Toggle3: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                ToggleLabel: {
                    text: '{{ settingsNotifyReminder24h | polyglot }}',
                    fontSize: 'A',
                    color: 'text'
                },
                ToggleVal: {
                    text: '{{ settingsToggleOn | polyglot }}',
                    fontSize: 'Z',
                    color: 'green',
                    fontWeight: '600'
                }
            },
            Toggle4: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                ToggleLabel: {
                    text: '{{ settingsNotifyOverdueInvoice | polyglot }}',
                    fontSize: 'A',
                    color: 'text'
                },
                ToggleVal: {
                    text: '{{ settingsToggleOff | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted'
                }
            },
            Toggle5: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                ToggleLabel: {
                    text: '{{ settingsNotifyDeadlineReminder | polyglot }}',
                    fontSize: 'A',
                    color: 'text'
                },
                ToggleVal: {
                    text: '{{ settingsToggle3DaysBefore | polyglot }}',
                    fontSize: 'Z',
                    color: 'amber',
                    fontWeight: '600'
                }
            }
        }
    }
};


const $67857027dbaf7383$export$d50b3de1148083e9 = {
    extends: 'Page',
    flow: 'y',
    minHeight: '100vh',
    background: 'surface',
    // Top nav — light, minimal
    ClientNav: {
        tag: 'nav',
        flow: 'x',
        align: 'center space-between',
        padding: 'A C',
        borderBottom: '1px solid surfaceBorder',
        background: 'surfaceCard',
        FirmLogo: {
            text: '{{ portalFirmLogo | polyglot }}',
            fontSize: 'A',
            fontWeight: '700',
            color: 'text'
        },
        ClientInfo: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            ClientName: {
                text: (el, s)=>s.root.clientPortal.clientName,
                fontSize: 'Z',
                color: 'textSoft'
            },
            LogoutClientLink: {
                extends: 'Link',
                href: '/',
                text: '{{ portalLogout | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted',
                textDecoration: 'none',
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: false
                    })
            }
        }
    },
    ClientContent: {
        flow: 'y',
        padding: 'C',
        gap: 'B',
        maxWidth: 'I',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'A'
        },
        WelcomeText: {
            tag: 'h1',
            text: (el, s)=>'{{ portalWelcome | polyglot }} ' + s.root.clientPortal.clientName,
            fontSize: 'C',
            fontWeight: '800',
            color: 'text'
        },
        // Active cases
        CasesSection: {
            flow: 'y',
            gap: 'A',
            SectionTitle: {
                tag: 'h2',
                text: '{{ portalActiveCases | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            CaseCard1: {
                flow: 'y',
                gap: 'A',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                CaseTop: {
                    flow: 'x',
                    align: 'center space-between',
                    CaseNumType: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        CaseNum: {
                            text: '#2024-047',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        CaseType: {
                            tag: 'span',
                            text: '{{ portalCaseTypeCivil | polyglot }}',
                            padding: 'Y Z',
                            background: 'blueBg',
                            color: 'blue',
                            border: '1px solid blueBorder',
                            borderRadius: 'Z',
                            fontSize: 'Z'
                        }
                    },
                    CaseStatusChip: {
                        extends: 'StatusActive',
                        text: '{{ portalStatusActive | polyglot }}'
                    }
                },
                ProgressBar: {
                    flow: 'y',
                    gap: 'Y',
                    ProgressLabel: {
                        text: '{{ portalProgressLabel | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted'
                    },
                    ProgressTrack: {
                        width: '100%',
                        height: 'Y',
                        background: 'surfaceBorder',
                        borderRadius: 'Z',
                        ProgressFill: {
                            width: '60%',
                            height: '100%',
                            background: 'green',
                            borderRadius: 'Z'
                        }
                    }
                },
                NextStep: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    StepIcon: {
                        extends: 'Icon',
                        icon: 'arrowRight',
                        width: 'Z',
                        height: 'Z',
                        color: 'green'
                    },
                    StepText: {
                        text: '{{ portalNextHearing | polyglot }}',
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500'
                    }
                },
                UpdateDate: {
                    text: '{{ portalLastUpdate | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted'
                }
            }
        },
        // Pending invoices
        InvoicesSection: {
            flow: 'y',
            gap: 'A',
            SectionTitle: {
                tag: 'h2',
                text: '{{ portalPendingInvoices | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            InvoiceCard: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid amberBorder',
                borderRadius: 'Z',
                InvLeft: {
                    flow: 'y',
                    gap: 'Y',
                    InvNum: {
                        text: 'INV-2024-031',
                        fontSize: 'Z',
                        color: 'textMuted'
                    },
                    InvAmount: {
                        text: "\u20BE1,200",
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    InvDue: {
                        text: '{{ portalInvoiceDue | polyglot }}',
                        fontSize: 'Z',
                        color: 'amber'
                    }
                },
                PayBtn: {
                    extends: 'Button',
                    text: '{{ portalPay | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            }
        },
        // Recent documents
        DocsSection: {
            flow: 'y',
            gap: 'A',
            SectionTitle: {
                tag: 'h2',
                text: '{{ portalDocuments | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            DocRow1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                DocInfo: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'A',
                        height: 'A',
                        color: 'textMuted'
                    },
                    DocName: {
                        text: '{{ portalDocName1 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text'
                    }
                },
                DocDate: {
                    text: '{{ portalDocDate1 | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted'
                }
            }
        },
        // Messages
        MessagesSection: {
            flow: 'y',
            gap: 'A',
            SectionTitle: {
                tag: 'h2',
                text: '{{ portalMessages | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            MessagesList: {
                flow: 'y',
                gap: 'Z',
                padding: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                minHeight: 'E',
                Msg1: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    borderRadius: 'Z',
                    maxWidth: '80%',
                    MsgFrom: {
                        text: '{{ portalMsgFrom1 | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'green'
                    },
                    MsgText: {
                        text: '{{ portalMsgText1 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text',
                        lineHeight: '1.5'
                    },
                    MsgTime: {
                        text: '10:30',
                        fontSize: 'Y',
                        color: 'textMuted'
                    }
                },
                Msg2: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'surfaceBorder',
                    borderRadius: 'Z',
                    maxWidth: '80%',
                    alignSelf: 'flex-end',
                    MsgText: {
                        text: '{{ portalMsgText2 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text',
                        lineHeight: '1.5'
                    },
                    MsgTime: {
                        text: '10:45',
                        fontSize: 'Y',
                        color: 'textMuted',
                        textAlign: 'right'
                    }
                }
            },
            MessageInput: {
                flow: 'x',
                gap: 'Z',
                MsgInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'message',
                    placeholder: '{{ portalMsgPlaceholder | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1'
                },
                SendMsgBtn: {
                    extends: 'Button',
                    text: '{{ portalSend | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            }
        }
    }
};


const $5334812cd89380b3$export$bba55ac008ecfff1 = {
    extends: 'Page',
    flow: 'y',
    minHeight: '100vh',
    background: 'surface',
    // Top nav — light, minimal
    ClientNav: {
        tag: 'nav',
        flow: 'x',
        align: 'center space-between',
        padding: 'A C',
        borderBottom: '1px solid surfaceBorder',
        background: 'surfaceMid',
        position: 'sticky',
        top: '0',
        zIndex: '10',
        '@mobileL': {
            padding: 'A'
        },
        NavLeft: {
            flow: 'x',
            gap: 'B',
            align: 'center',
            FirmLogo: {
                extends: 'Link',
                href: '/client-dashboard',
                text: 'TrustLegal',
                fontSize: 'B',
                fontWeight: '800',
                color: 'green',
                textDecoration: 'none'
            },
            NavLinks: {
                flow: 'x',
                gap: 'A',
                align: 'center',
                '@mobileL': {
                    display: 'none'
                },
                NavCases: {
                    text: '{{ clientDashNavCases | polyglot }}',
                    fontSize: 'Z',
                    color: (el, s)=>s.root.clientDashboardTab === 'cases' ? 'green' : 'textSoft',
                    fontWeight: (el, s)=>s.root.clientDashboardTab === 'cases' ? '600' : '400',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            clientDashboardTab: 'cases'
                        })
                },
                NavInvoices: {
                    text: '{{ clientDashNavInvoices | polyglot }}',
                    fontSize: 'Z',
                    color: (el, s)=>s.root.clientDashboardTab === 'invoices' ? 'green' : 'textSoft',
                    fontWeight: (el, s)=>s.root.clientDashboardTab === 'invoices' ? '600' : '400',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            clientDashboardTab: 'invoices'
                        })
                },
                NavDocs: {
                    text: '{{ clientDashNavDocuments | polyglot }}',
                    fontSize: 'Z',
                    color: (el, s)=>s.root.clientDashboardTab === 'documents' ? 'green' : 'textSoft',
                    fontWeight: (el, s)=>s.root.clientDashboardTab === 'documents' ? '600' : '400',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            clientDashboardTab: 'documents'
                        })
                },
                NavMessages: {
                    text: '{{ clientDashNavMessages | polyglot }}',
                    fontSize: 'Z',
                    color: (el, s)=>s.root.clientDashboardTab === 'messages' ? 'green' : 'textSoft',
                    fontWeight: (el, s)=>s.root.clientDashboardTab === 'messages' ? '600' : '400',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            clientDashboardTab: 'messages'
                        })
                }
            }
        },
        NavRight: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            ThemeToggle: {},
            ClientAvatar: {
                width: 'B',
                height: 'B',
                borderRadius: '100%',
                background: 'greenBg',
                border: '1px solid greenBorder',
                color: 'green',
                flow: 'x',
                align: 'center center',
                fontSize: 'Z',
                fontWeight: '700',
                text: (el, s)=>(s.root.clientPortal.clientName || "\u10D2").charAt(0)
            },
            LogoutClientLink: {
                extends: 'Link',
                href: '/',
                text: '{{ clientDashLogout | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted',
                textDecoration: 'none',
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: false
                    })
            }
        }
    },
    // Main content area
    ClientMain: {
        flow: 'y',
        padding: 'C',
        gap: 'B',
        maxWidth: 'J',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'A'
        },
        // Welcome header
        WelcomeHeader: {
            flow: 'y',
            gap: 'Z',
            WelcomeText: {
                tag: 'h1',
                text: (el, s)=>'{{ clientDashWelcome | polyglot }} ' + s.root.clientPortal.clientName,
                fontSize: 'C',
                fontWeight: '800',
                color: 'text',
                '@mobileL': {
                    fontSize: 'B'
                }
            },
            WelcomeSub: {
                text: '{{ clientDashWelcomeSub | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted',
                lineHeight: '1.6'
            }
        },
        // Stats summary
        ClientStats: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            ClientStat1: {
                extends: 'StatCard',
                StatValue: {
                    text: '1'
                },
                StatLabel: {
                    text: '{{ clientDashStatActiveCase | polyglot }}'
                }
            },
            ClientStat2: {
                extends: 'StatCard',
                StatValue: {
                    text: "\u20BE1,200",
                    color: 'amber'
                },
                StatLabel: {
                    text: '{{ clientDashStatPayable | polyglot }}'
                }
            },
            ClientStat3: {
                extends: 'StatCard',
                StatValue: {
                    text: '2'
                },
                StatLabel: {
                    text: '{{ clientDashStatDocument | polyglot }}'
                }
            },
            ClientStat4: {
                extends: 'StatCard',
                StatValue: {
                    text: '{{ clientDashStatNextHearingValue | polyglot }}'
                },
                StatLabel: {
                    text: '{{ clientDashStatNextHearing | polyglot }}'
                }
            }
        },
        // Tab content — Cases
        CasesView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>!s.root.clientDashboardTab || s.root.clientDashboardTab === 'cases',
            CasesSectionTitle: {
                flow: 'x',
                align: 'center space-between',
                TitleText: {
                    tag: 'h2',
                    text: '{{ clientDashMyCases | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'text'
                }
            },
            ActiveCase: {
                flow: 'y',
                gap: 'A',
                padding: 'B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                CaseHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    '@mobileL': {
                        flow: 'y',
                        gap: 'Z'
                    },
                    CaseNumType: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        CaseNum: {
                            text: '#2024-047',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'text'
                        },
                        CaseType: {
                            tag: 'span',
                            text: '{{ clientDashCaseTypeCivil | polyglot }}',
                            padding: 'Y Z',
                            background: 'blueBg',
                            color: 'blue',
                            border: '1px solid blueBorder',
                            borderRadius: 'Z',
                            fontSize: 'Y'
                        }
                    },
                    CaseStatusChip: {
                        extends: 'StatusActive',
                        text: '{{ clientDashStatusActive | polyglot }}'
                    }
                },
                // Timeline / Progress
                ProgressSection: {
                    flow: 'y',
                    gap: 'Z',
                    ProgressLabel: {
                        text: '{{ clientDashProgressLabel | polyglot }}',
                        fontSize: 'Z',
                        color: 'textSoft'
                    },
                    ProgressTrack: {
                        width: '100%',
                        height: 'Y',
                        background: 'surfaceBorder',
                        borderRadius: 'Z',
                        ProgressFill: {
                            width: '60%',
                            height: '100%',
                            background: 'green',
                            borderRadius: 'Z',
                            transition: 'width 300ms'
                        }
                    }
                },
                // Case timeline steps
                TimelineSteps: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A 0',
                    Step1: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'flex-start',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            borderRadius: '100%',
                            background: 'green',
                            flexShrink: '0',
                            marginTop: 'Y'
                        },
                        StepContent: {
                            flow: 'y',
                            gap: 'Y',
                            StepTitle: {
                                text: '{{ clientDashStep1Title | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'text'
                            },
                            StepDate: {
                                text: '{{ clientDashStep1Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            }
                        }
                    },
                    Step2: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'flex-start',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            borderRadius: '100%',
                            background: 'green',
                            flexShrink: '0',
                            marginTop: 'Y'
                        },
                        StepContent: {
                            flow: 'y',
                            gap: 'Y',
                            StepTitle: {
                                text: '{{ clientDashStep2Title | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'text'
                            },
                            StepDate: {
                                text: '{{ clientDashStep2Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            }
                        }
                    },
                    Step3: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'flex-start',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            borderRadius: '100%',
                            background: 'green',
                            flexShrink: '0',
                            marginTop: 'Y'
                        },
                        StepContent: {
                            flow: 'y',
                            gap: 'Y',
                            StepTitle: {
                                text: '{{ clientDashStep3Title | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'text'
                            },
                            StepDate: {
                                text: '{{ clientDashStep3Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'textMuted'
                            }
                        }
                    },
                    Step4: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'flex-start',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            borderRadius: '100%',
                            background: 'surfaceBorderStrong',
                            flexShrink: '0',
                            marginTop: 'Y'
                        },
                        StepContent: {
                            flow: 'y',
                            gap: 'Y',
                            StepTitle: {
                                text: '{{ clientDashStep4Title | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'textSoft'
                            },
                            StepDate: {
                                text: '{{ clientDashStep4Date | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber'
                            }
                        }
                    },
                    Step5: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'flex-start',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            borderRadius: '100%',
                            background: 'surfaceBorderStrong',
                            flexShrink: '0',
                            marginTop: 'Y'
                        },
                        StepContent: {
                            flow: 'y',
                            gap: 'Y',
                            StepTitle: {
                                text: '{{ clientDashStep5Title | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'textMuted'
                            },
                            StepDate: {
                                text: 'TBD',
                                fontSize: 'Y',
                                color: 'textMuted'
                            }
                        }
                    }
                },
                // Assigned lawyer
                LawyerInfo: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'A',
                    background: 'surfaceBorder',
                    borderRadius: 'Z',
                    LawyerAvatar: {
                        width: 'B',
                        height: 'B',
                        borderRadius: '100%',
                        background: 'greenBg',
                        color: 'green',
                        flow: 'x',
                        align: 'center center',
                        fontSize: 'Z',
                        fontWeight: '700',
                        text: '{{ clientDashLawyerInitials | polyglot }}',
                        flexShrink: '0'
                    },
                    LawyerDetails: {
                        flow: 'y',
                        gap: 'Y',
                        LawyerName: {
                            text: '{{ clientDashLawyerName | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'text'
                        },
                        LawyerRole: {
                            text: '{{ clientDashLawyerRole | polyglot }}',
                            fontSize: 'Y',
                            color: 'textMuted'
                        }
                    }
                }
            }
        },
        // Tab content — Invoices
        InvoicesView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.clientDashboardTab === 'invoices',
            InvoicesSectionTitle: {
                tag: 'h2',
                text: '{{ clientDashInvoicesTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            UnpaidInvoice: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A B',
                background: 'surfaceMid',
                border: '1px solid amberBorder',
                borderRadius: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'A'
                },
                InvLeft: {
                    flow: 'y',
                    gap: 'Y',
                    InvStatusRow: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        InvNum: {
                            text: 'INV-2024-031',
                            fontSize: 'Z',
                            color: 'textMuted'
                        },
                        InvChip: {
                            extends: 'StatusPending',
                            text: '{{ clientDashUnpaid | polyglot }}'
                        }
                    },
                    InvAmount: {
                        text: "\u20BE1,200",
                        fontSize: 'C',
                        fontWeight: '800',
                        color: 'text'
                    },
                    InvMeta: {
                        flow: 'y',
                        gap: 'Y',
                        InvCase: {
                            text: '{{ clientDashInvCase1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        InvDue: {
                            text: '{{ clientDashInvDue1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'amber',
                            fontWeight: '500'
                        }
                    }
                },
                PayBtn: {
                    extends: 'Button',
                    text: '{{ clientDashPay | polyglot }}',
                    theme: 'primary',
                    padding: 'Z B',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            },
            PaidInvoice: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'A'
                },
                InvLeft: {
                    flow: 'y',
                    gap: 'Y',
                    InvStatusRow: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        InvNum: {
                            text: 'INV-2024-030',
                            fontSize: 'Z',
                            color: 'textMuted'
                        },
                        InvChip: {
                            extends: 'StatusConfirmed',
                            text: '{{ clientDashPaid | polyglot }}'
                        }
                    },
                    InvAmount: {
                        text: "\u20BE640",
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'textSoft'
                    },
                    InvMeta: {
                        flow: 'y',
                        gap: 'Y',
                        InvCase: {
                            text: '{{ clientDashInvCase2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textSoft'
                        },
                        InvDue: {
                            text: '{{ clientDashInvPaidDate | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                }
            }
        },
        // Tab content — Documents
        DocumentsView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.clientDashboardTab === 'documents',
            DocsSectionTitle: {
                tag: 'h2',
                text: '{{ clientDashDocumentsTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            DocRow1: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                DocLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'B',
                        height: 'B',
                        color: 'green'
                    },
                    DocInfo: {
                        flow: 'y',
                        gap: 'Y',
                        DocName: {
                            text: '{{ clientDashDocName1 | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        DocMeta: {
                            text: '{{ clientDashDocMeta1 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                DownloadBtn: {
                    extends: 'Button',
                    text: '{{ clientDashDownload | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            },
            DocRow2: {
                flow: 'x',
                align: 'center space-between',
                padding: 'A B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                DocLeft: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    DocIcon: {
                        extends: 'Icon',
                        icon: 'document',
                        width: 'B',
                        height: 'B',
                        color: 'green'
                    },
                    DocInfo: {
                        flow: 'y',
                        gap: 'Y',
                        DocName: {
                            text: '{{ clientDashDocName2 | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: 'text'
                        },
                        DocMeta: {
                            text: '{{ clientDashDocMeta2 | polyglot }}',
                            fontSize: 'Z',
                            color: 'textMuted'
                        }
                    }
                },
                DownloadBtn: {
                    extends: 'Button',
                    text: '{{ clientDashDownload | polyglot }}',
                    theme: 'ghost',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            }
        },
        // Tab content — Messages
        MessagesView: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.clientDashboardTab === 'messages',
            MsgSectionTitle: {
                tag: 'h2',
                text: '{{ clientDashMessagesTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'text'
            },
            ChatArea: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                background: 'surfaceMid',
                border: '1px solid surfaceBorder',
                borderRadius: 'Z',
                minHeight: 'F',
                Msg1: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    borderRadius: 'Z',
                    maxWidth: '80%',
                    MsgFrom: {
                        text: '{{ clientDashMsgFrom1 | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'green'
                    },
                    MsgText: {
                        text: '{{ clientDashMsgText1 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text',
                        lineHeight: '1.6'
                    },
                    MsgTime: {
                        text: '{{ clientDashMsgTime1 | polyglot }}',
                        fontSize: 'Y',
                        color: 'textMuted'
                    }
                },
                Msg2: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'surfaceBorder',
                    borderRadius: 'Z',
                    maxWidth: '80%',
                    alignSelf: 'flex-end',
                    MsgText: {
                        text: '{{ clientDashMsgText2 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text',
                        lineHeight: '1.6'
                    },
                    MsgTime: {
                        text: '{{ clientDashMsgTime2 | polyglot }}',
                        fontSize: 'Y',
                        color: 'textMuted',
                        textAlign: 'right'
                    }
                },
                Msg3: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z A',
                    background: 'greenBg',
                    borderRadius: 'Z',
                    maxWidth: '80%',
                    MsgFrom: {
                        text: '{{ clientDashMsgFrom3 | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'green'
                    },
                    MsgText: {
                        text: '{{ clientDashMsgText3 | polyglot }}',
                        fontSize: 'Z',
                        color: 'text',
                        lineHeight: '1.6'
                    },
                    MsgTime: {
                        text: '{{ clientDashMsgTime3 | polyglot }}',
                        fontSize: 'Y',
                        color: 'textMuted'
                    }
                }
            },
            MessageInput: {
                flow: 'x',
                gap: 'Z',
                MsgInput: {
                    tag: 'input',
                    type: 'text',
                    name: 'message',
                    placeholder: '{{ clientDashMsgPlaceholder | polyglot }}',
                    padding: 'Z A',
                    fontSize: 'A',
                    background: 'surfaceMid',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    color: 'text',
                    flex: '1'
                },
                SendMsgBtn: {
                    extends: 'Button',
                    text: '{{ clientDashSend | polyglot }}',
                    theme: 'primary',
                    padding: 'Z A',
                    fontSize: 'Z',
                    borderRadius: 'Z',
                    cursor: 'pointer'
                }
            }
        }
    }
};


const $386b39b9d06f3a9f$var$slideBase = {
    flow: 'y',
    align: 'center center',
    justifyContent: 'center',
    padding: 'D',
    gap: 'B',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    '@mobileL': {
        padding: 'C A'
    }
};
const $386b39b9d06f3a9f$var$cardBase = {
    flow: 'y',
    align: 'center center',
    padding: 'B',
    background: 'surfaceCard',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    gap: 'Z',
    flex: '1',
    minWidth: '200px'
};
const $386b39b9d06f3a9f$var$painBase = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'A B',
    background: 'redBg',
    border: '1px solid redBorder',
    borderRadius: 'Z',
    textAlign: 'left',
    Dot: {
        width: 'Z',
        height: 'Z',
        borderRadius: '100%',
        background: 'red',
        flexShrink: '0'
    },
    PainText: {
        color: 'text',
        fontSize: 'C',
        textAlign: 'left'
    }
};
const $386b39b9d06f3a9f$var$pillarBase = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    borderRadius: 'Z',
    flex: '1',
    minWidth: '200px',
    transition: 'border-color 200ms',
    PillarTitle: {
        tag: 'h3',
        fontSize: 'D',
        fontWeight: '600'
    },
    childExtends: {
        color: 'textMuted',
        fontSize: 'B',
        lineHeight: '1.7'
    }
};
const $386b39b9d06f3a9f$var$tierBase = {
    flow: 'y',
    align: 'center center',
    gap: 'Z',
    padding: 'B',
    background: 'surfaceCard',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    flex: '1',
    minWidth: '180px',
    textAlign: 'center',
    TierLabel: {
        color: 'textSoft',
        fontSize: 'B',
        fontWeight: '600'
    },
    TierTarget: {
        color: 'textMuted',
        fontSize: 'A'
    },
    TierPrice: {
        tag: 'span',
        fontSize: 'F',
        fontWeight: '700',
        color: 'text'
    },
    TierPer: {
        text: '{{ pitchPerMonth | polyglot }}',
        color: 'textMuted',
        fontSize: 'A'
    }
};
const $386b39b9d06f3a9f$var$whyBase = {
    flow: 'x',
    align: 'center',
    gap: 'B',
    padding: 'B',
    background: 'surfaceCard',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'Z',
    WhyNum: {
        tag: 'span',
        fontSize: 'D',
        fontWeight: '700',
        color: 'green',
        minWidth: 'C',
        fontFamily: 'monospace'
    },
    WhyDesc: {
        color: 'text',
        fontSize: 'C',
        textAlign: 'left'
    }
};
const $386b39b9d06f3a9f$var$slideAnim = (idx)=>({
        opacity: (el, s)=>s.slide === idx ? '1' : '0',
        transform: (el, s)=>{
            if (s.slide === idx) return 'translateX(0) scale(1)';
            if (s.slide > idx) return 'translateX(-60px) scale(0.97)';
            return 'translateX(60px) scale(0.97)';
        },
        pointerEvents: (el, s)=>s.slide === idx ? 'auto' : 'none'
    });
const $386b39b9d06f3a9f$export$6c9e2d66dea2a302 = {
    extends: 'Page',
    background: 'surface',
    overflow: 'hidden',
    position: 'relative',
    flow: 'y',
    height: '100vh',
    state: {
        slide: 0,
        total: 12
    },
    SlideCounter: {
        position: 'absolute',
        top: 'A',
        right: 'B',
        zIndex: '10',
        fontSize: 'Z',
        color: 'textMuted',
        fontFamily: 'monospace',
        text: (el, s)=>s.slide + 1 + ' / ' + s.total
    },
    SlidesWrap: {
        width: '100%',
        flex: '1',
        overflow: 'hidden',
        position: 'relative',
        // Slide 0 — Hero
        Slide0: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(0),
            gap: 'B',
            TagLine: {
                fontSize: 'A',
                color: 'green',
                fontWeight: '600',
                text: '{{ pitchTagline | polyglot }}',
                letterSpacing: '1px',
                textTransform: 'uppercase'
            },
            TitleText: {
                tag: 'h1',
                text: '{{ pitchTitle | polyglot }}',
                fontSize: 'G',
                fontWeight: '700',
                color: 'text',
                lineHeight: '1.1',
                '@mobileL': {
                    fontSize: 'E'
                }
            },
            SubText: {
                text: '{{ pitchSubtitle | polyglot }}',
                fontSize: 'C',
                color: 'textMuted',
                maxWidth: 'H',
                lineHeight: '1.6'
            },
            CtaBtn: {
                extends: 'Button',
                text: '{{ pitchCta | polyglot }}',
                background: 'green',
                color: 'black',
                padding: 'A B',
                fontSize: 'B',
                fontWeight: '600',
                borderRadius: 'Y',
                border: 'none',
                cursor: 'pointer',
                marginTop: 'A',
                onClick: (e, el, s)=>s.update({
                        slide: 1
                    })
            }
        },
        // Slide 1 — Market stats
        Slide1: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(1),
            SlideLabel: {
                text: '{{ pitchMarketLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchMarketTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            StatsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                '@mobileL': {
                    flow: 'y',
                    width: '100%'
                },
                StatCard1: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    StatVal: {
                        tag: 'span',
                        text: '3.8M',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    StatLbl: {
                        text: '{{ pitchPopulation | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'B'
                    }
                },
                StatCard2: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    StatVal: {
                        tag: 'span',
                        text: '{{ pitchTbilisi | polyglot }}',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    StatLbl: {
                        text: '{{ pitchConcentrated | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'B'
                    }
                },
                StatCard3: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    StatVal: {
                        tag: 'span',
                        text: '0',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    StatLbl: {
                        text: '{{ pitchZeroCompetitor | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'B'
                    }
                }
            }
        },
        // Slide 2 — Pain points
        Slide2: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(2),
            SlideLabel: {
                text: '{{ pitchProblemLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchProblemTitle | polyglot }}',
                fontSize: 'E',
                fontWeight: '700',
                color: 'text',
                maxWidth: 'I',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            PainList: {
                flow: 'y',
                gap: 'A',
                maxWidth: 'H',
                width: '100%',
                Pain1: {
                    ...$386b39b9d06f3a9f$var$painBase,
                    PainText: {
                        ...$386b39b9d06f3a9f$var$painBase.PainText,
                        text: '{{ pitchNoBooking | polyglot }}'
                    }
                },
                Pain2: {
                    ...$386b39b9d06f3a9f$var$painBase,
                    PainText: {
                        ...$386b39b9d06f3a9f$var$painBase.PainText,
                        text: '{{ pitchManualCases | polyglot }}'
                    }
                },
                Pain3: {
                    ...$386b39b9d06f3a9f$var$painBase,
                    PainText: {
                        ...$386b39b9d06f3a9f$var$painBase.PainText,
                        text: '{{ pitchNoAiTools | polyglot }}'
                    }
                }
            }
        },
        // Slide 3 — Three pillars
        Slide3: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(3),
            SlideLabel: {
                text: '{{ pitchCapabilitiesLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchOnePlatform | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            PillarsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                PillarBooking: {
                    ...$386b39b9d06f3a9f$var$pillarBase,
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    ':hover': {
                        borderColor: 'green'
                    },
                    PillarNum: {
                        text: '01',
                        fontSize: 'Z',
                        color: 'green',
                        fontFamily: 'monospace'
                    },
                    PillarTitle: {
                        ...$386b39b9d06f3a9f$var$pillarBase.PillarTitle,
                        text: '{{ pitchBooking | polyglot }}',
                        color: 'text'
                    },
                    Feat1: {
                        text: '{{ pitchClientSchedule | polyglot }}'
                    },
                    Feat2: {
                        text: '{{ pitchCalendarSync | polyglot }}'
                    },
                    Feat3: {
                        text: '{{ pitchAutoReminder | polyglot }}'
                    }
                },
                PillarOps: {
                    ...$386b39b9d06f3a9f$var$pillarBase,
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    ':hover': {
                        borderColor: 'green'
                    },
                    PillarNum: {
                        text: '02',
                        fontSize: 'Z',
                        color: 'green',
                        fontFamily: 'monospace'
                    },
                    PillarTitle: {
                        ...$386b39b9d06f3a9f$var$pillarBase.PillarTitle,
                        text: '{{ pitchOperations | polyglot }}',
                        color: 'text'
                    },
                    Feat1: {
                        text: '{{ pitchCaseManagement | polyglot }}'
                    },
                    Feat2: {
                        text: '{{ pitchInvoices | polyglot }}'
                    },
                    Feat3: {
                        text: '{{ pitchTrustedAccounting | polyglot }}'
                    }
                },
                PillarAI: {
                    ...$386b39b9d06f3a9f$var$pillarBase,
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    ':hover': {
                        borderColor: 'green'
                    },
                    PillarNum: {
                        text: '03',
                        fontSize: 'Z',
                        color: 'green',
                        fontFamily: 'monospace'
                    },
                    PillarTitle: {
                        ...$386b39b9d06f3a9f$var$pillarBase.PillarTitle,
                        text: 'AI',
                        color: 'text'
                    },
                    Feat1: {
                        text: '{{ pitchDocDraftGeo | polyglot }}'
                    },
                    Feat2: {
                        text: '{{ pitchContractAnalysis | polyglot }}'
                    },
                    Feat3: {
                        text: '{{ pitchAutoNextSteps | polyglot }}'
                    }
                }
            }
        },
        // Slide 4 — Product & Perks
        Slide4: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(4),
            SlideLabel: {
                text: '{{ pitchProductLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchProductTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            PerksRow: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                childExtends: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    flex: '1',
                    minWidth: '140px',
                    textAlign: 'center',
                    transition: 'border-color 200ms',
                    ':hover': {
                        borderColor: 'green'
                    }
                },
                Perk1: {
                    PerkIcon: {
                        text: "\uD83D\uDCC5",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkBookings | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                },
                Perk2: {
                    PerkIcon: {
                        text: "\uD83E\uDD16",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkAiDocs | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                },
                Perk3: {
                    PerkIcon: {
                        text: "\uD83D\uDCF1",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkResponsive | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                },
                Perk4: {
                    PerkIcon: {
                        text: "\uD83D\uDCC1",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkFileStorage | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                },
                Perk5: {
                    PerkIcon: {
                        text: "\uD83D\uDCAC",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkCommunication | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                },
                Perk6: {
                    PerkIcon: {
                        text: "\uD83D\uDC64",
                        fontSize: 'C'
                    },
                    PerkName: {
                        text: '{{ pitchPerkClientPortal | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'text'
                    }
                }
            }
        },
        // Slide 5 — Integrations
        Slide5: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(5),
            SlideLabel: {
                text: '{{ pitchIntegrationsLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchIntegrationsTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            SlideSub: {
                text: '{{ pitchIntegrationsSub | polyglot }}',
                fontSize: 'B',
                color: 'textMuted',
                maxWidth: 'H',
                lineHeight: '1.6'
            },
            IntegrationsGrid: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                IntGov1: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    IntIcon: {
                        text: "\u2696\uFE0F",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: 'ecourt.ge',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchEcourtDesc | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                },
                IntGov2: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    IntIcon: {
                        text: "\uD83C\uDFDB\uFE0F",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: '{{ pitchPublicRegistry | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchPublicRegistryDesc | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                },
                IntGov3: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    IntIcon: {
                        text: "\uD83D\uDCDC",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: 'matsne.gov.ge',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchMatsneDesc | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                }
            },
            IntegrationsRow2: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                IntGov4: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    IntIcon: {
                        text: "\uD83D\uDCB0",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: 'rs.ge',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchRsGeDesc | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                },
                IntCal: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    background: 'greenBg',
                    border: '2px solid green',
                    IntIcon: {
                        text: "\uD83D\uDCC5",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: '{{ pitchCalendarSyncTitle | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchCalendarSyncDesc | polyglot }}',
                        color: 'textSoft',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                },
                IntOcr: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    IntIcon: {
                        text: "\uD83D\uDD0D",
                        fontSize: 'C'
                    },
                    IntTitle: {
                        tag: 'h3',
                        text: '{{ pitchOcrTitle | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'text'
                    },
                    IntDesc: {
                        text: '{{ pitchOcrDesc | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'Z',
                        lineHeight: '1.6'
                    }
                }
            }
        },
        // Slide 6 — Pricing
        Slide6: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(6),
            SlideLabel: {
                text: '{{ pitchPlansLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchPlansTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            RateNote: {
                text: '{{ pitchRateNote | polyglot }}',
                color: 'textMuted',
                fontSize: 'B'
            },
            TiersRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                TierStarter: {
                    ...$386b39b9d06f3a9f$var$tierBase,
                    TierLabel: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierLabel,
                        text: '{{ pitchTierStarter | polyglot }}'
                    },
                    TierTarget: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierTarget,
                        text: '{{ pitchTierStarter12 | polyglot }}'
                    },
                    TierPrice: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierPrice,
                        text: "\u20BE15"
                    }
                },
                TierPro: {
                    ...$386b39b9d06f3a9f$var$tierBase,
                    background: 'greenBg',
                    border: '2px solid green',
                    TierBadge: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        BadgeDot: {
                            width: 'Z',
                            height: 'Z',
                            background: 'green'
                        },
                        BadgeText: {
                            text: '{{ pitchMostPopular | polyglot }}',
                            color: 'green',
                            fontSize: 'Y',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }
                    },
                    TierLabel: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierLabel,
                        text: '{{ pitchTierPro | polyglot }}',
                        color: 'text'
                    },
                    TierTarget: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierTarget,
                        text: '{{ pitchTierPro310 | polyglot }}'
                    },
                    TierPrice: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierPrice,
                        text: "\u20BE75",
                        color: 'green'
                    }
                },
                TierBusiness: {
                    ...$386b39b9d06f3a9f$var$tierBase,
                    TierLabel: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierLabel,
                        text: '{{ pitchTierBusiness | polyglot }}'
                    },
                    TierTarget: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierTarget,
                        text: '{{ pitchTierBusiness10 | polyglot }}'
                    },
                    TierPrice: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierPrice,
                        text: "\u20BE299"
                    }
                },
                TierEnterprise: {
                    ...$386b39b9d06f3a9f$var$tierBase,
                    TierLabel: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierLabel,
                        text: '{{ pitchTierEnterprise | polyglot }}'
                    },
                    TierTarget: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierTarget,
                        text: '{{ pitchTierEnterpriseCustom | polyglot }}'
                    },
                    TierPrice: {
                        ...$386b39b9d06f3a9f$var$tierBase.TierPrice,
                        text: '{{ pitchTierEnterprisePrice | polyglot }}',
                        fontSize: 'D'
                    }
                }
            }
        },
        // Slide 7 — Revenue potential
        Slide7: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(7),
            SlideLabel: {
                text: '{{ pitchRevenueLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchRevenueTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            CalcNote: {
                text: '{{ pitchCalcNote | polyglot }}',
                color: 'textMuted',
                fontSize: 'A',
                fontStyle: 'italic'
            },
            ScenarioRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                '@mobileL': {
                    flow: 'y',
                    width: '100%'
                },
                Scenario1: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    ScenPct: {
                        tag: 'span',
                        text: '5%',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'textMuted'
                    },
                    ScenCapture: {
                        text: '{{ pitchScen250 | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    },
                    ScenArr: {
                        tag: 'span',
                        text: "\u20BE105K ARR",
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green'
                    }
                },
                Scenario2: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    background: 'greenBg',
                    border: '2px solid green',
                    ScenPct: {
                        tag: 'span',
                        text: '10%',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    ScenCapture: {
                        text: '{{ pitchScen500 | polyglot }}',
                        color: 'textSoft',
                        fontSize: 'A'
                    },
                    ScenArr: {
                        tag: 'span',
                        text: "\u20BE210K ARR",
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green'
                    }
                },
                Scenario3: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    ScenPct: {
                        tag: 'span',
                        text: '20%',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'textMuted'
                    },
                    ScenCapture: {
                        text: '{{ pitchScen1000 | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    },
                    ScenArr: {
                        tag: 'span',
                        text: "\u20BE420K ARR",
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green'
                    }
                }
            }
        },
        // Slide 8 — Unit Economics
        Slide8: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(8),
            SlideLabel: {
                text: '{{ pitchFinanceLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchFinanceTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            MetricsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                Metric1: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: "\u20BE35",
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: '{{ pitchArpuMonth | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                },
                Metric2: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: "\u20BE420",
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: '{{ pitchArpuYear | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                },
                Metric3: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: "~\u20BE5",
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: '{{ pitchServerCost | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                }
            },
            BottomRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                Metric4: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: '~86%',
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: 'Gross Margin',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                },
                Metric5: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: "\u20BE0",
                        fontSize: 'F',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: '{{ pitchCacOrganic | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                },
                Metric6: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    MetricVal: {
                        tag: 'span',
                        text: 'SaaS',
                        fontSize: 'E',
                        fontWeight: '700',
                        color: 'green'
                    },
                    MetricLbl: {
                        text: '{{ pitchRecurringModel | polyglot }}',
                        color: 'textMuted',
                        fontSize: 'A'
                    }
                }
            }
        },
        // Slide 9 — Why now
        Slide9: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(9),
            SlideLabel: {
                text: '{{ pitchTimeLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchTimeTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            WhyList: {
                flow: 'y',
                gap: 'A',
                maxWidth: 'H',
                width: '100%',
                Why1: {
                    ...$386b39b9d06f3a9f$var$whyBase,
                    WhyNum: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyNum,
                        text: '01'
                    },
                    WhyDesc: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyDesc,
                        text: '{{ pitchWhyAiCheap | polyglot }}'
                    }
                },
                Why2: {
                    ...$386b39b9d06f3a9f$var$whyBase,
                    WhyNum: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyNum,
                        text: '02'
                    },
                    WhyDesc: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyDesc,
                        text: '{{ pitchWhyDigitizing | polyglot }}'
                    }
                },
                Why3: {
                    ...$386b39b9d06f3a9f$var$whyBase,
                    WhyNum: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyNum,
                        text: '03'
                    },
                    WhyDesc: {
                        ...$386b39b9d06f3a9f$var$whyBase.WhyDesc,
                        text: '{{ pitchWhyNoCompetitor | polyglot }}'
                    }
                }
            }
        },
        // Slide 10 — Privacy & Infrastructure
        Slide10: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(10),
            SlideLabel: {
                text: '{{ pitchPrivacyLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ pitchPrivacyTitle | polyglot }}',
                fontSize: 'F',
                fontWeight: '700',
                color: 'text',
                '@mobileL': {
                    fontSize: 'D'
                }
            },
            SlideSubtitle: {
                text: '{{ pitchPrivacySubtitle | polyglot }}',
                fontSize: 'B',
                color: 'textMuted',
                maxWidth: 'H',
                lineHeight: '1.6'
            },
            InfraRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                InfraCloud: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    background: 'greenBg',
                    border: '2px solid green',
                    InfraIcon: {
                        text: "\u2601\uFE0F",
                        fontSize: 'D'
                    },
                    InfraTitle: {
                        tag: 'h3',
                        text: '{{ pitchCloudDedicated | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    InfraDesc: {
                        text: '{{ pitchCloudDedicatedDesc | polyglot }}',
                        color: 'textSoft',
                        fontSize: 'A',
                        lineHeight: '1.6'
                    }
                },
                InfraOnPrem: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    InfraIcon: {
                        text: "\uD83C\uDFE2",
                        fontSize: 'D'
                    },
                    InfraTitle: {
                        tag: 'h3',
                        text: '{{ pitchOnPremise | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    InfraDesc: {
                        text: '{{ pitchOnPremiseDesc | polyglot }}',
                        color: 'textSoft',
                        fontSize: 'A',
                        lineHeight: '1.6'
                    }
                },
                InfraHybrid: {
                    ...$386b39b9d06f3a9f$var$cardBase,
                    InfraIcon: {
                        text: "\uD83D\uDD12",
                        fontSize: 'D'
                    },
                    InfraTitle: {
                        tag: 'h3',
                        text: '{{ pitchHybrid | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'text'
                    },
                    InfraDesc: {
                        text: '{{ pitchHybridDesc | polyglot }}',
                        color: 'textSoft',
                        fontSize: 'A',
                        lineHeight: '1.6'
                    }
                }
            },
            PrivacyFeatures: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                align: 'stretch center',
                width: '100%',
                maxWidth: 'J',
                '@mobileL': {
                    flow: 'y'
                },
                Feat1: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    FeatDot: {
                        width: 'Y',
                        height: 'Y',
                        borderRadius: '100%',
                        background: 'green',
                        flexShrink: '0'
                    },
                    FeatText: {
                        text: 'End-to-end encryption',
                        fontSize: 'Z',
                        color: 'text'
                    }
                },
                Feat2: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    FeatDot: {
                        width: 'Y',
                        height: 'Y',
                        borderRadius: '100%',
                        background: 'green',
                        flexShrink: '0'
                    },
                    FeatText: {
                        text: '{{ pitchGdprCompliant | polyglot }}',
                        fontSize: 'Z',
                        color: 'text'
                    }
                },
                Feat3: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    FeatDot: {
                        width: 'Y',
                        height: 'Y',
                        borderRadius: '100%',
                        background: 'green',
                        flexShrink: '0'
                    },
                    FeatText: {
                        text: '{{ pitchDedicatedServer | polyglot }}',
                        fontSize: 'Z',
                        color: 'text'
                    }
                },
                Feat4: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Z A',
                    background: 'surfaceCard',
                    border: '1px solid surfaceBorderStrong',
                    borderRadius: 'Z',
                    FeatDot: {
                        width: 'Y',
                        height: 'Y',
                        borderRadius: '100%',
                        background: 'green',
                        flexShrink: '0'
                    },
                    FeatText: {
                        text: '{{ pitchAutoBackup | polyglot }}',
                        fontSize: 'Z',
                        color: 'text'
                    }
                }
            }
        },
        // Slide 11 — CTA
        Slide11: {
            ...$386b39b9d06f3a9f$var$slideBase,
            ...$386b39b9d06f3a9f$var$slideAnim(11),
            gap: 'B',
            TagLine: {
                fontSize: 'Z',
                color: 'green',
                fontWeight: '600',
                text: '{{ pitchCtaLabel | polyglot }}',
                letterSpacing: '1px',
                textTransform: 'uppercase'
            },
            TitleText: {
                tag: 'h2',
                text: '{{ pitchCtaTitle | polyglot }}',
                fontSize: 'G',
                fontWeight: '700',
                color: 'text',
                lineHeight: '1.1',
                maxWidth: 'J',
                '@mobileL': {
                    fontSize: 'E'
                }
            },
            SubText: {
                text: '{{ pitchCtaSubtext | polyglot }}',
                fontSize: 'D',
                color: 'green',
                fontWeight: '600'
            },
            CtaLink: {
                extends: 'Link',
                href: '/',
                text: '{{ pitchCtaLink | polyglot }}',
                background: 'green',
                color: 'black',
                padding: 'A B',
                fontSize: 'B',
                fontWeight: '600',
                borderRadius: 'Y',
                textDecoration: 'none',
                marginTop: 'A',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                }
            }
        }
    },
    // Navigation
    NavRow: {
        position: 'absolute',
        bottom: 'A',
        left: '0',
        right: '0',
        flow: 'x',
        align: 'center center',
        gap: 'A',
        zIndex: '10',
        PrevBtn: {
            extends: 'Button',
            text: "\u2190",
            background: 'transparent',
            color: 'textSoft',
            border: 'none',
            fontSize: 'B',
            padding: 'Z A',
            cursor: 'pointer',
            opacity: (el, s)=>s.slide > 0 ? '1' : '0.2',
            pointerEvents: (el, s)=>s.slide > 0 ? 'auto' : 'none',
            onClick: (e, el, s)=>s.update({
                    slide: s.slide - 1
                })
        },
        DotsWrap: {
            flow: 'x',
            gap: 'Y',
            align: 'center center',
            childExtends: {
                width: 'Y',
                height: 'Y',
                borderRadius: '100%',
                cursor: 'pointer',
                transition: 'background 200ms'
            },
            Dot0: {
                background: (el, s)=>s.slide === 0 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 0
                    })
            },
            Dot1: {
                background: (el, s)=>s.slide === 1 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 1
                    })
            },
            Dot2: {
                background: (el, s)=>s.slide === 2 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 2
                    })
            },
            Dot3: {
                background: (el, s)=>s.slide === 3 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 3
                    })
            },
            Dot4: {
                background: (el, s)=>s.slide === 4 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 4
                    })
            },
            Dot5: {
                background: (el, s)=>s.slide === 5 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 5
                    })
            },
            Dot6: {
                background: (el, s)=>s.slide === 6 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 6
                    })
            },
            Dot7: {
                background: (el, s)=>s.slide === 7 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 7
                    })
            },
            Dot8: {
                background: (el, s)=>s.slide === 8 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 8
                    })
            },
            Dot9: {
                background: (el, s)=>s.slide === 9 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 9
                    })
            },
            Dot10: {
                background: (el, s)=>s.slide === 10 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 10
                    })
            },
            Dot11: {
                background: (el, s)=>s.slide === 11 ? 'green' : 'surfaceBorderStrong',
                onClick: (e, el, s)=>s.update({
                        slide: 11
                    })
            }
        },
        NextBtn: {
            extends: 'Button',
            text: "\u2192",
            background: 'transparent',
            color: 'textSoft',
            border: 'none',
            fontSize: 'B',
            padding: 'Z A',
            cursor: 'pointer',
            opacity: (el, s)=>s.slide < s.total - 1 ? '1' : '0.2',
            pointerEvents: (el, s)=>s.slide < s.total - 1 ? 'auto' : 'none',
            onClick: (e, el, s)=>s.update({
                    slide: s.slide + 1
                })
        }
    }
};


const $6453c27a0f857188$export$301fd8a009fbc19d = {
    extends: 'Page',
    flow: 'y',
    theme: 'document',
    LawyersData: {
        display: 'none',
        fetch: {
            from: 'lawyers',
            order: {
                by: 'info_score',
                asc: false
            },
            limit: 50,
            cache: '5m',
            // Disabled during text search — SearchData handles OR query instead
            enabled: (el, s)=>!s.root.directoryFilter && (s.root.directoryView === 'all' || s.root.directoryView === 'lawyers'),
            params: (el, s)=>{
                const root = s.root || s;
                const p = {};
                if (root.cityFilter) p.city = root.cityFilter;
                if (root.verificationFilter === 'verified') p.is_subscribed = true;
                else if (root.verificationFilter === 'unverified') p.is_subscribed = {
                    neq: true
                };
                if (root.statusFilter === 'active') p.status = 'active';
                else if (root.statusFilter === 'inactive') p.status = {
                    neq: 'active'
                };
                if (root.areaFilter) p.specializations = {
                    contains: [
                        root.areaFilter
                    ]
                };
                return Object.keys(p).length ? p : undefined;
            },
            transform: (data, el)=>{
                const root = el.state.root || el.state;
                if (root && root.directoryFilter) return [];
                const lawyers = (data || []).map((item)=>el.call('mapLawyer', item));
                if (root && root.update) root.update({
                    lawyers: lawyers,
                    lawyersLoaded: true,
                    hasMoreLawyers: (data || []).length >= 50
                }, {
                    preventFetch: true
                });
                return lawyers;
            }
        }
    },
    FirmsData: {
        display: 'none',
        fetch: {
            from: 'law_firms',
            order: {
                by: 'name_en',
                asc: true
            },
            limit: 50,
            cache: '5m',
            enabled: (el, s)=>!s.root.directoryFilter && (s.root.directoryView === 'all' || s.root.directoryView === 'firms'),
            params: (el, s)=>{
                const root = s.root || s;
                const p = {};
                if (root.cityFilter) p.city = root.cityFilter;
                if (root.verificationFilter === 'verified') p.is_subscribed = true;
                else if (root.verificationFilter === 'unverified') p.is_subscribed = {
                    neq: true
                };
                if (root.statusFilter === 'active') p.status = 'active';
                else if (root.statusFilter === 'inactive') p.status = {
                    neq: 'active'
                };
                if (root.areaFilter) p.practice_areas = {
                    contains: [
                        root.areaFilter
                    ]
                };
                return Object.keys(p).length ? p : undefined;
            },
            transform: (data, el)=>{
                const root = el.state.root || el.state;
                if (root && root.directoryFilter) return [];
                const firms = (data || []).map((item)=>el.call('mapFirm', item));
                if (root && root.update) root.update({
                    firms: firms,
                    firmsLoaded: true,
                    hasMoreFirms: (data || []).length >= 50
                }, {
                    preventFetch: true
                });
                return firms;
            }
        }
    },
    LawyersCount: {
        display: 'none',
        fetch: {
            method: 'rpc',
            from: 'count_lawyers',
            cache: '10m',
            transform: (data, el)=>{
                const root = el.state.root || el.state;
                const count = data && data[0] ? data[0].count : 0;
                if (root && root.update) root.update({
                    totalLawyers: count
                }, {
                    preventFetch: true
                });
            }
        }
    },
    FirmsCount: {
        display: 'none',
        fetch: {
            method: 'rpc',
            from: 'count_firms',
            cache: '10m',
            transform: (data, el)=>{
                const root = el.state.root || el.state;
                const count = data && data[0] ? data[0].count : 0;
                if (root && root.update) root.update({
                    totalFirms: count
                }, {
                    preventFetch: true
                });
            }
        }
    },
    // OR-search across name_en + name_ka via direct REST call
    SearchData: {
        display: 'none',
        text: (el, s)=>{
            const root = s.root || s;
            const q = (root.directoryFilter || '').trim();
            const key = q + '|' + (root.cityFilter || '') + '|' + (root.verificationFilter || '') + '|' + (root.statusFilter || '') + '|' + (root.areaFilter || '');
            if (el.node._lastSearchKey === key) return key;
            el.node._lastSearchKey = key;
            if (!q) return key;
            const version = el.node._searchVersion = (el.node._searchVersion || 0) + 1;
            el.call('searchDirectory', q, {
                cityFilter: root.cityFilter,
                verificationFilter: root.verificationFilter,
                statusFilter: root.statusFilter,
                areaFilter: root.areaFilter
            }).then(({ lawyers: lawyers, firms: firms })=>{
                if (el.node._searchVersion !== version) return;
                root.update({
                    lawyers: lawyers,
                    firms: firms,
                    lawyersLoaded: true,
                    hasMoreLawyers: false,
                    hasMoreFirms: false,
                    lawyersVisible: 24
                }, {
                    preventFetch: true
                });
            });
            return key;
        }
    },
    LandingNav: {},
    // Read ?q= and ?area= from URL on page load
    ParamReader: {
        display: 'none',
        onRender: (el, s)=>{
            if (el.node._paramsRead) return;
            el.node._paramsRead = true;
            const params = new URLSearchParams(window.location.search);
            const q = params.get('q');
            const area = params.get('area');
            const updates = {};
            if (q) updates.directoryFilter = q;
            if (area) updates.areaFilter = area;
            if (Object.keys(updates).length) s.root.update(updates);
        }
    },
    HeroHeader: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        textAlign: 'center',
        padding: 'E B B B',
        width: '100%',
        background: 'neutral950',
        color: 'neutral50',
        '@mobileL': {
            padding: 'D A A A'
        },
        PageTitle: {
            tag: 'h1',
            text: '{{ lawyersTitle | polyglot }}',
            fontSize: 'E',
            fontWeight: '700',
            color: 'neutral50',
            letterSpacing: '-0.03em'
        },
        PageSubtitle: {
            text: (el, s)=>{
                const l = s.root.totalLawyers || (s.root.lawyers || []).length;
                const f = s.root.totalFirms || (s.root.firms || []).length;
                return l + ' Lawyers \u00B7 ' + f + ' Firms registered in Georgia';
            },
            fontSize: 'A',
            color: 'neutral300',
            marginTop: 'Y'
        },
        SearchBar: {
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            width: '100%',
            maxWidth: 'J',
            margin: 'B -',
            '@mobileL': {
                flow: 'y'
            },
            SearchInput: {
                tag: 'input',
                type: 'text',
                placeholder: '{{ searchPlaceholder | polyglot }}',
                flex: '1',
                padding: 'Z A',
                round: 'C',
                theme: 'card',
                fontSize: 'Z',
                outline: 'none',
                transition: 'all 0.2s ease',
                ':focus': {
                    boxShadow: 'black.08 0 Y A'
                },
                attr: {
                    value: (el, s)=>s.root.directoryFilter || ''
                },
                onRender: (el, s)=>{
                    if (s.root.directoryFilter && !el.node.value) el.node.value = s.root.directoryFilter;
                },
                onInput: (e, el, s)=>{
                    clearTimeout(el.node._searchTimer);
                    el.node._searchTimer = setTimeout(()=>{
                        const q = el.node.value;
                        // Clear lawyers/firms immediately so stale data doesn't show
                        s.root.update({
                            directoryFilter: q,
                            lawyers: [],
                            firms: [],
                            lawyersLoaded: false,
                            hasMoreLawyers: false,
                            hasMoreFirms: false
                        });
                    }, 400);
                }
            },
            ViewToggle: {
                flow: 'x',
                gap: 'W',
                flexShrink: '0',
                AllBtn: {
                    tag: 'button',
                    text: '{{ allFilter | polyglot }}',
                    padding: 'Z A',
                    round: 'C',
                    fontSize: 'Z',
                    fontWeight: '600',
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    theme: (el, s)=>s.root.directoryView === 'all' ? 'primary' : 'ghost',
                    onClick: (e, el, s)=>s.root.update({
                            directoryView: 'all'
                        })
                },
                LawyersBtn: {
                    tag: 'button',
                    text: '{{ lawyersBtn | polyglot }}',
                    padding: 'Z A',
                    round: 'C',
                    fontSize: 'Z',
                    fontWeight: '600',
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    theme: (el, s)=>s.root.directoryView === 'lawyers' ? 'primary' : 'ghost',
                    onClick: (e, el, s)=>s.root.update({
                            directoryView: 'lawyers'
                        })
                },
                FirmsBtn: {
                    tag: 'button',
                    text: '{{ firmsBtn | polyglot }}',
                    padding: 'Z A',
                    round: 'C',
                    fontSize: 'Z',
                    fontWeight: '600',
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    theme: (el, s)=>s.root.directoryView === 'firms' ? 'primary' : 'ghost',
                    onClick: (e, el, s)=>s.root.update({
                            directoryView: 'firms'
                        })
                }
            }
        },
        FilterRow: {
            flow: 'x',
            gap: 'Y',
            flexWrap: 'wrap',
            align: 'center center',
            maxWidth: 'J',
            children: [
                {
                    label: '{{ allFilter | polyglot }}',
                    value: ''
                },
                {
                    label: '{{ corporateLaw | polyglot }}',
                    value: 'Corporate Law'
                },
                {
                    label: '{{ criminalLaw | polyglot }}',
                    value: 'Criminal Law'
                },
                {
                    label: 'Civil Law',
                    value: 'Civil Law'
                },
                {
                    label: '{{ familyLaw | polyglot }}',
                    value: 'Family Law'
                },
                {
                    label: '{{ realEstate | polyglot }}',
                    value: 'Real Estate'
                },
                {
                    label: '{{ taxLaw | polyglot }}',
                    value: 'Tax Law'
                },
                {
                    label: '{{ ipLaw | polyglot }}',
                    value: 'IP'
                },
                {
                    label: '{{ immigration | polyglot }}',
                    value: 'Immigration'
                },
                {
                    label: '{{ laborLaw | polyglot }}',
                    value: 'Labor Law'
                },
                {
                    label: '{{ bankingFinance | polyglot }}',
                    value: 'Banking & Finance'
                },
                {
                    label: 'Administrative',
                    value: 'Administrative Law'
                },
                {
                    label: 'Constitutional',
                    value: 'Constitutional Law'
                },
                {
                    label: 'Human Rights',
                    value: 'Human Rights'
                },
                {
                    label: 'Juvenile Justice',
                    value: 'Juvenile Justice'
                },
                {
                    label: 'General Practice',
                    value: 'General Practice'
                }
            ],
            childrenAs: 'state',
            childProps: {
                tag: 'button',
                text: (el, s)=>s.label,
                padding: 'Y Z',
                round: 'C',
                fontSize: 'Z',
                fontWeight: '500',
                cursor: 'pointer',
                border: 'none',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s ease',
                theme: (el, s)=>(s.root.areaFilter || '') === s.value ? 'primary' : 'ghost',
                onClick: (e, el, s)=>s.root.update({
                        areaFilter: s.value
                    })
            }
        },
        FilterSelects: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            align: 'center center',
            maxWidth: 'J',
            margin: 'A - -',
            CitySelect: {
                tag: 'select',
                padding: 'Y Z',
                round: 'Z',
                fontSize: 'Z',
                fontWeight: '500',
                cursor: 'pointer',
                background: 'transparent',
                color: 'neutral300',
                border: '1px solid neutral700',
                outline: 'none',
                onRender: (el, s)=>{
                    el.node.value = s.root.cityFilter || '';
                },
                onChange: (e, el, s)=>s.root.update({
                        cityFilter: el.node.value
                    }),
                children: [
                    {
                        label: 'All Cities',
                        val: ''
                    },
                    {
                        label: 'Tbilisi',
                        val: 'Tbilisi'
                    },
                    {
                        label: 'Batumi',
                        val: 'Batumi'
                    },
                    {
                        label: 'Kutaisi',
                        val: 'Kutaisi'
                    },
                    {
                        label: 'Rustavi',
                        val: 'Rustavi'
                    },
                    {
                        label: 'Zugdidi',
                        val: 'Zugdidi'
                    },
                    {
                        label: 'Gori',
                        val: 'Gori'
                    },
                    {
                        label: 'Telavi',
                        val: 'Telavi'
                    },
                    {
                        label: 'Ozurgeti',
                        val: 'Ozurgeti'
                    },
                    {
                        label: 'Akhaltsikhe',
                        val: 'Akhaltsikhe'
                    },
                    {
                        label: 'Senaki',
                        val: 'Senaki'
                    }
                ],
                childrenAs: 'state',
                childProps: {
                    tag: 'option',
                    text: (el, s)=>s.label,
                    attr: {
                        value: (el, s)=>s.val
                    }
                }
            },
            VerificationSelect: {
                tag: 'select',
                padding: 'Y Z',
                round: 'Z',
                fontSize: 'Z',
                fontWeight: '500',
                cursor: 'pointer',
                background: 'transparent',
                color: 'neutral300',
                border: '1px solid neutral700',
                outline: 'none',
                onRender: (el, s)=>{
                    el.node.value = s.root.verificationFilter || '';
                },
                onChange: (e, el, s)=>s.root.update({
                        verificationFilter: el.node.value
                    }),
                children: [
                    {
                        label: 'All Verification',
                        val: ''
                    },
                    {
                        label: 'Verified',
                        val: 'verified'
                    },
                    {
                        label: 'Unverified',
                        val: 'unverified'
                    }
                ],
                childrenAs: 'state',
                childProps: {
                    tag: 'option',
                    text: (el, s)=>s.label,
                    attr: {
                        value: (el, s)=>s.val
                    }
                }
            },
            StatusSelect: {
                tag: 'select',
                padding: 'Y Z',
                round: 'Z',
                fontSize: 'Z',
                fontWeight: '500',
                cursor: 'pointer',
                background: 'transparent',
                color: 'neutral300',
                border: '1px solid neutral700',
                outline: 'none',
                onRender: (el, s)=>{
                    el.node.value = s.root.statusFilter || '';
                },
                onChange: (e, el, s)=>s.root.update({
                        statusFilter: el.node.value
                    }),
                children: [
                    {
                        label: 'All Status',
                        val: ''
                    },
                    {
                        label: 'Active',
                        val: 'active'
                    },
                    {
                        label: 'Inactive',
                        val: 'inactive'
                    }
                ],
                childrenAs: 'state',
                childProps: {
                    tag: 'option',
                    text: (el, s)=>s.label,
                    attr: {
                        value: (el, s)=>s.val
                    }
                }
            }
        },
        ResultCount: {
            text: (el, s)=>{
                const q = s.root.directoryFilter;
                if (!q) return '';
                if (!s.root.lawyersLoaded) return '...';
                const view = s.root.directoryView;
                const n = view === 'firms' ? (s.root.firms || []).length : (s.root.lawyers || []).length;
                const key = view === 'firms' ? 'firmsMatch' : 'lawyersMatch';
                return n + ' {{ ' + key + ' | polyglot }} "' + q + '"';
            },
            opacity: '0.5',
            margin: 'A2 -'
        }
    },
    ContentLayout: {
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        padding: 'B B',
        '@mobileL': {
            padding: 'A'
        },
        DirectoryGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            '@tabletS': {
                gridTemplateColumns: 'repeat(2, 1fr)'
            },
            '@mobileL': {
                gridTemplateColumns: '1fr'
            },
            gap: 'B',
            children: (el, s)=>{
                const view = s.root.directoryView || 'all';
                const visible = s.root.lawyersVisible || 24;
                // Backend handles all filtering (search, city, verification, status, area)
                let results = [];
                if (view === 'all' || view === 'lawyers') results = results.concat((s.root.lawyers || []).map((l)=>({
                        ...l,
                        _type: 'lawyer'
                    })));
                if (view === 'all' || view === 'firms') results = results.concat((s.root.firms || []).map((f)=>({
                        ...f,
                        _type: 'firm'
                    })));
                return results.slice(0, visible);
            },
            childrenAs: 'state',
            childExtends: 'DirectoryCard'
        },
        ShowMoreBtn: {
            tag: 'button',
            show: (el, s)=>{
                const visible = s.root.lawyersVisible || 24;
                const loaded = (s.root.lawyers || []).length + (s.root.firms || []).length;
                return visible < loaded || s.root.hasMoreLawyers || s.root.hasMoreFirms;
            },
            text: (el, s)=>{
                const visible = s.root.lawyersVisible || 24;
                const loaded = (s.root.lawyers || []).length + (s.root.firms || []).length;
                const hasFilters = s.root.cityFilter || s.root.verificationFilter || s.root.statusFilter || s.root.directoryFilter || s.root.areaFilter;
                const hasMore = s.root.hasMoreLawyers || s.root.hasMoreFirms;
                const total = hasFilters ? loaded + (hasMore ? '+' : '') : (s.root.totalLawyers || 0) + (s.root.totalFirms || 0) || loaded;
                return '{{ loadingMore | polyglot }} (' + visible + ' / ' + total + ')';
            },
            theme: 'ghost',
            padding: 'Z1 C',
            round: 'Z',
            fontSize: 'A',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'block',
            textAlign: 'center',
            width: '100%',
            maxWidth: 'H',
            margin: 'C auto',
            transition: 'all 0.2s ease',
            ':hover': {
                theme: 'primary'
            },
            onClick: (e, el, s)=>{
                const current = s.root.lawyersVisible || 24;
                const loaded = (s.root.lawyers || []).length + (s.root.firms || []).length;
                const next = current + 24;
                s.root.update({
                    lawyersVisible: next
                });
                // Fetch next page from backend when approaching end of loaded data
                if (next >= loaded) {
                    const page = el.parent?.parent;
                    if (page) {
                        const ld = page.LawyersData;
                        if (ld && ld.__ref && ld.__ref.__hasNextPage) ld.__ref.fetchNextPage();
                        const fd = page.FirmsData;
                        if (fd && fd.__ref && fd.__ref.__hasNextPage) fd.__ref.fetchNextPage();
                    }
                }
            }
        }
    },
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'C',
        padding: 'D 0',
        borderTop: '1px solid surfaceBorderStrong',
        maxWidth: 'K',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'C A'
        },
        FooterTop: {
            flow: 'x',
            gap: 'C',
            '@mobileL': {
                flow: 'y',
                gap: 'B'
            },
            FooterBrand: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                minWidth: 'F',
                FooterLogo: {
                    extends: 'Link',
                    href: '/',
                    text: 'TrustLegal',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'green',
                    textDecoration: 'none'
                },
                FooterTagline: {
                    text: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 SaaS \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0.',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.6'
                }
            },
            FooterLinks: {
                flow: 'x',
                gap: 'C',
                flex: '2',
                '@mobileL': {
                    flow: 'y',
                    gap: 'B'
                },
                FooterCol1: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/bookings',
                        text: '\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/cases',
                        text: '\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink3: {
                        extends: 'Link',
                        href: '/documents',
                        text: 'AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink4: {
                        extends: 'Link',
                        href: '/lawyers',
                        text: '{{ lawyersNav | polyglot }}',
                        fontSize: 'Z',
                        color: 'green',
                        textDecoration: 'none',
                        fontWeight: '500'
                    }
                },
                FooterCol2: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/',
                        text: '\u10E9\u10D5\u10D4\u10DC\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/',
                        text: '\u10D9\u10D0\u10E0\u10D8\u10D4\u10E0\u10D0',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                }
            }
        },
        FooterBottom: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            '@mobileL': {
                flow: 'y',
                gap: 'Z',
                align: 'center center'
            },
            CopyText: {
                text: '\u00A9 2026 TrustLegal',
                fontSize: 'Z',
                color: 'textMuted'
            },
            BuiltWith: {
                text: 'Built with Symbols',
                fontSize: 'Z',
                color: 'textMuted'
            }
        }
    }
};


const $3e0203566e4c452a$export$4882ae973e0491e = {
    extends: 'Page',
    flow: 'y',
    theme: 'document',
    LawyersData: {
        fetch: {
            from: 'lawyers',
            cache: '5m',
            keepPreviousData: true,
            params: ()=>{
                const params = new URLSearchParams(window.location.search);
                const slug = params.get('slug');
                if (slug) {
                    const match = slug.match(/-([A-Z][\w-]*)$/);
                    if (match) return {
                        bar_id: match[1]
                    };
                }
                const id = params.get('id');
                if (id) return {
                    id: id
                };
            },
            transform: (data, el)=>{
                const lawyers = (data || []).map((d)=>el.call('mapLawyer', d));
                const root = el.state.root || el.state;
                if (root && root.update) root.update({
                    lawyers: lawyers,
                    lawyersLoaded: true
                }, {
                    preventFetch: true
                });
                return lawyers;
            }
        },
        display: 'none'
    },
    FirmsData: {
        fetch: {
            from: 'law_firms',
            order: {
                by: 'name_en',
                asc: true
            },
            limit: 50,
            cache: '5m',
            keepPreviousData: true,
            transform: (data, el)=>{
                const firms = (data || []).map((d)=>el.call('mapFirm', d));
                const root = el.state.root || el.state;
                if (root && root.update) root.update({
                    firms: firms,
                    firmsLoaded: true
                }, {
                    preventFetch: true
                });
                return firms;
            }
        },
        display: 'none'
    },
    LandingNav: {},
    ProfileDetail: {
        flow: 'y',
        gap: 'A',
        padding: 'F B B B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        flex: '1',
        '@mobileL': {
            padding: 'E A A A'
        },
        BackRow: {
            extends: 'Link',
            href: '/lawyers',
            text: '{{ backToDirectory | polyglot }}',
            fontSize: 'Z',
            opacity: '0.7',
            textDecoration: 'none',
            fontWeight: '500',
            marginBottom: 'Y',
            ':hover': {
                opacity: '1'
            }
        },
        MainLayout: {
            flow: 'x',
            gap: 'B',
            width: '100%',
            align: 'stretch flex-start',
            '@mobileL': {
                flow: 'y'
            },
            LeftCol: {
                flex: '1',
                flow: 'y',
                gap: 'A',
                minWidth: '0',
                // === HEADER CARD ===
                HeaderCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    TopRow: {
                        flow: 'x',
                        gap: 'A',
                        align: 'flex-start flex-start',
                        '@mobileL': {
                            flow: 'y'
                        },
                        Avatar: {
                            tag: 'img',
                            width: 'E',
                            height: 'E',
                            round: (el, s)=>el.call('isFirmPage') ? 'Z' : 'E',
                            flexShrink: '0',
                            objectFit: 'cover',
                            src: (el, s)=>{
                                const e = el.call('getEntity');
                                return e ? e.photoUrl || e.avatar || e.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(e.nameEn) + '&background=1a2332&color=c6ac8f&size=128&bold=true&format=svg' : '';
                            }
                        },
                        Info: {
                            flow: 'y',
                            gap: 'Y',
                            flex: '1',
                            NameRow: {
                                flow: 'x',
                                align: 'center space-between',
                                flexWrap: 'wrap',
                                gap: 'Y',
                                Name: {
                                    tag: 'h1',
                                    text: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e ? e.nameEn : 'Not found';
                                    },
                                    fontSize: 'C',
                                    fontWeight: '700',
                                    letterSpacing: '-0.02em'
                                },
                                StatusBadge: {
                                    show: (el, s)=>!el.call('isFirmPage'),
                                    text: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e ? e.status : '';
                                    },
                                    padding: 'W Z',
                                    round: 'Y',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    theme: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.status === 'active' ? 'success' : 'danger';
                                    }
                                }
                            },
                            NameKa: {
                                text: (el, s)=>{
                                    const e = el.call('getEntity');
                                    return e ? e.nameKa : '';
                                },
                                fontSize: 'A',
                                opacity: '0.6'
                            },
                            // Lawyer: Bar ID
                            BarIdRow: {
                                show: (el, s)=>!el.call('isFirmPage'),
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                BarLabel: {
                                    text: '{{ barId | polyglot }}:',
                                    fontSize: 'Z',
                                    opacity: '0.5'
                                },
                                BarVal: {
                                    text: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e ? e.barId : '';
                                    },
                                    fontSize: 'Z',
                                    fontWeight: '600'
                                }
                            },
                            // Lawyer: Firm affiliation
                            FirmLink: {
                                show: (el, s)=>!el.call('isFirmPage'),
                                extends: 'Link',
                                href: (el, s)=>{
                                    const e = el.call('getEntity');
                                    if (!e || !e.firmId) return '#';
                                    const f = el.call('getFirmForEntity', e.firmId);
                                    return f ? '/firm?slug=' + f.slug : '#';
                                },
                                text: (el, s)=>{
                                    const e = el.call('getEntity');
                                    if (!e) return '';
                                    if (e.firmId) {
                                        const f = el.call('getFirmForEntity', e.firmId);
                                        return f ? f.nameEn : '';
                                    }
                                    return '{{ independent | polyglot }}';
                                },
                                fontSize: 'Z',
                                color: 'green',
                                fontWeight: '500',
                                textDecoration: 'none',
                                ':hover': {
                                    textDecoration: 'underline'
                                }
                            },
                            // Firm: Address
                            AddressRow: {
                                show: (el, s)=>el.call('isFirmPage'),
                                flow: 'x',
                                gap: 'W',
                                align: 'center flex-start',
                                PinIcon: {
                                    extends: 'Icon',
                                    icon: 'mapPin',
                                    width: 'Z',
                                    height: 'Z',
                                    opacity: '0.5'
                                },
                                AddrText: {
                                    text: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e ? e.address : '';
                                    },
                                    fontSize: 'Z',
                                    opacity: '0.7'
                                }
                            },
                            // Contact row (shared)
                            ContactRow: {
                                flow: 'x',
                                gap: 'A',
                                align: 'center flex-start',
                                flexWrap: 'wrap',
                                PhoneLink: {
                                    if: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.phone;
                                    },
                                    extends: 'Link',
                                    href: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#';
                                    },
                                    textDecoration: 'none',
                                    flow: 'x',
                                    gap: 'W',
                                    align: 'center flex-start',
                                    PhoneIcon: {
                                        extends: 'Icon',
                                        icon: 'phone',
                                        width: 'Z',
                                        height: 'Z',
                                        opacity: '0.5'
                                    },
                                    PhoneText: {
                                        text: (el, s)=>{
                                            const e = el.call('getEntity');
                                            return e ? e.phone : '';
                                        },
                                        fontSize: 'Z',
                                        color: 'green',
                                        fontWeight: '500'
                                    }
                                },
                                EmailLink: {
                                    if: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.email;
                                    },
                                    extends: 'Link',
                                    href: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.email ? 'mailto:' + e.email : '#';
                                    },
                                    textDecoration: 'none',
                                    flow: 'x',
                                    gap: 'W',
                                    align: 'center flex-start',
                                    EmailIcon: {
                                        extends: 'Icon',
                                        icon: 'mail',
                                        width: 'Z',
                                        height: 'Z',
                                        opacity: '0.5'
                                    },
                                    EmailText: {
                                        text: (el, s)=>{
                                            const e = el.call('getEntity');
                                            return e ? e.email : '';
                                        },
                                        fontSize: 'Z',
                                        color: 'green',
                                        fontWeight: '500'
                                    }
                                },
                                WebLink: {
                                    if: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e && e.website;
                                    },
                                    extends: 'Link',
                                    href: (el, s)=>{
                                        const e = el.call('getEntity');
                                        return e ? e.website : '#';
                                    },
                                    attr: {
                                        target: '_blank'
                                    },
                                    textDecoration: 'none',
                                    flow: 'x',
                                    gap: 'W',
                                    align: 'center flex-start',
                                    WebIcon: {
                                        extends: 'Icon',
                                        icon: 'externalLink',
                                        width: 'Z',
                                        height: 'Z',
                                        opacity: '0.5'
                                    },
                                    WebText: {
                                        text: '{{ website | polyglot }}',
                                        fontSize: 'Z',
                                        color: 'green',
                                        fontWeight: '500'
                                    }
                                },
                                CityInfo: {
                                    flow: 'x',
                                    gap: 'W',
                                    align: 'center flex-start',
                                    CityIcon: {
                                        extends: 'Icon',
                                        icon: 'mapPin',
                                        width: 'Z',
                                        height: 'Z',
                                        opacity: '0.5'
                                    },
                                    CityText: {
                                        text: (el, s)=>{
                                            const e = el.call('getEntity');
                                            return e ? e.city : '';
                                        },
                                        fontSize: 'Z',
                                        opacity: '0.6'
                                    }
                                }
                            }
                        }
                    },
                    // Tags (shared — specializations or practiceAreas)
                    Tags: {
                        flow: 'x',
                        gap: 'Y',
                        flexWrap: 'wrap',
                        marginTop: 'Y',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            if (!e) return [];
                            const tags = el.call('isFirmPage') ? e.practiceAreas || [] : e.specializations || [];
                            return tags.map((t)=>({
                                    label: t
                                }));
                        },
                        childrenAs: 'state',
                        childProps: {
                            text: (el, s)=>s.label,
                            padding: 'W Z',
                            round: 'C',
                            fontSize: 'Y',
                            fontWeight: '500',
                            theme: 'secondary'
                        }
                    },
                    // Lawyer: Rating / Experience / Languages
                    MetaRow: {
                        show: (el, s)=>!el.call('isFirmPage'),
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        marginTop: 'Z',
                        RatingInfo: {
                            flow: 'x',
                            gap: 'W',
                            align: 'center flex-start',
                            Star: {
                                text: '\u2605',
                                color: 'green'
                            },
                            RatingVal: {
                                text: (el, s)=>{
                                    const e = el.call('getEntity');
                                    return e ? e.rating + ' (' + e.reviews + ' {{ reviews | polyglot }})' : '';
                                },
                                fontSize: 'Z'
                            }
                        },
                        ExpInfo: {
                            text: (el, s)=>{
                                const e = el.call('getEntity');
                                if (!e || !e.admissionDate) return '';
                                const years = new Date().getFullYear() - new Date(e.admissionDate).getFullYear();
                                return years + ' {{ yearsExperience | polyglot }}';
                            },
                            fontSize: 'Z',
                            opacity: '0.6'
                        },
                        LangInfo: {
                            text: (el, s)=>{
                                const e = el.call('getEntity');
                                if (!e || !e.languages) return '';
                                const langMap = {
                                    ka: 'Georgian',
                                    en: 'English',
                                    ru: 'Russian',
                                    de: 'German',
                                    fr: 'French',
                                    tr: 'Turkish'
                                };
                                return '{{ languages | polyglot }}: ' + e.languages.map((x)=>langMap[x] || x).join(', ');
                            },
                            fontSize: 'Z',
                            opacity: '0.6'
                        }
                    },
                    // Firm: Year + City meta
                    FirmMeta: {
                        show: (el, s)=>el.call('isFirmPage'),
                        flow: 'x',
                        gap: 'A',
                        marginTop: 'Y',
                        YearBadge: {
                            show: (el, s)=>{
                                const e = el.call('getEntity');
                                return e && e.foundedYear;
                            },
                            text: (el, s)=>{
                                const e = el.call('getEntity');
                                return e ? 'Est. ' + e.foundedYear : '';
                            },
                            fontSize: 'Y',
                            opacity: '0.5'
                        },
                        CityBadge: {
                            text: (el, s)=>{
                                const e = el.call('getEntity');
                                return e ? e.city : '';
                            },
                            fontSize: 'Y',
                            padding: 'V Y',
                            round: 'C',
                            theme: 'secondary'
                        }
                    }
                },
                // === ABOUT / BIO (shared) ===
                AboutCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return e && (e.bioEn || e.descriptionEn);
                    },
                    flow: 'y',
                    gap: 'Y',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    AboutTitle: {
                        tag: 'h3',
                        text: '{{ about | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    AboutText: {
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.bioEn || e.descriptionEn || '' : '';
                        },
                        fontSize: 'Z',
                        lineHeight: '1.6',
                        opacity: '0.8'
                    },
                    AboutTextKa: {
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.bioKa || e.descriptionKa || '' : '';
                        },
                        fontSize: 'Z',
                        lineHeight: '1.6',
                        opacity: '0.5',
                        marginTop: 'Y'
                    }
                },
                // === LAWYER-ONLY SECTIONS ===
                EducationCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return !el.call('isFirmPage') && e && e.education && e.education.length > 0;
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    EduTitle: {
                        tag: 'h3',
                        text: 'Education',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    EduList: {
                        flow: 'y',
                        gap: 'Z',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.education || [] : [];
                        },
                        childrenAs: 'state',
                        childProps: {
                            flow: 'y',
                            gap: 'V',
                            padding: 'Z 0',
                            borderBottom: '1px solid surfaceBorderStrong',
                            EduDegree: {
                                text: (el, s)=>s.degree || '',
                                fontSize: 'Z',
                                fontWeight: '600'
                            },
                            EduSchool: {
                                text: (el, s)=>s.institution || '',
                                fontSize: 'Z',
                                opacity: '0.7'
                            },
                            EduYear: {
                                text: (el, s)=>s.year || '',
                                fontSize: 'Y',
                                opacity: '0.5'
                            }
                        }
                    }
                },
                ExperienceCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return !el.call('isFirmPage') && e && e.experience && e.experience.length > 0;
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    ExpTitle: {
                        tag: 'h3',
                        text: 'Experience',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    ExpList: {
                        flow: 'y',
                        gap: 'Z',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.experience || [] : [];
                        },
                        childrenAs: 'state',
                        childProps: {
                            flow: 'y',
                            gap: 'V',
                            padding: 'Z 0',
                            borderBottom: '1px solid surfaceBorderStrong',
                            ExpRole: {
                                text: (el, s)=>s.role || '',
                                fontSize: 'Z',
                                fontWeight: '600'
                            },
                            ExpOrg: {
                                text: (el, s)=>s.organization || '',
                                fontSize: 'Z',
                                opacity: '0.7'
                            },
                            ExpPeriod: {
                                text: (el, s)=>s.period || '',
                                fontSize: 'Y',
                                opacity: '0.5'
                            }
                        }
                    }
                },
                CertificationsCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return !el.call('isFirmPage') && e && e.certifications && e.certifications.length > 0;
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    CertTitle: {
                        tag: 'h3',
                        text: 'Certifications',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    CertList: {
                        flow: 'y',
                        gap: 'Y',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? (e.certifications || []).map((c)=>({
                                    label: typeof c === 'string' ? c : c.name
                                })) : [];
                        },
                        childrenAs: 'state',
                        childProps: {
                            flow: 'x',
                            gap: 'W',
                            align: 'center flex-start',
                            CertDot: {
                                text: '\u2022',
                                opacity: '0.4'
                            },
                            CertText: {
                                text: (el, s)=>s.label,
                                fontSize: 'Z',
                                opacity: '0.8'
                            }
                        }
                    }
                },
                MembershipsCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return !el.call('isFirmPage') && e && e.memberships && e.memberships.length > 0;
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    MemTitle: {
                        tag: 'h3',
                        text: 'Memberships',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    MemList: {
                        flow: 'y',
                        gap: 'Y',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? (e.memberships || []).map((m)=>({
                                    label: typeof m === 'string' ? m : m.name
                                })) : [];
                        },
                        childrenAs: 'state',
                        childProps: {
                            flow: 'x',
                            gap: 'W',
                            align: 'center flex-start',
                            MemDot: {
                                text: '\u2022',
                                opacity: '0.4'
                            },
                            MemText: {
                                text: (el, s)=>s.label,
                                fontSize: 'Z',
                                opacity: '0.8'
                            }
                        }
                    }
                },
                // === FIRM-ONLY: TEAM ===
                TeamSection: {
                    show: (el, s)=>el.call('isFirmPage'),
                    flow: 'y',
                    gap: 'A',
                    TeamTitle: {
                        tag: 'h3',
                        text: '{{ ourTeam | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700'
                    },
                    TeamGrid: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                        '@mobileL': {
                            gridTemplateColumns: '1fr'
                        },
                        gap: 'A',
                        children: (el, s)=>{
                            const e = el.call('getEntity');
                            if (!e) return [];
                            return (s.root.lawyers || []).filter((l)=>l.firmId === e.id).map((l)=>({
                                    ...l,
                                    _type: 'lawyer'
                                }));
                        },
                        childrenAs: 'state',
                        childExtends: 'DirectoryCard'
                    }
                },
                // Lawyer: GBA Link
                GbaLinkCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return !el.call('isFirmPage') && e && e.gbaProfileUrl;
                    },
                    flow: 'x',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    theme: 'card',
                    align: 'center space-between',
                    GbaLabel: {
                        text: 'Georgian Bar Association Profile',
                        fontSize: 'Z',
                        opacity: '0.7'
                    },
                    GbaLink: {
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.gbaProfileUrl : '#';
                        },
                        attr: {
                            target: '_blank'
                        },
                        text: 'View on GBA \u2192',
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        textDecoration: 'none'
                    }
                }
            },
            // === RIGHT COLUMN ===
            RightCol: {
                width: 'G1',
                flexShrink: '0',
                flow: 'y',
                gap: 'A',
                '@mobileL': {
                    width: '100%'
                },
                // Actions (lawyer)
                ActionsCard: {
                    show: (el, s)=>!el.call('isFirmPage'),
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    theme: 'card',
                    BookBtn: {
                        extends: 'Link',
                        href: '/bookings/public',
                        text: '{{ bookConsultation | polyglot }}',
                        theme: 'primary',
                        fontWeight: '600',
                        padding: 'Z1 C',
                        round: 'Z',
                        fontSize: 'Z',
                        width: '100%',
                        textDecoration: 'none',
                        textAlign: 'center',
                        transition: 'all 0.2s ease',
                        ':hover': {
                            opacity: '0.9'
                        }
                    },
                    MessageBtn: {
                        show: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.email;
                        },
                        tag: 'button',
                        text: '{{ sendMessage | polyglot }}',
                        theme: 'ghost',
                        fontWeight: '600',
                        padding: 'Z1 C',
                        round: 'Z',
                        fontSize: 'Z',
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    },
                    CallBtn: {
                        show: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.phone;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#';
                        },
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.phone ? '{{ call | polyglot }} ' + e.phone : '';
                        },
                        theme: 'ghostTeal',
                        fontWeight: '600',
                        padding: 'Z1 C',
                        round: 'Z',
                        fontSize: 'Z',
                        width: '100%',
                        textDecoration: 'none',
                        textAlign: 'center',
                        transition: 'all 0.2s ease'
                    }
                },
                // Contact (firm)
                ContactCard: {
                    show: (el, s)=>el.call('isFirmPage'),
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    theme: 'card',
                    ContactTitle: {
                        tag: 'h3',
                        text: '{{ contact | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    ContactPhone: {
                        if: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.phone;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.phone ? 'tel:' + e.phone.replace(/\s/g, '') : '#';
                        },
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.phone : '';
                        },
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        textDecoration: 'none'
                    },
                    ContactEmail: {
                        if: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.email;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.email ? 'mailto:' + e.email : '#';
                        },
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.email : '';
                        },
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        textDecoration: 'none'
                    },
                    ContactAddress: {
                        text: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.address : '';
                        },
                        fontSize: 'Z',
                        opacity: '0.6',
                        lineHeight: '1.5'
                    }
                },
                // Reviews (shared)
                ReviewsCard: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    theme: 'card',
                    ReviewTitle: {
                        text: '{{ reviewsRatings | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    ReviewPlaceholder: {
                        text: '{{ reviewsComingSoon | polyglot }}',
                        fontSize: 'Z',
                        opacity: '0.5',
                        lineHeight: '1.5'
                    }
                },
                // Links (lawyer)
                LinksCard: {
                    show: (el, s)=>{
                        const e = el.call('getEntity');
                        return e && (e.website || e.linkedin || e.gbaProfileUrl);
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    theme: 'card',
                    LinksTitle: {
                        text: 'Links',
                        fontSize: 'A',
                        fontWeight: '700'
                    },
                    WebsiteLink: {
                        show: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.website;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.website : '#';
                        },
                        attr: {
                            target: '_blank'
                        },
                        flow: 'x',
                        gap: 'W',
                        align: 'center flex-start',
                        textDecoration: 'none',
                        WebIcon: {
                            extends: 'Icon',
                            icon: 'externalLink',
                            width: 'Z',
                            height: 'Z',
                            opacity: '0.5'
                        },
                        WebLabel: {
                            text: '{{ website | polyglot }}',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '500'
                        }
                    },
                    LinkedinLink: {
                        show: (el, s)=>{
                            const e = el.call('getEntity');
                            return e && e.linkedin;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.linkedin : '#';
                        },
                        attr: {
                            target: '_blank'
                        },
                        flow: 'x',
                        gap: 'W',
                        align: 'center flex-start',
                        textDecoration: 'none',
                        LiIcon: {
                            extends: 'Icon',
                            icon: 'externalLink',
                            width: 'Z',
                            height: 'Z',
                            opacity: '0.5'
                        },
                        LiLabel: {
                            text: 'LinkedIn',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '500'
                        }
                    },
                    GbaLink2: {
                        show: (el, s)=>{
                            const e = el.call('getEntity');
                            return !el.call('isFirmPage') && e && e.gbaProfileUrl;
                        },
                        extends: 'Link',
                        href: (el, s)=>{
                            const e = el.call('getEntity');
                            return e ? e.gbaProfileUrl : '#';
                        },
                        attr: {
                            target: '_blank'
                        },
                        flow: 'x',
                        gap: 'W',
                        align: 'center flex-start',
                        textDecoration: 'none',
                        GbaIcon: {
                            extends: 'Icon',
                            icon: 'externalLink',
                            width: 'Z',
                            height: 'Z',
                            opacity: '0.5'
                        },
                        GbaLabel2: {
                            text: 'GBA Profile',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '500'
                        }
                    }
                }
            }
        }
    },
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'C',
        padding: 'D 0',
        borderTop: '1px solid surfaceBorderStrong',
        maxWidth: 'K',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'C A'
        },
        FooterTop: {
            flow: 'x',
            gap: 'C',
            '@mobileL': {
                flow: 'y',
                gap: 'B'
            },
            FooterBrand: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                minWidth: 'F',
                FooterLogo: {
                    extends: 'Link',
                    href: '/',
                    text: 'TrustLegal',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'green',
                    textDecoration: 'none'
                },
                FooterTagline: {
                    text: '{{ footerTagline | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.6'
                }
            },
            FooterLinks: {
                flow: 'x',
                gap: 'C',
                flex: '2',
                '@mobileL': {
                    flow: 'y',
                    gap: 'B'
                },
                FooterCol1: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ productLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/bookings',
                        text: '{{ bookingsLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/cases',
                        text: '{{ casesLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink3: {
                        extends: 'Link',
                        href: '/lawyers',
                        text: '{{ lawyersNav | polyglot }}',
                        fontSize: 'Z',
                        color: 'green',
                        textDecoration: 'none',
                        fontWeight: '500'
                    }
                },
                FooterCol2: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ companyLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ aboutUs | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ careers | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                }
            }
        },
        FooterBottom: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            '@mobileL': {
                flow: 'y',
                gap: 'Z',
                align: 'center center'
            },
            CopyText: {
                text: '{{ copyrightText | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            },
            BuiltWith: {
                text: '{{ builtWith | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            }
        }
    }
};


const $8f52cbf804c46fad$export$530dccc8e24f4e99 = {
    extends: 'Page',
    flow: 'y',
    theme: 'document',
    height: '100vh',
    overflow: 'hidden',
    LawyersData: {
        fetch: {
            from: 'lawyers',
            order: {
                by: 'info_score',
                asc: false
            },
            limit: 50,
            cache: '5m',
            keepPreviousData: true,
            transform: (data, el)=>{
                const lawyers = (data || []).map((d)=>el.call('mapLawyer', d));
                const root = el.state.root || el.state;
                if (root && root.update) root.update({
                    lawyers: lawyers,
                    lawyersLoaded: true
                }, {
                    preventFetch: true
                });
                return lawyers;
            }
        },
        display: 'none'
    },
    FirmsData: {
        fetch: {
            from: 'law_firms',
            order: {
                by: 'name_en',
                asc: true
            },
            limit: 50,
            cache: '5m',
            keepPreviousData: true,
            transform: (data, el)=>{
                const firms = (data || []).map((d)=>el.call('mapFirm', d));
                const root = el.state.root || el.state;
                if (root && root.update) root.update({
                    firms: firms,
                    firmsLoaded: true
                }, {
                    preventFetch: true
                });
                return firms;
            }
        },
        display: 'none'
    },
    LandingNav: {},
    ChatLayout: {
        flow: 'y',
        flex: '1',
        overflow: 'hidden',
        paddingTop: 'D',
        WelcomeMsg: {
            show: (el, s)=>!(s.root.chatMessages || []).length && !s.root.chatTyping,
            flow: 'y',
            align: 'center center',
            gap: 'A',
            padding: 'D B',
            textAlign: 'center',
            flex: '1',
            WelcomeIcon: {
                text: '\u2696\uFE0F',
                fontSize: 'G'
            },
            WelcomeTitle: {
                tag: 'h2',
                text: 'Legal Assistant',
                fontSize: 'D',
                fontWeight: '700',
                letterSpacing: '-0.02em'
            },
            WelcomeSub: {
                text: 'Ask about Georgian law, legal procedures, or find a lawyer',
                fontSize: 'B',
                opacity: '0.5',
                maxWidth: 'H'
            },
            Suggestions: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                align: 'center center',
                marginTop: 'A',
                children: [
                    {
                        label: '\uD83D\uDCDC How to file a civil lawsuit in Georgia?'
                    },
                    {
                        label: '\uD83C\uDFE0 Real estate purchase process for foreigners'
                    },
                    {
                        label: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67 Divorce and child custody laws'
                    },
                    {
                        label: '\uD83C\uDFE2 Starting a business in Georgia'
                    }
                ],
                childrenAs: 'state',
                childProps: {
                    tag: 'button',
                    text: (el, s)=>s.label,
                    padding: 'Z A',
                    round: 'Z',
                    fontSize: 'A',
                    cursor: 'pointer',
                    border: 'none',
                    theme: 'ghost',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        theme: 'secondary'
                    },
                    onClick: (e, el, s)=>{
                        const msg = s.label.replace(/^[\uD800-\uDBFF][\uDC00-\uDFFF]\s*/, '');
                        el.call('triggerChat', msg);
                    }
                }
            }
        },
        ThreadBody: {
            show: (el, s)=>(s.root.chatMessages || []).length > 0 || s.root.chatTyping,
            flex: '1',
            flow: 'y',
            gap: 'A',
            padding: 'B C',
            overflow: 'auto',
            maxWidth: '1680px',
            width: '100%',
            margin: '0 auto',
            '@mobileL': {
                padding: 'A'
            },
            children: (el, s)=>{
                return (s.root.chatMessages || []).map((m)=>{
                    const entry = {
                        role: m.role,
                        content: m.content
                    };
                    if (m.role === 'assistant') {
                        entry.cleanContent = m.content;
                        entry.sourceLinks = el.call('parseChatLinks', m.content);
                        if (m.recommended) entry.recommended = m.recommended;
                    }
                    return entry;
                });
            },
            childrenAs: 'state',
            childProps: {
                flow: 'y',
                gap: 'Z',
                maxWidth: 'J',
                width: '100%',
                margin: '0 auto',
                MsgBubble: {
                    padding: 'A B',
                    round: 'A',
                    background: (el, s)=>s.role === 'user' ? 'greenBg' : 'surfaceCard',
                    border: (el, s)=>s.role === 'user' ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
                    alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
                    maxWidth: '85%',
                    RoleLabel: {
                        text: (el, s)=>s.role === 'user' ? 'You' : '\u2696\uFE0F Legal Assistant',
                        fontSize: 'Z',
                        fontWeight: '600',
                        opacity: '0.6',
                        marginBottom: 'Y'
                    },
                    MsgText: {
                        tag: 'div',
                        html: (el, s)=>el.call('formatChatHtml', s.role === 'user' ? s.content : s.cleanContent || s.content),
                        fontSize: 'A',
                        lineHeight: '1.7'
                    },
                    SourceLinks: {
                        show: (el, s)=>s.role === 'assistant' && s.sourceLinks && s.sourceLinks.length > 0,
                        flow: 'x',
                        gap: 'Y',
                        flexWrap: 'wrap',
                        marginTop: 'Y',
                        padding: 'Y 0 0 0',
                        borderTop: '1px solid surfaceBorderStrong',
                        children: (el, s)=>{
                            const seen = new Set();
                            return (s.sourceLinks || []).filter((l)=>{
                                if (seen.has(l.url)) return false;
                                seen.add(l.url);
                                return true;
                            });
                        },
                        childrenAs: 'state',
                        childExtends: 'Link',
                        childProps: {
                            href: (el, s)=>s.url || '#',
                            attr: {
                                target: '_blank'
                            },
                            text: (el, s)=>'\uD83D\uDD17 ' + (s.label || ''),
                            fontSize: 'Z',
                            color: 'green',
                            textDecoration: 'none',
                            padding: 'Y Z',
                            round: 'W',
                            background: 'greenBg',
                            ':hover': {
                                textDecoration: 'underline'
                            }
                        }
                    }
                },
                QuickActions: {
                    show: (el, s)=>s.role === 'assistant' && !s.recommended,
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    marginTop: 'Y',
                    children: [
                        {
                            label: '\uD83D\uDC68\u200D\u2696\uFE0F Find a lawyer',
                            action: 'find_lawyer'
                        },
                        {
                            label: '\uD83D\uDCDE Book consultation',
                            action: 'book'
                        },
                        {
                            label: '\u2753 Ask another question',
                            action: 'ask'
                        }
                    ],
                    childrenAs: 'state',
                    childProps: {
                        tag: 'button',
                        text: (el, s)=>s.label,
                        padding: 'Z A',
                        round: 'Z',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none',
                        theme: 'ghost',
                        transition: 'all 0.2s ease',
                        ':hover': {
                            theme: 'secondary'
                        },
                        onClick: (e, el, s)=>{
                            if (s.action === 'find_lawyer') el.call('triggerChat', 'Find me a lawyer for this');
                            else if (s.action === 'book') window.location.href = '/bookings/public';
                            else {
                                const input = el.lookup('ChatInput');
                                if (input && input.node) input.node.focus();
                            }
                        }
                    }
                },
                RecommendedCards: {
                    show: (el, s)=>s.role === 'assistant' && s.recommended && s.recommended.length > 0,
                    flow: 'y',
                    gap: 'Y',
                    width: '100%',
                    children: (el, s)=>s.recommended || [],
                    childrenAs: 'state',
                    childExtends: 'Link',
                    childProps: {
                        href: (el, s)=>s.id ? (s._cardType === 'firm' ? '/firm' : '/lawyer') + '?slug=' + (s.slug || s.id) : '#',
                        textDecoration: 'none',
                        color: 'inherit',
                        flow: 'x',
                        gap: 'Z',
                        align: 'center flex-start',
                        padding: 'Z A',
                        round: 'Z',
                        theme: 'card',
                        border: '1px solid greenBorder',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        ':hover': {
                            boxShadow: 'black.1 0 Y Z'
                        },
                        CardAvatar: {
                            tag: 'img',
                            width: 'B1',
                            height: 'B1',
                            round: (el, s)=>s._cardType === 'firm' ? 'Y' : 'B1',
                            objectFit: 'cover',
                            flexShrink: '0',
                            attr: {
                                src: (el, s)=>s.photoUrl || s.avatar || s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn || '') + '&background=1a2332&color=c6ac8f&size=64&bold=true&format=svg'
                            }
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'V',
                            flex: '1',
                            minWidth: '0',
                            CardName: {
                                text: (el, s)=>s.nameEn || '',
                                fontSize: 'A',
                                fontWeight: '600'
                            },
                            CardMeta: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                CardCity: {
                                    text: (el, s)=>s.city || '',
                                    fontSize: 'Z',
                                    opacity: '0.6'
                                },
                                CardDot: {
                                    text: '\u00B7',
                                    fontSize: 'Z',
                                    opacity: '0.4'
                                },
                                CardSpec: {
                                    text: (el, s)=>s._cardType === 'firm' ? 'Law Firm' : (s.specializations || []).slice(0, 2).join(', '),
                                    fontSize: 'Z',
                                    opacity: '0.6'
                                }
                            },
                            CardBadge: {
                                show: (el, s)=>s.isSubscribed || s._cardType === 'firm',
                                text: (el, s)=>s._cardType === 'firm' ? '\uD83C\uDFE2 Law Firm' : '\u2605 Verified',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'green',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                            }
                        },
                        CardRating: {
                            show: (el, s)=>s._cardType !== 'firm' && s.rating > 0,
                            flow: 'x',
                            gap: 'W',
                            align: 'center center',
                            flexShrink: '0',
                            RatingStar: {
                                text: '\u2605',
                                fontSize: 'A',
                                color: 'green'
                            },
                            RatingVal: {
                                text: (el, s)=>String(s.rating),
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'green'
                            }
                        }
                    }
                }
            }
        },
        LoadingIndicator: {
            show: (el, s)=>s.root.chatTyping,
            padding: '0 C',
            maxWidth: 'J',
            width: '100%',
            margin: '0 auto',
            '@mobileL': {
                padding: '0 A'
            },
            TypingBubble: {
                padding: 'Z A',
                round: 'A',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                alignSelf: 'flex-start',
                text: '\u2696\uFE0F Thinking...',
                fontSize: 'A',
                opacity: '0.6'
            }
        },
        InputArea: {
            position: 'relative',
            padding: 'A C',
            borderTop: '1px solid surfaceBorderStrong',
            flexShrink: '0',
            maxWidth: '1680px',
            width: '100%',
            margin: '0 auto',
            '@mobileL': {
                padding: 'A'
            },
            ChatInput: {
                tag: 'textarea',
                placeholder: 'Ask about Georgian law...',
                width: '100%',
                padding: 'A',
                round: 'A',
                theme: 'card',
                fontSize: 'A',
                fontFamily: 'inherit',
                outline: 'none',
                resize: 'none',
                height: 'D1',
                lineHeight: '1.5',
                attr: {
                    rows: '4'
                },
                onKeyDown: (e, el, s)=>{
                    if (e.key === 'Enter' && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        const query = el.node.value;
                        if (!query.trim() || s.root.chatTyping) return;
                        el.node.value = '';
                        el.call('triggerChat', query);
                    }
                }
            },
            SendBtn: {
                tag: 'button',
                position: 'absolute',
                top: 'A1',
                right: 'C1',
                width: 'C',
                height: 'C',
                background: 'white',
                color: 'neutral950',
                border: 'none',
                round: '100%',
                cursor: 'pointer',
                align: 'center center',
                transition: 'all 0.2s ease',
                boxShadow: 'black.08 0 V Y',
                ':hover': {
                    background: 'green',
                    color: 'neutral950'
                },
                text: '\u2303',
                '@mobileL': {
                    right: 'A1'
                },
                onClick: (e, el, s)=>{
                    const input = el.lookup('ChatInput');
                    const query = input && input.node ? input.node.value : '';
                    if (!query.trim() || s.root.chatTyping) return;
                    input.node.value = '';
                    el.call('triggerChat', query);
                }
            }
        }
    }
};


const $3fe186eedbfa7296$export$644af75de1860b4e = {
    extends: 'Page',
    flow: 'y',
    background: 'surface',
    LandingNav: {},
    // ═══════════════════════════════════════════════════
    // HERO — simple, lawyer-focused
    // ═══════════════════════════════════════════════════
    HeroSection: {
        tag: 'section',
        flow: 'y',
        align: 'center',
        gap: 'B',
        padding: 'F D E D',
        minHeight: '60vh',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@tabletS': {
            padding: 'E B D B'
        },
        '@mobileL': {
            padding: 'D A C A'
        },
        HeroLabel: {
            text: 'FOR LAWYERS',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'green',
            textTransform: 'uppercase',
            letterSpacing: '2px'
        },
        HeroTitle: {
            tag: 'h1',
            flow: 'y',
            gap: '0',
            align: 'center',
            TitleLine1: {
                text: 'Your practice.',
                fontSize: 'C1',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            TitleLine2: {
                text: 'Your clients.',
                fontSize: 'C1',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            TitleLine3: {
                text: 'One platform.',
                fontSize: 'C1',
                fontWeight: '700',
                color: 'green',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            }
        },
        HeroDesc: {
            text: "Everything a modern lawyer needs \u2014 bookings, case management, AI-drafted documents, invoicing, and a client portal \u2014 in one clean dashboard.",
            fontSize: 'A',
            color: 'textMuted',
            lineHeight: '1.6',
            maxWidth: 'J',
            textAlign: 'center'
        },
        HeroCtas: {
            flow: 'x',
            gap: 'A',
            align: 'center center',
            '@mobileL': {
                flow: 'y',
                width: '100%'
            },
            TrialLink: {
                extends: 'Link',
                href: '/login',
                text: 'Start free trial',
                background: 'green',
                color: 'neutral950',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '600',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                '@mobileL': {
                    width: '100%',
                    textAlign: 'center'
                }
            },
            DemoLink: {
                extends: 'Link',
                href: '/dashboard',
                text: 'See live demo',
                background: 'transparent',
                color: 'text',
                border: '1px solid surfaceBorderStrong',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '500',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: true
                    }),
                '@mobileL': {
                    width: '100%',
                    textAlign: 'center'
                }
            }
        },
        HeroStats: {
            flow: 'x',
            gap: 'C',
            align: 'center center',
            padding: 'B 0 0 0',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            Stat1: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '500+',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Lawyers active',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            },
            StatDiv1: {
                width: '1px',
                height: 'B',
                background: 'surfaceBorderStrong',
                '@mobileL': {
                    display: 'none'
                }
            },
            Stat2: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '12k+',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Cases managed',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            },
            StatDiv2: {
                width: '1px',
                height: 'B',
                background: 'surfaceBorderStrong',
                '@mobileL': {
                    display: 'none'
                }
            },
            Stat3: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '98%',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Satisfaction rate',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // HOW IT WORKS
    // ═══════════════════════════════════════════════════
    HowSection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        background: 'neutral50',
        color: 'neutral900',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        HowHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HowTitle: {
                tag: 'h2',
                text: '{{ howItWorks | polyglot }}',
                fontSize: 'D',
                fontWeight: '700',
                color: 'neutral900',
                lineHeight: '1.1',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            HowLabel: {
                text: '{{ processLabel | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        HowSteps: {
            flow: 'x',
            gap: 'D',
            '@mobileL': {
                flow: 'y',
                gap: 'C'
            },
            StepsList: {
                flow: 'y',
                gap: 'B',
                flex: '1',
                Step1: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            flActiveStep: 1
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1 ? 'green' : 'transparent',
                            border: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '01',
                            fontSize: 'Y',
                            color: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: '{{ step1Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: '{{ step1Desc | polyglot }}',
                            fontSize: 'Z',
                            color: 'neutral500',
                            lineHeight: '1.6'
                        }
                    }
                },
                Step2: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>s.root.flActiveStep === 2 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            flActiveStep: 2
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>s.root.flActiveStep === 2 ? 'green' : 'transparent',
                            border: (el, s)=>s.root.flActiveStep === 2 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '02',
                            fontSize: 'Y',
                            color: (el, s)=>s.root.flActiveStep === 2 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: '{{ step2Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>s.root.flActiveStep === 2 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: '{{ step2Desc | polyglot }}',
                            fontSize: 'Z',
                            color: 'neutral400',
                            lineHeight: '1.6'
                        }
                    }
                },
                Step3: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>s.root.flActiveStep === 3 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            flActiveStep: 3
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>s.root.flActiveStep === 3 ? 'green' : 'transparent',
                            border: (el, s)=>s.root.flActiveStep === 3 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '03',
                            fontSize: 'Y',
                            color: (el, s)=>s.root.flActiveStep === 3 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: '{{ step3Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>s.root.flActiveStep === 3 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: '{{ step3Desc | polyglot }}',
                            fontSize: 'Z',
                            color: 'neutral400',
                            lineHeight: '1.6'
                        }
                    }
                },
                Step4: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>s.root.flActiveStep === 4 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            flActiveStep: 4
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>s.root.flActiveStep === 4 ? 'green' : 'transparent',
                            border: (el, s)=>s.root.flActiveStep === 4 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '04',
                            fontSize: 'Y',
                            color: (el, s)=>s.root.flActiveStep === 4 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: '{{ step4Title | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>s.root.flActiveStep === 4 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: '{{ step4Desc | polyglot }}',
                            fontSize: 'Z',
                            color: 'neutral400',
                            lineHeight: '1.6'
                        }
                    }
                }
            },
            StepsDemo: {
                flow: 'y',
                flex: '1',
                background: 'neutral900',
                borderRadius: 'Z',
                padding: 'B',
                gap: 'A',
                transition: 'opacity 300ms',
                '@mobileL': {
                    display: 'none'
                },
                Demo1: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>!s.root.flActiveStep || s.root.flActiveStep === 1,
                    DemoLabel: {
                        text: '{{ demoBadge | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: '{{ todaysBookings | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockTime: {
                            text: '10:00',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockTime: {
                            text: '11:30',
                            fontSize: 'Z',
                            color: 'neutral400'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockTime: {
                            text: '14:00',
                            fontSize: 'Z',
                            color: 'neutral400'
                        }
                    }
                },
                Demo2: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.flActiveStep === 2,
                    DemoLabel: {
                        text: "// \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "#2024-047 \u2014 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "#2024-046 \u2014 \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
                            fontSize: 'Y',
                            color: 'amber',
                            fontWeight: '600'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: "#2024-045 \u2014 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8",
                            fontSize: 'Y',
                            color: 'neutral400'
                        }
                    }
                },
                Demo3: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.flActiveStep === 3,
                    DemoLabel: {
                        text: '// AI',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\uD83D\uDCC4 \u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u2014 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u2713",
                            fontSize: 'Z',
                            color: 'green'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\uD83D\uDCC4 \u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 \u2014 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u2713",
                            fontSize: 'Z',
                            color: 'green'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: "\uD83D\uDD0D OCR \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0 \u2014 98.5%",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: "\u2713",
                            fontSize: 'Z',
                            color: 'green'
                        }
                    }
                },
                Demo4: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.flActiveStep === 4,
                    DemoLabel: {
                        text: "// \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: "\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\u10E1\u10E3\u10DA \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockVal: {
                            text: "\u20BE3,640",
                            fontSize: 'Z',
                            color: 'neutral50',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockVal: {
                            text: "\u20BE2,440",
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8",
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockVal: {
                            text: "\u20BE1,200",
                            fontSize: 'Z',
                            color: 'amber',
                            fontWeight: '600'
                        }
                    }
                },
                DemoCta: {
                    extends: 'Link',
                    href: '/dashboard',
                    text: '{{ fullDemo | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    padding: 'Z A',
                    fontSize: 'Y',
                    fontWeight: '600',
                    borderRadius: '0',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    textAlign: 'center',
                    onClick: (e, el, s)=>s.root.update({
                            loggedIn: true
                        })
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // FEATURES — three columns
    // ═══════════════════════════════════════════════════
    FeaturesSection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        FeaturesHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            FeaturesTitle: {
                tag: 'h2',
                text: '{{ onePlatformThreePillars | polyglot }}',
                fontSize: 'D',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                whiteSpace: 'pre-wrap',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            FeaturesLabel: {
                text: '{{ capabilitiesLabel | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        FeaturesRow: {
            flow: 'x',
            gap: 'A',
            '@mobileL': {
                flow: 'y'
            },
            FeatureBooking: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '01',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: '{{ bookingFeature | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: '{{ bookingFeatureDesc | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            },
            FeatureOps: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '02',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: '{{ operationsFeature | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: '{{ operationsFeatureDesc | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            },
            FeatureAI: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '03',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: '{{ aiFeature | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: '{{ aiFeatureDesc | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // PRICING
    // ═══════════════════════════════════════════════════
    PricingSection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        background: 'neutral50',
        color: 'neutral900',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        PricingHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            PricingTitle: {
                tag: 'h2',
                text: '{{ simplePricing | polyglot }}',
                fontSize: 'D',
                fontWeight: '700',
                color: 'neutral900',
                lineHeight: '1.1',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            PricingLabel: {
                text: '{{ plansLabel | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        PricingRow: {
            flow: 'x',
            gap: 'A',
            '@mobileL': {
                flow: 'y'
            },
            PriceTier1: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'neutral900',
                color: 'neutral50',
                borderRadius: 'Z',
                PriceAmount: {
                    text: "\u20BE15",
                    fontSize: 'C',
                    fontWeight: '300',
                    color: 'neutral50',
                    lineHeight: '1'
                },
                PricePeriod: {
                    text: '{{ perMonth | polyglot }}',
                    fontSize: 'Z',
                    color: 'neutral400'
                },
                PriceFeatures: {
                    flow: 'y',
                    gap: '0',
                    padding: 'A 0 0 0',
                    PriceFeat1: {
                        text: '{{ bookingMgmt | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat2: {
                        text: '{{ caseTracking | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat3: {
                        text: '{{ calendarSync | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat4: {
                        text: '{{ emailReminders | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0'
                    }
                },
                PriceLabel: {
                    text: '{{ starterPlan | polyglot }}',
                    fontSize: 'Y',
                    color: 'neutral400',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    padding: 'A 0 0 0'
                },
                PriceCta: {
                    extends: 'Link',
                    href: '/login',
                    text: '{{ startNow | polyglot }}',
                    background: 'neutral50',
                    color: 'neutral900',
                    padding: 'Z A',
                    fontSize: 'Y',
                    fontWeight: '600',
                    textDecoration: 'none',
                    textAlign: 'center',
                    width: '100%'
                }
            },
            PriceTier2: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'neutral900',
                color: 'neutral50',
                borderRadius: 'Z',
                border: '2px solid green',
                PriceAmount: {
                    text: "\u20BE75",
                    fontSize: 'C',
                    fontWeight: '300',
                    color: 'green',
                    lineHeight: '1'
                },
                PricePeriod: {
                    text: '{{ perMonth | polyglot }}',
                    fontSize: 'Z',
                    color: 'neutral400'
                },
                PriceFeatures: {
                    flow: 'y',
                    gap: '0',
                    padding: 'A 0 0 0',
                    PriceFeat1: {
                        text: '{{ everythingStarter | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat2: {
                        text: '{{ aiDocDrafting | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat3: {
                        text: '{{ invoicesPayments | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat4: {
                        text: '{{ clientPortalFeature | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat5: {
                        text: '{{ directSupport | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0'
                    }
                },
                PriceLabel: {
                    text: '{{ professionalPlan | polyglot }}',
                    fontSize: 'Y',
                    color: 'neutral400',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    padding: 'A 0 0 0'
                },
                PriceAvail: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    AvailDot: {
                        width: 'Z',
                        height: 'Z',
                        background: 'green'
                    },
                    AvailText: {
                        text: '{{ mostPopular | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }
                },
                PriceCta: {
                    extends: 'Link',
                    href: '/login',
                    text: '{{ startNow | polyglot }}',
                    background: 'green',
                    color: 'neutral950',
                    padding: 'Z A',
                    fontSize: 'Y',
                    fontWeight: '600',
                    textDecoration: 'none',
                    textAlign: 'center',
                    width: '100%'
                }
            },
            PriceTier3: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'neutral900',
                color: 'neutral50',
                borderRadius: 'Z',
                PriceAmount: {
                    text: "\u20BE299",
                    fontSize: 'C',
                    fontWeight: '300',
                    color: 'neutral50',
                    lineHeight: '1'
                },
                PricePeriod: {
                    text: '{{ perMonth | polyglot }}',
                    fontSize: 'Z',
                    color: 'neutral400'
                },
                PriceFeatures: {
                    flow: 'y',
                    gap: '0',
                    padding: 'A 0 0 0',
                    PriceFeat1: {
                        text: '{{ everythingPro | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat2: {
                        text: '{{ teamMgmt10 | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat3: {
                        text: '{{ contractAnalysis | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat4: {
                        text: '{{ advancedAnalytics | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0',
                        borderBottom: '1px solid neutral700'
                    },
                    PriceFeat5: {
                        text: '{{ personalOnboarding | polyglot }}',
                        fontSize: 'Z',
                        color: 'neutral300',
                        padding: 'Z 0'
                    }
                },
                PriceLabel: {
                    text: '{{ businessPlan | polyglot }}',
                    fontSize: 'Y',
                    color: 'neutral400',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    padding: 'A 0 0 0'
                },
                PriceAvail: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center',
                    AvailDot: {
                        width: 'Z',
                        height: 'Z',
                        background: 'green'
                    },
                    AvailText: {
                        text: '{{ spotsLeft | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }
                },
                PriceCta: {
                    extends: 'Link',
                    href: '/login',
                    text: '{{ startNow | polyglot }}',
                    background: 'neutral50',
                    color: 'neutral900',
                    padding: 'Z A',
                    fontSize: 'Y',
                    fontWeight: '600',
                    textDecoration: 'none',
                    textAlign: 'center',
                    width: '100%'
                }
            }
        },
        PricingNote: {
            text: '{{ enterpriseNote | polyglot }}',
            fontSize: 'Z',
            color: 'neutral500',
            textAlign: 'center',
            padding: 'A 0 0 0'
        }
    },
    // ═══════════════════════════════════════════════════
    // CTA
    // ═══════════════════════════════════════════════════
    CtaBanner: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        padding: 'F D',
        gap: 'B',
        textAlign: 'center',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        CtaTitle: {
            tag: 'h2',
            text: '{{ readyQuestion | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            color: 'text',
            '@mobileL': {
                fontSize: 'C'
            }
        },
        CtaSub: {
            text: '{{ first30DaysFree | polyglot }}',
            fontSize: 'A',
            color: 'textMuted',
            maxWidth: 'H'
        },
        CtaCtas: {
            flow: 'x',
            gap: 'A',
            align: 'center',
            CtaBtn: {
                extends: 'Link',
                href: '/login',
                text: '{{ tryFree | polyglot }}',
                background: 'green',
                color: 'neutral950',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '600',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                }
            },
            DemoBtn: {
                extends: 'Link',
                href: '/dashboard',
                text: '{{ liveDemo | polyglot }}',
                background: 'transparent',
                color: 'text',
                border: '1px solid surfaceBorderStrong',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '500',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                onClick: (e, el, s)=>s.root.update({
                        loggedIn: true
                    })
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // FOOTER
    // ═══════════════════════════════════════════════════
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'C',
        padding: 'D 0',
        borderTop: '1px solid surfaceBorderStrong',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'C A'
        },
        FooterTop: {
            flow: 'x',
            gap: 'C',
            '@mobileL': {
                flow: 'y',
                gap: 'B'
            },
            FooterBrand: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                minWidth: 'F',
                FooterLogo: {
                    extends: 'Link',
                    href: '/',
                    text: 'TrustLegal',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'green',
                    textDecoration: 'none'
                },
                FooterTagline: {
                    text: '{{ footerTagline | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.6'
                }
            },
            FooterLinks: {
                flow: 'x',
                gap: 'C',
                flex: '2',
                '@mobileL': {
                    flow: 'y',
                    gap: 'B'
                },
                FooterCol1: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ productLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/bookings',
                        text: '{{ bookingsLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/cases',
                        text: '{{ casesLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    },
                    ColLink3: {
                        extends: 'Link',
                        href: '/documents',
                        text: '{{ aiDocsLink | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                loggedIn: true
                            })
                    }
                },
                FooterCol2: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ companyLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ aboutUs | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ careers | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                }
            }
        },
        FooterBottom: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            '@mobileL': {
                flow: 'y',
                gap: 'Z',
                align: 'center center'
            },
            CopyText: {
                text: '{{ copyrightText | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            },
            BuiltWith: {
                text: '{{ builtWith | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            }
        }
    }
};


const $98bd3005b685f12f$export$b4534344d84894c3 = {
    extends: 'Page',
    flow: 'y',
    background: 'surface',
    LandingNav: {},
    // ═══════════════════════════════════════════════════
    // HERO
    // ═══════════════════════════════════════════════════
    HeroSection: {
        tag: 'section',
        flow: 'y',
        align: 'center',
        gap: 'B',
        padding: 'F D E D',
        minHeight: '60vh',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@tabletS': {
            padding: 'E B D B'
        },
        '@mobileL': {
            padding: 'D A C A'
        },
        HeroLabel: {
            text: 'FOR CLIENTS',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'green',
            textTransform: 'uppercase',
            letterSpacing: '2px'
        },
        HeroTitle: {
            tag: 'h1',
            flow: 'y',
            gap: '0',
            align: 'center',
            TitleLine1: {
                text: 'Find the right lawyer.',
                fontSize: 'C1',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            TitleLine2: {
                text: 'Book in seconds.',
                fontSize: 'C1',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            TitleLine3: {
                text: 'Stay in control.',
                fontSize: 'C1',
                fontWeight: '700',
                color: 'green',
                lineHeight: '1.15',
                letterSpacing: '-1px',
                textAlign: 'center',
                '@mobileL': {
                    fontSize: 'C'
                }
            }
        },
        HeroDesc: {
            text: "Search verified lawyers by specialty, book consultations online, track your case progress, and communicate securely \u2014 all from one place.",
            fontSize: 'A',
            color: 'textMuted',
            lineHeight: '1.6',
            maxWidth: 'J',
            textAlign: 'center'
        },
        HeroCtas: {
            flow: 'x',
            gap: 'A',
            align: 'center center',
            '@mobileL': {
                flow: 'y',
                width: '100%'
            },
            FindLink: {
                extends: 'Link',
                href: '/lawyers',
                text: 'Find a Lawyer',
                background: 'green',
                color: 'neutral950',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '600',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                '@mobileL': {
                    width: '100%',
                    textAlign: 'center'
                }
            },
            PortalLink: {
                extends: 'Link',
                href: '/client-dashboard',
                text: 'Client Portal Demo',
                background: 'transparent',
                color: 'text',
                border: '1px solid surfaceBorderStrong',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '500',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                },
                '@mobileL': {
                    width: '100%',
                    textAlign: 'center'
                }
            }
        },
        HeroStats: {
            flow: 'x',
            gap: 'C',
            align: 'center center',
            padding: 'B 0 0 0',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            Stat1: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '5,700+',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Verified lawyers',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            },
            StatDiv1: {
                width: '1px',
                height: 'B',
                background: 'surfaceBorderStrong',
                '@mobileL': {
                    display: 'none'
                }
            },
            Stat2: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '300+',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Law firms',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            },
            StatDiv2: {
                width: '1px',
                height: 'B',
                background: 'surfaceBorderStrong',
                '@mobileL': {
                    display: 'none'
                }
            },
            Stat3: {
                flow: 'y',
                gap: 'Y',
                align: 'center',
                StatNum: {
                    text: '100%',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'green',
                    lineHeight: '1'
                },
                StatLabel: {
                    text: 'Free for clients',
                    fontSize: 'Y',
                    color: 'textMuted'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // HOW IT WORKS
    // ═══════════════════════════════════════════════════
    HowSection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        background: 'neutral50',
        color: 'neutral900',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        HowHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            HowTitle: {
                tag: 'h2',
                text: 'How it works',
                fontSize: 'D',
                fontWeight: '700',
                color: 'neutral900',
                lineHeight: '1.1',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            HowLabel: {
                text: 'SIMPLE PROCESS',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        HowSteps: {
            flow: 'x',
            gap: 'D',
            '@mobileL': {
                flow: 'y',
                gap: 'C'
            },
            StepsList: {
                flow: 'y',
                gap: 'B',
                flex: '1',
                Step1: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            fcActiveStep: 1
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1 ? 'green' : 'transparent',
                            border: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '01',
                            fontSize: 'Y',
                            color: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: 'Search & Filter',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: 'Browse 5,700+ lawyers by specialty, city, language, and rating. Every profile is verified through the Georgian Bar Association.',
                            fontSize: 'Z',
                            color: 'neutral500',
                            lineHeight: '1.6'
                        }
                    }
                },
                Step2: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>s.root.fcActiveStep === 2 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            fcActiveStep: 2
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>s.root.fcActiveStep === 2 ? 'green' : 'transparent',
                            border: (el, s)=>s.root.fcActiveStep === 2 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '02',
                            fontSize: 'Y',
                            color: (el, s)=>s.root.fcActiveStep === 2 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: 'Book a Consultation',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>s.root.fcActiveStep === 2 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: "Pick a time that works for you. No phone calls needed \u2014 book online in seconds and receive instant confirmation.",
                            fontSize: 'Z',
                            color: 'neutral500',
                            lineHeight: '1.6'
                        }
                    }
                },
                Step3: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start',
                    cursor: 'pointer',
                    transition: 'opacity 150ms',
                    opacity: (el, s)=>s.root.fcActiveStep === 3 ? '1' : '.5',
                    onClick: (e, el, s)=>s.root.update({
                            fcActiveStep: 3
                        }),
                    StepMarker: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        StepDot: {
                            width: 'Z',
                            height: 'Z',
                            background: (el, s)=>s.root.fcActiveStep === 3 ? 'green' : 'transparent',
                            border: (el, s)=>s.root.fcActiveStep === 3 ? 'none' : '1px solid neutral300'
                        },
                        StepNum: {
                            text: '03',
                            fontSize: 'Y',
                            color: (el, s)=>s.root.fcActiveStep === 3 ? 'neutral500' : 'neutral400',
                            fontFamily: 'monospace'
                        }
                    },
                    StepContent: {
                        flow: 'y',
                        gap: 'Y',
                        StepTitle: {
                            text: 'Track Your Case',
                            fontSize: 'A',
                            fontWeight: '600',
                            color: (el, s)=>s.root.fcActiveStep === 3 ? 'neutral900' : 'neutral500'
                        },
                        StepDesc: {
                            text: 'Follow your case progress in real time through your personal client portal. Get updates, share documents, and message your lawyer directly.',
                            fontSize: 'Z',
                            color: 'neutral500',
                            lineHeight: '1.6'
                        }
                    }
                }
            },
            StepsDemo: {
                flow: 'y',
                flex: '1',
                background: 'neutral900',
                borderRadius: 'Z',
                padding: 'B',
                gap: 'A',
                transition: 'opacity 300ms',
                '@mobileL': {
                    display: 'none'
                },
                Demo1: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>!s.root.fcActiveStep || s.root.fcActiveStep === 1,
                    DemoLabel: {
                        text: '// DIRECTORY',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: "Corporate Law \u2014 Tbilisi",
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: 'Giorgi Beridze',
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockRating: {
                            text: '4.9 / 87 reviews',
                            fontSize: 'Z',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: 'Ana Maisuradze',
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockRating: {
                            text: '4.9 / 102 reviews',
                            fontSize: 'Z',
                            color: 'neutral400'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: 'Irakli Lomidze',
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockRating: {
                            text: '4.7 / 49 reviews',
                            fontSize: 'Z',
                            color: 'neutral400'
                        }
                    }
                },
                Demo2: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.fcActiveStep === 2,
                    DemoLabel: {
                        text: '// BOOKING',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: 'Select a time slot',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "Mon, Mar 24 \u2014 10:00",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: 'Available',
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: "Mon, Mar 24 \u2014 14:00",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: 'Available',
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: "Tue, Mar 25 \u2014 11:00",
                            fontSize: 'Z',
                            color: 'neutral50'
                        },
                        MockStatus: {
                            text: 'Available',
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    }
                },
                Demo3: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.fcActiveStep === 3,
                    DemoLabel: {
                        text: '// CLIENT PORTAL',
                        fontSize: 'Y',
                        color: 'green',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    },
                    DemoMockTitle: {
                        text: 'Case #2024-047',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'neutral50'
                    },
                    DemoMock1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: 'Status',
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockStatus: {
                            text: 'In Progress',
                            fontSize: 'Y',
                            color: 'green',
                            fontWeight: '600'
                        }
                    },
                    DemoMock2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        borderBottom: '1px solid neutral700',
                        MockName: {
                            text: 'Next hearing',
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockStatus: {
                            text: 'Apr 2, 2026',
                            fontSize: 'Y',
                            color: 'neutral50',
                            fontWeight: '600'
                        }
                    },
                    DemoMock3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z',
                        MockName: {
                            text: 'Documents shared',
                            fontSize: 'Z',
                            color: 'neutral400'
                        },
                        MockStatus: {
                            text: '4 files',
                            fontSize: 'Y',
                            color: 'neutral50'
                        }
                    }
                },
                DemoCta: {
                    extends: 'Link',
                    href: '/lawyers',
                    text: 'BROWSE DIRECTORY',
                    background: 'green',
                    color: 'neutral950',
                    padding: 'Z A',
                    fontSize: 'Y',
                    fontWeight: '600',
                    borderRadius: '0',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    textAlign: 'center'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // FEATURES
    // ═══════════════════════════════════════════════════
    FeaturesSection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        FeaturesHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            FeaturesTitle: {
                tag: 'h2',
                text: 'Everything you need\nas a client',
                fontSize: 'D',
                fontWeight: '300',
                color: 'text',
                lineHeight: '1.15',
                whiteSpace: 'pre-wrap',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            FeaturesLabel: {
                text: 'FEATURES',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        FeaturesRow: {
            flow: 'x',
            gap: 'A',
            '@mobileL': {
                flow: 'y'
            },
            Feature1: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '01',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: 'Verified Directory',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: 'Every lawyer is cross-referenced with the Georgian Bar Association. See real ratings, specialties, languages, education, and experience.',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            },
            Feature2: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '02',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: 'Online Booking',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: 'Book consultations directly from the lawyer\'s profile. Choose your preferred time, get instant confirmation, and receive reminders before your appointment.',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            },
            Feature3: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                padding: 'B',
                background: 'surfaceCard',
                border: '1px solid surfaceBorderStrong',
                borderRadius: 'Z',
                transition: 'border-color 200ms',
                ':hover': {
                    borderColor: 'green'
                },
                FeatureNum: {
                    text: '03',
                    fontSize: 'Y',
                    color: 'green',
                    fontFamily: 'monospace'
                },
                FeatureName: {
                    tag: 'h3',
                    text: 'Client Portal',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'text'
                },
                FeatureDesc: {
                    text: "Track case progress, exchange documents securely, view invoices, and communicate with your lawyer \u2014 all from your personal dashboard.",
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.7'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // WHY TRUSTLEGAL
    // ═══════════════════════════════════════════════════
    WhySection: {
        tag: 'section',
        flow: 'y',
        gap: 'D',
        padding: 'F D',
        background: 'neutral50',
        color: 'neutral900',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        WhyHeader: {
            flow: 'x',
            align: 'flex-start space-between',
            '@mobileL': {
                flow: 'y',
                gap: 'A'
            },
            WhyTitle: {
                tag: 'h2',
                text: 'Why TrustLegal?',
                fontSize: 'D',
                fontWeight: '700',
                color: 'neutral900',
                lineHeight: '1.1',
                '@mobileL': {
                    fontSize: 'C'
                }
            },
            WhyLabel: {
                text: 'BENEFITS',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'green',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }
        },
        WhyGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'B',
            '@mobileL': {
                gridTemplateColumns: '1fr'
            },
            Benefit1: {
                flow: 'y',
                gap: 'Z',
                padding: 'A',
                BenefitTitle: {
                    text: 'No hidden costs',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'neutral900'
                },
                BenefitDesc: {
                    text: "TrustLegal is completely free for clients. You only pay the lawyer's consultation fee \u2014 no platform commissions.",
                    fontSize: 'Z',
                    color: 'neutral500',
                    lineHeight: '1.6'
                }
            },
            Benefit2: {
                flow: 'y',
                gap: 'Z',
                padding: 'A',
                BenefitTitle: {
                    text: 'Transparent reviews',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'neutral900'
                },
                BenefitDesc: {
                    text: 'Read honest reviews from other clients. Ratings and feedback help you choose with confidence.',
                    fontSize: 'Z',
                    color: 'neutral500',
                    lineHeight: '1.6'
                }
            },
            Benefit3: {
                flow: 'y',
                gap: 'Z',
                padding: 'A',
                BenefitTitle: {
                    text: 'Secure communication',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'neutral900'
                },
                BenefitDesc: {
                    text: 'All messages and documents are encrypted. Your case information stays private between you and your lawyer.',
                    fontSize: 'Z',
                    color: 'neutral500',
                    lineHeight: '1.6'
                }
            },
            Benefit4: {
                flow: 'y',
                gap: 'Z',
                padding: 'A',
                BenefitTitle: {
                    text: 'GBA verified',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'neutral900'
                },
                BenefitDesc: {
                    text: 'Every lawyer on the platform is verified through the Georgian Bar Association database. Know your lawyer is licensed and in good standing.',
                    fontSize: 'Z',
                    color: 'neutral500',
                    lineHeight: '1.6'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // CTA
    // ═══════════════════════════════════════════════════
    CtaBanner: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        padding: 'F D',
        gap: 'B',
        textAlign: 'center',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'D A'
        },
        CtaTitle: {
            tag: 'h2',
            text: 'Need a lawyer?',
            fontSize: 'D',
            fontWeight: '700',
            color: 'text',
            '@mobileL': {
                fontSize: 'C'
            }
        },
        CtaSub: {
            text: "Search by specialty, compare profiles, and book a consultation \u2014 it takes less than a minute.",
            fontSize: 'A',
            color: 'textMuted',
            maxWidth: 'H'
        },
        CtaCtas: {
            flow: 'x',
            gap: 'A',
            align: 'center',
            FindBtn: {
                extends: 'Link',
                href: '/lawyers',
                text: 'Find a Lawyer',
                background: 'green',
                color: 'neutral950',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '600',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                }
            },
            LearnBtn: {
                extends: 'Link',
                href: '/',
                text: 'Learn More',
                background: 'transparent',
                color: 'text',
                border: '1px solid surfaceBorderStrong',
                padding: 'Z B',
                fontSize: 'Z',
                fontWeight: '500',
                borderRadius: 'B',
                textDecoration: 'none',
                transition: 'transform 200ms',
                ':hover': {
                    transform: 'scale(0.98)'
                }
            }
        }
    },
    // ═══════════════════════════════════════════════════
    // FOOTER
    // ═══════════════════════════════════════════════════
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'C',
        padding: 'D 0',
        borderTop: '1px solid surfaceBorderStrong',
        maxWidth: '1680px',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'C A'
        },
        FooterTop: {
            flow: 'x',
            gap: 'C',
            '@mobileL': {
                flow: 'y',
                gap: 'B'
            },
            FooterBrand: {
                flow: 'y',
                gap: 'A',
                flex: '1.5',
                minWidth: 'F',
                FooterLogo: {
                    extends: 'Link',
                    href: '/',
                    text: 'TrustLegal',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'green',
                    textDecoration: 'none'
                },
                FooterTagline: {
                    text: '{{ footerTagline | polyglot }}',
                    fontSize: 'Z',
                    color: 'textMuted',
                    lineHeight: '1.6'
                }
            },
            FooterLinks: {
                flow: 'x',
                gap: 'C',
                flex: '2',
                '@mobileL': {
                    flow: 'y',
                    gap: 'B'
                },
                FooterCol1: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ productLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/lawyers',
                        text: 'Find a Lawyer',
                        fontSize: 'Z',
                        color: 'green',
                        textDecoration: 'none',
                        fontWeight: '500'
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/for-lawyers',
                        text: 'For Lawyers',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                },
                FooterCol2: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    ColTitle: {
                        text: '{{ companyLabel | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'textMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        padding: '0 0 Z 0'
                    },
                    ColLink1: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ aboutUs | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    },
                    ColLink2: {
                        extends: 'Link',
                        href: '/',
                        text: '{{ careers | polyglot }}',
                        fontSize: 'Z',
                        color: 'textMuted',
                        textDecoration: 'none',
                        ':hover': {
                            color: 'text'
                        }
                    }
                }
            }
        },
        FooterBottom: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A 0 0 0',
            borderTop: '1px solid surfaceBorderStrong',
            '@mobileL': {
                flow: 'y',
                gap: 'Z',
                align: 'center center'
            },
            CopyText: {
                text: '{{ copyrightText | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            },
            BuiltWith: {
                text: '{{ builtWith | polyglot }}',
                fontSize: 'Z',
                color: 'textMuted'
            }
        }
    }
};


var $45001c780dea3812$export$2e2bcd8739ae039 = {
    '/': (0, $8d2c7cae8dfd7a3b$export$a9ae88069d8ac14e),
    '/login': (0, $979c3c60351c1a32$export$596d806903d1f59e),
    '/dashboard': (0, $4a3b6042fbd7c8f3$export$a5f98448b9315739),
    '/bookings': (0, $53ee824ff1ce7457$export$dbeef2c344004b5e),
    '/bookings/public': (0, $2b330bdbd1b280b3$export$3ee8813cfb9a6bdd),
    '/cases': (0, $e27b5f5bbb7cc435$export$3931a0da49df8dc0),
    '/clients': (0, $3b8c74c1f9bd59bc$export$a985976c39663a82),
    '/documents': (0, $d7f053e17fe69c28$export$3260cc9ddc8b12d),
    '/billing': (0, $942c0fe183543074$export$d87cfcc979a5825c),
    '/ai': (0, $4f74f4715283edb5$export$f3fdf23dea88dbed),
    '/settings': (0, $e3c2d50ee9db0663$export$34ad2f35a149a126),
    '/client': (0, $67857027dbaf7383$export$d50b3de1148083e9),
    '/client-dashboard': (0, $5334812cd89380b3$export$bba55ac008ecfff1),
    '/pitch': (0, $386b39b9d06f3a9f$export$6c9e2d66dea2a302),
    '/lawyers': (0, $6453c27a0f857188$export$301fd8a009fbc19d),
    '/lawyer': (0, $3e0203566e4c452a$export$4882ae973e0491e),
    '/firm': (0, $3e0203566e4c452a$export$4882ae973e0491e),
    '/chat': (0, $8f52cbf804c46fad$export$530dccc8e24f4e99),
    '/for-lawyers': (0, $3fe186eedbfa7296$export$644af75de1860b4e),
    '/for-clients': (0, $98bd3005b685f12f$export$b4534344d84894c3)
};


var $b42a2ac40ecd9203$exports = {};
var $8be5f038dc352071$exports = {};

$parcel$export($8be5f038dc352071$exports, "parseJSON", () => $8be5f038dc352071$export$27924e57e9afff7f);
$parcel$export($8be5f038dc352071$exports, "toSlug", () => $8be5f038dc352071$export$139c14101bbe733b);
$parcel$export($8be5f038dc352071$exports, "mapLawyer", () => $8be5f038dc352071$export$94f9b188bd848474);
$parcel$export($8be5f038dc352071$exports, "mapFirm", () => $8be5f038dc352071$export$f9c5893dac1ba437);
$parcel$export($8be5f038dc352071$exports, "lawyersFetch", () => $8be5f038dc352071$export$89394b89507bb9e9);
$parcel$export($8be5f038dc352071$exports, "firmsFetch", () => $8be5f038dc352071$export$23983784abe1bf71);
$parcel$export($8be5f038dc352071$exports, "searchDirectory", () => $8be5f038dc352071$export$38c2261f919365d4);
const $8be5f038dc352071$export$27924e57e9afff7f = function parseJSON(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') try {
        return JSON.parse(val);
    } catch  {
        return [];
    }
    return [];
};
const $8be5f038dc352071$export$139c14101bbe733b = function toSlug(name) {
    if (!name) return '';
    return name.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
};
const $8be5f038dc352071$export$94f9b188bd848474 = function mapLawyer(l) {
    let specializations = l.specializations;
    if (typeof specializations === 'string') try {
        specializations = JSON.parse(specializations);
    } catch  {
        specializations = [];
    }
    let languages = l.languages;
    if (typeof languages === 'string') try {
        languages = JSON.parse(languages);
    } catch  {
        languages = [];
    }
    const slug = $8be5f038dc352071$export$139c14101bbe733b(l.name_en) + (l.bar_id ? '-' + l.bar_id : '');
    return {
        id: l.id,
        slug: slug,
        nameKa: l.name_ka,
        nameEn: l.name_en,
        barId: l.bar_id,
        status: l.status,
        specializations: specializations || [],
        firmId: l.firm_id,
        firmNameEn: l.firm_name_en || '',
        firmNameKa: l.firm_name_ka || '',
        city: l.city,
        phone: l.phone,
        email: l.email,
        admissionDate: l.admission_date,
        languages: languages || [],
        avatar: l.avatar,
        rating: l.rating || 0,
        reviews: l.reviews || 0,
        bioKa: l.bio_ka,
        bioEn: l.bio_en,
        lat: l.lat,
        lng: l.lng,
        education: $8be5f038dc352071$export$27924e57e9afff7f(l.education),
        experience: $8be5f038dc352071$export$27924e57e9afff7f(l.experience),
        officeAddress: l.office_address,
        website: l.website,
        linkedin: l.linkedin,
        gbaProfileUrl: l.gba_profile_url,
        photoUrl: l.photo_url,
        coverPhoto: l.cover_photo,
        certifications: $8be5f038dc352071$export$27924e57e9afff7f(l.certifications),
        memberships: $8be5f038dc352071$export$27924e57e9afff7f(l.memberships),
        publications: $8be5f038dc352071$export$27924e57e9afff7f(l.publications),
        awards: $8be5f038dc352071$export$27924e57e9afff7f(l.awards),
        isSubscribed: l.is_subscribed || false,
        infoScore: l.info_score || 0
    };
};
const $8be5f038dc352071$export$f9c5893dac1ba437 = function mapFirm(f) {
    let practiceAreas = f.practice_areas;
    if (typeof practiceAreas === 'string') try {
        practiceAreas = JSON.parse(practiceAreas);
    } catch  {
        practiceAreas = [];
    }
    return {
        id: f.id,
        slug: $8be5f038dc352071$export$139c14101bbe733b(f.name_en),
        nameKa: f.name_ka,
        nameEn: f.name_en,
        address: f.address,
        phone: f.phone,
        email: f.email,
        website: f.website,
        logo: f.logo,
        descriptionKa: f.description_ka,
        descriptionEn: f.description_en,
        practiceAreas: practiceAreas || [],
        city: f.city,
        foundedYear: f.founded_year,
        status: f.status,
        lat: f.lat,
        lng: f.lng,
        lawyerCount: f.lawyer_count || 0
    };
};
const $8be5f038dc352071$export$89394b89507bb9e9 = {
    from: 'lawyers',
    order: {
        by: 'info_score',
        asc: false
    },
    limit: 50,
    cache: '5m',
    keepPreviousData: true,
    transform: (data, el)=>{
        const lawyers = (data || []).map($8be5f038dc352071$export$94f9b188bd848474);
        const root = el.state.root || el.state;
        if (root && root.update) root.update({
            lawyers: lawyers,
            lawyersLoaded: true
        }, {
            preventFetch: true
        });
        return lawyers;
    }
};
const $8be5f038dc352071$export$23983784abe1bf71 = {
    from: 'law_firms',
    order: {
        by: 'name_en',
        asc: true
    },
    limit: 50,
    cache: '5m',
    keepPreviousData: true,
    transform: (data, el)=>{
        const firms = (data || []).map($8be5f038dc352071$export$f9c5893dac1ba437);
        const root = el.state.root || el.state;
        if (root && root.update) root.update({
            firms: firms,
            firmsLoaded: true
        }, {
            preventFetch: true
        });
        return firms;
    }
};
const $8be5f038dc352071$export$38c2261f919365d4 = async function searchDirectory(query, filters = {}) {
    const SUPABASE_URL = 'https://xhzwvfniejgdvcpobdxm.supabase.co';
    const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhoend2Zm5pZWpnZHZjcG9iZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MTcxMTksImV4cCI6MjA4OTQ5MzExOX0.G2D-hdPv_ulmiEPS2AXZ2vGaykgvAmgTqU1eyKvLtcw';
    const HEADERS = {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`
    };
    const q = query.trim();
    if (!q) return {
        lawyers: [],
        firms: []
    };
    const nameOr = `or=(name_en.ilike.*${encodeURIComponent(q)}*,name_ka.ilike.*${encodeURIComponent(q)}*)`;
    const f = filters;
    const filterParts = [];
    if (f.cityFilter) filterParts.push(`city=eq.${encodeURIComponent(f.cityFilter)}`);
    if (f.verificationFilter === 'verified') filterParts.push('is_subscribed=eq.true');
    else if (f.verificationFilter === 'unverified') filterParts.push('is_subscribed=neq.true');
    if (f.statusFilter === 'active') filterParts.push('status=eq.active');
    else if (f.statusFilter === 'inactive') filterParts.push('status=neq.active');
    const extra = filterParts.join('&');
    const lawyersUrl = `${SUPABASE_URL}/rest/v1/lawyers?${nameOr}${extra ? '&' + extra : ''}&order=info_score.desc&limit=100`;
    const firmsUrl = `${SUPABASE_URL}/rest/v1/law_firms?${nameOr}${extra ? '&' + extra : ''}&order=name_en.asc&limit=50`;
    const [lr, fr] = await Promise.all([
        fetch(lawyersUrl, {
            headers: HEADERS
        }),
        fetch(firmsUrl, {
            headers: HEADERS
        })
    ]);
    const [ld, fd] = await Promise.all([
        lr.json(),
        fr.json()
    ]);
    const seenL = new Set();
    const lawyers = Array.isArray(ld) ? ld.filter((l)=>{
        const k = l.bar_id || l.id;
        if (seenL.has(k)) return false;
        seenL.add(k);
        return true;
    }).map($8be5f038dc352071$export$94f9b188bd848474) : [];
    const seenF = new Set();
    const firms = Array.isArray(fd) ? fd.filter((f)=>{
        if (seenF.has(f.id)) return false;
        seenF.add(f.id);
        return true;
    }).map($8be5f038dc352071$export$f9c5893dac1ba437) : [];
    return {
        lawyers: lawyers,
        firms: firms
    };
};


var $e8c8aace73339785$exports = {};

$parcel$export($e8c8aace73339785$exports, "getLawyer", () => $e8c8aace73339785$export$f158a7856dac0e34);
$parcel$export($e8c8aace73339785$exports, "getFirmById", () => $e8c8aace73339785$export$949cbd208e39bcf9);
const $e8c8aace73339785$export$f158a7856dac0e34 = function getLawyer() {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('slug');
    const id = params.get('id');
    if (slug) return (root.lawyers || []).find((x)=>x.slug === slug);
    if (id) return (root.lawyers || []).find((x)=>x.id === id);
};
const $e8c8aace73339785$export$949cbd208e39bcf9 = function getFirmById(firmId) {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    return (root.firms || []).find((f)=>f.id === firmId);
};


var $89d2621fb67c1abc$exports = {};

$parcel$export($89d2621fb67c1abc$exports, "getEntity", () => $89d2621fb67c1abc$export$fcf7c33d7fd02301);
$parcel$export($89d2621fb67c1abc$exports, "isFirmPage", () => $89d2621fb67c1abc$export$4787e58a2a6d4d0e);
$parcel$export($89d2621fb67c1abc$exports, "getFirmForEntity", () => $89d2621fb67c1abc$export$5fef2d3bbdcab0a0);
const $89d2621fb67c1abc$export$fcf7c33d7fd02301 = function getEntity() {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    const parts = window.location.pathname.split('/').filter(Boolean);
    const type = parts[0] === 'firm' ? 'firm' : 'lawyer';
    const slug = parts[1] || new URLSearchParams(window.location.search).get('slug') || '';
    if (!slug) return null;
    if (type === 'firm') return (root.firms || []).find((x)=>x.slug === slug);
    return (root.lawyers || []).find((x)=>x.slug === slug);
};
const $89d2621fb67c1abc$export$4787e58a2a6d4d0e = function isFirmPage() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return parts[0] === 'firm';
};
const $89d2621fb67c1abc$export$5fef2d3bbdcab0a0 = function getFirmForEntity(firmId) {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    return (root.firms || []).find((f)=>f.id === firmId);
};


var $7ead78a1e7956c4a$exports = {};

$parcel$export($7ead78a1e7956c4a$exports, "getFirmFromUrl", () => $7ead78a1e7956c4a$export$cbf87a4c5a99b805);
const $7ead78a1e7956c4a$export$cbf87a4c5a99b805 = function getFirmFromUrl() {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    const id = new URLSearchParams(window.location.search).get('id');
    return (root.firms || []).find((x)=>x.id === id);
};


var $329d938ea645a1c1$exports = {};

$parcel$export($329d938ea645a1c1$exports, "triggerChat", () => $329d938ea645a1c1$export$ed10dd92a82b1ea);
$parcel$export($329d938ea645a1c1$exports, "formatChatHtml", () => $329d938ea645a1c1$export$ae8e93c86752bc84);
$parcel$export($329d938ea645a1c1$exports, "parseChatLinks", () => $329d938ea645a1c1$export$650f643d805bf932);
const $329d938ea645a1c1$var$SUPABASE_URL = 'https://xhzwvfniejgdvcpobdxm.supabase.co';
const $329d938ea645a1c1$var$SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhoend2Zm5pZWpnZHZjcG9iZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MTcxMTksImV4cCI6MjA4OTQ5MzExOX0.G2D-hdPv_ulmiEPS2AXZ2vGaykgvAmgTqU1eyKvLtcw';
const $329d938ea645a1c1$var$AI_CHAT_URL = `${$329d938ea645a1c1$var$SUPABASE_URL}/functions/v1/ai-chat`;
const $329d938ea645a1c1$export$ed10dd92a82b1ea = async function triggerChat(query) {
    const s = this.getState ? this.getState() : this.state;
    const root = s.root || s;
    const thread = [
        ...root.chatMessages || [],
        {
            role: 'user',
            content: query
        }
    ];
    root.update({
        chatMessages: thread,
        chatTyping: true
    });
    try {
        const res = await fetch($329d938ea645a1c1$var$AI_CHAT_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${$329d938ea645a1c1$var$SUPABASE_KEY}`
            },
            body: JSON.stringify({
                action: 'message',
                messages: thread.filter((m)=>m.role && m.content)
            })
        });
        const data = await res.json();
        root.update({
            chatMessages: [
                ...thread,
                {
                    role: 'assistant',
                    content: data.reply || 'No response received.',
                    recommended: data.results || []
                }
            ],
            chatTyping: false
        });
        const threadEl = this.lookup ? this.lookup('ThreadBody') : null;
        if (threadEl && threadEl.node) setTimeout(()=>{
            threadEl.node.scrollTop = threadEl.node.scrollHeight;
        }, 100);
    } catch (err) {
        root.update({
            chatMessages: [
                ...thread,
                {
                    role: 'assistant',
                    content: 'Error: ' + err.message
                }
            ],
            chatTyping: false
        });
    }
};
const $329d938ea645a1c1$export$ae8e93c86752bc84 = function formatChatHtml(text) {
    if (!text) return '';
    let t = text;
    t = t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    t = t.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" style="color:#c6ac8f;text-decoration:underline">$1</a>');
    t = t.replace(/\n/g, '<br>');
    return t;
};
const $329d938ea645a1c1$export$650f643d805bf932 = function parseChatLinks(text) {
    const links = [];
    const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    let m;
    while((m = regex.exec(text)) !== null)links.push({
        label: m[1],
        url: m[2]
    });
    return links;
};


$parcel$exportWildcard($b42a2ac40ecd9203$exports, $8be5f038dc352071$exports);
$parcel$exportWildcard($b42a2ac40ecd9203$exports, $e8c8aace73339785$exports);
$parcel$exportWildcard($b42a2ac40ecd9203$exports, $89d2621fb67c1abc$exports);
$parcel$exportWildcard($b42a2ac40ecd9203$exports, $7ead78a1e7956c4a$exports);
$parcel$exportWildcard($b42a2ac40ecd9203$exports, $329d938ea645a1c1$exports);


var $3bda623ffab03480$exports = {};


var $1f94fb7560370f21$export$2e2bcd8739ae039 = {
    black: '#0a0908',
    white: '#ffffff',
    neutral50: '#eae0d5',
    neutral100: '#d5cbbe',
    neutral200: '#c6ac8f',
    neutral300: '#a89279',
    neutral400: '#8a7a65',
    neutral500: '#5e503f',
    neutral600: '#4a3f32',
    neutral700: '#3a3128',
    neutral800: '#22333b',
    neutral900: '#161a1d',
    neutral950: '#0a0908',
    green: '#c6ac8f',
    greenBg: 'rgba(198,172,143,0.12)',
    greenBorder: 'rgba(198,172,143,0.3)',
    blue: '#5d79df',
    blueBg: 'rgba(93,121,223,0.1)',
    blueBorder: 'rgba(93,121,223,0.25)',
    purple: '#a89279',
    purpleBg: 'rgba(168,146,121,0.12)',
    purpleBorder: 'rgba(168,146,121,0.3)',
    orange: '#f36f1c',
    orangeBg: 'rgba(243,111,28,0.1)',
    orangeBorder: 'rgba(243,111,28,0.25)',
    red: '#eb524b',
    redBg: 'rgba(235,82,75,0.1)',
    redBorder: 'rgba(235,82,75,0.2)',
    amber: '#c6ac8f',
    amberBg: 'rgba(198,172,143,0.12)',
    amberBorder: 'rgba(198,172,143,0.3)',
    cyan: '#22333b',
    cyanBg: 'rgba(34,51,59,0.15)',
    cyanBorder: 'rgba(34,51,59,0.3)',
    surface: '#0a0908',
    surfaceMid: '#161a1d',
    surfaceCard: '#22333b',
    surfaceBorder: 'rgba(198,172,143,0.08)',
    surfaceBorderStrong: 'rgba(198,172,143,0.18)',
    text: '#eae0d5',
    textSoft: 'rgba(234,224,213,0.7)',
    textMuted: 'rgba(234,224,213,0.45)'
};


var $3116e794b25d00ca$export$2e2bcd8739ae039 = {
    document: {
        '@dark': {
            background: 'neutral950',
            color: 'neutral50'
        },
        '@light': {
            background: 'neutral50',
            color: 'neutral900'
        }
    },
    primary: {
        '@dark': {
            background: 'green',
            color: 'neutral950'
        },
        '@light': {
            background: 'green',
            color: 'neutral950'
        },
        fontWeight: '600'
    },
    secondary: {
        '@dark': {
            background: 'neutral800',
            color: 'neutral50'
        },
        '@light': {
            background: 'neutral100',
            color: 'neutral900'
        }
    },
    ghost: {
        '@dark': {
            background: 'transparent',
            color: 'neutral300',
            border: '1px solid neutral700'
        },
        '@light': {
            background: 'transparent',
            color: 'neutral600',
            border: '1px solid neutral200'
        }
    },
    ghostTeal: {
        '@dark': {
            background: 'transparent',
            color: 'green',
            border: '1px solid greenBorder'
        },
        '@light': {
            background: 'transparent',
            color: 'green',
            border: '1px solid greenBorder'
        }
    },
    card: {
        '@dark': {
            background: 'neutral800',
            color: 'neutral50',
            border: '1px solid neutral700'
        },
        '@light': {
            background: 'white',
            color: 'neutral900',
            border: '1px solid neutral200'
        }
    },
    sidebar: {
        '@dark': {
            background: 'neutral950',
            color: 'neutral50'
        },
        '@light': {
            background: 'white',
            color: 'neutral900'
        }
    },
    none: {
        '@dark': {
            color: 'none',
            background: 'none'
        },
        '@light': {
            color: 'none',
            background: 'none'
        }
    },
    transparent: {
        '@dark': {
            color: 'currentColor',
            background: 'transparent',
            border: 'none'
        },
        '@light': {
            color: 'currentColor',
            background: 'transparent',
            border: 'none'
        }
    },
    danger: {
        background: 'redBg',
        color: 'red',
        border: '1px solid redBorder'
    },
    warning: {
        background: 'amberBg',
        color: 'amber',
        border: '1px solid amberBorder'
    },
    success: {
        background: 'greenBg',
        color: 'green',
        border: '1px solid greenBorder'
    }
};


var $311a5e5cb61c1a1b$export$2e2bcd8739ae039 = {};


var $d1e1c29584374e78$export$2e2bcd8739ae039 = {};


var $22b0a268f5e3c9c7$export$2e2bcd8739ae039 = {
    AvenirGeo: {
        isDefault: true,
        value: [
            'Avenir Geo',
            'Avenir',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'sans-serif'
        ],
        type: 'sans-serif'
    }
};


var $427ce150ce5df318$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


var $af6c52f5e26a563e$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.618,
    subSequence: true
};


var $3c00d699b7463a5a$export$2e2bcd8739ae039 = {};


var $90131e45aaa63902$export$2e2bcd8739ae039 = {};


var $6ede05c296bd9ec9$export$2e2bcd8739ae039 = {};


var $5d854b05544f3b96$export$2e2bcd8739ae039 = {
    dashboard: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor"/></svg>',
    calendar: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="currentColor"/></svg>',
    briefcase: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 7h-4V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5z" fill="currentColor"/></svg>',
    document: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="currentColor"/></svg>',
    settings: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.49.49 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.49.49 0 00-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6A3.6 3.6 0 1112 8.4a3.6 3.6 0 010 7.2z" fill="currentColor"/></svg>',
    user: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/></svg>',
    logout: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" fill="currentColor"/></svg>',
    plus: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/></svg>',
    check: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>',
    star: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z" fill="currentColor"/></svg>',
    search: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/></svg>',
    warning: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor"/></svg>',
    clock: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="currentColor"/></svg>',
    phone: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg>',
    mail: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/></svg>',
    copy: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/></svg>',
    download: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="currentColor"/></svg>',
    ai: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0A6.89 6.89 0 0019 12.1h2a9.02 9.02 0 01-2.64 5.89c-3.51 3.48-9.21 3.48-12.72 0-3.51-3.47-3.51-9.11 0-12.58 3.51-3.47 9.14-3.49 12.65-.06L21 2v8.12z" fill="currentColor"/></svg>',
    arrowRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" fill="currentColor"/></svg>',
    close: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg>'
};


var $78651d184c5325c2$export$2e2bcd8739ae039 = {};


var $92ec376187f7a4de$export$2e2bcd8739ae039 = {};


var $c4ca593693018207$export$2e2bcd8739ae039 = {};


var $372ac325ab0ab1d3$export$2e2bcd8739ae039 = {
    screenL: '(max-width: 1920px)',
    screenS: '(max-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    tabletS: '(max-width: 1024px)',
    mobileL: '(max-width: 768px)',
    mobileM: '(max-width: 560px)',
    mobileS: '(max-width: 480px)'
};


var $8d37bf74fd7dee28$export$2e2bcd8739ae039 = {};


var $1a9a2097450ea0af$export$2e2bcd8739ae039 = {
    color: (0, $1f94fb7560370f21$export$2e2bcd8739ae039),
    theme: (0, $3116e794b25d00ca$export$2e2bcd8739ae039),
    gradient: (0, $311a5e5cb61c1a1b$export$2e2bcd8739ae039),
    font: (0, $d1e1c29584374e78$export$2e2bcd8739ae039),
    font_family: (0, $22b0a268f5e3c9c7$export$2e2bcd8739ae039),
    typography: (0, $427ce150ce5df318$export$2e2bcd8739ae039),
    spacing: (0, $af6c52f5e26a563e$export$2e2bcd8739ae039),
    timing: (0, $3c00d699b7463a5a$export$2e2bcd8739ae039),
    class: (0, $90131e45aaa63902$export$2e2bcd8739ae039),
    grid: (0, $6ede05c296bd9ec9$export$2e2bcd8739ae039),
    icons: (0, $5d854b05544f3b96$export$2e2bcd8739ae039),
    shape: (0, $78651d184c5325c2$export$2e2bcd8739ae039),
    reset: (0, $92ec376187f7a4de$export$2e2bcd8739ae039),
    animation: (0, $c4ca593693018207$export$2e2bcd8739ae039),
    media: (0, $372ac325ab0ab1d3$export$2e2bcd8739ae039),
    cases: (0, $8d37bf74fd7dee28$export$2e2bcd8739ae039)
};


var $f00b8cc44c2f4180$export$2e2bcd8739ae039 = {};



var $dNnfS = parcelRequire("dNnfS");
var $3e7bb68d55e4c07c$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    globalTheme: 'dark',
    verbose: false,
    fetch: {
        adapter: 'supabase',
        createClient: $dNnfS.createClient,
        url: 'https://xhzwvfniejgdvcpobdxm.supabase.co',
        key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhoend2Zm5pZWpnZHZjcG9iZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MTcxMTksImV4cCI6MjA4OTQ5MzExOX0.G2D-hdPv_ulmiEPS2AXZ2vGaykgvAmgTqU1eyKvLtcw',
        db: {
            schema: 'public'
        },
        retry: {
            retry: '3',
            delay: '1000'
        }
    },
    polyglot: {
        defaultLang: 'en',
        languages: [
            'en',
            'ka',
            'ru',
            'uk',
            'tr',
            'zh',
            'hi',
            'msa'
        ],
        storageLangKey: 'legal_lang',
        storagePrefix: 'legal_t_'
    }
};


var $bc1454a6c0cf0628$export$2e2bcd8739ae039 = {
    en: {
        home: 'Home',
        dashboard: 'Dashboard',
        bookings: 'Bookings',
        bookingPage: 'Booking Page',
        aiDocuments: 'AI Documents',
        clientPortalNav: 'Client Portal',
        lawyersNav: 'Lawyers',
        login: 'Log in',
        getStarted: 'Get Started Free',
        lawyersTitle: 'Lawyers & Law Firms',
        lawyersSubtitle: 'registered in Georgia',
        searchPlaceholder: 'Search by name, firm, or practice area...',
        lawyersBtn: 'Lawyers',
        firmsBtn: 'Firms',
        allFilter: 'All',
        corporateLaw: 'Corporate Law',
        criminalLaw: 'Criminal Law',
        familyLaw: 'Family Law',
        realEstate: 'Real Estate',
        taxLaw: 'Tax Law',
        ipLaw: 'IP',
        immigration: 'Immigration',
        laborLaw: 'Labor Law',
        bankingFinance: 'Banking & Finance',
        firmsMatch: 'firms match',
        lawyersMatch: 'lawyers match',
        reviews: 'reviews',
        loadingMore: 'Load more',
        independent: 'Independent',
        yearsExperience: 'years experience',
        languages: 'Languages',
        backToDirectory: "\u2190 Back to directory",
        about: 'About',
        bookConsultation: 'Book Consultation',
        sendMessage: 'Send Message',
        call: 'Call',
        reviewsRatings: 'Reviews & Ratings',
        reviewsComingSoon: 'Reviews coming soon. Be the first to review.',
        barId: 'Bar ID',
        ourTeam: 'Our Team',
        contact: 'Contact',
        website: 'Website',
        established: 'Est.',
        lawyersCount: 'lawyers',
        georgian: 'Georgian',
        english: 'English',
        russian: 'Russian',
        german: 'German',
        french: 'French',
        turkish: 'Turkish',
        heroLine1: 'Your legal',
        heroLine2: 'team. One',
        heroLine3: 'platform.',
        heroSubtitle: "TrustLegal \u2014 bookings, cases, payments and AI document drafting for Georgian law firms. One monthly fee, no contract.",
        tryFree: "Try Free \u2192",
        liveDemo: 'Live Demo',
        trustedBrands: 'Brands that care about quality work with us',
        howItWorks: 'How it works',
        processLabel: '// Process',
        step1Title: 'Sign up',
        step1Desc: "Create an account and choose a plan. No credit card required \u2014 first 30 days free.",
        step2Title: 'Manage cases',
        step2Desc: 'Add clients, cases and bookings. Automatic reminders and calendar sync.',
        step3Title: 'Draft with AI',
        step3Desc: 'AI-powered document drafting in Georgian. Claims, power of attorney, contract analysis.',
        step4Title: 'Grow',
        step4Desc: 'Track invoices, revenue and team productivity. Real-time analytics.',
        demoBadge: '// Live Demo',
        todaysBookings: 'Today\'s bookings',
        fullDemo: "Full demo \u2192",
        onePlatformThreePillars: 'One platform.\nThree pillars.',
        capabilitiesLabel: '// Capabilities',
        bookingFeature: 'Booking',
        bookingFeatureDesc: 'Clients pick their own time. Auto reminders. Calendar sync. Public booking page.',
        operationsFeature: 'Operations',
        operationsFeatureDesc: 'Centralized case management. Client portal. Invoices and payments. Team management.',
        aiFeatureDesc: 'Document drafting in Georgian. Contract analysis. Legal research. Auto follow-up.',
        simplePricing: 'Simple pricing',
        plansLabel: '// Plans',
        perMonth: '/ month',
        bookingMgmt: 'Booking management',
        caseTracking: 'Case tracking',
        calendarSync: 'Calendar sync',
        emailReminders: 'Email reminders',
        starterPlan: 'Starter',
        startNow: "Start now \u2192",
        everythingStarter: 'Everything from Starter',
        aiDocDrafting: 'AI document drafting',
        invoicesPayments: 'Invoices and payments',
        clientPortalFeature: 'Client portal',
        directSupport: 'Direct support',
        professionalPlan: 'Professional',
        mostPopular: 'Most popular',
        everythingPro: 'Everything from Professional',
        teamMgmt10: 'Team management (10+ lawyers)',
        contractAnalysis: 'Contract analysis',
        advancedAnalytics: 'Advanced analytics',
        personalOnboarding: 'Personal onboarding',
        businessPlan: 'Business',
        spotsLeft: '3 spots left',
        enterpriseNote: "Enterprise \u2014 contact us for a custom offer.",
        readyQuestion: 'Ready?',
        first30DaysFree: 'First 30 days free. No contract. Cancel anytime.',
        footerTagline: 'Georgian legal SaaS platform.',
        productLabel: 'Product',
        companyLabel: 'Company',
        bookingsLink: 'Bookings',
        casesLink: 'Cases',
        aiDocsLink: 'AI Documents',
        aboutUs: 'About us',
        careers: 'Careers',
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: 'Built with Symbols',
        sidebarMain: 'Dashboard',
        sidebarBookings: 'Bookings',
        sidebarCases: 'Cases',
        sidebarClients: 'Clients',
        sidebarDocs: 'Documents',
        sidebarPayments: 'Payments',
        sidebarLawyers: 'Lawyers',
        sidebarSettings: 'Settings',
        sidebarLogout: 'Log out',
        bookingsTitle: 'Bookings',
        newBooking: '+ New Booking',
        newBookingTitle: 'New Booking',
        clientName: 'Client name',
        phoneNumber: 'Phone',
        civilLaw: 'Civil',
        criminalLaw2: 'Criminal Law',
        administrativeLaw: 'Administrative',
        otherType: 'Other',
        notesPlaceholder: 'Notes...',
        confirmBooking: 'Confirm Booking',
        cancelBtn: 'Cancel',
        calendarSyncNote: "Calendar sync \u2014 Google Calendar, Outlook, Apple Calendar sync automatically",
        synced: 'Synced',
        calendarSync2: 'Calendar Sync',
        syncedStatus: 'Synced',
        bookingsToday: '3 bookings today',
        settingsLink: "Settings \u2192",
        pendingStatus: 'Pending',
        connectionNeeded: 'Connection needed',
        connectLink: "Connect \u2192",
        lastSync: 'Last sync: 5 min ago',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        bookingDetails: 'Booking Details',
        confirmed: 'Confirmed',
        pending: 'Pending',
        upcomingBookings: 'Upcoming Bookings',
        closeBtn: 'Close',
        selectDateTime: 'Select date and time',
        fillInfo: "Fill in information \u2014 ",
        firstName: 'First name',
        lastName: 'Last name',
        phoneField: 'Phone',
        emailField: 'Email',
        caseDescription: 'Brief case description',
        confirmBookingPublic: 'Confirm Booking',
        goBack: 'Go back',
        bookingConfirmedMsg: 'Booking confirmed!',
        timeLabel: 'Time: ',
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: 'Nino Barateli',
        casesTitle: 'Cases',
        searchPlaceholder2: 'Search...',
        newCase: '+ New Case',
        allTab: 'All',
        activeTab: 'Active',
        pendingTab: 'Pending',
        closedTab: 'Closed',
        selectCasePrompt: 'Select a case to view details',
        info: 'Info',
        registry: 'Registry',
        clientInfo: 'Client Information',
        chronology: 'Chronology',
        addNote: 'Add note',
        enterNote: 'Enter a note...',
        addBtn: 'Add',
        documentsLabel: 'Documents',
        createBtn: '+ Create',
        noDocs: 'No documents',
        hearingSchedule: 'Hearing Schedule',
        caseStatus: 'Case Status',
        electronicFiling: 'Electronic Filing',
        idCode: 'ID Code:',
        director: 'Director:',
        addressLabel: 'Address:',
        statusLabel: 'Status:',
        registeredProperty: 'Registered Property',
        extractLabel: 'Extract',
        recentChanges: 'Recent Changes',
        yourFieldChanges: 'Changes in your field',
        newLabel: 'New',
        notifications: 'Notifications',
        clientsTitle: 'Clients',
        clientsSearchPlaceholder: 'Search clients...',
        clientsProfile: 'Client Profile',
        clientsContactLabel: 'Contact',
        clientsInvoiceHistory: 'Invoice History',
        clientsUnpaid: 'Unpaid',
        clientsPaid: 'Paid',
        clientsPortalInvite: 'Send client portal access',
        dashTodayBookings: 'Today bookings',
        dashUnpaid: 'Unpaid',
        dashOverdue: 'Overdue',
        dashAiGenerations: 'AI generations',
        dashTodaysBookings: 'Today\'s bookings',
        dashConfirmed: 'Confirmed',
        dashRecentCases: 'Recent cases',
        dashNewBooking: '+ New Booking',
        dashNewCase: '+ New Case',
        dashAiDocument: 'AI Document',
        docsTitle: 'Documents',
        docsCreate: 'Create',
        docsExisting: 'Existing Documents',
        docsFiles: 'Files',
        docsOcrScan: 'Scan',
        docsOcrTitle: 'OCR Scanning',
        docsUploadText: 'Upload a document photo or PDF',
        docsScanning: 'Document scanning...',
        docsFile: 'File',
        docsPages: 'Pages',
        docsLanguage: 'Language',
        docsGeorgian: 'Georgian',
        docsAddToCase: 'Add to case',
        docsCopy: 'Copy',
        docsRescan: 'Rescan',
        docsClaim: 'Claim',
        docsPowerOfAttorney: 'Power of Attorney',
        docsNotification: 'Notification',
        docsContractReview: 'Contract Review',
        docsFreeForm: 'Free Form',
        docsParty1: 'Party 1',
        docsNameCompany: 'Name / Company',
        docsParty2: 'Party 2',
        docsDate: 'Date',
        docsAdditionalInfo: 'Additional Information',
        docsGenerating: 'Generating...',
        docsGenerate: 'Generate',
        docsGeneratedDocument: 'Generated Document',
        docsEmptyState: 'Generated document will appear here',
        docsShowDemo: 'Show demo document',
        docsDownload: 'Download',
        docsSend: 'Send',
        docsCreatedDocuments: 'Created Documents',
        docsSearch: 'Search...',
        docsFileManager: 'File Manager',
        docsUpload: 'Upload',
        docsCases: 'Cases',
        docsTemplates: 'Templates',
        docsRecentFiles: 'Recent Files',
        billingTitle: 'Billing',
        billingNewInvoice: 'New Invoice',
        billingTotalSent: 'Total Sent',
        billingPaid: 'Paid',
        billingUnpaid: 'Unpaid',
        billingOverdue: 'Overdue',
        billingActive: 'Active',
        billingClientStatus: 'Client Status',
        billingEInvoice: 'e-Invoice',
        billingAutoCheck: 'Auto-check',
        billingSettings: "Settings \u2192",
        billingInvoice: 'Invoice',
        billingClient: 'Client',
        billingCase: 'Case',
        billingAmount: 'Amount',
        billingDue: 'Due',
        billingStatus: 'Status',
        aiTitle: 'AI Assistant',
        aiPowered: 'Powered by AI',
        aiDraftDocs: 'Document Drafting',
        aiContractAnalysis: 'Contract Analysis',
        aiLegalResearch: 'Legal Research',
        aiDraftAvailable: 'Document drafting is available on the documents page',
        aiGoToDocuments: "Go to documents \u2192",
        aiPasteContract: 'Paste contract text here...',
        aiAnalyze: 'Analyze',
        aiReanalyze: 'Re-analyze',
        aiParties: 'Parties',
        aiObligations: 'Key Obligations',
        aiRiskFactors: 'Risk Factors',
        aiDeadlines: 'Deadlines',
        aiRecommendations: 'Recommendations',
        aiAskQuestion: 'Ask a question about Georgian law',
        aiLegalResearchTitle: 'AI Legal Research',
        aiAskPlaceholder: 'Ask a question...',
        aiSend: 'Send',
        pitchTagline: 'Georgia\'s Legal SAAS',
        pitchSubtitle: "Booking \xb7 Operations \xb7 AI \u2014 for Georgian firms",
        pitchCta: "See the opportunity \u2192",
        pitchMarketLabel: '// Market',
        pitchMarketTitle: '5000+ lawyers in Georgia',
        pitchPopulation: 'Population',
        pitchTbilisi: 'Tbilisi',
        pitchConcentrated: 'Concentrated market',
        pitchZeroCompetitor: 'Local SaaS competitor',
        pitchProblemLabel: '// Problem',
        pitchProblemTitle: 'Georgian firms still run on WhatsApp and Excel',
        pitchNoBooking: 'No client booking system',
        pitchManualCases: 'Manual case management',
        pitchNoAiTools: 'No AI tools in Georgian',
        pitchCapabilitiesLabel: '// Capabilities',
        pitchOnePlatform: 'One platform. Three pillars.',
        pitchProductLabel: '// Product',
        pitchProductTitle: 'Everything in one platform',
        pitchIntegrationsLabel: '// Integrations',
        pitchIntegrationsTitle: 'Automation, not manual work',
        pitchPublicRegistry: 'Public Registry',
        pitchCalendarSyncTitle: 'Calendar Sync',
        pitchOcrTitle: 'OCR & Scanning',
        pitchPlansLabel: '// Plans',
        pitchPlansTitle: 'Pricing for the Georgian market',
        pitchTierStarter: 'Starter',
        pitchMostPopular: 'Most Popular',
        pitchTierPro: 'Professional',
        pitchTierBusiness: 'Business',
        pitchTierEnterprise: 'Enterprise',
        pitchRevenueLabel: '// Revenue',
        pitchRevenueTitle: 'Revenue Potential',
        pitchFinanceLabel: '// Financials',
        pitchFinanceTitle: 'Unit Economics',
        pitchTimeLabel: '// Timing',
        pitchTimeTitle: 'The timing is right',
        pitchPrivacyLabel: '// Privacy',
        pitchPrivacyTitle: 'Privacy is a priority',
        pitchCtaLabel: '// Build Together',
        pitchCtaTitle: 'Let\'s build Georgia\'s legal infrastructure',
        pitchCtaLink: "Home page \u2192",
        pitchPerMonth: 'month',
        settingsTitle: 'Settings',
        settingsTabProfile: 'Profile',
        settingsTabFirm: 'Firm',
        settingsTabTeam: 'Team',
        settingsTabNotifications: 'Notifications',
        settingsUploadPhoto: 'Upload Photo',
        settingsSave: 'Save',
        settingsFirmAddress: 'Address',
        settingsFirmRegNumber: 'Registration Number',
        settingsPublicBookingUrl: 'Public Booking URL',
        settingsTeamMembers: 'Team Members',
        settingsInvite: '+ Invite',
        settingsRoleOwner: 'Owner',
        settingsRoleLawyer: 'Lawyer',
        settingsNotifyTitle: 'Notification Settings',
        settingsToggleOn: 'Enabled',
        settingsToggleOff: 'Disabled',
        loginSubtitle: 'Sign in to your account',
        loginLawyer: 'Lawyer',
        loginClient: 'Client',
        loginPassword: 'Password',
        loginSubmit: "Sign in \u2192",
        loginCaseNumber: 'Case Number',
        loginBackLink: "\u2190 Go back",
        portalLogout: 'Log out',
        portalWelcome: 'Hello,',
        portalActiveCases: 'Active Cases',
        portalDocuments: 'Documents',
        portalMessages: 'Messages',
        portalSend: 'Send',
        clientDashNavCases: 'Cases',
        clientDashNavInvoices: 'Invoices',
        clientDashNavDocuments: 'Documents',
        clientDashNavMessages: 'Messages',
        clientDashLogout: 'Log out',
        clientDashWelcome: 'Hello,',
        clientDashDownload: 'Download',
        clientDashSend: 'Send',
        findLawyer: 'Find a Lawyer',
        lawyersSearchSub: 'Search 5,700+ lawyers registered with the Georgian Bar Association',
        searchBtn: 'Search',
        viewAll: 'View all',
        lawyerPortal: 'Lawyer Portal',
        aiFeature: 'AI',
        aiChip1: 'Notarial contract cancellation',
        aiChip1Question: 'What are the conditions for canceling a notarial contract?',
        aiChip2: 'Civil Code Article 317',
        aiChip2Question: 'Interpretation of Civil Code Article 317',
        aiChip3: 'Transaction nullity',
        aiChip3Question: 'Court practice on transaction nullity in the last 3 years',
        aiDeadlinesData: "\u2022 Service start: 10 days from contract\n\u2022 First payment: April 1, 2026\n\u2022 Contract term: 12 months",
        aiEmptyChatSub: "AI \u2014 Ask a question and get an answer about Georgian law",
        aiObligationsData: '1. Service delivery within 30 calendar days\n2. Payment within 15 business days\n3. Confidentiality for 3 years',
        aiPartiesData: 'Party 1: Barateli & Partners LLC\nParty 2: Delta Group LLC',
        aiRecommendationsData: '1. Add penalty clause (Civil Code Art. 417)\n2. Define dispute resolution via arbitration\n3. Expand force majeure clause',
        aiRisksData: "\u2022 Late payment penalty not defined\n\u2022 Dispute resolution mechanism not specified\n\u2022 Force majeure clause does not cover pandemic",
        address: 'Address',
        addressVal: 'Tbilisi, Chavchavadze 12',
        appleCalendar: 'Apple Calendar',
        billingClient1: 'Giorgi Mamulashvili',
        billingClient2: 'Mariam Kvaratskhelia',
        billingClient3: 'Lela Gogiashvili',
        billingClientName: 'Delta Group LLC',
        billingDue1: '25 Mar',
        billingDue2: '15 Mar',
        billingDue3: '10 Mar',
        billingEmailNotification: 'Email notification',
        billingLastCheck: 'Last check: today',
        billingNoDebt: 'No outstanding debt',
        billingRsBanner: "rs.ge integration \u2014 client tax debt and e-invoice in one click",
        billingRsTaxSystem: "rs.ge \u2014 Tax System",
        billingStatusPaid: 'Paid',
        billingStatusSent: 'Sent',
        billingViewFull: "View full \u2192",
        billingViewInvoices: "View invoices \u2192",
        billingWeeklyEnabled: 'Weekly enabled',
        caseRow1Title: "#2024-047 \u2014 Giorgi Mamulashvili",
        caseRow2Title: "#2024-046 \u2014 Mariam Kvaratskhelia",
        caseRow3Title: "#2024-045 \u2014 Lela Gogiashvili",
        change1Date: "March 15 \u2014 Effective: April 1",
        change1Desc: 'Deadline increased from 30 to 45 days',
        change1Name: "Civil Code \u2014 Art. 316",
        change2Date: "March 12 \u2014 Effective: May 1",
        change2Desc: 'Appeal deadline from 14 to 21 days',
        change2Name: "Procedural Code \u2014 Deadlines",
        claimAccepted: "Claim accepted \u2014 March 17",
        claimFiled: "Claim filed \u2014 March 15",
        claimFiledDoc: "Claim \u2014 Filed",
        clientName1: 'Giorgi Mamulashvili',
        clientName2: 'Mariam Kvaratskhelia',
        clientName3: 'Lela Gogiashvili',
        companyExtractLoaded: "Company extract \u2014 Loaded",
        companyName: 'Delta Group LLC',
        clientsActiveCases1: '1 active case',
        clientsActiveCases2: '1 active case',
        clientsActiveCases3: '0 active cases',
        clientsAvatar1: 'GM',
        clientsAvatar2: 'MK',
        clientsAvatar3: 'LG',
        clientsCaseLink1: "#2024-047 \u2014 Civil",
        clientsCaseLink2: "#2024-046 \u2014 Administrative",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: 'No active cases',
        clientsPaid1: "\u20BE2,400 paid",
        clientsPaid2: "\u20BE800 paid",
        clientsPaid3: "\u20BE1,800 paid",
        dashAlertText: "2 overdue cases and \u20BE1,840 unpaid invoices",
        dashBooking1Time: "10:00 \u2014 Civil",
        dashBooking2Time: "11:30 \u2014 Administrative",
        dashBooking3Time: "14:00 \u2014 Criminal",
        dashCaseMeta1: "Civil \xb7 18 Mar",
        dashCaseMeta2: "Administrative \xb7 17 Mar",
        dashCaseMeta3: "Criminal \xb7 15 Mar",
        dashClient3Name: 'Davit Chikovani',
        dashDate: 'March 18, 2026',
        dashGreeting: 'Hello, Nino',
        dateMar15: '15 Mar',
        dateMar17: '17 Mar',
        dateMar18: '18 Mar',
        disabledStatus: "\u2014 Disabled",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: 'Georgia, Tbilisi\n\nClaim\n\nPlaintiff: Barateli & Partners LLC\nDefendant: Delta Group LLC\n\nFactual Circumstances:\n\nBy this claim, the plaintiff requests the defendant to fulfill its obligations.\n\nRequest:\n\n1. Obligate defendant to pay 12,500 GEL\n2. Impose penalty of 1,875 GEL\n3. Reimburse court costs\n\nDate: March 18, 2026\nSignature: ________________',
        docsDocument: 'Document',
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 Mar 2026",
        docsFile1Name: 'Claim - Mamulashvili.pdf',
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 Mar 2026",
        docsFile2Name: 'Power of Attorney - Kvaratskhelia.pdf',
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 Mar 2026",
        docsFile3Name: "Contract \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 Mar 2026",
        docsFile4Name: 'ID Copy - Mamulashvili.jpg',
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 Mar 2026",
        docsFile5Name: 'Notification - Gogiashvili.pdf',
        docsFolder1Count: '3 files',
        docsFolder1Name: '#2024-047 Mamulashvili',
        docsFolder2Count: '2 files',
        docsFolder2Name: '#2024-046 Kvaratskhelia',
        docsFolder3Count: '1 file',
        docsFolder3Name: '#2024-045 Gogiashvili',
        docsFolder4Count: '5 files',
        docsFormatAnalysis: 'Format analysis...',
        docsFreeText: 'Free text...',
        docsGeneratedClaimText: 'Georgia, Tbilisi\n\nClaim\n\nPlaintiff: [Party 1]\nDefendant: [Party 2]\n\nFactual Circumstances:\n\nBy this claim, the plaintiff requests the defendant to fulfill its obligations under the Civil Code of Georgia.\n\nLegal Basis:\n\nPursuant to Article 316 of the Civil Code, obligations must be performed properly.\n\nRequest:\n\nConsidering the above, the plaintiff requests the court to obligate the defendant.\n\nDate: March 18, 2026\nSignature: ________________',
        docsGeorgianSymbols: 'Georgian characters',
        docsOcrNote: "OCR Scanning \u2014 automatic digitization of paper documents, no manual typing needed",
        docsOcrResultText: 'Contract \u2116147\n\nTbilisi, March 10, 2026\n\nOn one hand, Barateli & Partners LLC (ID 404123456), represented by director Nino Barateli (hereinafter "Contractor") and on the other hand, Delta Group LLC (ID 404789012), represented by director Giorgi Mamulashvili (hereinafter "Client"), entered into this contract:\n\nArticle 1. Subject of Contract\n1.1. Contractor undertakes to provide legal services to Client.\n1.2. Service cost is 12,500 (twelve thousand five hundred) GEL.',
        docsOcrSuccess: "Successfully recognized \u2014 98.5% accuracy",
        docsRow1Meta: "#2024-047 \xb7 Claim \xb7 15 Mar",
        docsRow1Name: 'Claim - Mamulashvili.pdf',
        docsRow2Meta: "#2024-046 \xb7 Power of Attorney \xb7 12 Mar",
        docsRow2Name: 'Power of Attorney - Kvaratskhelia.pdf',
        docsRow3Meta: "#2024-045 \xb7 Notification \xb7 8 Mar",
        docsRow3Name: 'Notification - Gogiashvili.pdf',
        docsTextRecognition: 'Text recognition',
        docsUploadFormats: "JPG, PNG, PDF \u2014 max 10MB",
        docsUploadSub: 'Drag a file or click to select',
        ecourt: 'ecourt',
        ecourtDesc: "File claims, check case status and hearing schedule \u2014 without visiting court",
        enabledStatus: "\u2713 Enabled",
        evidencePending: "Evidence \u2014 Pending",
        extract: 'Extract',
        field1Text: 'Civil: Art. 316 amendment',
        field2Text: 'Civil: Art. 259 deadlines',
        field3Text: 'Administrative: e-service',
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 Mar, 10:00 \u2014 Tbilisi City Court",
        hearingItem2: "\uD83D\uDCC5 28 Mar, 14:30 \u2014 Court of Appeals",
        loginEmail: 'Email',
        matsne: 'matsne',
        matsneDesc: "Legislation changes automatically \u2014 in your practice area",
        outlook: 'Outlook',
        prepHearing: "Preparatory hearing \u2014 March 22",
        propertyApartment: "Apartment \u2014 Vake, 85 sq.m \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "Property extract \u2014 Added",
        registryDesc: "Company and property data automatically \u2014 no more manual extract downloads",
        timeEntry1Date: '18 Mar, 10:30',
        timeEntry1Text: 'Case opened, initial consultation completed',
        timeEntry2Date: '17 Mar, 14:00',
        timeEntry2Text: 'Client provided documentation',
        timeEntry3Date: '15 Mar, 09:00',
        timeEntry3Text: 'Client contacted firm, initial application',
        typeCivil: 'Civil',
        typeAdministrative: 'Administrative',
        typeCriminal: 'Criminal',
        pitchArpuMonth: 'Average ARPU/month',
        pitchArpuYear: 'Average ARPU/year',
        pitchAutoBackup: 'Automatic backup',
        pitchAutoNextSteps: 'Auto next steps',
        pitchAutoReminder: 'Auto reminder',
        pitchBooking: 'Booking',
        pitchCacOrganic: 'CAC (organic growth)',
        pitchCalcNote: "5000 lawyers \xd7 \u20BE35/month avg \xd7 12 months",
        pitchCalendarSync: 'Calendar sync',
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 hearings and deadlines sync automatically",
        pitchCaseManagement: 'Case management',
        pitchClientSchedule: 'Client schedule',
        pitchCloudDedicated: 'Dedicated Cloud',
        pitchCloudDedicatedDesc: "Isolated cloud server \u2014 your data fully separated from other clients",
        pitchContractAnalysis: 'Contract analysis',
        pitchCtaSubtext: 'Booking + Operations + AI',
        pitchDedicatedServer: 'Dedicated server',
        pitchDocDraftGeo: 'Doc drafting in Georgian',
        pitchEcourtDesc: "File claims, case status and hearing schedule \u2014 without visiting court",
        pitchGdprCompliant: 'GDPR compliant',
        pitchHybrid: 'Hybrid',
        pitchHybridDesc: "Cloud + local \u2014 sensitive data locally, rest in cloud",
        pitchIntegrationsSub: "Government services, calendars and OCR \u2014 from one platform",
        pitchInvoices: 'Invoices',
        pitchMatsneDesc: "Legislation changes automatically \u2014 in your practice area",
        pitchOcrDesc: "Automatic paper document digitization \u2014 no manual typing needed",
        pitchOnPremise: 'On-Premise Server',
        pitchOnPremiseDesc: "Fully local \u2014 data stays in your office, no internet access",
        pitchOperations: 'Operations',
        pitchPerkAiDocs: 'AI Documents',
        pitchPerkBookings: 'Booking management',
        pitchPerkClientPortal: 'Client portal',
        pitchPerkCommunication: 'Communication',
        pitchPerkFileStorage: 'File storage',
        pitchPerkResponsive: 'Responsive',
        pitchPrivacySubtitle: 'Legal data requires maximum protection',
        pitchPublicRegistryDesc: "Company and property data automatically \u2014 no manual extract downloads",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 March 2026",
        pitchRecurringModel: 'Recurring model',
        pitchRsGeDesc: "Tax debt and e-invoice \u2014 client status in one click",
        pitchScen250: '250 lawyers',
        pitchScen500: '500 lawyers',
        pitchScen1000: '1000 lawyers',
        pitchServerCost: 'Server cost/user',
        pitchTierBusiness10: '10+ lawyers',
        pitchTierEnterpriseCustom: 'Custom',
        pitchTierEnterprisePrice: 'Quote',
        pitchTierPro310: '3-10 lawyers',
        pitchTierStarter12: '1-2 lawyers',
        pitchTitle: 'TrustLegal for Georgia',
        pitchTrustedAccounting: 'Trusted accounting',
        pitchWhyAiCheap: 'AI tools are now affordable enough',
        pitchWhyDigitizing: 'Georgian legal market is rapidly digitizing',
        pitchWhyNoCompetitor: 'No established competitor',
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: 'Nino Barateli',
        settingsMember2Name: 'Giga Aslanishvili',
        settingsNotifyDeadlineReminder: 'Deadline reminder',
        settingsNotifyNewBookingEmail: "New booking \u2014 Email",
        settingsNotifyNewBookingWhatsapp: "New booking \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: 'Overdue invoice',
        settingsNotifyReminder24h: 'Reminder 24h before',
        settingsProfileName: 'Nino Barateli',
        settingsToggle3DaysBefore: '3 days before',
        portalCaseTypeCivil: 'Civil',
        portalDocDate1: '15 Mar',
        portalDocName1: 'Claim - Mamulashvili.pdf',
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: 'Due: 25 Mar',
        portalLastUpdate: 'Last update: 18 Mar',
        portalMsgFrom1: 'Nino Barateli',
        portalMsgPlaceholder: 'Send a message...',
        portalMsgText1: 'Hello Giorgi, we have a new update on the case.',
        portalMsgText2: 'Thanks, waiting for details.',
        portalNextHearing: 'Court hearing March 25',
        portalPay: 'Pay',
        portalPendingInvoices: 'Pending Invoices',
        portalProgressLabel: 'Progress: 3/5 steps',
        portalStatusActive: 'Active',
        clientDashCaseTypeCivil: 'Civil',
        clientDashDocMeta1: "Case #2024-047 \xb7 15 Mar",
        clientDashDocMeta2: "Case #2024-046 \xb7 12 Mar",
        clientDashDocName1: 'Claim - Mamulashvili.pdf',
        clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
        clientDashDocumentsTitle: 'Documents',
        clientDashInvCase1: 'Case: #2024-047',
        clientDashInvCase2: 'Case: #2024-046',
        clientDashInvDue1: 'Due: March 25, 2026',
        clientDashInvoicesTitle: 'Invoices',
        clientDashInvPaidDate: 'Paid: March 14, 2026',
        clientDashLawyerInitials: 'NB',
        clientDashLawyerName: 'Nino Barateli',
        clientDashLawyerRole: 'Your lawyer',
        clientDashMessagesTitle: 'Messages',
        clientDashMsgFrom1: 'Nino Barateli',
        clientDashMsgFrom3: 'Nino Barateli',
        clientDashMsgPlaceholder: 'Write a message...',
        clientDashMsgText1: 'Hello Giorgi, we have a new case update. Court scheduled hearing for March 25.',
        clientDashMsgText2: 'Thanks, waiting for details. Should I prepare any documents?',
        clientDashMsgText3: 'No, everything is ready. Will contact you a week before the hearing.',
        clientDashMsgTime1: "10:30 \xb7 Today",
        clientDashMsgTime2: "10:45 \xb7 Today",
        clientDashMsgTime3: "11:02 \xb7 Today",
        clientDashMyCases: 'My Cases',
        clientDashPaid: 'Paid',
        clientDashPay: 'Pay',
        clientDashProgressLabel: 'Progress: 3/5 steps completed',
        clientDashStatActiveCase: 'Active case',
        clientDashStatDocument: 'Document',
        clientDashStatNextHearing: 'Next hearing',
        clientDashStatNextHearingValue: '25 Mar',
        clientDashStatPayable: 'Payable',
        clientDashStatusActive: 'Active',
        clientDashStep1Date: '5 Mar, 2026',
        clientDashStep1Title: 'Consultation completed',
        clientDashStep2Date: '10 Mar, 2026',
        clientDashStep2Title: 'Claim drafted',
        clientDashStep3Date: '15 Mar, 2026',
        clientDashStep3Title: 'Claim filed in court',
        clientDashStep4Date: "25 Mar, 2026 \u2014 Pending",
        clientDashStep4Title: 'Court hearing',
        clientDashStep5Title: 'Decision',
        clientDashUnpaid: 'Unpaid',
        clientDashWelcomeSub: 'Here you can track your cases, invoices and documents.'
    },
    ka: {
        home: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8",
        dashboard: "\u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10D8",
        bookings: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        bookingPage: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
        aiDocuments: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        clientPortalNav: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8",
        lawyersNav: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D4\u10D1\u10D8",
        login: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0",
        getStarted: "\u10D3\u10D0\u10D8\u10EC\u10E7\u10D4\u10D7 \u10E3\u10E4\u10D0\u10E1\u10DD\u10D3",
        lawyersTitle: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D8\u10E3\u10E0\u10D8\u10D3\u10D8\u10E3\u10DA\u10D8 \u10E4\u10D8\u10E0\u10DB\u10D4\u10D1\u10D8",
        lawyersSubtitle: "\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8",
        searchPlaceholder: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D0 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7, \u10E4\u10D8\u10E0\u10DB\u10D8\u10D7 \u10D0\u10DC \u10E1\u10DE\u10D4\u10EA\u10D8\u10D0\u10DA\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10D7...",
        lawyersBtn: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D4\u10D1\u10D8",
        firmsBtn: "\u10E4\u10D8\u10E0\u10DB\u10D4\u10D1\u10D8",
        allFilter: "\u10E7\u10D5\u10D4\u10DA\u10D0",
        corporateLaw: "\u10D9\u10DD\u10E0\u10DE\u10DD\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        criminalLaw: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1",
        familyLaw: "\u10E1\u10D0\u10DD\u10EF\u10D0\u10EE\u10DD",
        realEstate: "\u10E3\u10EB\u10E0\u10D0\u10D5\u10D8 \u10E5\u10DD\u10DC\u10D4\u10D1\u10D0",
        taxLaw: "\u10E1\u10D0\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10DD",
        ipLaw: "\u10D8\u10DC\u10E2\u10D4\u10DA\u10D4\u10E5\u10E2\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8",
        immigration: "\u10D8\u10DB\u10D8\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0",
        laborLaw: "\u10E8\u10E0\u10DD\u10DB\u10D8\u10E1",
        bankingFinance: "\u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D3\u10D0 \u10E4\u10D8\u10DC\u10D0\u10DC\u10E1\u10D4\u10D1\u10D8",
        firmsMatch: "\u10E4\u10D8\u10E0\u10DB\u10D0 \u10E8\u10D4\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D4\u10D1\u10D0",
        lawyersMatch: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8 \u10E8\u10D4\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D4\u10D1\u10D0",
        reviews: "\u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        loadingMore: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0...",
        independent: "\u10D3\u10D0\u10DB\u10DD\u10E3\u10D9\u10D8\u10D3\u10D4\u10D1\u10D4\u10DA\u10D8",
        yearsExperience: "\u10EC\u10DA\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10EA\u10D3\u10D8\u10DA\u10D4\u10D1\u10D0",
        languages: "\u10D4\u10DC\u10D4\u10D1\u10D8",
        backToDirectory: "\u2190 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D8\u10E0\u10D4\u10E5\u10E2\u10DD\u10E0\u10D8\u10D0\u10E8\u10D8",
        about: "\u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1",
        bookConsultation: "\u10D9\u10DD\u10DC\u10E1\u10E3\u10DA\u10E2\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D0",
        sendMessage: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        call: "\u10D3\u10D0\u10E0\u10D4\u10D9\u10D5\u10D0",
        reviewsRatings: "\u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10E0\u10D4\u10D8\u10E2\u10D8\u10DC\u10D2\u10D4\u10D1\u10D8",
        reviewsComingSoon: "\u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D4\u10D1\u10D8 \u10DB\u10D0\u10DA\u10D4. \u10D8\u10E7\u10D0\u10D5\u10D8\u10D7 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10D5\u10D8\u10DC\u10EA \u10E8\u10D4\u10D0\u10E4\u10D0\u10E1\u10D4\u10D1\u10E1.",
        barId: "\u10E1\u10D0\u10D1\u10D0\u10E0\u10DD ID",
        ourTeam: "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10D2\u10E3\u10DC\u10D3\u10D8",
        contact: "\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8",
        website: "\u10D5\u10D4\u10D1\u10E1\u10D0\u10D8\u10E2\u10D8",
        established: "\u10D3\u10D0\u10D0\u10E0\u10E1.",
        lawyersCount: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        georgian: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        english: "\u10D8\u10DC\u10D2\u10DA\u10D8\u10E1\u10E3\u10E0\u10D8",
        russian: "\u10E0\u10E3\u10E1\u10E3\u10DA\u10D8",
        german: "\u10D2\u10D4\u10E0\u10DB\u10D0\u10DC\u10E3\u10DA\u10D8",
        french: "\u10E4\u10E0\u10D0\u10DC\u10D2\u10E3\u10DA\u10D8",
        turkish: "\u10D7\u10E3\u10E0\u10E5\u10E3\u10DA\u10D8",
        heroLine1: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8",
        heroLine2: "\u10D2\u10E3\u10DC\u10D3\u10D8. \u10D4\u10E0\u10D7\u10D8",
        heroLine3: "\u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0.",
        heroSubtitle: "TrustLegal \u2014 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8, \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8, \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8 \u10D3\u10D0 AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10E4\u10D8\u10E0\u10DB\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10D4\u10E0\u10D7\u10D8 \u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10E4\u10D0\u10E1\u10E3\u10E0\u10D8, \u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4.",
        tryFree: "\u10E3\u10E4\u10D0\u10E1\u10DD\u10D3 \u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u2192",
        liveDemo: "\u10DA\u10D0\u10D8\u10D5 \u10D3\u10D4\u10DB\u10DD",
        trustedBrands: "\u10E9\u10D5\u10D4\u10DC\u10D7\u10D0\u10DC \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D4\u10DC \u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8 \u10D0\u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10D4\u10D1\u10D7",
        howItWorks: "\u10E0\u10DD\u10D2\u10DD\u10E0 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10E1",
        processLabel: "// \u10DE\u10E0\u10DD\u10EA\u10D4\u10E1\u10D8",
        step1Title: "\u10D3\u10D0\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D3\u10D8\u10D7",
        step1Desc: "\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8\u10D7 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8 \u10D3\u10D0 \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D2\u10D4\u10D2\u10DB\u10D0. \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD \u2014 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 30 \u10D3\u10E6\u10D4 \u10E3\u10E4\u10D0\u10E1\u10DD\u10D0.",
        step2Title: "\u10DB\u10D0\u10E0\u10D7\u10D4\u10D7 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        step2Desc: "\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8, \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8. \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0.",
        step3Title: "AI-\u10D8\u10D7 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0",
        step3Desc: "AI-\u10D6\u10D4 \u10D3\u10D0\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3. \u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8, \u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0, \u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8.",
        step4Title: "\u10D2\u10D0\u10D8\u10D6\u10D0\u10E0\u10D3\u10D4\u10D7",
        step4Desc: "\u10D7\u10D5\u10D0\u10DA\u10E7\u10E3\u10E0\u10D8 \u10D0\u10D3\u10D4\u10D5\u10DC\u10D4\u10D7 \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10E1, \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10E1 \u10D3\u10D0 \u10D2\u10E3\u10DC\u10D3\u10D8\u10E1 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E3\u10DA\u10DD\u10D1\u10D0\u10E1. \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10E0\u10D4\u10D0\u10DA\u10E3\u10E0 \u10D3\u10E0\u10DD\u10E8\u10D8.",
        demoBadge: "// \u10DA\u10D0\u10D8\u10D5 \u10D3\u10D4\u10DB\u10DD",
        todaysBookings: "\u10D3\u10E6\u10D4\u10D5\u10D0\u10DC\u10D3\u10D4\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        fullDemo: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10D3\u10D4\u10DB\u10DD \u2192",
        onePlatformThreePillars: "\u10D4\u10E0\u10D7\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0.\n\u10E1\u10D0\u10DB\u10D8 \u10E1\u10D5\u10D4\u10E2\u10D8.",
        capabilitiesLabel: "// \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D4\u10D1\u10D8",
        bookingFeature: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        bookingFeatureDesc: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10D7\u10D0\u10D5\u10D0\u10D3 \u10D8\u10E0\u10E9\u10D4\u10D5\u10E1 \u10D3\u10E0\u10DD\u10E1. \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8. \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0. \u10E1\u10D0\u10EF\u10D0\u10E0\u10DD \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8.",
        operationsFeature: "\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        operationsFeatureDesc: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8\u10E1 \u10EA\u10D4\u10DC\u10E2\u10E0\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0. \u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8. \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8. \u10D2\u10E3\u10DC\u10D3\u10D8\u10E1 \u10DB\u10D4\u10DC\u10D4\u10EF\u10DB\u10D4\u10DC\u10E2\u10D8.",
        aiFeatureDesc: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3. \u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8. \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0. \u10D0\u10D5\u10E2\u10DD follow-up.",
        simplePricing: "\u10DB\u10D0\u10E0\u10E2\u10D8\u10D5\u10D8 \u10E4\u10D0\u10E1\u10D4\u10D1\u10D8",
        plansLabel: "// \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        perMonth: "/ \u10D7\u10D5\u10D4\u10E8\u10D8",
        bookingMgmt: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        caseTracking: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8\u10E1 \u10E2\u10E0\u10D4\u10D9\u10D8\u10DC\u10D2\u10D8",
        calendarSync: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        emailReminders: "\u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        starterPlan: "\u10E1\u10E2\u10D0\u10E0\u10E2\u10D4\u10E0\u10D8",
        startNow: "\u10D3\u10D0\u10D8\u10EC\u10E7\u10D4\u10D7 \u2192",
        everythingStarter: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10E1\u10E2\u10D0\u10E0\u10E2\u10D4\u10E0\u10D8-\u10D3\u10D0\u10DC",
        aiDocDrafting: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0",
        invoicesPayments: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8",
        clientPortalFeature: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8",
        directSupport: "\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D0",
        professionalPlan: "\u10DE\u10E0\u10DD\u10E4\u10D4\u10E1\u10D8\u10DD\u10DC\u10D0\u10DA\u10D8",
        mostPopular: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10D6\u10D4 \u10DE\u10DD\u10DE\u10E3\u10DA\u10D0\u10E0\u10E3\u10DA\u10D8",
        everythingPro: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10DE\u10E0\u10DD\u10E4\u10D4\u10E1\u10D8\u10DD\u10DC\u10D0\u10DA\u10D8-\u10D3\u10D0\u10DC",
        teamMgmt10: "\u10D2\u10E3\u10DC\u10D3\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0 (10+ \u10D8\u10E3\u10E0\u10D8\u10E1\u10E2\u10D8)",
        contractAnalysis: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8",
        advancedAnalytics: "\u10DB\u10DD\u10EC\u10D8\u10DC\u10D0\u10D5\u10D4 \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
        personalOnboarding: "\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DD\u10DC\u10D1\u10DD\u10E0\u10D3\u10D8\u10DC\u10D2\u10D8",
        businessPlan: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1\u10D8",
        spotsLeft: "3 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D8 \u10D3\u10D0\u10E0\u10E9\u10D0",
        enterpriseNote: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6\u10D8 \u2014 \u10E8\u10D4\u10D2\u10D5\u10D4\u10EE\u10DB\u10D8\u10D0\u10DC\u10D4\u10D7 \u10D8\u10DC\u10D3\u10D8\u10D5\u10D8\u10D3\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        readyQuestion: "\u10DB\u10D6\u10D0\u10D3 \u10EE\u10D0\u10E0\u10D7?",
        first30DaysFree: "\u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 30 \u10D3\u10E6\u10D4 \u10E3\u10E4\u10D0\u10E1\u10DD\u10D0. \u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4. \u10D2\u10D0\u10D0\u10E3\u10E5\u10DB\u10D4\u10D7 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1.",
        footerTagline: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 SaaS \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0.",
        productLabel: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8",
        companyLabel: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0",
        bookingsLink: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        casesLink: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        aiDocsLink: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        aboutUs: "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1",
        careers: "\u10D9\u10D0\u10E0\u10D8\u10D4\u10E0\u10D0",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: 'Built with Symbols',
        sidebarMain: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8",
        sidebarBookings: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        sidebarCases: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        sidebarClients: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        sidebarDocs: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        sidebarPayments: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10D4\u10D1\u10D8",
        sidebarLawyers: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D4\u10D1\u10D8",
        sidebarSettings: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8",
        sidebarLogout: "\u10D2\u10D0\u10E1\u10D5\u10DA\u10D0",
        bookingsTitle: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        newBooking: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        newBookingTitle: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        clientName: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8",
        phoneNumber: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8",
        civilLaw: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        criminalLaw2: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8",
        administrativeLaw: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        otherType: "\u10E1\u10EE\u10D5\u10D0",
        notesPlaceholder: "\u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10D1\u10D8...",
        confirmBooking: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        cancelBtn: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0",
        calendarSyncNote: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8 \u2014 Google Calendar, Outlook, Apple Calendar \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D3\u10D4\u10D1\u10D0",
        synced: "\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
        calendarSync2: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        syncedStatus: "\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8",
        bookingsToday: "3 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \u10D3\u10E6\u10D4\u10E1",
        settingsLink: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8 \u2192",
        pendingStatus: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        connectionNeeded: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D0 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0",
        connectLink: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D0 \u2192",
        lastSync: "\u10D1\u10DD\u10DA\u10DD \u10E1\u10D8\u10DC\u10E5\u10E0: 5 \u10EC\u10D7 \u10EC\u10D8\u10DC",
        mon: "\u10DD\u10E0\u10E8",
        tue: "\u10E1\u10D0\u10DB",
        wed: "\u10DD\u10D7\u10EE",
        thu: "\u10EE\u10E3\u10D7",
        fri: "\u10DE\u10D0\u10E0",
        bookingDetails: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8",
        confirmed: "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        pending: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        upcomingBookings: "\u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        closeBtn: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
        selectDateTime: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10D3\u10E0\u10DD",
        fillInfo: "\u10E8\u10D4\u10D0\u10D5\u10E1\u10D4\u10D7 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u2014 ",
        firstName: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8",
        lastName: "\u10D2\u10D5\u10D0\u10E0\u10D8",
        phoneField: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8",
        emailField: "\u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D0",
        caseDescription: "\u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10DB\u10DD\u10D9\u10DA\u10D4 \u10D0\u10E6\u10EC\u10D4\u10E0\u10D0",
        confirmBookingPublic: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        goBack: "\u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0",
        bookingConfirmedMsg: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0!",
        timeLabel: "\u10D3\u10E0\u10DD: ",
        lawGroupBarateli: "\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        ninoBarateli: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        casesTitle: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        searchPlaceholder2: "\u10EB\u10D4\u10D1\u10DC\u10D0...",
        newCase: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        allTab: "\u10E7\u10D5\u10D4\u10DA\u10D0",
        activeTab: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        pendingTab: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        closedTab: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8",
        selectCasePrompt: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D0\u10E5\u10DB\u10D4 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10DC\u10D0\u10EE\u10D0\u10D5\u10D0\u10D3",
        info: "\u10D8\u10DC\u10E4\u10DD",
        registry: "\u10E0\u10D4\u10D4\u10E1\u10E2\u10E0\u10D8",
        clientInfo: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0",
        chronology: "\u10E5\u10E0\u10DD\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0",
        addNote: "\u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        enterNote: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0...",
        addBtn: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        documentsLabel: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        createBtn: "+ \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0",
        noDocs: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
        hearingSchedule: "\u10E1\u10EE\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        caseStatus: "\u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8",
        electronicFiling: "\u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D0",
        idCode: "\u10E1/\u10D9\u10DD\u10D3\u10D8:",
        director: "\u10D3\u10D8\u10E0\u10D4\u10E5\u10E2\u10DD\u10E0\u10D8:",
        addressLabel: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8:",
        statusLabel: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8:",
        registeredProperty: "\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E5\u10DD\u10DC\u10D4\u10D1\u10D0",
        extractLabel: "\u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8",
        recentChanges: "\u10D1\u10DD\u10DA\u10DD \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        yourFieldChanges: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10E4\u10D4\u10E0\u10DD\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        newLabel: "\u10D0\u10EE\u10D0\u10DA\u10D8",
        notifications: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        clientsTitle: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        clientsSearchPlaceholder: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0...",
        clientsProfile: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8",
        clientsContactLabel: "\u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD",
        clientsInvoiceHistory: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        clientsUnpaid: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8",
        clientsPaid: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        clientsPortalInvite: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D6\u10D4 \u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        dashTodayBookings: "\u10D3\u10E6\u10D4\u10E1 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        dashUnpaid: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8",
        dashOverdue: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8",
        dashAiGenerations: "AI \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        dashTodaysBookings: "\u10D3\u10E6\u10D4\u10D5\u10D0\u10DC\u10D3\u10D4\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8",
        dashConfirmed: "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        dashRecentCases: "\u10D1\u10DD\u10DA\u10DD \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        dashNewBooking: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        dashNewCase: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        dashAiDocument: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8",
        docsTitle: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        docsCreate: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D0",
        docsExisting: "\u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        docsFiles: "\u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8",
        docsOcrScan: "\u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0",
        docsOcrTitle: "OCR \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0",
        docsUploadText: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E4\u10DD\u10E2\u10DD \u10D0\u10DC PDF",
        docsScanning: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0...",
        docsFile: "\u10E4\u10D0\u10D8\u10DA\u10D8",
        docsPages: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10D8",
        docsLanguage: "\u10D4\u10DC\u10D0",
        docsGeorgian: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        docsAddToCase: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10E8\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        docsCopy: "\u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0",
        docsRescan: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0 \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0",
        docsClaim: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8",
        docsPowerOfAttorney: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0",
        docsNotification: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0",
        docsContractReview: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0",
        docsFreeForm: "\u10D7\u10D0\u10D5\u10D8\u10E1\u10E3\u10E4\u10D0\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0",
        docsParty1: "\u10DB\u10EE\u10D0\u10E0\u10D4 1",
        docsNameCompany: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 / \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0",
        docsParty2: "\u10DB\u10EE\u10D0\u10E0\u10D4 2",
        docsDate: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        docsAdditionalInfo: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0",
        docsGenerating: "\u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0...",
        docsGenerate: "\u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        docsGeneratedDocument: "\u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8",
        docsEmptyState: "\u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u10D0\u10E5",
        docsShowDemo: "\u10D3\u10D4\u10DB\u10DD \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0",
        docsDownload: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        docsSend: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        docsCreatedDocuments: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        docsSearch: "\u10EB\u10D4\u10D1\u10DC\u10D0...",
        docsFileManager: "\u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D4\u10DC\u10D4\u10EF\u10D4\u10E0\u10D8",
        docsUpload: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        docsCases: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        docsTemplates: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8",
        docsRecentFiles: "\u10D1\u10DD\u10DA\u10DD \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8",
        billingTitle: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10D4\u10D1\u10D8",
        billingNewInvoice: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        billingTotalSent: "\u10E1\u10E3\u10DA \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
        billingPaid: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        billingUnpaid: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8",
        billingOverdue: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8",
        billingActive: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        billingClientStatus: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8",
        billingEInvoice: "\u10D4-\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        billingAutoCheck: "\u10D0\u10D5\u10E2\u10DD-\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        billingSettings: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8 \u2192",
        billingInvoice: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        billingClient: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8",
        billingCase: "\u10E1\u10D0\u10E5\u10DB\u10D4",
        billingAmount: "\u10D7\u10D0\u10DC\u10EE\u10D0",
        billingDue: "\u10D5\u10D0\u10D3\u10D0",
        billingStatus: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8",
        aiTitle: "AI \u10D3\u10D0\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4",
        aiPowered: 'Powered by AI',
        aiDraftDocs: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0",
        aiContractAnalysis: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8",
        aiLegalResearch: "\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
        aiDraftAvailable: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4",
        aiGoToDocuments: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0 \u2192",
        aiPasteContract: "\u10E9\u10D0\u10E1\u10D5\u10D8\u10D7 \u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8 \u10D0\u10E5...",
        aiAnalyze: "\u10D2\u10D0\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D4\u10D7",
        aiReanalyze: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0 \u10D2\u10D0\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D4\u10D7",
        aiParties: "\u10DB\u10EE\u10D0\u10E0\u10D4\u10D4\u10D1\u10D8",
        aiObligations: "\u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        aiRiskFactors: "\u10E0\u10D8\u10E1\u10D9-\u10E4\u10D0\u10E5\u10E2\u10DD\u10E0\u10D4\u10D1\u10D8",
        aiDeadlines: "\u10D5\u10D0\u10D3\u10D4\u10D1\u10D8",
        aiRecommendations: "\u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        aiAskQuestion: "\u10D3\u10D0\u10E1\u10D5\u10D8\u10D7 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D6\u10D4",
        aiLegalResearchTitle: "AI \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
        aiAskPlaceholder: "\u10D3\u10D0\u10E1\u10D5\u10D8\u10D7 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0...",
        aiSend: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        pitchTagline: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 SAAS",
        pitchSubtitle: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \xb7 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8 \xb7 AI \u2014 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E4\u10D8\u10E0\u10DB\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        pitchCta: "\u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0 \u2192",
        pitchMarketLabel: "// \u10D1\u10D0\u10D6\u10D0\u10E0\u10D8",
        pitchMarketTitle: "5000+ \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8",
        pitchPopulation: "\u10DB\u10DD\u10E1\u10D0\u10EE\u10DA\u10D4\u10DD\u10D1\u10D0",
        pitchTbilisi: "\u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8",
        pitchConcentrated: "\u10D9\u10DD\u10DC\u10EA\u10D4\u10DC\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D1\u10D0\u10D6\u10D0\u10E0\u10D8",
        pitchZeroCompetitor: "\u10D0\u10D3\u10D2\u10D8\u10DA\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 SaaS \u10D9\u10DD\u10DC\u10D9\u10E3\u10E0\u10D4\u10DC\u10E2\u10D8",
        pitchProblemLabel: "// \u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D0",
        pitchProblemTitle: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E4\u10D8\u10E0\u10DB\u10D4\u10D1\u10D8 \u10D3\u10E6\u10D4\u10DB\u10D3\u10D4 WhatsApp-\u10E1\u10D0 \u10D3\u10D0 Excel-\u10D6\u10D4 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D4\u10DC",
        pitchNoBooking: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1",
        pitchManualCases: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0 \u10EE\u10D4\u10DA\u10D8\u10D7",
        pitchNoAiTools: "AI \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1",
        pitchCapabilitiesLabel: "// \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D4\u10D1\u10D8",
        pitchOnePlatform: "\u10D4\u10E0\u10D7\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0. \u10E1\u10D0\u10DB\u10D8 \u10E1\u10D5\u10D4\u10E2\u10D8.",
        pitchProductLabel: "// \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8",
        pitchProductTitle: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10D4\u10E0\u10D7 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0\u10E8\u10D8",
        pitchIntegrationsLabel: "// \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        pitchIntegrationsTitle: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0, \u10D0\u10E0\u10D0 \u10EE\u10D4\u10DA\u10D8\u10D7 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D0",
        pitchPublicRegistry: "\u10E1\u10D0\u10EF\u10D0\u10E0\u10DD \u10E0\u10D4\u10D4\u10E1\u10E2\u10E0\u10D8",
        pitchCalendarSyncTitle: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8",
        pitchOcrTitle: "OCR \u10D3\u10D0 \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0",
        pitchPlansLabel: "// \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        pitchPlansTitle: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10D1\u10D0\u10D6\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D3\u10D0\u10D3\u10D4\u10D1\u10D0",
        pitchTierStarter: "\u10E1\u10E2\u10D0\u10E0\u10E2\u10D4\u10E0\u10D8",
        pitchMostPopular: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10D6\u10D4 \u10DE\u10DD\u10DE\u10E3\u10DA\u10D0\u10E0\u10E3\u10DA\u10D8",
        pitchTierPro: "\u10DE\u10E0\u10DD\u10E4\u10D4\u10E1\u10D8\u10DD\u10DC\u10D0\u10DA\u10D8",
        pitchTierBusiness: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1\u10D8",
        pitchTierEnterprise: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6\u10D8",
        pitchRevenueLabel: "// \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
        pitchRevenueTitle: "\u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10DA\u10D8\u10E1 \u10DE\u10DD\u10E2\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10D8",
        pitchFinanceLabel: "// \u10E4\u10D8\u10DC\u10D0\u10DC\u10E1\u10D4\u10D1\u10D8",
        pitchFinanceTitle: "\u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D8\u10E1 \u10D4\u10D9\u10DD\u10DC\u10DD\u10DB\u10D8\u10D9\u10D0",
        pitchTimeLabel: "// \u10D3\u10E0\u10DD",
        pitchTimeTitle: "\u10D3\u10E0\u10DD \u10E1\u10EC\u10DD\u10E0\u10D8\u10D0",
        pitchPrivacyLabel: "// \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D0",
        pitchPrivacyTitle: "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D0 \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8\u10D0",
        pitchCtaLabel: "// \u10D0\u10D5\u10D0\u10E8\u10D4\u10DC\u10DD\u10D7 \u10D4\u10E0\u10D7\u10D0\u10D3",
        pitchCtaTitle: "\u10D0\u10D5\u10D0\u10E8\u10D4\u10DC\u10DD\u10D7 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D8\u10DC\u10E4\u10E0\u10D0\u10E1\u10E2\u10E0\u10E3\u10E5\u10E2\u10E3\u10E0\u10D0",
        pitchCtaLink: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u2192",
        pitchPerMonth: "\u10D7\u10D5\u10D4\u10E8\u10D8",
        settingsTitle: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8",
        settingsTabProfile: "\u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8",
        settingsTabFirm: "\u10E4\u10D8\u10E0\u10DB\u10D0",
        settingsTabTeam: "\u10D2\u10E3\u10DC\u10D3\u10D8",
        settingsTabNotifications: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        settingsUploadPhoto: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        settingsSave: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0",
        settingsFirmAddress: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        settingsFirmRegNumber: "\u10E1\u10D0\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10DD \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        settingsPublicBookingUrl: "\u10E1\u10D0\u10EF\u10D0\u10E0\u10DD \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D1\u10DB\u10E3\u10DA\u10D8",
        settingsTeamMembers: "\u10D2\u10E3\u10DC\u10D3\u10D8\u10E1 \u10EC\u10D4\u10D5\u10E0\u10D4\u10D1\u10D8",
        settingsInvite: "+ \u10DB\u10DD\u10EC\u10D5\u10D4\u10D5\u10D0",
        settingsRoleOwner: "\u10DB\u10E4\u10DA\u10DD\u10D1\u10D4\u10DA\u10D8",
        settingsRoleLawyer: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        settingsNotifyTitle: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8",
        settingsToggleOn: "\u10E9\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        settingsToggleOff: "\u10D2\u10D0\u10DB\u10DD\u10E0\u10D7\u10E3\u10DA\u10D8",
        loginSubtitle: "\u10E8\u10D4\u10D3\u10D8\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E8\u10D8",
        loginLawyer: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        loginClient: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8",
        loginPassword: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8",
        loginSubmit: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0 \u2192",
        loginCaseNumber: "\u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        loginBackLink: "\u2190 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0",
        portalLogout: "\u10D2\u10D0\u10E1\u10D5\u10DA\u10D0",
        portalWelcome: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0,",
        portalActiveCases: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        portalDocuments: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        portalMessages: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        portalSend: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        clientDashNavCases: "\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        clientDashNavInvoices: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8",
        clientDashNavDocuments: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        clientDashNavMessages: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        clientDashLogout: "\u10D2\u10D0\u10E1\u10D5\u10DA\u10D0",
        clientDashWelcome: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0,",
        clientDashDownload: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        clientDashSend: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        findLawyer: "\u10D8\u10DE\u10DD\u10D5\u10D4\u10D7 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        lawyersSearchSub: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 5,700+ \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8, \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D7\u10D0 \u10D0\u10E1\u10DD\u10EA\u10D8\u10D0\u10EA\u10D8\u10D0\u10E8\u10D8",
        searchBtn: "\u10EB\u10D4\u10D1\u10DC\u10D0",
        viewAll: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
        lawyerPortal: "\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8",
        aiFeature: 'AI',
        aiChip1: "\u10DC\u10DD\u10E2\u10D0\u10E0\u10D8\u10E3\u10DA\u10D8 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D1\u10D0\u10D7\u10D8\u10DA\u10D4\u10D1\u10D0",
        aiChip1Question: "\u10E0\u10D0 \u10D0\u10E0\u10D8\u10E1 \u10DC\u10DD\u10E2\u10D0\u10E0\u10D8\u10E3\u10DA\u10D8 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D1\u10D0\u10D7\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8?",
        aiChip2: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8 317-\u10D4 \u10DB\u10E3\u10EE\u10DA\u10D8",
        aiChip2Question: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8\u10E1 317-\u10D4 \u10DB\u10E3\u10EE\u10DA\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D0",
        aiChip3: "\u10D2\u10D0\u10E0\u10D8\u10D2\u10D4\u10D1\u10D8\u10E1 \u10D1\u10D0\u10D7\u10D8\u10DA\u10DD\u10D1\u10D0",
        aiChip3Question: "\u10D1\u10DD\u10DA\u10DD 3 \u10EC\u10DA\u10D8\u10E1 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD \u10DE\u10E0\u10D0\u10E5\u10E2\u10D8\u10D9\u10D0 \u10D2\u10D0\u10E0\u10D8\u10D2\u10D4\u10D1\u10D8\u10E1 \u10D1\u10D0\u10D7\u10D8\u10DA\u10DD\u10D1\u10D0\u10D6\u10D4",
        aiDeadlinesData: "\u2022 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0: \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC 10 \u10D3\u10E6\u10D4\n\u2022 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0: 2026 \u10EC\u10DA\u10D8\u10E1 1 \u10D0\u10DE\u10E0\u10D8\u10DA\u10D8\n\u2022 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0: 12 \u10D7\u10D5\u10D4",
        aiEmptyChatSub: "AI \u2014 \u10D3\u10D0\u10E1\u10D5\u10D8\u10D7 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10D8\u10E6\u10D4\u10D7 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D6\u10D4",
        aiObligationsData: "1. \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EC\u10D4\u10D5\u10D0 30 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10E3\u10DA\u10D8 \u10D3\u10E6\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0\u10E8\u10D8\n2. \u10D0\u10DC\u10D0\u10D6\u10E6\u10D0\u10E3\u10E0\u10D4\u10D1\u10D0 15 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D4\u10E8\u10D8\n3. \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D0 3 \u10EC\u10DA\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8",
        aiPartiesData: '\u10DB\u10EE\u10D0\u10E0\u10D4 1: \u10E8\u10DE\u10E1 \u201E\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D4\u10D1\u10D8"\n\u10DB\u10EE\u10D0\u10E0\u10D4 2: \u10E8\u10DE\u10E1 \u201E\u10D3\u10D4\u10DA\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"',
        aiRecommendationsData: "1. \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10DE\u10D8\u10E0\u10D2\u10D0\u10E1\u10D0\u10DB\u10E2\u10D4\u10EE\u10DA\u10DD\u10E1 \u10DB\u10E3\u10EE\u10DA\u10D8 (\u10E1\u10D0\u10E5. \u10E1\u10D0\u10DB. \u10D9\u10DD\u10D3. 417-\u10D4 \u10DB\u10E3\u10EE\u10DA\u10D8)\n2. \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D4\u10D7 \u10D3\u10D0\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D0 \u10D0\u10E0\u10D1\u10D8\u10E2\u10E0\u10D0\u10DF\u10D8\u10D7\n3. \u10D2\u10D0\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D5\u10D4\u10D7 \u10E4\u10DD\u10E0\u10E1-\u10DB\u10D0\u10DF\u10DD\u10E0\u10D8\u10E1 \u10DB\u10E3\u10EE\u10DA\u10D8",
        aiRisksData: "\u2022 \u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10D2\u10D0\u10E1\u10D0\u10DB\u10E2\u10D4\u10EE\u10DA\u10DD \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10E3\u10DA\u10D8\n\u2022 \u10D3\u10D0\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10DB\u10D4\u10E5\u10D0\u10DC\u10D8\u10D6\u10DB\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8\n\u2022 \u10E4\u10DD\u10E0\u10E1-\u10DB\u10D0\u10DF\u10DD\u10E0\u10D8\u10E1 \u10DB\u10E3\u10EE\u10DA\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EA\u10D0\u10D5\u10E1 \u10DE\u10D0\u10DC\u10D3\u10D4\u10DB\u10D8\u10D0\u10E1",
        address: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        addressVal: "\u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8, \u10ED\u10D0\u10D5\u10ED\u10D0\u10D5\u10D0\u10EB\u10D8\u10E1 12",
        appleCalendar: 'Apple Calendar',
        billingClient1: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        billingClient2: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
        billingClient3: "\u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        billingClientName: '\u10E8\u10DE\u10E1 \u201E\u10D3\u10D4\u10DA\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"',
        billingDue1: "25 \u10DB\u10D0\u10E0",
        billingDue2: "15 \u10DB\u10D0\u10E0",
        billingDue3: "10 \u10DB\u10D0\u10E0",
        billingEmailNotification: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0 \u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4",
        billingLastCheck: "\u10D1\u10DD\u10DA\u10DD \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0: \u10D3\u10E6\u10D4\u10E1",
        billingNoDebt: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1",
        billingRsBanner: "rs.ge \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0 \u2014 \u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E1\u10D0\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10DD \u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D4-\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8 \u10D4\u10E0\u10D7\u10D8 \u10D9\u10DA\u10D8\u10D9\u10D8\u10D7",
        billingRsTaxSystem: "rs.ge \u2014 \u10E1\u10D0\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10DD \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0",
        billingStatusPaid: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        billingStatusSent: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
        billingViewFull: "\u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10DC\u10D0\u10EE\u10D5\u10D0 \u2192",
        billingViewInvoices: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0 \u2192",
        billingWeeklyEnabled: "\u10E9\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8\u10D0 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D9\u10D5\u10D8\u10E0\u10D4\u10E3\u10DA\u10D8",
        caseRow1Title: "#2024-047 \u2014 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        caseRow2Title: "#2024-046 \u2014 \u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
        caseRow3Title: "#2024-045 \u2014 \u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        change1Date: "15 \u10DB\u10D0\u10E0\u10E2\u10D8 \u2014 \u10EB\u10D0\u10DA\u10D0\u10E8\u10D8: 1 \u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        change1Desc: "\u10D5\u10D0\u10D3\u10D0 30-\u10D3\u10D0\u10DC 45 \u10D3\u10E6\u10D4\u10DB\u10D3\u10D4 \u10D2\u10D0\u10D8\u10D6\u10D0\u10E0\u10D3\u10D0",
        change1Name: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8 \u2014 \u10DB\u10E3\u10EE. 316",
        change2Date: "12 \u10DB\u10D0\u10E0\u10E2\u10D8 \u2014 \u10EB\u10D0\u10DA\u10D0\u10E8\u10D8: 1 \u10DB\u10D0\u10D8\u10E1\u10D8",
        change2Desc: "\u10E1\u10D0\u10D0\u10DE\u10D4\u10DA\u10D0\u10EA\u10D8\u10DD \u10D5\u10D0\u10D3\u10D0 14-\u10D3\u10D0\u10DC 21 \u10D3\u10E6\u10D4\u10DB\u10D3\u10D4",
        change2Name: "\u10E1\u10D0\u10DE\u10E0\u10DD\u10EA\u10D4\u10E1\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8 \u2014 \u10D5\u10D0\u10D3\u10D4\u10D1\u10D8",
        claimAccepted: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u2014 17 \u10DB\u10D0\u10E0\u10E2\u10D8",
        claimFiled: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u2014 15 \u10DB\u10D0\u10E0\u10E2\u10D8",
        claimFiledDoc: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u2014 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8",
        clientName1: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        clientName2: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
        clientName3: "\u10DA\u10D4\u10DA\u10D0 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        companyExtractLoaded: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u2014 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA\u10D8",
        companyName: '\u10E8\u10DE\u10E1 \u201E\u10D3\u10D4\u10DA\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"',
        clientsActiveCases1: "1 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        clientsActiveCases2: "1 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        clientsActiveCases3: "0 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        clientsAvatar1: "\u10D2\u10DB",
        clientsAvatar2: "\u10DB\u10D9",
        clientsAvatar3: "\u10DA\u10D2",
        clientsCaseLink1: "#2024-047 \u2014 \u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        clientsCaseLink2: "#2024-046 \u2014 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
        clientsPaid1: "\u20BE2,400 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        clientsPaid2: "\u20BE800 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        clientsPaid3: "\u20BE1,800 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        dashAlertText: "2 \u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4 \u10D3\u10D0 \u20BE1,840 \u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8 \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        dashBooking1Time: "10:00 \u2014 \u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        dashBooking2Time: "11:30 \u2014 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        dashBooking3Time: "14:00 \u2014 \u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8",
        dashCaseMeta1: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \xb7 18 \u10DB\u10D0\u10E0",
        dashCaseMeta2: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \xb7 17 \u10DB\u10D0\u10E0",
        dashCaseMeta3: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8 \xb7 15 \u10DB\u10D0\u10E0",
        dashClient3Name: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10E9\u10D8\u10E5\u10DD\u10D5\u10D0\u10DC\u10D8",
        dashDate: "18 \u10DB\u10D0\u10E0\u10E2\u10D8, 2026",
        dashGreeting: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0, \u10DC\u10D8\u10DC\u10DD",
        dateMar15: "15 \u10DB\u10D0\u10E0",
        dateMar17: "17 \u10DB\u10D0\u10E0",
        dateMar18: "18 \u10DB\u10D0\u10E0",
        disabledStatus: "\u2014 \u10D2\u10D0\u10DB\u10DD\u10E0\u10D7\u10E3\u10DA\u10D8",
        docsContractScanPdf: "\u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0_\u10E1\u10D9\u10D0\u10DC\u10D8.pdf",
        docsDemoClaimText: '\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD, \u10E5. \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\n\n\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\n\n\u10DB\u10DD\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D4: \u10E8\u10DE\u10E1 \u201E\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D4\u10D1\u10D8"\n\u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4: \u10E8\u10DE\u10E1 \u201E\u10D3\u10D4\u10DA\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"\n\n\u10E4\u10D0\u10E5\u10E2\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D2\u10D0\u10E0\u10D4\u10DB\u10DD\u10D4\u10D1\u10D4\u10D1\u10D8:\n\n\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\u10D7 \u10DB\u10DD\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D4 \u10D8\u10D7\u10EE\u10DD\u10D5\u10E1 \u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10D0\u10D2\u10D0\u10DC \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1.\n\n\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0:\n\n1. \u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1 12,500 \u10DA\u10D0\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0\u10D6\u10D4\n2. \u10DE\u10D8\u10E0\u10D2\u10D0\u10E1\u10D0\u10DB\u10E2\u10D4\u10EE\u10DA\u10DD\u10E1 \u10D3\u10D0\u10D9\u10D8\u10E1\u10E0\u10D4\u10D1\u10D0\u10E1 1,875 \u10DA\u10D0\u10E0\u10D8\u10E1 \u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D8\u10D7\n3. \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD \u10EE\u10D0\u10E0\u10EF\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC\u10D0\u10D6\u10E6\u10D0\u10E3\u10E0\u10D4\u10D1\u10D0\u10E1\n\n\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8: 2026 \u10EC\u10DA\u10D8\u10E1 18 \u10DB\u10D0\u10E0\u10E2\u10D8\n\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0: ________________',
        docsDocument: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 \u10DB\u10D0\u10E0 2026",
        docsFile1Name: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 \u10DB\u10D0\u10E0 2026",
        docsFile2Name: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 - \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 \u10DB\u10D0\u10E0 2026",
        docsFile3Name: "\u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0 \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 \u10DB\u10D0\u10E0 2026",
        docsFile4Name: "\u10DE\u10D8\u10E0\u10D0\u10D3\u10DD\u10D1\u10D8\u10E1 \u10D0\u10E1\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 \u10DB\u10D0\u10E0 2026",
        docsFile5Name: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0 - \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        docsFolder1Count: "3 \u10E4\u10D0\u10D8\u10DA\u10D8",
        docsFolder1Name: "#2024-047 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        docsFolder2Count: "2 \u10E4\u10D0\u10D8\u10DA\u10D8",
        docsFolder2Name: "#2024-046 \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0",
        docsFolder3Count: "1 \u10E4\u10D0\u10D8\u10DA\u10D8",
        docsFolder3Name: "#2024-045 \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        docsFolder4Count: "5 \u10E4\u10D0\u10D8\u10DA\u10D8",
        docsFormatAnalysis: "\u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8...",
        docsFreeText: "\u10D7\u10D0\u10D5\u10D8\u10E1\u10E3\u10E4\u10D0\u10DA\u10D8 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8...",
        docsGeneratedClaimText: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD, \u10E5. \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\n\n\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\n\n\u10DB\u10DD\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D4: [\u10DB\u10EE\u10D0\u10E0\u10D4 1]\n\u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4: [\u10DB\u10EE\u10D0\u10E0\u10D4 2]\n\n\u10E4\u10D0\u10E5\u10E2\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D2\u10D0\u10E0\u10D4\u10DB\u10DD\u10D4\u10D1\u10D4\u10D1\u10D8:\n\n\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\u10D7 \u10DB\u10DD\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D4 \u10D8\u10D7\u10EE\u10DD\u10D5\u10E1 \u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10D0\u10D2\u10D0\u10DC \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3.\n\n\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10DA\u10D4\u10D1\u10D8:\n\n\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8\u10E1 316-\u10D4 \u10DB\u10E3\u10EE\u10DA\u10D8\u10E1 \u10D7\u10D0\u10DC\u10D0\u10EE\u10DB\u10D0\u10D3, \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10DB\u10DD\u10EE\u10D3\u10D4\u10E1 \u10EF\u10D4\u10E0\u10DD\u10D5\u10DC\u10D0\u10D3.\n\n\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0:\n\n\u10D6\u10D4\u10DB\u10DD\u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10D8\u10D7, \u10DB\u10DD\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D4 \u10D8\u10D7\u10EE\u10DD\u10D5\u10E1 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E1\u10D0\u10D2\u10D0\u10DC \u10DB\u10DD\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1.\n\n\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8: 2026 \u10EC\u10DA\u10D8\u10E1 18 \u10DB\u10D0\u10E0\u10E2\u10D8\n\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0: ________________",
        docsGeorgianSymbols: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD\u10D4\u10D1\u10D8",
        docsOcrNote: "OCR \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0 \u2014 \u10E5\u10D0\u10E6\u10D0\u10DA\u10D3\u10D8\u10E1 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10EA\u10D8\u10E4\u10E0\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0, \u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10D9\u10E0\u10D4\u10E4\u10D0 \u10D0\u10E6\u10D0\u10E0 \u10D3\u10D0\u10D2\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7",
        docsOcrResultText: '\u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0 \u2116147\n\n\u10E5. \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8, 2026 \u10EC\u10DA\u10D8\u10E1 10 \u10DB\u10D0\u10E0\u10E2\u10D8\n\n\u10D4\u10E0\u10D7\u10D8 \u10DB\u10EE\u10E0\u10D8\u10D5, \u10E8\u10DE\u10E1 \u201E\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D4\u10D1\u10D8" (\u10E1/\u10D9 404123456), \u10EC\u10D0\u10E0\u10DB\u10DD\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D3\u10D8\u10E0\u10D4\u10E5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 (\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u201E\u10E8\u10D4\u10DB\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8") \u10D3\u10D0 \u10DB\u10D4\u10DD\u10E0\u10D4 \u10DB\u10EE\u10E0\u10D8\u10D5, \u10E8\u10DE\u10E1 \u201E\u10D3\u10D4\u10DA\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8" (\u10E1/\u10D9 404789012), \u10EC\u10D0\u10E0\u10DB\u10DD\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D3\u10D8\u10E0\u10D4\u10E5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 (\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u201E\u10D3\u10D0\u10DB\u10D9\u10D5\u10D4\u10D7\u10D8"), \u10D3\u10D0\u10D3\u10D4\u10E1 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D6\u10D4:\n\n\u10DB\u10E3\u10EE\u10DA\u10D8 1. \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D2\u10D0\u10DC\u10D8\n1.1. \u10E8\u10D4\u10DB\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D8\u10E6\u10D4\u10D1\u10E1 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1 \u10D2\u10D0\u10E3\u10EC\u10D8\u10DD\u10E1 \u10D3\u10D0\u10DB\u10D9\u10D5\u10D4\u10D7\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0.\n1.2. \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 12,500 (\u10D7\u10DD\u10E0\u10DB\u10D4\u10E2\u10D8 \u10D0\u10D7\u10D0\u10E1 \u10EE\u10E3\u10D7\u10D0\u10E1\u10D8) \u10DA\u10D0\u10E0\u10E1.',
        docsOcrSuccess: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D0\u10DB\u10DD\u10D8\u10EA\u10DC\u10DD \u2014 98.5% \u10E1\u10D8\u10D6\u10E3\u10E1\u10E2\u10D4",
        docsRow1Meta: "#2024-047 \xb7 \u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \xb7 15 \u10DB\u10D0\u10E0",
        docsRow1Name: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 \xb7 12 \u10DB\u10D0\u10E0",
        docsRow2Name: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 - \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0 \xb7 8 \u10DB\u10D0\u10E0",
        docsRow3Name: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0 - \u10D2\u10DD\u10D2\u10D8\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        docsTextRecognition: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8\u10E1 \u10D0\u10DB\u10DD\u10EA\u10DC\u10DD\u10D1\u10D0",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u10DB\u10D0\u10E5\u10E1. 10MB",
        docsUploadSub: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D0\u10DC \u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        ecourt: 'ecourt',
        ecourtDesc: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\u10E1 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D0, \u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 \u10D3\u10D0 \u10E1\u10EE\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8 \u2014 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E8\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4",
        enabledStatus: "\u2713 \u10E9\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        evidencePending: "\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u2014 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        extract: "\u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8",
        field1Text: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD: \u10DB\u10E3\u10EE. 316 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D0",
        field2Text: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD: \u10DB\u10E3\u10EE. 259 \u10D5\u10D0\u10D3\u10D4\u10D1\u10D8",
        field3Text: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8: \u10D4\u10DA. \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 \u10DB\u10D0\u10E0, 10:00 \u2014 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10E1\u10D0\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        hearingItem2: "\uD83D\uDCC5 28 \u10DB\u10D0\u10E0, 14:30 \u2014 \u10E1\u10D0\u10D0\u10DE\u10D4\u10DA\u10D0\u10EA\u10D8\u10DD",
        loginEmail: 'Email',
        matsne: 'matsne',
        matsneDesc: "\u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u2014 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DE\u10E0\u10D0\u10E5\u10E2\u10D8\u10D9\u10D8\u10E1 \u10E1\u10E4\u10D4\u10E0\u10DD\u10E8\u10D8",
        outlook: 'Outlook',
        prepHearing: "\u10DB\u10DD\u10E1\u10D0\u10DB\u10D6\u10D0\u10D3\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0 \u2014 22 \u10DB\u10D0\u10E0\u10E2\u10D8",
        propertyApartment: "\u10D1\u10D8\u10DC\u10D0 \u2014 \u10D5\u10D0\u10D9\u10D4, 85 \u10D9\u10D5.\u10DB \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u10E5\u10DD\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u2014 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E3\u10DA\u10D8",
        registryDesc: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D3\u10D0 \u10E5\u10DD\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u2014 \u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10DB\u10DD\u10E2\u10D0\u10DC\u10D0 \u10D0\u10E6\u10D0\u10E0 \u10D3\u10D0\u10D2\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7",
        timeEntry1Date: "18 \u10DB\u10D0\u10E0, 10:30",
        timeEntry1Text: "\u10E1\u10D0\u10E5\u10DB\u10D4 \u10D2\u10D0\u10D8\u10EE\u10E1\u10DC\u10D0, \u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10D9\u10DD\u10DC\u10E1\u10E3\u10DA\u10E2\u10D0\u10EA\u10D8\u10D0 \u10E9\u10D0\u10E2\u10D0\u10E0\u10D3\u10D0",
        timeEntry2Date: "17 \u10DB\u10D0\u10E0, 14:00",
        timeEntry2Text: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10DB\u10D0 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10D0 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D0\u10EA\u10D8\u10D0",
        timeEntry3Date: "15 \u10DB\u10D0\u10E0, 09:00",
        timeEntry3Text: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10DB\u10D0 \u10D3\u10D0\u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D0 \u10E4\u10D8\u10E0\u10DB\u10D0\u10E1, \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D0\u10D3\u10D8 \u10D2\u10D0\u10DC\u10D0\u10EA\u10EE\u10D0\u10D3\u10D8",
        typeCivil: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        typeAdministrative: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        typeCriminal: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D0\u10DA\u10D8",
        pitchArpuMonth: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD ARPU/\u10D7\u10D5\u10D4",
        pitchArpuYear: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD ARPU/\u10EC\u10D4\u10DA\u10D8",
        pitchAutoBackup: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D1\u10D4\u10E5\u10D0\u10E4\u10D8",
        pitchAutoNextSteps: "\u10D0\u10D5\u10E2\u10DD \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10DC\u10D0\u10D1\u10D8\u10EF\u10D4\u10D1\u10D8",
        pitchAutoReminder: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D0",
        pitchBooking: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        pitchCacOrganic: "CAC (\u10DD\u10E0\u10D2\u10D0\u10DC\u10E3\u10DA\u10D8 \u10D6\u10E0\u10D3\u10D0)",
        pitchCalcNote: "5000 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8 \xd7 \u20BE35/\u10D7\u10D5\u10D4 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD \xd7 12 \u10D7\u10D5\u10D4",
        pitchCalendarSync: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0.",
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 \u10E1\u10EE\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D5\u10D0\u10D3\u10D4\u10D1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D3\u10D4\u10D1\u10D0",
        pitchCaseManagement: "\u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        pitchClientSchedule: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        pitchCloudDedicated: "Cloud \u10D2\u10D0\u10DB\u10DD\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8",
        pitchCloudDedicatedDesc: "\u10D8\u10D6\u10DD\u10DA\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8 \u10E6\u10E0\u10E3\u10D1\u10D4\u10DA\u10E8\u10D8 \u2014 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10E1\u10EE\u10D5\u10D0 \u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1\u10D2\u10D0\u10DC \u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10D2\u10D0\u10DB\u10DD\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0",
        pitchContractAnalysis: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8",
        pitchCtaSubtext: "\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 + \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8 + AI",
        pitchDedicatedServer: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8",
        pitchDocDraftGeo: "\u10D3\u10DD\u10D9. \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3",
        pitchEcourtDesc: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8\u10E1 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D0, \u10E1\u10D0\u10E5\u10DB\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 \u10D3\u10D0 \u10E1\u10EE\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8 \u2014 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E8\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4",
        pitchGdprCompliant: "GDPR \u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10D0\u10D3\u10D8",
        pitchHybrid: "\u10F0\u10D8\u10D1\u10E0\u10D8\u10D3\u10E3\u10DA\u10D8",
        pitchHybridDesc: "\u10E6\u10E0\u10E3\u10D1\u10D4\u10DA\u10D8 + \u10DA\u10DD\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u2014 \u10E1\u10D4\u10DC\u10E1\u10D8\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10DA\u10DD\u10D9\u10D0\u10DA\u10E3\u10E0\u10D0\u10D3, \u10D3\u10D0\u10DC\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8 \u10E6\u10E0\u10E3\u10D1\u10D4\u10DA\u10E8\u10D8",
        pitchIntegrationsSub: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10DB\u10EC\u10D8\u10E4\u10DD \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8, \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10E0\u10D4\u10D1\u10D8 \u10D3\u10D0 OCR \u2014 \u10D4\u10E0\u10D7\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D8\u10D3\u10D0\u10DC",
        pitchInvoices: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8",
        pitchMatsneDesc: "\u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u2014 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DE\u10E0\u10D0\u10E5\u10E2\u10D8\u10D9\u10D8\u10E1 \u10E1\u10E4\u10D4\u10E0\u10DD\u10E8\u10D8",
        pitchOcrDesc: "\u10E5\u10D0\u10E6\u10D0\u10DA\u10D3\u10D8\u10E1 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10EA\u10D8\u10E4\u10E0\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0 \u2014 \u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10D9\u10E0\u10D4\u10E4\u10D0 \u10D0\u10E6\u10D0\u10E0 \u10D3\u10D0\u10D2\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7",
        pitchOnPremise: "On-Premise \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8",
        pitchOnPremiseDesc: "\u10E1\u10E0\u10E3\u10DA\u10D8\u10D0\u10D3 \u10DA\u10DD\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u2014 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10DD\u10E4\u10D8\u10E1\u10E8\u10D8 \u10E0\u10E9\u10D4\u10D1\u10D0, \u10D8\u10DC\u10E2\u10D4\u10E0\u10DC\u10D4\u10E2\u10D6\u10D4 \u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4",
        pitchOperations: "\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        pitchPerkAiDocs: "AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        pitchPerkBookings: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        pitchPerkClientPortal: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8",
        pitchPerkCommunication: "\u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        pitchPerkFileStorage: "\u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0",
        pitchPerkResponsive: "\u10E0\u10D4\u10E1\u10DE\u10DD\u10DC\u10E1\u10D8\u10D5\u10D8",
        pitchPrivacySubtitle: "\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10D0\u10DA\u10E3\u10E0 \u10D3\u10D0\u10EA\u10D5\u10D0\u10E1 \u10DB\u10DD\u10D8\u10D7\u10EE\u10DD\u10D5\u10E1",
        pitchPublicRegistryDesc: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D3\u10D0 \u10E5\u10DD\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u2014 \u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10DB\u10DD\u10E2\u10D0\u10DC\u10D0 \u10D0\u10E6\u10D0\u10E0 \u10D3\u10D0\u10D2\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 \u10DB\u10D0\u10E0\u10E2\u10D8 2026",
        pitchRecurringModel: "\u10E0\u10D4\u10D9\u10E3\u10E0\u10D4\u10DC\u10E2\u10E3\u10DA\u10D8 \u10DB\u10DD\u10D3\u10D4\u10DA\u10D8",
        pitchRsGeDesc: "\u10E1\u10D0\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D0\u10D3\u10DD \u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D4-\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8 \u2014 \u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 \u10D4\u10E0\u10D7\u10D8 \u10D9\u10DA\u10D8\u10D9\u10D8\u10D7",
        pitchScen250: "250 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        pitchScen500: "500 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        pitchScen1000: "1000 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        pitchServerCost: "\u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8\u10E1 \u10EE\u10D0\u10E0\u10EF\u10D8/\u10DB\u10DD\u10DB\u10EE.",
        pitchTierBusiness10: "10+ \u10D8\u10E3\u10E0\u10D8\u10E1\u10E2\u10D8",
        pitchTierEnterpriseCustom: "\u10D8\u10DC\u10D3\u10D8\u10D5\u10D8\u10D3\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8",
        pitchTierEnterprisePrice: "\u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0",
        pitchTierPro310: "3-10 \u10D8\u10E3\u10E0\u10D8\u10E1\u10E2\u10D8",
        pitchTierStarter12: "1-2 \u10D8\u10E3\u10E0\u10D8\u10E1\u10E2\u10D8",
        pitchTitle: "TrustLegal \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1\u10D7\u10D5\u10D8\u10E1",
        pitchTrustedAccounting: "\u10E1\u10D0\u10DC\u10D3\u10DD \u10D1\u10E3\u10E6\u10D0\u10DA\u10E2\u10D4\u10E0\u10D8\u10D0",
        pitchWhyAiCheap: "AI \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D0\u10EE\u10DA\u10D0 \u10E1\u10D0\u10D9\u10DB\u10D0\u10E0\u10D8\u10E1\u10D0\u10D3 \u10D8\u10D0\u10E4\u10D8\u10D0",
        pitchWhyDigitizing: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D1\u10D0\u10D6\u10D0\u10E0\u10D8 \u10E1\u10EC\u10E0\u10D0\u10E4\u10D0\u10D3 \u10EA\u10D8\u10E4\u10E0\u10D3\u10D4\u10D1\u10D0",
        pitchWhyNoCompetitor: "\u10E9\u10D0\u10DB\u10DD\u10E7\u10D0\u10DA\u10D8\u10D1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DD\u10DC\u10D9\u10E3\u10E0\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
        settingsFirmName: '\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8 "\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8"',
        settingsMember1Name: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        settingsMember2Name: "\u10D2\u10D8\u10D2\u10D0 \u10D0\u10E1\u10DA\u10D0\u10DC\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        settingsNotifyDeadlineReminder: "\u10D5\u10D0\u10D3\u10D8\u10E1 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D0",
        settingsNotifyNewBookingEmail: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \u2014 Email",
        settingsNotifyNewBookingWhatsapp: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        settingsNotifyReminder24h: "\u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D0 24 \u10E1\u10D7-\u10D8\u10D7 \u10D0\u10D3\u10E0\u10D4",
        settingsProfileName: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        settingsToggle3DaysBefore: "3 \u10D3\u10E6\u10D8\u10D7 \u10D0\u10D3\u10E0\u10D4",
        portalCaseTypeCivil: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        portalDocDate1: "15 \u10DB\u10D0\u10E0",
        portalDocName1: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        portalFirmLogo: "\u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8 Legal",
        portalInvoiceDue: "\u10D5\u10D0\u10D3\u10D0: 25 \u10DB\u10D0\u10E0",
        portalLastUpdate: "\u10D1\u10DD\u10DA\u10DD \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0: 18 \u10DB\u10D0\u10E0",
        portalMsgFrom1: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        portalMsgPlaceholder: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0...",
        portalMsgText1: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8, \u10E1\u10D0\u10E5\u10DB\u10D4\u10D6\u10D4 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D2\u10D5\u10D0\u10E5\u10D5\u10E1.",
        portalMsgText2: "\u10DB\u10D0\u10D3\u10DA\u10DD\u10D1\u10D0, \u10D5\u10D4\u10DA\u10DD\u10D3\u10D4\u10D1\u10D8 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10E1.",
        portalNextHearing: "\u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0 25 \u10DB\u10D0\u10E0\u10E2\u10E1",
        portalPay: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        portalPendingInvoices: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D3\u10D4\u10DA\u10D8 \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8",
        portalProgressLabel: "\u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8: 3/5 \u10D4\u10E2\u10D0\u10DE\u10D8",
        portalStatusActive: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        clientDashCaseTypeCivil: "\u10E1\u10D0\u10DB\u10DD\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD",
        clientDashDocMeta1: "\u10E1\u10D0\u10E5\u10DB\u10D4 #2024-047 \xb7 15 \u10DB\u10D0\u10E0",
        clientDashDocMeta2: "\u10E1\u10D0\u10E5\u10DB\u10D4 #2024-046 \xb7 12 \u10DB\u10D0\u10E0",
        clientDashDocName1: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 - \u10DB\u10D0\u10DB\u10E3\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8.pdf",
        clientDashDocName2: "\u10DB\u10D8\u10DC\u10D3\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 - \u10D9\u10D5\u10D0\u10E0\u10D0\u10EA\u10EE\u10D4\u10DA\u10D8\u10D0.pdf",
        clientDashDocumentsTitle: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        clientDashInvCase1: "\u10E1\u10D0\u10E5\u10DB\u10D4: #2024-047",
        clientDashInvCase2: "\u10E1\u10D0\u10E5\u10DB\u10D4: #2024-046",
        clientDashInvDue1: "\u10D5\u10D0\u10D3\u10D0: 25 \u10DB\u10D0\u10E0\u10E2\u10D8, 2026",
        clientDashInvoicesTitle: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8",
        clientDashInvPaidDate: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8: 14 \u10DB\u10D0\u10E0\u10E2\u10D8, 2026",
        clientDashLawyerInitials: "\u10DC\u10D1",
        clientDashLawyerName: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        clientDashLawyerRole: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10D8",
        clientDashMessagesTitle: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        clientDashMsgFrom1: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        clientDashMsgFrom3: "\u10DC\u10D8\u10DC\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10DA\u10D8",
        clientDashMsgPlaceholder: "\u10D3\u10D0\u10EC\u10D4\u10E0\u10D4\u10D7 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0...",
        clientDashMsgText1: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8, \u10E1\u10D0\u10E5\u10DB\u10D4\u10D6\u10D4 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D2\u10D5\u10D0\u10E5\u10D5\u10E1. \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10DB \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0 \u10D3\u10D0\u10DC\u10D8\u10E8\u10DC\u10D0 25 \u10DB\u10D0\u10E0\u10E2\u10E1.",
        clientDashMsgText2: "\u10DB\u10D0\u10D3\u10DA\u10DD\u10D1\u10D0, \u10D5\u10D4\u10DA\u10DD\u10D3\u10D4\u10D1\u10D8 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10E1. \u10E0\u10D0\u10DB\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10EE\u10DD\u10DB \u10D0\u10E0 \u10E3\u10DC\u10D3\u10D0 \u10DB\u10DD\u10D5\u10D0\u10DB\u10D6\u10D0\u10D3\u10DD?",
        clientDashMsgText3: "\u10D0\u10E0\u10D0, \u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10DB\u10D6\u10D0\u10D3\u10D0\u10D0. \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0\u10DB\u10D3\u10D4 \u10D4\u10E0\u10D7\u10D8 \u10D9\u10D5\u10D8\u10E0\u10D8\u10D7 \u10D0\u10D3\u10E0\u10D4 \u10D9\u10D8\u10D3\u10D4\u10D5 \u10D3\u10D0\u10D2\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D1\u10D8\u10D7.",
        clientDashMsgTime1: "10:30 \xb7 \u10D3\u10E6\u10D4\u10E1",
        clientDashMsgTime2: "10:45 \xb7 \u10D3\u10E6\u10D4\u10E1",
        clientDashMsgTime3: "11:02 \xb7 \u10D3\u10E6\u10D4\u10E1",
        clientDashMyCases: "\u10E9\u10D4\u10DB\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8",
        clientDashPaid: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        clientDashPay: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        clientDashProgressLabel: "\u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8: 3/5 \u10D4\u10E2\u10D0\u10DE\u10D8 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        clientDashStatActiveCase: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E5\u10DB\u10D4",
        clientDashStatDocument: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8",
        clientDashStatNextHearing: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0",
        clientDashStatNextHearingValue: "25 \u10DB\u10D0\u10E0",
        clientDashStatPayable: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D3\u10D4\u10DA\u10D8",
        clientDashStatusActive: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        clientDashStep1Date: "5 \u10DB\u10D0\u10E0, 2026",
        clientDashStep1Title: "\u10D9\u10DD\u10DC\u10E1\u10E3\u10DA\u10E2\u10D0\u10EA\u10D8\u10D0 \u10E9\u10D0\u10E2\u10D0\u10E0\u10D3\u10D0",
        clientDashStep2Date: "10 \u10DB\u10D0\u10E0, 2026",
        clientDashStep2Title: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8\u10D0",
        clientDashStep3Date: "15 \u10DB\u10D0\u10E0, 2026",
        clientDashStep3Title: "\u10E1\u10D0\u10E0\u10E9\u10D4\u10DA\u10D8 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8\u10D0 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E8\u10D8",
        clientDashStep4Date: "25 \u10DB\u10D0\u10E0, 2026 \u2014 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        clientDashStep4Title: "\u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD \u10E1\u10EE\u10D3\u10DD\u10DB\u10D0",
        clientDashStep5Title: "\u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D0",
        clientDashUnpaid: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10EE\u10D3\u10D4\u10DA\u10D8",
        clientDashWelcomeSub: "\u10D0\u10E5 \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D7\u10D5\u10D0\u10DA\u10D8 \u10D0\u10D3\u10D4\u10D5\u10DC\u10DD\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10E1, \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10E1."
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        dashboard: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434",
        bookings: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        bookingPage: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        aiDocuments: "\u0418\u0418-\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        clientPortalNav: "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        lawyersNav: "\u042E\u0440\u0438\u0441\u0442\u044B",
        login: "\u0412\u043E\u0439\u0442\u0438",
        getStarted: "\u041D\u0430\u0447\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
        lawyersTitle: "\u042E\u0440\u0438\u0441\u0442\u044B \u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0444\u0438\u0440\u043C\u044B",
        lawyersSubtitle: "\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        searchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438, \u0444\u0438\u0440\u043C\u0435 \u0438\u043B\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438...",
        lawyersBtn: "\u042E\u0440\u0438\u0441\u0442\u044B",
        firmsBtn: "\u0424\u0438\u0440\u043C\u044B",
        allFilter: "\u0412\u0441\u0435",
        corporateLaw: "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        criminalLaw: "\u0423\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        familyLaw: "\u0421\u0435\u043C\u0435\u0439\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        realEstate: "\u041D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C",
        taxLaw: "\u041D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        ipLaw: "\u0418\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
        immigration: "\u0418\u043C\u043C\u0438\u0433\u0440\u0430\u0446\u0438\u044F",
        laborLaw: "\u0422\u0440\u0443\u0434\u043E\u0432\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        bankingFinance: "\u0411\u0430\u043D\u043A\u0438 \u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u044B",
        firmsMatch: "\u0444\u0438\u0440\u043C \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        lawyersMatch: "\u044E\u0440\u0438\u0441\u0442\u043E\u0432 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        reviews: "\u043E\u0442\u0437\u044B\u0432\u043E\u0432",
        loadingMore: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
        independent: "\u041D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u044B\u0439",
        yearsExperience: "\u043B\u0435\u0442 \u043E\u043F\u044B\u0442\u0430",
        languages: "\u042F\u0437\u044B\u043A\u0438",
        backToDirectory: "\u2190 \u041D\u0430\u0437\u0430\u0434 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433",
        about: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        bookConsultation: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E",
        sendMessage: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
        call: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        reviewsRatings: "\u041E\u0442\u0437\u044B\u0432\u044B \u0438 \u043E\u0446\u0435\u043D\u043A\u0438",
        reviewsComingSoon: "\u041E\u0442\u0437\u044B\u0432\u044B \u0441\u043A\u043E\u0440\u043E \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F. \u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043E\u0442\u0437\u044B\u0432 \u043F\u0435\u0440\u0432\u044B\u043C.",
        barId: "\u041D\u043E\u043C\u0435\u0440 \u0432 \u0440\u0435\u0435\u0441\u0442\u0440\u0435",
        ourTeam: "\u041D\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430",
        contact: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B",
        website: "\u0412\u0435\u0431-\u0441\u0430\u0439\u0442",
        established: "\u041E\u0441\u043D.",
        lawyersCount: "\u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        georgian: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0439",
        english: "\u0410\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u0438\u0439",
        russian: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        german: "\u041D\u0435\u043C\u0435\u0446\u043A\u0438\u0439",
        french: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0439",
        turkish: "\u0422\u0443\u0440\u0435\u0446\u043A\u0438\u0439",
        heroLine1: "\u0412\u0430\u0448\u0430 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0430\u044F",
        heroLine2: "\u043A\u043E\u043C\u0430\u043D\u0434\u0430. \u041E\u0434\u043D\u0430",
        heroLine3: "\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.",
        heroSubtitle: "TrustLegal \u2014 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u0434\u0435\u043B\u0430, \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0441 \u0418\u0418 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0444\u0438\u0440\u043C. \u0415\u0434\u0438\u043D\u0430\u044F \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0430, \u0431\u0435\u0437 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430.",
        tryFree: "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u2192",
        liveDemo: "\u0416\u0438\u0432\u043E\u0435 \u0434\u0435\u043C\u043E",
        trustedBrands: "\u0411\u0440\u0435\u043D\u0434\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0432\u0430\u0436\u043D\u043E \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E, \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0441 \u043D\u0430\u043C\u0438",
        howItWorks: "\u041A\u0430\u043A \u044D\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442",
        processLabel: "// \u041F\u0440\u043E\u0446\u0435\u0441\u0441",
        step1Title: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F",
        step1Desc: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0438 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0430\u0440\u0438\u0444. \u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u2014 \u043F\u0435\u0440\u0432\u044B\u0435 30 \u0434\u043D\u0435\u0439 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E.",
        step2Title: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0435\u043B\u0430\u043C\u0438",
        step2Desc: "\u0414\u043E\u0431\uFFFD\uFFFD\u0432\u043B\u044F\u0439\u0442\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432, \u0434\u0435\u043B\u0430 \u0438 \u0437\u0430\u043F\u0438\u0441\u0438. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F \u0438 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0435\u043C.",
        step3Title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0441 \u0418\u0418",
        step3Desc: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0418\u0418. \u0418\u0441\u043A\u0438, \u0434\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0430\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432.",
        step4Title: "\u0420\u043E\u0441\u0442",
        step4Desc: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0441\u0447\u0435\u0442\u0430, \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u044B. \u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438.",
        demoBadge: "// \u0416\u0438\u0432\u043E\u0435 \u0434\u0435\u043C\u043E",
        todaysBookings: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
        fullDemo: "\u041F\u043E\u043B\u043D\u043E\u0435 \u0434\u0435\u043C\u043E \u2192",
        onePlatformThreePillars: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.\n\u0422\u0440\u0438 \u043E\u0441\u043D\u043E\u0432\u044B.",
        capabilitiesLabel: "// \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438",
        bookingFeature: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        bookingFeatureDesc: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B \u0441\u0430\u043C\u0438 \u0432\u044B\u0431\u0438\u0440\u0430\u044E\u0442 \u0432\u0440\u0435\u043C\u044F. \u0410\u0432\u0442\u043E-\u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F. \u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0441 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0435\u043C. \u041F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.",
        operationsFeature: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438",
        operationsFeatureDesc: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0435\u043B\u0430\u043C\u0438. \u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\uFFFD\uFFFD \u043F\u043E\u0440\u0442\u0430\u043B. \u0421\u0447\u0435\u0442\u0430 \u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0438. \u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
        aiFeatureDesc: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C. \u0410\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432. \u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044F. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0444\u043E\u043B\u043B\u043E\u0443-\u0430\u043F\u044B.",
        simplePricing: "\u041F\u0440\u043E\u0441\u0442\u044B\u0435 \u0442\u0430\u0440\u0438\u0444\u044B",
        plansLabel: "// \u0422\u0430\u0440\u0438\u0444\u044B",
        perMonth: "/ \u043C\u0435\u0441\u044F\u0446",
        bookingMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438",
        caseTracking: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0434\u0435\u043B",
        calendarSync: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        emailReminders: "Email-\u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F",
        starterPlan: "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439",
        startNow: "\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441 \u2192",
        everythingStarter: "\u0412\u0441\u0451 \u0438\u0437 \u0442\u0430\u0440\u0438\u0444\u0430 \u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439",
        aiDocDrafting: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0441 \u0418\u0418",
        invoicesPayments: "\u0421\u0447\u0435\u0442\u0430 \u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0438",
        clientPortalFeature: "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        directSupport: "\u041F\u0440\u044F\u043C\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        professionalPlan: "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439",
        mostPopular: "\u0421\u0430\u043C\u044B\u0439 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0439",
        everythingPro: "\u0412\u0441\u0451 \u0438\u0437 \u0442\u0430\u0440\u0438\u0444\u0430 \u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439",
        teamMgmt10: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439 (10+ \u044E\u0440\u0438\u0441\u0442\u043E\u0432)",
        contractAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432",
        advancedAnalytics: "\u041F\u0440\u043E\u0434\u0432\u0438\u043D\u0443\u0442\u0430\u044F \u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        personalOnboarding: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u043D\u0431\u043E\u0440\u0434\u0438\u043D\u0433",
        businessPlan: "\u0411\u0438\u0437\u043D\u0435\u0441",
        spotsLeft: "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C 3 \u043C\u0435\u0441\u0442\u0430",
        enterpriseNote: "Enterprise \u2014 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u0434\u043B\u044F \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F.",
        readyQuestion: "\u0413\u043E\u0442\u043E\u0432\u044B?",
        first30DaysFree: "\u041F\u0435\u0440\u0432\u044B\u0435 30 \u0434\u043D\u0435\u0439 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E. \u0411\u0435\u0437 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430. \u041E\u0442\u043C\u0435\u043D\u0430 \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F.",
        footerTagline: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0430\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0430\u044F SaaS-\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.",
        productLabel: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        companyLabel: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F",
        bookingsLink: "\u0417\u0430\u043F\u0438\u0441\u0438",
        casesLink: "\u0414\u0435\u043B\u0430",
        aiDocsLink: "\u0418\u0418-\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        aboutUs: "\u041E \u043D\u0430\u0441",
        careers: "\u041A\u0430\u0440\u044C\u0435\u0440\u0430",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "\u0421\u043E\u0437\u0434\u0430\u043D\u043E \u0441 Symbols",
        sidebarMain: "\u041F\u0430\u043D\u0435\u043B\u044C \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
        sidebarBookings: "\u0417\u0430\u043F\u0438\u0441\u0438",
        sidebarCases: "\u0414\u0435\u043B\u0430",
        sidebarClients: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B",
        sidebarDocs: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        sidebarPayments: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438",
        sidebarLawyers: "\u042E\u0440\u0438\u0441\u0442\u044B",
        sidebarSettings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        sidebarLogout: "\u0412\u044B\u0439\u0442\u0438",
        bookingsTitle: "\u0417\u0430\u043F\u0438\u0441\u0438",
        newBooking: "+ \u041D\u043E\u0432\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
        newBookingTitle: "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
        clientName: "\u0418\u043C\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
        phoneNumber: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        civilLaw: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435",
        criminalLaw2: "\u0423\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        administrativeLaw: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435",
        otherType: "\u0414\u0440\u0443\u0433\u043E\u0435",
        notesPlaceholder: "\u0417\u0430\u043C\u0435\u0442\u043A\u0438...",
        confirmBooking: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
        cancelBtn: "\u041E\u0442\u043C\u0435\u043D\u0430",
        calendarSyncNote: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F \u2014 Google Calendar, Outlook, Apple Calendar \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438",
        synced: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        calendarSync2: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        syncedStatus: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        bookingsToday: "3 \u0437\u0430\u043F\u0438\u0441\u0438 \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
        settingsLink: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u2192",
        pendingStatus: "\u0412 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438",
        connectionNeeded: "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435",
        connectLink: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u2192",
        lastSync: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F: 5 \u043C\u0438\u043D \u043D\u0430\u0437\u0430\u0434",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        bookingDetails: "\u0414\u0435\u0442\u0430\u043B\u0438 \u0437\u0430\u043F\u0438\u0441\u0438",
        confirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E",
        pending: "\u0412 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438",
        upcomingBookings: "\u041F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438",
        closeBtn: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
        selectDateTime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F",
        fillInfo: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u2014 ",
        firstName: "\u0418\u043C\u044F",
        lastName: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
        phoneField: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        emailField: 'Email',
        caseDescription: "\u041A\u0440\u0430\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0434\u0435\u043B\u0430",
        confirmBookingPublic: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        goBack: "\u041D\u0430\u0437\u0430\u0434",
        bookingConfirmedMsg: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E!",
        timeLabel: "\u0412\u0440\u0435\u043C\u044F: ",
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        casesTitle: "\u0414\u0435\u043B\u0430",
        searchPlaceholder2: "\u041F\u043E\u0438\u0441\u043A...",
        newCase: "+ \u041D\u043E\u0432\u043E\u0435 \u0434\u0435\u043B\u043E",
        allTab: "\u0412\u0441\u0435",
        activeTab: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
        pendingTab: "\u0412 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438",
        closedTab: "\u0417\u0430\u043A\u0440\u044B\u0442\u044B\u0435",
        selectCasePrompt: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0435\u043B\u043E \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0442\u0430\u043B\u0435\u0439",
        info: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
        registry: "\u0420\u0435\u0435\u0441\u0442\u0440",
        clientInfo: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0435",
        chronology: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F",
        addNote: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u043C\u0435\u0442\u043A\u0443",
        enterNote: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u0430\u043C\u0435\u0442\u043A\u0443...",
        addBtn: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
        documentsLabel: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        createBtn: "+ \u0421\u043E\u0437\u0434\u0430\u0442\u044C",
        noDocs: "\u041D\u0435\u0442 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        hearingSchedule: "\u0413\u0440\u0430\u0444\u0438\u043A \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0439",
        caseStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u0435\u043B\u0430",
        electronicFiling: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0434\u0430\u0447\u0430",
        idCode: "ID \u043A\u043E\u0434:",
        director: "\u0414\u0438\u0440\u0435\u043A\u0442\u043E\u0440:",
        addressLabel: "\u0410\u0434\u0440\u0435\u0441:",
        statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441:",
        registeredProperty: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E",
        extractLabel: "\u0412\u044B\u043F\u0438\u0441\u043A\u0430",
        recentChanges: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
        yourFieldChanges: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0432\u0430\u0448\u0435\u0439 \u0441\u0444\u0435\u0440\u0435",
        newLabel: "\u041D\u043E\u0432\u043E\u0435",
        notifications: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F",
        clientsTitle: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B",
        clientsSearchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432...",
        clientsProfile: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
        clientsContactLabel: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B",
        clientsInvoiceHistory: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0447\u0435\u0442\u043E\u0432",
        clientsUnpaid: "\u041D\u0435\u043E\u043F\u043B\uFFFD\uFFFD\u0447\u0435\u043D\u043D\u044B\u0435",
        clientsPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435",
        clientsPortalInvite: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u043C\u0443 \u043F\u043E\u0440\u0442\u0430\u043B\u0443",
        dashTodayBookings: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
        dashUnpaid: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435",
        dashOverdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0435",
        dashAiGenerations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u0418\u0418",
        dashTodaysBookings: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
        dashConfirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u0435",
        dashRecentCases: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 \u0434\u0435\u043B\u0430",
        dashNewBooking: "+ \u041D\u043E\u0432\u043E\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        dashNewCase: "+ \u041D\u043E\u0432\u043E\u0435 \u0434\u0435\u043B\u043E",
        dashAiDocument: "\u0418\u0418 \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsTitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        docsCreate: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C",
        docsExisting: "\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        docsFiles: "\u0424\u0430\u0439\u043B\u044B",
        docsOcrScan: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        docsOcrTitle: "OCR \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        docsUploadText: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u043E\u0442\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0438\u043B\u0438 PDF",
        docsScanning: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430...",
        docsFile: "\u0424\u0430\u0439\u043B",
        docsPages: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
        docsLanguage: "\u042F\u0437\u044B\u043A",
        docsGeorgian: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0439",
        docsAddToCase: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A \u0434\u0435\u043B\u0443",
        docsCopy: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        docsRescan: "\u041F\u0435\u0440\u0435\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        docsClaim: "\u0418\u0441\u043A",
        docsPowerOfAttorney: "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
        docsNotification: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435",
        docsContractReview: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
        docsFreeForm: "\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430",
        docsParty1: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1",
        docsNameCompany: "\u0418\u043C\u044F / \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F",
        docsParty2: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2",
        docsDate: "\u0414\u0430\u0442\u0430",
        docsAdditionalInfo: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F",
        docsGenerating: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F...",
        docsGenerate: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        docsGeneratedDocument: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsEmptyState: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C",
        docsShowDemo: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0434\u0435\u043C\u043E-\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsDownload: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
        docsSend: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        docsCreatedDocuments: "\u0421\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        docsSearch: "\u041F\u043E\u0438\u0441\u043A...",
        docsFileManager: "\u0424\u0430\u0439\u043B\u043E\u0432\u044B\u0439 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440",
        docsUpload: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
        docsCases: "\u0414\u0435\u043B\u0430",
        docsTemplates: "\u0428\u0430\u0431\u043B\u043E\u043D\u044B",
        docsRecentFiles: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B",
        billingTitle: "\u0411\u0438\u043B\u043B\u0438\u043D\u0433",
        billingNewInvoice: "\u041D\u043E\u0432\u044B\u0439 \u0441\u0447\u0435\u0442",
        billingTotalSent: "\u0412\u0441\u0435\u0433\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        billingPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingUnpaid: "\u041D\u0435 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingOverdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043E",
        billingActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E",
        billingClientStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
        billingEInvoice: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0441\u0447\u0435\u0442",
        billingAutoCheck: "\u0410\u0432\u0442\u043E\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430",
        billingSettings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u2192",
        billingInvoice: "\u0421\u0447\u0435\u0442",
        billingClient: "\u041A\u043B\u0438\u0435\u043D\u0442",
        billingCase: "\u0414\u0435\u043B\u043E",
        billingAmount: "\u0421\u0443\u043C\u043C\u0430",
        billingDue: "\u0421\u0440\u043E\u043A",
        billingStatus: "\u0421\u0442\u0430\u0442\u0443\u0441",
        aiTitle: "\u0418\u0418-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        aiPowered: "\u041D\u0430 \u0431\u0430\u0437\u0435 \u0418\u0418",
        aiDraftDocs: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        aiContractAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432",
        aiLegalResearch: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435",
        aiDraftAvailable: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        aiGoToDocuments: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C \u2192",
        aiPasteContract: "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\uFFFD\uFFFD\u0430 \u0437\u0434\u0435\u0441\u044C...",
        aiAnalyze: "\u0410\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        aiReanalyze: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0430\u043D\u0430\u043B\u0438\u0437",
        aiParties: "\u0421\u0442\u043E\u0440\u043E\u043D\u044B",
        aiObligations: "\u041A\u043B\u044E\u0447\u0435\u0432\u044B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",
        aiRiskFactors: "\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u0440\u0438\u0441\u043A\u0430",
        aiDeadlines: "\u0421\u0440\u043E\u043A\u0438",
        aiRecommendations: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438",
        aiAskQuestion: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441 \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0413\u0440\u0443\u0437\u0438\u0438",
        aiLegalResearchTitle: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0441 \u0418\u0418",
        aiAskPlaceholder: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441...",
        aiSend: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        pitchTagline: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 SaaS \u0413\u0440\u0443\u0437\u0438\u0438",
        pitchSubtitle: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \xb7 \u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \xb7 \u0418\u0418 \u2014 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0445 \u0444\u0438\u0440\u043C",
        pitchCta: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u2192",
        pitchMarketLabel: "// \u0420\u044B\u043D\u043E\u043A",
        pitchMarketTitle: "5000+ \u044E\u0440\u0438\u0441\u0442\u043E\u0432 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        pitchPopulation: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0435",
        pitchTbilisi: "\u0422\u0431\u0438\u043B\u0438\u0441\u0438",
        pitchConcentrated: "\u041A\u043E\u043D\u0446\u0435\u043D\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0440\u044B\u043D\u043E\u043A",
        pitchZeroCompetitor: "\u041C\u0435\u0441\u0442\u043D\u044B\u0439 SaaS-\u043A\u043E\u043D\u043A\u0443\u0440\u0435\u043D\u0442",
        pitchProblemLabel: "// \u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        pitchProblemTitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0435 \u0444\u0438\u0440\u043C\u044B \u0432\u0441\u0435 \u0435\u0449\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0432 WhatsApp \u0438 Excel",
        pitchNoBooking: "\u041D\u0435\u0442 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        pitchManualCases: "\u0420\u0443\u0447\u043D\u043E\u0435 \u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0434\u0435\u043B",
        pitchNoAiTools: "\u041D\u0435\u0442 \u0418\u0418-\u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C",
        pitchCapabilitiesLabel: "// \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438",
        pitchOnePlatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430. \u0422\u0440\u0438 \u043E\u0441\u043D\u043E\u0432\u044B.",
        pitchProductLabel: "// \u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        pitchProductTitle: "\u0412\u0441\u0451 \u0432 \u043E\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
        pitchIntegrationsLabel: "// \u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
        pitchIntegrationsTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044F, \u0430 \u043D\u0435 \u0440\u0443\u0447\u043D\u043E\u0439 \u0442\u0440\u0443\u0434",
        pitchPublicRegistry: "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0435\u0441\u0442\u0440",
        pitchCalendarSyncTitle: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        pitchOcrTitle: "OCR \u0438 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        pitchPlansLabel: "// \u0422\u0430\u0440\u0438\u0444\u044B",
        pitchPlansTitle: "\u0426\u0435\u043D\u044B \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u0433\u043E \u0440\u044B\u043D\u043A\u0430",
        pitchTierStarter: "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439",
        pitchMostPopular: "\u0421\u0430\u043C\u044B\u0439 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0439",
        pitchTierPro: "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439",
        pitchTierBusiness: "\u0411\u0438\u0437\u043D\u0435\u0441",
        pitchTierEnterprise: 'Enterprise',
        pitchRevenueLabel: "// \u0414\u043E\u0445\u043E\u0434",
        pitchRevenueTitle: "\u041F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B \u0434\u043E\u0445\u043E\u0434\u0430",
        pitchFinanceLabel: "// \u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        pitchFinanceTitle: "\u042E\u043D\u0438\u0442-\u044D\u043A\u043E\u043D\u043E\u043C\u0438\u043A\u0430",
        pitchTimeLabel: "// \u0412\u0440\u0435\u043C\u044F",
        pitchTimeTitle: "\u0421\u0430\u043C\u043E\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F",
        pitchPrivacyLabel: "// \u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
        pitchPrivacyTitle: "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u2014 \u043D\u0430\u0448 \u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442",
        pitchCtaLabel: "// \u0421\u0442\u0440\u043E\u0438\u043C \u0432\u043C\u0435\u0441\u0442\u0435",
        pitchCtaTitle: "\u0414\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u043E\u0432\u0443\u044E \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443 \u0413\u0440\u0443\u0437\u0438\u0438 \u0432\u043C\u0435\u0441\u0442\u0435",
        pitchCtaLink: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u2192",
        pitchPerMonth: "\u043C\u0435\u0441\u044F\u0446",
        settingsTitle: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        settingsTabProfile: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
        settingsTabFirm: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F",
        settingsTabTeam: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
        settingsTabNotifications: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F",
        settingsUploadPhoto: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u043E\u0442\u043E",
        settingsSave: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
        settingsFirmAddress: "\u0410\u0434\u0440\u0435\u0441",
        settingsFirmRegNumber: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440",
        settingsPublicBookingUrl: "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u0437\u0430\u043F\u0438\u0441\u0438",
        settingsTeamMembers: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
        settingsInvite: "+ \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
        settingsRoleOwner: "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446",
        settingsRoleLawyer: "\u042E\u0440\u0438\u0441\u0442",
        settingsNotifyTitle: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439",
        settingsToggleOn: "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        settingsToggleOff: "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        loginSubtitle: "\u0412\u043E\u0439\u0434\u0438\u0442\u0435 \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
        loginLawyer: "\u042E\u0440\u0438\u0441\u0442",
        loginClient: "\u041A\u043B\u0438\u0435\u043D\u0442",
        loginPassword: "\u041F\u0430\u0440\u043E\u043B\u044C",
        loginSubmit: "\u0412\u043E\u0439\u0442\u0438 \u2192",
        loginCaseNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u0435\u043B\u0430",
        loginBackLink: "\u2190 \u041D\u0430\u0437\u0430\u0434",
        portalLogout: "\u0412\u044B\u0439\u0442\u0438",
        portalWelcome: "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435,",
        portalActiveCases: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0434\u0435\uFFFD\uFFFD\u0430",
        portalDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        portalMessages: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
        portalSend: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        clientDashNavCases: "\u0414\u0435\u043B\u0430",
        clientDashNavInvoices: "\u0421\u0447\u0435\u0442\u0430",
        clientDashNavDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        clientDashNavMessages: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
        clientDashLogout: "\u0412\u044B\u0439\u0442\u0438",
        clientDashWelcome: "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435,",
        clientDashDownload: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
        clientDashSend: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        findLawyer: "\u041D\u0430\u0439\u0442\u0438 \u044E\u0440\u0438\u0441\u0442\u0430",
        lawyersSearchSub: "\u041F\u043E\u0438\u0441\u043A \u0441\u0440\u0435\u0434\u0438 5,700+ \u044E\u0440\u0438\u0441\u0442\u043E\u0432, \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0432 Georgian Bar Association",
        searchBtn: "\u041F\u043E\u0438\u0441\u043A",
        viewAll: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435",
        lawyerPortal: "\u041F\u043E\u0440\u0442\u0430\u043B \u044E\u0440\u0438\u0441\u0442\u0430",
        aiFeature: 'AI',
        aiChip1: "\u0420\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u0435 \u043D\u043E\u0442\u0430\u0440\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
        aiChip1Question: "\u041A\u0430\u043A\u043E\u0432\u044B \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0440\u0430\u0441\u0442\u043E\u0440\u0436\u0435\u043D\u0438\u044F \u043D\u043E\u0442\u0430\u0440\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430?",
        aiChip2: "\u0421\u0442\u0430\u0442\u044C\u044F 317 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0430",
        aiChip2Question: "\u0422\u043E\u043B\u043A\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0430\u0442\u044C\u0438 317 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0430",
        aiChip3: "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0441\u0434\u0435\u043B\u043A\u0438",
        aiChip3Question: "\u0421\u0443\uFFFD\uFFFD\u0435\u0431\u043D\u0430\u044F \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0430 \u043F\u043E \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0441\u0434\u0435\u043B\u043E\u043A \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 3 \u0433\u043E\u0434\u0430",
        aiDeadlinesData: "\u2022 \u041D\u0430\u0447\u0430\u043B\u043E \u0443\u0441\u043B\u0443\u0433: 10 \u0434\u043D\u0435\u0439 \u0441 \u0434\u0430\u0442\u044B \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\n\u2022 \u041F\u0435\u0440\u0432\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: 1 \u0430\u043F\u0440\u0435\u043B\u044F 2026 \u0433.\n\u2022 \u0421\u0440\u043E\u043A \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430: 12 \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
        aiEmptyChatSub: "AI \u2014 \u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441 \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442 \u043F\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0413\u0440\u0443\u0437\u0438\u0438",
        aiObligationsData: "1. \u041E\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0443\u0441\u043B\u0443\u0433 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439\n2. \u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 15 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439\n3. \u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 3 \u043B\u0435\u0442",
        aiPartiesData: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1: \u041E\u041E\u041E Barateli & Partners\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2: \u041E\u041E\u041E Delta Group",
        aiRecommendationsData: "1. \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442 \u043E \u043D\u0435\u0443\u0441\u0442\u043E\u0439\u043A\u0435 (\u0441\u0442. 417 \u0413\u041A)\n2. \u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0440\u043E\u0432 \u0447\u0435\u0440\u0435\u0437 \u0430\u0440\u0431\u0438\u0442\u0440\u0430\u0436\n3. \u0420\u0430\u0441\u0448\u0438\u0440\u0438\u0442\u044C \u043F\u0443\u043D\u043A\u0442 \u043E \u0444\u043E\u0440\u0441-\u043C\u0430\u0436\u043E\u0440\u0435",
        aiRisksData: "\u2022 \u041D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0430 \u043F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u043A\u0443 \u043F\u043B\u0430\u0442\u0435\u0436\u0430\n\u2022 \u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u043C\u0435\u0445\u0430\u043D\u0438\u0437\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0440\u043E\u0432\n\u2022 \u041F\u0443\u043D\u043A\u0442 \u043E \u0444\u043E\u0440\u0441-\u043C\u0430\u0436\u043E\u0440\u0435 \u043D\u0435 \u043F\u043E\u043A\u0440\u044B\u0432\u0430\u0435\u0442 \u043F\u0430\u043D\u0434\u0435\u043C\u0438\u044E",
        address: "\u0410\u0434\u0440\u0435\u0441",
        addressVal: "\u0422\u0431\u0438\u043B\u0438\u0441\u0438, \u0427\u0430\u0432\u0447\u0430\u0432\u0430\u0434\u0437\u0435 12",
        appleCalendar: 'Apple Calendar',
        billingClient1: "\u0413\u0435\u043E\u0440\u0433\u0438\u0439 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438",
        billingClient2: "\u041C\u0430\u0440\u0438\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F",
        billingClient3: "\u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438",
        billingClientName: "\u041E\u041E\u041E Delta Group",
        billingDue1: "25 \u043C\u0430\u0440",
        billingDue2: "15 \u043C\u0430\u0440",
        billingDue3: "10 \u043C\u0430\u0440",
        billingEmailNotification: "Email-\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435",
        billingLastCheck: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430: \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
        billingNoDebt: "\u041D\u0435\u0442 \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u0438",
        billingRsBanner: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u044F \u0441 rs.ge \u2014 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u0430\u044F \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0441\u0447\u0435\u0442 \u0432 \u043E\u0434\u0438\u043D \u043A\u043B\u0438\u043A",
        billingRsTaxSystem: "rs.ge \u2014 \u041D\u0430\u043B\u043E\u0433\u043E\u0432\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430",
        billingStatusPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingStatusSent: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        billingViewFull: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u2192",
        billingViewInvoices: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u0447\u0435\u0442\u0430 \u2192",
        billingWeeklyEnabled: "\u0415\u0436\u0435\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        caseRow1Title: "#2024-047 \u2014 \u0413\u0438\u043E\u0440\u0433\u0438 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438",
        caseRow2Title: "#2024-046 \u2014 \u041C\u0430\u0440\u0438\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F",
        caseRow3Title: "#2024-045 \u2014 \u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438",
        change1Date: "15 \u043C\u0430\u0440\u0442\u0430 \u2014 \u0412\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443: 1 \u0430\u043F\u0440\u0435\u043B\u044F",
        change1Desc: "\u0421\u0440\u043E\u043A \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D \u0441 30 \u0434\u043E 45 \u0434\u043D\u0435\u0439",
        change1Name: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441 \u2014 \u0421\u0442. 316",
        change2Date: "12 \u043C\u0430\u0440\u0442\u0430 \u2014 \u0412\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0432 \u0441\u0438\u043B\u0443: 1 \u043C\u0430\u044F",
        change2Desc: "\u0421\u0440\u043E\u043A \u0430\u043F\u0435\u043B\u043B\u044F\u0446\u0438\u0438 \u0441 14 \u0434\u043E 21 \u0434\u043D\u044F",
        change2Name: "\u041F\u0440\u043E\u0446\u0435\u0441\u0441\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434\u0435\u043A\u0441 \u2014 \u0421\u0440\u043E\u043A\u0438",
        claimAccepted: "\u0418\u0441\u043A \u043F\u0440\u0438\u043D\u044F\u0442 \u2014 17 \u043C\u0430\u0440\u0442\u0430",
        claimFiled: "\u0418\u0441\u043A \u043F\u043E\u0434\u0430\u043D \u2014 15 \u043C\u0430\u0440\u0442\u0430",
        claimFiledDoc: "\u0418\u0441\u043A \u2014 \u041F\u043E\u0434\u0430\u043D",
        clientName1: "\u0413\u0438\u043E\u0440\u0433\u0438 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438",
        clientName2: "\u041C\u0430\u0440\u0438\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F",
        clientName3: "\u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438",
        companyExtractLoaded: "\u0412\u044B\u043F\u0438\u0441\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u2014 \u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u0430",
        companyName: "\u041E\u041E\u041E Delta Group",
        clientsActiveCases1: "1 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
        clientsActiveCases2: "1 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
        clientsActiveCases3: "0 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0434\u0435\u043B",
        clientsAvatar1: "\u0413\u041C",
        clientsAvatar2: "\u041C\u041A",
        clientsAvatar3: "\u041B\u0413",
        clientsCaseLink1: "#2024-047 \u2014 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\uFFFD\uFFFD\u043A\u043E\u0435",
        clientsCaseLink2: "#2024-046 \u2014 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u041D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0434\u0435\u043B",
        clientsPaid1: "\u20BE2,400 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPaid2: "\u20BE800 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPaid3: "\u20BE1,800 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        dashAlertText: "2 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0445 \u0434\u0435\u043B\u0430 \u0438 \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u0441\u0447\u0435\u0442\u0430 \u043D\u0430 \u20BE1,840",
        dashBooking1Time: "10:00 \u2014 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435",
        dashBooking2Time: "11:30 \u2014 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435",
        dashBooking3Time: "14:00 \u2014 \u0423\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0435",
        dashCaseMeta1: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435 \xb7 18 \u043C\u0430\u0440",
        dashCaseMeta2: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \xb7 17 \u043C\u0430\u0440",
        dashCaseMeta3: "\u0423\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0435 \xb7 15 \u043C\u0430\u0440",
        dashClient3Name: "\u0414\u0430\u0432\u0438\u0442 \u0427\u0438\u043A\u043E\u0432\u0430\u043D\u0438",
        dashDate: "18 \u043C\u0430\u0440\u0442\u0430 2026 \u0433.",
        dashGreeting: "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435, \u041D\u0438\u043D\u043E",
        dateMar15: "15 \u043C\u0430\u0440",
        dateMar17: "17 \u043C\u0430\u0440",
        dateMar18: "18 \u043C\u0430\u0440",
        disabledStatus: "\u2014 \u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "\u0413\u0440\u0443\u0437\u0438\u044F, \u0422\u0431\u0438\u043B\u0438\u0441\u0438\n\n\u0418\u0441\u043A\n\n\u0418\u0441\u0442\u0435\u0446: \u041E\u041E\u041E Barateli & Partners\n\u041E\u0442\u0432\u0435\u0442\u0447\u0438\u043A: \u041E\u041E\u041E Delta Group\n\n\u0424\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430:\n\n\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0438\u0441\u043A\u043E\u043C \u0438\u0441\u0442\u0435\u0446 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0447\u0438\u043A\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0441\u0432\u043E\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.\n\n\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0435:\n\n1. \u041E\u0431\u044F\u0437\u0430\u0442\u044C \u043E\u0442\u0432\u0435\u0442\u0447\u0438\u043A\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0438\u0442\u044C 12,500 GEL\n2. \u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0448\u0442\u0440\u0430\u0444 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 1,875 GEL\n3. \u0412\u043E\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0441\u0443\u0434\u0435\u0431\u043D\u044B\u0435 \u0438\u0437\u0434\u0435\u0440\u0436\u043A\u0438\n\n\u0414\u0430\u0442\u0430: 18 \u043C\u0430\u0440\u0442\u0430 2026 \u0433.\n\u041F\u043E\u0434\u043F\u0438\u0441\u044C: ________________",
        docsDocument: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 \u043C\u0430\u0440 2026",
        docsFile1Name: "\u0418\u0441\u043A - \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 \u043C\u0430\u0440 2026",
        docsFile2Name: "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C - \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 \u043C\u0430\u0440 2026",
        docsFile3Name: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 \u043C\u0430\u0440 2026",
        docsFile4Name: "\u041A\u043E\u043F\u0438\u044F ID - \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 \u043C\u0430\u0440 2026",
        docsFile5Name: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 - \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438.pdf",
        docsFolder1Count: "3 \u0444\u0430\u0439\u043B\u0430",
        docsFolder1Name: "#2024-047 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438",
        docsFolder2Count: "2 \u0444\u0430\u0439\u043B\u0430",
        docsFolder2Name: "#2024-046 \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F",
        docsFolder3Count: "1 \u0444\u0430\u0439\u043B",
        docsFolder3Name: "#2024-045 \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438",
        docsFolder4Count: "5 \u0444\u0430\u0439\u043B\u043E\u0432",
        docsFormatAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0444\u043E\u0440\u043C\u0430\u0442\u0430...",
        docsFreeText: "\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442...",
        docsGeneratedClaimText: "\u0413\u0440\u0443\u0437\u0438\u044F, \u0422\u0431\u0438\u043B\u0438\u0441\u0438\n\n\u0418\u0441\u043A\n\n\u0418\u0441\u0442\u0435\u0446: [\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1]\n\u041E\u0442\u0432\u0435\u0442\u0447\u0438\u043A: [\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2]\n\n\u0424\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430:\n\n\u041D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u043C \u0438\u0441\u043A\u043E\u043C \u0438\u0441\u0442\u0435\u0446 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043E\u0442 \u043E\u0442\u0432\u0435\u0442\u0447\u0438\u043A\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0441\u0432\u043E\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u043C\u0443 \u043A\u043E\u0434\u0435\u043A\u0441\u0443 \u0413\u0440\u0443\u0437\u0438\u0438.\n\n\u041F\u0440\u0430\u0432\u043E\u0432\u043E\u0435 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0435:\n\n\u0421\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0441\u0442\u0430\u0442\u044C\u0435 316 \u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0434\u043E\u043B\u0436\u043D\u044B \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0442\u044C\u0441\u044F \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C.\n\n\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0435:\n\n\u0423\u0447\u0438\u0442\u044B\u0432\u0430\u044F \u0432\u044B\u0448\u0435\u0438\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u043E\u0435, \u0438\u0441\u0442\u0435\u0446 \u043F\u0440\u043E\u0441\u0438\u0442 \u0441\u0443\u0434 \u043E\u0431\u044F\u0437\u0430\u0442\u044C \u043E\u0442\u0432\u0435\u0442\u0447\u0438\u043A\u0430.\n\n\u0414\u0430\u0442\u0430: 18 \u043C\u0430\u0440\u0442\u0430 2026 \u0433.\n\u041F\u043E\u0434\u043F\u0438\u0441\u044C: ________________",
        docsGeorgianSymbols: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B",
        docsOcrNote: "OCR-\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u2014 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0431\u0443\u043C\u0430\u0436\u043D\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432, \u0440\u0443\u0447\u043D\u043E\u0439 \u0432\u0432\u043E\u0434 \u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F",
        docsOcrResultText: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116147\n\n\u0422\u0431\u0438\u043B\u0438\u0441\u0438, 10 \u043C\u0430\u0440\u0442\u0430 2026 \u0433.\n\n\u0421 \u043E\u0434\u043D\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u041E\u041E\u041E Barateli & Partners (\u0418\u041D\u041D 404123456) \u0432 \u043B\u0438\u0446\u0435 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438 (\u0434\u0430\u043B\u0435\u0435 \xab\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\xbb) \u0438 \u0441 \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u041E\u041E\u041E Delta Group (\u0418\u041D\u041D 404789012) \u0432 \u043B\u0438\u0446\u0435 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438 (\u0434\u0430\u043B\u0435\u0435 \xab\u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\xbb), \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440:\n\n\u0421\u0442\u0430\u0442\u044C\u044F 1. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\n1.1. \u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043E\u043A\u0430\u0437\u0430\u0442\u044C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0417\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0443.\n1.2. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0443\u0441\u043B\u0443\u0433 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 12 500 (\u0434\u0432\u0435\u043D\u0430\u0434\u0446\u0430\u0442\u044C \u0442\u044B\u0441\u044F\u0447 \u043F\u044F\u0442\u044C\u0441\u043E\u0442) GEL.",
        docsOcrSuccess: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0430\u0441\u043F\u043E\uFFFD\uFFFD\u043D\u0430\u043D\u043E \u2014 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u044C 98.5%",
        docsRow1Meta: "#2024-047 \xb7 \u0418\u0441\u043A \xb7 15 \u043C\u0430\u0440",
        docsRow1Name: "\u0418\u0441\u043A - \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0438\u043B\u0438.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \xb7 12 \u043C\u0430\u0440",
        docsRow2Name: "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C - \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0438\u044F.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \xb7 8 \u043C\u0430\u0440",
        docsRow3Name: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 - \u0413\u043E\u0433\u0438\u0430\u0448\u0432\u0438\u043B\u0438.pdf",
        docsTextRecognition: "\u0420\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u043C\u0430\u043A\u0441. 10MB",
        docsUploadSub: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430",
        ecourt: 'ecourt',
        ecourtDesc: "\u041F\u043E\u0434\u0430\u0447\u0430 \u0438\u0441\u043A\u043E\u0432, \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0434\u0435\u043B\u0430 \u0438 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0439 \u2014 \u0431\u0435\u0437 \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u044F \u0441\u0443\u0434\u0430",
        enabledStatus: "\u2713 \u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        evidencePending: "\u0414\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u2014 \u0412 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438",
        extract: "\u0412\u044B\u043F\u0438\u0441\u043A\u0430",
        field1Text: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435: \u0441\u0442. 316 \u043F\u043E\u043F\u0440\u0430\u0432\u043A\u0430",
        field2Text: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435: \u0441\u0442. 259 \u0441\u0440\u043E\u043A\u0438",
        field3Text: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435: \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 \u043C\u0430\u0440, 10:00 \u2014 \u0422\u0431\u0438\u043B\u0438\u0441\u0441\u043A\u0438\u0439 \u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439 \u0441\u0443\u0434",
        hearingItem2: "\uD83D\uDCC5 28 \u043C\u0430\u0440, 14:30 \u2014 \u0410\u043F\u0435\u043B\u043B\u044F\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0441\u0443\u0434",
        loginEmail: 'Email',
        matsne: 'matsne',
        matsneDesc: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u2014 \u0432 \u0432\u0430\u0448\u0435\u0439 \u0441\u0444\u0435\u0440\u0435 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        outlook: 'Outlook',
        prepHearing: "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0441\u043B\u0443\u0448\u0430\u043D\u0438\u0435 \u2014 22 \u043C\u0430\u0440\u0442\u0430",
        propertyApartment: "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 \u2014 \u0412\u0430\u043A\u0435, 85 \u043A\u0432.\u043C \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u0412\u044B\u043F\u0438\u0441\u043A\u0430 \u043D\u0430 \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E \u2014 \u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430",
        registryDesc: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445 \u0438 \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u2014 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u0440\u0443\u0447\u043D\u044B\u0445 \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u0439 \u0432\u044B\u043F\u0438\u0441\u043E\u043A",
        timeEntry1Date: "18 \u043C\u0430\u0440, 10:30",
        timeEntry1Text: "\u0414\u0435\u043B\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u043E, \u043F\u0435\u0440\u0432\u0438\u0447\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
        timeEntry2Date: "17 \u043C\u0430\u0440, 14:00",
        timeEntry2Text: "\u041A\u043B\u0438\u0435\u043D\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E",
        timeEntry3Date: "15 \u043C\u0430\u0440, 09:00",
        timeEntry3Text: "\u041A\u043B\u0438\u0435\u043D\u0442 \u0441\u0432\u044F\u0437\u0430\u043B\u0441\u044F \u0441 \u0444\u0438\u0440\u043C\u043E\u0439, \u043F\u0435\u0440\u0432\u0438\u0447\u043D\u043E\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435",
        typeCivil: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435",
        typeAdministrative: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435",
        typeCriminal: "\u0423\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0435",
        pitchArpuMonth: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439 ARPU/\u043C\u0435\u0441",
        pitchArpuYear: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439 ARPU/\u0433\u043E\u0434",
        pitchAutoBackup: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0435 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        pitchAutoNextSteps: "\u0410\u0432\u0442\u043E-\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0448\u0430\u0433\u0438",
        pitchAutoReminder: "\u0410\u0432\u0442\u043E-\u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435",
        pitchBooking: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        pitchCacOrganic: "CAC (\u043E\u0440\u0433\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0440\u043E\u0441\u0442)",
        pitchCalcNote: "5000 \u044E\u0440\u0438\u0441\u0442\u043E\u0432 \xd7 \u20BE35/\u043C\u0435\u0441 \u0432 \u0441\u0440. \xd7 12 \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
        pitchCalendarSync: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 \u0441\u043B\u0443\u0448\u0430\u043D\u0438\u044F \u0438 \u0441\u0440\u043E\u043A\u0438 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438",
        pitchCaseManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0435\u043B\u0430\u043C\u0438",
        pitchClientSchedule: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        pitchCloudDedicated: "\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435 \u043E\u0431\u043B\u0430\u043A\u043E",
        pitchCloudDedicatedDesc: "\u0418\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440 \u2014 \u0432\u0430\u0448\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043E\u0442\u0434\u0435\u043B\u0435\u043D\u044B \u043E\u0442 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        pitchContractAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432",
        pitchCtaSubtext: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 + \u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 + AI",
        pitchDedicatedServer: "\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440",
        pitchDocDraftGeo: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C",
        pitchEcourtDesc: "\u041F\u043E\u0434\u0430\u0447\u0430 \u0438\u0441\u043A\u043E\u0432, \u0441\u0442\u0430\u0442\u0443\u0441 \u0434\u0435\u043B\u0430 \u0438 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0439 \u2014 \u0431\u0435\u0437 \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u044F \u0441\u0443\u0434\u0430",
        pitchGdprCompliant: "\u0421\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 GDPR",
        pitchHybrid: "\u0413\u0438\u0431\u0440\u0438\u0434",
        pitchHybridDesc: "\u041E\u0431\u043B\u0430\u043A\u043E + \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u2014 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E, \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u0432 \u043E\u0431\u043B\u0430\u043A\u0435",
        pitchIntegrationsSub: "\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044B, \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0438 \u0438 OCR \u2014 \u0441 \u043E\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
        pitchInvoices: "\u0421\u0447\u0435\u0442\u0430",
        pitchMatsneDesc: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u2014 \u0432 \u0432\u0430\u0448\u0435\u0439 \u0441\u0444\u0435\u0440\u0435 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        pitchOcrDesc: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0438\u0444\u0440\u043E\u0432\u043A\u0430 \u0431\u0443\u043C\u0430\u0436\u043D\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u2014 \u0431\u0435\u0437 \u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0432\u0432\u043E\u0434\u0430",
        pitchOnPremise: "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440",
        pitchOnPremiseDesc: "\u041F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u2014 \u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0441\u0442\u0430\u044E\u0442\u0441\u044F \u0432 \u0432\u0430\u0448\u0435\u043C \u043E\uFFFD\uFFFD\u0438\u0441\u0435, \u0431\u0435\u0437 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0432 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442",
        pitchOperations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438",
        pitchPerkAiDocs: "AI \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        pitchPerkBookings: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u043C",
        pitchPerkClientPortal: "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        pitchPerkCommunication: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F",
        pitchPerkFileStorage: "\u0425\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u043E\u0432",
        pitchPerkResponsive: "\u0410\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
        pitchPrivacySubtitle: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0435\u0431\u0443\u044E\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0437\u0430\u0449\u0438\u0442\u044B",
        pitchPublicRegistryDesc: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445 \u0438 \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u2014 \u0431\u0435\u0437 \u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F \u0432\u044B\u043F\u0438\u0441\u043E\u043A",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 \u043C\u0430\u0440\u0442 2026",
        pitchRecurringModel: "\u0420\u0435\u043A\u0443\u0440\u0440\u0435\u043D\u0442\u043D\u0430\u044F \u043C\u043E\u0434\u0435\u043B\u044C",
        pitchRsGeDesc: "\u041D\u0430\u043B\u043E\u0433\u043E\u0432\u0430\u044F \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0441\u0447\u0435\u0442\u0430 \u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0432 \u043E\u0434\u0438\u043D \u043A\u043B\u0438\u043A",
        pitchScen250: "250 \u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        pitchScen500: "500 \u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        pitchScen1000: "1000 \u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        pitchServerCost: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043D\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
        pitchTierBusiness10: "10+ \u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        pitchTierEnterpriseCustom: "\u0418\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0439",
        pitchTierEnterprisePrice: "\u041F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443",
        pitchTierPro310: "3-10 \u044E\u0440\u0438\u0441\u0442\u043E\u0432",
        pitchTierStarter12: "1-2 \u044E\u0440\u0438\u0441\u0442\u0430",
        pitchTitle: "TrustLegal \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0438\u0438",
        pitchTrustedAccounting: "\u041D\u0430\u0434\u0435\u0436\u043D\u044B\u0439 \u0443\u0447\u0435\u0442",
        pitchWhyAiCheap: "\u0418\u0418-\u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B \u0442\u0435\u043F\u0435\u0440\u044C \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B",
        pitchWhyDigitizing: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0439 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0440\u044B\u043D\u043E\u043A \u0431\u044B\u0441\u0442\u0440\u043E \u0446\u0438\u0444\u0440\u043E\u0432\u0438\u0437\u0438\u0440\uFFFD\uFFFD\u0435\u0442\u0441\u044F",
        pitchWhyNoCompetitor: "\u041D\u0435\u0442 \u0443\u0441\u0442\u043E\u044F\u0432\u0448\u0438\u0445\u0441\u044F \u043A\u043E\u043D\u043A\u0443\u0440\u0435\u043D\u0442\u043E\u0432",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        settingsMember2Name: "\u0413\u0438\u0433\u0430 \u0410\u0441\u043B\u0430\u043D\u0438\u0448\u0432\u0438\u043B\u0438",
        settingsNotifyDeadlineReminder: "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435 \u043E \u0441\u0440\u043E\u043A\u0435",
        settingsNotifyNewBookingEmail: "\u041D\u043E\u0432\u043E\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u2014 Email",
        settingsNotifyNewBookingWhatsapp: "\u041D\u043E\u0432\u043E\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u0441\u0447\u0435\u0442",
        settingsNotifyReminder24h: "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435 \u0437\u0430 24 \u0447\u0430\u0441\u0430",
        settingsProfileName: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        settingsToggle3DaysBefore: "\u0417\u0430 3 \u0434\u043D\u044F",
        portalCaseTypeCivil: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435",
        portalDocDate1: "15 \u043C\u0430\u0440",
        portalDocName1: "\u0418\u0441\u043A - Mamulashvili.pdf",
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0434\u043E: 25 \u043C\u0430\u0440",
        portalLastUpdate: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435: 18 \u043C\u0430\u0440",
        portalMsgFrom1: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        portalMsgPlaceholder: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...",
        portalMsgText1: "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435, \u0413\u0435\u043E\u0440\u0433\u0438\u0439, \u0443 \u043D\u0430\u0441 \u043D\u043E\u0432\u044B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\uFFFD\uFFFD \u043F\u043E \u0434\u0435\u043B\u0443.",
        portalMsgText2: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E, \u0436\u0434\u0443 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0435\u0439.",
        portalNextHearing: "\u0421\u0443\u0434\u0435\u0431\u043D\u043E\u0435 \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0435 25 \u043C\u0430\u0440\u0442\u0430",
        portalPay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
        portalPendingInvoices: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u0441\u0447\u0435\u0442\u0430",
        portalProgressLabel: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441: 3/5 \u0448\u0430\u0433\u043E\u0432",
        portalStatusActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E",
        clientDashCaseTypeCivil: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0435",
        clientDashDocMeta1: "\u0414\u0435\u043B\u043E #2024-047 \xb7 15 \u043C\u0430\u0440",
        clientDashDocMeta2: "\u0414\u0435\u043B\u043E #2024-046 \xb7 12 \u043C\u0430\u0440",
        clientDashDocName1: "\u0418\u0441\u043A - Mamulashvili.pdf",
        clientDashDocName2: "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C - Kvaratskhelia.pdf",
        clientDashDocumentsTitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        clientDashInvCase1: "\u0414\u0435\u043B\u043E: #2024-047",
        clientDashInvCase2: "\u0414\u0435\u043B\u043E: #2024-046",
        clientDashInvDue1: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0434\u043E: 25 \u043C\u0430\u0440\u0442\u0430 2026",
        clientDashInvoicesTitle: "\u0421\u0447\u0435\u0442\u0430",
        clientDashInvPaidDate: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E: 14 \u043C\u0430\u0440\u0442\u0430 2026",
        clientDashLawyerInitials: "\u041D\u0411",
        clientDashLawyerName: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        clientDashLawyerRole: "\u0412\u0430\u0448 \u044E\u0440\u0438\u0441\u0442",
        clientDashMessagesTitle: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
        clientDashMsgFrom1: "\u041D\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        clientDashMsgFrom3: "\uFFFD\uFFFD\u0438\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0438",
        clientDashMsgPlaceholder: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...",
        clientDashMsgText1: "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435, \u0413\u0435\u043E\u0440\u0433\u0438\u0439, \u0443 \u043D\u0430\u0441 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u043F\u043E \u0434\u0435\u043B\u0443. \u0421\u0443\u0434 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u043B \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0435 \u043D\u0430 25 \u043C\u0430\u0440\u0442\u0430.",
        clientDashMsgText2: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E, \u0436\u0434\u0443 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0435\u0439. \u041D\u0443\u0436\u043D\u043E \u043B\u0438 \u043C\u043D\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C \u043A\u0430\u043A\u0438\u0435-\u0442\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B?",
        clientDashMsgText3: "\u041D\u0435\u0442, \u0432\u0441\u0435 \u0433\u043E\u0442\u043E\u0432\u043E. \u042F \u0441\u0432\u044F\u0436\u0443\u0441\u044C \u0441 \u0432\u0430\u043C\u0438 \u0437\u0430 \u043D\u0435\u0434\u0435\u043B\u044E \u0434\u043E \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u044F.",
        clientDashMsgTime1: "10:30 \xb7 \u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        clientDashMsgTime2: "10:45 \xb7 \u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        clientDashMsgTime3: "11:02 \xb7 \u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        clientDashMyCases: "\u041C\u043E\u0438 \u0434\u0435\u043B\u0430",
        clientDashPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientDashPay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C",
        clientDashProgressLabel: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441: \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E 3/5 \u0448\u0430\u0433\u043E\u0432",
        clientDashStatActiveCase: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
        clientDashStatDocument: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        clientDashStatNextHearing: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0435",
        clientDashStatNextHearingValue: "25 \u043C\u0430\u0440",
        clientDashStatPayable: "\u041A \u043E\u043F\u043B\u0430\u0442\u0435",
        clientDashStatusActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E",
        clientDashStep1Date: "5 \u043C\u0430\u0440 2026",
        clientDashStep1Title: "\u041A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
        clientDashStep2Date: "10 \u043C\u0430\u0440 2026",
        clientDashStep2Title: "\u0418\u0441\u043A \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D",
        clientDashStep3Date: "15 \u043C\u0430\u0440 2026",
        clientDashStep3Title: "\u0418\u0441\u043A \u043F\u043E\u0434\u0430\u043D \u0432 \u0441\u0443\u0434",
        clientDashStep4Date: "25 \u043C\u0430\u0440 2026 \u2014 \u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F",
        clientDashStep4Title: "\u0421\u0443\u0434\u0435\u0431\u043D\u043E\u0435 \u0437\u0430\u0441\u0435\u0434\u0430\u043D\u0438\u0435",
        clientDashStep5Title: "\u0420\u0435\u0448\u0435\u043D\u0438\u0435",
        clientDashUnpaid: "\u041D\u0435 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientDashWelcomeSub: "\u0417\u0434\u0435\u0441\u044C \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0438 \u0434\u0435\u043B\u0430, \u0441\u0447\u0435\u0442\u0430 \u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B."
    },
    uk: {
        home: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
        dashboard: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434",
        bookings: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        bookingPage: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        aiDocuments: "AI \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        clientPortalNav: "\u041A\u043B\u0456\u0454\u043D\u0442\u0441\u044C\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        lawyersNav: "\u042E\u0440\u0438\u0441\u0442\u0438",
        login: "\u0423\u0432\u0456\u0439\u0442\u0438",
        getStarted: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        lawyersTitle: "\u042E\u0440\u0438\u0441\u0442\u0438 \u0442\u0430 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u0444\u0456\u0440\u043C\u0438",
        lawyersSubtitle: "\u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0456 \u0432 \u0413\u0440\u0443\u0437\u0456\u0457",
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C'\u044F\u043C, \u0444\u0456\u0440\u043C\u043E\u044E \u0430\u0431\u043E \u0441\u0444\u0435\u0440\u043E\u044E \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438...",
        lawyersBtn: "\u042E\u0440\u0438\u0441\u0442\u0438",
        firmsBtn: "\u0424\u0456\u0440\u043C\u0438",
        allFilter: "\u0412\u0441\u0456",
        corporateLaw: "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0435 \u043F\u0440\u0430\u0432\u043E",
        criminalLaw: "\u041A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0435 \u043F\u0440\u0430\u0432\u043E",
        familyLaw: "\u0421\u0456\u043C\u0435\u0439\u043D\u0435 \u043F\u0440\u0430\u0432\u043E",
        realEstate: "\u041D\u0435\u0440\u0443\u0445\u043E\u043C\u0456\u0441\u0442\u044C",
        taxLaw: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0435 \u043F\u0440\u0430\u0432\u043E",
        ipLaw: 'IP',
        immigration: "\u0406\u043C\u043C\u0456\u0433\u0440\u0430\u0446\u0456\u044F",
        laborLaw: "\u0422\u0440\u0443\u0434\u043E\u0432\u0435 \u043F\u0440\u0430\u0432\u043E",
        bankingFinance: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u0441\u043F\u0440\u0430\u0432\u0430 \u0442\u0430 \u0444\u0456\u043D\u0430\u043D\u0441\u0438",
        firmsMatch: "\u0444\u0456\u0440\u043C \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        lawyersMatch: "\u044E\u0440\u0438\u0441\u0442\u0456\u0432 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        reviews: "\u0432\u0456\u0434\u0433\u0443\u043A\u0456\u0432",
        loadingMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0449\u0435...",
        independent: "\u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u0438\u0439",
        yearsExperience: "\u0440\u043E\u043A\u0456\u0432 \u0434\u043E\u0441\u0432\u0456\u0434\u0443",
        languages: "\u041C\u043E\u0432\u0438",
        backToDirectory: "\u2190 \u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0443",
        about: "\u041F\u0440\u043E \u043D\u0430\u0441",
        bookConsultation: "\u0417\u0430\u0431\u0440\u043E\u043D\u044E\u0432\u0430\u0442\u0438 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044E",
        sendMessage: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        call: "\u0417\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0432\u0430\u0442\u0438",
        reviewsRatings: "\u0412\u0456\u0434\u0433\u0443\u043A\u0438 \u0442\u0430 \u043E\u0446\u0456\u043D\u043A\u0438",
        reviewsComingSoon: "\u0412\u0456\u0434\u0433\u0443\u043A\u0438 \u0437'\u044F\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C. \u0411\u0443\u0434\u044C\u0442\u0435 \u043F\u0435\u0440\u0448\u0438\u043C, \u0445\u0442\u043E \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C \u0432\u0456\u0434\u0433\u0443\u043A.",
        barId: 'Bar ID',
        ourTeam: "\u041D\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430",
        contact: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
        website: "\u0412\u0435\u0431\u0441\u0430\u0439\u0442",
        established: "\u0417\u0430\u0441\u043D.",
        lawyersCount: "\u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        georgian: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0430",
        english: "\u0410\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u0430",
        russian: "\u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0430",
        german: "\u041D\u0456\u043C\u0435\u0446\u044C\u043A\u0430",
        french: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430",
        turkish: "\u0422\u0443\u0440\u0435\u0446\u044C\u043A\u0430",
        heroLine1: "\u0412\u0430\u0448\u0430 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0430",
        heroLine2: "\u043A\u043E\u043C\u0430\u043D\u0434\u0430. \u041E\u0434\u043D\u0430",
        heroLine3: "\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.",
        heroSubtitle: "TrustLegal \u2014 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F, \u0441\u043F\u0440\u0430\u0432\u0438, \u043F\u043B\u0430\u0442\u0435\u0436\u0456 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E AI \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0445 \u0444\u0456\u0440\u043C. \u041E\u0434\u043D\u0430 \u0449\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0430 \u043F\u043B\u0430\u0442\u0430, \u0431\u0435\u0437 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0456\u0432.",
        tryFree: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u2192",
        liveDemo: 'Live Demo',
        trustedBrands: "\u0411\u0440\u0435\u043D\u0434\u0438, \u044F\u043A\u0456 \u0434\u0431\u0430\u044E\u0442\u044C \u043F\u0440\u043E \u044F\u043A\u0456\u0441\u0442\u044C, \u043F\u0440\u0430\u0446\u044E\u044E\u0442\u044C \u0437 \u043D\u0430\u043C\u0438",
        howItWorks: "\u042F\u043A \u0446\u0435 \u043F\u0440\u0430\u0446\u044E\u0454",
        processLabel: "// \u041F\u0440\u043E\u0446\u0435\u0441",
        step1Title: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F",
        step1Desc: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0430\u043A\u0430\u0443\u043D\u0442 \u0442\u0430 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0430\u0440\u0438\u0444. \u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0430 \u043A\u0430\u0440\u0442\u043A\u0430 \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u2014 \u043F\u0435\u0440\u0448\u0456 30 \u0434\u043D\u0456\u0432 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E.",
        step2Title: "\u041A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u0440\u0430\u0432\u0430\u043C\u0438",
        step2Desc: "\u0414\u043E\u0434\u0430\u0432\u0430\u0439\uFFFD\uFFFD\u0435 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432, \u0441\u043F\u0440\u0430\u0432\u0438 \u0442\u0430 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0456 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u0430 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u0437 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0435\u043C.",
        step3Title: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437 AI",
        step3Desc: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E AI. \u041F\u043E\u0437\u043E\u0432\u0438, \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456, \u0430\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432.",
        step4Title: "\u0417\u0440\u043E\u0441\u0442\u0430\u043D\u043D\u044F",
        step4Desc: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0439\u0442\u0435 \u0440\u0430\u0445\u0443\u043D\u043A\u0438, \u0434\u043E\u0445\u043E\u0434\u0438 \u0442\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0438. \u0410\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430 \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456.",
        demoBadge: '// Live Demo',
        todaysBookings: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        fullDemo: "\u041F\u043E\u0432\u043D\u0435 \u0434\u0435\u043C\u043E \u2192",
        onePlatformThreePillars: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.\n\u0422\u0440\u0438 \u043E\u0441\u043D\u043E\u0432\u0438.",
        capabilitiesLabel: "// \u041C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0456",
        bookingFeature: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        bookingFeatureDesc: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438 \u0441\u0430\u043C\u0456 \u043E\u0431\u0438\u0440\u0430\u044E\u0442\u044C \u0447\u0430\u0441. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0456 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F. \u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u0437 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0435\u043C. \u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F.",
        operationsFeature: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
        operationsFeatureDesc: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u043F\u0440\u0430\u0432\u0430\u043C\u0438. \u041A\u043B\u0456\u0454\u043D\u0442\u0441\uFFFD\uFFFD\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B. \u0420\u0430\u0445\u0443\u043D\u043A\u0438 \u0442\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0456. \u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
        aiFeatureDesc: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E. \u0410\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432. \u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u0434\u043E\u0441\u043B\u0456\u0434\u0436\u0435\u043D\u043D\u044F. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0456 \u0444\u043E\u043B\u043B\u043E\u0443-\u0430\u043F\u0438.",
        simplePricing: "\u041F\u0440\u043E\u0441\u0442\u0456 \u0442\u0430\u0440\u0438\u0444\u0438",
        plansLabel: "// \u0422\u0430\u0440\u0438\u0444\u0438",
        perMonth: "/ \u043C\u0456\u0441\u044F\u0446\u044C",
        bookingMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F\u043C\u0438",
        caseTracking: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u0441\u043F\u0440\u0430\u0432",
        calendarSync: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        emailReminders: "Email-\u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
        starterPlan: "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u0438\u0439",
        startNow: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0437\u0430\u0440\u0430\u0437 \u2192",
        everythingStarter: "\u0423\u0441\u0435 \u0437 \u043F\u043B\u0430\u043D\u0443 \u0421\u0442\u0430\u0440\u0442\u043E\u0432\u0438\u0439",
        aiDocDrafting: "\u0428\u0406-\u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
        invoicesPayments: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438 \u0442\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0456",
        clientPortalFeature: "\u041A\u043B\u0456\u0454\u043D\u0442\u0441\u044C\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        directSupport: "\u041F\u0440\u044F\u043C\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0430",
        professionalPlan: "\u041F\u0440\u043E\u0444\u0435\u0441\u0456\u0439\u043D\u0438\u0439",
        mostPopular: "\u041D\u0430\u0439\u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456\u0448\u0438\u0439",
        everythingPro: "\u0423\u0441\u0435 \u0437 \u043F\u043B\u0430\u043D\u0443 \u041F\u0440\u043E\uFFFD\uFFFD\u0435\u0441\u0456\u0439\u043D\u0438\u0439",
        teamMgmt10: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E (10+ \u044E\u0440\u0438\u0441\u0442\u0456\u0432)",
        contractAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432",
        advancedAnalytics: "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0430 \u0430\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430",
        personalOnboarding: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u043D\u0431\u043E\u0440\u0434\u0438\u043D\u0433",
        businessPlan: "\u0411\u0456\u0437\u043D\u0435\u0441",
        spotsLeft: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044F 3 \u043C\u0456\u0441\u0446\u044F",
        enterpriseNote: "Enterprise \u2014 \u0437\u0432'\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437 \u043D\u0430\u043C\u0438 \u0434\u043B\u044F \u0456\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0457 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457.",
        readyQuestion: "\u0413\u043E\u0442\u043E\u0432\u0456?",
        first30DaysFree: "\u041F\u0435\u0440\u0448\u0456 30 \u0434\u043D\u0456\u0432 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E. \u0411\u0435\u0437 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0443. \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u0434\u044C-\u043A\u043E\u043B\u0438.",
        footerTagline: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0430 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0430 SaaS-\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430.",
        productLabel: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        companyLabel: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
        bookingsLink: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        casesLink: "\u0421\u043F\u0440\u0430\u0432\u0438",
        aiDocsLink: "\u0428\u0406-\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        aboutUs: "\u041F\u0440\u043E \u043D\u0430\u0441",
        careers: "\u041A\u0430\u0440'\u0454\u0440\u0430",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E Symbols",
        sidebarMain: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434",
        sidebarBookings: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        sidebarCases: "\u0421\u043F\u0440\u0430\u0432\u0438",
        sidebarClients: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438",
        sidebarDocs: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        sidebarPayments: "\u041F\u043B\u0430\u0442\u0435\u0436\u0456",
        sidebarLawyers: "\u042E\u0440\u0438\u0441\u0442\u0438",
        sidebarSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        sidebarLogout: "\u0412\u0438\u0439\u0442\u0438",
        bookingsTitle: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        newBooking: "+ \u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        newBookingTitle: "\u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        clientName: "\u0406\u043C'\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        phoneNumber: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        civilLaw: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0435",
        criminalLaw2: "\u041A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0435 \u043F\u0440\u0430\u0432\u043E",
        administrativeLaw: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0435",
        otherType: "\u0406\u043D\u0448\u0435",
        notesPlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438...",
        confirmBooking: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        cancelBtn: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        calendarSyncNote: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F \u2014 Google Calendar, Outlook, Apple Calendar \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u044E\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E",
        synced: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u043E\u0432\u0430\u043D\u043E",
        calendarSync2: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        syncedStatus: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u043E\u0432\u0430\u043D\u043E",
        bookingsToday: "3 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        settingsLink: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u2192",
        pendingStatus: "\u0412 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u0456",
        connectionNeeded: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F",
        connectLink: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u2192",
        lastSync: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F: 5 \u0445\u0432 \u0442\u043E\u043C\u0443",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        bookingDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        confirmed: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        pending: "\u0412 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u0456",
        upcomingBookings: "\u041C\u0430\u0439\u0431\u0443\u0442\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        closeBtn: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        selectDateTime: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443 \u0442\u0430 \u0447\u0430\u0441",
        fillInfo: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u2014 ",
        firstName: "\u0406\u043C'\u044F",
        lastName: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        phoneField: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        emailField: 'Email',
        caseDescription: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u043E\u043F\u0438\u0441 \u0441\u043F\u0440\u0430\u0432\u0438",
        confirmBookingPublic: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        goBack: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F",
        bookingConfirmedMsg: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E!",
        timeLabel: "\u0427\u0430\u0441: ",
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        casesTitle: "\u0421\u043F\u0440\u0430\u0432\u0438",
        searchPlaceholder2: "\u041F\u043E\u0448\u0443\u043A...",
        newCase: "+ \u041D\u043E\u0432\u0430 \u0441\u043F\u0440\u0430\u0432\u0430",
        allTab: "\u0412\u0441\u0456",
        activeTab: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        pendingTab: "\u0412 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u0456",
        closedTab: "\u0417\u0430\u043A\u0440\u0438\u0442\u0456",
        selectCasePrompt: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u0430\u0432\u0443 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0434\u0435\u0442\u0430\u043B\u0435\u0439",
        info: "\u0406\u043D\u0444\u043E",
        registry: "\u0420\u0435\u0454\u0441\u0442\u0440",
        clientInfo: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        chronology: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F",
        addNote: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0442\u0430\u0442\u043A\u0443",
        enterNote: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u0442\u0430\u0442\u043A\u0443...",
        addBtn: "\u0414\u043E\u0434\u0430\u0442\u0438",
        documentsLabel: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        createBtn: "+ \u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        noDocs: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
        hearingSchedule: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u044C",
        caseStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0441\u043F\u0440\u0430\u0432\u0438",
        electronicFiling: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0435 \u043F\u043E\u0434\u0430\u043D\u043D\u044F",
        idCode: "\u0406\u0414 \u043A\u043E\u0434:",
        director: "\u0414\u0438\u0440\u0435\u043A\u0442\u043E\u0440:",
        addressLabel: "\u0410\u0434\u0440\u0435\u0441\u0430:",
        statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441:",
        registeredProperty: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0435 \u043C\u0430\u0439\u043D\u043E",
        extractLabel: "\u0412\u0438\u0442\u044F\u0433",
        recentChanges: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        yourFieldChanges: "\u0417\u043C\u0456\u043D\u0438 \u0443 \u0432\u0430\u0448\u0456\u0439 \u0441\u0444\u0435\u0440\u0456",
        newLabel: "\u041D\u043E\u0432\u0435",
        notifications: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
        clientsTitle: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438",
        clientsSearchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432...",
        clientsProfile: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        clientsContactLabel: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442",
        clientsInvoiceHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
        clientsUnpaid: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPaid: "\u041E\uFFFD\uFFFD\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPortalInvite: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u043E\u0440\u0442\u0430\u043B\u0443 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        dashTodayBookings: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        dashUnpaid: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        dashOverdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
        dashAiGenerations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u0457 \u0428\u0406",
        dashTodaysBookings: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        dashConfirmed: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        dashRecentCases: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0441\u043F\u0440\u0430\u0432\u0438",
        dashNewBooking: "+ \u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        dashNewCase: "+ \u041D\u043E\u0432\u0430 \u0441\u043F\u0440\u0430\u0432\u0430",
        dashAiDocument: "\u0428\u0406 \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsTitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        docsCreate: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        docsExisting: "\u0406\u0441\u043D\u0443\u044E\u0447\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        docsFiles: "\u0424\u0430\u0439\u043B\u0438",
        docsOcrScan: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u0442\u0438",
        docsOcrTitle: "OCR \u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
        docsUploadText: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0444\u043E\u0442\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0430\u0431\u043E PDF",
        docsScanning: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430...",
        docsFile: "\u0424\u0430\u0439\u043B",
        docsPages: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
        docsLanguage: "\u041C\u043E\u0432\u0430",
        docsGeorgian: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0430",
        docsAddToCase: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u0441\u043F\u0440\u0430\u0432\u0438",
        docsCopy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
        docsRescan: "\u041F\u0435\u0440\u0435\u0441\u043A\u0430\u043D\u0443\u0432\u0430\u0442\u0438",
        docsClaim: "\u041F\u043E\u0437\u043E\u0432",
        docsPowerOfAttorney: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C",
        docsNotification: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        docsContractReview: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
        docsFreeForm: "\u0412\u0456\u043B\u044C\u043D\u0430 \u0444\u043E\u0440\u043C\u0430",
        docsParty1: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1",
        docsNameCompany: "\u0406\u043C'\u044F / \u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
        docsParty2: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2",
        docsDate: "\u0414\u0430\u0442\u0430",
        docsAdditionalInfo: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
        docsGenerating: "\u0413\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F...",
        docsGenerate: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438",
        docsGeneratedDocument: "\u0417\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsEmptyState: "\u0417\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0437'\u044F\u0432\u0438\u0442\u044C\u0441\u044F \u0442\u0443\u0442",
        docsShowDemo: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0434\u0435\u043C\u043E-\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        docsSend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        docsCreatedDocuments: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        docsSearch: "\u041F\u043E\u0448\u0443\u043A...",
        docsFileManager: "\u0424\u0430\u0439\u043B\u043E\u0432\u0438\u0439 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440",
        docsUpload: "\u0412\u0438\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        docsCases: "\u0421\u043F\u0440\u0430\u0432\u0438",
        docsTemplates: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438",
        docsRecentFiles: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0444\u0430\uFFFD\uFFFD\u043B\u0438",
        billingTitle: "\u0411\u0456\u043B\u0456\u043D\u0433",
        billingNewInvoice: "\u041D\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
        billingTotalSent: "\u0412\u0441\u044C\u043E\u0433\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        billingPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingUnpaid: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingOverdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
        billingActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        billingClientStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        billingEInvoice: "\u0415-\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
        billingAutoCheck: "\u0410\u0432\u0442\u043E\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430",
        billingSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u2192",
        billingInvoice: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
        billingClient: "\u041A\u043B\u0456\u0454\u043D\u0442",
        billingCase: "\u0421\u043F\u0440\u0430\u0432\u0430",
        billingAmount: "\u0421\u0443\u043C\u0430",
        billingDue: "\u0422\u0435\u0440\u043C\u0456\u043D",
        billingStatus: "\u0421\u0442\u0430\u0442\u0443\u0441",
        aiTitle: "AI \u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        aiPowered: 'Powered by AI',
        aiDraftDocs: "\u0421\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
        aiContractAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432",
        aiLegalResearch: "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u0434\u043E\u0441\u043B\u0456\u0434\u0436\u0435\u043D\u043D\u044F",
        aiDraftAvailable: "\u0421\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
        aiGoToDocuments: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u2192",
        aiPasteContract: "\u0412\u0441\u0442\u0430\u0432\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u0441\u044E\u0434\u0438...",
        aiAnalyze: "\u0410\u043D\u0430\u043B\u0456\u0437\u0443\u0432\u0430\u0442\u0438",
        aiReanalyze: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0438\u0439 \u0430\u043D\u0430\u043B\u0456\u0437",
        aiParties: "\u0421\u0442\u043E\u0440\u043E\u043D\u0438",
        aiObligations: "\u041A\u043B\u044E\u0447\u043E\u0432\u0456 \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u043D\u043D\u044F",
        aiRiskFactors: "\u0424\u0430\u043A\u0442\u043E\u0440\u0438 \u0440\u0438\u0437\u0438\u043A\u0443",
        aiDeadlines: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D\u0438",
        aiRecommendations: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0457",
        aiAskQuestion: "\u041F\u043E\u0441\u0442\u0430\u0432\u0442\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0430 \u0413\u0440\u0443\u0437\u0456\u0457",
        aiLegalResearchTitle: "AI \u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u0434\u043E\u0441\u043B\u0456\u0434\u0436\u0435\u043D\u043D\u044F",
        aiAskPlaceholder: "\u041F\u043E\u0441\u0442\u0430\u0432\u0442\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F...",
        aiSend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        pitchTagline: "Legal SAAS \u0413\u0440\u0443\u0437\u0456\u0457",
        pitchSubtitle: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \xb7 \u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \xb7 AI \u2014 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0438\u0445 \u0444\u0456\u0440\u043C",
        pitchCta: "\u041F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u043C\u043E\u0436\u043B\u0438\u0432\u0456\u0441\u0442\u044C \u2192",
        pitchMarketLabel: "// \u0420\u0438\u043D\u043E\u043A",
        pitchMarketTitle: "5000+ \u044E\u0440\u0438\u0441\u0442\u0456\u0432 \u0443 \u0413\u0440\u0443\u0437\u0456\u0457",
        pitchPopulation: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044F",
        pitchTbilisi: "\u0422\u0431\u0456\u043B\u0456\u0441\u0456",
        pitchConcentrated: "\u041A\u043E\u043D\u0446\u0435\u043D\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u0440\u0438\u043D\u043E\u043A",
        pitchZeroCompetitor: "\u041C\u0456\u0441\u0446\u0435\u0432\u0438\u0439 SaaS \u043A\u043E\u043D\u043A\u0443\u0440\u0435\u043D\u0442",
        pitchProblemLabel: "// \u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        pitchProblemTitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0456 \u0444\u0456\u0440\u043C\u0438 \u0434\u043E\u0441\u0456 \u043F\u0440\u0430\u0446\u044E\u044E\u0442\u044C \u0443 WhatsApp \u0442\uFFFD\uFFFD Excel",
        pitchNoBooking: "\u041D\u0435\u043C\u0430\u0454 \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        pitchManualCases: "\u0420\u0443\u0447\u043D\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u043F\u0440\u0430\u0432\u0430\u043C\u0438",
        pitchNoAiTools: "\u041D\u0435\u043C\u0430\u0454 AI \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E",
        pitchCapabilitiesLabel: "// \u041C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0456",
        pitchOnePlatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430. \u0422\u0440\u0438 \u043E\u0441\u043D\u043E\u0432\u0438.",
        pitchProductLabel: "// \u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        pitchProductTitle: "\u0412\u0441\u0435 \u0432 \u043E\u0434\u043D\u0456\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
        pitchIntegrationsLabel: "// \u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457",
        pitchIntegrationsTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0456\u044F, \u0430 \u043D\u0435 \u0440\u0443\u0447\u043D\u0430 \u0440\u043E\u0431\u043E\u0442\u0430",
        pitchPublicRegistry: "\u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0438\u0439 \u0440\u0435\u0454\u0441\u0442\u0440",
        pitchCalendarSyncTitle: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        pitchOcrTitle: "OCR \u0442\u0430 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
        pitchPlansLabel: "// \u0422\u0430\u0440\u0438\u0444\u0438",
        pitchPlansTitle: "\u0426\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0438\u043D\u043A\u0443",
        pitchTierStarter: 'Starter',
        pitchMostPopular: "\u041D\u0430\u0439\u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456\u0448\u0438\u0439",
        pitchTierPro: 'Professional',
        pitchTierBusiness: 'Business',
        pitchTierEnterprise: "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0438\u0439",
        pitchRevenueLabel: "// \u0414\u043E\u0445\u0456\u0434",
        pitchRevenueTitle: "\u041F\u043E\u0442\u0435\u043D\u0446\u0456\u0430\u043B \u0434\u043E\u0445\u043E\u0434\u0443",
        pitchFinanceLabel: "// \u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        pitchFinanceTitle: "\u042E\u043D\u0456\u0442-\u0435\u043A\u043E\u043D\u043E\u043C\u0456\u043A\u0430",
        pitchTimeLabel: "// \u0427\u0430\u0441",
        pitchTimeTitle: "\u0421\u043B\u0443\u0448\u043D\u0438\u0439 \u0447\u0430\u0441",
        pitchPrivacyLabel: "// \u041A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u0456\u0441\u0442\u044C",
        pitchPrivacyTitle: "\u041A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u0456\u0441\u0442\u044C \u2014 \u0446\u0435 \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        pitchCtaLabel: "// \u0411\u0443\u0434\u0443\u0454\u043C\u043E \u0440\u0430\u0437\u043E\u043C",
        pitchCtaTitle: "\u041F\u043E\u0431\u0443\u0434\u0443\u0439\u043C\u043E \u043F\u0440\u0430\u0432\u043E\u0432\u0443 \u0456\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443 \u0413\u0440\u0443\u0437\u0456\u0457",
        pitchCtaLink: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u2192",
        pitchPerMonth: "\u043C\u0456\u0441\u044F\u0446\u044C",
        settingsTitle: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        settingsTabProfile: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C",
        settingsTabFirm: "\u0424\u0456\u0440\u043C\u0430",
        settingsTabTeam: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
        settingsTabNotifications: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
        settingsUploadPhoto: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E",
        settingsSave: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        settingsFirmAddress: "\u0410\u0434\u0440\u0435\u0441\u0430",
        settingsFirmRegNumber: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
        settingsPublicBookingUrl: "\u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0438\u0439 URL \u0434\u043B\u044F \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        settingsTeamMembers: "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
        settingsInvite: "+ \u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438",
        settingsRoleOwner: "\u0412\u043B\u0430\u0441\u043D\u0438\u043A",
        settingsRoleLawyer: "\u042E\u0440\u0438\u0441\u0442",
        settingsNotifyTitle: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
        settingsToggleOn: "\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
        settingsToggleOff: "\u0412\u0438\u043C\u043A\u043D\u0435\u043D\u043E",
        loginSubtitle: "\u0423\u0432\u0456\u0439\u0434\u0456\u0442\u044C \u0434\u043E \u0441\u0432\u043E\u0433\u043E \u0430\u043A\u0430\u0443\u043D\u0442\u0430",
        loginLawyer: "\u042E\u0440\u0438\u0441\u0442",
        loginClient: "\u041A\u043B\u0456\u0454\u043D\u0442",
        loginPassword: "\u041F\u0430\u0440\u043E\u043B\u044C",
        loginSubmit: "\u0423\u0432\u0456\u0439\u0442\u0438 \u2192",
        loginCaseNumber: "\u041D\u043E\u043C\u0435\u0440 \u0441\u043F\u0440\u0430\u0432\u0438",
        loginBackLink: "\u2190 \u041D\u0430\u0437\u0430\u0434",
        portalLogout: "\u0412\u0438\u0439\u0442\u0438",
        portalWelcome: "\u0412\u0456\u0442\u0430\u0454\u043C\u043E,",
        portalActiveCases: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0441\u043F\u0440\u0430\u0432\u0438",
        portalDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\uFFFD\uFFFD",
        portalMessages: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        portalSend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        clientDashNavCases: "\u0421\u043F\u0440\u0430\u0432\u0438",
        clientDashNavInvoices: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
        clientDashNavDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        clientDashNavMessages: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        clientDashLogout: "\u0412\u0438\u0439\u0442\u0438",
        clientDashWelcome: "\u0412\u0456\u0442\u0430\u0454\u043C\u043E,",
        clientDashDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        clientDashSend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        findLawyer: "\u0417\u043D\u0430\u0439\u0442\u0438 \u044E\u0440\u0438\u0441\u0442\u0430",
        lawyersSearchSub: "\u0428\u0443\u043A\u0430\u0439\u0442\u0435 \u0441\u0435\u0440\u0435\u0434 5,700+ \u044E\u0440\u0438\u0441\u0442\u0456\u0432, \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u0443 Georgian Bar Association",
        searchBtn: "\u041F\u043E\u0448\u0443\u043A",
        viewAll: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u0456",
        lawyerPortal: "\u041F\u043E\u0440\u0442\u0430\u043B \u044E\u0440\u0438\u0441\u0442\u0430",
        aiFeature: 'AI',
        aiChip1: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u043D\u043E\u0442\u0430\u0440\u0456\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
        aiChip1Question: "\u042F\u043A\u0456 \u0443\u043C\u043E\u0432\u0438 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u043D\u043E\u0442\u0430\u0440\u0456\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443?",
        aiChip2: "\u0421\u0442\u0430\u0442\u0442\u044F 317 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0443",
        aiChip2Question: "\u0422\u043B\u0443\u043C\u0430\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0442\u0456 317 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0443",
        aiChip3: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0456\u0441\u0442\u044C \u043F\u0440\u0430\u0432\u043E\u0447\u0438\u043D\u0443",
        aiChip3Question: "\u0421\u0443\u0434\u043E\u0432\u0430 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0430 \u0449\u043E\u0434\u043E \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u043E\u0441\u0442\u0456 \uFFFD\uFFFD\u0440\u0430\u0432\u043E\u0447\u0438\u043D\u0443 \u0437\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 3 \u0440\u043E\u043A\u0438",
        aiDeadlinesData: "\u2022 \u041F\u043E\u0447\u0430\u0442\u043E\u043A \u043D\u0430\u0434\u0430\u043D\u043D\u044F \u043F\u043E\u0441\u043B\u0443\u0433: 10 \u0434\u043D\u0456\u0432 \u0432\u0456\u0434 \u0434\u0430\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443\n\u2022 \u041F\u0435\u0440\u0448\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436: 1 \u043A\u0432\u0456\u0442\u043D\u044F 2026 \u0440\u043E\u043A\u0443\n\u2022 \u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443: 12 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
        aiEmptyChatSub: "AI \u2014 \u041F\u043E\u0441\u0442\u0430\u0432\u0442\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F \u0442\u0430 \u043E\u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0449\u043E\u0434\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0430 \u0413\u0440\u0443\u0437\u0456\u0457",
        aiObligationsData: "1. \u041D\u0430\u0434\u0430\u043D\u043D\u044F \u043F\u043E\u0441\u043B\u0443\u0433 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u0438\u0445 \u0434\u043D\u0456\u0432\n2. \u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 15 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432\n3. \u041A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u0456\u0441\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 3 \u0440\u043E\u043A\u0456\u0432",
        aiPartiesData: "\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1: \u0422\u041E\u0412 Barateli & Partners\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2: \u0422\u041E\u0412 Delta Group",
        aiRecommendationsData: "1. \u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0443\u043D\u043A\u0442 \u043F\u0440\u043E \u0448\u0442\u0440\u0430\u0444\u043D\u0456 \u0441\u0430\u043D\u043A\u0446\u0456\u0457 (\u0441\u0442. 417 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0443)\n2. \u0412\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0441\u043F\u043E\u0440\u0456\u0432 \u0447\u0435\u0440\u0435\u0437 \u0430\u0440\u0431\u0456\u0442\u0440\u0430\u0436\n3. \u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u0443\u043D\u043A\u0442 \u043F\u0440\u043E \u0444\u043E\u0440\u0441-\u043C\u0430\u0436\u043E\u0440",
        aiRisksData: "\u2022 \u0428\u0442\u0440\u0430\u0444 \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0443 \u043D\u0435 \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E\n\u2022 \u041C\u0435\u0445\u0430\u043D\u0456\u0437\u043C \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0441\u043F\u043E\u0440\u0456\u0432 \u043D\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u043E\n\u2022 \u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u043E \u0444\u043E\u0440\u0441-\u043C\u0430\u0436\u043E\u0440 \u043D\u0435 \u043E\u0445\u043E\u043F\u043B\u044E\u0454 \u043F\u0430\u043D\u0434\u0435\u043C\u0456\u044E",
        address: "\u0410\u0434\u0440\u0435\u0441\u0430",
        addressVal: "\u0422\u0431\u0456\u043B\u0456\u0441\u0456, \u0427\u0430\u0432\u0447\u0430\u0432\u0430\u0434\u0437\u0435 12",
        appleCalendar: 'Apple Calendar',
        billingClient1: "\u0413\u0456\u043E\u0440\u0433\u0456 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456",
        billingClient2: "\u041C\u0430\u0440\u0456\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0456\u044F",
        billingClient3: "\u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0456\u0430\u0448\u0432\u0456\u043B\u0456",
        billingClientName: "\u0422\u041E\u0412 Delta Group",
        billingDue1: "25 \u0431\u0435\u0440",
        billingDue2: "15 \u0431\u0435\u0440",
        billingDue3: "10 \u0431\u0435\u0440",
        billingEmailNotification: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u044E \u043F\u043E\u0448\u0442\u043E\u044E",
        billingLastCheck: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430: \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        billingNoDebt: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u044F",
        billingRsBanner: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u044F \u0437 rs.ge \u2014 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0430 \u0442\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A-\u0444\u0430\u043A\u0442\u0443\u0440\u0430 \u0432 \u043E\u0434\u0438\u043D \u043A\u043B\u0456\u043A",
        billingRsTaxSystem: "rs.ge \u2014 \u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430",
        billingStatusPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        billingStatusSent: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        billingViewFull: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u2192",
        billingViewInvoices: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043A\u0438 \u2192",
        billingWeeklyEnabled: "\u0429\u043E\u0442\u0438\u0436\u043D\u0435\u0432\u043E \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
        caseRow1Title: "#2024-047 \u2014 \u0413\u0456\u043E\u0440\u0433\u0456 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456",
        caseRow2Title: "#2024-046 \u2014 \u041C\u0430\u0440\u0456\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0456\u044F",
        caseRow3Title: "#2024-045 \u2014 \u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0456\u0430\u0448\u0432\u0456\u043B\u0456",
        change1Date: "15 \u0431\u0435\u0440\u0435\u0437\u043D\u044F \u2014 \u041D\u0430\u0431\u0443\u0432\u0430\u0454 \u0447\u0438\u043D\u043D\u043E\u0441\u0442\u0456: 1 \u043A\u0432\u0456\u0442\u043D\u044F",
        change1Desc: "\u0422\u0435\u0440\u043C\u0456\u043D \u0437\u0431\u0456\u043B\u044C\u0448\u0435\u043D\u043E \u0437 30 \u0434\u043E 45 \u0434\u043D\u0456\u0432",
        change1Name: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441 \u2014 \u0441\u0442. 316",
        change2Date: "12 \u0431\u0435\u0440\u0435\u0437\u043D\u044F \u2014 \u041D\u0430\u0431\u0443\u0432\u0430\u0454 \u0447\u0438\u043D\u043D\u043E\u0441\u0442\u0456: 1 \u0442\u0440\u0430\u0432\u043D\u044F",
        change2Desc: "\u0422\u0435\u0440\u043C\u0456\u043D \u0430\u043F\u0435\u043B\u044F\u0446\u0456\u0457 \u0437 14 \u0434\u043E 21 \u0434\u043D\u044F",
        change2Name: "\u041F\u0440\u043E\u0446\u0435\u0441\u0443\u0430\u043B\u044C\u043D\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441 \u2014 \u0422\u0435\u0440\u043C\u0456\u043D\u0438",
        claimAccepted: "\u041F\u043E\u0437\u043E\u0432 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u043E \u2014 17 \u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        claimFiled: "\u041F\u043E\u0437\u043E\u0432 \u043F\u043E\u0434\u0430\u043D\u043E \u2014 15 \u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        claimFiledDoc: "\u041F\u043E\u0437\u043E\u0432 \u2014 \u041F\u043E\u0434\u0430\u043D\u043E",
        clientName1: "\u0413\u0456\u043E\u0440\u0433\u0456 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456",
        clientName2: "\u041C\u0430\u0440\u0456\u0430\u043C \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0456\u044F",
        clientName3: "\u041B\u0435\u043B\u0430 \u0413\u043E\u0433\u0456\u0430\u0448\u0432\u0456\u043B\u0456",
        companyExtractLoaded: "\u0412\u0438\u043F\u0438\u0441\u043A\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u2014 \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
        companyName: "\u0422\u041E\u0412 Delta Group",
        clientsActiveCases1: "1 \u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u0441\u043F\u0440\u0430\u0432\u0430",
        clientsActiveCases2: "1 \u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u0441\u043F\u0440\u0430\u0432\u0430",
        clientsActiveCases3: "0 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0441\u043F\u0440\u0430\u0432",
        clientsAvatar1: "\u0413\u041C",
        clientsAvatar2: "\u041C\u041A",
        clientsAvatar3: "\u041B\u0413",
        clientsCaseLink1: "#2024-047 \u2014 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0430",
        clientsCaseLink2: "#2024-046 \u2014 \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0430",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0441\u043F\u0440\u0430\u0432",
        clientsPaid1: "\u20BE2,400 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPaid2: "\u20BE800 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientsPaid3: "\u20BE1,800 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        dashAlertText: "2 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u0441\u043F\u0440\u0430\u0432\u0438 \u0442\u0430 \u20BE1,840 \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0445 \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
        dashBooking1Time: "10:00 \u2014 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0430",
        dashBooking2Time: "11:30 \u2014 \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0430",
        dashBooking3Time: "14:00 \u2014 \u041A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0430",
        dashCaseMeta1: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0430 \xb7 18 \u0431\u0435\u0440",
        dashCaseMeta2: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0430 \xb7 17 \u0431\u0435\u0440",
        dashCaseMeta3: "\u041A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0430 \xb7 15 \u0431\u0435\u0440",
        dashClient3Name: "\u0414\u0430\u0432\u0456\u0442 \u0427\u0456\u043A\u043E\u0432\u0430\u043D\u0456",
        dashDate: "18 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026",
        dashGreeting: "\u041F\u0440\u0438\u0432\u0456\u0442, \u041D\u0456\u043D\u043E",
        dateMar15: "15 \u0431\u0435\u0440",
        dateMar17: "17 \u0431\u0435\u0440",
        dateMar18: "18 \u0431\u0435\u0440",
        disabledStatus: "\u2014 \u0412\uFFFD\uFFFD\u043C\u043A\u043D\u0435\u043D\u043E",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "\u0413\u0440\u0443\u0437\u0456\u044F, \u0422\u0431\u0456\u043B\u0456\u0441\u0456\n\n\u041F\u043E\u0437\u043E\u0432\n\n\u041F\u043E\u0437\u0438\u0432\u0430\u0447: \u0422\u041E\u0412 Barateli & Partners\n\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447: \u0422\u041E\u0412 Delta Group\n\n\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0456 \u043E\u0431\u0441\u0442\u0430\u0432\u0438\u043D\u0438:\n\n\u0426\u0438\u043C \u043F\u043E\u0437\u043E\u0432\u043E\u043C \u043F\u043E\u0437\u0438\u0432\u0430\u0447 \u0432\u0438\u043C\u0430\u0433\u0430\u0454 \u0432\u0456\u0434 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447\u0430 \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0441\u0432\u043E\u0457 \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u043D\u043D\u044F.\n\n\u0412\u0438\u043C\u043E\u0433\u0430:\n\n1. \u0417\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447\u0430 \u0432\u0438\u043F\u043B\u0430\u0442\u0438\u0442\u0438 12,500 GEL\n2. \u041D\u0430\u043A\u043B\u0430\u0441\u0442\u0438 \u0448\u0442\u0440\u0430\u0444 \u0443 \u0440\u043E\u0437\u043C\u0456\u0440\u0456 1,875 GEL\n3. \u0412\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u0442\u0438 \u0441\u0443\u0434\u043E\u0432\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438\n\n\u0414\u0430\u0442\u0430: 18 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026\n\u041F\u0456\u0434\u043F\u0438\u0441: ________________",
        docsDocument: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 \u0431\u0435\u0440 2026",
        docsFile1Name: "\u041F\u043E\u0437\u043E\u0432 - \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 \u0431\u0435\u0440 2026",
        docsFile2Name: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C - \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0456\u044F.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 \u0431\u0435\u0440 2026",
        docsFile3Name: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 \u0431\u0435\u0440 2026",
        docsFile4Name: "\u041A\u043E\u043F\u0456\u044F ID - \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 \u0431\u0435\u0440 2026",
        docsFile5Name: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F - \u0413\u043E\u0433\u0456\u0430\u0448\u0432\u0456\u043B\u0456.pdf",
        docsFolder1Count: "3 \u0444\u0430\u0439\u043B\u0438",
        docsFolder1Name: "#2024-047 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456",
        docsFolder2Count: "2 \u0444\u0430\u0439\u043B\u0438",
        docsFolder2Name: "#2024-046 \u041A\u0432\u0430\u0440\u0430\u0446\u0445\u0435\u043B\u0456\u044F",
        docsFolder3Count: "1 \u0444\u0430\u0439\u043B",
        docsFolder3Name: "#2024-045 \u0413\u043E\u0433\u0456\u0430\u0448\u0432\u0456\u043B\u0456",
        docsFolder4Count: "5 \u0444\u0430\u0439\u043B\u0456\u0432",
        docsFormatAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0444\u043E\u0440\u043C\u0430\u0442\u0443...",
        docsFreeText: "\u0412\u0456\u043B\u044C\u043D\u0438\u0439 \u0442\u0435\u043A\u0441\u0442...",
        docsGeneratedClaimText: "\u0413\u0440\u0443\u0437\u0456\u044F, \u0422\u0431\u0456\u043B\u0456\u0441\u0456\n\n\u041F\u043E\u0437\u043E\u0432\n\n\u041F\u043E\u0437\u0438\u0432\u0430\u0447: [\u0421\u0442\u043E\u0440\u043E\u043D\u0430 1]\n\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447: [\u0421\u0442\u043E\u0440\u043E\u043D\u0430 2]\n\n\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0456 \u043E\u0431\u0441\u0442\u0430\u0432\u0438\u043D\u0438:\n\n\u0426\u0438\u043C \u043F\u043E\u0437\u043E\u0432\u043E\u043C \u043F\u043E\u0437\u0438\u0432\u0430\u0447 \u0432\u0438\u043C\u0430\u0433\u0430\u0454 \u0432\u0456\u0434 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447\u0430 \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0441\u0432\u043E\u0457 \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0443 \u0413\u0440\u0443\u0437\u0456\u0457.\n\n\u041F\u0440\u0430\u0432\u043E\u0432\u0430 \u043E\u0441\u043D\u043E\u0432\u0430:\n\n\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0441\u0442\u0430\u0442\u0442\u0456 316 \u0426\u0438\u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0435\u043A\u0441\u0443, \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0438\u043D\u043D\u0456 \u0432\u0438\u043A\u043E\u043D\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u043D\u0430\u043B\u0435\u0436\u043D\u0438\u043C \u0447\u0438\u043D\u043E\u043C.\n\n\u0412\u0438\u043C\u043E\u0433\u0430:\n\n\u0412\u0440\u0430\u0445\u043E\u0432\u0443\u044E\u0447\u0438 \u0432\u0438\u0449\u0435\u0432\u0438\u043A\u043B\u0430\u0434\u0435\u043D\u0435, \u043F\u043E\u0437\u0438\u0432\u0430\u0447 \u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0443\u0434 \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0447\u0430.\n\n\u0414\u0430\u0442\u0430: 18 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026\n\u041F\u0456\u0434\u043F\u0438\u0441: ________________",
        docsGeorgianSymbols: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0438",
        docsOcrNote: "OCR-\u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u2014 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043E\u0446\u0438\u0444\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0430\u043F\u0435\u0440\u043E\u0432\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432, \u0440\u0443\u0447\u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0435",
        docsOcrResultText: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u2116147\n\n\u0422\u0431\u0456\u043B\u0456\u0441\u0456, 10 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026 \u0440\u043E\u043A\u0443\n\n\u0417 \u043E\u0434\u043D\u0456\u0454\u0457 \u0441\u0442\u043E\u0440\u043E\u043D\u0438, \u0422\u041E\u0412 \xabBarateli & Partners\xbb (\u0406\u041D 404123456) \u0432 \u043E\u0441\u043E\u0431\u0456 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456 (\u043D\u0430\u0434\u0430\u043B\u0456 \xab\u0412\u0438\u043A\u043E\u043D\u0430\u0432\u0435\u0446\u044C\xbb), \u0442\u0430 \u0437 \u0456\u043D\u0448\u043E\u0457 \u0441\u0442\u043E\u0440\u043E\u043D\u0438, \u0422\u041E\u0412 \xabDelta Group\xbb (\u0406\u041D 404789012) \u0432 \u043E\u0441\u043E\u0431\u0456 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430 \u0413\u0456\u043E\u0440\u0433\u0456 \u041C\u0430\u043C\u0443\u043B\u0430\u0448\u0432\u0456\u043B\u0456 (\u043D\u0430\u0434\u0430\u043B\u0456 \xab\u041A\u043B\u0456\u0454\u043D\u0442\xbb), \u0443\u043A\u043B\u0430\u043B\u0438 \u0446\u0435\u0439 \u0434\u043E\u0433\u043E\u0432\u0456\u0440:\n\n\u0421\u0442\u0430\u0442\u0442\u044F 1. \u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443\n1.1. \u0412\u0438\u043A\u043E\u043D\u0430\u0432\u0435\u0446\u044C \u0437\u043E\u0431\u043E\u0432'\u044F\u0437\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430\u0434\u0430\u0442\u0438 \u041A\u043B\u0456\u0454\u043D\u0442\u0443 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u043F\u043E\u0441\u043B\u0443\u0433\u0438.\n1.2. \u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043F\u043E\u0441\u043B\u0443\u0433 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C 12 500 (\u0434\u0432\u0430\u043D\u0430\u0434\u0446\u044F\u0442\u044C \u0442\u0438\u0441\u044F\u0447 \u043F'\u044F\u0442\u0441\u043E\u0442) GEL.",
        docsOcrSuccess: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0440\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u043D\uFFFD\uFFFD \u2014 \u0442\u043E\u0447\u043D\u0456\u0441\u0442\u044C 98.5%",
        docsRow1Meta: "#2024-047 \xb7 \u041F\u043E\u0437\u043E\u0432 \xb7 15 \u0431\u0435\u0440",
        docsRow1Name: "\u041F\u043E\u0437\u043E\u0432 - Mamulashvili.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \xb7 12 \u0431\u0435\u0440",
        docsRow2Name: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C - Kvaratskhelia.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \xb7 8 \u0431\u0435\u0440",
        docsRow3Name: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F - Gogiashvili.pdf",
        docsTextRecognition: "\u0420\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u0432\u0430\u043D\u043D\u044F \u0442\u0435\u043A\u0441\u0442\u0443",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u043C\u0430\u043A\u0441. 10MB",
        docsUploadSub: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0430\u0431\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0432\u0438\u0431\u0440\u0430\u0442\u0438",
        ecourt: 'ecourt',
        ecourtDesc: "\u041F\u043E\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0437\u043E\u0432\u0438, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u044F\u0439\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \u0441\u043F\u0440\u0430\u0432\u0438 \u0442\u0430 \u0440\u043E\u0437\u043A\u043B\u0430\u0434 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u044C \u2014 \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0443 \u0434\u043E \u0441\u0443\u0434\u0443",
        enabledStatus: "\u2713 \u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
        evidencePending: "\u0414\u043E\u043A\u0430\u0437\u0438 \u2014 \u041E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F",
        extract: "\u0412\u0438\u0442\u044F\u0433",
        field1Text: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0435: \u0441\u0442. 316 \u0437\u043C\u0456\u043D\u0430",
        field2Text: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0435: \u0441\u0442. 259 \u0441\u0442\u0440\u043E\u043A\u0438",
        field3Text: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0435: \u0435-\u043F\u043E\u0441\u043B\u0443\u0433\u0438",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 \u0431\u0435\u0440, 10:00 \u2014 \u0422\u0431\u0456\u043B\u0456\u0441\u044C\u043A\u0438\u0439 \u043C\u0456\u0441\u044C\u043A\u0438\u0439 \u0441\u0443\uFFFD\uFFFD",
        hearingItem2: "\uD83D\uDCC5 28 \u0431\u0435\u0440, 14:30 \u2014 \u0410\u043F\u0435\u043B\u044F\u0446\u0456\u0439\u043D\u0438\u0439 \u0441\u0443\u0434",
        loginEmail: 'Email',
        matsne: 'matsne',
        matsneDesc: "\u0417\u043C\u0456\u043D\u0438 \u0432 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u2014 \u0443 \u0432\u0430\u0448\u0456\u0439 \u0433\u0430\u043B\u0443\u0437\u0456 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        outlook: 'Outlook',
        prepHearing: "\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u0447\u0435 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F \u2014 22 \u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        propertyApartment: "\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430 \u2014 \u0412\u0430\u043A\u0435, 85 \u043A\u0432.\u043C \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u0412\u0438\u0442\u044F\u0433 \u043D\u0430 \u043C\u0430\u0439\u043D\u043E \u2014 \u0414\u043E\u0434\u0430\u043D\u043E",
        registryDesc: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u0442\u0430 \u043C\u0430\u0439\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u2014 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0456\u044F\u043A\u0438\u0445 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u044C \u0432\u0438\u0442\u044F\u0433\u0456\u0432 \u0432\u0440\u0443\u0447\u043D\u0443",
        timeEntry1Date: "18 \u0431\u0435\u0440, 10:30",
        timeEntry1Text: "\u0421\u043F\u0440\u0430\u0432\u0443 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E, \u043F\u0435\u0440\u0432\u0438\u043D\u043D\u0443 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        timeEntry2Date: "17 \u0431\u0435\u0440, 14:00",
        timeEntry2Text: "\u041A\u043B\u0456\u0454\u043D\u0442 \u043D\u0430\u0434\u0430\u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E",
        timeEntry3Date: "15 \u0431\u0435\u0440, 09:00",
        timeEntry3Text: "\u041A\u043B\u0456\u0454\u043D\u0442 \u0437\u0432\u0435\u0440\u043D\u0443\u0432\u0441\u044F \u0434\u043E \u0444\u0456\u0440\u043C\u0438, \u043F\u0435\u0440\u0432\u0438\u043D\u043D\u0430 \u0437\u0430\u044F\u0432\u043A\u0430",
        typeCivil: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0435",
        typeAdministrative: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u0435",
        typeCriminal: "\u041A\u0440\u0438\u043C\u0456\u043D\u0430\u043B\u044C\u043D\u0435",
        pitchArpuMonth: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439 ARPU/\u043C\u0456\u0441",
        pitchArpuYear: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439 ARPU/\u0440\u0456\u043A",
        pitchAutoBackup: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0435 \u043A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F",
        pitchAutoNextSteps: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0456 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0456 \u043A\u0440\u043E\u043A\u0438",
        pitchAutoReminder: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
        pitchBooking: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
        pitchCacOrganic: "CAC (\u043E\u0440\u0433\u0430\u043D\u0456\u0447\u043D\u0435 \u0437\u0440\u043E\u0441\u0442\u0430\u043D\u043D\u044F)",
        pitchCalcNote: "5000 \u044E\u0440\u0438\u0441\u0442\u0456\u0432 \xd7 \u20BE35/\u043C\u0456\u0441 \u0443 \u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u043C\u0443 \xd7 12 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
        pitchCalendarSync: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F",
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F \u0442\u0430 \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u0438 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u044E\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E",
        pitchCaseManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u043F\u0440\u0430\u0432\u0430\u043C\u0438",
        pitchClientSchedule: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
        pitchCloudDedicated: "\u0412\u0438\u0434\u0456\u043B\u0435\u043D\u0430 \u0445\u043C\u0430\u0440\u0430",
        pitchCloudDedicatedDesc: "\u0406\u0437\u043E\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0439 \u0445\u043C\u0430\u0440\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0435\u0440 \u2014 \u0432\u0430\u0448\u0456 \u0434\u0430\u043D\u0456 \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0432\u0456\u0434\u043E\u043A\u0440\u0435\u043C\u043B\u0435\u043D\u0456 \u0432\u0456\u0434 \u0456\u043D\u0448\u0438\u0445 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        pitchContractAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432",
        pitchCtaSubtext: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F + \u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 + AI",
        pitchDedicatedServer: "\u0412\u0438\u0434\u0456\u043B\u0435\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0435\u0440",
        pitchDocDraftGeo: "\u0421\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E",
        pitchEcourtDesc: "\u041F\u043E\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0437\u043E\u0432\u0438, \u0441\u0442\u0430\u0442\u0443\u0441 \u0441\u043F\u0440\u0430\u0432\u0438 \u0442\u0430 \u0440\u043E\u0437\u043A\u043B\u0430\u0434 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u044C \u2014 \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0443 \u0434\u043E \u0441\u0443\u0434\u0443",
        pitchGdprCompliant: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0432\u0438\u043C\u043E\u0433\u0430\u043C GDPR",
        pitchHybrid: "\u0413\u0456\u0431\u0440\u0438\u0434\u043D\u0438\u0439",
        pitchHybridDesc: "\u0425\u043C\u0430\u0440\u0430 + \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u2014 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u0456 \u0434\u0430\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E, \u0440\u0435\u0448\u0442\u0430 \u0443 \u0445\u043C\u0430\u0440\u0456",
        pitchIntegrationsSub: "\u0414\u0435\u0440\u0436\u0430\u0432\u043D\u0456 \u0441\u0435\u0440\u0432\u0456\u0441\u0438, \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0456 \u0442\u0430 OCR \u2014 \u0437 \u043E\u0434\u043D\u0456\u0454\u0457 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0438",
        pitchInvoices: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
        pitchMatsneDesc: "\u0417\u043C\u0456\u043D\u0438 \u0432 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u2014 \u0443 \u0432\u0430\u0448\u0456\u0439 \u0433\u0430\u043B\u0443\u0437\u0456 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        pitchOcrDesc: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043E\u0446\u0438\u0444\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0430\u043F\u0435\u0440\u043E\u0432\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u2014 \u0431\u0435\u0437 \u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
        pitchOnPremise: "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0435\u0440 (On-Premise)",
        pitchOnPremiseDesc: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u2014 \u0434\u0430\u043D\u0456 \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u043E\u0444\u0456\u0441\u0456, \u0431\u0435\u0437 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443",
        pitchOperations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
        pitchPerkAiDocs: "AI \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        pitchPerkBookings: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F\u043C\u0438",
        pitchPerkClientPortal: "\u041A\u043B\u0456\u0454\u043D\u0442\u0441\u044C\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0430\u043B",
        pitchPerkCommunication: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F",
        pitchPerkFileStorage: "\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0456\u0432",
        pitchPerkResponsive: "\u0410\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C",
        pitchPrivacySubtitle: "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0456 \u0434\u0430\u043D\u0456 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u044E\u0442\u044C \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u0445\u0438\u0441\u0442\u0443",
        pitchPublicRegistryDesc: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u0442\u0430 \u043C\u0430\u0439\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u2014 \u0431\u0435\u0437 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u044C \u0432\u0438\u0442\u044F\u0433\u0456\u0432 \u0432\u0440\u0443\u0447\u043D\u0443",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 \u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C 2026",
        pitchRecurringModel: "\u0420\u0435\u043A\u0443\u0440\u0435\u043D\u0442\u043D\u0430 \u043C\u043E\u0434\u0435\u043B\u044C",
        pitchRsGeDesc: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0431\u043E\u0440\u0433 \u0442\u0430 \u0435-\u0440\u0430\u0445\u0443\u043D\u043A\u0438 \u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 \u0432 \u043E\u0434\u0438\u043D \u043A\u043B\u0456\u043A",
        pitchScen250: "250 \u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        pitchScen500: "500 \u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        pitchScen1000: "1000 \u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        pitchServerCost: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0441\u0435\u0440\u0432\u0435\u0440\u0430/\u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
        pitchTierBusiness10: "10+ \u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        pitchTierEnterpriseCustom: "\u0406\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u0438\u0439",
        pitchTierEnterprisePrice: "\u0417\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C",
        pitchTierPro310: "3-10 \u044E\u0440\u0438\u0441\u0442\u0456\u0432",
        pitchTierStarter12: "1-2 \u044E\u0440\u0438\u0441\u0442\u0438",
        pitchTitle: "TrustLegal \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0456\u0457",
        pitchTrustedAccounting: "\u041D\u0430\u0434\u0456\u0439\u043D\u0438\u0439 \u043E\u0431\u043B\u0456\u043A",
        pitchWhyAiCheap: "\u0406\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438 \u0428\u0406 \u0442\u0435\u043F\u0435\u0440 \u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456",
        pitchWhyDigitizing: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0438\u0439 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0440\u0438\u043D\u043E\u043A \u0448\u0432\u0438\u0434\u043A\u043E \u0446\u0438\u0444\u0440\u043E\u0432\u0456\u0437\u0443\u0454\u0442\u044C\u0441\u044F",
        pitchWhyNoCompetitor: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0438\u0437\u043D\u0430\u043D\u0438\u0445 \u043A\u043E\u043D\u043A\u0443\u0440\u0435\u043D\u0442\u0456\u0432",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        settingsMember2Name: "\u0413\u0456\u0433\u0430 \u0410\u0441\u043B\u0430\u043D\u0456\u0448\u0432\u0456\u043B\u0456",
        settingsNotifyDeadlineReminder: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u043E \u0434\u0435\u0434\u043B\u0430\u0439\u043D",
        settingsNotifyNewBookingEmail: "\u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u2014 Email",
        settingsNotifyNewBookingWhatsapp: "\u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
        settingsNotifyReminder24h: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 24 \u0433\u043E\u0434",
        settingsProfileName: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        settingsToggle3DaysBefore: "\u0417\u0430 3 \u0434\u043D\u0456",
        portalCaseTypeCivil: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0430",
        portalDocDate1: "15 \u0431\u0435\u0440",
        portalDocName1: "\u041F\u043E\u0437\u043E\u0432 - Mamulashvili.pdf",
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0434\u043E: 25 \u0431\u0435\u0440",
        portalLastUpdate: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F: 18 \u0431\u0435\u0440",
        portalMsgFrom1: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        portalMsgPlaceholder: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F...",
        portalMsgText1: "\u0412\u0456\u0442\u0430\u044E, \u0413\u0456\u043E\u0440\u0433\u0456, \u0443 \u043D\u0430\u0441 \u0454 \u043D\u043E\u0432\u0435 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0443 \u0441\u043F\u0440\u0430\u0432\u0456.",
        portalMsgText2: "\u0414\u044F\u043A\u0443\u044E, \u0447\u0435\u043A\u0430\u044E \u043D\u0430 \u0434\u0435\u0442\u0430\u043B\u0456.",
        portalNextHearing: "\u0421\u0443\u0434\u043E\u0432\u0435 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F 25 \u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        portalPay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438",
        portalPendingInvoices: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0438",
        portalProgressLabel: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441: 3/5 \u043A\u0440\u043E\u043A\u0456\u0432",
        portalStatusActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        clientDashCaseTypeCivil: "\u0426\u0438\u0432\u0456\u043B\u044C\u043D\u0430",
        clientDashDocMeta1: "\u0421\u043F\u0440\u0430\u0432\u0430 #2024-047 \xb7 15 \u0431\u0435\u0440",
        clientDashDocMeta2: "\u0421\u043F\u0440\u0430\u0432\u0430 #2024-046 \xb7 12 \u0431\u0435\u0440",
        clientDashDocName1: "\u041F\u043E\u0437\u043E\u0432 - Mamulashvili.pdf",
        clientDashDocName2: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C - Kvaratskhelia.pdf",
        clientDashDocumentsTitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        clientDashInvCase1: "\u0421\u043F\u0440\u0430\u0432\u0430: #2024-047",
        clientDashInvCase2: "\u0421\u043F\u0440\u0430\u0432\u0430: #2024-046",
        clientDashInvDue1: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0434\u043E: 25 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026",
        clientDashInvoicesTitle: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
        clientDashInvPaidDate: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E: 14 \u0431\u0435\u0440\u0435\u0437\u043D\u044F 2026",
        clientDashLawyerInitials: "\u041D\u0411",
        clientDashLawyerName: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        clientDashLawyerRole: "\u0412\u0430\u0448 \u044E\u0440\u0438\u0441\u0442",
        clientDashMessagesTitle: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        clientDashMsgFrom1: "\u041D\u0456\u043D\u043E \u0411\u0430\u0440\u0430\u0442\u0435\u043B\u0456",
        clientDashMsgFrom3: "\u041D\u0456\u043D\u043E \u0411\u0430\uFFFD\uFFFD\u0430\u0442\u0435\u043B\u0456",
        clientDashMsgPlaceholder: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F...",
        clientDashMsgText1: "\u0412\u0456\u0442\u0430\u044E, \u0413\u0456\u043E\u0440\u0433\u0456, \u0443 \u043D\u0430\u0441 \u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0443 \u0441\u043F\u0440\u0430\u0432\u0456. \u0421\u0443\u0434 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0432 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F \u043D\u0430 25 \u0431\u0435\u0440\u0435\u0437\u043D\u044F.",
        clientDashMsgText2: "\u0414\u044F\u043A\u0443\u044E, \u0447\u0435\u043A\u0430\u044E \u043D\u0430 \u0434\u0435\u0442\u0430\u043B\u0456. \u0427\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043C\u0435\u043D\u0456 \u043F\u0456\u0434\u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u044F\u043A\u0456\u0441\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438?",
        clientDashMsgText3: "\u041D\u0456, \u0432\u0441\u0435 \u0433\u043E\u0442\u043E\u0432\u043E. \u0417\u0432'\u044F\u0436\u0443\u0441\u044F \u0437 \u0432\u0430\u043C\u0438 \u0437\u0430 \u0442\u0438\u0436\u0434\u0435\u043D\u044C \u0434\u043E \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F.",
        clientDashMsgTime1: "10:30 \xb7 \u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        clientDashMsgTime2: "10:45 \xb7 \u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        clientDashMsgTime3: "11:02 \xb7 \u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        clientDashMyCases: "\u041C\u043E\u0457 \u0441\u043F\u0440\u0430\u0432\u0438",
        clientDashPaid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientDashPay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438",
        clientDashProgressLabel: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441: 3/5 \u043A\u0440\u043E\u043A\u0456\u0432 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        clientDashStatActiveCase: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430 \u0441\u043F\u0440\u0430\u0432\u0430",
        clientDashStatDocument: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        clientDashStatNextHearing: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F",
        clientDashStatNextHearingValue: "25 \u0431\u0435\u0440",
        clientDashStatPayable: "\u0414\u043E \u043E\u043F\u043B\u0430\u0442\u0438",
        clientDashStatusActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        clientDashStep1Date: "5 \u0431\u0435\u0440 2026",
        clientDashStep1Title: "\u041A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        clientDashStep2Date: "10 \u0431\u0435\u0440 2026",
        clientDashStep2Title: "\u041F\u043E\u0437\u043E\u0432 \u0441\u043A\u043B\u0430\u0434\u0435\u043D\u043E",
        clientDashStep3Date: "15 \u0431\u0435\u0440 2026",
        clientDashStep3Title: "\u041F\u043E\u0437\u043E\u0432 \u043F\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0441\u0443\u0434\u0443",
        clientDashStep4Date: "25 \u0431\u0435\u0440 2026 \u2014 \u041E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F",
        clientDashStep4Title: "\u0421\u0443\u0434\u043E\u0432\u0435 \u0437\u0430\u0441\u0456\u0434\u0430\u043D\u043D\u044F",
        clientDashStep5Title: "\u0420\u0456\u0448\u0435\u043D\u043D\u044F",
        clientDashUnpaid: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        clientDashWelcomeSub: "\u0422\u0443\u0442 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0432\u0430\u0442\u0438 \u0441\u0432\u043E\u0457 \u0441\u043F\u0440\u0430\u0432\u0438, \u0440\u0430\u0445\u0443\u043D\u043A\u0438 \u0442\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438."
    },
    tr: {
        home: 'Ana Sayfa',
        dashboard: 'Panel',
        bookings: 'Randevular',
        bookingPage: "Randevu Sayfas\u0131",
        aiDocuments: 'AI Belgeleri',
        clientPortalNav: "M\xfcvekkil Portal\u0131",
        lawyersNav: 'Avukatlar',
        login: "Giri\u015F Yap",
        getStarted: "\xdccretsiz Ba\u015Fla",
        lawyersTitle: "Avukatlar ve Hukuk B\xfcrolar\u0131",
        lawyersSubtitle: "G\xfcrcistan'da kay\u0131tl\u0131",
        searchPlaceholder: "\u0130sim, b\xfcro veya uzmanl\u0131k alan\u0131na g\xf6re ara...",
        lawyersBtn: 'Avukatlar',
        firmsBtn: "B\xfcrolar",
        allFilter: "T\xfcm\xfc",
        corporateLaw: "\u015Eirketler Hukuku",
        criminalLaw: 'Ceza Hukuku',
        familyLaw: 'Aile Hukuku',
        realEstate: 'Gayrimenkul Hukuku',
        taxLaw: 'Vergi Hukuku',
        ipLaw: "Fikri M\xfclkiyet",
        immigration: "G\xf6\xe7menlik",
        laborLaw: "\u0130\u015F Hukuku",
        bankingFinance: "Bankac\u0131l\u0131k ve Finans",
        firmsMatch: "e\u015Fle\u015Fen b\xfcro",
        lawyersMatch: "e\u015Fle\u015Fen avukat",
        reviews: "de\u011Ferlendirme",
        loadingMore: "Daha fazla y\xfckleniyor...",
        independent: "Ba\u011F\u0131ms\u0131z",
        yearsExperience: "y\u0131ll\u0131k deneyim",
        languages: 'Diller',
        backToDirectory: "\u2190 Rehbere d\xf6n",
        about: "Hakk\u0131nda",
        bookConsultation: 'Randevu Al',
        sendMessage: "Mesaj G\xf6nder",
        call: 'Ara',
        reviewsRatings: "De\u011Ferlendirmeler ve Puanlar",
        reviewsComingSoon: "De\u011Ferlendirmeler yak\u0131nda. \u0130lk de\u011Ferlendiren siz olun.",
        barId: 'Baro Sicil No',
        ourTeam: 'Ekibimiz',
        contact: "\u0130leti\u015Fim",
        website: 'Web Sitesi',
        established: 'Kur.',
        lawyersCount: 'avukat',
        georgian: "G\xfcrc\xfcce",
        english: "\u0130ngilizce",
        russian: "Rus\xe7a",
        german: 'Almanca',
        french: "Frans\u0131zca",
        turkish: "T\xfcrk\xe7e",
        heroLine1: 'Hukuk',
        heroLine2: 'ekibiniz. Tek',
        heroLine3: 'platform.',
        heroSubtitle: "TrustLegal \u2014 G\xfcrcistan hukuk b\xfcrolar\u0131 i\xe7in randevular, davalar, \xf6demeler ve AI belge tasla\u011F\u0131 olu\u015Fturma. Tek ayl\u0131k \xfccret, s\xf6zle\u015Fme yok.",
        tryFree: "\uFFFD\uFFFDcretsiz Dene \u2192",
        liveDemo: "Canl\u0131 Demo",
        trustedBrands: "Kaliteye \xf6nem veren markalar bizimle \xe7al\u0131\u015F\u0131yor",
        howItWorks: "Nas\u0131l \xe7al\u0131\u015F\u0131r",
        processLabel: "// S\xfcre\xe7",
        step1Title: "Kay\u0131t ol",
        step1Desc: "Hesap olu\u015Fturun ve bir plan se\xe7in. Kredi kart\u0131 gerekmez \u2014 ilk 30 g\xfcn \xfccretsiz.",
        step2Title: "Davalar\u0131 y\xf6net",
        step2Desc: "M\xfcvekkilleri, davalar\u0131 ve randevular\u0131 ekleyin. Otomatik hat\u0131rlat\u0131c\u0131lar ve takvim senkronizasyonu.",
        step3Title: "AI ile taslak olu\u015Ftur",
        step3Desc: "G\xfcrc\xfcce AI destekli belge tasla\u011F\u0131 olu\u015Fturma. Dilek\xe7eler, vekaletnameler, s\xf6zle\u015Fme analizi.",
        step4Title: "B\xfcy\xfc",
        step4Desc: "Faturalar\u0131, gelirleri ve ekip verimlili\u011Fini takip edin. Ger\xe7ek zamanl\u0131 analizler.",
        demoBadge: "// Canl\u0131 Demo",
        todaysBookings: "Bug\xfcn\xfcn randevular\u0131",
        fullDemo: "Tam demo \u2192",
        onePlatformThreePillars: "Tek platform.\n\xdc\xe7 temel yap\u0131.",
        capabilitiesLabel: '// Yetenekler',
        bookingFeature: 'Randevu',
        bookingFeatureDesc: "M\xfcvekkiller kendi zamanlar\u0131n\u0131 se\xe7er. Otomatik hat\u0131rlat\u0131c\u0131lar. Takvim senkronizasyonu. Herkese a\xe7\u0131k randevu sayfas\u0131.",
        operationsFeature: 'Operasyonlar',
        operationsFeatureDesc: "Merkezi dava y\xf6netimi. M\xfcvekkil portal\u0131. Faturalar ve \xf6demeler. Ekip y\xf6netimi.",
        aiFeatureDesc: "G\xfcrc\xfcce belge tasla\u011F\u0131 olu\u015Fturma. S\xf6zle\u015Fme analizi. Hukuki ara\u015Ft\u0131rma. Otomatik takip.",
        simplePricing: "Basit fiyatland\u0131rma",
        plansLabel: '// Planlar',
        perMonth: '/ ay',
        bookingMgmt: "Randevu y\xf6netimi",
        caseTracking: 'Dava takibi',
        calendarSync: 'Takvim senkronizasyonu',
        emailReminders: "E-posta hat\u0131rlat\u0131c\u0131lar\u0131",
        starterPlan: "Ba\u015Flang\u0131\xe7",
        startNow: "Hemen ba\u015Fla \u2192",
        everythingStarter: "Ba\u015Flang\u0131\xe7 plan\u0131ndaki her \u015Fey",
        aiDocDrafting: "Yapay zeka belge tasla\u011F\u0131",
        invoicesPayments: "Faturalar ve \xf6demeler",
        clientPortalFeature: "M\xfcvekkil portal\u0131",
        directSupport: "Do\u011Frudan destek",
        professionalPlan: 'Profesyonel',
        mostPopular: "En pop\xfcler",
        everythingPro: "Profesyonel plan\u0131ndaki her \u015Fey",
        teamMgmt10: "Ekip y\xf6netimi (10+ avukat)",
        contractAnalysis: "S\xf6zle\u015Fme analizi",
        advancedAnalytics: "Geli\u015Fmi\u015F analitik",
        personalOnboarding: "Ki\u015Fisel oryantasyon",
        businessPlan: "\u0130\u015Fletme",
        spotsLeft: "3 yer kald\u0131",
        enterpriseNote: "Kurumsal \u2014 \xf6zel bir teklif i\xe7in bizimle ileti\u015Fime ge\xe7in.",
        readyQuestion: "Haz\u0131r m\u0131s\u0131n\u0131z?",
        first30DaysFree: "\u0130lk 30 g\xfcn \xfccretsiz. S\xf6zle\u015Fme yok. \u0130stedi\u011Finiz zaman iptal edin.",
        footerTagline: "G\xfcrc\xfc hukuki SaaS platformu.",
        productLabel: "\xdcr\xfcn",
        companyLabel: "\u015Eirket",
        bookingsLink: 'Randevular',
        casesLink: 'Davalar',
        aiDocsLink: 'Yapay Zeka Belgeleri',
        aboutUs: "Hakk\u0131m\u0131zda",
        careers: 'Kariyer',
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "Symbols ile olu\u015Fturuldu",
        sidebarMain: 'Kontrol Paneli',
        sidebarBookings: 'Randevular',
        sidebarCases: 'Davalar',
        sidebarClients: "M\xfcvekkiller",
        sidebarDocs: 'Belgeler',
        sidebarPayments: "\xd6demeler",
        sidebarLawyers: 'Avukatlar',
        sidebarSettings: 'Ayarlar',
        sidebarLogout: "\xc7\u0131k\u0131\u015F yap",
        bookingsTitle: 'Randevular',
        newBooking: '+ Yeni Randevu',
        newBookingTitle: 'Yeni Randevu',
        clientName: "M\xfcvekkil ad\u0131",
        phoneNumber: 'Telefon',
        civilLaw: 'Medeni',
        criminalLaw2: 'Ceza Hukuku',
        administrativeLaw: "\u0130dare",
        otherType: "Di\u011Fer",
        notesPlaceholder: 'Notlar...',
        confirmBooking: 'Randevuyu Onayla',
        cancelBtn: "\u0130ptal",
        calendarSyncNote: "Takvim senkronizasyonu \u2014 Google Calendar, Outlook, Apple Calendar otomatik olarak senkronize edilir",
        synced: 'Senkronize edildi',
        calendarSync2: 'Takvim Senkronizasyonu',
        syncedStatus: 'Senkronize',
        bookingsToday: "Bug\xfcn 3 randevu",
        settingsLink: "Ayarlar \u2192",
        pendingStatus: 'Bekliyor',
        connectionNeeded: "Ba\u011Flant\u0131 gerekli",
        connectLink: "Ba\u011Flan \u2192",
        lastSync: "Son senkronizasyon: 5 dk \xf6nce",
        mon: 'Pzt',
        tue: 'Sal',
        wed: "\xc7ar",
        thu: 'Per',
        fri: 'Cum',
        bookingDetails: "Randevu Detaylar\u0131",
        confirmed: "Onayland\u0131",
        pending: 'Bekliyor',
        upcomingBookings: "Yakla\u015Fan Randevular",
        closeBtn: 'Kapat',
        selectDateTime: "Tarih ve saat se\xe7in",
        fillInfo: "Bilgileri doldurun \u2014 ",
        firstName: 'Ad',
        lastName: 'Soyad',
        phoneField: 'Telefon',
        emailField: 'E-posta',
        caseDescription: "K\u0131sa dava a\xe7\u0131klamas\u0131",
        confirmBookingPublic: 'Randevuyu Onayla',
        goBack: "Geri d\xf6n",
        bookingConfirmedMsg: "Randevu onayland\u0131!",
        timeLabel: 'Saat: ',
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: 'Nino Barateli',
        casesTitle: 'Davalar',
        searchPlaceholder2: 'Ara...',
        newCase: '+ Yeni Dava',
        allTab: "T\xfcm\xfc",
        activeTab: 'Aktif',
        pendingTab: 'Bekleyen',
        closedTab: "Kapal\u0131",
        selectCasePrompt: "Ayr\u0131nt\u0131lar\u0131 g\xf6rmek i\xe7in bir dava se\xe7in",
        info: 'Bilgi',
        registry: 'Sicil',
        clientInfo: "M\xfcvekkil Bilgileri",
        chronology: 'Kronoloji',
        addNote: 'Not ekle',
        enterNote: 'Bir not girin...',
        addBtn: 'Ekle',
        documentsLabel: 'Belgeler',
        createBtn: "+ Olu\u015Ftur",
        noDocs: 'Belge yok',
        hearingSchedule: "Duru\u015Fma Takvimi",
        caseStatus: 'Dava Durumu',
        electronicFiling: 'Elektronik Dosyalama',
        idCode: 'Kimlik Kodu:',
        director: "Y\xf6netici:",
        addressLabel: 'Adres:',
        statusLabel: 'Durum:',
        registeredProperty: "Kay\u0131tl\u0131 M\xfclk",
        extractLabel: "\xd6zet",
        recentChanges: "Son De\u011Fi\u015Fiklikler",
        yourFieldChanges: "Alan\u0131n\u0131zdaki de\u011Fi\u015Fiklikler",
        newLabel: 'Yeni',
        notifications: 'Bildirimler',
        clientsTitle: "M\xfcvekkiller",
        clientsSearchPlaceholder: "M\xfcvekkil ara...",
        clientsProfile: "M\xfcvekkil Profili",
        clientsContactLabel: "\u0130leti\u015Fim",
        clientsInvoiceHistory: "Fatura Ge\xe7mi\u015Fi",
        clientsUnpaid: "\xd6denmemi\u015F",
        clientsPaid: "\xd6dendi",
        clientsPortalInvite: "M\xfcvekkil portal\u0131 eri\u015Fimi g\xf6nder",
        dashTodayBookings: "Bug\xfcnk\xfc randevular",
        dashUnpaid: "\xd6denmemi\u015F",
        dashOverdue: "Gecikmi\u015F",
        dashAiGenerations: "AI \xfcretimleri",
        dashTodaysBookings: "Bug\xfcn\xfcn randevular\u0131",
        dashConfirmed: "Onayland\u0131",
        dashRecentCases: 'Son davalar',
        dashNewBooking: '+ Yeni Randevu',
        dashNewCase: '+ Yeni Dava',
        dashAiDocument: 'AI Belgesi',
        docsTitle: 'Belgeler',
        docsCreate: "Olu\u015Ftur",
        docsExisting: 'Mevcut Belgeler',
        docsFiles: 'Dosyalar',
        docsOcrScan: 'Tara',
        docsOcrTitle: "OCR Taramas\u0131",
        docsUploadText: "Bir belge foto\u011Fraf\u0131 veya PDF y\xfckleyin",
        docsScanning: "Belge taran\u0131yor...",
        docsFile: 'Dosya',
        docsPages: 'Sayfalar',
        docsLanguage: 'Dil',
        docsGeorgian: "G\xfcrc\xfcce",
        docsAddToCase: 'Davaya ekle',
        docsCopy: 'Kopyala',
        docsRescan: 'Yeniden tara',
        docsClaim: 'Talep',
        docsPowerOfAttorney: 'Vekaletname',
        docsNotification: 'Bildirim',
        docsContractReview: "S\xf6zle\u015Fme \u0130ncelemesi",
        docsFreeForm: 'Serbest Form',
        docsParty1: 'Taraf 1',
        docsNameCompany: "\u0130sim / \u015Eirket",
        docsParty2: 'Taraf 2',
        docsDate: 'Tarih',
        docsAdditionalInfo: 'Ek Bilgiler',
        docsGenerating: "Olu\u015Fturuluyor...",
        docsGenerate: "Olu\u015Ftur",
        docsGeneratedDocument: "Olu\u015Fturulan Belge",
        docsEmptyState: "Olu\u015Fturulan belge burada g\xf6r\xfcnecek",
        docsShowDemo: "Demo belgeyi g\xf6ster",
        docsDownload: "\u0130ndir",
        docsSend: "G\xf6nder",
        docsCreatedDocuments: "Olu\u015Fturulan Belgeler",
        docsSearch: 'Ara...',
        docsFileManager: "Dosya Y\xf6neticisi",
        docsUpload: "Y\xfckle",
        docsCases: 'Davalar',
        docsTemplates: "\u015Eablonlar",
        docsRecentFiles: 'Son Dosyalar',
        billingTitle: "Faturaland\u0131rma",
        billingNewInvoice: 'Yeni Fatura',
        billingTotalSent: "Toplam G\xf6nderilen",
        billingPaid: "\xd6dendi",
        billingUnpaid: "\xd6denmedi",
        billingOverdue: "Gecikmi\u015F",
        billingActive: 'Aktif',
        billingClientStatus: "M\xfcvekkil Durumu",
        billingEInvoice: 'e-Fatura',
        billingAutoCheck: 'Otomatik kontrol',
        billingSettings: "Ayarlar \u2192",
        billingInvoice: 'Fatura',
        billingClient: "M\xfcvekkil",
        billingCase: 'Dava',
        billingAmount: 'Tutar',
        billingDue: 'Vade',
        billingStatus: 'Durum',
        aiTitle: "AI Asistan\u0131",
        aiPowered: 'AI Destekli',
        aiDraftDocs: "Belge Haz\u0131rlama",
        aiContractAnalysis: "S\xf6zle\u015Fme Analizi",
        aiLegalResearch: "Hukuki Ara\u015Ft\u0131rma",
        aiDraftAvailable: "Belge haz\u0131rlama belgeler sayfas\u0131nda mevcuttur",
        aiGoToDocuments: "Belgelere git \u2192",
        aiPasteContract: "S\xf6zle\u015Fme metnini buraya yap\u0131\u015Ft\u0131r\u0131n...",
        aiAnalyze: 'Analiz Et',
        aiReanalyze: 'Yeniden Analiz Et',
        aiParties: 'Taraflar',
        aiObligations: "Temel Y\xfck\xfcml\xfcl\xfckler",
        aiRiskFactors: "Risk Fakt\xf6rleri",
        aiDeadlines: 'Son Tarihler',
        aiRecommendations: "\xd6neriler",
        aiAskQuestion: "G\xfcrcistan hukuku hakk\u0131nda bir soru sorun",
        aiLegalResearchTitle: "AI Hukuki Ara\u015Ft\u0131rma",
        aiAskPlaceholder: 'Bir soru sorun...',
        aiSend: "G\xf6nder",
        pitchTagline: "G\xfcrcistan'\u0131n Hukuk SAAS'\u0131",
        pitchSubtitle: "Randevu \xb7 Operasyonlar \xb7 AI \u2014 G\xfcrc\xfc firmalar i\xe7in",
        pitchCta: "F\u0131rsat\u0131 g\xf6r\xfcn \u2192",
        pitchMarketLabel: '// Pazar',
        pitchMarketTitle: "G\xfcrcistan'da 5000+ avukat",
        pitchPopulation: "N\xfcfus",
        pitchTbilisi: 'Tiflis',
        pitchConcentrated: "Yo\u011Funla\u015Fm\u0131\u015F pazar",
        pitchZeroCompetitor: 'Yerel SaaS rakibi',
        pitchProblemLabel: '// Problem',
        pitchProblemTitle: "G\xfcrc\xfc firmalar hala WhatsApp ve Excel ile \xe7al\u0131\u015F\u0131yor",
        pitchNoBooking: "M\xfcvekkil randevu sistemi yok",
        pitchManualCases: "Manuel dava y\xf6netimi",
        pitchNoAiTools: "G\xfcrc\xfcce AI ara\xe7lar\u0131 yok",
        pitchCapabilitiesLabel: '// Yetenekler',
        pitchOnePlatform: "Tek platform. \xdc\xe7 temel yap\u0131.",
        pitchProductLabel: "// \xdcr\xfcn",
        pitchProductTitle: "Her \u015Fey tek bir platformda",
        pitchIntegrationsLabel: '// Entegrasyonlar',
        pitchIntegrationsTitle: "Manuel i\u015F de\u011Fil, otomasyon",
        pitchPublicRegistry: 'Kamu Sicili',
        pitchCalendarSyncTitle: 'Takvim Senkronizasyonu',
        pitchOcrTitle: 'OCR & Tarama',
        pitchPlansLabel: '// Planlar',
        pitchPlansTitle: "G\xfcrcistan pazar\u0131 i\xe7in fiyatland\u0131rma",
        pitchTierStarter: "Ba\u015Flang\u0131\xe7",
        pitchMostPopular: "En Pop\xfcler",
        pitchTierPro: 'Profesyonel',
        pitchTierBusiness: 'Kurumsal',
        pitchTierEnterprise: 'Kurumsal',
        pitchRevenueLabel: '// Gelir',
        pitchRevenueTitle: 'Gelir Potansiyeli',
        pitchFinanceLabel: '// Finans',
        pitchFinanceTitle: 'Birim Ekonomisi',
        pitchTimeLabel: '// Zamanlama',
        pitchTimeTitle: "Zamanlama do\u011Fru",
        pitchPrivacyLabel: '// Gizlilik',
        pitchPrivacyTitle: "Gizlilik bir \xf6nceliktir",
        pitchCtaLabel: "// Birlikte \u0130n\u015Fa Edelim",
        pitchCtaTitle: "G\xfcrcistan'\u0131n yasal altyap\u0131s\u0131n\u0131 in\u015Fa edelim",
        pitchCtaLink: "Ana sayfa \u2192",
        pitchPerMonth: 'ay',
        settingsTitle: 'Ayarlar',
        settingsTabProfile: 'Profil',
        settingsTabFirm: 'Firma',
        settingsTabTeam: 'Ekip',
        settingsTabNotifications: 'Bildirimler',
        settingsUploadPhoto: "Foto\u011Fraf Y\xfckle",
        settingsSave: 'Kaydet',
        settingsFirmAddress: 'Adres',
        settingsFirmRegNumber: "Sicil Numaras\u0131",
        settingsPublicBookingUrl: "Herkese A\xe7\u0131k Rezervasyon URL'si",
        settingsTeamMembers: "Ekip \xdcyeleri",
        settingsInvite: '+ Davet Et',
        settingsRoleOwner: 'Sahip',
        settingsRoleLawyer: 'Avukat',
        settingsNotifyTitle: "Bildirim Ayarlar\u0131",
        settingsToggleOn: 'Etkin',
        settingsToggleOff: "Devre D\u0131\u015F\u0131",
        loginSubtitle: "Hesab\u0131n\u0131za giri\u015F yap\u0131n",
        loginLawyer: 'Avukat',
        loginClient: "M\xfcvekkil",
        loginPassword: "\u015Eifre",
        loginSubmit: "Giri\u015F yap \u2192",
        loginCaseNumber: "Dosya Numaras\u0131",
        loginBackLink: "\u2190 Geri d\xf6n",
        portalLogout: "\xc7\u0131k\u0131\u015F yap",
        portalWelcome: 'Merhaba,',
        portalActiveCases: 'Aktif Davalar',
        portalDocuments: 'Belgeler',
        portalMessages: 'Mesajlar',
        portalSend: "G\xf6nder",
        clientDashNavCases: 'Davalar',
        clientDashNavInvoices: 'Faturalar',
        clientDashNavDocuments: 'Belgeler',
        clientDashNavMessages: 'Mesajlar',
        clientDashLogout: "\xc7\u0131k\u0131\u015F yap",
        clientDashWelcome: 'Merhaba,',
        clientDashDownload: "\u0130ndir",
        clientDashSend: "G\xf6nder",
        findLawyer: 'Avukat Bul',
        lawyersSearchSub: "Georgian Bar Association'a kay\u0131tl\u0131 5.700+ avukat aras\u0131nda arama yap\u0131n",
        searchBtn: 'Ara',
        viewAll: "T\xfcm\xfcn\xfc g\xf6r",
        lawyerPortal: "Avukat Portal\u0131",
        aiFeature: 'AI',
        aiChip1: "Noter s\xf6zle\u015Fmesi iptali",
        aiChip1Question: "Bir noter s\xf6zle\u015Fmesini iptal etmenin \u015Fartlar\u0131 nelerdir?",
        aiChip2: 'Medeni Kanun Madde 317',
        aiChip2Question: "Medeni Kanun Madde 317'nin yorumlanmas\u0131",
        aiChip3: "\u0130\u015Flem ge\xe7ersizli\u011Fi",
        aiChip3Question: "Son 3 y\u0131lda i\u015Flem ge\xe7ersizli\u011Fi \xfczerine mahkeme uygulamas\u0131",
        aiDeadlinesData: "\u2022 Hizmet ba\u015Flang\u0131c\u0131: S\xf6zle\u015Fmeden itibaren 10 g\xfcn\n\u2022 \u0130lk \xf6deme: 1 Nisan 2026\n\u2022 S\xf6zle\u015Fme s\xfcresi: 12 ay",
        aiEmptyChatSub: "AI \u2014 G\xfcrcistan hukuku hakk\u0131nda bir soru sorun ve cevap al\u0131n",
        aiObligationsData: "1. 30 takvim g\xfcn\xfc i\xe7inde hizmet teslimi\n2. 15 i\u015F g\xfcn\xfc i\xe7inde \xf6deme\n3. 3 y\u0131l boyunca gizlilik",
        aiPartiesData: 'Taraf 1: Barateli & Partners LLC\nTaraf 2: Delta Group LLC',
        aiRecommendationsData: "1. Ceza \u015Fart\u0131 ekleyin (Medeni Kanun Mad. 417)\n2. Tahkim yoluyla uyu\u015Fmazl\u0131k \xe7\xf6z\xfcm\xfcn\xfc tan\u0131mlay\u0131n\n3. M\xfccbir sebep maddesini geni\u015Fletin",
        aiRisksData: "\u2022 Gecikme cezas\u0131 tan\u0131mlanmam\u0131\u015F\n\u2022 Uyu\u015Fmazl\u0131k \xe7\xf6z\xfcm mekanizmas\u0131 belirtilmemi\u015F\n\uFFFD\uFFFD M\xfccbir sebep maddesi pandemiyi kapsam\u0131yor",
        address: 'Adres',
        addressVal: 'Tiflis, Chavchavadze 12',
        appleCalendar: 'Apple Calendar',
        billingClient1: 'Giorgi Mamulashvili',
        billingClient2: 'Mariam Kvaratskhelia',
        billingClient3: 'Lela Gogiashvili',
        billingClientName: 'Delta Group LLC',
        billingDue1: '25 Mar',
        billingDue2: '15 Mar',
        billingDue3: '10 Mar',
        billingEmailNotification: 'E-posta bildirimi',
        billingLastCheck: "Son kontrol: bug\xfcn",
        billingNoDebt: "\xd6denmemi\u015F bor\xe7 yok",
        billingRsBanner: "rs.ge entegrasyonu \u2014 tek t\u0131kla m\xfc\u015Fteri vergi borcu ve e-fatura",
        billingRsTaxSystem: "rs.ge \u2014 Vergi Sistemi",
        billingStatusPaid: "\xd6dendi",
        billingStatusSent: "G\xf6nderildi",
        billingViewFull: "Tamam\u0131n\u0131 g\xf6r\xfcnt\xfcle \u2192",
        billingViewInvoices: "Faturalar\u0131 g\xf6r\xfcnt\xfcle \u2192",
        billingWeeklyEnabled: "Haftal\u0131k etkin",
        caseRow1Title: "#2024-047 \u2014 Giorgi Mamulashvili",
        caseRow2Title: "#2024-046 \u2014 Mariam Kvaratskhelia",
        caseRow3Title: "#2024-045 \u2014 Lela Gogiashvili",
        change1Date: "15 Mart \u2014 Y\xfcr\xfcrl\xfck: 1 Nisan",
        change1Desc: "S\xfcre 30 g\xfcnden 45 g\xfcne \xe7\u0131kar\u0131ld\u0131",
        change1Name: "Medeni Kanun \u2014 Madde 316",
        change2Date: "12 Mart \u2014 Y\xfcr\xfcrl\xfck: 1 May\u0131s",
        change2Desc: "\u0130tiraz s\xfcresi 14 g\xfcnden 21 g\xfcne \xe7\u0131kar\u0131ld\u0131",
        change2Name: "Usul Kanunu \u2014 S\xfcreler",
        claimAccepted: "Dava kabul edildi \u2014 17 Mart",
        claimFiled: "Dava a\xe7\u0131ld\u0131 \u2014 15 Mart",
        claimFiledDoc: "Dava \u2014 A\xe7\u0131ld\u0131",
        clientName1: 'Giorgi Mamulashvili',
        clientName2: 'Mariam Kvaratskhelia',
        clientName3: 'Lela Gogiashvili',
        companyExtractLoaded: "\u015Eirket sicil \xf6zeti \u2014 Y\xfcklendi",
        companyName: 'Delta Group LLC',
        clientsActiveCases1: '1 aktif dava',
        clientsActiveCases2: '1 aktif dava',
        clientsActiveCases3: '0 aktif dava',
        clientsAvatar1: 'GM',
        clientsAvatar2: 'MK',
        clientsAvatar3: 'LG',
        clientsCaseLink1: "#2024-047 \u2014 Hukuk",
        clientsCaseLink2: "#2024-046 \u2014 \u0130dare",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: 'Aktif dava yok',
        clientsPaid1: "\u20BE2,400 \xf6dendi",
        clientsPaid2: "\u20BE800 \xf6dendi",
        clientsPaid3: "\u20BE1,800 \xf6dendi",
        dashAlertText: "2 gecikmi\u015F dava ve \u20BE1,840 \xf6denmemi\u015F fatura",
        dashBooking1Time: "10:00 \u2014 Hukuk",
        dashBooking2Time: "11:30 \u2014 \u0130dare",
        dashBooking3Time: "14:00 \u2014 Ceza",
        dashCaseMeta1: "Hukuk \xb7 18 Mart",
        dashCaseMeta2: "\u0130dare \xb7 17 Mart",
        dashCaseMeta3: "Ceza \xb7 15 Mart",
        dashClient3Name: 'Davit Chikovani',
        dashDate: '18 Mart 2026',
        dashGreeting: 'Merhaba, Nino',
        dateMar15: '15 Mart',
        dateMar17: '17 Mart',
        dateMar18: '18 Mart',
        disabledStatus: "\u2014 Devre d\u0131\u015F\u0131",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "G\xfcrcistan, Tiflis\n\nDava Dilek\xe7esi\n\nDavac\u0131: Barateli & Partners LLC\nDaval\u0131: Delta Group LLC\n\nMaddi Vak\u0131alar:\n\nBu dava ile davac\u0131, daval\u0131n\u0131n y\xfck\xfcml\xfcl\xfcklerini yerine getirmesini talep etmektedir.\n\nTalep:\n\n1. Daval\u0131n\u0131n 12,500 GEL \xf6demeye mahkum edilmesi\n2. 1,875 GEL ceza uygulanmas\u0131\n3. Mahkeme masraflar\u0131n\u0131n kar\u015F\u0131lanmas\u0131\n\nTarih: 18 Mart 2026\n\u0130mza: ________________",
        docsDocument: 'Belge',
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 Mart 2026",
        docsFile1Name: "Dava Dilek\xe7esi - Mamulashvili.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 Mart 2026",
        docsFile2Name: 'Vekaletname - Kvaratskhelia.pdf',
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 Mart 2026",
        docsFile3Name: "S\xf6zle\u015Fme \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 Mart 2026",
        docsFile4Name: 'Kimlik Fotokopisi - Mamulashvili.jpg',
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 Mart 2026",
        docsFile5Name: 'Bildirim - Gogiashvili.pdf',
        docsFolder1Count: '3 dosya',
        docsFolder1Name: '#2024-047 Mamulashvili',
        docsFolder2Count: '2 dosya',
        docsFolder2Name: '#2024-046 Kvaratskhelia',
        docsFolder3Count: '1 dosya',
        docsFolder3Name: '#2024-045 Gogiashvili',
        docsFolder4Count: '5 dosya',
        docsFormatAnalysis: 'Format analizi...',
        docsFreeText: 'Serbest metin...',
        docsGeneratedClaimText: "G\xfcrcistan, Tiflis\n\nDava Dilek\xe7esi\n\nDavac\u0131: [Taraf 1]\nDaval\u0131: [Taraf 2]\n\nMaddi Vak\u0131alar:\n\nBu dava ile davac\u0131, daval\u0131n\u0131n G\xfcrcistan Medeni Kanunu kapsam\u0131ndaki y\xfck\xfcml\xfcl\xfcklerini yerine getirmesini talep etmektedir.\n\nHukuki Dayanak:\n\nMedeni Kanun'un 316. Maddesi uyar\u0131nca, y\xfck\xfcml\xfcl\xfckler usul\xfcne uygun olarak yerine getirilmelidir.\n\nTalep:\n\nYukar\u0131dakiler g\xf6z \xf6n\xfcne al\u0131narak, davac\u0131 mahkemeden daval\u0131y\u0131 y\xfck\xfcml\xfc k\u0131lmas\u0131n\u0131 talep etmektedir.\n\nTarih: 18 Mart 2026\n\u0130mza: ________________",
        docsGeorgianSymbols: "G\xfcrc\xfcce karakterler",
        docsOcrNote: "OCR Tarama \u2014 ka\u011F\u0131t belgelerin otomatik dijitalle\u015Ftirilmesi, manuel yazmaya gerek yok",
        docsOcrResultText: 'S\xf6zle\u015Fme \u2116147\n\nTiflis, 10 Mart 2026\n\nBir tarafta, y\xf6netici Nino Barateli taraf\u0131ndan temsil edilen Barateli & Partners LLC (Kimlik 404123456) (bundan b\xf6yle "Y\xfcklenici" olarak an\u0131lacakt\u0131r) ve di\u011Fer tarafta, y\xf6netici Giorgi Mamulashvili taraf\u0131ndan temsil edilen Delta Group LLC (Kimlik 404789012) (bundan b\xf6yle "M\xfc\u015Fteri" olarak an\u0131lacakt\u0131r) aras\u0131nda bu s\xf6zle\u015Fme akdedilmi\u015Ftir:\n\nMadde 1. S\xf6zle\u015Fmenin Konusu\n1.1. Y\xfcklenici, M\xfc\u015Fteriye hukuki hizmetler sunmay\u0131 taahh\xfct eder.\n1.2. Hizmet bedeli 12.500 (on iki bin be\u015F y\xfcz) GEL\'dir.',
        docsOcrSuccess: "Ba\u015Far\u0131yla tan\u0131nd\u0131 \u2014 %98.5 do\u011Fruluk",
        docsRow1Meta: "#2024-047 \xb7 Dava Dilek\xe7esi \xb7 15 Mar",
        docsRow1Name: "Dava Dilek\xe7esi - Mamulashvili.pdf",
        docsRow2Meta: "#2024-046 \xb7 Vekaletname \xb7 12 Mar",
        docsRow2Name: 'Vekaletname - Kvaratskhelia.pdf',
        docsRow3Meta: "#2024-045 \xb7 Tebligat \xb7 8 Mar",
        docsRow3Name: 'Tebligat - Gogiashvili.pdf',
        docsTextRecognition: "Metin tan\u0131ma",
        docsUploadFormats: "JPG, PNG, PDF \u2014 maks 10MB",
        docsUploadSub: "Bir dosyay\u0131 s\xfcr\xfckleyin veya se\xe7mek i\xe7in t\u0131klay\u0131n",
        ecourt: 'ecourt',
        ecourtDesc: "Dava a\xe7\u0131n, dava durumunu ve duru\u015Fma takvimini kontrol edin \u2014 mahkemeye gitmeden",
        enabledStatus: "\u2713 Etkin",
        evidencePending: "Delil \u2014 Bekliyor",
        extract: "Kay\u0131t \xd6zeti",
        field1Text: "Hukuk: Madde 316 de\u011Fi\u015Fikli\u011Fi",
        field2Text: "Hukuk: Madde 259 s\xfcreleri",
        field3Text: "\u0130dare: e-tebligat",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 Mar, 10:00 \u2014 Tiflis \u015Eehir Mahkemesi",
        hearingItem2: "\uD83D\uDCC5 28 Mar, 14:30 \u2014 Temyiz Mahkemesi",
        loginEmail: 'E-posta',
        matsne: 'matsne',
        matsneDesc: "Mevzuat de\u011Fi\u015Fiklikleri otomatik olarak \u2014 \xe7al\u0131\u015Fma alan\u0131n\u0131zda",
        outlook: 'Outlook',
        prepHearing: "\xd6n inceleme duru\u015Fmas\u0131 \u2014 22 Mart",
        propertyApartment: "Daire \u2014 Vake, 85 m\xb2 \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "Tapu kayd\u0131 \u2014 Eklendi",
        registryDesc: "\u015Eirket ve m\xfclk verileri otomatik olarak \u2014 art\u0131k manuel kay\u0131t indirmeye son",
        timeEntry1Date: '18 Mar, 10:30',
        timeEntry1Text: "Dosya a\xe7\u0131ld\u0131, ilk g\xf6r\xfc\u015Fme tamamland\u0131",
        timeEntry2Date: '17 Mar, 14:00',
        timeEntry2Text: "M\xfcvekkil belgeleri sa\u011Flad\u0131",
        timeEntry3Date: '15 Mar, 09:00',
        timeEntry3Text: "M\xfcvekkil firmayla ileti\u015Fime ge\xe7ti, ilk ba\u015Fvuru",
        typeCivil: 'Hukuk',
        typeAdministrative: "\u0130dare",
        typeCriminal: 'Ceza',
        pitchArpuMonth: 'Ortalama ARPU/ay',
        pitchArpuYear: "Ortalama ARPU/y\u0131l",
        pitchAutoBackup: 'Otomatik yedekleme',
        pitchAutoNextSteps: "Otomatik sonraki ad\u0131mlar",
        pitchAutoReminder: "Otomatik hat\u0131rlat\u0131c\u0131",
        pitchBooking: 'Randevu',
        pitchCacOrganic: "CAC (organik b\xfcy\xfcme)",
        pitchCalcNote: "5000 avukat \xd7 ort. \u20BE35/ay \xd7 12 ay",
        pitchCalendarSync: 'Takvim senkronizasyonu',
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 duru\u015Fmalar ve son tarihler otomatik olarak senkronize edilir",
        pitchCaseManagement: "Dava y\xf6netimi",
        pitchClientSchedule: "M\xfcvekkil takvimi",
        pitchCloudDedicated: "\xd6zel Bulut",
        pitchCloudDedicatedDesc: "\u0130zole bulut sunucusu \u2014 verileriniz di\u011Fer m\xfc\u015Fterilerden tamamen ayr\u0131l\u0131r",
        pitchContractAnalysis: "S\xf6zle\u015Fme analizi",
        pitchCtaSubtext: 'Randevu + Operasyonlar + AI',
        pitchDedicatedServer: "\xd6zel sunucu",
        pitchDocDraftGeo: "G\xfcrc\xfcce belge tasla\u011F\u0131 olu\u015Fturma",
        pitchEcourtDesc: "Dava a\xe7\u0131n, dava durumu ve duru\u015Fma takvimi \u2014 mahkemeye gitmeden",
        pitchGdprCompliant: 'GDPR uyumlu',
        pitchHybrid: 'Hibrit',
        pitchHybridDesc: "Bulut + yerel \u2014 hassas veriler yerelde, geri kalan\u0131 bulutta",
        pitchIntegrationsSub: "Devlet hizmetleri, takvimler ve OCR \u2014 tek bir platformdan",
        pitchInvoices: 'Faturalar',
        pitchMatsneDesc: "Mevzuat de\u011Fi\u015Fiklikleri otomatik olarak \u2014 \xe7al\u0131\u015Fma alan\u0131n\u0131zda",
        pitchOcrDesc: "Otomatik ka\u011F\u0131t belge dijitalle\u015Ftirme \u2014 manuel yazmaya gerek yok",
        pitchOnPremise: "\u015Eirket \u0130\xe7i Sunucu",
        pitchOnPremiseDesc: "Tamamen yerel \u2014 veriler ofisinizde kal\u0131r, internet eri\u015Fimi yoktur",
        pitchOperations: 'Operasyonlar',
        pitchPerkAiDocs: 'AI Belgeleri',
        pitchPerkBookings: "Randevu y\xf6netimi",
        pitchPerkClientPortal: "M\xfcvekkil portal\u0131",
        pitchPerkCommunication: "\u0130leti\u015Fim",
        pitchPerkFileStorage: 'Dosya depolama',
        pitchPerkResponsive: 'Mobil Uyumlu',
        pitchPrivacySubtitle: 'Hukuki veriler maksimum koruma gerektirir',
        pitchPublicRegistryDesc: "\u015Eirket ve m\xfclk verileri otomatik olarak \u2014 manuel kay\u0131t indirmeye son",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 Mart 2026",
        pitchRecurringModel: 'Abonelik modeli',
        pitchRsGeDesc: "Vergi borcu ve e-fatura \u2014 tek t\u0131kla m\xfcvekkil durumu",
        pitchScen250: '250 avukat',
        pitchScen500: '500 avukat',
        pitchScen1000: '1000 avukat',
        pitchServerCost: "Sunucu maliyeti/kullan\u0131c\u0131",
        pitchTierBusiness10: '10+ avukat',
        pitchTierEnterpriseCustom: "\xd6zel",
        pitchTierEnterprisePrice: 'Teklif',
        pitchTierPro310: '3-10 avukat',
        pitchTierStarter12: '1-2 avukat',
        pitchTitle: "G\xfcrcistan i\xe7in TrustLegal",
        pitchTrustedAccounting: "G\xfcvenilir muhasebe",
        pitchWhyAiCheap: "Yapay zeka ara\xe7lar\u0131 art\u0131k yeterince uygun fiyatl\u0131",
        pitchWhyDigitizing: "G\xfcrcistan hukuk pazar\u0131 h\u0131zla dijitalle\u015Fiyor",
        pitchWhyNoCompetitor: "Yerle\u015Fik bir rakip yok",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: 'Nino Barateli',
        settingsMember2Name: 'Giga Aslanishvili',
        settingsNotifyDeadlineReminder: "Son tarih hat\u0131rlat\u0131c\u0131s\u0131",
        settingsNotifyNewBookingEmail: "Yeni rezervasyon \u2014 E-posta",
        settingsNotifyNewBookingWhatsapp: "Yeni rezervasyon \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "Gecikmi\u015F fatura",
        settingsNotifyReminder24h: "24 saat \xf6nce hat\u0131rlatma",
        settingsProfileName: 'Nino Barateli',
        settingsToggle3DaysBefore: "3 g\xfcn \xf6nce",
        portalCaseTypeCivil: 'Hukuk',
        portalDocDate1: '15 Mar',
        portalDocName1: "Dava Dilek\xe7esi - Mamulashvili.pdf",
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "Son \xd6deme: 25 Mar",
        portalLastUpdate: "Son g\xfcncelleme: 18 Mar",
        portalMsgFrom1: 'Nino Barateli',
        portalMsgPlaceholder: "Bir mesaj g\xf6nder...",
        portalMsgText1: "Merhaba Giorgi, davayla ilgili yeni bir g\xfcncellememiz var.",
        portalMsgText2: "Te\u015Fekk\xfcrler, detaylar\u0131 bekliyorum.",
        portalNextHearing: "Mahkeme duru\u015Fmas\u0131 25 Mart",
        portalPay: "\xd6de",
        portalPendingInvoices: 'Bekleyen Faturalar',
        portalProgressLabel: "\u0130lerleme: 3/5 ad\u0131m",
        portalStatusActive: 'Aktif',
        clientDashCaseTypeCivil: 'Hukuk',
        clientDashDocMeta1: "Dava #2024-047 \xb7 15 Mar",
        clientDashDocMeta2: "Dava #2024-046 \xb7 12 Mar",
        clientDashDocName1: "Dava Dilek\xe7esi - Mamulashvili.pdf",
        clientDashDocName2: 'Vekaletname - Kvaratskhelia.pdf',
        clientDashDocumentsTitle: 'Belgeler',
        clientDashInvCase1: 'Dava: #2024-047',
        clientDashInvCase2: 'Dava: #2024-046',
        clientDashInvDue1: "Son \xd6deme: 25 Mart 2026",
        clientDashInvoicesTitle: 'Faturalar',
        clientDashInvPaidDate: "\xd6dendi: 14 Mart 2026",
        clientDashLawyerInitials: 'NB',
        clientDashLawyerName: 'Nino Barateli',
        clientDashLawyerRole: "Avukat\u0131n\u0131z",
        clientDashMessagesTitle: 'Mesajlar',
        clientDashMsgFrom1: 'Nino Barateli',
        clientDashMsgFrom3: 'Nino Barateli',
        clientDashMsgPlaceholder: 'Bir mesaj yaz...',
        clientDashMsgText1: "Merhaba Giorgi, yeni bir dava g\xfcncellememiz var. Mahkeme duru\u015Fmay\u0131 25 Mart'a planlad\u0131.",
        clientDashMsgText2: "Te\u015Fekk\xfcrler, detaylar\u0131 bekliyorum. Herhangi bir belge haz\u0131rlamal\u0131 m\u0131y\u0131m?",
        clientDashMsgText3: "Hay\u0131r, her \u015Fey haz\u0131r. Duru\u015Fmadan bir hafta \xf6nce sizinle ileti\u015Fime ge\xe7ece\u011Fim.",
        clientDashMsgTime1: "10:30 \xb7 Bug\xfcn",
        clientDashMsgTime2: "10:45 \xb7 Bug\xfcn",
        clientDashMsgTime3: "11:02 \xb7 Bug\xfcn",
        clientDashMyCases: "Davalar\u0131m",
        clientDashPaid: "\xd6dendi",
        clientDashPay: "\xd6de",
        clientDashProgressLabel: "\u0130lerleme: 3/5 ad\u0131m tamamland\u0131",
        clientDashStatActiveCase: 'Aktif dava',
        clientDashStatDocument: 'Belge',
        clientDashStatNextHearing: "Sonraki duru\u015Fma",
        clientDashStatNextHearingValue: '25 Mar',
        clientDashStatPayable: "\xd6denecek",
        clientDashStatusActive: 'Aktif',
        clientDashStep1Date: '5 Mar 2026',
        clientDashStep1Title: "Dan\u0131\u015Fmanl\u0131k tamamland\u0131",
        clientDashStep2Date: '10 Mar 2026',
        clientDashStep2Title: "Dava dilek\xe7esi haz\u0131rland\u0131",
        clientDashStep3Date: '15 Mar 2026',
        clientDashStep3Title: "Dava dilek\xe7esi mahkemeye sunuldu",
        clientDashStep4Date: "25 Mar 2026 \u2014 Bekliyor",
        clientDashStep4Title: "Duru\u015Fma",
        clientDashStep5Title: 'Karar',
        clientDashUnpaid: "\xd6denmemi\u015F",
        clientDashWelcomeSub: "Buradan davalar\u0131n\u0131z\u0131, faturalar\u0131n\u0131z\u0131 ve belgelerinizi takip edebilirsiniz."
    },
    zh: {
        home: "\u9996\u9875",
        dashboard: "\u4EEA\u8868\u76D8",
        bookings: "\u9884\u7EA6",
        bookingPage: "\u9884\u7EA6\u9875\u9762",
        aiDocuments: "AI \u6587\u6863",
        clientPortalNav: "\u5BA2\u6237\u95E8\u6237",
        lawyersNav: "\u5F8B\u5E08",
        login: "\u767B\u5F55",
        getStarted: "\u514D\u8D39\u5F00\u59CB",
        lawyersTitle: "\u5F8B\u5E08\u4E0E\u5F8B\u6240",
        lawyersSubtitle: "\u5728\u683C\u9C81\u5409\u4E9A\u6CE8\u518C",
        searchPlaceholder: "\u6309\u59D3\u540D\u3001\u5F8B\u6240\u6216\u4E1A\u52A1\u9886\u57DF\u641C\u7D22...",
        lawyersBtn: "\u5F8B\u5E08",
        firmsBtn: "\u5F8B\u6240",
        allFilter: "\u5168\u90E8",
        corporateLaw: "\u516C\u53F8\u6CD5",
        criminalLaw: "\u5211\u6CD5",
        familyLaw: "\u5BB6\u5EAD\u6CD5",
        realEstate: "\u623F\u5730\u4EA7",
        taxLaw: "\u7A0E\u6CD5",
        ipLaw: "\u77E5\u8BC6\u4EA7\u6743",
        immigration: "\u79FB\u6C11",
        laborLaw: "\u52B3\u52A8\u6CD5",
        bankingFinance: "\u94F6\u884C\u4E0E\u91D1\uFFFD\uFFFD\uFFFD",
        firmsMatch: "\u5BB6\u5F8B\u6240\u5339\u914D",
        lawyersMatch: "\u540D\u5F8B\u5E08\u5339\u914D",
        reviews: "\u6761\u8BC4\u4EF7",
        loadingMore: "\u52A0\u8F7D\u66F4\u591A...",
        independent: "\u72EC\u7ACB",
        yearsExperience: "\u5E74\u7ECF\u9A8C",
        languages: "\u8BED\u8A00",
        backToDirectory: "\u2190 \u8FD4\u56DE\u76EE\u5F55",
        about: "\u5173\u4E8E",
        bookConsultation: "\u9884\u7EA6\u54A8\u8BE2",
        sendMessage: "\u53D1\u9001\u6D88\u606F",
        call: "\u81F4\u7535",
        reviewsRatings: "\u8BC4\u4EF7\u4E0E\u8BC4\u5206",
        reviewsComingSoon: "\u8BC4\u4EF7\u5373\u5C06\u63A8\u51FA\u3002\u6210\u4E3A\u7B2C\u4E00\u4E2A\u8BC4\u4EF7\u7684\u4EBA\u3002",
        barId: "\u6267\u4E1A\u8BC1\u53F7",
        ourTeam: "\u6211\u4EEC\u7684\u56E2\u961F",
        contact: "\u8054\u7CFB\u65B9\u5F0F",
        website: "\u7F51\u7AD9",
        established: "\u521B\u529E\u4E8E",
        lawyersCount: "\u540D\u5F8B\u5E08",
        georgian: "\u683C\u9C81\u5409\u4E9A\u8BED",
        english: "\u82F1\u8BED",
        russian: "\u4FC4\u8BED",
        german: "\u5FB7\u8BED",
        french: "\u6CD5\u8BED",
        turkish: "\u571F\u8033\u5176\u8BED",
        heroLine1: "\u60A8\u7684\u6CD5\u5F8B",
        heroLine2: "\u56E2\u961F\u3002\u4E00\u4E2A",
        heroLine3: "\u5E73\u53F0\u3002",
        heroSubtitle: "TrustLegal \u2014 \u4E13\u4E3A\u683C\u9C81\u5409\u4E9A\u5F8B\u6240\u63D0\u4F9B\u7684\u9884\u7EA6\u3001\u6848\u4EF6\u3001\u652F\u4ED8\u548C AI \u6587\u6863\u8D77\u8349\u670D\u52A1\u3002\u6309\u6708\u6536\u8D39\uFF0C\u65E0\u5408\u7EA6\u7ED1\u5B9A\u3002",
        tryFree: "\u514D\u8D39\u8BD5\u7528 \u2192",
        liveDemo: "\u5B9E\u65F6\u6F14\u793A",
        trustedBrands: "\u6CE8\u91CD\u8D28\u91CF\u7684\u54C1\u724C\u4E0E\u6211\u4EEC\u5408\u4F5C",
        howItWorks: "\uFFFD\uFFFD\u4F5C\u65B9\u5F0F",
        processLabel: "// \u6D41\u7A0B",
        step1Title: "\u6CE8\u518C",
        step1Desc: "\u521B\u5EFA\u8D26\u6237\u5E76\u9009\u62E9\u5957\u9910\u3002\u65E0\u9700\u4FE1\u7528\u5361 \u2014 \u524D 30 \u5929\u514D\u8D39\u3002",
        step2Title: "\u7BA1\u7406\u6848\u4EF6",
        step2Desc: "\u6DFB\u52A0\u5BA2\u6237\u3001\u6848\u4EF6\u548C\u9884\u7EA6\u3002\u81EA\u52A8\u63D0\u9192\u548C\u65E5\u5386\u540C\u6B65\u3002",
        step3Title: "AI \u8D77\u8349",
        step3Desc: "\u4F7F\u7528 AI \u8D77\u8349\u683C\u9C81\u5409\u4E9A\u8BED\u6587\u6863\u3002\u7D22\u8D54\u3001\u6388\u6743\u4E66\u3001\u5408\u540C\u5206\u6790\u3002",
        step4Title: "\u4E1A\u52A1\u589E\u957F",
        step4Desc: "\u8DDF\u8E2A\u53D1\u7968\u3001\u6536\u5165\u548C\u56E2\u961F\u751F\u4EA7\u529B\u3002\u5B9E\u65F6\u5206\u6790\u3002",
        demoBadge: "// \u5B9E\u65F6\u6F14\u793A",
        todaysBookings: "\u4ECA\u65E5\u9884\u7EA6",
        fullDemo: "\u5B8C\u6574\u6F14\u793A \u2192",
        onePlatformThreePillars: "\u4E00\u4E2A\u5E73\u53F0\u3002\n\u4E09\u5927\u652F\u67F1\u3002",
        capabilitiesLabel: "// \u529F\u80FD",
        bookingFeature: "\u9884\u7EA6",
        bookingFeatureDesc: "\u5BA2\u6237\u81EA\u4E3B\u9009\u62E9\u65F6\u95F4\u3002\u81EA\u52A8\u63D0\u9192\u3002\u65E5\u5386\u540C\u6B65\u3002\u516C\u5F00\u9884\u7EA6\u9875\u9762\u3002",
        operationsFeature: "\u8FD0\u8425",
        operationsFeatureDesc: "\u96C6\u4E2D\u5F0F\u6848\u4EF6\u7BA1\u7406\u3002\u5BA2\u6237\u95E8\u6237\u3002\u53D1\u7968\u4E0E\u652F\u4ED8\u3002\u56E2\u961F\u7BA1\u7406\u3002",
        aiFeatureDesc: "\u683C\u9C81\u5409\u4E9A\u8BED\u6587\u6863\u8D77\u8349\u3002\u5408\u540C\u5206\u6790\u3002\u6CD5\u5F8B\u7814\u7A76\u3002\u81EA\u52A8\u8DDF\u8FDB\u3002",
        simplePricing: "\u7B80\u5355\u5B9A\u4EF7",
        plansLabel: "// \u5957\u9910",
        perMonth: "/ \u6708",
        bookingMgmt: "\u9884\u7EA6\u7BA1\u7406",
        caseTracking: "\u6848\u4EF6\u8FFD\u8E2A",
        calendarSync: "\u65E5\u5386\u540C\u6B65",
        emailReminders: "\u90AE\u4EF6\u63D0\u9192",
        starterPlan: "\u5165\u95E8\u7248",
        startNow: "\u7ACB\u5373\u5F00\u59CB \u2192",
        everythingStarter: "\u5305\u542B\u5165\u95E8\u7248\u6240\u6709\u529F\u80FD",
        aiDocDrafting: "AI \u6587\u6863\u8D77\u8349",
        invoicesPayments: "\u53D1\u7968\u4E0E\u652F\u4ED8",
        clientPortalFeature: "\u5BA2\u6237\u95E8\u6237",
        directSupport: "\u76F4\u63A5\u652F\u6301",
        professionalPlan: "\u4E13\u4E1A\u7248",
        mostPopular: "\u6700\u53D7\u6B22\u8FCE",
        everythingPro: "\u5305\u542B\u4E13\u4E1A\u7248\u6240\u6709\u529F\u80FD",
        teamMgmt10: "\u56E2\u961F\u7BA1\u7406 (10+ \u5F8B\u5E08)",
        contractAnalysis: "\u5408\u540C\u5206\u6790",
        advancedAnalytics: "\u9AD8\u7EA7\u5206\u6790",
        personalOnboarding: "\u4E13\u5C5E\u5165\u804C\u5F15\u5BFC",
        businessPlan: "\u5546\u4E1A\u7248",
        spotsLeft: "\u4EC5\u5269 3 \u4E2A\u540D\u989D",
        enterpriseNote: "\u4F01\u4E1A\u7248 \u2014 \u8BF7\u8054\u7CFB\u6211\u4EEC\u83B7\u53D6\u5B9A\u5236\u62A5\u4EF7\u3002",
        readyQuestion: "\u51C6\u5907\u597D\u4E86\u5417\uFF1F",
        first30DaysFree: "\u524D 30 \u5929\u514D\u8D39\u3002\u65E0\u5408\u7EA6\u9650\u5236\u3002\u968F\u65F6\u53D6\u6D88\u3002",
        footerTagline: "\u683C\u9C81\u5409\u4E9A\u6CD5\u5F8B SaaS \u5E73\u53F0\u3002",
        productLabel: "\u4EA7\u54C1",
        companyLabel: "\u516C\u53F8",
        bookingsLink: "\u9884\u7EA6",
        casesLink: "\u6848\u4EF6",
        aiDocsLink: "AI \u6587\u6863",
        aboutUs: "\u5173\u4E8E\u6211\u4EEC",
        careers: "\u62DB\u8058",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "\u4F7F\u7528 Symbols \u6784\u5EFA",
        sidebarMain: "\u4EEA\u8868\u76D8",
        sidebarBookings: "\u9884\u7EA6",
        sidebarCases: "\u6848\u4EF6",
        sidebarClients: "\u5BA2\u6237",
        sidebarDocs: "\u6587\u6863",
        sidebarPayments: "\u652F\u4ED8",
        sidebarLawyers: "\u5F8B\u5E08",
        sidebarSettings: "\u8BBE\u7F6E",
        sidebarLogout: "\u9000\u51FA\u767B\u5F55",
        bookingsTitle: "\u9884\u7EA6",
        newBooking: "+ \u65B0\u5EFA\u9884\u7EA6",
        newBookingTitle: "\u65B0\u5EFA\u9884\u7EA6",
        clientName: "\u5BA2\u6237\u59D3\u540D",
        phoneNumber: "\u7535\u8BDD",
        civilLaw: "\u6C11\u4E8B",
        criminalLaw2: "\u5211\u4E8B",
        administrativeLaw: "\u884C\u653F",
        otherType: "\u5176\u4ED6",
        notesPlaceholder: "\u5907\u6CE8...",
        confirmBooking: "\u786E\u8BA4\u9884\u7EA6",
        cancelBtn: "\u53D6\u6D88",
        calendarSyncNote: "\u65E5\u5386\u540C\u6B65 \u2014 \u81EA\u52A8\u540C\u6B65 Google Calendar\u3001Outlook\u3001Apple Calendar",
        synced: "\u5DF2\u540C\u6B65",
        calendarSync2: "\u65E5\u5386\u540C\u6B65",
        syncedStatus: "\u5DF2\u540C\u6B65",
        bookingsToday: "\u4ECA\u65E5 3 \u4E2A\u9884\u7EA6",
        settingsLink: "\u8BBE\u7F6E \u2192",
        pendingStatus: "\u5F85\u5904\u7406",
        connectionNeeded: "\u9700\u8981\u8FDE\u63A5",
        connectLink: "\u8FDE\u63A5 \u2192",
        lastSync: "\u4E0A\u6B21\u540C\u6B65\uFF1A5 \u5206\u949F\u524D",
        mon: "\u5468\u4E00",
        tue: "\u5468\u4E8C",
        wed: "\u5468\u4E09",
        thu: "\u5468\u56DB",
        fri: "\u5468\u4E94",
        bookingDetails: "\u9884\u7EA6\u8BE6\u60C5",
        confirmed: "\u5DF2\u786E\u8BA4",
        pending: "\u5F85\u5904\u7406",
        upcomingBookings: "\u5373\u5C06\u5230\u6765\u7684\u9884\u7EA6",
        closeBtn: "\u5173\u95ED",
        selectDateTime: "\u9009\u62E9\u65E5\u671F\u548C\u65F6\u95F4",
        fillInfo: "\u586B\u5199\u4FE1\u606F \u2014 ",
        firstName: "\u540D\u5B57",
        lastName: "\u59D3\u6C0F",
        phoneField: "\u7535\u8BDD",
        emailField: "\u90AE\u7BB1",
        caseDescription: "\u6848\u4EF6\u7B80\u4ECB",
        confirmBookingPublic: "\u786E\u8BA4\u9884\u7EA6",
        goBack: "\u8FD4\u56DE",
        bookingConfirmedMsg: "\u9884\u7EA6\u5DF2\u786E\u8BA4\uFF01",
        timeLabel: "\u65F6\u95F4\uFF1A",
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: 'Nino Barateli',
        casesTitle: "\u6848\u4EF6",
        searchPlaceholder2: "\u641C\u7D22...",
        newCase: "+ \u65B0\u5EFA\u6848\u4EF6",
        allTab: "\u5168\u90E8",
        activeTab: "\u8FDB\u884C\u4E2D",
        pendingTab: "\u5F85\u5904\u7406",
        closedTab: "\u5DF2\u7ED3\u6848",
        selectCasePrompt: "\u9009\u62E9\u4E00\u4E2A\u6848\u4EF6\u4EE5\u67E5\u770B\u8BE6\u60C5",
        info: "\u4FE1\u606F",
        registry: "\u767B\u8BB0\u518C",
        clientInfo: "\u5BA2\u6237\u4FE1\u606F",
        chronology: "\u65F6\u95F4\u7EBF",
        addNote: "\u6DFB\u52A0\u5907\u6CE8",
        enterNote: "\u8F93\u5165\u5907\u6CE8...",
        addBtn: "\u6DFB\u52A0",
        documentsLabel: "\u6587\uFFFD\uFFFD\uFFFD",
        createBtn: "+ \u521B\u5EFA",
        noDocs: "\u6682\u65E0\u6587\u6863",
        hearingSchedule: "\u5F00\u5EAD\u65E5\u7A0B",
        caseStatus: "\u6848\u4EF6\u72B6\u6001",
        electronicFiling: "\u7535\u5B50\u7ACB\u6848",
        idCode: "\u8BC6\u522B\u7801\uFF1A",
        director: "\u8D1F\u8D23\u4EBA\uFF1A",
        addressLabel: "\u5730\u5740\uFF1A",
        statusLabel: "\u72B6\u6001\uFF1A",
        registeredProperty: "\u767B\u8BB0\u8D22\u4EA7",
        extractLabel: "\u6458\u5F55",
        recentChanges: "\u6700\u8FD1\u66F4\u6539",
        yourFieldChanges: "\u60A8\u6240\u5728\u9886\u57DF\u7684\u52A8\u6001",
        newLabel: "\u65B0",
        notifications: "\u901A\u77E5",
        clientsTitle: "\u5BA2\u6237",
        clientsSearchPlaceholder: "\u641C\u7D22\u5BA2\u6237...",
        clientsProfile: "\u5BA2\u6237\u8D44\u6599",
        clientsContactLabel: "\u8054\u7CFB\u65B9\u5F0F",
        clientsInvoiceHistory: "\u8D26\u5355\u5386\u53F2",
        clientsUnpaid: "\u672A\u652F\u4ED8",
        clientsPaid: "\u5DF2\u652F\u4ED8",
        clientsPortalInvite: "\u53D1\u9001\u5BA2\u6237\u95E8\u6237\u8BBF\u95EE\u6743\u9650",
        dashTodayBookings: "\u4ECA\u65E5\u9884\u7EA6",
        dashUnpaid: "\u672A\u652F\u4ED8",
        dashOverdue: "\u903E\u671F",
        dashAiGenerations: "AI \u751F\u6210",
        dashTodaysBookings: "\u4ECA\u65E5\u9884\u7EA6",
        dashConfirmed: "\u5DF2\u786E\u8BA4",
        dashRecentCases: "\u6700\u8FD1\u6848\u4EF6",
        dashNewBooking: "+ \u65B0\u5EFA\u9884\u7EA6",
        dashNewCase: "+ \u65B0\u5EFA\u6848\u4EF6",
        dashAiDocument: "AI \u6587\u6863",
        docsTitle: "\u6587\u6863",
        docsCreate: "\u521B\u5EFA",
        docsExisting: "\u73B0\u6709\u6587\u6863",
        docsFiles: "\u6587\u4EF6",
        docsOcrScan: "\u626B\u63CF",
        docsOcrTitle: "OCR \u626B\u63CF",
        docsUploadText: "\u4E0A\u4F20\u6587\u6863\u7167\u7247\u6216 PDF",
        docsScanning: "\u6587\u6863\u626B\u63CF\u4E2D...",
        docsFile: "\u6587\u4EF6",
        docsPages: "\u9875\u6570",
        docsLanguage: "\u8BED\u8A00",
        docsGeorgian: "\u683C\u9C81\u5409\u4E9A\u8BED",
        docsAddToCase: "\u6DFB\u52A0\u5230\u6848\u4EF6",
        docsCopy: "\u590D\u5236",
        docsRescan: "\u91CD\u65B0\u626B\u63CF",
        docsClaim: "\u8BC9\u72B6",
        docsPowerOfAttorney: "\u6388\u6743\u59D4\u6258\u4E66",
        docsNotification: "\u901A\u77E5",
        docsContractReview: "\u5408\u540C\u5BA1\u67E5",
        docsFreeForm: "\u81EA\u7531\u683C\u5F0F",
        docsParty1: "\u7532\u65B9",
        docsNameCompany: "\u59D3\u540D / \u516C\u53F8",
        docsParty2: "\u4E59\u65B9",
        docsDate: "\u65E5\u671F",
        docsAdditionalInfo: "\u9644\u52A0\u4FE1\u606F",
        docsGenerating: "\u751F\u6210\u4E2D...",
        docsGenerate: "\u751F\u6210",
        docsGeneratedDocument: "\u751F\u6210\u7684\u6587\u6863",
        docsEmptyState: "\u751F\u6210\u7684\u6587\u6863\u5C06\u663E\u793A\u5728\u6B64\u5904",
        docsShowDemo: "\u663E\u793A\u6F14\u793A\u6587\u6863",
        docsDownload: "\u4E0B\u8F7D",
        docsSend: "\u53D1\u9001",
        docsCreatedDocuments: "\u5DF2\u521B\u5EFA\u6587\u6863",
        docsSearch: "\u641C\u7D22...",
        docsFileManager: "\u6587\u4EF6\u7BA1\u7406\u5668",
        docsUpload: "\u4E0A\u4F20",
        docsCases: "\u6848\u4EF6",
        docsTemplates: "\u6A21\u677F",
        docsRecentFiles: "\u6700\u8FD1\u6587\u4EF6",
        billingTitle: "\u8D26\u5355",
        billingNewInvoice: "\u65B0\u5EFA\u53D1\u7968",
        billingTotalSent: "\u53D1\u9001\u603B\u8BA1",
        billingPaid: "\u5DF2\u4ED8\u6B3E",
        billingUnpaid: "\u672A\u4ED8\u6B3E",
        billingOverdue: "\u5DF2\u903E\u671F",
        billingActive: "\u6D3B\u8DC3",
        billingClientStatus: "\u5BA2\u6237\u72B6\u6001",
        billingEInvoice: "\u7535\u5B50\u53D1\u7968",
        billingAutoCheck: "\u81EA\u52A8\u68C0\u67E5",
        billingSettings: "\u8BBE\u7F6E \u2192",
        billingInvoice: "\u53D1\u7968",
        billingClient: "\u5BA2\u6237",
        billingCase: "\u6848\u4EF6",
        billingAmount: "\u91D1\u989D",
        billingDue: "\u5230\u671F",
        billingStatus: "\u72B6\u6001",
        aiTitle: "AI \u52A9\u624B",
        aiPowered: "\u7531 AI \u9A71\u52A8",
        aiDraftDocs: "\u6587\u6863\u8D77\u8349",
        aiContractAnalysis: "\u5408\u540C\u5206\u6790",
        aiLegalResearch: "\u6CD5\u5F8B\u68C0\u7D22",
        aiDraftAvailable: "\u6587\u6863\u8D77\u8349\u529F\u80FD\u53EF\u5728\u6587\u6863\u9875\u9762\u4F7F\u7528",
        aiGoToDocuments: "\u524D\u5F80\u6587\u6863 \u2192",
        aiPasteContract: "\u5728\u6B64\u7C98\u8D34\u5408\u540C\u6587\u672C...",
        aiAnalyze: "\u5206\u6790",
        aiReanalyze: "\u91CD\u65B0\u5206\u6790",
        aiParties: "\u5F53\u4E8B\u4EBA",
        aiObligations: "\u4E3B\u8981\u4E49\u52A1",
        aiRiskFactors: "\u98CE\u9669\u56E0\u7D20",
        aiDeadlines: "\u671F\u9650",
        aiRecommendations: "\u5EFA\u8BAE",
        aiAskQuestion: "\u63D0\u95EE\u5173\u4E8E\u683C\u9C81\u5409\u4E9A\u6CD5\u5F8B\u7684\u95EE\u9898",
        aiLegalResearchTitle: "AI \u6CD5\u5F8B\u68C0\u7D22",
        aiAskPlaceholder: "\u63D0\u95EE...",
        aiSend: "\u53D1\u9001",
        pitchTagline: "\u683C\u9C81\u5409\u4E9A\u6CD5\u5F8B SAAS",
        pitchSubtitle: "\u9884\u7EA6 \xb7 \u8FD0\u8425 \xb7 AI \u2014 \u4E13\u4E3A\u683C\u9C81\u5409\u4E9A\u5F8B\u6240\u6253\u9020",
        pitchCta: "\u53D1\u73B0\u673A\u9047 \u2192",
        pitchMarketLabel: "// \u5E02\u573A",
        pitchMarketTitle: "\u683C\u9C81\u5409\u4E9A\u6709 5000+ \u540D\u5F8B\u5E08",
        pitchPopulation: "\u4EBA\u53E3",
        pitchTbilisi: "\u7B2C\u6BD4\u5229\u65AF",
        pitchConcentrated: "\u96C6\u4E2D\u5316\u5E02\u573A",
        pitchZeroCompetitor: "\u672C\u5730 SaaS \u7ADE\u4E89\u5BF9\u624B",
        pitchProblemLabel: "// \u95EE\u9898",
        pitchProblemTitle: "\u683C\u9C81\u5409\u4E9A\u5F8B\u6240\u4ECD\u5728\u4F7F\u7528 WhatsApp \u548C Excel \u529E\u516C",
        pitchNoBooking: "\u65E0\u5BA2\u6237\u9884\u7EA6\u7CFB\u7EDF",
        pitchManualCases: "\u624B\u52A8\u6848\u4EF6\u7BA1\u7406",
        pitchNoAiTools: "\u65E0\u683C\u9C81\u5409\u4E9A\u8BED AI \u5DE5\u5177",
        pitchCapabilitiesLabel: "// \u529F\u80FD",
        pitchOnePlatform: "\u4E00\u4E2A\u5E73\u53F0\u3002\u4E09\u5927\u652F\u67F1\u3002",
        pitchProductLabel: "// \u4EA7\u54C1",
        pitchProductTitle: "\u4E00\u7AD9\u5F0F\u5E73\u53F0",
        pitchIntegrationsLabel: "// \u96C6\u6210",
        pitchIntegrationsTitle: "\u81EA\u52A8\u5316\uFF0C\u544A\u522B\u624B\u52A8\u5DE5\u4F5C",
        pitchPublicRegistry: "\u516C\u5171\u767B\u8BB0\u5904",
        pitchCalendarSyncTitle: "\u65E5\u5386\u540C\u6B65",
        pitchOcrTitle: "OCR \u4E0E\u626B\u63CF",
        pitchPlansLabel: "// \u5957\u9910",
        pitchPlansTitle: "\u4E13\u4E3A\u683C\u9C81\u5409\u4E9A\u5E02\u573A\u5B9A\u4EF7",
        pitchTierStarter: "\u5165\u95E8\u7248",
        pitchMostPopular: "\u6700\u53D7\u6B22\u8FCE",
        pitchTierPro: "\u4E13\u4E1A\u7248",
        pitchTierBusiness: "\u5546\u4E1A\u7248",
        pitchTierEnterprise: "\u4F01\u4E1A\u7248",
        pitchRevenueLabel: "// \u6536\u5165",
        pitchRevenueTitle: "\u6536\u5165\u6F5C\u529B",
        pitchFinanceLabel: "// \u8D22\u52A1",
        pitchFinanceTitle: "\u5355\u4F4D\u7ECF\u6D4E\u6548\u76CA",
        pitchTimeLabel: "// \u65F6\u673A",
        pitchTimeTitle: "\u65F6\u673A\u6B63\u597D",
        pitchPrivacyLabel: "// \u9690\u79C1",
        pitchPrivacyTitle: "\u9690\u79C1\u4F18\u5148",
        pitchCtaLabel: "// \u5171\u540C\u5EFA\u8BBE",
        pitchCtaTitle: "\u8BA9\u6211\u4EEC\u5171\u5EFA\u683C\u9C81\u5409\u4E9A\u7684\u6CD5\u5F8B\u57FA\u7840\u8BBE\u65BD",
        pitchCtaLink: "\u9996\u9875 \u2192",
        pitchPerMonth: "\u6708",
        settingsTitle: "\u8BBE\u7F6E",
        settingsTabProfile: "\u4E2A\u4EBA\u8D44\u6599",
        settingsTabFirm: "\u5F8B\u6240",
        settingsTabTeam: "\u56E2\u961F",
        settingsTabNotifications: "\u901A\u77E5",
        settingsUploadPhoto: "\u4E0A\u4F20\u7167\u7247",
        settingsSave: "\u4FDD\u5B58",
        settingsFirmAddress: "\u5730\u5740",
        settingsFirmRegNumber: "\u6CE8\u518C\u53F7",
        settingsPublicBookingUrl: "\u516C\u5F00\u9884\u7EA6 URL",
        settingsTeamMembers: "\u56E2\u961F\u6210\u5458",
        settingsInvite: "+ \u9080\u8BF7",
        settingsRoleOwner: "\u6240\u6709\u8005",
        settingsRoleLawyer: "\u5F8B\u5E08",
        settingsNotifyTitle: "\u901A\u77E5\u8BBE\u7F6E",
        settingsToggleOn: "\u5DF2\u542F\u7528",
        settingsToggleOff: "\u5DF2\u7981\u7528",
        loginSubtitle: "\u767B\u5F55\u60A8\u7684\u8D26\u6237",
        loginLawyer: "\u5F8B\u5E08",
        loginClient: "\u5BA2\u6237",
        loginPassword: "\u5BC6\u7801",
        loginSubmit: "\u767B\u5F55 \u2192",
        loginCaseNumber: "\u6848\u4EF6\u7F16\u53F7",
        loginBackLink: "\u2190 \u8FD4\u56DE",
        portalLogout: "\u9000\u51FA\u767B\u5F55",
        portalWelcome: "\u4F60\u597D\uFF0C",
        portalActiveCases: "\u6D3B\u8DC3\u6848\u4EF6",
        portalDocuments: "\u6587\u6863",
        portalMessages: "\u6D88\u606F",
        portalSend: "\u53D1\u9001",
        clientDashNavCases: "\u6848\u4EF6",
        clientDashNavInvoices: "\u53D1\u7968",
        clientDashNavDocuments: "\u6587\u6863",
        clientDashNavMessages: "\u6D88\u606F",
        clientDashLogout: "\u9000\u51FA\u767B\u5F55",
        clientDashWelcome: "\u4F60\u597D\uFF0C",
        clientDashDownload: "\u4E0B\u8F7D",
        clientDashSend: "\u53D1\u9001",
        findLawyer: "\u5BFB\u627E\u5F8B\u5E08",
        lawyersSearchSub: "\u641C\u7D22 5,700+ \u540D\u5728\u683C\u9C81\u5409\u4E9A\u5F8B\u5E08\u534F\u4F1A\u6CE8\u518C\u7684\u5F8B\u5E08",
        searchBtn: "\u641C\u7D22",
        viewAll: "\u67E5\u770B\u5168\u90E8",
        lawyerPortal: "\u5F8B\u5E08\u95E8\u6237",
        aiFeature: 'AI',
        aiChip1: "\u516C\u8BC1\u5408\u540C\u53D6\u6D88",
        aiChip1Question: "\u53D6\u6D88\u516C\u8BC1\u5408\u540C\u7684\u6761\u4EF6\u662F\u4EC0\u4E48\uFF1F",
        aiChip2: "\u6C11\u6CD5\u5178\u7B2C 317 \u6761",
        aiChip2Question: "\u6C11\u6CD5\u5178\u7B2C 317 \u6761\u7684\u89E3\u91CA",
        aiChip3: "\u4EA4\u6613\u65E0\u6548",
        aiChip3Question: "\u8FC7\u53BB 3 \u5E74\u5173\u4E8E\u4EA4\u6613\u65E0\u6548\u7684\u6CD5\u9662\u5B9E\u8DF5",
        aiDeadlinesData: "\u2022 \u670D\u52A1\u5F00\u59CB\uFF1A\u5408\u540C\u7B7E\u8BA2\u540E 10 \u5929\n\u2022 \u9996\u6B21\u4ED8\u6B3E\uFF1A2026 \u5E74 4 \u6708 1 \u65E5\n\u2022 \u5408\u540C\u671F\u9650\uFF1A12 \u4E2A\u6708",
        aiEmptyChatSub: "AI \u2014 \u63D0\u95EE\u5E76\u83B7\u53D6\u6709\u5173\u683C\u9C81\u5409\u4E9A\u6CD5\u5F8B\u7684\u89E3\u7B54",
        aiObligationsData: "1. 30 \u4E2A\u65E5\u5386\u65E5\u5185\u4EA4\u4ED8\u670D\u52A1\n2. 15 \u4E2A\u5DE5\u4F5C\u65E5\u5185\u4ED8\u6B3E\n3. \u4FDD\u5BC6\u671F 3 \u5E74",
        aiPartiesData: "\u7532\u65B9\uFF1ABarateli & Partners LLC\n\u4E59\u65B9\uFF1ADelta Group LLC",
        aiRecommendationsData: "1. \u589E\u52A0\u8FDD\u7EA6\u91D1\u6761\u6B3E\uFF08\u6C11\u6CD5\u5178\u7B2C 417 \u6761\uFF09\n2. \u660E\u786E\u901A\u8FC7\u4EF2\u88C1\u89E3\u51B3\u4E89\u8BAE\n3. \u6269\u5C55\u4E0D\u53EF\u6297\u529B\u6761\u6B3E",
        aiRisksData: "\u2022 \u672A\u660E\u786E\u903E\u671F\u4ED8\u6B3E\u8FDD\u7EA6\u91D1\n\u2022 \u672A\u6307\u5B9A\u4E89\u8BAE\u89E3\u51B3\u673A\u5236\n\u2022 \u4E0D\u53EF\u6297\u529B\u6761\u6B3E\u672A\u6DB5\u76D6\u5927\u6D41\u884C\u75C5",
        address: "\u5730\u5740",
        addressVal: "\u7B2C\u6BD4\u5229\u65AF\uFF0CChavchavadze 12",
        appleCalendar: 'Apple Calendar',
        billingClient1: 'Giorgi Mamulashvili',
        billingClient2: 'Mariam Kvaratskhelia',
        billingClient3: 'Lela Gogiashvili',
        billingClientName: 'Delta Group LLC',
        billingDue1: "3\u670825\u65E5",
        billingDue2: "3\u670815\u65E5",
        billingDue3: "3\u670810\u65E5",
        billingEmailNotification: "\u7535\u5B50\u90AE\u4EF6\u901A\u77E5",
        billingLastCheck: "\u6700\u540E\u68C0\u67E5\uFF1A\u4ECA\u5929",
        billingNoDebt: "\u65E0\u672A\u7ED3\u503A\u52A1",
        billingRsBanner: "rs.ge \u96C6\u6210 \u2014 \u4E00\u952E\u83B7\u53D6\u5BA2\u6237\u7A0E\u52A1\u503A\u52A1\u548C\u7535\u5B50\u53D1\u7968",
        billingRsTaxSystem: "rs.ge \u2014 \u7A0E\u52A1\u7CFB\u7EDF",
        billingStatusPaid: "\u5DF2\u4ED8\u6B3E",
        billingStatusSent: "\u5DF2\u53D1\u9001",
        billingViewFull: "\u67E5\u770B\u5168\u90E8 \u2192",
        billingViewInvoices: "\u67E5\u770B\u53D1\u7968 \u2192",
        billingWeeklyEnabled: "\u6BCF\u5468\u542F\u7528",
        caseRow1Title: "#2024-047 \u2014 Giorgi Mamulashvili",
        caseRow2Title: "#2024-046 \u2014 Mariam Kvaratskhelia",
        caseRow3Title: "#2024-045 \u2014 Lela Gogiashvili",
        change1Date: "3\u670815\u65E5 \u2014 \u751F\u6548\uFF1A4\u67081\u65E5",
        change1Desc: "\u671F\u9650\u4ECE30\u5929\u589E\u52A0\u523045\u5929",
        change1Name: "\u6C11\u6CD5\u5178 \u2014 \u7B2C316\u6761",
        change2Date: "3\u670812\u65E5 \u2014 \u751F\uFFFD\uFFFD\uFF1A5\u67081\u65E5",
        change2Desc: "\u4E0A\u8BC9\u671F\u9650\u4ECE14\u5929\u589E\u52A0\u523021\u5929",
        change2Name: "\u8BC9\u8BBC\u6CD5 \u2014 \u671F\u9650",
        claimAccepted: "\u8D77\u8BC9\u5DF2\u53D7\u7406 \u2014 3\u670817\u65E5",
        claimFiled: "\u5DF2\u63D0\u4EA4\u8D77\u8BC9 \u2014 3\u670815\u65E5",
        claimFiledDoc: "\u8D77\u8BC9\u72B6 \u2014 \u5DF2\u63D0\u4EA4",
        clientName1: 'Giorgi Mamulashvili',
        clientName2: 'Mariam Kvaratskhelia',
        clientName3: 'Lela Gogiashvili',
        companyExtractLoaded: "\u516C\u53F8\u767B\u8BB0\u6458\u8981 \u2014 \u5DF2\u52A0\u8F7D",
        companyName: 'Delta Group LLC',
        clientsActiveCases1: "1\u4E2A\u6D3B\u8DC3\u6848\u4EF6",
        clientsActiveCases2: "1\u4E2A\u6D3B\u8DC3\u6848\u4EF6",
        clientsActiveCases3: "0\u4E2A\u6D3B\u8DC3\u6848\u4EF6",
        clientsAvatar1: 'GM',
        clientsAvatar2: 'MK',
        clientsAvatar3: 'LG',
        clientsCaseLink1: "#2024-047 \u2014 \u6C11\u4E8B",
        clientsCaseLink2: "#2024-046 \u2014 \u884C\u653F",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u65E0\u6D3B\u8DC3\u6848\u4EF6",
        clientsPaid1: "\u5DF2\u652F\u4ED8 \u20BE2,400",
        clientsPaid2: "\u5DF2\u652F\u4ED8 \u20BE800",
        clientsPaid3: "\u5DF2\u652F\u4ED8 \u20BE1,800",
        dashAlertText: "2\u4E2A\u903E\u671F\u6848\u4EF6\u548C \u20BE1,840 \u672A\u4ED8\u53D1\u7968",
        dashBooking1Time: "10:00 \u2014 \u6C11\u4E8B",
        dashBooking2Time: "11:30 \uFFFD\uFFFD\uFFFD \u884C\u653F",
        dashBooking3Time: "14:00 \u2014 \u5211\u4E8B",
        dashCaseMeta1: "\u6C11\u4E8B \xb7 3\u670818\u65E5",
        dashCaseMeta2: "\u884C\u653F \xb7 3\u670817\u65E5",
        dashCaseMeta3: "\u5211\u4E8B \xb7 3\u670815\u65E5",
        dashClient3Name: 'Davit Chikovani',
        dashDate: "2026\u5E743\u670818\u65E5",
        dashGreeting: "\u4F60\u597D\uFF0CNino",
        dateMar15: "3\u670815\u65E5",
        dateMar17: "3\u670817\u65E5",
        dateMar18: "3\u670818\u65E5",
        disabledStatus: "\u2014 \u5DF2\u7981\u7528",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "\u683C\u9C81\u5409\u4E9A\uFF0C\u7B2C\u6BD4\u5229\u65AF\n\n\u8D77\u8BC9\u72B6\n\n\u539F\u544A\uFF1ABarateli & Partners LLC\n\u88AB\u544A\uFF1ADelta Group LLC\n\n\u4E8B\u5B9E\u60C5\u51B5\uFF1A\n\n\u901A\u8FC7\u672C\u8D77\u8BC9\u72B6\uFF0C\u539F\u544A\u8981\u6C42\u88AB\u544A\u5C65\u884C\u5176\u4E49\u52A1\u3002\n\n\u8BC9\u6C42\uFF1A\n\n1. \u8D23\u4EE4\u88AB\u544A\u652F\u4ED8 12,500 GEL\n2. \u5904\u4EE5 1,875 GEL \u7F5A\u6B3E\n3. \u507F\u8FD8\u8BC9\u8BBC\u8D39\u7528\n\n\u65E5\u671F\uFF1A2026\u5E743\u670818\u65E5\n\u7B7E\u540D\uFF1A________________",
        docsDocument: "\u6587\u6863",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 2026\u5E743\u670815\u65E5",
        docsFile1Name: "\u8D77\u8BC9\u72B6 - Mamulashvili.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 2026\u5E743\u670812\u65E5",
        docsFile2Name: "\u6388\u6743\u59D4\u6258\u4E66 - Kvaratskhelia.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 2026\u5E743\u670810\u65E5",
        docsFile3Name: "\u5408\u540C \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 2026\u5E743\u67088\u65E5",
        docsFile4Name: "\u8EAB\u4EFD\u8BC1\u590D\u5370\u4EF6 - Mamulashvili.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 2026\u5E743\u67085\u65E5",
        docsFile5Name: "\u901A\u77E5 - Gogiashvili.pdf",
        docsFolder1Count: "3\u4E2A\u6587\u4EF6",
        docsFolder1Name: '#2024-047 Mamulashvili',
        docsFolder2Count: "2\u4E2A\u6587\u4EF6",
        docsFolder2Name: '#2024-046 Kvaratskhelia',
        docsFolder3Count: "1\u4E2A\u6587\u4EF6",
        docsFolder3Name: '#2024-045 Gogiashvili',
        docsFolder4Count: "5\u4E2A\u6587\u4EF6",
        docsFormatAnalysis: "\u683C\u5F0F\u5206\u6790...",
        docsFreeText: "\u81EA\u7531\u6587\u672C...",
        docsGeneratedClaimText: "\u683C\u9C81\u5409\u4E9A\uFF0C\u7B2C\u6BD4\u5229\u65AF\n\n\u8D77\u8BC9\u72B6\n\n\u539F\u544A\uFF1A[Party 1]\n\u88AB\u544A\uFF1A[Party 2]\n\n\u4E8B\u5B9E\u60C5\u51B5\uFF1A\n\n\u901A\u8FC7\u672C\u8D77\u8BC9\u72B6\uFF0C\u539F\u544A\u8981\u6C42\u88AB\u544A\u5C65\u884C\u300A\u683C\u9C81\u5409\u4E9A\u6C11\u6CD5\u5178\u300B\u89C4\u5B9A\u7684\u4E49\u52A1\u3002\n\n\u6CD5\u5F8B\u4F9D\u636E\uFF1A\n\n\u6839\u636E\u300A\u6C11\u6CD5\u5178\u300B\u7B2C316\u6761\uFF0C\u5FC5\u987B\u9002\u5F53\u5C65\u884C\u4E49\u52A1\u3002\n\n\u8BC9\u6C42\uFF1A\n\n\u9274\u4E8E\u4E0A\u8FF0\u60C5\u51B5\uFF0C\u539F\u544A\u8BF7\u6C42\u6CD5\u9662\u8D23\u4EE4\u88AB\u544A\u5C65\u884C\u4E49\u52A1\u3002\n\n\u65E5\u671F\uFF1A2026\u5E743\u670818\u65E5\n\u7B7E\u540D\uFF1A________________",
        docsGeorgianSymbols: "\u683C\u9C81\u5409\u4E9A\u5B57\u7B26",
        docsOcrNote: "OCR \u626B\u63CF \u2014 \u7EB8\u8D28\u6587\u6863\u81EA\u52A8\u6570\u5B57\u5316\uFF0C\u65E0\u9700\u624B\u52A8\u8F93\u5165",
        docsOcrResultText: "\u5408\u540C \u2116147\n\n\u7B2C\u6BD4\u5229\u65AF\uFF0C2026\u5E743\u670810\u65E5\n\n\u4E00\u65B9\u9762\uFF0CBarateli & Partners LLC\uFF08ID 404123456\uFF09\uFF0C\u7531\u603B\u76D1 Nino Barateli \u4EE3\u8868\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u627F\u5305\u5546\u201D\uFF09\uFF0C\u53E6\u4E00\u65B9\u9762\uFF0CDelta Group LLC\uFF08ID 404789012\uFF09\uFF0C\u7531\u603B\u76D1 Giorgi Mamulashvili \u4EE3\u8868\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u5BA2\u6237\u201D\uFF09\uFF0C\u7B7E\u8BA2\u672C\u5408\u540C\uFF1A\n\n\u7B2C\u4E00\u6761 \u5408\u540C\u6807\u7684\n1.1. \u627F\u5305\u5546\u627F\u8BFA\u5411\u5BA2\u6237\u63D0\u4F9B\u6CD5\u5F8B\u670D\u52A1\u3002\n1.2. \u670D\u52A1\u8D39\u7528\u4E3A 12,500\uFF08\u4E00\u4E07\u4E8C\u5343\u4E94\u767E\uFF09GEL\u3002",
        docsOcrSuccess: "\u8BC6\u522B\u6210\u529F \u2014 \u51C6\u786E\u7387 98.5%",
        docsRow1Meta: "#2024-047 \xb7 \u7D22\u8D54 \xb7 3\u670815\u65E5",
        docsRow1Name: "\u7D22\u8D54 - Mamulashvili.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u6388\u6743\u59D4\u6258\u4E66 \xb7 3\u670812\u65E5",
        docsRow2Name: "\u6388\u6743\u59D4\u6258\u4E66 - Kvaratskhelia.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u901A\u77E5 \xb7 3\u67088\u65E5",
        docsRow3Name: "\u901A\u77E5 - Gogiashvili.pdf",
        docsTextRecognition: "\u6587\u672C\u8BC6\u522B",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u6700\u5927 10MB",
        docsUploadSub: "\u62D6\u62FD\u6587\u4EF6\u6216\u70B9\u51FB\u9009\u62E9",
        ecourt: 'ecourt',
        ecourtDesc: "\u63D0\u4EA4\u7D22\u8D54\u3001\u67E5\u770B\u6848\u4EF6\u72B6\u6001\u548C\u542C\u8BC1\u4F1A\u65E5\u7A0B \u2014 \u65E0\u9700\u4EB2\u81EA\u524D\u5F80\u6CD5\u9662",
        enabledStatus: "\u2713 \u5DF2\u542F\u7528",
        evidencePending: "\u8BC1\u636E \u2014 \u5F85\u5904\u7406",
        extract: "\u6458\u5F55",
        field1Text: "\u6C11\u4E8B\uFF1A\u7B2C316\u6761\u4FEE\u6B63\u6848",
        field2Text: "\u6C11\u4E8B\uFF1A\u7B2C259\u6761\u671F\u9650",
        field3Text: "\u884C\u653F\uFF1A\u7535\u5B50\u670D\u52A1",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 3\u670822\u65E5, 10:00 \u2014 \u7B2C\u6BD4\u5229\u65AF\u5E02\u6CD5\u9662",
        hearingItem2: "\uD83D\uDCC5 3\u670828\u65E5, 14:30 \u2014 \u4E0A\u8BC9\u6CD5\u9662",
        loginEmail: "\u90AE\u7BB1",
        matsne: 'matsne',
        matsneDesc: "\u7ACB\u6CD5\u53D8\u66F4\u81EA\u52A8\u66F4\u65B0 \u2014 \u9488\u5BF9\u60A8\u7684\u6267\u4E1A\u9886\u57DF",
        outlook: 'Outlook',
        prepHearing: "\u9884\u5907\u542C\u8BC1\u4F1A \u2014 3\u670822\u65E5",
        propertyApartment: "\u516C\u5BD3 \u2014 Vake, 85 \u5E73\u65B9\u7C73 \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u8D22\u4EA7\u6458\u5F55 \u2014 \u5DF2\u6DFB\u52A0",
        registryDesc: "\u81EA\u52A8\u83B7\u53D6\u516C\u53F8\u548C\u8D22\u4EA7\u6570\u636E \u2014 \u65E0\u9700\u518D\u624B\u52A8\u4E0B\u8F7D\u6458\u5F55",
        timeEntry1Date: "3\u670818\u65E5, 10:30",
        timeEntry1Text: "\u6848\u4EF6\u5DF2\u7ACB\u6848\uFF0C\u521D\u6B65\u54A8\u8BE2\u5DF2\u5B8C\u6210",
        timeEntry2Date: "3\u670817\u65E5, 14:00",
        timeEntry2Text: "\u5BA2\u6237\u5DF2\u63D0\u4F9B\u6587\u4EF6",
        timeEntry3Date: "3\u670815\u65E5, 09:00",
        timeEntry3Text: "\u5BA2\u6237\u8054\u7CFB\u5F8B\u6240\uFF0C\u521D\u6B65\u7533\u8BF7",
        typeCivil: "\u6C11\u4E8B",
        typeAdministrative: "\u884C\u653F",
        typeCriminal: "\u5211\u4E8B",
        pitchArpuMonth: "\u5E73\u5747 ARPU/\u6708",
        pitchArpuYear: "\u5E73\u5747 ARPU/\u5E74",
        pitchAutoBackup: "\u81EA\u52A8\u5907\u4EFD",
        pitchAutoNextSteps: "\u81EA\u52A8\u4E0B\u4E00\u6B65",
        pitchAutoReminder: "\u81EA\u52A8\u63D0\u9192",
        pitchBooking: "\u9884\u7EA6",
        pitchCacOrganic: "CAC\uFF08\u81EA\u7136\u589E\u957F\uFF09",
        pitchCalcNote: "5000 \u540D\u5F8B\u5E08 \xd7 \u5E73\u5747 \u20BE35/\u6708 \xd7 12 \u4E2A\u6708",
        pitchCalendarSync: "\u65E5\u5386\u540C\u6B65",
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 \u542C\u8BC1\u4F1A\u548C\u622A\u6B62\u65E5\u671F\u81EA\u52A8\u540C\u6B65",
        pitchCaseManagement: "\u6848\u4EF6\u7BA1\u7406",
        pitchClientSchedule: "\u5BA2\u6237\u65E5\u7A0B",
        pitchCloudDedicated: "\u4E13\u5C5E\u4E91",
        pitchCloudDedicatedDesc: "\u9694\u79BB\u7684\u4E91\u670D\u52A1\u5668 \u2014 \u60A8\u7684\u6570\u636E\u4E0E\u5176\u4ED6\u5BA2\u6237\u5B8C\u5168\u5206\u79BB",
        pitchContractAnalysis: "\u5408\u540C\u5206\u6790",
        pitchCtaSubtext: "\u9884\u7EA6 + \u8FD0\u8425 + AI",
        pitchDedicatedServer: "\u72EC\u7ACB\u670D\u52A1\u5668",
        pitchDocDraftGeo: "\u683C\u9C81\u5409\u4E9A\u8BED\u6587\u6863\u8D77\u8349",
        pitchEcourtDesc: "\u63D0\u4EA4\u7D22\u8D54\u3001\u6848\uFFFD\uFFFD\uFFFD\u72B6\u6001\u548C\u542C\u8BC1\u4F1A\u65E5\u7A0B \u2014 \u65E0\u9700\u4EB2\u81EA\u524D\u5F80\u6CD5\u9662",
        pitchGdprCompliant: "\u7B26\u5408 GDPR",
        pitchHybrid: "\u6DF7\u5408\u90E8\u7F72",
        pitchHybridDesc: "\u4E91\u7AEF + \u672C\u5730 \u2014 \u654F\u611F\u6570\u636E\u5B58\u672C\u5730\uFF0C\u5176\u4F59\u5B58\u4E91\u7AEF",
        pitchIntegrationsSub: "\u653F\u5E9C\u670D\u52A1\u3001\u65E5\u5386\u548C OCR \u2014 \u5C3D\u5728\u4E00\u4E2A\u5E73\u53F0",
        pitchInvoices: "\u53D1\u7968",
        pitchMatsneDesc: "\u7ACB\u6CD5\u53D8\u66F4\u81EA\u52A8\u66F4\u65B0 \u2014 \u9488\u5BF9\u60A8\u7684\u6267\u4E1A\u9886\u57DF",
        pitchOcrDesc: "\u7EB8\u8D28\u6587\u6863\u81EA\u52A8\u6570\u5B57\u5316 \u2014 \u65E0\u9700\u624B\u52A8\u8F93\u5165",
        pitchOnPremise: "\u672C\u5730\u670D\u52A1\u5668",
        pitchOnPremiseDesc: "\u5B8C\u5168\u672C\u5730\u5316 \u2014 \u6570\u636E\u7559\u5728\u60A8\u7684\u529E\u516C\u5BA4\uFF0C\u65E0\u9700\u4E92\u8054\u7F51\u8BBF\u95EE",
        pitchOperations: "\u8FD0\u8425",
        pitchPerkAiDocs: "AI \u6587\u6863",
        pitchPerkBookings: "\u9884\u7EA6\u7BA1\u7406",
        pitchPerkClientPortal: "\u5BA2\u6237\u95E8\u6237",
        pitchPerkCommunication: "\u6C9F\u901A",
        pitchPerkFileStorage: "\u6587\u4EF6\u5B58\u50A8",
        pitchPerkResponsive: "\u54CD\u5E94\u5F0F",
        pitchPrivacySubtitle: "\u6CD5\u5F8B\u6570\u636E\u9700\u8981\u6700\u9AD8\u7EA7\u522B\u7684\u4FDD\u62A4",
        pitchPublicRegistryDesc: "\u81EA\u52A8\u83B7\u53D6\u516C\u53F8\u548C\u8D22\u4EA7\u6570\u636E \u2014 \u65E0\u9700\u624B\u52A8\u4E0B\u8F7D\u6458\u5F55",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 2026\u5E743\u6708",
        pitchRecurringModel: "\u8BA2\u9605\u6A21\u5F0F",
        pitchRsGeDesc: "\u7A0E\u52A1\u6B20\u6B3E\u548C\u7535\u5B50\u53D1\u7968 \u2014 \u4E00\u952E\u67E5\u770B\u5BA2\u6237\u72B6\u6001",
        pitchScen250: "250\u540D\u5F8B\u5E08",
        pitchScen500: "500\u540D\u5F8B\u5E08",
        pitchScen1000: "1000\u540D\u5F8B\u5E08",
        pitchServerCost: "\u670D\u52A1\u5668\u6210\u672C/\u7528\u6237",
        pitchTierBusiness10: "10+\u540D\u5F8B\u5E08",
        pitchTierEnterpriseCustom: "\u5B9A\u5236",
        pitchTierEnterprisePrice: "\u62A5\u4EF7",
        pitchTierPro310: "3-10\u540D\u5F8B\u5E08",
        pitchTierStarter12: "1-2\u540D\u5F8B\u5E08",
        pitchTitle: "TrustLegal \u683C\u9C81\u5409\u4E9A",
        pitchTrustedAccounting: "\u53EF\u4FE1\u8D56\u7684\u8D22\u52A1",
        pitchWhyAiCheap: "AI\u5DE5\u5177\u73B0\u5728\u5DF2\u7ECF\u8DB3\u591F\u5B9E\u60E0",
        pitchWhyDigitizing: "\u683C\u9C81\u5409\u4E9A\u6CD5\u5F8B\u5E02\u573A\u6B63\u5728\u5FEB\u901F\u6570\u5B57\u5316",
        pitchWhyNoCompetitor: "\u6CA1\u6709\u6210\u719F\u7684\u7ADE\u4E89\u5BF9\u624B",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: 'Nino Barateli',
        settingsMember2Name: 'Giga Aslanishvili',
        settingsNotifyDeadlineReminder: "\u622A\u6B62\u65E5\u671F\u63D0\u9192",
        settingsNotifyNewBookingEmail: "\u65B0\u9884\u7EA6 \u2014 \u7535\u5B50\u90AE\u4EF6",
        settingsNotifyNewBookingWhatsapp: "\u65B0\u9884\u7EA6 \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u903E\u671F\u53D1\u7968",
        settingsNotifyReminder24h: "\u63D0\u524D24\u5C0F\u65F6\u63D0\u9192",
        settingsProfileName: 'Nino Barateli',
        settingsToggle3DaysBefore: "\u63D0\u524D3\u5929",
        portalCaseTypeCivil: "\u6C11\u4E8B",
        portalDocDate1: "3\u670815\u65E5",
        portalDocName1: 'Claim - Mamulashvili.pdf',
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "\u622A\u6B62\u65E5\u671F: 3\u670825\u65E5",
        portalLastUpdate: "\u6700\u540E\u66F4\u65B0: 3\u670818\u65E5",
        portalMsgFrom1: 'Nino Barateli',
        portalMsgPlaceholder: "\u53D1\u9001\u6D88\u606F...",
        portalMsgText1: "\u4F60\u597D Giorgi\uFF0C\u6211\u4EEC\u7684\u6848\u4EF6\u6709\u4E86\u65B0\u8FDB\u5C55\u3002",
        portalMsgText2: "\u8C22\u8C22\uFF0C\u7B49\u5F85\u8BE6\u7EC6\u4FE1\u606F\u3002",
        portalNextHearing: "3\u670825\u65E5\u6CD5\u5EAD\u542C\u8BC1\u4F1A",
        portalPay: "\u652F\u4ED8",
        portalPendingInvoices: "\u5F85\u5904\u7406\u53D1\u7968",
        portalProgressLabel: "\u8FDB\u5EA6: 3/5 \u6B65",
        portalStatusActive: "\u8FDB\u884C\u4E2D",
        clientDashCaseTypeCivil: "\u6C11\u4E8B",
        clientDashDocMeta1: "\u6848\u4EF6 #2024-047 \xb7 3\u670815\u65E5",
        clientDashDocMeta2: "\u6848\u4EF6 #2024-046 \xb7 3\u670812\u65E5",
        clientDashDocName1: 'Claim - Mamulashvili.pdf',
        clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
        clientDashDocumentsTitle: "\u6587\u6863",
        clientDashInvCase1: "\u6848\u4EF6: #2024-047",
        clientDashInvCase2: "\u6848\u4EF6: #2024-046",
        clientDashInvDue1: "\u622A\u6B62\u65E5\u671F: 2026\u5E743\u670825\u65E5",
        clientDashInvoicesTitle: "\u53D1\u7968",
        clientDashInvPaidDate: "\u5DF2\u652F\u4ED8: 2026\u5E743\u670814\u65E5",
        clientDashLawyerInitials: 'NB',
        clientDashLawyerName: 'Nino Barateli',
        clientDashLawyerRole: "\u60A8\u7684\u5F8B\u5E08",
        clientDashMessagesTitle: "\u6D88\u606F",
        clientDashMsgFrom1: 'Nino Barateli',
        clientDashMsgFrom3: 'Nino Barateli',
        clientDashMsgPlaceholder: "\u5199\u6D88\u606F...",
        clientDashMsgText1: "\u4F60\u597D Giorgi\uFF0C\u6211\u4EEC\u6709\u65B0\u7684\u6848\u4EF6\u8FDB\u5C55\u3002\u6CD5\u9662\u5DF2\u5C06\u542C\u8BC1\u4F1A\u5B89\u6392\u57283\u670825\u65E5\u3002",
        clientDashMsgText2: "\u8C22\u8C22\uFF0C\u7B49\u5F85\u8BE6\u7EC6\u4FE1\u606F\u3002\u6211\u9700\u8981\u51C6\u5907\u4EC0\u4E48\u6587\u4EF6\u5417\uFF1F",
        clientDashMsgText3: "\u4E0D\u9700\u8981\uFF0C\u4E00\u5207\u90FD\u51C6\u5907\u597D\u4E86\u3002\u6211\u4EEC\u4F1A\u5728\u542C\u8BC1\u4F1A\u524D\u4E00\u5468\u8054\u7CFB\u60A8\u3002",
        clientDashMsgTime1: "10:30 \xb7 \u4ECA\u5929",
        clientDashMsgTime2: "10:45 \xb7 \u4ECA\u5929",
        clientDashMsgTime3: "11:02 \xb7 \u4ECA\u5929",
        clientDashMyCases: "\u6211\u7684\u6848\u4EF6",
        clientDashPaid: "\u5DF2\u652F\u4ED8",
        clientDashPay: "\u652F\u4ED8",
        clientDashProgressLabel: "\u8FDB\u5EA6: \u5DF2\u5B8C\u6210 3/5 \u6B65",
        clientDashStatActiveCase: "\u8FDB\u884C\u4E2D\u7684\u6848\u4EF6",
        clientDashStatDocument: "\u6587\u6863",
        clientDashStatNextHearing: "\u4E0B\u6B21\u542C\u8BC1\u4F1A",
        clientDashStatNextHearingValue: "3\u670825\u65E5",
        clientDashStatPayable: "\u5E94\u4ED8",
        clientDashStatusActive: "\u8FDB\u884C\u4E2D",
        clientDashStep1Date: "2026\u5E743\u67085\u65E5",
        clientDashStep1Title: "\u54A8\u8BE2\u5DF2\u5B8C\u6210",
        clientDashStep2Date: "2026\u5E743\u670810\u65E5",
        clientDashStep2Title: "\u8D77\u8BC9\u4E66\u5DF2\u8D77\u8349",
        clientDashStep3Date: "2026\u5E743\u670815\u65E5",
        clientDashStep3Title: "\u8D77\u8BC9\u4E66\u5DF2\u63D0\u4EA4\u6CD5\u9662",
        clientDashStep4Date: "2026\u5E743\u670825\u65E5 \u2014 \u5F85\u5904\u7406",
        clientDashStep4Title: "\u5EAD\u5BA1",
        clientDashStep5Title: "\u88C1\u51B3",
        clientDashUnpaid: "\u672A\u652F\u4ED8",
        clientDashWelcomeSub: "\u60A8\u53EF\u4EE5\u5728\u6B64\u8FFD\u8E2A\u60A8\u7684\u6848\u4EF6\u3001\u53D1\u7968\u548C\u6587\u4EF6\u3002"
    },
    hi: {
        home: "\u0939\u094B\u092E",
        dashboard: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        bookings: "\u092C\u0941\u0915\u093F\u0902\u0917\u094D\u0938",
        bookingPage: "\u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u0947\u091C",
        aiDocuments: "AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        clientPortalNav: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094B\u0930\u094D\u091F\u0932",
        lawyersNav: "\u0935\u0915\u0940\u0932",
        login: "\u0932\u0949\u0917 \u0907\u0928",
        getStarted: "\u092E\u0941\u092B\u093C\u094D\u0924 \u092E\u0947\u0902 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
        lawyersTitle: "\u0935\u0915\u0940\u0932 \u0914\u0930 \u0932\u0949 \u092B\u0930\u094D\u092E",
        lawyersSubtitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 \u092A\u0902\u091C\u0940\u0915\u0943\u0924",
        searchPlaceholder: "\u0928\u093E\u092E, \u092B\u0930\u094D\u092E \u092F\u093E \u092A\u094D\u0930\u0948\u0915\u094D\u091F\u093F\u0938 \u090F\u0930\u093F\u092F\u093E \u0938\u0947 \u0916\u094B\u091C\u0947\u0902...",
        lawyersBtn: "\u0935\u0915\u0940\u0932",
        firmsBtn: "\u092B\u0930\u094D\u092E",
        allFilter: "\u0938\u092D\u0940",
        corporateLaw: "\u0915\u0949\u0930\u094D\u092A\u094B\u0930\u0947\u091F \u0932\u0949",
        criminalLaw: "\u0915\u094D\u0930\u093F\u092E\u093F\u0928\u0932 \u0932\u0949",
        familyLaw: "\u092B\u0948\u092E\u093F\u0932\u0940 \u0932\u0949",
        realEstate: "\u0930\u093F\u092F\u0932 \u090F\u0938\u094D\u091F\u0947\u091F",
        taxLaw: "\u091F\u0948\u0915\u094D\u0938 \u0932\u0949",
        ipLaw: "\u0906\u0908\u092A\u0940",
        immigration: "\u0907\u092E\u093F\u0917\u094D\u0930\u0947\u0936\u0928",
        laborLaw: "\u0932\u0947\u092C\u0930 \u0932\u0949",
        bankingFinance: "\u092C\u0948\u0902\u0915\u093F\u0902\u0917 \u0914\u0930 \u092B\u093E\u0907\u0928\u0947\u0902\u0938",
        firmsMatch: "\u092B\u0930\u094D\u092E \u092E\u093F\u0932\u0940\u0902",
        lawyersMatch: "\u0935\u0915\u0940\u0932 \u092E\u093F\u0932\u0947",
        reviews: "\u0930\u093F\u0935\u094D\u092F\u0942",
        loadingMore: "\u0914\u0930 \u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948...",
        independent: "\u0938\u094D\u0935\u0924\u0902\u0924\u094D\u0930",
        yearsExperience: "\u0938\u093E\u0932 \u0915\u093E \u0905\u0928\u0941\u092D\u0935",
        languages: "\u092D\u093E\u0937\u093E\u090F\u0902",
        backToDirectory: "\u2190 \u0921\u093E\u092F\u0930\u0947\u0915\u094D\u091F\u0930\u0940 \u092A\u0930 \u0935\u093E\u092A\u0938 \u091C\u093E\u090F\u0902",
        about: "\u092C\u093E\u0930\u0947 \u092E\u0947\u0902",
        bookConsultation: "\u092A\u0930\u093E\u092E\u0930\u094D\u0936 \u092C\u0941\u0915 \u0915\u0930\u0947\u0902",
        sendMessage: "\u092E\u0948\u0938\u0947\u091C \u092D\u0947\u091C\u0947\u0902",
        call: "\u0915\u0949\u0932 \u0915\u0930\u0947\u0902",
        reviewsRatings: "\u0930\u093F\u0935\u094D\u092F\u0942 \u0914\u0930 \u0930\u0947\u091F\u093F\u0902\u0917",
        reviewsComingSoon: "\u0930\u093F\u0935\u094D\u092F\u0942 \u091C\u0932\u094D\u0926 \u0906 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0938\u092C\u0938\u0947 \u092A\u0939\u0932\u0947 \u0930\u093F\u0935\u094D\u092F\u0942 \u0926\u0947\u0902\u0964",
        barId: "\u092C\u093E\u0930 ID",
        ourTeam: "\u0939\u092E\u093E\u0930\u0940 \u091F\u0940\u092E",
        contact: "\u0938\u0902\u092A\u0930\u094D\u0915",
        website: "\u0935\u0947\u092C\u0938\u093E\u0907\u091F",
        established: "\u0938\u094D\u0925\u093E.",
        lawyersCount: "\u0935\u0915\u0940\u0932",
        georgian: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908",
        english: "\u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940",
        russian: "\u0930\u0942\u0938\u0940",
        german: "\u091C\u0930\u094D\u092E\u0928",
        french: "\u092B\u093C\u094D\u0930\u0947\u0902\u091A",
        turkish: "\u0924\u0941\u0930\u094D\u0915\u0940",
        heroLine1: "\u0906\u092A\u0915\u0940 \u0932\u0940\u0917\u0932",
        heroLine2: "\u091F\u0940\u092E\u0964 \u090F\u0915",
        heroLine3: "\u092A\u094D\u0932\u0947\u091F\u092B\u093C\u0949\u0930\u094D\u092E\u0964",
        heroSubtitle: "TrustLegal \u2014 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0932\u0949 \u092B\u0930\u094D\u092E\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u092C\u0941\u0915\u093F\u0902\u0917\u094D\u0938, \u0915\u0947\u0938, \u092A\u0947\u092E\u0947\u0902\u091F \u0914\u0930 AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917\u0964 \u090F\u0915 \u092E\u093E\u0938\u093F\u0915 \u0936\u0941\u0932\u094D\u0915, \u0915\u094B\u0908 \u0915\u0949\u0928\u094D\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u0928\u0939\u0940\u0902\u0964",
        tryFree: "\u092E\u0941\u092B\u093C\u094D\u0924 \u092E\u0947\u0902 \u0906\u091C\u093C\u092E\u093E\u090F\u0902 \u2192",
        liveDemo: "\u0932\u093E\u0907\u0935 \u0921\u0947\u092E\u094B",
        trustedBrands: "\u0915\u094D\u0935\u093E\u0932\u093F\u091F\u0940 \u0915\u0940 \u092A\u0930\u0935\u093E\u0939 \u0915\u0930\u0928\u0947 \u0935\u093E\u0932\u0947 \u092C\u094D\u0930\u093E\u0902\u0921 \u0939\u092E\u093E\u0930\u0947 \u0938\u093E\u0925 \u0915\u093E\u092E \u0915\u0930\u0924\u0947 \u0939\u0948\u0902",
        howItWorks: "\u092F\u0939 \u0915\u0948\u0938\u0947 \u0915\u093E\u092E \u0915\u0930\u0924\u093E \u0939\u0948",
        processLabel: "// \uFFFD\uFFFD\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E",
        step1Title: "\u0938\u093E\u0907\u0928 \u0905\u092A \u0915\u0930\u0947\u0902",
        step1Desc: "\u0905\u0915\u093E\u0909\u0902\u091F \u092C\u0928\u093E\u090F\u0902 \u0914\u0930 \u092A\u094D\u0932\u093E\u0928 \u091A\u0941\u0928\u0947\u0902\u0964 \u0915\u093F\u0938\u0940 \u0915\u094D\u0930\u0947\u0921\u093F\u091F \u0915\u093E\u0930\u094D\u0921 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u2014 \u092A\u0939\u0932\u0947 30 \u0926\u093F\u0928 \u092E\u0941\u092B\u093C\u094D\u0924\u0964",
        step2Title: "\u0915\u0947\u0938 \u092E\u0948\u0928\u0947\u091C \u0915\u0930\u0947\u0902",
        step2Desc: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F, \u0915\u0947\u0938 \u0914\u0930 \u092C\u0941\u0915\u093F\u0902\u0917\u094D\u0938 \u091C\u094B\u0921\u093C\u0947\u0902\u0964 \u0911\u091F\u094B\u092E\u0948\u091F\u093F\u0915 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930 \u0914\u0930 \u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915\u0964",
        step3Title: "AI \u0915\u0947 \u0938\u093E\u0925 \u0921\u094D\u0930\u093E\u092B\u094D\u091F \u0915\u0930\u0947\u0902",
        step3Desc: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092E\u0947\u0902 AI-\u092A\u093E\u0935\u0930\u094D\u0921 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917\u0964 \u0926\u093E\u0935\u0947, \u092A\u093E\u0935\u0930 \u0911\u092B \u0905\u091F\u0949\u0930\u094D\u0928\u0940, \u0915\u0949\u0928\u094D\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923\u0964",
        step4Title: "\u0935\u093F\u0915\u093E\u0938 \u0915\u0930\u0947\u0902",
        step4Desc: "\u0907\u0928\u0935\u0949\u0907\u0938, \u0930\u0947\u0935\u0947\u0928\u094D\u092F\u0942 \u0914\u0930 \u091F\u0940\u092E \u0915\u0940 \u0909\u0924\u094D\u092A\u093E\u0926\u0915\u0924\u093E \u091F\u094D\u0930\u0948\u0915 \u0915\u0930\u0947\u0902\u0964 \u0930\u093F\u092F\u0932-\u091F\u093E\u0907\u092E \u090F\u0928\u093E\u0932\u093F\u091F\u093F\u0915\u094D\u0938\u0964",
        demoBadge: "// \u0932\u093E\u0907\u0935 \u0921\u0947\u092E\u094B",
        todaysBookings: "\u0906\u091C \u0915\u0940 \u092C\u0941\u0915\u093F\u0902\u0917\u094D\u0938",
        fullDemo: "\u092A\u0942\u0930\u093E \u0921\u0947\u092E\u094B \u2192",
        onePlatformThreePillars: "\u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u093C\u0949\u0930\u094D\u092E\u0964\n\u0924\u0940\u0928 \u0938\u094D\u0924\u0902\u092D\u0964",
        capabilitiesLabel: "// \u0915\u094D\u0937\u092E\u0924\u093E\u090F\u0902",
        bookingFeature: "\u092C\u0941\u0915\u093F\u0902\u0917",
        bookingFeatureDesc: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0905\u092A\u0928\u093E \u0938\u092E\u092F \u0916\u0941\u0926 \u091A\u0941\u0928\u0924\u0947 \u0939\u0948\u0902\u0964 \u0911\u091F\u094B \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930\u0964 \u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915\u0964 \u092A\u092C\u094D\u0932\u093F\u0915 \u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u0947\u091C\u0964",
        operationsFeature: "\u0911\u092A\u0930\u0947\u0936\u0928\u094D\u0938",
        operationsFeatureDesc: "\u0915\u0947\u0902\u0926\u094D\u0930\u0940\u0915\u0943\u0924 \u0915\u0947\u0938 \u092E\u0948\u0928\u0947\u091C\u092E\u0947\u0902\u091F\u0964 \u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094B\u0930\u094D\u091F\u0932\u0964 \u0907\u0928\u0935\u0949\u0907\u0938 \u0914\u0930 \u092A\u0947\u092E\u0947\u0902\u091F\u0964 \u091F\u0940\u092E \u092E\u0948\u0928\u0947\u091C\u092E\u0947\u0902\u091F\u0964",
        aiFeatureDesc: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092E\u0947\u0902 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917\u0964 \u0915\u0949\u0928\u094D\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923\u0964 \u0932\u0940\u0917\u0932 \u0930\u093F\u0938\u0930\u094D\u091A\u0964 \u0911\u091F\u094B \u092B\u0949\u0932\u094B-\u0905\u092A\u0964",
        simplePricing: "\u0938\u0930\u0932 \u092A\u094D\u0930\u093E\u0907\u0938\u093F\u0902\u0917",
        plansLabel: "// \u092A\u094D\u0932\u093E\u0928",
        perMonth: "/ \u092E\u0939\u0940\u0928\u093E",
        bookingMgmt: "\u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        caseTracking: "\u0915\u0947\u0938 \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917",
        calendarSync: "\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915",
        emailReminders: "\u0908\u092E\u0947\u0932 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930",
        starterPlan: "\u0938\u094D\u091F\u093E\u0930\u094D\u091F\u0930",
        startNow: "\u0905\u092D\u0940 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902 \u2192",
        everythingStarter: "\u0938\u094D\u091F\u093E\u0930\u094D\u091F\u0930 \u0938\u0947 \u0938\u092C \u0915\u0941\u091B",
        aiDocDrafting: "AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917",
        invoicesPayments: "\u0907\u0928\u0935\u0949\u0907\u0938 \u0914\u0930 \u092D\u0941\u0917\u0924\u093E\u0928",
        clientPortalFeature: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094B\u0930\u094D\u091F\u0932",
        directSupport: "\u0921\u093E\u092F\u0930\u0947\u0915\u094D\u091F \u0938\u092A\u094B\u0930\u094D\u091F",
        professionalPlan: "\u092A\u094D\u0930\u094B\u092B\u0947\u0936\u0928\u0932",
        mostPopular: "\u0938\u092C\u0938\u0947 \uFFFD\uFFFD\uFFFD\u094B\u0915\u092A\u094D\u0930\u093F\u092F",
        everythingPro: "\u092A\u094D\u0930\u094B\u092B\u0947\u0936\u0928\u0932 \u0938\u0947 \u0938\u092C \u0915\u0941\u091B",
        teamMgmt10: "\u091F\u0940\u092E \u092A\u094D\u0930\u092C\u0902\u0927\u0928 (10+ \u0935\u0915\u0940\u0932)",
        contractAnalysis: "\u0905\u0928\u0941\u092C\u0902\u0927 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        advancedAnalytics: "\u090F\u0921\u0935\u093E\u0902\u0938\u094D\u0921 \u090F\u0928\u093E\u0932\u093F\u091F\u093F\u0915\u094D\u0938",
        personalOnboarding: "\u0935\u094D\u092F\u0915\u094D\u0924\u093F\u0917\u0924 \u0911\u0928\u092C\u094B\u0930\u094D\u0921\u093F\u0902\u0917",
        businessPlan: "\u092C\u093F\u091C\u093C\u0928\u0947\u0938",
        spotsLeft: "3 \u091C\u0917\u0939 \u092C\u093E\u0915\u0940",
        enterpriseNote: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C \u2014 \u0915\u0938\u094D\u091F\u092E \u0911\u092B\u093C\u0930 \u0915\u0947 \u0932\u093F\u090F \u0939\u092E\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902\u0964",
        readyQuestion: "\u0924\u0948\u092F\u093E\u0930 \u0939\u0948\u0902?",
        first30DaysFree: "\u092A\u0939\u0932\u0947 30 \u0926\u093F\u0928 \u092E\u0941\u092B\u093C\u094D\u0924\u0964 \u0915\u094B\u0908 \u0905\u0928\u0941\u092C\u0902\u0927 \u0928\u0939\u0940\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902\u0964",
        footerTagline: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u0928 \u0932\u0940\u0917\u0932 SaaS \u092A\u094D\u0932\u0947\u091F\u092B\u093C\u0949\u0930\u094D\u092E\u0964",
        productLabel: "\u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
        companyLabel: "\u0915\u0902\u092A\u0928\u0940",
        bookingsLink: "\u092C\u0941\u0915\u093F\u0902\u0917",
        casesLink: "\u0915\u0947\u0938",
        aiDocsLink: "AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        aboutUs: "\u0939\u092E\u093E\u0930\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902",
        careers: "\u0915\u0930\u093F\u092F\u0930",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "Symbols \u0915\u0947 \u0938\u093E\u0925 \u0928\u093F\u0930\u094D\u092E\u093F\u0924",
        sidebarMain: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        sidebarBookings: "\u092C\u0941\u0915\u093F\u0902\u0917",
        sidebarCases: "\u0915\u0947\u0938",
        sidebarClients: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F",
        sidebarDocs: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        sidebarPayments: "\u092D\u0941\u0917\u0924\u093E\u0928",
        sidebarLawyers: "\u0935\u0915\u0940\u0932",
        sidebarSettings: "\u0938\u0947\u091F\u093F\u0902\u0917",
        sidebarLogout: "\u0932\u0949\u0917 \u0906\u0909\u091F",
        bookingsTitle: "\u092C\u0941\u0915\u093F\u0902\u0917",
        newBooking: "+ \u0928\u0908 \u092C\u0941\u0915\u093F\u0902\u0917",
        newBookingTitle: "\u0928\u0908 \u092C\u0941\u0915\u093F\u0902\u0917",
        clientName: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u093E \u0928\u093E\u092E",
        phoneNumber: "\u092B\u093C\u094B\u0928",
        civilLaw: "\u0938\u093F\u0935\u093F\u0932",
        criminalLaw2: "\u0906\u092A\u0930\u093E\u0927\u093F\u0915 \u0915\u093E\u0928\u0942\u0928",
        administrativeLaw: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915",
        otherType: "\u0905\u0928\u094D\u092F",
        notesPlaceholder: "\u0928\u094B\u091F\u094D\u0938...",
        confirmBooking: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        cancelBtn: "\u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902",
        calendarSyncNote: "\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915 \u2014 Google Calendar, Outlook, Apple Calendar \u0905\u092A\u0928\u0947 \u0906\u092A \u0938\u093F\u0902\u0915 \u0939\u094B\u0924\u0947 \u0939\u0948\u0902",
        synced: "\u0938\u093F\u0902\u0915 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        calendarSync2: "\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915",
        syncedStatus: "\u0938\u093F\u0902\u0915 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        bookingsToday: "\u0906\u091C 3 \u092C\u0941\u0915\u093F\u0902\u0917",
        settingsLink: "\u0938\u0947\u091F\u093F\u0902\u0917 \u2192",
        pendingStatus: "\u0932\u0902\u092C\u093F\u0924",
        connectionNeeded: "\u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0906\u0935\u0936\u094D\u092F\u0915",
        connectLink: "\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902 \u2192",
        lastSync: "\u0905\u0902\u0924\u093F\u092E \u0938\u093F\u0902\u0915: 5 \u092E\u093F\u0928\u091F \u092A\u0939\u0932\u0947",
        mon: "\u0938\u094B\u092E",
        tue: "\u092E\u0902\u0917\u0932",
        wed: "\u092C\u0941\u0927",
        thu: "\u0917\u0941\u0930\u0941",
        fri: "\u0936\u0941\u0915\u094D\u0930",
        bookingDetails: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0935\u093F\u0935\u0930\u0923",
        confirmed: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0940 \u0917\u0908",
        pending: "\u0932\u0902\u092C\u093F\u0924",
        upcomingBookings: "\u0906\u0917\u093E\u092E\u0940 \u092C\u0941\u0915\u093F\u0902\u0917",
        closeBtn: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902",
        selectDateTime: "\u0926\u093F\u0928\u093E\u0902\u0915 \u0914\u0930 \u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902",
        fillInfo: "\u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u092D\u0930\u0947\u0902 \u2014 ",
        firstName: "\u092A\u0939\u0932\u093E \u0928\u093E\u092E",
        lastName: "\u0905\u0902\u0924\u093F\u092E \u0928\u093E\u092E",
        phoneField: "\u092B\u093C\u094B\u0928",
        emailField: "\u0908\u092E\u0947\u0932",
        caseDescription: "\u0915\u0947\u0938 \u0915\u093E \u0938\u0902\u0915\u094D\u0937\u093F\u092A\u094D\u0924 \u0935\u093F\u0935\u0930\u0923",
        confirmBookingPublic: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        goBack: "\u0935\u093E\u092A\u0938 \u091C\u093E\u090F\u0902",
        bookingConfirmedMsg: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0939\u094B \u0917\u0908!",
        timeLabel: "\u0938\u092E\u092F: ",
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: 'Nino Barateli',
        casesTitle: "\u0915\u0947\u0938",
        searchPlaceholder2: "\u0916\u094B\u091C\u0947\u0902...",
        newCase: "+ \u0928\u092F\u093E \u0915\u0947\u0938",
        allTab: "\u0938\u092D\u0940",
        activeTab: "\u0938\u0915\u094D\u0930\u093F\u092F",
        pendingTab: "\u0932\u0902\u092C\u093F\u0924",
        closedTab: "\u092C\u0902\u0926",
        selectCasePrompt: "\u0935\u093F\u0935\u0930\u0923 \u0926\u0947\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0947\u0938 \u091A\u0941\u0928\u0947\u0902",
        info: "\u091C\u093E\u0928\u0915\u093E\u0930\u0940",
        registry: "\u0930\u091C\u093F\u0938\u094D\u091F\u094D\u0930\u0940",
        clientInfo: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940",
        chronology: "\u0915\u093E\u0932\u0915\u094D\u0930\u092E",
        addNote: "\u0928\u094B\u091F \u091C\u094B\u0921\u093C\u0947\u0902",
        enterNote: "\u090F\u0915 \u0928\u094B\u091F \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902...",
        addBtn: "\u091C\u094B\u0921\u093C\u0947\u0902",
        documentsLabel: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        createBtn: "+ \u092C\u0928\u093E\u090F\u0902",
        noDocs: "\u0915\u094B\u0908 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0928\u0939\u0940\u0902",
        hearingSchedule: "\u0938\u0941\u0928\u0935\u093E\u0908 \u0915\u093E \u0915\u093E\u0930\u094D\u092F\u0915\u094D\u0930\u092E",
        caseStatus: "\u0915\u0947\u0938 \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F",
        electronicFiling: "\u0907\u0932\u0947\u0915\u094D\u091F\u094D\u0930\u0949\u0928\u093F\u0915 \u092B\u093E\u0907\u0932\u093F\u0902\u0917",
        idCode: "\u0906\u0908\u0921\u0940 \u0915\u094B\u0921:",
        director: "\u0928\u093F\u0926\u0947\u0936\u0915:",
        addressLabel: "\u092A\u0924\u093E:",
        statusLabel: "\u0938\u094D\u0925\u093F\u0924\u093F:",
        registeredProperty: "\u092A\u0902\u091C\u0940\u0915\u0943\u0924 \u0938\u0902\u092A\u0924\u094D\u0924\u093F",
        extractLabel: "\u0909\u0926\u094D\u0927\u0930\u0923",
        recentChanges: "\u0939\u093E\u0932 \u0915\u0947 \u092C\u0926\u0932\u093E\u0935",
        yourFieldChanges: "\u0906\u092A\u0915\u0947 \u0915\u094D\u0937\u0947\u0924\u094D\u0930 \u092E\u0947\u0902 \u092C\u0926\u0932\u093E\u0935",
        newLabel: "\u0928\u092F\u093E",
        notifications: "\u0938\u0942\u091A\u0928\u093E\u090F\u0902",
        clientsTitle: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F\u094D\u0938",
        clientsSearchPlaceholder: "\u0915\u094D\u0932\u093E\uFFFD\uFFFD\u0902\u091F\u094D\u0938 \u0916\u094B\u091C\u0947\u0902...",
        clientsProfile: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932",
        clientsContactLabel: "\u0938\u0902\u092A\u0930\u094D\u0915",
        clientsInvoiceHistory: "\u0907\u0928\u0935\u0949\u0907\u0938 \u0907\u0924\u093F\u0939\u093E\u0938",
        clientsUnpaid: "\u092C\u0915\u093E\u092F\u093E",
        clientsPaid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientsPortalInvite: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094B\u0930\u094D\u091F\u0932 \u090F\u0915\u094D\u0938\u0947\u0938 \u092D\u0947\u091C\u0947\u0902",
        dashTodayBookings: "\u0906\u091C \u0915\u0940 \u092C\u0941\u0915\u093F\u0902\u0917",
        dashUnpaid: "\u092C\u0915\u093E\u092F\u093E",
        dashOverdue: "\u0905\u0924\u093F\u0926\u0947\u092F",
        dashAiGenerations: "AI \u091C\u0928\u0930\u0947\u0936\u0928",
        dashTodaysBookings: "\u0906\u091C \u0915\u0940 \u092C\u0941\u0915\u093F\u0902\u0917",
        dashConfirmed: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0940 \u0917\u0908",
        dashRecentCases: "\u0939\u093E\u0932 \u0915\u0947 \u0915\u0947\u0938",
        dashNewBooking: "+ \u0928\u0908 \u092C\u0941\u0915\u093F\u0902\u0917",
        dashNewCase: "+ \u0928\u092F\u093E \u0915\u0947\u0938",
        dashAiDocument: "AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsTitle: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsCreate: "\u092C\u0928\u093E\u090F\u0902",
        docsExisting: "\u092E\u094C\u091C\u0942\u0926\u093E \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsFiles: "\u092B\u093C\u093E\u0907\u0932\u0947\u0902",
        docsOcrScan: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
        docsOcrTitle: "OCR \u0938\u094D\u0915\u0948\u0928\u093F\u0902\u0917",
        docsUploadText: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0915\uFFFD\uFFFD \u092B\u093C\u094B\u091F\u094B \u092F\u093E PDF \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902",
        docsScanning: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0938\u094D\u0915\u0948\u0928 \u0939\u094B \u0930\u0939\u093E \u0939\u0948...",
        docsFile: "\u092B\u093C\u093E\u0907\u0932",
        docsPages: "\u092A\u0943\u0937\u094D\u0920",
        docsLanguage: "\u092D\u093E\u0937\u093E",
        docsGeorgian: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908",
        docsAddToCase: "\u0915\u0947\u0938 \u092E\u0947\u0902 \u091C\u094B\u0921\u093C\u0947\u0902",
        docsCopy: "\u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902",
        docsRescan: "\u092B\u093F\u0930 \u0938\u0947 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
        docsClaim: "\u0926\u093E\u0935\u093E",
        docsPowerOfAttorney: "\u092A\u093E\u0935\u0930 \u0911\u092B \u0905\u091F\u0949\u0930\u094D\u0928\u0940",
        docsNotification: "\u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E",
        docsContractReview: "\u0905\u0928\u0941\u092C\u0902\u0927 \u0915\u0940 \u0938\u092E\u0940\u0915\u094D\u0937\u093E",
        docsFreeForm: "\u092B\u094D\u0930\u0940 \u092B\u0949\u0930\u094D\u092E",
        docsParty1: "\u092A\u0915\u094D\u0937 1",
        docsNameCompany: "\u0928\u093E\u092E / \u0915\u0902\u092A\u0928\u0940",
        docsParty2: "\u092A\u0915\u094D\u0937 2",
        docsDate: "\u0926\u093F\u0928\u093E\u0902\u0915",
        docsAdditionalInfo: "\u0905\u0924\u093F\u0930\u093F\u0915\u094D\u0924 \u091C\u093E\u0928\u0915\u093E\u0930\u0940",
        docsGenerating: "\u091C\u0947\u0928\u0930\u0947\u091F \u0939\u094B \u0930\u0939\u093E \u0939\u0948...",
        docsGenerate: "\u091C\u0947\u0928\u0930\u0947\u091F \u0915\u0930\u0947\u0902",
        docsGeneratedDocument: "\u091C\u0947\u0928\u0930\u0947\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsEmptyState: "\u091C\u0947\u0928\u0930\u0947\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u092F\u0939\u093E\u0901 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E",
        docsShowDemo: "\u0921\u0947\u092E\u094B \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0926\u093F\u0916\u093E\u090F\u0902",
        docsDownload: "\u0921\u093E\u0909\u0928\u0932\u094B\u0921",
        docsSend: "\u092D\u0947\u091C\u0947\u0902",
        docsCreatedDocuments: "\u092C\u0928\u093E\u090F \u0917\u090F \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsSearch: "\u0916\u094B\u091C\u0947\u0902...",
        docsFileManager: "\u092B\u093C\u093E\u0907\u0932 \u092E\u0948\u0928\u0947\u091C\u0930",
        docsUpload: "\u0905\u092A\u0932\uFFFD\uFFFD\u0921",
        docsCases: "\u0915\u0947\u0938",
        docsTemplates: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F",
        docsRecentFiles: "\u0939\u093E\u0932 \u0915\u0940 \u092B\u093C\u093E\u0907\u0932\u0947\u0902",
        billingTitle: "\u092C\u093F\u0932\u093F\u0902\u0917",
        billingNewInvoice: "\u0928\u092F\u093E \u0907\u0928\u0935\u0949\u0907\u0938",
        billingTotalSent: "\u0915\u0941\u0932 \u092D\u0947\u091C\u093E \u0917\u092F\u093E",
        billingPaid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        billingUnpaid: "\u092C\u0915\u093E\u092F\u093E",
        billingOverdue: "\u0913\u0935\u0930\u0921\u094D\u092F\u0942",
        billingActive: "\u0938\u0915\u094D\u0930\u093F\u092F",
        billingClientStatus: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F",
        billingEInvoice: 'e-Invoice',
        billingAutoCheck: "\u0911\u091F\u094B-\u091A\u0947\u0915",
        billingSettings: "\u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938 \u2192",
        billingInvoice: "\u0907\u0928\u0935\u0949\u0907\u0938",
        billingClient: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F",
        billingCase: "\u0915\u0947\u0938",
        billingAmount: "\u0930\u093E\u0936\u093F",
        billingDue: "\u0926\u0947\u092F",
        billingStatus: "\u0938\u094D\u091F\u0947\u091F\u0938",
        aiTitle: "AI \u0905\u0938\u093F\u0938\u094D\u091F\u0947\u0902\u091F",
        aiPowered: "AI \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u091A\u093E\u0932\u093F\u0924",
        aiDraftDocs: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917",
        aiContractAnalysis: "\u0905\u0928\u0941\u092C\u0902\u0927 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        aiLegalResearch: "\u0915\u093E\u0928\u0942\u0928\u0940 \u0936\u094B\u0927",
        aiDraftAvailable: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u092A\u0947\u091C \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948",
        aiGoToDocuments: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C\u094B\u0902 \u092A\u0930 \u091C\u093E\u090F\u0902 \u2192",
        aiPasteContract: "\u0915\u0949\u0928\u094D\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u0915\u093E \u091F\u0947\u0915\u094D\u0938\u094D\u091F \u092F\u0939\u093E\u0901 \u092A\u0947\u0938\u094D\u091F \u0915\u0930\u0947\u0902...",
        aiAnalyze: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0915\u0930\u0947\u0902",
        aiReanalyze: "\u092B\u093F\u0930 \u0938\u0947 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0915\u0930\u0947\u0902",
        aiParties: "\u092A\u0915\u094D\u0937",
        aiObligations: "\u092E\u0941\u0916\u094D\u092F \u0926\u093E\u092F\u093F\u0924\u094D\u0935",
        aiRiskFactors: "\u091C\u094B\u0916\u093F\u092E \u0915\u093E\u0930\u0915",
        aiDeadlines: "\u0921\u0947\u0921\u0932\u093E\u0907\u0928",
        aiRecommendations: "\u0938\u093F\u092B\u093E\u0930\u093F\u0936\u0947\u0902",
        aiAskQuestion: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0915\u093E\u0928\u0942\u0928 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u090F\u0915 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0942\u091B\u0947\u0902",
        aiLegalResearchTitle: "AI \u0915\u093E\u0928\u0942\u0928\u0940 \u0936\u094B\u0927",
        aiAskPlaceholder: "\u090F\u0915 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0942\u091B\u0947\u0902...",
        aiSend: "\u092D\u0947\u091C\u0947\u0902",
        pitchTagline: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u093E \u0932\u0940\u0917\u0932 SaaS",
        pitchSubtitle: "\u092C\u0941\u0915\u093F\u0902\u0917 \xb7 \u0911\u092A\u0930\u0947\u0936\u0928\u094D\u0938 \xb7 AI \u2014 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092B\u0930\u094D\u092E\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F",
        pitchCta: "\u0905\u0935\u0938\u0930 \u0926\u0947\u0916\u0947\u0902 \u2192",
        pitchMarketLabel: "// \u092E\u093E\u0930\u094D\u0915\u0947\u091F",
        pitchMarketTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 5000+ \u0935\u0915\u0940\u0932",
        pitchPopulation: "\u0906\u092C\u093E\u0926\u0940",
        pitchTbilisi: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940",
        pitchConcentrated: "\u0915\u0947\u0902\u0926\u094D\u0930\u093F\u0924 \u092C\u093E\u091C\u093C\u093E\u0930",
        pitchZeroCompetitor: "\u0938\u094D\u0925\u093E\u0928\u0940\u092F SaaS \u092A\u094D\u0930\u0924\u093F\u092F\u094B\u0917\u0940",
        pitchProblemLabel: "// \u0938\u092E\u0938\u094D\u092F\u093E",
        pitchProblemTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092B\u0930\u094D\u092E\u0947\u0902 \u0905\u092D\u0940 \u092D\u0940 WhatsApp \u0914\u0930 Excel \u092A\u0930 \u091A\u0932\u0924\u0940 \u0939\u0948\u0902",
        pitchNoBooking: "\u0915\u094B\u0908 \u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092C\u0941\u0915\u093F\u0902\u0917 \u0938\u093F\u0938\u094D\u091F\u092E \u0928\u0939\u0940\u0902",
        pitchManualCases: "\u092E\u0948\u0928\u0941\u0905\u0932 \u0915\u0947\u0938 \u092E\u0948\u0928\u0947\u091C\u092E\u0947\u0902\u091F",
        pitchNoAiTools: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092E\u0947\u0902 \u0915\u094B\u0908 AI \u091F\u0942\u0932 \u0928\u0939\u0940\u0902",
        pitchCapabilitiesLabel: "// \u0915\u094D\u0937\u092E\u0924\u093E\u090F\u0902",
        pitchOnePlatform: "\u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u093C\u0949\u0930\u094D\u092E. \u0924\u0940\u0928 \u0938\u094D\u0924\u0902\u092D.",
        pitchProductLabel: "// \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
        pitchProductTitle: "\u090F\u0915 \u0939\u0940 \u092A\u094D\u0932\u0947\u091F\u092B\u093C\u0949\u0930\u094D\u092E \u092E\u0947\u0902 \u0938\u092C \u0915\u0941\u091B",
        pitchIntegrationsLabel: "// \u0907\u0902\u091F\u0940\u0917\u094D\u0930\u0947\u0936\u0928",
        pitchIntegrationsTitle: "\u0911\u091F\u094B\u092E\u0947\u0936\u0928, \u092E\u0948\u0928\u0941\u0905\u0932 \u0915\u093E\u092E \u0928\u0939\u0940\u0902",
        pitchPublicRegistry: "\u092A\u092C\u094D\u0932\u093F\u0915 \u0930\u091C\u093F\u0938\u094D\u091F\u094D\u0930\u0940",
        pitchCalendarSyncTitle: "\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915",
        pitchOcrTitle: "OCR \u0914\u0930 \u0938\u094D\u0915\u0948\u0928\u093F\u0902\u0917",
        pitchPlansLabel: "// \u092A\u094D\u0932\u093E\u0928",
        pitchPlansTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092C\u093E\u091C\u093C\u093E\u0930 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u093E\u0907\u0938\u093F\u0902\u0917",
        pitchTierStarter: "\u0938\u094D\u091F\u093E\u0930\u094D\u091F\u0930",
        pitchMostPopular: "\u0938\u092C\u0938\u0947 \u0932\u094B\u0915\u092A\u094D\u0930\u093F\u092F",
        pitchTierPro: "\u092A\u094D\u0930\u094B\u092B\u0947\u0936\u0928\u0932",
        pitchTierBusiness: "\u092C\u093F\u091C\u093C\u0928\u0947\u0938",
        pitchTierEnterprise: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C",
        pitchRevenueLabel: "// \u0930\u093E\u091C\u0938\u094D\u0935",
        pitchRevenueTitle: "\u0930\u093E\u091C\u0938\u094D\u0935 \u0915\u094D\u0937\u092E\u0924\u093E",
        pitchFinanceLabel: "// \u0935\u093F\u0924\u094D\u0924\u0940\u092F",
        pitchFinanceTitle: "\u092F\u0942\u0928\u093F\u091F \u0907\u0915\u094B\u0928\u0949\u092E\u093F\u0915\u094D\u0938",
        pitchTimeLabel: "// \u0938\u092E\u092F",
        pitchTimeTitle: "\u0938\u092E\u092F \u0938\u0939\u0940 \u0939\u0948",
        pitchPrivacyLabel: "// \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E",
        pitchPrivacyTitle: "\u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E \u092A\u094D\u0930\u093E\u0925\u092E\u093F\u0915\u0924\u093E \u0939\u0948",
        pitchCtaLabel: "// \u0938\u093E\u0925 \u092E\u093F\u0932\u0915\u0930 \u092C\u0928\u093E\u090F\u0902",
        pitchCtaTitle: "\u0906\u0907\u090F \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u093E \u0915\u093E\u0928\u0942\u0928\u0940 \u092C\u0941\u0928\u093F\u092F\u093E\u0926\u0940 \u0922\u093E\u0902\u091A\u093E \u092C\u0928\u093E\u090F\u0902",
        pitchCtaLink: "\u0939\u094B\u092E \u092A\u0947\u091C \u2192",
        pitchPerMonth: "\u092E\u0939\u0940\u0928\u093E",
        settingsTitle: "\u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938",
        settingsTabProfile: "\u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932",
        settingsTabFirm: "\u092B\u093C\u0930\u094D\u092E",
        settingsTabTeam: "\u091F\u0940\u092E",
        settingsTabNotifications: "\u0938\u0942\u091A\u0928\u093E\u090F\u0902",
        settingsUploadPhoto: "\u092B\u093C\u094B\u091F\u094B \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902",
        settingsSave: "\u0938\u0939\u0947\u091C\u0947\u0902",
        settingsFirmAddress: "\u092A\u0924\u093E",
        settingsFirmRegNumber: "\u092A\u0902\u091C\u0940\u0915\u0930\u0923 \u0938\u0902\u0916\u094D\u092F\u093E",
        settingsPublicBookingUrl: "\u0938\u093E\u0930\u094D\u0935\u091C\u0928\u093F\u0915 \u092C\u0941\u0915\u093F\u0902\u0917 URL",
        settingsTeamMembers: "\u091F\u0940\u092E \u0915\u0947 \u0938\u0926\u0938\u094D\u092F",
        settingsInvite: "+ \u0906\u092E\u0902\u0924\u094D\u0930\u093F\u0924 \u0915\u0930\u0947\u0902",
        settingsRoleOwner: "\u092E\u093E\u0932\u093F\u0915",
        settingsRoleLawyer: "\u0935\u0915\u0940\u0932",
        settingsNotifyTitle: "\u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E \u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938",
        settingsToggleOn: "\u0938\u0915\u094D\u0937\u092E",
        settingsToggleOff: "\u0905\u0915\u094D\u0937\u092E",
        loginSubtitle: "\u0905\u092A\u0928\u0947 \u0916\u093E\u0924\u0947 \u092E\u0947\u0902 \u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902",
        loginLawyer: "\u0935\u0915\u0940\u0932",
        loginClient: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F",
        loginPassword: "\u092A\u093E\u0938\u0935\u0930\u094D\u0921",
        loginSubmit: "\u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902 \u2192",
        loginCaseNumber: "\u0915\u0947\u0938 \u0928\u0902\u092C\u0930",
        loginBackLink: "\u2190 \u0935\u093E\u092A\u0938 \u091C\u093E\u090F\u0902",
        portalLogout: "\u0932\u0949\u0917 \u0906\u0909\u091F \u0915\u0930\u0947\u0902",
        portalWelcome: "\u0928\u092E\u0938\u094D\u0924\u0947,",
        portalActiveCases: "\u0938\u0915\u094D\u0930\u093F\u092F \u0915\u0947\u0938",
        portalDocuments: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        portalMessages: "\u0938\u0902\u0926\u0947\u0936",
        portalSend: "\u092D\u0947\u091C\u0947\u0902",
        clientDashNavCases: "\u0915\u0947\u0938",
        clientDashNavInvoices: "\u0907\u0928\u0935\u0949\u0907\u0938",
        clientDashNavDocuments: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        clientDashNavMessages: "\u0938\u0902\u0926\u0947\u0936",
        clientDashLogout: "\u0932\u0949\u0917 \u0906\u0909\u091F \u0915\u0930\u0947\u0902",
        clientDashWelcome: "\u0928\u092E\u0938\u094D\u0924\u0947,",
        clientDashDownload: "\u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0947\u0902",
        clientDashSend: "\u092D\u0947\u091C\u0947\u0902",
        findLawyer: "\u0935\u0915\u0940\u0932 \u0916\u094B\u091C\u0947\u0902",
        lawyersSearchSub: "Georgian Bar Association \u0915\u0947 \u0938\u093E\u0925 \u092A\u0902\u091C\u0940\u0915\u0943\u0924 5,700+ \u0935\u0915\u0940\u0932\u094B\u0902 \u0915\u094B \u0916\u094B\u091C\u0947\u0902",
        searchBtn: "\u0916\u094B\u091C\u0947\u0902",
        viewAll: "\u0938\u092D\u0940 \u0926\u0947\u0916\u0947\u0902",
        lawyerPortal: "\u0935\u0915\u0940\u0932 \u092A\u094B\u0930\u094D\u091F\u0932",
        aiFeature: 'AI',
        aiChip1: "\u0928\u094B\u091F\u0930\u0940 \u0905\u0928\u0941\u092C\u0902\u0927 \u0930\u0926\u094D\u0926\u0940\u0915\u0930\u0923",
        aiChip1Question: "\u0928\u094B\u091F\u0930\u0940 \u0905\u0928\u0941\u092C\u0902\u0927 \u0915\u094B \u0930\u0926\u094D\u0926 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0936\u0930\u094D\u0924\u0947\u0902 \u0915\u094D\u092F\u093E \u0939\u0948\u0902?",
        aiChip2: "\u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u0905\u0928\u0941\u091A\u094D\u091B\u0947\u0926 317",
        aiChip2Question: "\u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u0905\u0928\u0941\u091A\u094D\u091B\u0947\u0926 317 \u0915\u0940 \u0935\u094D\u092F\u093E\u0916\u094D\u092F\u093E",
        aiChip3: "\u0932\u0947\u0928\u0926\u0947\u0928 \u0936\u0942\u0928\u094D\u092F\u0924\u093E",
        aiChip3Question: "\u092A\u093F\u091B\u0932\u0947 3 \u0935\u0930\u094D\u0937\u094B\u0902 \u092E\u0947\u0902 \u0932\u0947\u0928\u0926\u0947\u0928 \u0936\u0942\u0928\u094D\u092F\u0924\u093E \u092A\u0930 \u0928\u094D\u092F\u093E\u092F\u093E\u0932\u092F \u0915\u093E \u0905\u092D\u094D\u092F\u093E\u0938",
        aiDeadlinesData: "\u2022 \u0938\u0947\u0935\u093E \u092A\u094D\u0930\u093E\u0930\u0902\u092D: \u0905\u0928\u0941\u092C\u0902\u0927 \u0938\u0947 10 \u0926\u093F\u0928\n\u2022 \u092A\u0939\u0932\u093E \u092D\u0941\u0917\u0924\u093E\u0928: 1 \u0905\u092A\u094D\u0930\u0948\u0932, 2026\n\u2022 \u0905\u0928\u0941\u092C\u0902\u0927 \u0905\u0935\u0927\u093F: 12 \u092E\u0939\u0940\u0928\u0947",
        aiEmptyChatSub: "AI \u2014 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0915\u093E\u0928\u0942\u0928 \u0915\u0947 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0942\u091B\u0947\u0902 \u0914\u0930 \u0909\u0924\u094D\u0924\u0930 \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902",
        aiObligationsData: "1. 30 \u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0926\u093F\u0928\u094B\u0902 \u0915\u0947 \u092D\u0940\u0924\u0930 \u0938\u0947\u0935\u093E \u0935\u093F\u0924\u0930\u0923\n2. 15 \u0915\u093E\u0930\u094D\u092F \u0926\u093F\u0935\u0938\u094B\u0902 \u0915\u0947 \u092D\u0940\u0924\u0930 \u092D\u0941\u0917\u0924\u093E\u0928\n3. 3 \u0935\u0930\u094D\u0937\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0917\u094B\u092A\u0928\u0940\u092F\u0924\u093E",
        aiPartiesData: 'Party 1: Barateli & Partners LLC\nParty 2: Delta Group LLC',
        aiRecommendationsData: "1. \u091C\u0941\u0930\u094D\u092E\u093E\u0928\u093E \u0916\u0902\u0921 \u091C\u094B\u0921\u093C\u0947\u0902 (\u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\uFFFD\uFFFD \u0905\u0928\u0941. 417)\n2. \u092E\u0927\u094D\u092F\u0938\u094D\u0925\u0924\u093E \u0915\u0947 \u092E\u093E\u0927\u094D\u092F\u092E \u0938\u0947 \u0935\u093F\u0935\u093E\u0926 \u0938\u092E\u093E\u0927\u093E\u0928 \u0915\u094B \u092A\u0930\u093F\u092D\u093E\u0937\u093F\u0924 \u0915\u0930\u0947\u0902\n3. \u092B\u094B\u0930\u094D\u0938 \u092E\u0947\u091C\u094D\u092F\u094B\u0930 \u0916\u0902\u0921 \u0915\u093E \u0935\u093F\u0938\u094D\u0924\u093E\u0930 \u0915\u0930\u0947\u0902",
        aiRisksData: "\u2022 \u0935\u093F\u0932\u0902\u092C\u093F\u0924 \u092D\u0941\u0917\u0924\u093E\u0928 \u091C\u0941\u0930\u094D\u092E\u093E\u0928\u093E \u092A\u0930\u093F\u092D\u093E\u0937\u093F\u0924 \u0928\u0939\u0940\u0902 \u0939\u0948\n\u2022 \u0935\u093F\u0935\u093E\u0926 \u0938\u092E\u093E\u0927\u093E\u0928 \u0924\u0902\u0924\u094D\u0930 \u0928\u093F\u0930\u094D\u0926\u093F\u0937\u094D\u091F \u0928\u0939\u0940\u0902 \u0939\u0948\n\u2022 \u092B\u094B\u0930\u094D\u0938 \u092E\u0947\u091C\u094D\u092F\u094B\u0930 \u0916\u0902\u0921 \u092E\u0947\u0902 \u092E\u0939\u093E\u092E\u093E\u0930\u0940 \u0936\u093E\u092E\u093F\u0932 \u0928\u0939\u0940\u0902 \u0939\u0948",
        address: "\u092A\u0924\u093E",
        addressVal: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940, \u091A\u093E\u0935\u091A\u093E\u0935\u0926\u094D\u091C\u093C\u0947 12",
        appleCalendar: 'Apple Calendar',
        billingClient1: "\u091C\u093F\u092F\u094B\u0930\u094D\u0917\u0940 \u092E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940",
        billingClient2: "\u092E\u0930\u093F\u092F\u092E \u0915\u094D\u0935\u093E\u0930\u0924\u094D\u0938\u0916\u0947\u0932\u093F\u092F\u093E",
        billingClient3: "\u0932\u0947\u0932\u093E \u0917\u094B\u0917\u093F\u092F\u093E\u0936\u0935\u093F\u0932\u0940",
        billingClientName: 'Delta Group LLC',
        billingDue1: "25 \u092E\u093E\u0930\u094D\u091A",
        billingDue2: "15 \u092E\u093E\u0930\u094D\u091A",
        billingDue3: "10 \u092E\u093E\u0930\u094D\u091A",
        billingEmailNotification: "\u0908\u092E\u0947\u0932 \u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E",
        billingLastCheck: "\u0905\u0902\u0924\u093F\u092E \u091C\u093E\u0902\u091A: \u0906\u091C",
        billingNoDebt: "\u0915\u094B\u0908 \u092C\u0915\u093E\u092F\u093E \u090B\u0923 \u0928\u0939\u0940\u0902",
        billingRsBanner: "rs.ge \u090F\u0915\u0940\u0915\u0930\u0923 \u2014 \u090F\u0915 \u0915\u094D\u0932\u093F\u0915 \u092E\u0947\u0902 \u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u093E \u0915\u0930 \u090B\u0923 \u0914\u0930 \u0908-\u091A\u093E\u0932\u093E\u0928",
        billingRsTaxSystem: "rs.ge \u2014 \u0915\u0930 \u092A\u094D\u0930\u0923\u093E\u0932\u0940",
        billingStatusPaid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        billingStatusSent: "\u092D\u0947\u091C\u093E \u0917\u092F\u093E",
        billingViewFull: "\u092A\u0942\u0930\u093E \u0926\u0947\u0916\u0947\u0902 \u2192",
        billingViewInvoices: "\u091A\u093E\u0932\u093E\u0928 \u0926\u0947\u0916\u0947\u0902 \u2192",
        billingWeeklyEnabled: "\u0938\u093E\u092A\u094D\u0924\u093E\u0939\u093F\u0915 \u0938\u0915\u094D\u0937\u092E",
        caseRow1Title: "#2024-047 \u2014 \u091C\u093F\u092F\u094B\u0930\u094D\u0917\u0940 \u092E\u093E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940",
        caseRow2Title: "#2024-046 \u2014 \u092E\u093E\u0930\u093F\u092F\u092E \u0915\u094D\u0935\u093E\u0930\u0924\u094D\u0938\u0916\u0947\u0932\u093F\u092F\u093E",
        caseRow3Title: "#2024-045 \u2014 \u0932\u0947\u0932\u093E \u0917\u094B\u0917\u093F\u092F\u093E\u0936\u0935\u093F\u0932\u0940",
        change1Date: "15 \u092E\u093E\u0930\u094D\u091A \u2014 \u092A\u094D\u0930\u092D\u093E\u0935\u0940: 1 \u0905\u092A\u094D\u0930\u0948\u0932",
        change1Desc: "\u0938\u092E\u092F \u0938\u0940\u092E\u093E 30 \u0938\u0947 \u092C\u0922\u093C\u093E\u0915\u0930 45 \u0926\u093F\u0928 \u0915\u0930 \u0926\u0940 \u0917\u0908 \u0939\u0948",
        change1Name: "\u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u2014 \u0905\u0928\u0941\u091A\u094D\u091B\u0947\u0926 316",
        change2Date: "12 \u092E\u093E\u0930\u094D\u091A \u2014 \u092A\u094D\u0930\u092D\u093E\u0935\u0940: 1 \u092E\u0908",
        change2Desc: "\u0905\u092A\u0940\u0932 \u0915\u0940 \u0938\u092E\u092F \u0938\u0940\u092E\u093E 14 \u0938\u0947 21 \u0926\u093F\u0928",
        change2Name: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E\u0924\u094D\u092E\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u2014 \u0938\u092E\u092F \u0938\u0940\u092E\u093E\u090F\u0902",
        claimAccepted: "\u0926\u093E\u0935\u093E \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u2014 17 \u092E\u093E\u0930\u094D\u091A",
        claimFiled: "\u0926\u093E\u0935\u093E \u0926\u093E\u092F\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u2014 15 \u092E\u093E\u0930\u094D\u091A",
        claimFiledDoc: "\u0926\u093E\u0935\u093E \u2014 \u0926\u093E\u092F\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientName1: "\u091C\u093F\u092F\u094B\u0930\u094D\u0917\u0940 \u092E\u093E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940",
        clientName2: "\u092E\u093E\u0930\u093F\u092F\u092E \u0915\u094D\u0935\u093E\u0930\u0924\u094D\u0938\u0916\u0947\u0932\u093F\u092F\u093E",
        clientName3: "\u0932\u0947\u0932\u093E \u0917\u094B\u0917\u093F\u092F\u093E\u0936\u0935\u093F\u0932\u0940",
        companyExtractLoaded: "\u0915\u0902\u092A\u0928\u0940 \u0915\u093E \u0909\u0926\u094D\u0927\u0930\u0923 \u2014 \u0932\u094B\u0921 \u0915\u093F\u092F\u093E \u0917\u092F\uFFFD\uFFFD\uFFFD",
        companyName: 'Delta Group LLC',
        clientsActiveCases1: "1 \u0938\u0915\u094D\u0930\u093F\u092F \u092E\u093E\u092E\u0932\u093E",
        clientsActiveCases2: "1 \u0938\u0915\u094D\u0930\u093F\u092F \u092E\u093E\u092E\u0932\u093E",
        clientsActiveCases3: "0 \u0938\u0915\u094D\u0930\u093F\u092F \u092E\u093E\u092E\u0932\u0947",
        clientsAvatar1: 'GM',
        clientsAvatar2: 'MK',
        clientsAvatar3: 'LG',
        clientsCaseLink1: "#2024-047 \u2014 \u0926\u0940\u0935\u093E\u0928\u0940",
        clientsCaseLink2: "#2024-046 \u2014 \u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u0915\u094B\u0908 \u0938\u0915\u094D\u0930\u093F\u092F \u092E\u093E\u092E\u0932\u0947 \u0928\u0939\u0940\u0902",
        clientsPaid1: "\u20BE2,400 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientsPaid2: "\u20BE800 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientsPaid3: "\u20BE1,800 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        dashAlertText: "2 \u0905\u0924\u093F\u0926\u0947\u092F \u092E\u093E\u092E\u0932\u0947 \u0914\u0930 \u20BE1,840 \u0915\u0947 \u0905\u0935\u0948\u0924\u0928\u093F\u0915 \u091A\u093E\u0932\u093E\u0928",
        dashBooking1Time: "10:00 \u2014 \u0926\u0940\u0935\u093E\u0928\u0940",
        dashBooking2Time: "11:30 \u2014 \u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915",
        dashBooking3Time: "14:00 \u2014 \u0906\u092A\u0930\u093E\u0927\u093F\u0915",
        dashCaseMeta1: "\u0926\u0940\u0935\u093E\u0928\u0940 \xb7 18 \u092E\u093E\u0930\u094D\uFFFD\uFFFD\uFFFD",
        dashCaseMeta2: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915 \xb7 17 \u092E\u093E\u0930\u094D\u091A",
        dashCaseMeta3: "\u0906\u092A\u0930\u093E\u0927\u093F\u0915 \xb7 15 \u092E\u093E\u0930\u094D\u091A",
        dashClient3Name: "\u0921\u0947\u0935\u093F\u091F \u091A\u093F\u0915\u094B\u0935\u093E\u0928\u0940",
        dashDate: "18 \u092E\u093E\u0930\u094D\u091A, 2026",
        dashGreeting: "\u0928\u092E\u0938\u094D\u0924\u0947, \u0928\u0940\u0928\u094B",
        dateMar15: "15 \u092E\u093E\u0930\u094D\u091A",
        dateMar17: "17 \u092E\u093E\u0930\u094D\u091A",
        dateMar18: "18 \u092E\u093E\u0930\u094D\u091A",
        disabledStatus: "\u2014 \u0905\u0915\u094D\u0937\u092E",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E, \u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940\n\n\u0926\u093E\u0935\u093E\n\n\u0935\u093E\u0926\u0940: Barateli & Partners LLC\n\u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940: Delta Group LLC\n\n\u0924\u0925\u094D\u092F\u093E\u0924\u094D\u092E\u0915 \u092A\u0930\u093F\u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902:\n\n\u0907\u0938 \u0926\u093E\u0935\u0947 \u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E, \u0935\u093E\u0926\u0940 \u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940 \u0938\u0947 \u0905\u092A\u0928\u0947 \u0926\u093E\u092F\u093F\u0924\u094D\u0935\u094B\u0902 \u0915\u094B \u092A\u0942\u0930\u093E \u0915\u0930\u0928\u0947 \u0915\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u0930\u0924\u093E \u0939\u0948\u0964\n\n\u0905\u0928\u0941\u0930\u094B\u0927:\n\n1. \u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940 \u0915\u094B 12,500 GEL \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092C\u093E\u0927\u094D\u092F \u0915\u0930\u0947\u0902\n2. 1,875 GEL \u0915\u093E \u091C\u0941\u0930\u094D\u092E\u093E\u0928\u093E \u0932\u0917\u093E\u090F\u0902\n3. \u0905\u0926\u093E\u0932\u0924\u0940 \u0916\u0930\u094D\u091A\u094B\u0902 \u0915\u0940 \u092A\u094D\u0930\u0924\u093F\u092A\u0942\u0930\u094D\u0924\u093F \u0915\u0930\u0947\u0902\n\n\u0926\u093F\u0928\u093E\uFFFD\uFFFD\uFFFD\u0915: 18 \u092E\u093E\u0930\u094D\u091A, 2026\n\u0939\u0938\u094D\u0924\u093E\u0915\u094D\u0937\u0930: ________________",
        docsDocument: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 \u092E\u093E\u0930\u094D\u091A 2026",
        docsFile1Name: "\u0926\u093E\u0935\u093E - \u092E\u093E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 \u092E\u093E\u0930\u094D\u091A 2026",
        docsFile2Name: "\u092E\u0941\u0916\u094D\u0924\u093E\u0930\u0928\u093E\u092E\u093E - \u0915\u094D\u0935\u093E\u0930\u0924\u094D\u0938\u0916\u0947\u0932\u093F\u092F\u093E.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 \u092E\u093E\u0930\u094D\u091A 2026",
        docsFile3Name: "\u0905\u0928\u0941\u092C\u0902\u0927 \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 \u092E\u093E\u0930\u094D\u091A 2026",
        docsFile4Name: "\u0906\u0908\u0921\u0940 \u0915\u0949\u092A\u0940 - \u092E\u093E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 \u092E\u093E\u0930\u094D\u091A 2026",
        docsFile5Name: "\u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E - \u0917\u094B\u0917\u093F\u092F\u093E\u0936\u0935\u093F\u0932\u0940.pdf",
        docsFolder1Count: "3 \u092B\u093C\u093E\u0907\u0932\u0947\u0902",
        docsFolder1Name: "#2024-047 \u092E\u093E\u092E\u0941\u0932\u093E\u0936\u0935\u093F\u0932\u0940",
        docsFolder2Count: "2 \u092B\u093C\u093E\u0907\u0932\u0947\u0902",
        docsFolder2Name: "#2024-046 \u0915\u094D\u0935\u093E\u0930\u0924\u094D\u0938\u0916\u0947\u0932\u093F\u092F\u093E",
        docsFolder3Count: "1 \u092B\u093C\u093E\u0907\u0932",
        docsFolder3Name: "#2024-045 \u0917\u094B\u0917\u093F\u092F\u093E\u0936\u0935\u093F\u0932\u0940",
        docsFolder4Count: "5 \u092B\u093C\u093E\u0907\u0932\u0947\u0902",
        docsFormatAnalysis: "\u092A\uFFFD\uFFFD\u0930\u093E\u0930\u0942\u092A \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923...",
        docsFreeText: "\u092E\u0941\u0915\u094D\u0924 \u092A\u093E\u0920...",
        docsGeneratedClaimText: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E, \u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940\n\n\u0926\u093E\u0935\u093E\n\n\u0935\u093E\u0926\u0940: [Party 1]\n\u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940: [Party 2]\n\n\u0924\u0925\u094D\u092F\u093E\u0924\u094D\u092E\u0915 \u092A\u0930\u093F\u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902:\n\n\u0907\u0938 \u0926\u093E\u0935\u0947 \u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E, \u0935\u093E\u0926\u0940 \u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940 \u0938\u0947 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u0915\u0947 \u0924\u0939\u0924 \u0905\u092A\u0928\u0947 \u0926\u093E\u092F\u093F\u0924\u094D\u0935\u094B\u0902 \u0915\u094B \u092A\u0942\u0930\u093E \u0915\u0930\u0928\u0947 \u0915\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u0930\u0924\u093E \u0939\u0948\u0964\n\n\u0915\u093E\u0928\u0942\u0928\u0940 \u0906\u0927\u093E\u0930:\n\n\u0928\u093E\u0917\u0930\u093F\u0915 \u0938\u0902\u0939\u093F\u0924\u093E \u0915\u0947 \u0905\u0928\u0941\u091A\u094D\u091B\u0947\u0926 316 \u0915\u0947 \u0905\u0928\u0941\u0938\u093E\u0930, \u0926\u093E\u092F\u093F\u0924\u094D\u0935\u094B\u0902 \u0915\u093E \u0920\u0940\u0915 \u0938\u0947 \u092A\u093E\u0932\u0928 \u0915\u093F\u092F\u093E \u091C\u093E\u0928\u093E \u091A\u093E\u0939\u093F\u090F\u0964\n\n\u0905\u0928\u0941\u0930\u094B\u0927:\n\n\u0909\u092A\u0930\u094B\u0915\u094D\u0924 \u0915\u094B \u0927\u094D\u092F\u093E\u0928 \u092E\u0947\u0902 \u0930\u0916\u0924\u0947 \u0939\u0941\u090F, \u0935\u093E\u0926\u0940 \u0905\u0926\u093E\u0932\u0924 \u0938\u0947 \u092A\u094D\u0930\u0924\u093F\u0935\u093E\u0926\u0940 \u0915\u094B \u092C\u093E\u0927\u094D\u092F \u0915\u0930\u0928\u0947 \u0915\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u0930\u0924\u093E \u0939\u0948\u0964\n\n\u0926\u093F\u0928\u093E\u0902\u0915: 18 \u092E\u093E\u0930\u094D\u091A, 2026\n\u0939\u0938\u094D\u0924\u093E\u0915\u094D\u0937\u0930: ________________",
        docsGeorgianSymbols: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0935\u0930\u094D\u0923",
        docsOcrNote: "OCR \u0938\u094D\u0915\u0948\u0928\u093F\u0902\u0917 \u2014 \u0915\u093E\u0917\u091C\u0940 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C\u094B\u0902 \u0915\u093E \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0921\u093F\u091C\u093F\u091F\u0932\u0940\u0915\u0930\u0923, \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 \u091F\u093E\u0907\u092A\u093F\u0902\u0917 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902",
        docsOcrResultText: '\u0905\u0928\u0941\u092C\u0902\u0927 \u2116147\n\nTbilisi, 10 \u092E\u093E\u0930\u094D\u091A, 2026\n\n\u090F\u0915 \u0913\u0930, Barateli & Partners LLC (ID 404123456), \u091C\u093F\u0938\u0915\u093E \u092A\u094D\u0930\u0924\u093F\u0928\u093F\u0927\u093F\u0924\u094D\u0935 \u0928\u093F\u0926\u0947\u0936\u0915 Nino Barateli (\u0907\u0938\u0915\u0947 \u092C\u093E\u0926 "\u0920\u0947\u0915\u0947\u0926\u093E\u0930") \u0926\u094D\u0935\u093E\u0930\u093E \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948 \u0914\u0930 \u0926\u0942\u0938\u0930\u0940 \u0913\u0930, Delta Group LLC (ID 404789012), \u091C\u093F\u0938\u0915\u093E \u092A\u094D\u0930\u0924\u093F\u0928\u093F\u0927\u093F\u0924\u094D\u0935 \u0928\u093F\u0926\u0947\u0936\u0915 Giorgi Mamulashvili (\u0907\u0938\u0915\u0947 \u092C\u093E\u0926 "\u0915\u094D\u0932\u093E\u0907\u0902\u091F") \u0926\u094D\u0935\u093E\u0930\u093E \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948, \u0928\u0947 \u0907\u0938 \u0905\u0928\u0941\u092C\u0902\u0927 \u092E\u0947\u0902 \u092A\u094D\u0930\u0935\u0947\u0936 \u0915\u093F\u092F\u093E:\n\n\u0905\u0928\u0941\u091A\u094D\u091B\u0947\u0926 1. \u0905\u0928\u0941\u092C\u0902\u0927 \u0915\u093E \u0935\u093F\u0937\u092F\n1.1. \u0920\u0947\u0915\u0947\u0926\u093E\u0930 \u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u094B \u0915\u093E\u0928\u0942\u0928\u0940 \u0938\u0947\u0935\u093E\u090F\u0902 \uFFFD\uFFFD\u094D\u0930\u0926\u093E\u0928 \u0915\u0930\u0928\u0947 \u0915\u093E \u0935\u091A\u0928 \u0926\u0947\u0924\u093E \u0939\u0948\u0964\n1.2. \u0938\u0947\u0935\u093E \u0915\u0940 \u0932\u093E\u0917\u0924 12,500 (\u092C\u093E\u0930\u0939 \u0939\u091C\u093C\u093E\u0930 \u092A\u093E\u0901\u091A \u0938\u094C) GEL \u0939\u0948\u0964',
        docsOcrSuccess: "\u0938\u092B\u0932\u0924\u093E\u092A\u0942\u0930\u094D\u0935\u0915 \u092A\u0939\u091A\u093E\u0928\u093E \u0917\u092F\u093E \u2014 98.5% \u0938\u091F\u0940\u0915\u0924\u093E",
        docsRow1Meta: "#2024-047 \xb7 \u0926\u093E\u0935\u093E \xb7 15 \u092E\u093E\u0930\u094D\u091A",
        docsRow1Name: "\u0926\u093E\u0935\u093E - Mamulashvili.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u092E\u0941\u0916\u094D\u0924\u093E\u0930\u0928\u093E\u092E\u093E \xb7 12 \u092E\u093E\u0930\u094D\u091A",
        docsRow2Name: "\u092E\u0941\u0916\u094D\u0924\u093E\u0930\u0928\u093E\u092E\u093E - Kvaratskhelia.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E \xb7 8 \u092E\u093E\u0930\u094D\u091A",
        docsRow3Name: "\u0905\u0927\u093F\u0938\u0942\u091A\u0928\u093E - Gogiashvili.pdf",
        docsTextRecognition: "\u091F\u0947\u0915\u094D\u0938\u094D\u091F \u0930\u093F\u0915\u0917\u094D\u0928\u093F\u0936\u0928",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u0905\u0927\u093F\u0915\u0924\u092E 10MB",
        docsUploadSub: "\u092B\u093C\u093E\u0907\u0932 \u0916\u0940\u0902\u091A\u0947\u0902 \u092F\u093E \u091A\u0941\u0928\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902",
        ecourt: 'ecourt',
        ecourtDesc: "\u0926\u093E\u0935\u0947 \u0926\u093E\u092F\u0930 \u0915\u0930\u0947\u0902, \u0915\u0947\u0938 \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F \u0914\u0930 \u0938\u0941\u0928\u0935\u093E\u0908 \u0915\u093E \u0936\u0947\u0921\u094D\u092F\u0942\u0932 \u091C\u093E\u0902\u091A\u0947\u0902 \u2014 \u092C\u093F\u0928\u093E \u0905\u0926\u093E\u0932\u0924 \u091C\u093E\u090F",
        enabledStatus: "\u2713 \u0938\u0915\u094D\u0937\u092E",
        evidencePending: "\u0938\u092C\uFFFD\uFFFD\u0924 \u2014 \u0932\u0902\u092C\u093F\u0924",
        extract: "\u090F\u0915\u094D\u0938\u091F\u094D\u0930\u0948\u0915\u094D\u091F",
        field1Text: "\u0926\u0940\u0935\u093E\u0928\u0940: \u0905\u0928\u0941. 316 \u0938\u0902\u0936\u094B\u0927\u0928",
        field2Text: "\u0926\u0940\u0935\u093E\u0928\u0940: \u0905\u0928\u0941. 259 \u0938\u092E\u092F \u0938\u0940\u092E\u093E",
        field3Text: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915: \u0908-\u0938\u0947\u0935\u093E",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 \u092E\u093E\u0930\u094D\u091A, 10:00 \u2014 Tbilisi City Court",
        hearingItem2: "\uD83D\uDCC5 28 \u092E\u093E\u0930\u094D\u091A, 14:30 \u2014 Court of Appeals",
        loginEmail: "\u0908\u092E\u0947\u0932",
        matsne: 'matsne',
        matsneDesc: "\u0915\u093E\u0928\u0942\u0928 \u092E\u0947\u0902 \u092C\u0926\u0932\u093E\u0935 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u2014 \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0948\u0915\u094D\u091F\u093F\u0938 \u0915\u094D\u0937\u0947\u0924\u094D\u0930 \u092E\u0947\u0902",
        outlook: 'Outlook',
        prepHearing: "\u092A\u094D\u0930\u093E\u0930\u0902\u092D\u093F\u0915 \u0938\u0941\u0928\u0935\u093E\u0908 \u2014 22 \u092E\u093E\u0930\u094D\u091A",
        propertyApartment: "\u0905\u092A\u093E\u0930\u094D\u091F\u092E\u0947\u0902\u091F \u2014 Vake, 85 \u0935\u0930\u094D\u0917 \u092E\u0940\u091F\u0930 \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021, AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u0938\u0902\u092A\u0924\u094D\u0924\u093F \u090F\u0915\u094D\u0938\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u2014 \u091C\u094B\u0921\u093C\u093E \u0917\u092F\u093E",
        registryDesc: "\u0915\u0902\u092A\u0928\u0940 \u0914\u0930 \u0938\u0902\u092A\u0924\u094D\u0924\u093F \u0921\u0947\u091F\u093E \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u2014 \u0905\u092C \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 \u090F\u0915\u094D\u0938\u091F\u094D\u0930\u0948\u0915\uFFFD\uFFFD\u091F \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902",
        timeEntry1Date: "18 \u092E\u093E\u0930\u094D\u091A, 10:30",
        timeEntry1Text: "\u0915\u0947\u0938 \u0916\u094B\u0932\u093E \u0917\u092F\u093E, \u092A\u094D\u0930\u093E\u0930\u0902\u092D\u093F\u0915 \u092A\u0930\u093E\u092E\u0930\u094D\u0936 \u092A\u0942\u0930\u093E \u0939\u0941\u0906",
        timeEntry2Date: "17 \u092E\u093E\u0930\u094D\u091A, 14:00",
        timeEntry2Text: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0928\u0947 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u092A\u094D\u0930\u0926\u093E\u0928 \u0915\u093F\u090F",
        timeEntry3Date: "15 \u092E\u093E\u0930\u094D\u091A, 09:00",
        timeEntry3Text: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0928\u0947 \u092B\u0930\u094D\u092E \u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u093F\u092F\u093E, \u092A\u094D\u0930\u093E\u0930\u0902\u092D\u093F\u0915 \u0906\u0935\u0947\u0926\u0928",
        typeCivil: "\u0926\u0940\u0935\u093E\u0928\u0940",
        typeAdministrative: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928\u093F\u0915",
        typeCriminal: "\u092B\u094C\u091C\u0926\u093E\u0930\u0940",
        pitchArpuMonth: "\u0914\u0938\u0924 ARPU/\u092E\u093E\u0939",
        pitchArpuYear: "\u0914\u0938\u0924 ARPU/\u0935\u0930\u094D\u0937",
        pitchAutoBackup: "\u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u092C\u0948\u0915\u0905\u092A",
        pitchAutoNextSteps: "\u0911\u091F\u094B \u0905\u0917\u0932\u0947 \u0915\u0926\u092E",
        pitchAutoReminder: "\u0911\u091F\u094B \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930",
        pitchBooking: "\u092C\u0941\u0915\u093F\u0902\u0917",
        pitchCacOrganic: "CAC (\u0911\u0930\u094D\u0917\u0947\u0928\u093F\u0915 \u0917\u094D\u0930\u094B\u0925)",
        pitchCalcNote: "5000 \u0935\u0915\u0940\u0932 \xd7 \u20BE35/\u092E\u093E\u0939 \u0914\u0938\u0924 \xd7 12 \u092E\u0939\u0940\u0928\u0947",
        pitchCalendarSync: "\u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0938\u093F\u0902\u0915",
        pitchCalendarSyncDesc: "Google Calendar, Outlook, Apple Calendar \u2014 \u0938\u0941\u0928\u0935\u093E\u0908 \u0914\u0930 \u0938\u092E\u092F \u0938\u0940\u092E\u093E \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u093F\u0902\u0915 \u0939\u094B\u0924\u0940 \u0939\u0948\u0902",
        pitchCaseManagement: "\u0915\u0947\u0938 \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        pitchClientSchedule: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0936\u0947\u0921\u094D\u092F\u0942\u0932",
        pitchCloudDedicated: "\u0921\u0947\u0921\u093F\u0915\u0947\u091F\u0947\u0921 \u0915\u094D\u0932\u093E\u0909\u0921",
        pitchCloudDedicatedDesc: "\u0906\u0907\u0938\u094B\u0932\u0947\u091F\u0947\u0921 \u0915\u094D\u0932\u093E\u0909\u0921 \u0938\u0930\u094D\u0935\u0930 \u2014 \u0906\u092A\u0915\u093E \u0921\u0947\u091F\u093E \u0905\u0928\u094D\u092F \u0915\u094D\u0932\u093E\u0907\u0902\u091F\u094D\u0938 \u0938\u0947 \u092A\u0942\u0930\u0940 \u0924\u0930\u0939 \u0905\u0932\u0917",
        pitchContractAnalysis: "\u0905\u0928\u0941\u092C\u0902\u0927 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        pitchCtaSubtext: "\u092C\u0941\u0915\u093F\u0902\u0917 + \u0911\u092A\u0930\u0947\u0936\u0928\u094D\u0938 + AI",
        pitchDedicatedServer: "\u0921\u0947\u0921\u093F\u0915\u0947\u091F\u0947\u0921 \u0938\u0930\u094D\u0935\u0930",
        pitchDocDraftGeo: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u092E\u0947\u0902 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u094D\u0930\u093E\u092B\u094D\u091F\u093F\u0902\u0917",
        pitchEcourtDesc: "\u0926\u093E\u0935\u0947 \u0926\u093E\u092F\u0930 \u0915\u0930\u0947\u0902, \u0915\u0947\u0938 \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F \u0914\u0930 \u0938\u0941\u0928\u0935\u093E\u0908 \u0915\u093E \u0936\u0947\u0921\u094D\u092F\u0942\u0932 \u2014 \u092C\u093F\u0928\u093E \u0905\u0926\u093E\u0932\u0924 \u091C\u093E\u090F",
        pitchGdprCompliant: "GDPR \u0905\u0928\u0941\u092A\u093E\u0932\u0915",
        pitchHybrid: "\u0939\u093E\u0907\u092C\u094D\u0930\u093F\u0921",
        pitchHybridDesc: "\u0915\u094D\u0932\u093E\u0909\u0921 + \u0932\u094B\u0915\uFFFD\uFFFD \u2014 \u0938\u0902\u0935\u0947\u0926\u0928\u0936\u0940\u0932 \u0921\u0947\u091F\u093E \u0938\u094D\u0925\u093E\u0928\u0940\u092F \u0930\u0942\u092A \u0938\u0947, \u092C\u093E\u0915\u0940 \u0915\u094D\u0932\u093E\u0909\u0921 \u092E\u0947\u0902",
        pitchIntegrationsSub: "\u0938\u0930\u0915\u093E\u0930\u0940 \u0938\u0947\u0935\u093E\u090F\u0902, \u0915\u0948\u0932\u0947\u0902\u0921\u0930 \u0914\u0930 OCR \u2014 \u090F\u0915 \u0939\u0940 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E \u0938\u0947",
        pitchInvoices: "\u0907\u0928\u0935\u0949\u0907\u0938",
        pitchMatsneDesc: "\u0915\u093E\u0928\u0942\u0928 \u092E\u0947\u0902 \u092C\u0926\u0932\u093E\u0935 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u2014 \u0906\u092A\u0915\u0947 \u092A\u094D\u0930\u0948\u0915\u094D\u091F\u093F\u0938 \u0915\u094D\u0937\u0947\u0924\u094D\u0930 \u092E\u0947\u0902",
        pitchOcrDesc: "\u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u092A\u0947\u092A\u0930 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0921\u093F\u091C\u093F\u091F\u0932\u0940\u0915\u0930\u0923 \u2014 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 \u091F\u093E\u0907\u092A\u093F\u0902\u0917 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902",
        pitchOnPremise: "\u0911\u0928-\u092A\u094D\u0930\u093F\u092E\u093E\u0907\u0938\u0947\u0938 \u0938\u0930\u094D\u0935\u0930",
        pitchOnPremiseDesc: "\u092A\u0942\u0930\u0940 \u0924\u0930\u0939 \u0938\u0947 \u0932\u094B\u0915\u0932 \u2014 \u0921\u0947\u091F\u093E \u0906\u092A\u0915\u0947 \u0915\u093E\u0930\u094D\u092F\u093E\u0932\u092F \u092E\u0947\u0902 \u0930\u0939\u0924\u093E \u0939\u0948, \u0915\u094B\u0908 \u0907\u0902\u091F\u0930\u0928\u0947\u091F \u090F\u0915\u094D\u0938\u0947\u0938 \u0928\u0939\u0940\u0902",
        pitchOperations: "\u0911\u092A\u0930\u0947\u0936\u0928\u094D\u0938",
        pitchPerkAiDocs: "AI \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        pitchPerkBookings: "\u092C\u0941\u0915\u093F\u0902\u0917 \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        pitchPerkClientPortal: "\u0915\u094D\u0932\u093E\u0907\u0902\u091F \u092A\u094B\u0930\u094D\u091F\u0932",
        pitchPerkCommunication: "\u0938\u0902\u091A\u093E\u0930",
        pitchPerkFileStorage: "\u092B\u093C\u093E\u0907\u0932 \u0938\u094D\u091F\u094B\u0930\u0947\u091C",
        pitchPerkResponsive: "\u0930\u093F\u0938\u094D\u092A\u0949\u0928\u094D\u0938\u093F\u0935",
        pitchPrivacySubtitle: "\u0915\u093E\u0928\u0942\u0928\u0940 \u0921\u0947\u091F\u093E \u0915\u094B \u0905\u0927\u093F\u0915\u0924\u092E \u0938\u0941\u0930\u0915\u094D\u0937\u093E \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u094B\u0924\u0940 \u0939\u0948",
        pitchPublicRegistryDesc: "\u0915\u0902\u092A\u0928\u0940 \u0914\u0930 \u0938\u0902\u092A\u0924\u094D\u0924\u093F \u0921\u0947\u091F\u093E \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u2014 \u0915\u094B\u0908 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 \u090F\u0915\u094D\u0938\u091F\u094D\u0930\u0948\u0915\u094D\u091F \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0928\u0939\u0940\u0902",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 \u092E\u093E\u0930\u094D\u091A 2026",
        pitchRecurringModel: "\u0930\u093F\u0915\u0930\u093F\u0902\u0917 \u092E\u0949\u0921\u0932",
        pitchRsGeDesc: "\u091F\u0948\u0915\u094D\u0938 \u090B\u0923 \u0914\u0930 \u0908-\u0907\u0928\u0935\u0949\u0907\u0938 \u2014 \u090F\u0915 \u0915\u094D\u0932\u093F\u0915 \u092E\u0947\u0902 \u0915\u094D\u0932\u093E\u0907\u0902\u091F \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F",
        pitchScen250: "250 \u0935\u0915\u0940\u0932",
        pitchScen500: "500 \u0935\u0915\u0940\u0932",
        pitchScen1000: "1000 \u0935\u0915\u0940\u0932",
        pitchServerCost: "\u0938\u0930\u094D\u0935\u0930 \u0932\u093E\u0917\u0924/\u0909\u092A\u092F\u094B\u0917\u0915\u0930\u094D\u0924\u093E",
        pitchTierBusiness10: "10+ \u0935\u0915\u0940\u0932",
        pitchTierEnterpriseCustom: "\u0915\u0938\u094D\u091F\u092E",
        pitchTierEnterprisePrice: "\u0915\u094B\u091F",
        pitchTierPro310: "3-10 \u0935\u0915\u0940\u0932",
        pitchTierStarter12: "1-2 \u0935\u0915\u0940\u0932",
        pitchTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F TrustLegal",
        pitchTrustedAccounting: "\u0935\u093F\u0936\u094D\u0935\u0938\u0928\u0940\u092F \u0905\u0915\u093E\u0909\u0902\u091F\u093F\u0902\u0917",
        pitchWhyAiCheap: "AI \u091F\u0942\u0932 \u0905\u092C \u0915\u093E\u092B\u0940 \u0915\u093F\u092B\u093E\u092F\u0924\u0940 \u0939\u0948\u0902",
        pitchWhyDigitizing: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0915\u093E\u0928\u0942\u0928\u0940 \u092C\u093E\u091C\u093C\u093E\u0930 \u0924\u0947\u091C\u093C\u0940 \u0938\u0947 \u0921\u093F\u091C\u093F\u091F\u0932 \u0939\u094B \u0930\u0939\u093E \u0939\u0948",
        pitchWhyNoCompetitor: "\u0915\u094B\u0908 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u092A\u094D\u0930\u0924\u093F\u0938\u094D\u092A\u0930\u094D\u0927\u0940 \u0928\u0939\u0940\u0902",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: 'Nino Barateli',
        settingsMember2Name: 'Giga Aslanishvili',
        settingsNotifyDeadlineReminder: "\u0921\u0947\u0921\u0932\u093E\u0907\u0928 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930",
        settingsNotifyNewBookingEmail: "\u0928\u0908 \u092C\u0941\u0915\u093F\u0902\u0917 \u2014 \u0908\u092E\u0947\u0932",
        settingsNotifyNewBookingWhatsapp: "\u0928\u0908 \u092C\u0941\u0915\u093F\u0902\u0917 \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u092C\u0915\u093E\u092F\u093E \u0907\u0928\u0935\u0949\u0907\u0938",
        settingsNotifyReminder24h: "24 \u0918\u0902\u091F\u0947 \u092A\u0939\u0932\u0947 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930",
        settingsProfileName: 'Nino Barateli',
        settingsToggle3DaysBefore: "3 \u0926\u093F\u0928 \u092A\u0939\u0932\u0947",
        portalCaseTypeCivil: "\u0938\u093F\u0935\u093F\u0932",
        portalDocDate1: "15 \u092E\u093E\u0930\u094D\u091A",
        portalDocName1: 'Claim - Mamulashvili.pdf',
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "\u0926\u0947\u092F: 25 \u092E\u093E\u0930\u094D\u091A",
        portalLastUpdate: "\u0905\u0902\u0924\u093F\u092E \u0905\u092A\u0921\u0947\u091F: 18 \u092E\u093E\u0930\u094D\u091A",
        portalMsgFrom1: 'Nino Barateli',
        portalMsgPlaceholder: "\u090F\u0915 \u0938\u0902\u0926\u0947\u0936 \u092D\u0947\u091C\u0947\u0902...",
        portalMsgText1: "\u0928\u092E\u0938\u094D\u0924\u0947 Giorgi, \u0939\u092E\u093E\u0930\u0947 \u092A\u093E\u0938 \u0915\u0947\u0938 \u092A\u0930 \u090F\u0915 \u0928\u092F\u093E \u0905\u092A\u0921\u0947\u091F \u0939\u0948\u0964",
        portalMsgText2: "\u0927\u0928\u094D\u092F\u0935\u093E\u0926, \u0935\u093F\u0935\u0930\u0923 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0939\u0948\u0964",
        portalNextHearing: "\u0915\u094B\u0930\u094D\u091F \u0915\u0940 \u0938\u0941\u0928\u0935\u093E\u0908 25 \u092E\u093E\u0930\u094D\u091A",
        portalPay: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0947\u0902",
        portalPendingInvoices: "\u0932\u0902\u092C\u093F\u0924 \u0907\u0928\u0935\u0949\u0907\u0938",
        portalProgressLabel: "\u092A\u094D\u0930\u0917\u0924\u093F: 3/5 \u091A\u0930\u0923",
        portalStatusActive: "\u0938\u0915\u094D\u0930\u093F\u092F",
        clientDashCaseTypeCivil: "\u0938\u093F\u0935\u093F\u0932",
        clientDashDocMeta1: "\u0915\u0947\u0938 #2024-047 \xb7 15 \u092E\u093E\u0930\u094D\u091A",
        clientDashDocMeta2: "\u0915\u0947\u0938 #2024-046 \xb7 12 \u092E\u093E\u0930\u094D\u091A",
        clientDashDocName1: 'Claim - Mamulashvili.pdf',
        clientDashDocName2: 'Power of Attorney - Kvaratskhelia.pdf',
        clientDashDocumentsTitle: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        clientDashInvCase1: "\u0915\u0947\u0938: #2024-047",
        clientDashInvCase2: "\u0915\u0947\u0938: #2024-046",
        clientDashInvDue1: "\u0926\u0947\u092F: 25 \u092E\u093E\u0930\u094D\u091A, 2026",
        clientDashInvoicesTitle: "\u0907\u0928\u0935\u0949\u0907\u0938",
        clientDashInvPaidDate: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E: 14 \u092E\u093E\u0930\u094D\u091A, 2026",
        clientDashLawyerInitials: 'NB',
        clientDashLawyerName: 'Nino Barateli',
        clientDashLawyerRole: "\u0906\u092A\u0915\u0947 \uFFFD\uFFFD\u0915\u0940\u0932",
        clientDashMessagesTitle: "\u0938\u0902\u0926\u0947\u0936",
        clientDashMsgFrom1: 'Nino Barateli',
        clientDashMsgFrom3: 'Nino Barateli',
        clientDashMsgPlaceholder: "\u090F\u0915 \u0938\u0902\u0926\u0947\u0936 \u0932\u093F\u0916\u0947\u0902...",
        clientDashMsgText1: "\u0928\u092E\u0938\u094D\u0924\u0947 Giorgi, \u0939\u092E\u093E\u0930\u0947 \u092A\u093E\u0938 \u0915\u0947\u0938 \u0915\u093E \u0928\u092F\u093E \u0905\u092A\u0921\u0947\u091F \u0939\u0948\u0964 \u0915\u094B\u0930\u094D\u091F \u0928\u0947 25 \u092E\u093E\u0930\u094D\u091A \u0915\u0947 \u0932\u093F\u090F \u0938\u0941\u0928\u0935\u093E\u0908 \u0924\u092F \u0915\u0940 \u0939\u0948\u0964",
        clientDashMsgText2: "\u0927\u0928\u094D\u092F\u0935\u093E\u0926, \u0935\u093F\u0935\u0930\u0923 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0939\u0948\u0964 \u0915\u094D\u092F\u093E \u092E\u0941\u091D\u0947 \u0915\u094B\u0908 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C \u0924\u0948\u092F\u093E\u0930 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u093F\u090F?",
        clientDashMsgText3: "\u0928\u0939\u0940\u0902, \u0938\u092C \u0915\u0941\u091B \u0924\u0948\u092F\u093E\u0930 \u0939\u0948\u0964 \u0938\u0941\u0928\u0935\u093E\u0908 \u0938\u0947 \u090F\u0915 \u0938\u092A\u094D\u0924\u093E\u0939 \u092A\u0939\u0932\u0947 \u0906\u092A\u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902\u0917\u0947\u0964",
        clientDashMsgTime1: "10:30 \xb7 \u0906\u091C",
        clientDashMsgTime2: "10:45 \xb7 \u0906\u091C",
        clientDashMsgTime3: "11:02 \xb7 \u0906\u091C",
        clientDashMyCases: "\u092E\u0947\u0930\u0947 \u0915\u0947\u0938",
        clientDashPaid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientDashPay: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0947\u0902",
        clientDashProgressLabel: "\u092A\u094D\u0930\u0917\u0924\u093F: 3/5 \u091A\u0930\u0923 \u092A\u0942\u0930\u0947 \u0939\u0941\u090F",
        clientDashStatActiveCase: "\u0938\u0915\u094D\u0930\u093F\u092F \u0915\u0947\u0938",
        clientDashStatDocument: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        clientDashStatNextHearing: "\u0905\u0917\u0932\u0940 \u0938\u0941\u0928\u0935\u093E\u0908",
        clientDashStatNextHearingValue: "25 \u092E\u093E\u0930\u094D\u091A",
        clientDashStatPayable: "\u0926\u0947\u092F",
        clientDashStatusActive: "\u0938\u0915\u094D\u0930\u093F\u092F",
        clientDashStep1Date: "5 \u092E\u093E\u0930\u094D\u091A, 2026",
        clientDashStep1Title: "\u092A\u0930\u093E\u092E\u0930\u094D\u0936 \u092A\u0942\u0930\u093E \u0939\u0941\u0906",
        clientDashStep2Date: "10 \u092E\u093E\u0930\u094D\u091A, 2026",
        clientDashStep2Title: "\u0926\u093E\u0935\u093E \u0921\u094D\u0930\u093E\u092B\u094D\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientDashStep3Date: "15 \u092E\u093E\u0930\u094D\u091A, 2026",
        clientDashStep3Title: "\u0926\u093E\u0935\u093E \u0915\u094B\u0930\u094D\u091F \u092E\u0947\u0902 \u0926\u093E\u092F\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E",
        clientDashStep4Date: "25 \u092E\u093E\u0930\u094D\u091A, 2026 \u2014 \u0932\u0902\u092C\u093F\u0924",
        clientDashStep4Title: "\u0905\u0926\u093E\u0932\u0924 \u0915\u0940 \u0938\u0941\u0928\u0935\u093E\u0908",
        clientDashStep5Title: "\u0928\u093F\u0930\u094D\u0923\u092F",
        clientDashUnpaid: "\u092C\u0915\u093E\u092F\u093E",
        clientDashWelcomeSub: "\u092F\u0939\u093E\u0901 \u0906\u092A \u0905\u092A\u0928\u0947 \u092E\u093E\u092E\u0932\u094B\u0902, \u0907\u0928\u0935\u0949\u0907\u0938 \u0914\u0930 \u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C\u094B\u0902 \u0915\u094B \u091F\u094D\u0930\u0948\u0915 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964"
    },
    msa: {
        home: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
        dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        bookings: "\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        bookingPage: "\u0635\u0641\u062D\u0629 \u0627\u0644\u062D\u062C\u0632",
        aiDocuments: "\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        clientPortalNav: "\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        lawyersNav: "\u0627\u0644\u0645\u062D\u0627\u0645\u0648\u0646",
        login: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
        getStarted: "\u0627\u0628\u062F\u0623 \u0645\u062C\u0627\u0646\u0627\u064B",
        lawyersTitle: "\u0627\u0644\u0645\u062D\u0627\u0645\u0648\u0646 \u0648\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u0645\u062D\u0627\u0645\u0627\u0629",
        lawyersSubtitle: "\u0627\u0644\u0645\u0633\u062C\u0644\u0648\u0646 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        searchPlaceholder: "\u0627\u0644\u0628\u062D\u062B \u0628\u0627\u0644\u0627\u0633\u0645\u060C \u0627\u0644\u0634\u0631\u0643\u0629\u060C \u0623\u0648 \u0645\u062C\u0627\u0644 \u0627\u0644\u062A\u062E\u0635\u0635...",
        lawyersBtn: "\u0627\u0644\u0645\u062D\u0627\u0645\u0648\u0646",
        firmsBtn: "\u0627\u0644\u0634\u0631\u0643\u0627\u062A",
        allFilter: "\u0627\u0644\u0643\u0644",
        corporateLaw: "\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0634\u0631\u0643\u0627\u062A",
        criminalLaw: "\u0627\u0644\uFFFD\uFFFD\u0627\u0646\u0648\u0646 \u0627\u0644\u062C\u0646\u0627\u0626\u064A",
        familyLaw: "\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0633\u0631\u0629",
        realEstate: "\u0627\u0644\u0639\u0642\u0627\u0631\u0627\u062A",
        taxLaw: "\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0636\u0631\u0627\u0626\u0628",
        ipLaw: "\u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0627\u0644\u0641\u0643\u0631\u064A\u0629",
        immigration: "\u0627\u0644\u0647\u062C\u0631\u0629",
        laborLaw: "\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0639\u0645\u0644",
        bankingFinance: "\u0627\u0644\u0628\u0646\u0648\u0643 \u0648\u0627\u0644\u062A\u0645\u0648\u064A\u0644",
        firmsMatch: "\u0634\u0631\u0643\u0627\u062A \u0645\u0637\u0627\u0628\u0642\u0629",
        lawyersMatch: "\u0645\u062D\u0627\u0645\u0648\u0646 \u0645\u0637\u0627\u0628\u0642\u0648\u0646",
        reviews: "\u062A\u0642\u064A\u064A\u0645\u0627\u062A",
        loadingMore: "\u062C\u0627\u0631\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F...",
        independent: "\u0645\u0633\u062A\u0642\u0644",
        yearsExperience: "\u0633\u0646\u0648\u0627\u062A \u062E\u0628\u0631\u0629",
        languages: "\u0627\u0644\u0644\u063A\u0627\u062A",
        backToDirectory: "\u2190 \u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u062F\u0644\u064A\u0644",
        about: "\u0646\u0628\u0630\u0629",
        bookConsultation: "\u062D\u062C\u0632 \u0627\u0633\u062A\u0634\u0627\u0631\u0629",
        sendMessage: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629",
        call: "\u0627\u062A\u0635\u0627\u0644",
        reviewsRatings: "\u0627\u0644\u062A\u0642\u064A\u064A\u0645\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0627\u062A",
        reviewsComingSoon: "\u0627\u0644\u062A\u0642\u064A\u064A\u0645\u0627\u062A \u0642\u0631\u064A\u0628\u0627\u064B. \u0643\u0646 \u0623\u0648\u0644 \u0645\u0646 \u064A\u0642\u064A\u0651\u0645.",
        barId: "\u0631\u0642\u0645 \u0627\u0644\u0646\u0642\u0627\u0628\u0629",
        ourTeam: "\u0641\u0631\u064A\u0642\u0646\u0627",
        contact: "\u062A\u0648\u0627\u0635\u0644",
        website: "\u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        established: "\u062A\u0623\u0633\u0633\u062A",
        lawyersCount: "\u0645\u062D\u0627\u0645\u0648\u0646",
        georgian: "\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        english: "\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629",
        russian: "\u0627\u0644\u0631\u0648\u0633\u064A\u0629",
        german: "\u0627\u0644\u0623\u0644\u0645\u0627\u0646\u064A\u0629",
        french: "\u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
        turkish: "\u0627\u0644\u062A\u0631\u0643\u064A\u0629",
        heroLine1: "\u0641\u0631\u064A\u0642\u0643",
        heroLine2: "\u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A. \u0645\u0646\u0635\u0629",
        heroLine3: "\u0648\u0627\u062D\u062F\u0629.",
        heroSubtitle: "TrustLegal \u2014 \u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A\u060C \u0627\u0644\u0642\u0636\u0627\u064A\u0627\u060C \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u0645\u062D\u0627\u0645\u0627\u0629 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629. \u0631\u0633\u0648\u0645 \u0634\u0647\u0631\u064A\u0629 \u0648\u0627\u062D\u062F\u0629\u060C \u0628\u062F\u0648\u0646 \u0639\u0642\u062F.",
        tryFree: "\u062C\u0631\u0628 \u0645\u062C\u0627\u0646\u0627\u064B \u2192",
        liveDemo: "\u0639\u0631\u0636 \u062A\u062C\u0631\u064A\u0628\u064A \u062D\u064A",
        trustedBrands: "\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0647\u062A\u0645 \u0628\u0627\u0644\u062C\u0648\u062F\u0629 \u062A\u0639\u0645\u0644 \u0645\u0639\u0646\u0627",
        howItWorks: "\u0643\u064A\u0641 \u062A\u0639\u0645\u0644",
        processLabel: "// \u0627\u0644\u0639\u0645\u0644\u064A\u0629",
        step1Title: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644",
        step1Desc: "\u0623\u0646\u0634\u0626 \u062D\u0633\u0627\u0628\u0627\u064B \u0648\u0627\u062E\u062A\u0631 \u062E\u0637\u0629. \u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062A\u0645\u0627\u0646 \u2014 \u0623\u0648\u0644 30 \u064A\u0648\u0645\u0627\u064B \u0645\u062C\u0627\u0646\u0627\u064B.",
        step2Title: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        step2Desc: "\u0623\u0636\u0641 \u0627\u0644\u0639\u0645\u0644\u0627\u0621\u060C \u0627\u0644\u0642\u0636\u0627\u064A\u0627 \u0648\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A. \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629 \u0648\u0645\u0632\u0627\u0645\u0646\u0629 \u0645\u0639 \u0627\u0644\u062A\u0642\u0648\u064A\u0645.",
        step3Title: "\u0627\u0644\u0635\u064A\u0627\u063A\u0629 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        step3Desc: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u0645\u062F\u0639\u0648\u0645\u0629 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A. \u0627\u0644\u062F\u0639\u0627\u0648\u0649\u060C \u0627\u0644\u062A\u0648\u0643\u064A\u0644\u0627\u062A\u060C \u0648\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F.",
        step4Title: "\u0627\u0644\u0646\u0645\u0648",
        step4Desc: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\u060C \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A \u0648\u0625\u0646\u062A\u0627\u062C\u064A\u0629 \u0627\u0644\u0641\u0631\u064A\u0642. \u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0641\u0639\u0644\u064A.",
        demoBadge: "// \u0639\u0631\u0636 \u062A\u062C\u0631\u064A\u0628\u064A \u062D\u064A",
        todaysBookings: "\u062D\u062C\u0648\u0632\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
        fullDemo: "\u0639\u0631\u0636 \u062A\u062C\u0631\u064A\u0628\u064A \u0643\u0627\u0645\u0644 \u2192",
        onePlatformThreePillars: "\u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629.\n\u062B\u0644\u0627\u062B \u0631\u0643\u0627\u0626\u0632.",
        capabilitiesLabel: "// \u0627\u0644\u0642\u062F\u0631\u0627\u062A",
        bookingFeature: "\u0627\u0644\u062D\u062C\u0632",
        bookingFeatureDesc: "\u064A\u062E\u062A\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0648\u0642\u062A\u0647\u0645 \u0627\u0644\u062E\u0627\u0635. \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629. \u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645. \u0635\u0641\u062D\u0629 \u062D\u062C\u0632 \u0639\u0627\u0645\u0629.",
        operationsFeature: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        operationsFeatureDesc: "\u0625\u062F\u0627\u0631\u0629 \u0645\u0631\u0643\u0632\u064A\u0629 \u0644\u0644\u0642\u0636\u0627\u064A\u0627. \u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621. \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A. \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0641\u0631\u064A\u0642.",
        aiFeatureDesc: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629. \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F. \u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A. \u0645\u062A\u0627\u0628\u0639\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0629.",
        simplePricing: "\u0623\u0633\u0639\u0627\u0631 \u0628\u0633\u064A\u0637\u0629",
        plansLabel: "// \u0627\u0644\u062E\u0637\u0637",
        perMonth: "/ \u0634\u0647\u0631",
        bookingMgmt: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        caseTracking: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        calendarSync: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
        emailReminders: "\u062A\u0630\u0643\u064A\u0631\u0627\u062A \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        starterPlan: "\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
        startNow: "\u0627\u0628\u062F\u0623 \u0627\u0644\u0622\u0646 \u2192",
        everythingStarter: "\u0643\u0644 \u0634\u064A\u0621 \u0641\u064A \u062E\u0637\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629",
        aiDocDrafting: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        invoicesPayments: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
        clientPortalFeature: "\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        directSupport: "\u062F\u0639\u0645 \u0645\u0628\u0627\u0634\u0631",
        professionalPlan: "\u0627\u0644\u0627\u062D\u062A\u0631\u0627\u0641\u064A\u0629",
        mostPopular: "\u0627\u0644\u0623\u0643\u062B\u0631 \u0634\u064A\u0648\u0639\u0627\u064B",
        everythingPro: "\u0643\u0644 \u0634\u064A\u0621 \u0641\u064A \u0627\u0644\u062E\u0637\u0629 \u0627\u0644\u0627\u062D\u062A\u0631\u0627\u0641\u064A\u0629",
        teamMgmt10: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0641\u0631\u064A\u0642 (+10 \u0645\u062D\u0627\u0645\u064A\u0646)",
        contractAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F",
        advancedAnalytics: "\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0645\u062A\u0642\u062F\u0645\u0629",
        personalOnboarding: "\u062A\u0648\u062C\u064A\u0647 \u0634\u062E\u0635\u064A",
        businessPlan: "\u0627\u0644\u0623\u0639\u0645\u0627\u0644",
        spotsLeft: "3 \u0623\u0645\u0627\u0643\u0646 \u0645\u062A\u0628\u0642\u064A\u0629",
        enterpriseNote: "\u0627\u0644\u0645\u0624\u0633\u0633\u0627\u062A \u2014 \u0627\u062A\u0635\u0644 \u0628\u0646\u0627 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0639\u0631\u0636 \u0645\u062E\u0635\u0635.",
        readyQuestion: "\u062C\u0627\u0647\u0632\u061F",
        first30DaysFree: "\u0623\u0648\u0644 30 \u064A\u0648\u0645\u0627\u064B \u0645\u062C\u0627\u0646\u0627\u064B. \u0628\u062F\u0648\u0646 \u0639\u0642\u062F. \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0625\u0644\u063A\u0627\u0621 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.",
        footerTagline: "\u0645\u0646\u0635\u0629 SaaS \u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u062C\u0648\u0631\u062C\u064A\u0629.",
        productLabel: "\u0627\u0644\u0645\u0646\u062A\u062C",
        companyLabel: "\u0627\u0644\u0634\u0631\u0643\u0629",
        bookingsLink: "\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        casesLink: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        aiDocsLink: "\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        aboutUs: "\u0645\u0646 \u0646\u062D\u0646",
        careers: "\u0627\u0644\u0648\u0638\u0627\u0626\u0641",
        copyrightText: "\xa9 2026 TrustLegal",
        builtWith: "\u0645\u0628\u0646\u064A \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 Symbols",
        sidebarMain: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        sidebarBookings: "\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        sidebarCases: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        sidebarClients: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        sidebarDocs: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        sidebarPayments: "\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
        sidebarLawyers: "\u0627\u0644\u0645\u062D\u0627\u0645\u0648\u0646",
        sidebarSettings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
        sidebarLogout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
        bookingsTitle: "\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        newBooking: "+ \u062D\u062C\u0632 \u062C\u062F\u064A\u062F",
        newBookingTitle: "\u062D\u062C\u0632 \u062C\u062F\u064A\u062F",
        clientName: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0645\u064A\u0644",
        phoneNumber: "\u0627\u0644\u0647\u0627\u062A\u0641",
        civilLaw: "\u0645\u062F\u0646\u064A",
        criminalLaw2: "\u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u062C\u0646\u0627\u0626\u064A",
        administrativeLaw: "\u0625\u062F\u0627\u0631\u064A",
        otherType: "\u0623\u062E\u0631\u0649",
        notesPlaceholder: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A...",
        confirmBooking: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u062C\u0632",
        cancelBtn: "\u0625\u0644\u063A\u0627\u0621",
        calendarSyncNote: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u2014 \u062A\u062A\u0645 \u0645\u0632\u0627\u0645\u0646\u0629 Google Calendar \u0648 Outlook \u0648 Apple Calendar \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B",
        synced: "\u062A\u0645\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629",
        calendarSync2: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
        syncedStatus: "\u062A\u0645\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629",
        bookingsToday: "3 \u062D\u062C\u0648\u0632\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
        settingsLink: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u2192",
        pendingStatus: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        connectionNeeded: "\u0645\u0637\u0644\u0648\u0628 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
        connectLink: "\u0627\u062A\u0635\u0627\u0644 \u2192",
        lastSync: "\u0622\u062E\u0631 \u0645\u0632\u0627\u0645\u0646\u0629: \u0642\u0628\u0644 5 \u062F\u0642\u0627\u0626\u0642",
        mon: "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        tue: "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        wed: "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        thu: "\u0627\u0644\u062E\u0645\u064A\u0633",
        fri: "\u0627\u0644\u062C\u0645\u0639\u0629",
        bookingDetails: "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062D\u062C\u0632",
        confirmed: "\u0645\u0624\u0643\u062F",
        pending: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        upcomingBookings: "\u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
        closeBtn: "\u0625\u063A\u0644\u0627\u0642",
        selectDateTime: "\u062D\u062F\u062F \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0648\u0642\u062A",
        fillInfo: "\u0627\u0645\u0644\u0623 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u2014 ",
        firstName: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
        lastName: "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629",
        phoneField: "\u0627\u0644\u0647\u0627\u062A\u0641",
        emailField: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        caseDescription: "\u0648\u0635\u0641 \u0645\u0648\u062C\u0632 \u0644\u0644\u0642\u0636\u064A\u0629",
        confirmBookingPublic: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u062C\u0632",
        goBack: "\u0627\u0644\u0631\u062C\u0648\u0639",
        bookingConfirmedMsg: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u062C\u0632!",
        timeLabel: "\u0627\u0644\u0648\u0642\u062A: ",
        lawGroupBarateli: 'Barateli Legal Group',
        ninoBarateli: 'Nino Barateli',
        casesTitle: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        searchPlaceholder2: "\u0628\u062D\u062B...",
        newCase: "+ \u0642\u0636\u064A\u0629 \u062C\u062F\u064A\u062F\u0629",
        allTab: "\u0627\u0644\u0643\u0644",
        activeTab: "\u0646\u0634\u0637",
        pendingTab: "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        closedTab: "\u0645\u063A\u0644\u0642",
        selectCasePrompt: "\u062D\u062F\u062F \u0642\u0636\u064A\u0629 \u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
        info: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A",
        registry: "\u0627\u0644\u0633\u062C\u0644",
        clientInfo: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u0645\u064A\u0644",
        chronology: "\u0627\u0644\u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
        addNote: "\u0625\u0636\u0627\u0641\u0629 \u0645\u0644\u0627\u062D\u0638\u0629",
        enterNote: "\u0623\u062F\u062E\u0644 \u0645\u0644\u0627\u062D\u0638\u0629...",
        addBtn: "\u0625\u0636\u0627\u0641\u0629",
        documentsLabel: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        createBtn: "+ \u0625\u0646\u0634\u0627\u0621",
        noDocs: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        hearingSchedule: "\u062C\u062F\u0648\u0644 \u0627\u0644\u062C\u0644\u0633\u0627\u062A",
        caseStatus: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0642\u0636\u064A\u0629",
        electronicFiling: "\u0627\u0644\u0625\u064A\u062F\u0627\u0639 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        idCode: "\u0631\u0645\u0632 \u0627\u0644\u0647\u0648\u064A\u0629:",
        director: "\u0627\u0644\u0645\u062F\u064A\u0631:",
        addressLabel: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646:",
        statusLabel: "\u0627\u0644\u062D\u0627\u0644\u0629:",
        registeredProperty: "\u0627\u0644\u0645\u0645\u062A\u0644\u0643\u0627\u062A \u0627\u0644\u0645\u0633\u062C\u0644\u0629",
        extractLabel: "\u0645\u0633\u062A\u062E\u0631\u062C",
        recentChanges: "\u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629",
        yourFieldChanges: "\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0641\u064A \u0645\u062C\u0627\u0644\u0643",
        newLabel: "\u062C\u062F\u064A\u062F",
        notifications: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
        clientsTitle: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        clientsSearchPlaceholder: "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0639\u0645\u0644\u0627\u0621...",
        clientsProfile: "\u0645\u0644\u0641 \u0627\u0644\u0639\u0645\u064A\u0644",
        clientsContactLabel: "\u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
        clientsInvoiceHistory: "\u0633\u062C\u0644 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        clientsUnpaid: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639",
        clientsPaid: "\u0645\u062F\u0641\u0648\u0639",
        clientsPortalInvite: "\u0625\u0631\u0633\u0627\u0644 \u0631\u0627\u0628\u0637 \u0627\u0644\u0648\u0635\u0648\u0644 \u0644\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0639\u0645\u064A\u0644",
        dashTodayBookings: "\u062D\u062C\u0648\u0632\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
        dashUnpaid: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639",
        dashOverdue: "\u0645\u062A\u0623\u062E\u0631",
        dashAiGenerations: "\u062A\u0648\u0644\u064A\u062F\u0627\u062A \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        dashTodaysBookings: "\u062D\u062C\u0648\u0632\u0627\u062A \u0627\u0644\u064A\u0648\u0645",
        dashConfirmed: "\u0645\u0624\u0643\u062F",
        dashRecentCases: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627 \u0627\u0644\u0623\u062E\u064A\u0631\u0629",
        dashNewBooking: "+ \u062D\u062C\u0632 \u062C\u062F\u064A\u062F",
        dashNewCase: "+ \u0642\u0636\u064A\u0629 \u062C\u062F\u064A\u062F\u0629",
        dashAiDocument: "\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        docsTitle: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        docsCreate: "\u0625\u0646\u0634\u0627\u0621",
        docsExisting: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
        docsFiles: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A",
        docsOcrScan: "\u0645\u0633\u062D \u0636\u0648\u0626\u064A",
        docsOcrTitle: "\u0627\u0644\u0645\u0633\u062D \u0627\u0644\u0636\u0648\u0626\u064A OCR",
        docsUploadText: "\u0631\u0641\u0639 \u0635\u0648\u0631\u0629 \u0645\u0633\u062A\u0646\u062F \u0623\u0648 PDF",
        docsScanning: "\u062C\u0627\u0631\u064A \u0645\u0633\u062D \u0627\u0644\u0645\u0633\u062A\u0646\u062F...",
        docsFile: "\u0645\u0644\u0641",
        docsPages: "\u0635\u0641\u062D\u0627\u062A",
        docsLanguage: "\u0627\u0644\u0644\u063A\u0629",
        docsGeorgian: "\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        docsAddToCase: "\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0636\u064A\u0629",
        docsCopy: "\u0646\u0633\u062E",
        docsRescan: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u0633\u062D",
        docsClaim: "\u0645\u0637\u0627\u0644\u0628\u0629",
        docsPowerOfAttorney: "\u062A\u0648\u0643\u064A\u0644 \u0631\u0633\u0645\u064A",
        docsNotification: "\u0625\u0634\u0639\u0627\u0631",
        docsContractReview: "\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0639\u0642\u062F",
        docsFreeForm: "\u0635\u064A\u063A\u0629 \u062D\u0631\u0629",
        docsParty1: "\u0627\u0644\u0637\u0631\u0641 1",
        docsNameCompany: "\u0627\u0644\u0627\u0633\u0645 / \u0627\u0644\u0634\u0631\u0643\u0629",
        docsParty2: "\u0627\u0644\u0637\u0631\u0641 2",
        docsDate: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        docsAdditionalInfo: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629",
        docsGenerating: "\u062C\u0627\u0631\u064A \u0627\u0644\u0625\u0646\u0634\u0627\u0621...",
        docsGenerate: "\u0625\u0646\u0634\u0627\u0621",
        docsGeneratedDocument: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u0645\u064F\u0646\u0634\u0623",
        docsEmptyState: "\u0633\u064A\u0638\u0647\u0631 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0627\u0644\u0645\u064F\u0646\u0634\u0623 \u0647\u0646\u0627",
        docsShowDemo: "\u0639\u0631\u0636 \u0645\u0633\u062A\u0646\u062F \u062A\u062C\u0631\u064A\u0628\u064A",
        docsDownload: "\u062A\u0646\u0632\u064A\u0644",
        docsSend: "\u0625\u0631\u0633\u0627\u0644",
        docsCreatedDocuments: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0645\u064F\u0646\u0634\u0623\u0629",
        docsSearch: "\u0628\u062D\u062B...",
        docsFileManager: "\u0645\u062F\u064A\u0631 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
        docsUpload: "\u0631\u0641\u0639",
        docsCases: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        docsTemplates: "\u0627\u0644\u0642\u0648\u0627\u0644\u0628",
        docsRecentFiles: "\u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u062D\u062F\u064A\u062B\u0629",
        billingTitle: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
        billingNewInvoice: "\u0641\u0627\u062A\u0648\u0631\u0629 \u062C\u062F\u064A\u062F\u0629",
        billingTotalSent: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u064F\u0631\u0633\u0644",
        billingPaid: "\u0645\u062F\u0641\u0648\u0639",
        billingUnpaid: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639",
        billingOverdue: "\u0645\u062A\u0623\u062E\u0631",
        billingActive: "\u0646\u0634\u0637",
        billingClientStatus: "\u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0645\u064A\u0644",
        billingEInvoice: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
        billingAutoCheck: "\u062A\u062D\u0642\u0642 \u062A\u0644\u0642\u0627\u0626\u064A",
        billingSettings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u2192",
        billingInvoice: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
        billingClient: "\u0627\u0644\u0639\u0645\u064A\u0644",
        billingCase: "\u0627\u0644\u0642\u0636\u064A\u0629",
        billingAmount: "\u0627\u0644\u0645\u0628\u0644\u063A",
        billingDue: "\u0645\u0633\u062A\u062D\u0642",
        billingStatus: "\u0627\u0644\u062D\u0627\u0644\u0629",
        aiTitle: "\u0645\u0633\u0627\u0639\u062F AI",
        aiPowered: "\u0645\u062F\u0639\u0648\u0645 \u0628\u0648\u0627\u0633\u0637\u0629 AI",
        aiDraftDocs: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        aiContractAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F",
        aiLegalResearch: "\u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A",
        aiDraftAvailable: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0645\u062A\u0627\u062D\u0629 \u0641\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        aiGoToDocuments: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u2192",
        aiPasteContract: "\u0627\u0644\u0635\u0642 \u0646\u0635 \u0627\u0644\u0639\u0642\u062F \u0647\u0646\u0627...",
        aiAnalyze: "\u062A\u062D\u0644\u064A\u0644",
        aiReanalyze: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0644\u064A\u0644",
        aiParties: "\u0627\u0644\u0623\u0637\u0631\u0627\u0641",
        aiObligations: "\u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
        aiRiskFactors: "\u0639\u0648\u0627\u0645\uFFFD\uFFFD \u0627\u0644\u062E\u0637\u0631",
        aiDeadlines: "\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
        aiRecommendations: "\u0627\u0644\u062A\u0648\u0635\u064A\u0627\u062A",
        aiAskQuestion: "\u0627\u0637\u0631\u062D \u0633\u0624\u0627\u0644\u0627\u064B \u062D\u0648\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u062C\u0648\u0631\u062C\u064A",
        aiLegalResearchTitle: "\u0627\u0644\u0628\u062D\u062B \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0639\u0628\u0631 AI",
        aiAskPlaceholder: "\u0627\u0637\u0631\u062D \u0633\u0624\u0627\u0644\u0627\u064B...",
        aiSend: "\u0625\u0631\u0633\u0627\u0644",
        pitchTagline: "SaaS \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        pitchSubtitle: "\u0627\u0644\u062D\u062C\u0632 \xb7 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \xb7 AI \u2014 \u0644\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        pitchCta: "\u0627\u0643\u062A\u0634\u0641 \u0627\u0644\u0641\u0631\u0635\u0629 \u2192",
        pitchMarketLabel: "// \u0627\u0644\u0633\u0648\u0642",
        pitchMarketTitle: "+5000 \u0645\u062D\u0627\u0645\u064D \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        pitchPopulation: "\u062A\u0639\u062F\u0627\u062F \u0627\u0644\u0633\u0643\u0627\u0646",
        pitchTbilisi: "\u062A\u0628\u0644\u064A\u0633\u064A",
        pitchConcentrated: "\u0633\u0648\u0642 \u0645\u0631\u0643\u0651\u0632",
        pitchZeroCompetitor: "\u0645\u0646\u0627\u0641\u0633 SaaS \u0645\u062D\u0644\u064A",
        pitchProblemLabel: "// \u0627\u0644\u0645\u0634\u0643\u0644\u0629",
        pitchProblemTitle: "\u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u0644\u0627 \u062A\u0632\u0627\u0644 \u062A\u0639\u062A\u0645\u062F \u0639\u0644\u0649 WhatsApp \u0648 Excel",
        pitchNoBooking: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0638\u0627\u0645 \u0644\u062D\u062C\u0632 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        pitchManualCases: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0642\u0636\u0627\u064A\u0627 \u064A\u062F\u0648\u064A\u0627\u064B",
        pitchNoAiTools: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062F\u0648\u0627\u062A AI \u0628\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        pitchCapabilitiesLabel: "// \u0627\u0644\u0642\u062F\u0631\u0627\u062A",
        pitchOnePlatform: "\u0645\u0646\u0635\u0629 \u0648\u0627\uFFFD\uFFFD\u062F\u0629. \u062B\u0644\u0627\u062B \u0631\u0643\u0627\u0626\u0632.",
        pitchProductLabel: "// \u0627\u0644\u0645\u0646\u062A\u062C",
        pitchProductTitle: "\u0643\u0644 \u0634\u064A\u0621 \u0641\u064A \u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629",
        pitchIntegrationsLabel: "// \u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
        pitchIntegrationsTitle: "\u0623\u062A\u0645\u062A\u0629\u060C \u0644\u0627 \u0639\u0645\u0644 \u064A\u062F\u0648\u064A",
        pitchPublicRegistry: "\u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0639\u0627\u0645",
        pitchCalendarSyncTitle: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
        pitchOcrTitle: "OCR \u0648\u0627\u0644\u0645\u0633\u062D \u0627\u0644\u0636\u0648\u0626\u064A",
        pitchPlansLabel: "// \u0627\u0644\u062E\u0637\u0637",
        pitchPlansTitle: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0644\u0644\u0633\u0648\u0642 \u0627\u0644\u062C\u0648\u0631\u062C\u064A",
        pitchTierStarter: "\u0623\u0633\u0627\u0633\u064A",
        pitchMostPopular: "\u0627\u0644\u0623\u0643\u062B\u0631 \u0634\u064A\u0648\u0639\u0627\u064B",
        pitchTierPro: "\u0627\u062D\u062A\u0631\u0627\u0641\u064A",
        pitchTierBusiness: "\u0623\u0639\u0645\u0627\u0644",
        pitchTierEnterprise: "\u0627\u0644\u0634\u0631\u0643\u0627\u062A",
        pitchRevenueLabel: "// \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
        pitchRevenueTitle: "\u0625\u0645\u0643\u0627\u0646\u0627\u062A \u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A",
        pitchFinanceLabel: "// \u0627\u0644\u0634\u0624\u0648\u0646 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
        pitchFinanceTitle: "\u0627\u0642\u062A\u0635\u0627\u062F\u064A\u0627\u062A \u0627\u0644\u0648\u062D\u062F\u0629",
        pitchTimeLabel: "// \u0627\u0644\u062A\u0648\u0642\u064A\u062A",
        pitchTimeTitle: "\u0627\u0644\u062A\u0648\u0642\u064A\u062A \u0645\u0646\u0627\u0633\u0628",
        pitchPrivacyLabel: "// \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
        pitchPrivacyTitle: "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u0623\u0648\u0644\u0648\u064A\u0629",
        pitchCtaLabel: "// \u0646\u0628\u0646\u064A \u0645\u0639\u0627\u064B",
        pitchCtaTitle: "\u062F\u0639\u0648\u0646\u0627 \u0646\u0628\u0646\u064A \u0627\u0644\u0628\u0646\u064A\u0629 \u0627\u0644\u062A\u062D\u062A\u064A\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        pitchCtaLink: "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u2192",
        pitchPerMonth: "\u0634\u0647\u0631",
        settingsTitle: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
        settingsTabProfile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
        settingsTabFirm: "\u0627\u0644\u0634\u0631\u0643\u0629",
        settingsTabTeam: "\u0627\u0644\u0641\u0631\u064A\u0642",
        settingsTabNotifications: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
        settingsUploadPhoto: "\u0631\u0641\u0639 \u0635\u0648\u0631\u0629",
        settingsSave: "\u062D\u0641\u0638",
        settingsFirmAddress: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
        settingsFirmRegNumber: "\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
        settingsPublicBookingUrl: "\u0631\u0627\u0628\u0637 \u0627\u0644\u062D\u062C\u0632 \u0627\u0644\u0639\u0627\u0645",
        settingsTeamMembers: "\u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0641\u0631\u064A\u0642",
        settingsInvite: "+ \u062F\u0639\u0648\u0629",
        settingsRoleOwner: "\u0627\u0644\u0645\u0627\u0644\u0643",
        settingsRoleLawyer: "\u0645\u062D\u0627\u0645\u064D",
        settingsNotifyTitle: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
        settingsToggleOn: "\u0645\u0641\u0639\u0644",
        settingsToggleOff: "\u0645\u0639\u0637\u0644",
        loginSubtitle: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643",
        loginLawyer: "\u0645\u062D\u0627\u0645\u064D",
        loginClient: "\u0639\u0645\u064A\u0644",
        loginPassword: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631",
        loginSubmit: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u2192",
        loginCaseNumber: "\u0631\u0642\u0645 \u0627\u0644\u0642\u0636\u064A\u0629",
        loginBackLink: "\u2190 \u0627\u0644\u0639\u0648\u062F\u0629",
        portalLogout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
        portalWelcome: "\u0645\u0631\u062D\u0628\u0627\u064B\u060C",
        portalActiveCases: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627 \u0627\u0644\u0646\u0634\u0637\u0629",
        portalDocuments: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        portalMessages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
        portalSend: "\u0625\u0631\u0633\u0627\u0644",
        clientDashNavCases: "\u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        clientDashNavInvoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        clientDashNavDocuments: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        clientDashNavMessages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
        clientDashLogout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
        clientDashWelcome: "\u0645\u0631\u062D\u0628\u0627\u064B\u060C",
        clientDashDownload: "\u062A\u0646\u0632\u064A\u0644",
        clientDashSend: "\u0625\u0631\u0633\u0627\u0644",
        findLawyer: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u062D\u0627\u0645\u064D",
        lawyersSearchSub: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0623\u0643\u062B\u0631 \u0645\u0646 5,700 \u0645\u062D\u0627\u0645\u064D \u0645\u0633\u062C\u0644 \u0641\u064A \u0646\u0642\u0627\u0628\u0629 \u0627\u0644\u0645\u062D\u0627\u0645\u064A\u0646 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        searchBtn: "\u0628\u062D\u062B",
        viewAll: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
        lawyerPortal: "\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0645\u062D\u0627\u0645\u064A",
        aiFeature: "\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A",
        aiChip1: "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0639\u0642\u062F \u0627\u0644\u062A\u0648\u062B\u064A\u0642\u064A",
        aiChip1Question: "\u0645\u0627 \u0647\u064A \u0634\u0631\u0648\u0637 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0639\u0642\u062F \u0627\u0644\u062A\u0648\u062B\u064A\u0642\u064A\u061F",
        aiChip2: "\u0627\u0644\u0645\u0627\u062F\u0629 317 \u0645\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A",
        aiChip2Question: "\u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0645\u0627\u062F\u0629 317 \u0645\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A",
        aiChip3: "\u0628\u0637\u0644\u0627\u0646 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629",
        aiChip3Question: "\u0627\u0644\u0645\u0645\u0627\u0631\u0633\u0629 \u0627\u0644\u0642\u0636\u0627\u0626\u064A\u0629 \u062D\u0648\u0644 \u0628\u0637\u0644\u0627\u0646 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0641\u064A \u0627\u0644\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u062B\u0644\u0627\u062B \u0627\u0644\u0645\u0627\u0636\u064A\u0629",
        aiDeadlinesData: "\u2022 \u0628\u062F\u0621 \u0627\u0644\u062E\u062F\u0645\u0629: 10 \u0623\u064A\u0627\u0645 \u0645\u0646 \u0627\u0644\u0639\u0642\u062F\n\u2022 \u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0623\u0648\u0644\u0649: 1 \u0623\u0628\u0631\u064A\u0644 2026\n\u2022 \u0645\u062F\u0629 \u0627\u0644\u0639\u0642\u062F: 12 \u0634\uFFFD\uFFFD\u0631\u0627\u064B",
        aiEmptyChatSub: "\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u2014 \u0627\u0637\u0631\u062D \u0633\u0624\u0627\u0644\u0627\u064B \u0648\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0625\u062C\u0627\u0628\u0629 \u062D\u0648\u0644 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u062C\u0648\u0631\u062C\u064A",
        aiObligationsData: "1. \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u062E\u062F\u0645\u0629 \u062E\u0644\u0627\u0644 30 \u064A\u0648\u0645\u0627\u064B \u062A\u0642\u0648\u064A\u0645\u064A\u0627\u064B\n2. \u0627\u0644\u062F\u0641\u0639 \u062E\u0644\u0627\u0644 15 \u064A\u0648\u0645 \u0639\u0645\u0644\n3. \u0627\u0644\u0633\u0631\u064A\u0629 \u0644\u0645\u062F\u0629 3 \u0633\u0646\u0648\u0627\u062A",
        aiPartiesData: "\u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u0623\u0648\u0644: Barateli & Partners LLC\n\u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u062B\u0627\u0646\u064A: Delta Group LLC",
        aiRecommendationsData: "1. \u0625\u0636\u0627\u0641\u0629 \u0634\u0631\u0637 \u062C\u0632\u0627\u0626\u064A (\u0627\u0644\u0645\u0627\u062F\u0629 417 \u0645\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A)\n2. \u062A\u062D\u062F\u064A\u062F \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0645\u0646\u0627\u0632\u0639\u0627\u062A \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u062D\u0643\u064A\u0645\n3. \u062A\u0648\u0633\u064A\u0639 \u0634\u0631\u0637 \u0627\u0644\u0642\u0648\u0629 \u0627\u0644\u0642\u0627\u0647\u0631\u0629",
        aiRisksData: "\u2022 \u063A\u0631\u0627\u0645\u0629 \u0627\u0644\u062A\u0623\u062E\u064A\u0631 \u0641\u064A \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629\n\u2022 \u0622\u0644\u064A\u0629 \u062A\u0633\u0648\u064A\u0629 \u0627\u0644\u0645\u0646\u0627\u0632\u0639\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u062F\u062F\u0629\n\u2022 \u0634\u0631\u0637 \u0627\u0644\u0642\u0648\u0629 \u0627\u0644\u0642\u0627\u0647\u0631\u0629 \u0644\u0627 \u064A\u063A\u0637\u064A \u0627\u0644\u062C\u0648\u0627\u0626\u062D",
        address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
        addressVal: "\u062A\u0628\u0644\u064A\u0633\u064A\u060C \u062A\u0634\u0627\u0641\u062A\u0634\u0627\u0641\u0627\u062F\u0632\u0647 12",
        appleCalendar: "\u062A\u0642\u0648\u064A\u0645 Apple",
        billingClient1: "\u062C\u064A\u0648\u0631\u062C\u064A \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A",
        billingClient2: "\u0645\u0631\u064A\u0645 \u0643\u0641\u0627\u0631\u0627\u062A\u0633\u062E\u064A\u0644\u064A\u0627",
        billingClient3: "\u0644\u064A\u0644\u0627 \u063A\u0648\u063A\u064A\u064A\u0627\u0634\u0641\u064A\u0644\u064A",
        billingClientName: 'Delta Group LLC',
        billingDue1: "25 \u0645\u0627\u0631\u0633",
        billingDue2: "15 \u0645\u0627\u0631\u0633",
        billingDue3: "10 \u0645\u0627\u0631\u0633",
        billingEmailNotification: "\u0625\u0634\u0639\u0627\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        billingLastCheck: "\u0622\u062E\u0631 \u0641\u062D\u0635: \u0627\u0644\u064A\u0648\u0645",
        billingNoDebt: "\u0644\u0627 \u062A\u0648\u062C\u062F \u062F\u064A\u0648\u0646 \u0645\u0633\u062A\u062D\u0642\u0629",
        billingRsBanner: "\u062A\u0643\u0627\u0645\u0644 rs.ge \u2014 \u062F\u064A\u0648\u0646 \u0636\u0631\u0627\u0626\u0628 \u0627\u0644\u0639\u0645\u064A\u0644 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u0628\u0646\u0642\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
        billingRsTaxSystem: "rs.ge \u2014 \u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0636\u0631\u064A\u0628\u064A",
        billingStatusPaid: "\u0645\u062F\u0641\u0648\u0639",
        billingStatusSent: "\u0645\u064F\u0631\u0633\u0644",
        billingViewFull: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u2192",
        billingViewInvoices: "\u0639\u0631\u0636 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u2192",
        billingWeeklyEnabled: "\u0645\u064F\u0641\u0639\u0651\u0644 \u0623\u0633\u0628\u0648\u0639\u064A\u0627\u064B",
        caseRow1Title: "#2024-047 \u2014 \u062C\u064A\u0648\u0631\u062C\u064A \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A",
        caseRow2Title: "#2024-046 \u2014 \u0645\u0631\u064A\u0645 \u0643\u0641\u0627\u0631\u0627\u062A\u0633\u062E\u064A\u0644\u064A\u0627",
        caseRow3Title: "#2024-045 \u2014 \u0644\u064A\u0644\u0627 \u063A\u0648\u063A\u064A\u0627\u0633\u0641\uFFFD\uFFFD\u0644\u064A",
        change1Date: "15 \u0645\u0627\u0631\u0633 \u2014 \u0633\u0627\u0631\u064A \u0645\u0646: 1 \u0623\u0628\u0631\u064A\u0644",
        change1Desc: "\u062A\u0645\u062A \u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0645\u0646 30 \u0625\u0644\u0649 45 \u064A\u0648\u0645\u0627\u064B",
        change1Name: "\u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A \u2014 \u0645\u0627\u062F\u0629 316",
        change2Date: "12 \u0645\u0627\u0631\u0633 \u2014 \u0633\u0627\u0631\u064A \u0645\u0646: 1 \u0645\u0627\u064A\u0648",
        change2Desc: "\u0645\u0648\u0639\u062F \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0645\u0646 14 \u0625\u0644\u0649 21 \u064A\u0648\u0645\u0627\u064B",
        change2Name: "\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u2014 \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
        claimAccepted: "\u062A\u0645 \u0642\u0628\u0648\u0644 \u0627\u0644\u062F\u0639\u0648\u0649 \u2014 17 \u0645\u0627\u0631\u0633",
        claimFiled: "\u062A\u0645 \u0631\u0641\u0639 \u0627\u0644\u062F\u0639\u0648\u0649 \u2014 15 \u0645\u0627\u0631\u0633",
        claimFiledDoc: "\u0627\u0644\u062F\u0639\u0648\u0649 \u2014 \u0631\u064F\u0641\u0639\u062A",
        clientName1: "\u062C\u064A\u0648\u0631\u062C\u064A \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A",
        clientName2: "\u0645\u0631\u064A\u0645 \u0643\u0641\u0627\u0631\u0627\u062A\u0633\u062E\u064A\u0644\u064A\u0627",
        clientName3: "\u0644\u064A\u0644\u0627 \u063A\u0648\u063A\u064A\u0627\u0633\u0641\u064A\u0644\u064A",
        companyExtractLoaded: "\u0645\u0633\u062A\u062E\u0631\u062C \u0627\u0644\u0634\u0631\u0643\u0629 \u2014 \u062A\u0645 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
        companyName: "\u0645\u062C\u0645\u0648\u0639\u0629 \u062F\u0644\u062A\u0627 \u0630.\u0645.\u0645",
        clientsActiveCases1: "\u0642\u0636\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0646\u0634\u0637\u0629",
        clientsActiveCases2: "\u0642\u0636\u064A\u0629 \u0648\u0627\u062D\u062F\u0629 \u0646\u0634\u0637\u0629",
        clientsActiveCases3: "0 \u0642\u0636\u0627\u064A\u0627 \u0646\u0634\u0637\u0629",
        clientsAvatar1: 'GM',
        clientsAvatar2: 'MK',
        clientsAvatar3: 'LG',
        clientsCaseLink1: "#2024-047 \u2014 \u0645\u062F\u0646\u064A",
        clientsCaseLink2: "#2024-046 \u2014 \u0625\u062F\u0627\u0631\u064A",
        clientsContact1: "599123456 \xb7 g.mamulasvili@gmail.com",
        clientsContact2: "577234567 \xb7 mari.k@mail.ru",
        clientsContact3: "571456789 \xb7 lela.g@inbox.ge",
        clientsNoCases: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0636\u0627\u064A\u0627 \u0646\u0634\u0637\u0629",
        clientsPaid1: "\u062A\u0645 \u062F\u0641\u0639 \u20BE2,400",
        clientsPaid2: "\u062A\u0645 \u062F\u0641\u0639 \u20BE800",
        clientsPaid3: "\u062A\u0645 \u062F\u0641\u0639 \u20BE1,800",
        dashAlertText: "\u0642\u0636\u064A\u062A\u0627\u0646 \u0645\u062A\u0623\u062E\u0631\u062A\u0627\u0646 \u0648\u0641\u0648\u0627\u062A\u064A\u0631 \u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629 \u0628\u0642\u064A\u0645\u0629 \u20BE1,840",
        dashBooking1Time: "10:00 \u2014 \u0645\u062F\u0646\u064A",
        dashBooking2Time: "11:30 \u2014 \u0625\u062F\u0627\u0631\u064A",
        dashBooking3Time: "14:00 \u2014 \u062C\u0646\u0627\u0626\u064A",
        dashCaseMeta1: "\u0645\u062F\u0646\u064A \xb7 18 \u0645\u0627\u0631\u0633",
        dashCaseMeta2: "\u0625\u062F\u0627\u0631\u064A \xb7 17 \u0645\u0627\u0631\u0633",
        dashCaseMeta3: "\u062C\u0646\u0627\u0626\u064A \xb7 15 \u0645\u0627\u0631\u0633",
        dashClient3Name: "\u062F\u064A\u0641\u064A\u062A \u062A\u0634\u064A\u0643\u0648\u0641\u0627\u0646\u064A",
        dashDate: "18 \u0645\u0627\u0631\u0633 2026",
        dashGreeting: "\u0645\u0631\u062D\u0628\u0627\u064B\u060C \u0646\u064A\u0646\u0648",
        dateMar15: "15 \u0645\u0627\u0631\u0633",
        dateMar17: "17 \u0645\u0627\u0631\u0633",
        dateMar18: "18 \u0645\u0627\u0631\u0633",
        disabledStatus: "\u2014 \u0645\u064F\u0639\u0637\u0651\u0644",
        docsContractScanPdf: 'contract_scan.pdf',
        docsDemoClaimText: "\u062C\u0648\u0631\u062C\u064A\u0627\u060C \u062A\u0628\u0644\u064A\u0633\u064A\n\n\u062F\u0639\u0648\u0649\n\n\u0627\u0644\u0645\u062F\u0639\u064A: \u0634\u0631\u0643\u0629 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A \u0648\u0634\u0631\u0643\u0627\u0647 \u0630.\u0645.\u0645\n\u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647: \u0645\u062C\u0645\u0648\u0639\u0629 \u062F\u0644\u062A\u0627 \u0630.\u0645.\u0645\n\n\u0627\u0644\u0648\u0642\u0627\u0626\u0639:\n\n\u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0649\u060C \u064A\u0637\u0644\u0628 \u0627\u0644\u0645\u062F\u0639\u064A \u0645\u0646 \u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647 \u0627\u0644\u0648\u0641\u0627\u0621 \u0628\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A\u0647.\n\n\u0627\u0644\u0637\u0644\u0628\u0627\u062A:\n\n1. \u0625\u0644\u0632\u0627\u0645 \u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647 \u0628\u062F\u0641\u0639 12,500 GEL\n2. \u0641\u0631\u0636 \u063A\u0631\u0627\u0645\u0629 \u0642\u062F\u0631\u0647\u0627 1,875 GEL\n3. \u062A\u0639\u0648\u064A\u0636 \u0645\u0635\u0627\u0631\u064A\u0641 \u0627\u0644\u0645\u062D\u0643\u0645\u0629\n\n\u0627\u0644\u062A\u0627\u0631\u064A\u062E: 18 \u0645\u0627\u0631\u0633 2026\n\u0627\u0644\u062A\u0648\u0642\u064A\u0639: ________________",
        docsDocument: "\u0645\u0633\u062A\u0646\u062F",
        docsFile1Meta: "PDF \xb7 124 KB \xb7 15 \u0645\u0627\u0631\u0633 2026",
        docsFile1Name: "\u062F\u0639\u0648\u0649 - \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A.pdf",
        docsFile2Meta: "PDF \xb7 89 KB \xb7 12 \u0645\u0627\u0631\u0633 2026",
        docsFile2Name: "\u062A\u0648\u0643\u064A\u0644 - \u0643\u0641\u0627\u0631\u0627\u062A\u0633\u062E\u064A\u0644\u064A\u0627.pdf",
        docsFile3Meta: "DOCX \xb7 45 KB \xb7 10 \u0645\u0627\u0631\u0633 2026",
        docsFile3Name: "\u0639\u0642\u062F \u2116147.docx",
        docsFile4Meta: "JPG \xb7 1.2 MB \xb7 8 \u0645\u0627\u0631\u0633 2026",
        docsFile4Name: "\u0646\u0633\u062E\u0629 \u0627\u0644\u0647\u0648\u064A\u0629 - \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A.jpg",
        docsFile5Meta: "PDF \xb7 67 KB \xb7 5 \u0645\u0627\u0631\u0633 2026",
        docsFile5Name: "\u0625\u0634\u0639\u0627\u0631 - \u063A\u0648\u063A\u064A\u0627\u0633\u0641\u064A\u0644\u064A.pdf",
        docsFolder1Count: "3 \u0645\u0644\u0641\u0627\u062A",
        docsFolder1Name: "#2024-047 \u0645\u0627\u0645\u0648\u0644\u0627\u0634\u0641\u064A\u0644\u064A",
        docsFolder2Count: "\u0645\u0644\u0641\u0627\u0646",
        docsFolder2Name: "#2024-046 \u0643\u0641\u0627\u0631\u0627\u062A\u0633\u062E\u064A\u0644\u064A\u0627",
        docsFolder3Count: "\u0645\u0644\u0641 \u0648\u0627\u062D\u062F",
        docsFolder3Name: "#2024-045 \u063A\u0648\u063A\u064A\u0627\u0633\u0641\u064A\u0644\u064A",
        docsFolder4Count: "5 \u0645\u0644\u0641\u0627\u062A",
        docsFormatAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u062A\u0646\u0633\u064A\u0642...",
        docsFreeText: "\u0646\u0635 \u062D\u0631...",
        docsGeneratedClaimText: "\u062C\u0648\u0631\u062C\u064A\u0627\u060C \u062A\u0628\u0644\u064A\u0633\u064A\n\n\u062F\u0639\u0648\u0649\n\n\u0627\u0644\u0645\u062F\u0639\u064A: [\u0627\u0644\u0637\u0631\u0641 1]\n\u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647: [\u0627\u0644\u0637\u0631\u0641 2]\n\n\u0627\u0644\u0648\u0642\u0627\u0626\u0639:\n\n\u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0647 \u0627\u0644\u062F\u0639\u0648\u0649\u060C \u064A\u0637\u0644\u0628 \u0627\u0644\u0645\u062F\u0639\u064A \u0645\u0646 \u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647 \u0627\u0644\u0648\u0641\u0627\u0621 \u0628\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A\u0647 \u0628\u0645\u0648\u062C\u0628 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A \u0627\u0644\u062C\u0648\u0631\u062C\u064A.\n\n\u0627\u0644\u0623\u0633\u0627\u0633 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A:\n\n\u0639\u0645\u0644\u0627\u064B \u0628\u0627\u0644\u0645\u0627\u062F\u0629 316 \u0645\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u0645\u062F\u0646\u064A\u060C \u064A\u062C\u0628 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645\u0627\u062A \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.\n\n\u0627\u0644\u0637\u0644\u0628\u0627\u062A:\n\n\u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u0645\u0627 \u0633\u0628\u0642\u060C \u064A\u0637\u0644\u0628 \u0627\u0644\u0645\u062F\u0639\u064A \u0645\u0646 \u0627\u0644\u0645\u062D\u0643\u0645\u0629 \u0625\u0644\u0632\u0627\u0645 \u0627\u0644\u0645\u062F\u0639\u0649 \u0639\u0644\u064A\u0647.\n\n\u0627\u0644\u062A\u0627\u0631\u064A\u062E: 18 \u0645\u0627\u0631\u0633 2026\n\u0627\u0644\u062A\u0648\u0642\u064A\u0639: ________________",
        docsGeorgianSymbols: "\u062D\u0631\u0648\u0641 \u062C\u0648\u0631\u062C\u064A\u0629",
        docsOcrNote: "\u0645\u0633\u062D OCR \u2014 \u0631\u0642\u0645\u0646\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0629 \u0644\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0648\u0631\u0642\u064A\u0629\u060C \u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0644\u0643\u062A\u0627\u0628\u0629 \u0627\u0644\u064A\u062F\u0648\u064A\u0629",
        docsOcrResultText: '\u0639\u0642\u062F \u0631\u0642\u0645 147\n\n\u062A\u0628\u0644\u064A\u0633\u064A\u060C 10 \u0645\u0627\u0631\u0633 2026\n\n\u0645\u0646 \u0646\u0627\u062D\u064A\u0629\u060C \u0634\u0631\u0643\u0629 Barateli & Partners LLC (\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 404123456)\u060C \u0645\u0645\u062B\u0644\u0629 \u0628\u0645\u062F\u064A\u0631\u062A\u0647\u0627 Nino Barateli (\u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0641\u064A\u0645\u0627 \u064A\u0644\u064A \u0628\u0640 "\u0627\u0644\u0645\u0642\u0627\u0648\u0644") \u0648\u0645\u0646 \u0646\u0627\u062D\u064A\u0629 \u0623\u062E\u0631\u0649\u060C \u0634\u0631\u0643\u0629 Delta Group LLC (\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 404789012)\u060C \u0645\u0645\u062B\u0644\u0629 \u0628\u0645\u062F\u064A\u0631\u0647\u0627 Giorgi Mamulashvili (\u064A\u0634\u0627\u0631 \u0625\u0644\u064A\u0647 \u0641\u064A\u0645\u0627 \u064A\u0644\u064A \u0628\u0640 "\u0627\u0644\u0639\u0645\u064A\u0644")\u060C \u0623\u0628\u0631\u0645\u0627 \u0647\u0630\u0627 \u0627\u0644\u0639\u0642\u062F:\n\n\u0627\u0644\u0645\u0627\u062F\u0629 1. \u0645\u0648\u0636\u0648\u0639 \u0627\u0644\u0639\u0642\u062F\n1.1. \u064A\u062A\u0639\u0647\u062F \u0627\u0644\u0645\u0642\u0627\u0648\u0644 \u0628\u062A\u0642\u062F\u064A\u0645 \u062E\u062F\u0645\u0627\u062A \u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0644\u0644\u0639\u0645\u064A\u0644.\n1.2. \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062E\u062F\u0645\u0629 \u0647\u064A 12,500 (\u0627\u062B\u0646\u0627 \u0639\u0634\u0631 \u0623\u0644\u0641\u0627\u064B \u0648\u062E\u0645\u0633\u0645\u0627\u0626\u0629) GEL.',
        docsOcrSuccess: "\u062A\u0645 \u0627\u0644\u062A\u0639\u0631\u0641 \u0628\u0646\u062C\u0627\u062D \u2014 \u062F\u0642\u0629 98.5%",
        docsRow1Meta: "#2024-047 \xb7 \u0645\u0637\u0627\u0644\u0628\u0629 \xb7 15 \u0645\u0627\u0631\u0633",
        docsRow1Name: "\u0645\u0637\u0627\u0644\u0628\u0629 - Mamulashvili.pdf",
        docsRow2Meta: "#2024-046 \xb7 \u062A\u0648\u0643\u064A\u0644 \u0631\u0633\u0645\u064A \xb7 12 \u0645\u0627\u0631\u0633",
        docsRow2Name: "\u062A\u0648\u0643\u064A\u0644 \u0631\u0633\u0645\u064A - Kvaratskhelia.pdf",
        docsRow3Meta: "#2024-045 \xb7 \u0625\u0634\u0639\u0627\u0631 \xb7 8 \u0645\u0627\u0631\u0633",
        docsRow3Name: "\u0625\u0634\u0639\u0627\u0631 - Gogiashvili.pdf",
        docsTextRecognition: "\u0627\u0644\u062A\u0639\u0631\u0641 \u0639\u0644\u0649 \u0627\u0644\u0646\u0635",
        docsUploadFormats: "JPG, PNG, PDF \u2014 \u0628\u062D\u062F \u0623\u0642\u0635\u0649 10MB",
        docsUploadSub: "\u0627\u0633\u062D\u0628 \u0645\u0644\u0641\u0627\u064B \u0623\u0648 \u0627\u0646\u0642\u0631 \u0644\u0644\u062A\u062D\u062F\u064A\u062F",
        ecourt: 'ecourt',
        ecourtDesc: "\u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A\u060C \u0648\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062D\u0627\u0644\u0629 \u0627\u0644\u0642\u0636\u064A\u0629 \u0648\u062C\u062F\u0648\u0644 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u2014 \u062F\u0648\u0646 \u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0645\u062D\u0643\u0645\u0629",
        enabledStatus: "\u2713 \u0645\u0641\u0639\u0644",
        evidencePending: "\u0627\u0644\u0623\u062F\u0644\u0629 \u2014 \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        extract: "\u0645\u0633\u062A\u062E\u0631\u062C",
        field1Text: "\u0645\u062F\u0646\u064A: \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0627\u062F\u0629 316",
        field2Text: "\u0645\u062F\u0646\u064A: \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0644\u0644\u0645\u0627\u062F\u0629 259",
        field3Text: "\u0625\u062F\u0627\u0631\u064A: \u0627\u0644\u062E\u062F\u0645\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
        googleCalendar: 'Google Calendar',
        hearingItem1: "\uD83D\uDCC5 22 \u0645\u0627\u0631\u0633\u060C 10:00 \u2014 \u0645\u062D\u0643\u0645\u0629 \u0645\u062F\u064A\u0646\u0629 \u062A\u0628\u0644\u064A\u0633\u064A",
        hearingItem2: "\uD83D\uDCC5 28 \u0645\u0627\u0631\u0633\u060C 14:30 \u2014 \u0645\u062D\u0643\u0645\u0629 \u0627\u0644\u0627\u0633\u062A\u0626\u0646\u0627\u0641",
        loginEmail: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        matsne: 'matsne',
        matsneDesc: "\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u062A\u0634\u0631\u064A\u0639\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u2014 \u0641\u064A \u0645\u062C\u0627\u0644 \u062A\u062E\u0635\u0635\u0643",
        outlook: 'Outlook',
        prepHearing: "\u062C\u0644\u0633\u0629 \u062A\u062D\u0636\u064A\u0631\u064A\u0629 \u2014 22 \u0645\u0627\u0631\u0633",
        propertyApartment: "\u0634\u0642\u0629 \u2014 Vake\u060C 85 \u0645\u062A\u0631 \u0645\u0631\u0628\u0639 \xb7 ~\u20BE180,000",
        propertyCar: "BMW X5 \u2014 2021\u060C AA-123-BB \xb7 ~\u20BE95,000",
        propertyExtractAdded: "\u0645\u0633\u062A\u062E\u0631\u062C \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u2014 \u062A\u0645\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
        registryDesc: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0648\u0627\u0644\u0645\u0645\u062A\u0644\u0643\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u2014 \u0644\u0627 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u064A\u062F\u0648\u064A \u0644\u0644\u0645\u0633\u062A\u062E\u0631\u062C\u0627\u062A",
        timeEntry1Date: "18 \u0645\u0627\u0631\u0633\u060C 10:30",
        timeEntry1Text: "\u062A\u0645 \u0641\u062A\u062D \u0627\u0644\u0642\u0636\u064A\u0629\u060C \u0648\u0627\u0643\u062A\u0645\u0644\u062A \u0627\u0644\u0627\u0633\u062A\u0634\u0627\u0631\u0629 \u0627\u0644\u0623\u0648\u0644\u064A\u0629",
        timeEntry2Date: "17 \u0645\u0627\u0631\u0633\u060C 14:00",
        timeEntry2Text: "\u0642\u062F\u0645 \u0627\u0644\u0639\u0645\u064A\u0644 \u0627\u0644\u0648\u062B\u0627\u0626\u0642",
        timeEntry3Date: "15 \u0645\u0627\u0631\u0633\u060C 09:00",
        timeEntry3Text: "\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0639\u0645\u064A\u0644 \u0645\u0639 \u0627\u0644\u0634\u0631\u0643\u0629\u060C \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0623\u0648\u0644\u064A",
        typeCivil: "\u0645\u062F\u0646\u064A",
        typeAdministrative: "\u0625\u062F\u0627\u0631\u064A",
        typeCriminal: "\u062C\u0646\u0627\u0626\u064A",
        pitchArpuMonth: "\u0645\u062A\u0648\u0633\u0637 ARPU/\u0634\u0647\u0631",
        pitchArpuYear: "\u0645\u062A\u0648\u0633\u0637 ARPU/\u0633\u0646\u0629",
        pitchAutoBackup: "\u0646\u0633\u062E \u0627\u062D\u062A\u064A\u0627\u0637\u064A \u062A\u0644\u0642\u0627\u0626\u064A",
        pitchAutoNextSteps: "\u0627\u0644\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A\u0629",
        pitchAutoReminder: "\u062A\u0630\u0643\u064A\u0631 \u062A\u0644\u0642\u0627\u0626\u064A",
        pitchBooking: "\u0627\u0644\u062D\u062C\u0632",
        pitchCacOrganic: "CAC (\u0646\u0645\u0648 \u0639\u0636\u0648\u064A)",
        pitchCalcNote: "5000 \u0645\u062D\u0627\u0645\u064D \xd7 \u20BE35/\u0634\u0647\u0631 \u0641\u064A \u0627\u0644\u0645\u062A\u0648\u0633\u0637 \xd7 12 \u0634\u0647\u0631\u0627\u064B",
        pitchCalendarSync: "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
        pitchCalendarSyncDesc: "Google Calendar\u060C Outlook\u060C Apple Calendar \u2014 \u062A\u062A\u0645 \u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u0648\u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B",
        pitchCaseManagement: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0642\u0636\u0627\u064A\u0627",
        pitchClientSchedule: "\u062C\u062F\u0648\u0644 \u0627\u0644\u0639\u0645\u064A\u0644",
        pitchCloudDedicated: "\u0633\u062D\u0627\u0628\u0629 \u0645\u062E\u0635\u0635\u0629",
        pitchCloudDedicatedDesc: "\u062E\u0627\u062F\u0645 \u0633\u062D\u0627\u0628\u064A \u0645\u0639\u0632\u0648\u0644 \u2014 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0645\u0641\u0635\u0648\u0644\u0629 \u062A\u0645\u0627\u0645\u0627\u064B \u0639\u0646 \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0622\u062E\u0631\u064A\u0646",
        pitchContractAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0639\u0642\u0648\u062F",
        pitchCtaSubtext: "\u0627\u0644\u062D\u062C\u0632 + \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A + AI",
        pitchDedicatedServer: "\u062E\u0627\u062F\u0645 \u0645\u062E\u0635\u0635",
        pitchDocDraftGeo: "\u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0628\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629",
        pitchEcourtDesc: "\u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A\u060C \u0648\u062D\u0627\u0644\u0629 \u0627\u0644\u0642\u0636\u064A\u0629 \u0648\u062C\u062F\u0648\u0644 \u0627\u0644\u062C\u0644\u0633\u0627\u062A \u2014 \u062F\u0648\u0646 \u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0645\u062D\u0643\u0645\u0629",
        pitchGdprCompliant: "\u0645\u062A\u0648\u0627\u0641\u0642 \u0645\u0639 GDPR",
        pitchHybrid: "\u0647\u062C\u064A\u0646",
        pitchHybridDesc: "\u0633\u062D\u0627\u0628\u064A + \u0645\u062D\u0644\u064A \u2014 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0633\u0629 \u0645\u062D\u0644\u064A\u0627\u064B\u060C \u0648\u0627\u0644\u0628\u0627\u0642\u064A \u0641\u064A \u0627\u0644\u0633\u062D\u0627\u0628\u0629",
        pitchIntegrationsSub: "\u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062D\u0643\u0648\u0645\u064A\u0629\u060C \u0627\u0644\u062A\u0642\u0648\u064A\u0645\u0627\u062A \u0648 OCR \u2014 \u0645\u0646 \u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629",
        pitchInvoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        pitchMatsneDesc: "\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0627\u0644\u062A\u0634\u0631\u064A\u0639\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u2014 \u0641\u064A \u0645\u062C\u0627\u0644 \u062A\u062E\u0635\u0635\u0643",
        pitchOcrDesc: "\u0631\u0642\u0645\u0646\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0648\u0631\u0642\u064A\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u2014 \u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0644\u0643\u062A\u0627\u0628\u0629 \u0627\u0644\u064A\u062F\u0648\u064A\u0629",
        pitchOnPremise: "\u062E\u0627\u062F\u0645 \u0645\u062D\u0644\u064A",
        pitchOnPremiseDesc: "\u0645\u062D\u0644\u064A \u0628\u0627\u0644\u0643\u0627\u0645\u0644 \u2014 \u062A\u0628\u0642\u0649 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u064A \u0645\u0643\u062A\u0628\u0643\u060C \u062F\u0648\u0646 \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
        pitchOperations: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        pitchPerkAiDocs: "\u0645\u0633\u062A\u0646\u062F\u0627\u062A AI",
        pitchPerkBookings: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062D\u062C\u0648\u0632\u0627\u062A",
        pitchPerkClientPortal: "\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621",
        pitchPerkCommunication: "\u0627\u0644\u062A\u0648\u0627\u0635\u0644",
        pitchPerkFileStorage: "\u062A\u062E\u0632\u064A\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
        pitchPerkResponsive: "\u0645\u062A\u062C\u0627\u0648\u0628",
        pitchPrivacySubtitle: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u062A\u062A\u0637\u0644\u0628 \u0623\u0642\u0635\u0649 \u062F\u0631\u062C\u0627\u062A \u0627\u0644\u062D\u0645\u0627\u064A\u0629",
        pitchPublicRegistryDesc: "\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0648\u0627\u0644\u0645\u0645\u062A\u0644\u0643\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u2014 \u0644\u0627 \u062A\u0646\u0632\u064A\u0644 \u064A\u062F\u0648\u064A \u0644\u0644\u0645\u0633\u062A\u062E\u0631\u062C\u0627\u062A",
        pitchRateNote: "1 USD = 2.73 GEL \u2014 \u0645\u0627\u0631\u0633 2026",
        pitchRecurringModel: "\u0646\u0645\u0648\u0630\u062C \u0645\u062A\u0643\u0631\u0631",
        pitchRsGeDesc: "\u0627\u0644\u062F\u064A\u0648\u0646 \u0627\u0644\u0636\u0631\u064A\u0628\u064A\u0629 \u0648\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 \u2014 \u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0645\u064A\u0644 \u0628\u0646\u0642\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
        pitchScen250: "250 \u0645\u062D\u0627\u0645\u064A\u0627\u064B",
        pitchScen500: "500 \u0645\u062D\u0627\u0645\u064D",
        pitchScen1000: "1000 \u0645\u062D\u0627\u0645\u064D",
        pitchServerCost: "\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062E\u0627\u062F\u0645/\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
        pitchTierBusiness10: "+10 \u0645\u062D\u0627\u0645\u064A\u0646",
        pitchTierEnterpriseCustom: "\u0645\u062E\u0635\u0635",
        pitchTierEnterprisePrice: "\u0639\u0631\u0636 \u0633\u0639\u0631",
        pitchTierPro310: "3-10 \u0645\u062D\u0627\u0645\u064A\u0646",
        pitchTierStarter12: "1-2 \u0645\u062D\u0627\u0645\u064A\u0646",
        pitchTitle: "TrustLegal \u0644\u062C\u0648\u0631\u062C\u064A\u0627",
        pitchTrustedAccounting: "\u0645\u062D\u0627\u0633\u0628\u0629 \u0645\u0648\u062B\u0648\u0642\u0629",
        pitchWhyAiCheap: "\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u0623\u0635\u0628\u062D\u062A \u0627\u0644\u0622\u0646 \u0628\u0623\u0633\u0639\u0627\u0631 \u0645\u0639\u0642\u0648\u0644\u0629",
        pitchWhyDigitizing: "\u0627\u0644\u0633\u0648\u0642 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A \u0627\u0644\u062C\u0648\u0631\u062C\u064A \u064A\u062A\u062D\u0648\u0644 \u0631\u0642\u0645\u064A\u0627\u064B \u0628\u0633\u0631\u0639\u0629",
        pitchWhyNoCompetitor: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0646\u0627\u0641\u0633 \u0631\u0627\u0633\u062E",
        settingsFirmName: 'Barateli Legal Group',
        settingsMember1Name: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        settingsMember2Name: "\u062C\u064A\u062C\u0627 \u0623\u0633\u0644\u0627\u0646\u064A\u0634\u0641\u064A\u0644\u064A",
        settingsNotifyDeadlineReminder: "\u062A\u0630\u0643\u064A\u0631 \u0628\u0627\u0644\u0645\u0648\u0639\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A",
        settingsNotifyNewBookingEmail: "\u062D\u062C\u0632 \u062C\u062F\u064A\u062F \u2014 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        settingsNotifyNewBookingWhatsapp: "\u062D\u062C\u0632 \u062C\u062F\u064A\u062F \u2014 WhatsApp",
        settingsNotifyOverdueInvoice: "\u0641\u0627\u062A\u0648\u0631\u0629 \u0645\u062A\u0623\u062E\u0631\u0629",
        settingsNotifyReminder24h: "\u062A\u0630\u0643\u064A\u0631 \u0642\u0628\u0644 24 \u0633\u0627\u0639\u0629",
        settingsProfileName: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        settingsToggle3DaysBefore: "\u0642\u0628\u0644 3 \u0623\u064A\u0627\u0645",
        portalCaseTypeCivil: "\u0645\u062F\u0646\u064A",
        portalDocDate1: "15 \u0645\u0627\u0631\u0633",
        portalDocName1: "\u062F\u0639\u0648\u0649 - Mamulashvili.pdf",
        portalFirmLogo: 'Barateli Legal',
        portalInvoiceDue: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642: 25 \u0645\u0627\u0631\u0633",
        portalLastUpdate: "\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B: 18 \u0645\u0627\u0631\u0633",
        portalMsgFrom1: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        portalMsgPlaceholder: "\u0623\u0631\u0633\u0644 \u0631\u0633\u0627\u0644\u0629...",
        portalMsgText1: "\u0645\u0631\u062D\u0628\u0627\u064B \u062C\u064A\u0648\u0631\u062C\u064A\u060C \u0644\u062F\u064A\u0646\u0627 \u062A\u062D\u062F\u064A\u062B \u062C\u062F\u064A\u062F \u0628\u0634\u0623\u0646 \u0627\u0644\u0642\u0636\u064A\u0629.",
        portalMsgText2: "\u0634\u0643\u0631\u0627\u064B\u060C \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644.",
        portalNextHearing: "\u062C\u0644\u0633\u0629 \u0627\u0644\u0645\u062D\u0643\u0645\u0629 25 \u0645\u0627\u0631\u0633",
        portalPay: "\u062F\u0641\u0639",
        portalPendingInvoices: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u0627\u0644\u0645\u0639\u0644\u0642\u0629",
        portalProgressLabel: "\u0627\u0644\u062A\u0642\u062F\u0645: 3/5 \u062E\u0637\u0648\u0627\u062A",
        portalStatusActive: "\u0646\u0634\u0637",
        clientDashCaseTypeCivil: "\u0645\u062F\u0646\u064A",
        clientDashDocMeta1: "\u0642\u0636\u064A\u0629 #2024-047 \xb7 15 \u0645\u0627\u0631\u0633",
        clientDashDocMeta2: "\u0642\u0636\u064A\u0629 #2024-046 \xb7 12 \u0645\u0627\u0631\u0633",
        clientDashDocName1: "\u062F\u0639\u0648\u0649 - Mamulashvili.pdf",
        clientDashDocName2: "\u062A\u0648\u0643\u064A\u0644 \u0631\u0633\u0645\u064A - Kvaratskhelia.pdf",
        clientDashDocumentsTitle: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        clientDashInvCase1: "\u0642\u0636\u064A\u0629: #2024-047",
        clientDashInvCase2: "\u0642\u0636\u064A\u0629: #2024-046",
        clientDashInvDue1: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642: 25 \u0645\u0627\u0631\u0633 2026",
        clientDashInvoicesTitle: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
        clientDashInvPaidDate: "\u062A\u0645 \u0627\u0644\u062F\u0641\u0639: 14 \u0645\u0627\u0631\u0633 2026",
        clientDashLawyerInitials: 'NB',
        clientDashLawyerName: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        clientDashLawyerRole: "\u0645\u062D\u0627\u0645\u064A\u0643",
        clientDashMessagesTitle: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
        clientDashMsgFrom1: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        clientDashMsgFrom3: "\u0646\u064A\u0646\u0648 \u0628\u0627\u0631\u0627\u062A\u064A\u0644\u064A",
        clientDashMsgPlaceholder: "\u0627\u0643\u062A\u0628 \u0631\u0633\u0627\u0644\u0629...",
        clientDashMsgText1: "\u0645\u0631\u062D\u0628\u0627\u064B \u062C\u064A\u0648\u0631\u062C\u064A\u060C \u0644\u062F\u064A\u0646\u0627 \u062A\u062D\u062F\u064A\u062B \u062C\u062F\u064A\u062F \u0644\u0644\u0642\u0636\u064A\u0629. \u062D\u062F\u062F\u062A \u0627\uFFFD\uFFFD\u0645\u062D\u0643\u0645\u0629 \u062C\u0644\u0633\u0629 \u0627\u0633\u062A\u0645\u0627\u0639 \u0641\u064A 25 \u0645\u0627\u0631\u0633.",
        clientDashMsgText2: "\u0634\u0643\u0631\u0627\u064B\u060C \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644. \u0647\u0644 \u064A\u062C\u0628 \u0639\u0644\u064A \u062A\u062D\u0636\u064A\u0631 \u0623\u064A \u0645\u0633\u062A\u0646\u062F\u0627\u062A\u061F",
        clientDashMsgText3: "\u0644\u0627\u060C \u0643\u0644 \u0634\u064A\u0621 \u062C\u0627\u0647\u0632. \u0633\u0623\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u0642\u0628\u0644 \u0623\u0633\u0628\u0648\u0639 \u0645\u0646 \u0627\u0644\u062C\u0644\u0633\u0629.",
        clientDashMsgTime1: "10:30 \xb7 \u0627\u0644\u064A\u0648\u0645",
        clientDashMsgTime2: "10:45 \xb7 \u0627\u0644\u064A\u0648\u0645",
        clientDashMsgTime3: "11:02 \xb7 \u0627\u0644\u064A\u0648\u0645",
        clientDashMyCases: "\u0642\u0636\u0627\u064A\u0627\u064A",
        clientDashPaid: "\u0645\u062F\u0641\u0648\u0639",
        clientDashPay: "\u062F\u0641\u0639",
        clientDashProgressLabel: "\u0627\u0644\u062A\u0642\u062F\u0645: \u0627\u0643\u062A\u0645\u0644\u062A 3/5 \u062E\u0637\u0648\u0627\u062A",
        clientDashStatActiveCase: "\u0642\u0636\u064A\u0629 \u0646\u0634\u0637\u0629",
        clientDashStatDocument: "\u0645\u0633\u062A\u0646\u062F",
        clientDashStatNextHearing: "\u0627\u0644\u062C\u0644\u0633\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629",
        clientDashStatNextHearingValue: "25 \u0645\u0627\u0631\u0633",
        clientDashStatPayable: "\u0645\u0633\u062A\u062D\u0642 \u0627\u0644\u062F\u0641\u0639",
        clientDashStatusActive: "\u0646\u0634\u0637",
        clientDashStep1Date: "5 \u0645\u0627\u0631\u0633 2026",
        clientDashStep1Title: "\u0627\u0643\u062A\u0645\u0644\u062A \u0627\u0644\u0627\u0633\u062A\u0634\u0627\u0631\u0629",
        clientDashStep2Date: "10 \u0645\u0627\u0631\u0633 2026",
        clientDashStep2Title: "\u062A\u0645\u062A \u0635\u064A\u0627\u063A\u0629 \u0627\u0644\u062F\u0639\u0648\u0649",
        clientDashStep3Date: "15 \u0645\u0627\u0631\u0633 2026",
        clientDashStep3Title: "\u062A\u0645 \u0631\u0641\u0639 \u0627\u0644\u062F\u0639\u0648\u0649 \u0641\u064A \u0627\u0644\u0645\u062D\u0643\u0645\u0629",
        clientDashStep4Date: "25 \u0645\u0627\u0631\u0633 2026 \u2014 \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        clientDashStep4Title: "\u062C\u0644\u0633\u0629 \u0627\u0644\u0645\u062D\u0643\u0645\u0629",
        clientDashStep5Title: "\u0627\u0644\u0642\u0631\u0627\u0631",
        clientDashUnpaid: "\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639",
        clientDashWelcomeSub: "\u0647\u0646\u0627 \u064A\u0645\u0643\u0646\u0643 \u062A\u062A\u0628\u0639 \u0642\u0636\u0627\u064A\u0627\u0643 \u0648\u0641\u0648\u0627\u062A\u064A\u0631\u0643 \u0648\u0645\u0633\u062A\u0646\u062F\u0627\u062A\u0643."
    }
};


var $70676ed063e69c3c$export$2e2bcd8739ae039 = {
    ...(0, $3e7bb68d55e4c07c$export$2e2bcd8739ae039),
    polyglot: {
        ...(0, $3e7bb68d55e4c07c$export$2e2bcd8739ae039).polyglot,
        translations: $bc1454a6c0cf0628$export$2e2bcd8739ae039
    },
    state: $583e5c65243bf299$export$2e2bcd8739ae039,
    dependencies: $ffee29e35474451f$export$2e2bcd8739ae039,
    components: $b940b823876787d8$exports,
    snippets: $5006d5ef181f83de$exports,
    pages: $45001c780dea3812$export$2e2bcd8739ae039,
    functions: $b42a2ac40ecd9203$exports,
    methods: $3bda623ffab03480$exports,
    designSystem: $1a9a2097450ea0af$export$2e2bcd8739ae039,
    files: $f00b8cc44c2f4180$export$2e2bcd8739ae039
};


(0, $iTneE.create)((0, $85274e1cff99deb2$export$2e2bcd8739ae039), (0, $70676ed063e69c3c$export$2e2bcd8739ae039));


//# sourceMappingURL=symbols.9daf8660.js.map
